
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
"use strict";
"use strict";
var $ca3e1754e676956d$exports = {};
"use strict";
var $3fbf1185731afe2b$exports = {};
"use strict";
var $3fbf1185731afe2b$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$3fbf1185731afe2b$exports = // eslint-disable-next-line es/no-global-this -- safe
$3fbf1185731afe2b$var$check(typeof globalThis == "object" && globalThis) || $3fbf1185731afe2b$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$3fbf1185731afe2b$var$check(typeof self == "object" && self) || $3fbf1185731afe2b$var$check(typeof $parcel$global == "object" && $parcel$global) || $3fbf1185731afe2b$var$check(typeof $3fbf1185731afe2b$exports == "object" && $3fbf1185731afe2b$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $6d99163b6684d050$export$2d1720544b23b823;
"use strict";
var $ef322a7f89c3ed41$exports = {};
"use strict";
var $6140c9fa18232846$exports = {};
"use strict";
$6140c9fa18232846$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$ef322a7f89c3ed41$exports = !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $881ad37dbe259e8f$exports = {};
"use strict";
var $bcbe62e89adc7d37$exports = {};
"use strict";

$bcbe62e89adc7d37$exports = !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $881ad37dbe259e8f$var$call = Function.prototype.call;
$881ad37dbe259e8f$exports = $bcbe62e89adc7d37$exports ? $881ad37dbe259e8f$var$call.bind($881ad37dbe259e8f$var$call) : function() {
    return $881ad37dbe259e8f$var$call.apply($881ad37dbe259e8f$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $1e0782be6903ea7b$export$2d1720544b23b823;
"use strict";
var $1e0782be6903ea7b$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $1e0782be6903ea7b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $1e0782be6903ea7b$var$NASHORN_BUG = $1e0782be6903ea7b$var$getOwnPropertyDescriptor && !$1e0782be6903ea7b$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$1e0782be6903ea7b$export$2d1720544b23b823 = $1e0782be6903ea7b$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $1e0782be6903ea7b$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $1e0782be6903ea7b$var$$propertyIsEnumerable;


var $b66966b48674609b$exports = {};
"use strict";
$b66966b48674609b$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $4d273c9d7e1bdf46$exports = {};
"use strict";
var $8239f4c7c6082668$exports = {};
"use strict";
var $43b18aa2f1faac44$exports = {};
"use strict";

var $43b18aa2f1faac44$var$FunctionPrototype = Function.prototype;
var $43b18aa2f1faac44$var$call = $43b18aa2f1faac44$var$FunctionPrototype.call;
var $43b18aa2f1faac44$var$uncurryThisWithBind = $bcbe62e89adc7d37$exports && $43b18aa2f1faac44$var$FunctionPrototype.bind.bind($43b18aa2f1faac44$var$call, $43b18aa2f1faac44$var$call);
$43b18aa2f1faac44$exports = $bcbe62e89adc7d37$exports ? $43b18aa2f1faac44$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $43b18aa2f1faac44$var$call.apply(fn, arguments);
    };
};



var $b0ba63bfbfb16088$exports = {};
"use strict";

var $b0ba63bfbfb16088$var$toString = $43b18aa2f1faac44$exports({}.toString);
var $b0ba63bfbfb16088$var$stringSlice = $43b18aa2f1faac44$exports("".slice);
$b0ba63bfbfb16088$exports = function(it) {
    return $b0ba63bfbfb16088$var$stringSlice($b0ba63bfbfb16088$var$toString(it), 8, -1);
};


var $8239f4c7c6082668$var$$Object = Object;
var $8239f4c7c6082668$var$split = $43b18aa2f1faac44$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$8239f4c7c6082668$exports = $6140c9fa18232846$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$8239f4c7c6082668$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $b0ba63bfbfb16088$exports(it) === "String" ? $8239f4c7c6082668$var$split(it, "") : $8239f4c7c6082668$var$$Object(it);
} : $8239f4c7c6082668$var$$Object;


var $c378177673193450$exports = {};
"use strict";
var $7ce250ddf7b42d4d$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$7ce250ddf7b42d4d$exports = function(it) {
    return it === null || it === undefined;
};


var $c378177673193450$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$c378177673193450$exports = function(it) {
    if ($7ce250ddf7b42d4d$exports(it)) throw new $c378177673193450$var$$TypeError("Can't call method on " + it);
    return it;
};


$4d273c9d7e1bdf46$exports = function(it) {
    return $8239f4c7c6082668$exports($c378177673193450$exports(it));
};


var $7f19acfe53927f5c$exports = {};
"use strict";
var $8ffb6b36a733d3c0$exports = {};
"use strict";

var $6a130d390db46c8e$exports = {};
"use strict";
var $70e34a5a2021f756$exports = {};
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $70e34a5a2021f756$var$documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$70e34a5a2021f756$exports = typeof $70e34a5a2021f756$var$documentAll == "undefined" && $70e34a5a2021f756$var$documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === $70e34a5a2021f756$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


$6a130d390db46c8e$exports = function(it) {
    return typeof it == "object" ? it !== null : $70e34a5a2021f756$exports(it);
};


var $0b429cc7792c7d26$exports = {};
"use strict";
var $a5217dbd1b0d33ce$exports = {};
"use strict";


var $a5217dbd1b0d33ce$var$aFunction = function(argument) {
    return $70e34a5a2021f756$exports(argument) ? argument : undefined;
};
$a5217dbd1b0d33ce$exports = function(namespace, method) {
    return arguments.length < 2 ? $a5217dbd1b0d33ce$var$aFunction($3fbf1185731afe2b$exports[namespace]) : $3fbf1185731afe2b$exports[namespace] && $3fbf1185731afe2b$exports[namespace][method];
};



var $41cc576e850a251e$exports = {};
"use strict";

$41cc576e850a251e$exports = $43b18aa2f1faac44$exports({}.isPrototypeOf);


var $47f18b427c2fbabf$exports = {};
"use strict";
var $4a39565fee8fe980$exports = {};
"use strict";
var $b2a56c1a090208a5$exports = {};
"use strict";

var $34fa2a1382dc63c1$exports = {};
"use strict";

var $34fa2a1382dc63c1$var$navigator = $3fbf1185731afe2b$exports.navigator;
var $34fa2a1382dc63c1$var$userAgent = $34fa2a1382dc63c1$var$navigator && $34fa2a1382dc63c1$var$navigator.userAgent;
$34fa2a1382dc63c1$exports = $34fa2a1382dc63c1$var$userAgent ? String($34fa2a1382dc63c1$var$userAgent) : "";


var $b2a56c1a090208a5$var$process = $3fbf1185731afe2b$exports.process;
var $b2a56c1a090208a5$var$Deno = $3fbf1185731afe2b$exports.Deno;
var $b2a56c1a090208a5$var$versions = $b2a56c1a090208a5$var$process && $b2a56c1a090208a5$var$process.versions || $b2a56c1a090208a5$var$Deno && $b2a56c1a090208a5$var$Deno.version;
var $b2a56c1a090208a5$var$v8 = $b2a56c1a090208a5$var$versions && $b2a56c1a090208a5$var$versions.v8;
var $b2a56c1a090208a5$var$match, $b2a56c1a090208a5$var$version;
if ($b2a56c1a090208a5$var$v8) {
    $b2a56c1a090208a5$var$match = $b2a56c1a090208a5$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $b2a56c1a090208a5$var$version = $b2a56c1a090208a5$var$match[0] > 0 && $b2a56c1a090208a5$var$match[0] < 4 ? 1 : +($b2a56c1a090208a5$var$match[0] + $b2a56c1a090208a5$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$b2a56c1a090208a5$var$version && $34fa2a1382dc63c1$exports) {
    $b2a56c1a090208a5$var$match = $34fa2a1382dc63c1$exports.match(/Edge\/(\d+)/);
    if (!$b2a56c1a090208a5$var$match || $b2a56c1a090208a5$var$match[1] >= 74) {
        $b2a56c1a090208a5$var$match = $34fa2a1382dc63c1$exports.match(/Chrome\/(\d+)/);
        if ($b2a56c1a090208a5$var$match) $b2a56c1a090208a5$var$version = +$b2a56c1a090208a5$var$match[1];
    }
}
$b2a56c1a090208a5$exports = $b2a56c1a090208a5$var$version;




var $4a39565fee8fe980$var$$String = $3fbf1185731afe2b$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$4a39565fee8fe980$exports = !!Object.getOwnPropertySymbols && !$6140c9fa18232846$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$4a39565fee8fe980$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $b2a56c1a090208a5$exports && $b2a56c1a090208a5$exports < 41;
});


$47f18b427c2fbabf$exports = $4a39565fee8fe980$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $0b429cc7792c7d26$var$$Object = Object;
$0b429cc7792c7d26$exports = $47f18b427c2fbabf$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $a5217dbd1b0d33ce$exports("Symbol");
    return $70e34a5a2021f756$exports($Symbol) && $41cc576e850a251e$exports($Symbol.prototype, $0b429cc7792c7d26$var$$Object(it));
};


var $eb80dcd0b8a5698c$exports = {};
"use strict";
var $ae485921c5498156$exports = {};
"use strict";

var $8f0ebae34f61e14c$exports = {};
"use strict";
var $8f0ebae34f61e14c$var$$String = String;
$8f0ebae34f61e14c$exports = function(argument) {
    try {
        return $8f0ebae34f61e14c$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $ae485921c5498156$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$ae485921c5498156$exports = function(argument) {
    if ($70e34a5a2021f756$exports(argument)) return argument;
    throw new $ae485921c5498156$var$$TypeError($8f0ebae34f61e14c$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$eb80dcd0b8a5698c$exports = function(V, P) {
    var func = V[P];
    return $7ce250ddf7b42d4d$exports(func) ? undefined : $ae485921c5498156$exports(func);
};


var $b0f812e443807cb5$exports = {};
"use strict";



var $b0f812e443807cb5$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$b0f812e443807cb5$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $70e34a5a2021f756$exports(fn = input.toString) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    if ($70e34a5a2021f756$exports(fn = input.valueOf) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    if (pref !== "string" && $70e34a5a2021f756$exports(fn = input.toString) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    throw new $b0f812e443807cb5$var$$TypeError("Can't convert object to primitive value");
};


var $842f8f0a18746212$exports = {};
"use strict";

var $1946b9b54b48e7fd$exports = {};
"use strict";
var $d00d03e557d638db$exports = {};
"use strict";
var $e0409817d4e03fc4$exports = {};
"use strict";
$e0409817d4e03fc4$exports = false;



var $4ce407c7007beb63$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $4ce407c7007beb63$var$defineProperty = Object.defineProperty;
$4ce407c7007beb63$exports = function(key, value) {
    try {
        $4ce407c7007beb63$var$defineProperty($3fbf1185731afe2b$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $3fbf1185731afe2b$exports[key] = value;
    }
    return value;
};


var $d00d03e557d638db$var$SHARED = "__core-js_shared__";
var $d00d03e557d638db$var$store = $d00d03e557d638db$exports = $3fbf1185731afe2b$exports[$d00d03e557d638db$var$SHARED] || $4ce407c7007beb63$exports($d00d03e557d638db$var$SHARED, {});
($d00d03e557d638db$var$store.versions || ($d00d03e557d638db$var$store.versions = [])).push({
    version: "3.38.1",
    mode: $e0409817d4e03fc4$exports ? "pure" : "global",
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.38.1/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


$1946b9b54b48e7fd$exports = function(key, value) {
    return $d00d03e557d638db$exports[key] || ($d00d03e557d638db$exports[key] = value || {});
};


var $1f868a26fd901990$exports = {};
"use strict";

var $a2f3ebb5da11db12$exports = {};
"use strict";

var $a2f3ebb5da11db12$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$a2f3ebb5da11db12$exports = function(argument) {
    return $a2f3ebb5da11db12$var$$Object($c378177673193450$exports(argument));
};


var $1f868a26fd901990$var$hasOwnProperty = $43b18aa2f1faac44$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$1f868a26fd901990$exports = Object.hasOwn || function hasOwn(it, key) {
    return $1f868a26fd901990$var$hasOwnProperty($a2f3ebb5da11db12$exports(it), key);
};


var $5e0a1e292f79defc$exports = {};
"use strict";

var $5e0a1e292f79defc$var$id = 0;
var $5e0a1e292f79defc$var$postfix = Math.random();
var $5e0a1e292f79defc$var$toString = $43b18aa2f1faac44$exports(1.0.toString);
$5e0a1e292f79defc$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $5e0a1e292f79defc$var$toString(++$5e0a1e292f79defc$var$id + $5e0a1e292f79defc$var$postfix, 36);
};




var $842f8f0a18746212$var$Symbol = $3fbf1185731afe2b$exports.Symbol;
var $842f8f0a18746212$var$WellKnownSymbolsStore = $1946b9b54b48e7fd$exports("wks");
var $842f8f0a18746212$var$createWellKnownSymbol = $47f18b427c2fbabf$exports ? $842f8f0a18746212$var$Symbol["for"] || $842f8f0a18746212$var$Symbol : $842f8f0a18746212$var$Symbol && $842f8f0a18746212$var$Symbol.withoutSetter || $5e0a1e292f79defc$exports;
$842f8f0a18746212$exports = function(name) {
    if (!$1f868a26fd901990$exports($842f8f0a18746212$var$WellKnownSymbolsStore, name)) $842f8f0a18746212$var$WellKnownSymbolsStore[name] = $4a39565fee8fe980$exports && $1f868a26fd901990$exports($842f8f0a18746212$var$Symbol, name) ? $842f8f0a18746212$var$Symbol[name] : $842f8f0a18746212$var$createWellKnownSymbol("Symbol." + name);
    return $842f8f0a18746212$var$WellKnownSymbolsStore[name];
};


var $8ffb6b36a733d3c0$var$$TypeError = TypeError;
var $8ffb6b36a733d3c0$var$TO_PRIMITIVE = $842f8f0a18746212$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$8ffb6b36a733d3c0$exports = function(input, pref) {
    if (!$6a130d390db46c8e$exports(input) || $0b429cc7792c7d26$exports(input)) return input;
    var exoticToPrim = $eb80dcd0b8a5698c$exports(input, $8ffb6b36a733d3c0$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $881ad37dbe259e8f$exports(exoticToPrim, input, pref);
        if (!$6a130d390db46c8e$exports(result) || $0b429cc7792c7d26$exports(result)) return result;
        throw new $8ffb6b36a733d3c0$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $b0f812e443807cb5$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$7f19acfe53927f5c$exports = function(argument) {
    var key = $8ffb6b36a733d3c0$exports(argument, "string");
    return $0b429cc7792c7d26$exports(key) ? key : key + "";
};



var $d45526d8245cb22c$exports = {};
"use strict";


var $15c0c414b89100b1$exports = {};
"use strict";


var $15c0c414b89100b1$var$document = $3fbf1185731afe2b$exports.document;
// typeof document.createElement is 'object' in old IE
var $15c0c414b89100b1$var$EXISTS = $6a130d390db46c8e$exports($15c0c414b89100b1$var$document) && $6a130d390db46c8e$exports($15c0c414b89100b1$var$document.createElement);
$15c0c414b89100b1$exports = function(it) {
    return $15c0c414b89100b1$var$EXISTS ? $15c0c414b89100b1$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$d45526d8245cb22c$exports = !$ef322a7f89c3ed41$exports && !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($15c0c414b89100b1$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $6d99163b6684d050$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$6d99163b6684d050$export$2d1720544b23b823 = $ef322a7f89c3ed41$exports ? $6d99163b6684d050$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $4d273c9d7e1bdf46$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    if ($d45526d8245cb22c$exports) try {
        return $6d99163b6684d050$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($1f868a26fd901990$exports(O, P)) return $b66966b48674609b$exports(!$881ad37dbe259e8f$exports($1e0782be6903ea7b$export$2d1720544b23b823, O, P), O[P]);
};


var $ca3e1754e676956d$require$getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;
var $8693737507995841$exports = {};
"use strict";

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $2d0ac3aa5e39584b$export$2d1720544b23b823;
"use strict";


var $161a89d67c436ccf$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$161a89d67c436ccf$exports = $ef322a7f89c3ed41$exports && $6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $c845d421b7b0e630$exports = {};
"use strict";

var $c845d421b7b0e630$var$$String = String;
var $c845d421b7b0e630$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$c845d421b7b0e630$exports = function(argument) {
    if ($6a130d390db46c8e$exports(argument)) return argument;
    throw new $c845d421b7b0e630$var$$TypeError($c845d421b7b0e630$var$$String(argument) + " is not an object");
};



var $2d0ac3aa5e39584b$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $2d0ac3aa5e39584b$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $2d0ac3aa5e39584b$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $2d0ac3aa5e39584b$var$ENUMERABLE = "enumerable";
var $2d0ac3aa5e39584b$var$CONFIGURABLE = "configurable";
var $2d0ac3aa5e39584b$var$WRITABLE = "writable";
$2d0ac3aa5e39584b$export$2d1720544b23b823 = $ef322a7f89c3ed41$exports ? $161a89d67c436ccf$exports ? function defineProperty(O, P, Attributes) {
    $c845d421b7b0e630$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    $c845d421b7b0e630$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $2d0ac3aa5e39584b$var$WRITABLE in Attributes && !Attributes[$2d0ac3aa5e39584b$var$WRITABLE]) {
        var current = $2d0ac3aa5e39584b$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$2d0ac3aa5e39584b$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $2d0ac3aa5e39584b$var$CONFIGURABLE in Attributes ? Attributes[$2d0ac3aa5e39584b$var$CONFIGURABLE] : current[$2d0ac3aa5e39584b$var$CONFIGURABLE],
                enumerable: $2d0ac3aa5e39584b$var$ENUMERABLE in Attributes ? Attributes[$2d0ac3aa5e39584b$var$ENUMERABLE] : current[$2d0ac3aa5e39584b$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $2d0ac3aa5e39584b$var$$defineProperty(O, P, Attributes);
} : $2d0ac3aa5e39584b$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $c845d421b7b0e630$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    $c845d421b7b0e630$exports(Attributes);
    if ($d45526d8245cb22c$exports) try {
        return $2d0ac3aa5e39584b$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $2d0ac3aa5e39584b$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};



$8693737507995841$exports = $ef322a7f89c3ed41$exports ? function(object, key, value) {
    return $2d0ac3aa5e39584b$export$2d1720544b23b823(object, key, $b66966b48674609b$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $40e957865125f98f$exports = {};
"use strict";


var $09c56ff2ae09b2d7$exports = {};
"use strict";





var $81c64883d194e3b4$exports = {};
"use strict";


var $81c64883d194e3b4$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $81c64883d194e3b4$var$getDescriptor = $ef322a7f89c3ed41$exports && Object.getOwnPropertyDescriptor;
var $81c64883d194e3b4$var$EXISTS = $1f868a26fd901990$exports($81c64883d194e3b4$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $81c64883d194e3b4$var$PROPER = $81c64883d194e3b4$var$EXISTS && (function something() {}).name === "something";
var $81c64883d194e3b4$var$CONFIGURABLE = $81c64883d194e3b4$var$EXISTS && (!$ef322a7f89c3ed41$exports || $ef322a7f89c3ed41$exports && $81c64883d194e3b4$var$getDescriptor($81c64883d194e3b4$var$FunctionPrototype, "name").configurable);
$81c64883d194e3b4$exports = {
    EXISTS: $81c64883d194e3b4$var$EXISTS,
    PROPER: $81c64883d194e3b4$var$PROPER,
    CONFIGURABLE: $81c64883d194e3b4$var$CONFIGURABLE
};


var $09c56ff2ae09b2d7$require$CONFIGURABLE_FUNCTION_NAME = $81c64883d194e3b4$exports.CONFIGURABLE;
var $9990f6f719f26a96$exports = {};
"use strict";



var $9990f6f719f26a96$var$functionToString = $43b18aa2f1faac44$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$70e34a5a2021f756$exports($d00d03e557d638db$exports.inspectSource)) $d00d03e557d638db$exports.inspectSource = function(it) {
    return $9990f6f719f26a96$var$functionToString(it);
};
$9990f6f719f26a96$exports = $d00d03e557d638db$exports.inspectSource;


var $3a8bcef306e86159$exports = {};
"use strict";
var $47d53bb84a8f3c5b$exports = {};
"use strict";


var $47d53bb84a8f3c5b$var$WeakMap = $3fbf1185731afe2b$exports.WeakMap;
$47d53bb84a8f3c5b$exports = $70e34a5a2021f756$exports($47d53bb84a8f3c5b$var$WeakMap) && /native code/.test(String($47d53bb84a8f3c5b$var$WeakMap));







var $834abcf0f8f3f871$exports = {};
"use strict";


var $834abcf0f8f3f871$var$keys = $1946b9b54b48e7fd$exports("keys");
$834abcf0f8f3f871$exports = function(key) {
    return $834abcf0f8f3f871$var$keys[key] || ($834abcf0f8f3f871$var$keys[key] = $5e0a1e292f79defc$exports(key));
};


var $9f571a3f3d135e31$exports = {};
"use strict";
$9f571a3f3d135e31$exports = {};


var $3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $3a8bcef306e86159$var$TypeError = $3fbf1185731afe2b$exports.TypeError;
var $3a8bcef306e86159$var$WeakMap = $3fbf1185731afe2b$exports.WeakMap;
var $3a8bcef306e86159$var$set, $3a8bcef306e86159$var$get, $3a8bcef306e86159$var$has;
var $3a8bcef306e86159$var$enforce = function(it) {
    return $3a8bcef306e86159$var$has(it) ? $3a8bcef306e86159$var$get(it) : $3a8bcef306e86159$var$set(it, {});
};
var $3a8bcef306e86159$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$6a130d390db46c8e$exports(it) || (state = $3a8bcef306e86159$var$get(it)).type !== TYPE) throw new $3a8bcef306e86159$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($47d53bb84a8f3c5b$exports || $d00d03e557d638db$exports.state) {
    var $3a8bcef306e86159$var$store = $d00d03e557d638db$exports.state || ($d00d03e557d638db$exports.state = new $3a8bcef306e86159$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $3a8bcef306e86159$var$store.get = $3a8bcef306e86159$var$store.get;
    $3a8bcef306e86159$var$store.has = $3a8bcef306e86159$var$store.has;
    $3a8bcef306e86159$var$store.set = $3a8bcef306e86159$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $3a8bcef306e86159$var$set = function(it, metadata) {
        if ($3a8bcef306e86159$var$store.has(it)) throw new $3a8bcef306e86159$var$TypeError($3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $3a8bcef306e86159$var$store.set(it, metadata);
        return metadata;
    };
    $3a8bcef306e86159$var$get = function(it) {
        return $3a8bcef306e86159$var$store.get(it) || {};
    };
    $3a8bcef306e86159$var$has = function(it) {
        return $3a8bcef306e86159$var$store.has(it);
    };
} else {
    var $3a8bcef306e86159$var$STATE = $834abcf0f8f3f871$exports("state");
    $9f571a3f3d135e31$exports[$3a8bcef306e86159$var$STATE] = true;
    $3a8bcef306e86159$var$set = function(it, metadata) {
        if ($1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE)) throw new $3a8bcef306e86159$var$TypeError($3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $8693737507995841$exports(it, $3a8bcef306e86159$var$STATE, metadata);
        return metadata;
    };
    $3a8bcef306e86159$var$get = function(it) {
        return $1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE) ? it[$3a8bcef306e86159$var$STATE] : {};
    };
    $3a8bcef306e86159$var$has = function(it) {
        return $1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE);
    };
}
$3a8bcef306e86159$exports = {
    set: $3a8bcef306e86159$var$set,
    get: $3a8bcef306e86159$var$get,
    has: $3a8bcef306e86159$var$has,
    enforce: $3a8bcef306e86159$var$enforce,
    getterFor: $3a8bcef306e86159$var$getterFor
};


var $09c56ff2ae09b2d7$var$enforceInternalState = $3a8bcef306e86159$exports.enforce;
var $09c56ff2ae09b2d7$var$getInternalState = $3a8bcef306e86159$exports.get;
var $09c56ff2ae09b2d7$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $09c56ff2ae09b2d7$var$defineProperty = Object.defineProperty;
var $09c56ff2ae09b2d7$var$stringSlice = $43b18aa2f1faac44$exports("".slice);
var $09c56ff2ae09b2d7$var$replace = $43b18aa2f1faac44$exports("".replace);
var $09c56ff2ae09b2d7$var$join = $43b18aa2f1faac44$exports([].join);
var $09c56ff2ae09b2d7$var$CONFIGURABLE_LENGTH = $ef322a7f89c3ed41$exports && !$6140c9fa18232846$exports(function() {
    return $09c56ff2ae09b2d7$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $09c56ff2ae09b2d7$var$TEMPLATE = String(String).split("String");
var $09c56ff2ae09b2d7$var$makeBuiltIn = $09c56ff2ae09b2d7$exports = function(value, name, options) {
    if ($09c56ff2ae09b2d7$var$stringSlice($09c56ff2ae09b2d7$var$$String(name), 0, 7) === "Symbol(") name = "[" + $09c56ff2ae09b2d7$var$replace($09c56ff2ae09b2d7$var$$String(name), /^Symbol\(([^)]*)\).*$/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$1f868a26fd901990$exports(value, "name") || $09c56ff2ae09b2d7$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($ef322a7f89c3ed41$exports) $09c56ff2ae09b2d7$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($09c56ff2ae09b2d7$var$CONFIGURABLE_LENGTH && options && $1f868a26fd901990$exports(options, "arity") && value.length !== options.arity) $09c56ff2ae09b2d7$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $1f868a26fd901990$exports(options, "constructor") && options.constructor) {
            if ($ef322a7f89c3ed41$exports) $09c56ff2ae09b2d7$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $09c56ff2ae09b2d7$var$enforceInternalState(value);
    if (!$1f868a26fd901990$exports(state, "source")) state.source = $09c56ff2ae09b2d7$var$join($09c56ff2ae09b2d7$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $09c56ff2ae09b2d7$var$makeBuiltIn(function toString() {
    return $70e34a5a2021f756$exports(this) && $09c56ff2ae09b2d7$var$getInternalState(this).source || $9990f6f719f26a96$exports(this);
}, "toString");



$40e957865125f98f$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($70e34a5a2021f756$exports(value)) $09c56ff2ae09b2d7$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $4ce407c7007beb63$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $2d0ac3aa5e39584b$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $ef14b437ba65973a$exports = {};
"use strict";

var $339f2419d379e6c2$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $f6c32256739dd9b5$export$2d1720544b23b823;
"use strict";
var $c4fba4611365c4f5$exports = {};
"use strict";



var $f00609c516640f24$exports = {};
"use strict";

var $1ef9432c43157f41$exports = {};
"use strict";
var $b5bb21648546ce5b$exports = {};
"use strict";
var $5395b5a4913a5e32$exports = {};
"use strict";
var $5395b5a4913a5e32$var$ceil = Math.ceil;
var $5395b5a4913a5e32$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$5395b5a4913a5e32$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $5395b5a4913a5e32$var$floor : $5395b5a4913a5e32$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$b5bb21648546ce5b$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $5395b5a4913a5e32$exports(number);
};


var $1ef9432c43157f41$var$max = Math.max;
var $1ef9432c43157f41$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$1ef9432c43157f41$exports = function(index, length) {
    var integer = $b5bb21648546ce5b$exports(index);
    return integer < 0 ? $1ef9432c43157f41$var$max(integer + length, 0) : $1ef9432c43157f41$var$min(integer, length);
};


var $04c91bd3815cd64a$exports = {};
"use strict";
var $4aba983aae3daed3$exports = {};
"use strict";

var $4aba983aae3daed3$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$4aba983aae3daed3$exports = function(argument) {
    var len = $b5bb21648546ce5b$exports(argument);
    return len > 0 ? $4aba983aae3daed3$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$04c91bd3815cd64a$exports = function(obj) {
    return $4aba983aae3daed3$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $f00609c516640f24$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $4d273c9d7e1bdf46$exports($this);
        var length = $04c91bd3815cd64a$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $1ef9432c43157f41$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$f00609c516640f24$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $f00609c516640f24$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $f00609c516640f24$var$createMethod(false)
};


var $c4fba4611365c4f5$require$indexOf = $f00609c516640f24$exports.indexOf;

var $c4fba4611365c4f5$var$push = $43b18aa2f1faac44$exports([].push);
$c4fba4611365c4f5$exports = function(object, names) {
    var O = $4d273c9d7e1bdf46$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$1f868a26fd901990$exports($9f571a3f3d135e31$exports, key) && $1f868a26fd901990$exports(O, key) && $c4fba4611365c4f5$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($1f868a26fd901990$exports(O, key = names[i++])) ~$c4fba4611365c4f5$require$indexOf(result, key) || $c4fba4611365c4f5$var$push(result, key);
    return result;
};


var $e73f13f1d8a17cad$exports = {};
"use strict";
// IE8- don't enum bug keys
$e73f13f1d8a17cad$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $f6c32256739dd9b5$var$hiddenKeys = $e73f13f1d8a17cad$exports.concat("length", "prototype");
$f6c32256739dd9b5$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $c4fba4611365c4f5$exports(O, $f6c32256739dd9b5$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $0ed66cde5c449819$export$2d1720544b23b823;
"use strict";
$0ed66cde5c449819$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $339f2419d379e6c2$var$concat = $43b18aa2f1faac44$exports([].concat);
// all object keys, includes non-enumerable and symbols
$339f2419d379e6c2$exports = $a5217dbd1b0d33ce$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $f6c32256739dd9b5$export$2d1720544b23b823($c845d421b7b0e630$exports(it));
    var getOwnPropertySymbols = $0ed66cde5c449819$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $339f2419d379e6c2$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$ef14b437ba65973a$exports = function(target, source, exceptions) {
    var keys = $339f2419d379e6c2$exports(source);
    var defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$1f868a26fd901990$exports(target, key) && !(exceptions && $1f868a26fd901990$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $ca268db110e9e457$exports = {};
"use strict";


var $ca268db110e9e457$var$replacement = /#|\.prototype\./;
var $ca268db110e9e457$var$isForced = function(feature, detection) {
    var value = $ca268db110e9e457$var$data[$ca268db110e9e457$var$normalize(feature)];
    return value === $ca268db110e9e457$var$POLYFILL ? true : value === $ca268db110e9e457$var$NATIVE ? false : $70e34a5a2021f756$exports(detection) ? $6140c9fa18232846$exports(detection) : !!detection;
};
var $ca268db110e9e457$var$normalize = $ca268db110e9e457$var$isForced.normalize = function(string) {
    return String(string).replace($ca268db110e9e457$var$replacement, ".").toLowerCase();
};
var $ca268db110e9e457$var$data = $ca268db110e9e457$var$isForced.data = {};
var $ca268db110e9e457$var$NATIVE = $ca268db110e9e457$var$isForced.NATIVE = "N";
var $ca268db110e9e457$var$POLYFILL = $ca268db110e9e457$var$isForced.POLYFILL = "P";
$ca268db110e9e457$exports = $ca268db110e9e457$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $ca3e1754e676956d$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $3fbf1185731afe2b$exports;
    else if (STATIC) target = $3fbf1185731afe2b$exports[TARGET] || $4ce407c7007beb63$exports(TARGET, {});
    else target = $3fbf1185731afe2b$exports[TARGET] && $3fbf1185731afe2b$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $ca3e1754e676956d$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $ca268db110e9e457$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $ef14b437ba65973a$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $8693737507995841$exports(sourceProperty, "sham", true);
        $40e957865125f98f$exports(target, key, sourceProperty, options);
    }
};



var $a393da0e05d61ed1$exports = {};
"use strict";

var $3cdb2ef65d8e3cb5$exports = {};
"use strict";

var $3cdb2ef65d8e3cb5$var$FunctionPrototype = Function.prototype;
var $3cdb2ef65d8e3cb5$var$apply = $3cdb2ef65d8e3cb5$var$FunctionPrototype.apply;
var $3cdb2ef65d8e3cb5$var$call = $3cdb2ef65d8e3cb5$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$3cdb2ef65d8e3cb5$exports = typeof Reflect == "object" && Reflect.apply || ($bcbe62e89adc7d37$exports ? $3cdb2ef65d8e3cb5$var$call.bind($3cdb2ef65d8e3cb5$var$apply) : function() {
    return $3cdb2ef65d8e3cb5$var$call.apply($3cdb2ef65d8e3cb5$var$apply, arguments);
});


var $43284f0171045916$exports = {};
"use strict";
var $4828cb1b4c7586c8$exports = {};
"use strict";


$4828cb1b4c7586c8$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($b0ba63bfbfb16088$exports(fn) === "Function") return $43b18aa2f1faac44$exports(fn);
};




var $43284f0171045916$var$bind = $4828cb1b4c7586c8$exports($4828cb1b4c7586c8$exports.bind);
// optional / simple context binding
$43284f0171045916$exports = function(fn, that) {
    $ae485921c5498156$exports(fn);
    return that === undefined ? fn : $bcbe62e89adc7d37$exports ? $43284f0171045916$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $b8ce1ad1b6b1e7c1$exports = {};
"use strict";

$b8ce1ad1b6b1e7c1$exports = $a5217dbd1b0d33ce$exports("document", "documentElement");


var $0709cba658bb4ed6$exports = {};
"use strict";

$0709cba658bb4ed6$exports = $43b18aa2f1faac44$exports([].slice);



var $7d824954c5058f7d$exports = {};
"use strict";
var $7d824954c5058f7d$var$$TypeError = TypeError;
$7d824954c5058f7d$exports = function(passed, required) {
    if (passed < required) throw new $7d824954c5058f7d$var$$TypeError("Not enough arguments");
    return passed;
};


var $2d59c67a15180939$exports = {};
"use strict";

// eslint-disable-next-line redos/no-vulnerable -- safe
$2d59c67a15180939$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($34fa2a1382dc63c1$exports);


var $88d6935be735e2e8$exports = {};
"use strict";
var $87e21695405add0a$exports = {};
"use strict";



var $87e21695405add0a$var$userAgentStartsWith = function(string) {
    return $34fa2a1382dc63c1$exports.slice(0, string.length) === string;
};
$87e21695405add0a$exports = function() {
    if ($87e21695405add0a$var$userAgentStartsWith("Bun/")) return "BUN";
    if ($87e21695405add0a$var$userAgentStartsWith("Cloudflare-Workers")) return "CLOUDFLARE";
    if ($87e21695405add0a$var$userAgentStartsWith("Deno/")) return "DENO";
    if ($87e21695405add0a$var$userAgentStartsWith("Node.js/")) return "NODE";
    if ($3fbf1185731afe2b$exports.Bun && typeof Bun.version == "string") return "BUN";
    if ($3fbf1185731afe2b$exports.Deno && typeof Deno.version == "object") return "DENO";
    if ($b0ba63bfbfb16088$exports($3fbf1185731afe2b$exports.process) === "process") return "NODE";
    if ($3fbf1185731afe2b$exports.window && $3fbf1185731afe2b$exports.document) return "BROWSER";
    return "REST";
}();


$88d6935be735e2e8$exports = $87e21695405add0a$exports === "NODE";


var $a393da0e05d61ed1$var$set = $3fbf1185731afe2b$exports.setImmediate;
var $a393da0e05d61ed1$var$clear = $3fbf1185731afe2b$exports.clearImmediate;
var $a393da0e05d61ed1$var$process = $3fbf1185731afe2b$exports.process;
var $a393da0e05d61ed1$var$Dispatch = $3fbf1185731afe2b$exports.Dispatch;
var $a393da0e05d61ed1$var$Function = $3fbf1185731afe2b$exports.Function;
var $a393da0e05d61ed1$var$MessageChannel = $3fbf1185731afe2b$exports.MessageChannel;
var $a393da0e05d61ed1$var$String = $3fbf1185731afe2b$exports.String;
var $a393da0e05d61ed1$var$counter = 0;
var $a393da0e05d61ed1$var$queue = {};
var $a393da0e05d61ed1$var$ONREADYSTATECHANGE = "onreadystatechange";
var $a393da0e05d61ed1$var$$location, $a393da0e05d61ed1$var$defer, $a393da0e05d61ed1$var$channel, $a393da0e05d61ed1$var$port;
$6140c9fa18232846$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $a393da0e05d61ed1$var$$location = $3fbf1185731afe2b$exports.location;
});
var $a393da0e05d61ed1$var$run = function(id) {
    if ($1f868a26fd901990$exports($a393da0e05d61ed1$var$queue, id)) {
        var fn = $a393da0e05d61ed1$var$queue[id];
        delete $a393da0e05d61ed1$var$queue[id];
        fn();
    }
};
var $a393da0e05d61ed1$var$runner = function(id) {
    return function() {
        $a393da0e05d61ed1$var$run(id);
    };
};
var $a393da0e05d61ed1$var$eventListener = function(event) {
    $a393da0e05d61ed1$var$run(event.data);
};
var $a393da0e05d61ed1$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $3fbf1185731afe2b$exports.postMessage($a393da0e05d61ed1$var$String(id), $a393da0e05d61ed1$var$$location.protocol + "//" + $a393da0e05d61ed1$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$a393da0e05d61ed1$var$set || !$a393da0e05d61ed1$var$clear) {
    $a393da0e05d61ed1$var$set = function setImmediate(handler) {
        $7d824954c5058f7d$exports(arguments.length, 1);
        var fn = $70e34a5a2021f756$exports(handler) ? handler : $a393da0e05d61ed1$var$Function(handler);
        var args = $0709cba658bb4ed6$exports(arguments, 1);
        $a393da0e05d61ed1$var$queue[++$a393da0e05d61ed1$var$counter] = function() {
            $3cdb2ef65d8e3cb5$exports(fn, undefined, args);
        };
        $a393da0e05d61ed1$var$defer($a393da0e05d61ed1$var$counter);
        return $a393da0e05d61ed1$var$counter;
    };
    $a393da0e05d61ed1$var$clear = function clearImmediate(id) {
        delete $a393da0e05d61ed1$var$queue[id];
    };
    // Node.js 0.8-
    if ($88d6935be735e2e8$exports) $a393da0e05d61ed1$var$defer = function(id) {
        $a393da0e05d61ed1$var$process.nextTick($a393da0e05d61ed1$var$runner(id));
    };
    else if ($a393da0e05d61ed1$var$Dispatch && $a393da0e05d61ed1$var$Dispatch.now) $a393da0e05d61ed1$var$defer = function(id) {
        $a393da0e05d61ed1$var$Dispatch.now($a393da0e05d61ed1$var$runner(id));
    };
    else if ($a393da0e05d61ed1$var$MessageChannel && !$2d59c67a15180939$exports) {
        $a393da0e05d61ed1$var$channel = new $a393da0e05d61ed1$var$MessageChannel();
        $a393da0e05d61ed1$var$port = $a393da0e05d61ed1$var$channel.port2;
        $a393da0e05d61ed1$var$channel.port1.onmessage = $a393da0e05d61ed1$var$eventListener;
        $a393da0e05d61ed1$var$defer = $43284f0171045916$exports($a393da0e05d61ed1$var$port.postMessage, $a393da0e05d61ed1$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($3fbf1185731afe2b$exports.addEventListener && $70e34a5a2021f756$exports($3fbf1185731afe2b$exports.postMessage) && !$3fbf1185731afe2b$exports.importScripts && $a393da0e05d61ed1$var$$location && $a393da0e05d61ed1$var$$location.protocol !== "file:" && !$6140c9fa18232846$exports($a393da0e05d61ed1$var$globalPostMessageDefer)) {
        $a393da0e05d61ed1$var$defer = $a393da0e05d61ed1$var$globalPostMessageDefer;
        $3fbf1185731afe2b$exports.addEventListener("message", $a393da0e05d61ed1$var$eventListener, false);
    // IE8-
    } else if ($a393da0e05d61ed1$var$ONREADYSTATECHANGE in $15c0c414b89100b1$exports("script")) $a393da0e05d61ed1$var$defer = function(id) {
        $b8ce1ad1b6b1e7c1$exports.appendChild($15c0c414b89100b1$exports("script"))[$a393da0e05d61ed1$var$ONREADYSTATECHANGE] = function() {
            $b8ce1ad1b6b1e7c1$exports.removeChild(this);
            $a393da0e05d61ed1$var$run(id);
        };
    };
    else $a393da0e05d61ed1$var$defer = function(id) {
        setTimeout($a393da0e05d61ed1$var$runner(id), 0);
    };
}
$a393da0e05d61ed1$exports = {
    set: $a393da0e05d61ed1$var$set,
    clear: $a393da0e05d61ed1$var$clear
};


var $99b55bbd56d52729$require$clearImmediate = $a393da0e05d61ed1$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$ca3e1754e676956d$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $3fbf1185731afe2b$exports.clearImmediate !== $99b55bbd56d52729$require$clearImmediate
}, {
    clearImmediate: $99b55bbd56d52729$require$clearImmediate
});


"use strict";



var $e55ac54d5aaa2e1c$require$setTask = $a393da0e05d61ed1$exports.set;
var $f112a170991e44cc$exports = {};
"use strict";







var $f112a170991e44cc$var$Function = $3fbf1185731afe2b$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $f112a170991e44cc$var$WRAP = /MSIE .\./.test($34fa2a1382dc63c1$exports) || $87e21695405add0a$exports === "BUN" && function() {
    var version = $3fbf1185731afe2b$exports.Bun.version.split(".");
    return version.length < 3 || version[0] === "0" && (version[1] < 3 || version[1] === "3" && version[2] === "0");
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$f112a170991e44cc$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $f112a170991e44cc$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $7d824954c5058f7d$exports(arguments.length, 1) > firstParamIndex;
        var fn = $70e34a5a2021f756$exports(handler) ? handler : $f112a170991e44cc$var$Function(handler);
        var params = boundArgs ? $0709cba658bb4ed6$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $3cdb2ef65d8e3cb5$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $e55ac54d5aaa2e1c$var$setImmediate = $3fbf1185731afe2b$exports.setImmediate ? $f112a170991e44cc$exports($e55ac54d5aaa2e1c$require$setTask, false) : $e55ac54d5aaa2e1c$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$ca3e1754e676956d$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $3fbf1185731afe2b$exports.setImmediate !== $e55ac54d5aaa2e1c$var$setImmediate
}, {
    setImmediate: $e55ac54d5aaa2e1c$var$setImmediate
});




var $13c40c34b78c8ee2$var$n, $13c40c34b78c8ee2$export$41c562ebe57d11e2, $13c40c34b78c8ee2$var$u, $13c40c34b78c8ee2$export$a8257692ac88316c, $13c40c34b78c8ee2$var$i, $13c40c34b78c8ee2$var$o, $13c40c34b78c8ee2$var$r, $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$e, $13c40c34b78c8ee2$var$c, $13c40c34b78c8ee2$var$s, $13c40c34b78c8ee2$var$a, $13c40c34b78c8ee2$var$h = {}, $13c40c34b78c8ee2$var$v = [], $13c40c34b78c8ee2$var$p = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $13c40c34b78c8ee2$var$y = Array.isArray;
function $13c40c34b78c8ee2$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $13c40c34b78c8ee2$var$w(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $13c40c34b78c8ee2$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $13c40c34b78c8ee2$var$g(l, f, i, o, null);
}
function $13c40c34b78c8ee2$var$g(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$13c40c34b78c8ee2$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(f), f;
}
function $13c40c34b78c8ee2$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $13c40c34b78c8ee2$export$ffb0004e005737fa(n) {
    return n.children;
}
function $13c40c34b78c8ee2$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $13c40c34b78c8ee2$var$x(n, l) {
    if (null == l) return n.__ ? $13c40c34b78c8ee2$var$x(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $13c40c34b78c8ee2$var$x(n) : null;
}
function $13c40c34b78c8ee2$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $13c40c34b78c8ee2$var$C(n);
    }
}
function $13c40c34b78c8ee2$var$S(n) {
    (!n.__d && (n.__d = !0) && $13c40c34b78c8ee2$var$i.push(n) && !$13c40c34b78c8ee2$var$M.__r++ || $13c40c34b78c8ee2$var$o !== $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) && (($13c40c34b78c8ee2$var$o = $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) || $13c40c34b78c8ee2$var$r)($13c40c34b78c8ee2$var$M);
}
function $13c40c34b78c8ee2$var$M() {
    var n, u, t, o, r, e, c, s;
    for($13c40c34b78c8ee2$var$i.sort($13c40c34b78c8ee2$var$f); n = $13c40c34b78c8ee2$var$i.shift();)n.__d && (u = $13c40c34b78c8ee2$var$i.length, o = void 0, e = (r = (t = n).__v).__e, c = [], s = [], t.__P && ((o = $13c40c34b78c8ee2$var$d({}, r)).__v = r.__v + 1, $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(o), $13c40c34b78c8ee2$var$O(t.__P, o, r, t.__n, t.__P.namespaceURI, 32 & r.__u ? [
        e
    ] : null, c, null == e ? $13c40c34b78c8ee2$var$x(r) : e, !!(32 & r.__u), s), o.__v = r.__v, o.__.__k[o.__i] = o, $13c40c34b78c8ee2$var$j(c, o, s), o.__e != e && $13c40c34b78c8ee2$var$C(o)), $13c40c34b78c8ee2$var$i.length > u && $13c40c34b78c8ee2$var$i.sort($13c40c34b78c8ee2$var$f));
    $13c40c34b78c8ee2$var$M.__r = 0;
}
function $13c40c34b78c8ee2$var$P(n, l, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, w, _ = t && t.__k || $13c40c34b78c8ee2$var$v, g = l.length;
    for(u.__d = e, $13c40c34b78c8ee2$var$$(u, l, _), e = u.__d, a = 0; a < g; a++)null != (y = u.__k[a]) && (p = -1 === y.__i ? $13c40c34b78c8ee2$var$h : _[y.__i] || $13c40c34b78c8ee2$var$h, y.__i = a, $13c40c34b78c8ee2$var$O(n, y, p, i, o, r, f, e, c, s), d = y.__e, y.ref && p.ref != y.ref && (p.ref && $13c40c34b78c8ee2$var$N(p.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), 65536 & y.__u || p.__k === y.__k ? e = $13c40c34b78c8ee2$var$I(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = w;
}
function $13c40c34b78c8ee2$var$$(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)null != (i = l[t]) && "boolean" != typeof i && "function" != typeof i ? (r = t + a, (i = n.__k[t] = "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $13c40c34b78c8ee2$var$g(null, i, null, null, null) : $13c40c34b78c8ee2$var$y(i) ? $13c40c34b78c8ee2$var$g($13c40c34b78c8ee2$export$ffb0004e005737fa, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $13c40c34b78c8ee2$var$g(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i).__ = n, i.__b = n.__b + 1, o = null, -1 !== (f = i.__i = $13c40c34b78c8ee2$var$L(i, u, r, s)) && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f == r - 1 ? a-- : f == r + 1 ? a++ : (f > r ? a-- : a++, i.__u |= 65536))) : i = n.__k[t] = null;
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $13c40c34b78c8ee2$var$x(o)), $13c40c34b78c8ee2$var$V(o, o));
}
function $13c40c34b78c8ee2$var$I(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $13c40c34b78c8ee2$var$I(t[i], l, u));
        return l;
    }
    n.__e != l && (l && n.type && !u.contains(l) && (l = $13c40c34b78c8ee2$var$x(n)), u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $13c40c34b78c8ee2$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($13c40c34b78c8ee2$var$y(n) ? n.some(function(n) {
        $13c40c34b78c8ee2$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $13c40c34b78c8ee2$var$L(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type && 0 == (131072 & e.__u)) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $13c40c34b78c8ee2$var$T(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $13c40c34b78c8ee2$var$p.test(l) ? u : u + "px";
}
function $13c40c34b78c8ee2$var$A(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $13c40c34b78c8ee2$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $13c40c34b78c8ee2$var$T(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n || "onFocusOut" === l || "onFocusIn" === l ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = $13c40c34b78c8ee2$var$e, n.addEventListener(l, o ? $13c40c34b78c8ee2$var$s : $13c40c34b78c8ee2$var$c, o)) : n.removeEventListener(l, o ? $13c40c34b78c8ee2$var$s : $13c40c34b78c8ee2$var$c, o);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $13c40c34b78c8ee2$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $13c40c34b78c8ee2$var$e++;
            else if (u.t < t.u) return;
            return t($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $13c40c34b78c8ee2$var$O(n, u, t, i, o, r, f, e, c, s) {
    var a, h, v, p, w, _, g, m, x, C, S, M, $, I, H, L, T = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof T) try {
        if (m = u.props, x = "prototype" in T && T.prototype.render, C = (a = T.contextType) && i[a.__c], S = a ? C ? C.props.value : a.__ : i, t.__c ? g = (h = u.__c = t.__c).__ = h.__E : (x ? u.__c = h = new T(m, S) : (u.__c = h = new $13c40c34b78c8ee2$export$16fa2f45be04daa8(m, S), h.constructor = T, h.render = $13c40c34b78c8ee2$var$q), C && C.sub(h), h.props = m, h.state || (h.state = {}), h.context = S, h.__n = i, v = h.__d = !0, h.__h = [], h._sb = []), x && null == h.__s && (h.__s = h.state), x && null != T.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $13c40c34b78c8ee2$var$d({}, h.__s)), $13c40c34b78c8ee2$var$d(h.__s, T.getDerivedStateFromProps(m, h.__s))), p = h.props, w = h.state, h.__v = u, v) x && null == T.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), x && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (x && null == T.getDerivedStateFromProps && m !== p && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, S), !h.__e && (null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, S) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (h.props = m, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), M = 0; M < h._sb.length; M++)h.__h.push(h._sb[M]);
                h._sb = [], h.__h.length && f.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, S), x && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(p, w, _);
            });
        }
        if (h.context = S, h.props = m, h.__P = n, h.__e = !1, $ = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__r, I = 0, x) {
            for(h.state = h.__s, h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++I < 25);
        h.state = h.__s, null != h.getChildContext && (i = $13c40c34b78c8ee2$var$d($13c40c34b78c8ee2$var$d({}, i), h.getChildContext())), x && !v && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(p, w)), $13c40c34b78c8ee2$var$P(n, $13c40c34b78c8ee2$var$y(L = null != a && a.type === $13c40c34b78c8ee2$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? L : [
            L
        ], u, t, i, o, r, f, e, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && f.push(h), g && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != r) {
            for(u.__u |= c ? 160 : 128; e && 8 === e.nodeType && e.nextSibling;)e = e.nextSibling;
            r[r.indexOf(e)] = null, u.__e = e;
        } else u.__e = t.__e, u.__k = t.__k;
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $13c40c34b78c8ee2$var$z(t.__e, u, t, i, o, r, f, c, s);
    (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.diffed) && a(u);
}
function $13c40c34b78c8ee2$var$j(n, u, t) {
    u.__d = void 0;
    for(var i = 0; i < t.length; i++)$13c40c34b78c8ee2$var$N(t[i], t[++i], t[++i]);
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $13c40c34b78c8ee2$var$z(u, t, i, o, r, f, e, c, s) {
    var a, v, p, d, _, g, m, b = i.props, k = t.props, C = t.type;
    if ("svg" === C ? r = "http://www.w3.org/2000/svg" : "math" === C ? r = "http://www.w3.org/1998/Math/MathML" : r || (r = "http://www.w3.org/1999/xhtml"), null != f) {
        for(a = 0; a < f.length; a++)if ((_ = f[a]) && "setAttribute" in _ == !!C && (C ? _.localName === C : 3 === _.nodeType)) {
            u = _, f[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null === C) return document.createTextNode(k);
        u = document.createElementNS(r, C, k.is && k), c && ($13c40c34b78c8ee2$export$41c562ebe57d11e2.__m && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__m(t, f), c = !1), f = null;
    }
    if (null === C) b === k || c && u.data === k || (u.data = k);
    else {
        if (f = f && $13c40c34b78c8ee2$var$n.call(u.childNodes), b = i.props || $13c40c34b78c8ee2$var$h, !c && null != f) for(b = {}, a = 0; a < u.attributes.length; a++)b[(_ = u.attributes[a]).name] = _.value;
        for(a in b)if (_ = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) p = _;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $13c40c34b78c8ee2$var$A(u, a, null, _, r);
        }
        for(a in k)_ = k[a], "children" == a ? d = _ : "dangerouslySetInnerHTML" == a ? v = _ : "value" == a ? g = _ : "checked" == a ? m = _ : c && "function" != typeof _ || b[a] === _ || $13c40c34b78c8ee2$var$A(u, a, _, b[a], r);
        if (v) c || p && (v.__html === p.__html || v.__html === u.innerHTML) || (u.innerHTML = v.__html), t.__k = [];
        else if (p && (u.innerHTML = ""), $13c40c34b78c8ee2$var$P(u, $13c40c34b78c8ee2$var$y(d) ? d : [
            d
        ], t, i, o, "foreignObject" === C ? "http://www.w3.org/1999/xhtml" : r, f, e, f ? f[0] : i.__k && $13c40c34b78c8ee2$var$x(i, 0), c, s), null != f) for(a = f.length; a--;)$13c40c34b78c8ee2$var$w(f[a]);
        c || (a = "value", "progress" === C && null == g ? u.removeAttribute("value") : void 0 !== g && (g !== u[a] || "progress" === C && !g || "option" === C && g !== b[a]) && $13c40c34b78c8ee2$var$A(u, a, g, b[a], r), a = "checked", void 0 !== m && m !== u[a] && $13c40c34b78c8ee2$var$A(u, a, m, b[a], r));
    }
    return u;
}
function $13c40c34b78c8ee2$var$N(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $13c40c34b78c8ee2$var$V(n, u, t) {
    var i, o;
    if ($13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount && $13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $13c40c34b78c8ee2$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $13c40c34b78c8ee2$var$V(i[o], u, t || "function" != typeof n.type);
    t || $13c40c34b78c8ee2$var$w(n.__e), n.__c = n.__ = n.__e = n.__d = void 0;
}
function $13c40c34b78c8ee2$var$q(n, l, u) {
    return this.constructor(n, u);
}
function $13c40c34b78c8ee2$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__ && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $13c40c34b78c8ee2$var$O(t, u = (!o && i || t).__k = $13c40c34b78c8ee2$export$c8a8987d4410bf2d($13c40c34b78c8ee2$export$ffb0004e005737fa, null, [
        u
    ]), r || $13c40c34b78c8ee2$var$h, $13c40c34b78c8ee2$var$h, t.namespaceURI, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $13c40c34b78c8ee2$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), $13c40c34b78c8ee2$var$j(f, u, e);
}
function $13c40c34b78c8ee2$export$fa8d919ba61d84db(n, l) {
    $13c40c34b78c8ee2$export$b3890eb0ae9dca99(n, l, $13c40c34b78c8ee2$export$fa8d919ba61d84db);
}
function $13c40c34b78c8ee2$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $13c40c34b78c8ee2$var$d({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), $13c40c34b78c8ee2$var$g(l.type, e, i || l.key, o || l.ref, null);
}
function $13c40c34b78c8ee2$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $13c40c34b78c8ee2$var$a++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = new Set, (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.componentWillUnmount = function() {
                u = null;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.forEach(function(n) {
                    n.__e = !0, $13c40c34b78c8ee2$var$S(n);
                });
            }, this.sub = function(n) {
                u.add(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u && u.delete(n), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$13c40c34b78c8ee2$var$n = $13c40c34b78c8ee2$var$v.slice, $13c40c34b78c8ee2$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $13c40c34b78c8ee2$var$u = 0, $13c40c34b78c8ee2$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $13c40c34b78c8ee2$var$d({}, this.state), "function" == typeof n && (n = n($13c40c34b78c8ee2$var$d({}, u), this.props)), n && $13c40c34b78c8ee2$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $13c40c34b78c8ee2$var$S(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $13c40c34b78c8ee2$var$S(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.render = $13c40c34b78c8ee2$export$ffb0004e005737fa, $13c40c34b78c8ee2$var$i = [], $13c40c34b78c8ee2$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $13c40c34b78c8ee2$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $13c40c34b78c8ee2$var$M.__r = 0, $13c40c34b78c8ee2$var$e = 0, $13c40c34b78c8ee2$var$c = $13c40c34b78c8ee2$var$F(!1), $13c40c34b78c8ee2$var$s = $13c40c34b78c8ee2$var$F(!0), $13c40c34b78c8ee2$var$a = 0;


var $7cf5de2d778dc547$var$t = /["&<]/;
function $7cf5de2d778dc547$var$n(r) {
    if (0 === r.length || !1 === $7cf5de2d778dc547$var$t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var $7cf5de2d778dc547$var$o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $7cf5de2d778dc547$var$f = 0, $7cf5de2d778dc547$var$i = Array.isArray;
function $7cf5de2d778dc547$export$34b9dba7ce09269b(e, t, n, o, i, u) {
    t || (t = {});
    var a, c, l = t;
    "ref" in t && (a = t.ref, delete t.ref);
    var p = {
        type: e,
        props: l,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: --$7cf5de2d778dc547$var$f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === l[c] && (l[c] = a[c]);
    return (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).vnode && (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).vnode(p), p;
}
function $7cf5de2d778dc547$export$45700d561b2268ac(r) {
    var t = $7cf5de2d778dc547$export$34b9dba7ce09269b((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var $7cf5de2d778dc547$var$c = {}, $7cf5de2d778dc547$var$l = /[A-Z]/g;
function $7cf5de2d778dc547$export$991f6ffe102e5bac(e, t) {
    if ((0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).attr) {
        var f = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if ("ref" === e || "key" === e) return "";
    if ("style" === e && "object" == typeof t) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var p = "-" == u[0] ? u : $7cf5de2d778dc547$var$c[u] || ($7cf5de2d778dc547$var$c[u] = u.replace($7cf5de2d778dc547$var$l, "-$&").toLowerCase()), _ = ";";
                "number" != typeof a || p.startsWith("--") || $7cf5de2d778dc547$var$o.test(p) || (_ = "px;"), i = i + p + ":" + a + _;
            }
        }
        return e + '="' + i + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == typeof t ? "" : !0 === t ? e : e + '="' + $7cf5de2d778dc547$var$n(t) + '"';
}
function $7cf5de2d778dc547$export$40e96e718441efeb(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == typeof r) {
        if (void 0 === r.constructor) return r;
        if ($7cf5de2d778dc547$var$i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = $7cf5de2d778dc547$export$40e96e718441efeb(r[e]);
            return r;
        }
    }
    return $7cf5de2d778dc547$var$n("" + r);
}



var $7238a34a955809b2$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7238a34a955809b2$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $7238a34a955809b2$exports));
try {
    regeneratorRuntime = $7238a34a955809b2$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $7238a34a955809b2$var$runtime;
    else Function("r", "regeneratorRuntime = r")($7238a34a955809b2$var$runtime);
}






var $204a33a7557cbbd0$var$t, $204a33a7557cbbd0$var$r, $204a33a7557cbbd0$var$u, $204a33a7557cbbd0$var$i, $204a33a7557cbbd0$var$o = 0, $204a33a7557cbbd0$var$f = [], $204a33a7557cbbd0$var$c = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2), $204a33a7557cbbd0$var$e = $204a33a7557cbbd0$var$c.__b, $204a33a7557cbbd0$var$a = $204a33a7557cbbd0$var$c.__r, $204a33a7557cbbd0$var$v = $204a33a7557cbbd0$var$c.diffed, $204a33a7557cbbd0$var$l = $204a33a7557cbbd0$var$c.__c, $204a33a7557cbbd0$var$m = $204a33a7557cbbd0$var$c.unmount, $204a33a7557cbbd0$var$s = $204a33a7557cbbd0$var$c.__;
function $204a33a7557cbbd0$var$d(n, t) {
    $204a33a7557cbbd0$var$c.__h && $204a33a7557cbbd0$var$c.__h($204a33a7557cbbd0$var$r, n, $204a33a7557cbbd0$var$o || t), $204a33a7557cbbd0$var$o = 0;
    var u = $204a33a7557cbbd0$var$r.__H || ($204a33a7557cbbd0$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $204a33a7557cbbd0$export$60241385465d0a34(n) {
    return $204a33a7557cbbd0$var$o = 1, $204a33a7557cbbd0$export$13e3392192263954($204a33a7557cbbd0$var$D, n);
}
function $204a33a7557cbbd0$export$13e3392192263954(n, u, i) {
    var o = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $204a33a7557cbbd0$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $204a33a7557cbbd0$var$r, !$204a33a7557cbbd0$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        $204a33a7557cbbd0$var$r.u = !0;
        var c = $204a33a7557cbbd0$var$r.shouldComponentUpdate, e = $204a33a7557cbbd0$var$r.componentWillUpdate;
        $204a33a7557cbbd0$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $204a33a7557cbbd0$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $204a33a7557cbbd0$export$6d9c69b0de29b591(n, u) {
    var i = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 3);
    !$204a33a7557cbbd0$var$c.__s && $204a33a7557cbbd0$var$C(i.__H, u) && (i.__ = n, i.i = u, $204a33a7557cbbd0$var$r.__H.__h.push(i));
}
function $204a33a7557cbbd0$export$e5c5a5f917a5871c(n, u) {
    var i = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 4);
    !$204a33a7557cbbd0$var$c.__s && $204a33a7557cbbd0$var$C(i.__H, u) && (i.__ = n, i.i = u, $204a33a7557cbbd0$var$r.__h.push(i));
}
function $204a33a7557cbbd0$export$b8f5890fc79d6aca(n) {
    return $204a33a7557cbbd0$var$o = 5, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $204a33a7557cbbd0$export$d5a552a76deda3c2(n, t, r) {
    $204a33a7557cbbd0$var$o = 6, $204a33a7557cbbd0$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $204a33a7557cbbd0$export$1538c33de8887b59(n, r) {
    var u = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 7);
    return $204a33a7557cbbd0$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $204a33a7557cbbd0$export$35808ee640e87ca7(n, t) {
    return $204a33a7557cbbd0$var$o = 8, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $204a33a7557cbbd0$export$fae74005e78b1a27(n) {
    var u = $204a33a7557cbbd0$var$r.context[n.__c], i = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($204a33a7557cbbd0$var$r)), u.props.value) : n.__;
}
function $204a33a7557cbbd0$export$dc8fbce3eb94dc1e(n, t) {
    $204a33a7557cbbd0$var$c.useDebugValue && $204a33a7557cbbd0$var$c.useDebugValue(t ? t(n) : n);
}
function $204a33a7557cbbd0$export$c052f6604b7d51fe(n) {
    var u = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 10), i = $204a33a7557cbbd0$export$60241385465d0a34();
    return u.__ = n, $204a33a7557cbbd0$var$r.componentDidCatch || ($204a33a7557cbbd0$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $204a33a7557cbbd0$export$f680877a34711e37() {
    var n = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 11);
    if (!n.__) {
        for(var u = $204a33a7557cbbd0$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $204a33a7557cbbd0$var$j() {
    for(var n; n = $204a33a7557cbbd0$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($204a33a7557cbbd0$var$z), n.__H.__h.forEach($204a33a7557cbbd0$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $204a33a7557cbbd0$var$c.__e(t, n.__v);
    }
}
$204a33a7557cbbd0$var$c.__b = function(n) {
    $204a33a7557cbbd0$var$r = null, $204a33a7557cbbd0$var$e && $204a33a7557cbbd0$var$e(n);
}, $204a33a7557cbbd0$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $204a33a7557cbbd0$var$s && $204a33a7557cbbd0$var$s(n, t);
}, $204a33a7557cbbd0$var$c.__r = function(n) {
    $204a33a7557cbbd0$var$a && $204a33a7557cbbd0$var$a(n), $204a33a7557cbbd0$var$t = 0;
    var i = ($204a33a7557cbbd0$var$r = n.__c).__H;
    i && ($204a33a7557cbbd0$var$u === $204a33a7557cbbd0$var$r ? (i.__h = [], $204a33a7557cbbd0$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.i = n.__N = void 0;
    })) : (i.__h.forEach($204a33a7557cbbd0$var$z), i.__h.forEach($204a33a7557cbbd0$var$B), i.__h = [], $204a33a7557cbbd0$var$t = 0)), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r;
}, $204a33a7557cbbd0$var$c.diffed = function(n) {
    $204a33a7557cbbd0$var$v && $204a33a7557cbbd0$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $204a33a7557cbbd0$var$f.push(t) && $204a33a7557cbbd0$var$i === $204a33a7557cbbd0$var$c.requestAnimationFrame || (($204a33a7557cbbd0$var$i = $204a33a7557cbbd0$var$c.requestAnimationFrame) || $204a33a7557cbbd0$var$w)($204a33a7557cbbd0$var$j)), t.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.i = void 0;
    })), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r = null;
}, $204a33a7557cbbd0$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($204a33a7557cbbd0$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $204a33a7557cbbd0$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $204a33a7557cbbd0$var$c.__e(r, n.__v);
        }
    }), $204a33a7557cbbd0$var$l && $204a33a7557cbbd0$var$l(n, t);
}, $204a33a7557cbbd0$var$c.unmount = function(n) {
    $204a33a7557cbbd0$var$m && $204a33a7557cbbd0$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $204a33a7557cbbd0$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $204a33a7557cbbd0$var$c.__e(t, r.__v));
};
var $204a33a7557cbbd0$var$k = "function" == typeof requestAnimationFrame;
function $204a33a7557cbbd0$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $204a33a7557cbbd0$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $204a33a7557cbbd0$var$k && (t = requestAnimationFrame(r));
}
function $204a33a7557cbbd0$var$z(n) {
    var t = $204a33a7557cbbd0$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$B(n) {
    var t = $204a33a7557cbbd0$var$r;
    n.__c = n.__(), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $204a33a7557cbbd0$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}


var $044786338e0e8fe2$var$a = {};
function $044786338e0e8fe2$var$c(n, t) {
    for(var r in t)n[r] = t[r];
    return n;
}
function $044786338e0e8fe2$export$78e3044358792147(n, t, r) {
    var i, o = /(?:\?([^#]*))?(#.*)?$/, e = n.match(o), u = {};
    if (e && e[1]) for(var f = e[1].split("&"), c = 0; c < f.length; c++){
        var s = f[c].split("=");
        u[decodeURIComponent(s[0])] = decodeURIComponent(s.slice(1).join("="));
    }
    n = $044786338e0e8fe2$var$d(n.replace(o, "")), t = $044786338e0e8fe2$var$d(t || "");
    for(var h = Math.max(n.length, t.length), v = 0; v < h; v++)if (t[v] && ":" === t[v].charAt(0)) {
        var l = t[v].replace(/(^:|[+*?]+$)/g, ""), p = (t[v].match(/[+*?]+$/) || $044786338e0e8fe2$var$a)[0] || "", m = ~p.indexOf("+"), y = ~p.indexOf("*"), U = n[v] || "";
        if (!U && !y && (p.indexOf("?") < 0 || m)) {
            i = !1;
            break;
        }
        if (u[l] = decodeURIComponent(U), m || y) {
            u[l] = n.slice(v).map(decodeURIComponent).join("/");
            break;
        }
    } else if (t[v] !== n[v]) {
        i = !1;
        break;
    }
    return (!0 === r.default || !1 !== i) && u;
}
function $044786338e0e8fe2$var$h(n, t) {
    return n.rank < t.rank ? 1 : n.rank > t.rank ? -1 : n.index - t.index;
}
function $044786338e0e8fe2$var$v(n, t) {
    return n.index = t, n.rank = function(n) {
        return n.props.default ? 0 : $044786338e0e8fe2$var$d(n.props.path).map($044786338e0e8fe2$var$l).join("");
    }(n), n.props;
}
function $044786338e0e8fe2$var$d(n) {
    return n.replace(/(^\/+|\/+$)/g, "").split("/");
}
function $044786338e0e8fe2$var$l(n) {
    return ":" == n.charAt(0) ? 1 + "*+?".indexOf(n.charAt(n.length - 1)) || 4 : 5;
}
var $044786338e0e8fe2$var$p = {}, $044786338e0e8fe2$var$m = [], $044786338e0e8fe2$var$y = [], $044786338e0e8fe2$var$U = null, $044786338e0e8fe2$var$g = {
    url: $044786338e0e8fe2$export$dc90482e4ef07afd()
}, $044786338e0e8fe2$var$k = (0, $13c40c34b78c8ee2$export$fd42f52fd3ae1109)($044786338e0e8fe2$var$g);
function $044786338e0e8fe2$export$9a302a45f65d0572() {
    var n = (0, $204a33a7557cbbd0$export$fae74005e78b1a27)($044786338e0e8fe2$var$k);
    if (n === $044786338e0e8fe2$var$g) {
        var t = (0, $204a33a7557cbbd0$export$60241385465d0a34)()[1];
        (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(function() {
            return $044786338e0e8fe2$var$y.push(t), function() {
                return $044786338e0e8fe2$var$y.splice($044786338e0e8fe2$var$y.indexOf(t), 1);
            };
        }, []);
    }
    return [
        n,
        $044786338e0e8fe2$export$4cb887bfde2d34ca
    ];
}
function $044786338e0e8fe2$export$dc90482e4ef07afd() {
    var n;
    return "" + ((n = $044786338e0e8fe2$var$U && $044786338e0e8fe2$var$U.location ? $044786338e0e8fe2$var$U.location : $044786338e0e8fe2$var$U && $044786338e0e8fe2$var$U.getCurrentLocation ? $044786338e0e8fe2$var$U.getCurrentLocation() : "undefined" != typeof location ? location : $044786338e0e8fe2$var$p).pathname || "") + (n.search || "");
}
function $044786338e0e8fe2$export$4cb887bfde2d34ca(n, t) {
    return void 0 === t && (t = !1), "string" != typeof n && n.url && (t = n.replace, n = n.url), function(n) {
        for(var t = $044786338e0e8fe2$var$m.length; t--;)if ($044786338e0e8fe2$var$m[t].canRoute(n)) return !0;
        return !1;
    }(n) && function(n, t) {
        void 0 === t && (t = "push"), $044786338e0e8fe2$var$U && $044786338e0e8fe2$var$U[t] ? $044786338e0e8fe2$var$U[t](n) : "undefined" != typeof history && history[t + "State"] && history[t + "State"](null, null, n);
    }(n, t ? "replace" : "push"), $044786338e0e8fe2$var$I(n);
}
function $044786338e0e8fe2$var$I(n) {
    for(var t = !1, r = 0; r < $044786338e0e8fe2$var$m.length; r++)$044786338e0e8fe2$var$m[r].routeTo(n) && (t = !0);
    return t;
}
function $044786338e0e8fe2$var$M(n) {
    if (n && n.getAttribute) {
        var t = n.getAttribute("href"), r = n.getAttribute("target");
        if (t && t.match(/^\//g) && (!r || r.match(/^_?self$/i))) return $044786338e0e8fe2$export$4cb887bfde2d34ca(t);
    }
}
function $044786338e0e8fe2$var$b(n) {
    return n.stopImmediatePropagation && n.stopImmediatePropagation(), n.stopPropagation && n.stopPropagation(), n.preventDefault(), !1;
}
function $044786338e0e8fe2$var$W(n) {
    if (!(n.ctrlKey || n.metaKey || n.altKey || n.shiftKey || n.button)) {
        var t = n.target;
        do if ("a" === t.localName && t.getAttribute("href")) {
            if (t.hasAttribute("data-native") || t.hasAttribute("native")) return;
            if ($044786338e0e8fe2$var$M(t)) return $044786338e0e8fe2$var$b(n);
        }
        while (t = t.parentNode);
    }
}
var $044786338e0e8fe2$var$w = !1;
function $044786338e0e8fe2$export$55185c17a0fcbe46(n) {
    n.history && ($044786338e0e8fe2$var$U = n.history), this.state = {
        url: n.url || $044786338e0e8fe2$export$dc90482e4ef07afd()
    };
}
$044786338e0e8fe2$var$c($044786338e0e8fe2$export$55185c17a0fcbe46.prototype = new (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8), {
    shouldComponentUpdate: function(n) {
        return !0 !== n.static || n.url !== this.props.url || n.onChange !== this.props.onChange;
    },
    canRoute: function(n) {
        var t = (0, $13c40c34b78c8ee2$export$47e4c5b300681277)(this.props.children);
        return void 0 !== this.g(t, n);
    },
    routeTo: function(n) {
        this.setState({
            url: n
        });
        var t = this.canRoute(n);
        return this.p || this.forceUpdate(), t;
    },
    componentWillMount: function() {
        this.p = !0;
    },
    componentDidMount: function() {
        var n = this;
        $044786338e0e8fe2$var$w || ($044786338e0e8fe2$var$w = !0, $044786338e0e8fe2$var$U || addEventListener("popstate", function() {
            $044786338e0e8fe2$var$I($044786338e0e8fe2$export$dc90482e4ef07afd());
        }), addEventListener("click", $044786338e0e8fe2$var$W)), $044786338e0e8fe2$var$m.push(this), $044786338e0e8fe2$var$U && (this.u = $044786338e0e8fe2$var$U.listen(function(t) {
            var r = t.location || t;
            n.routeTo("" + (r.pathname || "") + (r.search || ""));
        })), this.p = !1;
    },
    componentWillUnmount: function() {
        "function" == typeof this.u && this.u(), $044786338e0e8fe2$var$m.splice($044786338e0e8fe2$var$m.indexOf(this), 1);
    },
    componentWillUpdate: function() {
        this.p = !0;
    },
    componentDidUpdate: function() {
        this.p = !1;
    },
    g: function(n, t) {
        n = n.filter($044786338e0e8fe2$var$v).sort($044786338e0e8fe2$var$h);
        for(var r = 0; r < n.length; r++){
            var i = n[r], o = $044786338e0e8fe2$export$78e3044358792147(t, i.props.path, i.props);
            if (o) return [
                i,
                o
            ];
        }
    },
    render: function(n, t) {
        var e, u, f = n.onChange, a = t.url, s = this.c, h = this.g((0, $13c40c34b78c8ee2$export$47e4c5b300681277)(n.children), a);
        if (h && (u = (0, $13c40c34b78c8ee2$export$e530037191fcd5d7)(h[0], $044786338e0e8fe2$var$c($044786338e0e8fe2$var$c({
            url: a,
            matches: e = h[1]
        }, e), {
            key: void 0,
            ref: void 0
        }))), a !== (s && s.url)) {
            $044786338e0e8fe2$var$c($044786338e0e8fe2$var$g, s = this.c = {
                url: a,
                previous: s && s.url,
                current: u,
                path: u ? u.props.path : null,
                matches: e
            }), s.router = this, s.active = u ? [
                u
            ] : [];
            for(var v = $044786338e0e8fe2$var$y.length; v--;)$044786338e0e8fe2$var$y[v]({});
            "function" == typeof f && f(s);
        }
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($044786338e0e8fe2$var$k.Provider, {
            value: s
        }, u);
    }
});
var $044786338e0e8fe2$export$a6c7ac8248d6e38a = function(n) {
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("a", $044786338e0e8fe2$var$c({
        onClick: $044786338e0e8fe2$var$W
    }, n));
}, $044786338e0e8fe2$export$e7b0ac011bb776c6 = function(n) {
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(n.component, n);
};










"use strict";
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Walk the prototype chain (excluding the shared Object.prototype) looking for
 * an own `prop`. This distinguishes genuine own/inherited members — including
 * class accessors and template prototypes — from members injected via
 * Object.prototype pollution (e.g. `Object.prototype.username = '...'`), which
 * live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $c319b2c832c2914a$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null && obj !== Object.prototype){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        if ($c319b2c832c2914a$var$hasOwnProperty(obj, prop)) return true;
        obj = $c319b2c832c2914a$var$getPrototypeOf(obj);
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $c319b2c832c2914a$var$getSafeProp = (obj, prop)=>obj != null && $c319b2c832c2914a$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if (!$c319b2c832c2914a$var$isObject(val)) return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $c319b2c832c2914a$var$getPrototypeOf(prototype) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
    // Symbol.iterator as evidence the value is a tagged/iterable type rather
    // than a plain object, while ignoring keys injected onto Object.prototype.
    !$c319b2c832c2914a$var$hasOwnInPrototypeChain(val, $c319b2c832c2914a$var$toStringTag) && !$c319b2c832c2914a$var$hasOwnInPrototypeChain(val, $c319b2c832c2914a$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c319b2c832c2914a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c319b2c832c2914a$var$isObject(val) || $c319b2c832c2914a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest("File");
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $c319b2c832c2914a$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== "undefined");
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $c319b2c832c2914a$var$isReactNative = (formData)=>formData && typeof formData.getParts !== "undefined";
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    return {};
}
const $c319b2c832c2914a$var$G = $c319b2c832c2914a$var$getGlobal();
const $c319b2c832c2914a$var$FormDataCtor = typeof $c319b2c832c2914a$var$G.FormData !== "undefined" ? $c319b2c832c2914a$var$G.FormData : undefined;
const $c319b2c832c2914a$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($c319b2c832c2914a$var$FormDataCtor && thing instanceof $c319b2c832c2914a$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $c319b2c832c2914a$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$c319b2c832c2914a$var$isFunction(thing.append)) return false;
    const kind = $c319b2c832c2914a$var$kindOf(thing);
    return kind === "formdata" || // detect form-data instance
    kind === "object" && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === "[object FormData]";
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest("URLSearchParams");
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c319b2c832c2914a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $c319b2c832c2914a$var$findKey(obj, key) {
    if ($c319b2c832c2914a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === "__proto__" || key === "constructor" || key === "prototype") return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === "string" && $c319b2c832c2914a$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $c319b2c832c2914a$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($c319b2c832c2914a$var$isPlainObject(existing) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(existing, val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c319b2c832c2914a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $c319b2c832c2914a$var$isBuffer(source)) continue;
        $c319b2c832c2914a$var$forEach(source, assignValue);
        if (typeof source !== "object" || $c319b2c832c2914a$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($c319b2c832c2914a$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, "constructor", {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, "super", {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest("HTMLFormElement");
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $c319b2c832c2914a$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest("RegExp");
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].includes(name)) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === "FormData" && thing[$c319b2c832c2914a$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($c319b2c832c2914a$var$isBuffer(source)) return source;
            if (!("toJSON" in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest("AsyncFunction");
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : typeof $cfae44f0dfdf62c0$exports !== "undefined" && $cfae44f0dfdf62c0$exports.nextTick || $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $c319b2c832c2914a$var$isSafeIterable = (thing)=>thing != null && $c319b2c832c2914a$var$hasOwnInPrototypeChain(thing, $c319b2c832c2914a$var$iterator) && $c319b2c832c2914a$var$isIterable(thing);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isEmptyObject: $c319b2c832c2914a$var$isEmptyObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isReactNativeBlob: $c319b2c832c2914a$var$isReactNativeBlob,
    isReactNative: $c319b2c832c2914a$var$isReactNative,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnInPrototypeChain: $c319b2c832c2914a$var$hasOwnInPrototypeChain,
    getSafeProp: $c319b2c832c2914a$var$getSafeProp,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable,
    isSafeIterable: $c319b2c832c2914a$var$isSafeIterable
};









"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};



"use strict";
function $f8f5102fdfcbfec9$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g");
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function $f8f5102fdfcbfec9$var$sanitizeValue(value, invalidChars) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$f8f5102fdfcbfec9$var$sanitizeValue(item, invalidChars));
    return $f8f5102fdfcbfec9$var$trimSPorHTAB(String(value).replace(invalidChars, ""));
}
const $f8f5102fdfcbfec9$export$9e344cffce061a22 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $f8f5102fdfcbfec9$export$59dd66c2a12d8f62 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $f8f5102fdfcbfec9$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $f8f5102fdfcbfec9$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


"use strict";
const $866cce54f6bdfb0c$var$$internals = Symbol("internals");
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : (0, $f8f5102fdfcbfec9$export$9e344cffce061a22)(String(value));
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(header) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError("Object iterator must return a key-value pair");
                key = entry[0];
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


"use strict";
const $4e2395edb77acf3a$var$REDACTED = "[REDACTED ****]";
function $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(source, "toJSON")) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(prototype, "toJSON")) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $4e2395edb77acf3a$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== "object") return source;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source) && $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $4e2395edb77acf3a$var$REDACTED : visit(value);
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
class $4e2395edb77acf3a$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $4e2395edb77acf3a$var$AxiosError(error.message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, "cause", {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, "message", {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = "AxiosError";
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config, "redact") ? config.redact : undefined;
        const serializedConfig = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $4e2395edb77acf3a$var$redactConfig(config, redactKeys) : (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION = "ERR_BAD_OPTION";
$4e2395edb77acf3a$var$AxiosError.ECONNABORTED = "ECONNABORTED";
$4e2395edb77acf3a$var$AxiosError.ETIMEDOUT = "ETIMEDOUT";
$4e2395edb77acf3a$var$AxiosError.ECONNREFUSED = "ECONNREFUSED";
$4e2395edb77acf3a$var$AxiosError.ERR_NETWORK = "ERR_NETWORK";
$4e2395edb77acf3a$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
$4e2395edb77acf3a$var$AxiosError.ERR_DEPRECATED = "ERR_DEPRECATED";
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
$4e2395edb77acf3a$var$AxiosError.ERR_CANCELED = "ERR_CANCELED";
$4e2395edb77acf3a$var$AxiosError.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
$4e2395edb77acf3a$var$AxiosError.ERR_INVALID_URL = "ERR_INVALID_URL";
$4e2395edb77acf3a$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $e6cbd383b18c9625$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
"use strict";
const $e6cbd383b18c9625$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const maxDepth = options.maxDepth === undefined ? $e6cbd383b18c9625$export$659081b45d03227d : options.maxDepth;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) {
            if (useBlob && typeof _Blob === "function") return new _Blob([
                value
            ]);
            if (typeof $e6cbd383b18c9625$require$Buffer !== "undefined") return $e6cbd383b18c9625$require$Buffer.from(value);
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Object is too deeply nested (" + depth + " levels). Max depth: " + maxDepth, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNative(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === "object") {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $f66f8c7b4f247caf$var$encode) : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


"use strict";
function $8df8fedf1c1e4428$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || "";
    const _options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(_options, "encode") || $8df8fedf1c1e4428$export$c564cdbbe6da493;
    const serializeFn = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(_options, "serialize");
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





"use strict";
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};






"use strict";
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


"use strict";
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


"use strict";
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}






"use strict";
const $5f8142930b3b943f$var$MAX_DEPTH = (0, $e6cbd383b18c9625$export$659081b45d03227d);
function $5f8142930b3b943f$var$throwIfDepthExceeded(index) {
    if (index > $5f8142930b3b943f$var$MAX_DEPTH) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("FormData field is too deeply nested (" + index + " levels). Max depth: " + $5f8142930b3b943f$var$MAX_DEPTH, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    const path = [];
    const pattern = /\w+|\[(\w*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $5f8142930b3b943f$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === "[]" ? "" : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $5f8142930b3b943f$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


"use strict";
const $843bf0209bc94df8$var$own = (obj, key)=>obj != null && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $843bf0209bc94df8$var$own(this, "formSerializer");
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const env = $843bf0209bc94df8$var$own(this, "env");
                    const _FormData = env && env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $843bf0209bc94df8$var$own(this, "transitional") || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $843bf0209bc94df8$var$own(this, "responseType");
            const JSONRequested = responseType === "json";
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $843bf0209bc94df8$var$own(this, "parseReviver"));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $843bf0209bc94df8$var$own(this, "response"));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch",
    "query"
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;



"use strict";
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




"use strict";
class $9fd0919e266b4fda$var$CanceledError extends (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? "canceled" : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = "CanceledError";
        this.__CANCEL__ = true;
    }
}
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







"use strict";
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request failed with status code " + response.status, response.status >= 400 && response.status < 500 ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





"use strict";
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;



const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        if (!e || typeof e.loaded !== "number") return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(()=>fn(...args));






var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin), (0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === "undefined") return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push("secure");
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join("; ");
    },
    read (name) {
        if (typeof document === "undefined") return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(";");
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, "");
            const eq = cookie.indexOf("=");
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000, "/");
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};



"use strict";
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== "string") return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
const $598acbfafd2c63c5$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
const $598acbfafd2c63c5$var$httpProtocolControlCharacters = /[\t\n\r]/g;
function $598acbfafd2c63c5$var$stripLeadingC0ControlOrSpace(url) {
    let i = 0;
    while(i < url.length && url.charCodeAt(i) <= 0x20)i++;
    return url.slice(i);
}
function $598acbfafd2c63c5$var$normalizeURLForProtocolCheck(url) {
    return $598acbfafd2c63c5$var$stripLeadingC0ControlOrSpace(url).replace($598acbfafd2c63c5$var$httpProtocolControlCharacters, "");
}
function $598acbfafd2c63c5$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === "string" && $598acbfafd2c63c5$var$malformedHttpProtocol.test($598acbfafd2c63c5$var$normalizeURLForProtocolCheck(url))) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Invalid URL: missing "//" after protocol', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
}
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $598acbfafd2c63c5$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $598acbfafd2c63c5$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}




"use strict";
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, "hasOwnProperty", {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, "transitional") ? config2.transitional : undefined;
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, "transitional") ? config1.transitional : undefined;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === "__proto__" || prop === "constructor" || prop === "prototype") return;
        const merge = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, "validateStatus") && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption("validateStatusUndefinedResolves") === false) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, "validateStatus")) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}




const $ab4625fac3104691$var$FORM_DATA_CONTENT_HEADERS = [
    "content-type",
    "content-length"
];
function $ab4625fac3104691$var$setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== "content-only") {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($ab4625fac3104691$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $ab4625fac3104691$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $ab4625fac3104691$var$resolveConfig(config) {
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own("data");
    let withXSRFToken = own("withXSRFToken");
    const xsrfHeaderName = own("xsrfHeaderName");
    const xsrfCookieName = own("xsrfCookieName");
    let headers = own("headers");
    const auth = own("auth");
    const baseURL = own("baseURL");
    const allowAbsoluteUrls = own("allowAbsoluteUrls");
    const url = own("url");
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own("params"), own("paramsSerializer"));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(auth, "username") || "";
        const password = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(auth, "password") || "";
        try {
            headers.set("Authorization", "Basic " + btoa(username + ":" + (password ? $ab4625fac3104691$var$encodeUTF8(password) : "")));
        } catch (e) {
            throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        $ab4625fac3104691$var$setFormDataHeaders(headers, data.getHeaders(), own("formDataHeaderPolicy"));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $ab4625fac3104691$export$2e2bcd8739ae039 = $ab4625fac3104691$var$resolveConfig;



const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith("file:"))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request aborted", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : "Network Error";
            const err = new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(msg, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach((0, $f8f5102fdfcbfec9$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>signal.addEventListener("abort", onabort, {
            once: true
        }));
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: compute the exact percent-decoded UTF-8 byte length.
 *
 * @param {string} url
 * @returns {number}
 */ const $da69a2069c6136ea$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $da69a2069c6136ea$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $da69a2069c6136ea$var$isHexDigit(str.charCodeAt(i + 1)) && $da69a2069c6136ea$var$isHexDigit(str.charCodeAt(i + 2));
function $da69a2069c6136ea$export$2e2bcd8739ae039(url) {
    if (!url || typeof url !== "string") return 0;
    if (!url.startsWith("data:")) return 0;
    const comma = url.indexOf(",");
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) {
        let effectiveLen = body.length;
        const len = body.length; // cache length
        for(let i = 0; i < len; i++)if (body.charCodeAt(i) === 37 /* '%' */  && i + 2 < len) {
            const a = body.charCodeAt(i + 1);
            const b = body.charCodeAt(i + 2);
            const isHex = $da69a2069c6136ea$var$isHexDigit(a) && $da69a2069c6136ea$var$isHexDigit(b);
            if (isHex) {
                effectiveLen -= 2;
                i += 2;
            }
        }
        let pad = 0;
        let idx = len - 1;
        const tailIsPct3D = (j)=>j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
            body.charCodeAt(j - 1) === 51 && // '3'
            (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100); // 'D' or 'd'
        if (idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) {
                pad++;
                idx--;
            } else if (tailIsPct3D(idx)) {
                pad++;
                idx -= 3;
            }
        }
        if (pad === 1 && idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) pad++;
            else if (tailIsPct3D(idx)) pad++;
        }
        const groups = Math.floor(effectiveLen / 4);
        const bytes = groups * 3 - (pad || 0);
        return bytes > 0 ? bytes : 0;
    }
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $da69a2069c6136ea$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
}


const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.18.1";



const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $e52be20a9fc15e96$var$isFunction } = (0, $c319b2c832c2914a$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $e52be20a9fc15e96$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $e52be20a9fc15e96$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf("://");
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes("@") || urlToCheck.includes(":");
};
const $e52be20a9fc15e96$var$factory = (env)=>{
    const globalObject = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global !== undefined && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global !== null ? (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $e52be20a9fc15e96$var$isFunction(envFetch) : typeof fetch === "function";
    const isRequestSupported = $e52be20a9fc15e96$var$isFunction(Request);
    const isResponseSupported = $e52be20a9fc15e96$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $e52be20a9fc15e96$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: "POST",
            get duplex () {
                duplexAccessed = true;
                return "half";
            }
        });
        const hasContentType = request.headers.has("Content-Type");
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response("").body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            "text",
            "arrayBuffer",
            "blob",
            "formData",
            "stream"
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
                method: "POST",
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + "").toLowerCase() : "text";
        let composedSignal = (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request body larger than maxBodyLength limit", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own("auth");
            if (configAuth) {
                const username = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(configAuth, "username") || "";
                const password = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(configAuth, "password") || "";
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($e52be20a9fc15e96$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = "";
                    parsedURL.password = "";
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete("authorization");
                headers.set("Authorization", "Basic " + btoa($e52be20a9fc15e96$var$encodeUTF8((auth.username || "") + ":" + (auth.password || ""))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === "string" && url.startsWith("data:")) {
                const estimated = (0, $da69a2069c6136ea$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("maxContentLength size of " + maxContentLength + " exceeded", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== "get" && method !== "head") {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === "number" && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $c9465135abb26626$export$b0119225647bd83)(stream, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== "get" && method !== "head" && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: "POST",
                        body: data,
                        duplex: "half"
                    });
                    let contentTypeHeader;
                    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(requestContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== "get" && method !== "head") data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== "get" && method !== "head") throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Stream request bodies are not supported by the current fetch implementation", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete("content-type");
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set("User-Agent", "axios/" + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $f8f5102fdfcbfec9$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: "half",
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("maxContentLength size of " + maxContentLength + " exceeded", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === "stream" || responseType === "response");
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    "status",
                    "statusText",
                    "headers"
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(responseContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("maxContentLength size of " + maxContentLength + " exceeded", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || "text";
            let responseData = await resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(resolvers, responseType) || "text"](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === "number") materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === "number") materializedSize = responseData.size;
                    else if (typeof responseData === "string") materializedSize = typeof TextEncoder === "function" ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === "number" && materializedSize > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("maxContentLength size of " + maxContentLength + " exceeded", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, "cause", {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === "TypeError" && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Network Error", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, "cause", {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $e52be20a9fc15e96$var$seedCache = new Map();
const $e52be20a9fc15e96$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $e52be20a9fc15e96$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $e52be20a9fc15e96$var$factory(env));
        map = target;
    }
    return target;
};
const $e52be20a9fc15e96$var$adapter = $e52be20a9fc15e96$export$3105c6651375d4fa();
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: {
        get: $e52be20a9fc15e96$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, "name", {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $e8c8c7960873e9ee$var$getAdapter(adapters, config) {
    adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || "#" + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
        let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($e8c8c7960873e9ee$var$renderReason).join("\n") : " " + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : "as no adapter specified";
        throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $e8c8c7960873e9ee$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $e8c8c7960873e9ee$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}






"use strict";
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object" || options === null) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("options must be an object", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};




"use strict";
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return "";
                    const firstNewlineIndex = dummy.stack.indexOf("\n");
                    return firstNewlineIndex === -1 ? "" : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf("\n");
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf("\n", firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? "" : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += "\n" + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            legacyInterceptorReqResOrdering: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            advertiseZstdAcceptEncoding: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            validateStatusUndefinedResolves: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling("baseURL"),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling("withXSRFToken")
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "query",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config, "data") ? config.data : undefined
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch",
    "query"
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== "query") $a93486d2307f31c3$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






"use strict";
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a, create: $b302555736d21bd7$export$185802fd694ee1f5 } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);


function $b678971e312560c2$var$useDrawing(uuid, configuration) {
    const [xml, setXml] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(null);
    const isXmlConfigured = (0, $204a33a7557cbbd0$export$b8f5890fc79d6aca)(false);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        async function configureXml() {
            if (uuid) try {
                const response = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`/api/v1/drawings/${uuid}`, {
                    headers: {
                        Authorization: `Bearer ${configuration.authentication.jwt}`
                    }
                });
                setXml(response.data.xml);
            } catch (error) {
                console.error(error.message);
            }
            else if (configuration?.xml) setXml(configuration.xml);
            else setXml("");
            isXmlConfigured.current = true;
        }
        (async ()=>{
            if (configuration?.authentication && !isXmlConfigured.current) await configureXml();
        })();
    }, [
        uuid,
        configuration
    ]);
    return xml;
}
var $b678971e312560c2$export$2e2bcd8739ae039 = $b678971e312560c2$var$useDrawing;


const $5ffe098e6e560069$export$6b60ce27feb4311e = "configure";
const $5ffe098e6e560069$export$f9ec4afc4535638b = "save";
const $5ffe098e6e560069$export$e271b26eefe41db8 = "update";
const $5ffe098e6e560069$export$7f100f842f565dc9 = "exit";
const $5ffe098e6e560069$export$50c885a21bfec48c = "load";
const $5ffe098e6e560069$export$74f94c628b84d921 = "image";
const $5ffe098e6e560069$export$9d358706ccac3727 = "hover";
const $5ffe098e6e560069$export$ac8e04182e10dd92 = "hoverOut";
const $5ffe098e6e560069$export$cb5542418ddbb7ed = "click";
const $5ffe098e6e560069$export$550499b0cf0fb1f4 = "clickLinkIcon";
const $5ffe098e6e560069$export$ef1febaf297f2cfc = "savingSuccess";
const $5ffe098e6e560069$export$7eb593425f027669 = "savingFailed";
const $5ffe098e6e560069$export$c8806dc6e5449e79 = "refreshJwt";
const $5ffe098e6e560069$export$48b514bbbf6509fa = "invalidJwt";
const $5ffe098e6e560069$export$73f7aa85b0021907 = "highlight";
const $5ffe098e6e560069$export$de263d49a916f147 = "getImage";
const $5ffe098e6e560069$export$f26c57e51ac4ea52 = "renderLinkIcons";
const $5ffe098e6e560069$export$5e897e3fa998e5c1 = "removeLinkIcons";
const $5ffe098e6e560069$export$204c77719608f548 = "activateLinkIcons";
const $5ffe098e6e560069$export$39a7e91b3892a011 = "deactivateLinkIcons";
const $5ffe098e6e560069$export$cbd0831d906aa7f6 = "fullScreen";
const $5ffe098e6e560069$export$6694d01e094b56c2 = "exitFullScreen";
function $5ffe098e6e560069$var$sendMessageToParentSystem(message, data) {
    window.parent.postMessage({
        message: message,
        iframeName: window.name,
        ...data
    }, "*");
}
function $5ffe098e6e560069$export$167a6e0c4c2a8c73(id, image, objectData) {
    $5ffe098e6e560069$var$sendMessageToParentSystem($5ffe098e6e560069$export$f9ec4afc4535638b, {
        drawId: id,
        image: image,
        objectData: objectData
    });
}
function $5ffe098e6e560069$export$634e8c9c16324be9(id, image, objectData) {
    $5ffe098e6e560069$var$sendMessageToParentSystem($5ffe098e6e560069$export$e271b26eefe41db8, {
        drawId: id,
        image: image,
        objectData: objectData
    });
}
function $5ffe098e6e560069$export$bf844755cacf5eeb() {
    $5ffe098e6e560069$var$sendMessageToParentSystem($5ffe098e6e560069$export$7f100f842f565dc9);
}
function $5ffe098e6e560069$export$3fd7ca7993daa918(height) {
    $5ffe098e6e560069$var$sendMessageToParentSystem($5ffe098e6e560069$export$50c885a21bfec48c, {
        height: height
    });
}
function $5ffe098e6e560069$export$c0bd7ff637c35648(event) {
    $5ffe098e6e560069$var$sendMessageToParentSystem(event.data.viewerEvent, {
        target: event.data.target,
        ...event.data.mousePosition && {
            mousePosition: event.data.mousePosition
        },
        ...event.data.isOverLinkIcon && {
            isOverLinkIcon: true
        },
        ...event.data.isOutsideOfShape && {
            isOutsideOfShape: true
        }
    });
}
function $5ffe098e6e560069$export$60072eb1fc683daf(dataURI) {
    $5ffe098e6e560069$var$sendMessageToParentSystem($5ffe098e6e560069$export$74f94c628b84d921, {
        image: dataURI
    });
}
function $5ffe098e6e560069$export$d037512f99596d45() {
    $5ffe098e6e560069$var$sendMessageToParentSystem($5ffe098e6e560069$export$6b60ce27feb4311e);
}
function $5ffe098e6e560069$export$5a4edfb6cfce8da2() {
    $5ffe098e6e560069$var$sendMessageToParentSystem($5ffe098e6e560069$export$48b514bbbf6509fa);
}
function $5ffe098e6e560069$export$3707f9d7fabf4fd() {
    $5ffe098e6e560069$var$sendMessageToParentSystem($5ffe098e6e560069$export$cbd0831d906aa7f6);
}
function $5ffe098e6e560069$export$586ad21cd043140f() {
    $5ffe098e6e560069$var$sendMessageToParentSystem($5ffe098e6e560069$export$6694d01e094b56c2);
}


/* eslint-disable no-param-reassign */ /*
 * Application Insights JavaScript SDK - Web, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
/*! https://github.com/nevware21/ts-utils v0.11.5 */ /*
 * Copyright (c) NevWare21 Solutions LLC and contributors. All rights reserved.
 * Licensed under the MIT license.
 */ /*#__NO_SIDE_EFFECTS__*/ 
function $5831ddb3a0caf7c7$var$_pureAssign(func1, func2) {
    return func1 || func2;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_pureRef(value, name) {
    return value[name];
}
var $5831ddb3a0caf7c7$var$UNDEF_VALUE = undefined;
var $5831ddb3a0caf7c7$var$NULL_VALUE = null;
var $5831ddb3a0caf7c7$var$EMPTY = "";
var $5831ddb3a0caf7c7$var$FUNCTION = "function";
var $5831ddb3a0caf7c7$var$OBJECT = "object";
var $5831ddb3a0caf7c7$var$PROTOTYPE = "prototype";
var $5831ddb3a0caf7c7$var$__PROTO__ = "__proto__";
var $5831ddb3a0caf7c7$var$UNDEFINED = "undefined";
var $5831ddb3a0caf7c7$var$CONSTRUCTOR = "constructor";
var $5831ddb3a0caf7c7$var$SYMBOL = "Symbol";
var $5831ddb3a0caf7c7$var$POLYFILL_TAG = "_polyfill";
var $5831ddb3a0caf7c7$var$LENGTH = "length";
var $5831ddb3a0caf7c7$var$NAME = "name";
var $5831ddb3a0caf7c7$var$CALL = "call";
var $5831ddb3a0caf7c7$var$TO_STRING = "toString";
var $5831ddb3a0caf7c7$var$ObjClass = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(Object);
var $5831ddb3a0caf7c7$var$ObjProto = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, $5831ddb3a0caf7c7$var$PROTOTYPE);
var $5831ddb3a0caf7c7$var$StrCls = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(String);
var $5831ddb3a0caf7c7$var$StrProto = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$StrCls, $5831ddb3a0caf7c7$var$PROTOTYPE);
var $5831ddb3a0caf7c7$var$MathCls = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(Math);
var $5831ddb3a0caf7c7$var$ArrCls = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(Array);
var $5831ddb3a0caf7c7$var$ArrProto = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ArrCls, $5831ddb3a0caf7c7$var$PROTOTYPE);
var $5831ddb3a0caf7c7$var$ArrSlice = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ArrProto, "slice");
function $5831ddb3a0caf7c7$export$170b8c323eee7bec(func, argArray) {
    try {
        return {
            v: func.apply(this, argArray)
        };
    } catch (e) {
        return {
            e: e
        };
    }
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$e51ae4db7b428f67(cb, defValue) {
    var result = $5831ddb3a0caf7c7$export$170b8c323eee7bec(cb);
    return result.e ? defValue : result.v;
}
var $5831ddb3a0caf7c7$var$_primitiveTypes;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_createIs(theType) {
    return function(value) {
        return typeof value === theType;
    };
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_createObjIs(theName) {
    var theType = "[object " + theName + "]";
    return function(value) {
        return !!(value && $5831ddb3a0caf7c7$export$3cbb80dec8953997(value) === theType);
    };
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$3cbb80dec8953997(value) {
    return $5831ddb3a0caf7c7$var$ObjProto[$5831ddb3a0caf7c7$var$TO_STRING].call(value);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$aa336f94d74d9e02(value, theType) {
    return typeof value === theType;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$fce6876652108ab(value) {
    return typeof value === $5831ddb3a0caf7c7$var$UNDEFINED || value === $5831ddb3a0caf7c7$var$UNDEFINED;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$565ef2e4233b16ad(arg) {
    return !$5831ddb3a0caf7c7$export$4e62c701997796c1(arg);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$bedb7023a7733221(value) {
    return value === $5831ddb3a0caf7c7$var$NULL_VALUE || $5831ddb3a0caf7c7$export$fce6876652108ab(value);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$3388cdee8977b866(value) {
    return value === $5831ddb3a0caf7c7$var$NULL_VALUE || !$5831ddb3a0caf7c7$export$4e62c701997796c1(value);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$4e62c701997796c1(arg) {
    return !!arg || arg !== $5831ddb3a0caf7c7$var$UNDEF_VALUE;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$c3825b437cbdea5c(value) {
    return value === $5831ddb3a0caf7c7$var$NULL_VALUE || $5831ddb3a0caf7c7$export$1f3b27a0956fac0e(typeof value);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$1f3b27a0956fac0e(theType) {
    !$5831ddb3a0caf7c7$var$_primitiveTypes && ($5831ddb3a0caf7c7$var$_primitiveTypes = [
        "string",
        "number",
        "boolean",
        $5831ddb3a0caf7c7$var$UNDEFINED,
        "symbol",
        "bigint"
    ]);
    return !!(theType !== $5831ddb3a0caf7c7$var$OBJECT && $5831ddb3a0caf7c7$var$_primitiveTypes.indexOf(theType) !== -1);
}
var $5831ddb3a0caf7c7$export$844ec244b1367d54 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createIs("string");
var $5831ddb3a0caf7c7$export$f6e2535fb5126e54 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createIs($5831ddb3a0caf7c7$var$FUNCTION);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a(value) {
    if (!value && $5831ddb3a0caf7c7$export$bedb7023a7733221(value)) return false;
    return !!value && typeof value === $5831ddb3a0caf7c7$var$OBJECT;
}
var $5831ddb3a0caf7c7$export$43bee75e5e14138e = /* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ArrCls, "isArray");
var $5831ddb3a0caf7c7$export$871608497c498473 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("Date");
var $5831ddb3a0caf7c7$export$7e4aa119212bc614 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createIs("number");
var $5831ddb3a0caf7c7$export$f9ce7b637dfbe238 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createIs("boolean");
var $5831ddb3a0caf7c7$export$49841c62b9eff15 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("RegExp");
var $5831ddb3a0caf7c7$export$be78b3111c50efdd = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("File");
var $5831ddb3a0caf7c7$export$67a42df2b7ab73bc = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("FormData");
var $5831ddb3a0caf7c7$export$5bcd6e94ed871c88 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("Blob");
var $5831ddb3a0caf7c7$export$9dd3754ae86f0017 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("ArrayBuffer");
var $5831ddb3a0caf7c7$export$e6127cc7fe7395c3 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("Error");
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$ae936b9d47e5870e(value) {
    return !!(value && value.then && $5831ddb3a0caf7c7$export$f6e2535fb5126e54(value.then));
}
var $5831ddb3a0caf7c7$export$f5b060c2914b97c8 = $5831ddb3a0caf7c7$export$ae936b9d47e5870e;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$4369c812aac99591(value) {
    return !!(value && value.then && value.catch && $5831ddb3a0caf7c7$export$f6e2535fb5126e54(value.then) && $5831ddb3a0caf7c7$export$f6e2535fb5126e54(value.catch));
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$5f2b986706b25721(value) {
    return !value || !$5831ddb3a0caf7c7$export$8f9cae6546f97a9f(value);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$8f9cae6546f97a9f(value) {
    return !(!value || $5831ddb3a0caf7c7$export$e51ae4db7b428f67(function() {
        return !(value && 0 + value);
    }, !value));
}
var $5831ddb3a0caf7c7$export$1bd5e8b059facbe9 = /* #__PURE__ */ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "getOwnPropertyDescriptor");
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$d76937f5d45b7158(obj, prop) {
    return !!obj && $5831ddb3a0caf7c7$var$ObjProto.hasOwnProperty[$5831ddb3a0caf7c7$var$CALL](obj, prop);
}
var $5831ddb3a0caf7c7$export$34e6b98f73578a9c = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/* #__PURE__ */ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "hasOwn"), $5831ddb3a0caf7c7$export$9a4df78208de965f);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$9a4df78208de965f(obj, prop) {
    return $5831ddb3a0caf7c7$export$d76937f5d45b7158(obj, prop) || !!$5831ddb3a0caf7c7$export$1bd5e8b059facbe9(obj, prop);
}
function $5831ddb3a0caf7c7$export$aa0705d5774c95d1(theObject, callbackfn, thisArg) {
    if (theObject && $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a(theObject)) {
        for(var prop in theObject)if ($5831ddb3a0caf7c7$export$34e6b98f73578a9c(theObject, prop)) {
            if (callbackfn[$5831ddb3a0caf7c7$var$CALL](thisArg || theObject, prop, theObject[prop]) === -1) break;
        }
    }
}
var $5831ddb3a0caf7c7$var$propMap = {
    e: "enumerable",
    c: "configurable",
    v: "value",
    w: "writable",
    g: "get",
    s: "set"
};
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_createProp(value) {
    var prop = {};
    prop[$5831ddb3a0caf7c7$var$propMap["c"]] = true;
    prop[$5831ddb3a0caf7c7$var$propMap["e"]] = true;
    if (value.l) {
        prop.get = function() {
            return value.l.v;
        };
        var desc = $5831ddb3a0caf7c7$export$1bd5e8b059facbe9(value.l, "v");
        if (desc && desc.set) prop.set = function(newValue) {
            value.l.v = newValue;
        };
    }
    $5831ddb3a0caf7c7$export$aa0705d5774c95d1(value, function(key, value) {
        prop[$5831ddb3a0caf7c7$var$propMap[key]] = $5831ddb3a0caf7c7$export$565ef2e4233b16ad(value) ? prop[$5831ddb3a0caf7c7$var$propMap[key]] : value;
    });
    return prop;
}
var $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "defineProperty");
var $5831ddb3a0caf7c7$export$aa4c975d12edd698 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "defineProperties");
function $5831ddb3a0caf7c7$export$4f97e7dc4bb3c3bb(target, key, value, configurable, enumerable) {
    var _a;
    return $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(target, key, $5831ddb3a0caf7c7$var$_createProp((_a = {
        e: enumerable,
        c: configurable
    }, _a[$5831ddb3a0caf7c7$export$f6e2535fb5126e54(value) ? "g" : "v"] = value, _a)));
}
function $5831ddb3a0caf7c7$export$5525b807dcec3e1b(target, prop, getProp, setProp, configurable, enumerable) {
    var desc = {
        e: enumerable,
        c: configurable
    };
    if (getProp) desc.g = getProp;
    if (setProp) desc.s = setProp;
    return $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(target, prop, $5831ddb3a0caf7c7$var$_createProp(desc));
}
function $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2(target, key, propDesc) {
    return $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(target, key, $5831ddb3a0caf7c7$var$_createProp(propDesc));
}
function $5831ddb3a0caf7c7$export$343685e498f18ed2(target, propDescMap) {
    var props = {};
    $5831ddb3a0caf7c7$export$aa0705d5774c95d1(propDescMap, function(key, value) {
        props[key] = $5831ddb3a0caf7c7$var$_createProp(value);
    });
    return $5831ddb3a0caf7c7$export$aa4c975d12edd698(target, props);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_createKeyValueMap(values, keyType, valueType, completeFn, writable) {
    var theMap = {};
    $5831ddb3a0caf7c7$export$aa0705d5774c95d1(values, function(key, value) {
        $5831ddb3a0caf7c7$var$_assignMapValue(theMap, key, keyType ? value : key, writable);
        $5831ddb3a0caf7c7$var$_assignMapValue(theMap, value, valueType ? value : key, writable);
    });
    return completeFn ? completeFn(theMap) : theMap;
}
function $5831ddb3a0caf7c7$var$_assignMapValue(theMap, key, value, writable) {
    $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(theMap, key, {
        value: value,
        enumerable: true,
        writable: !!writable
    });
}
var $5831ddb3a0caf7c7$export$590567be997858b6 = /* #__PURE__ */ $5831ddb3a0caf7c7$var$_pureAssign($5831ddb3a0caf7c7$var$StrCls);
var $5831ddb3a0caf7c7$var$ERROR_TYPE = "[object Error]";
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(object, format) {
    var propertyValueDump = $5831ddb3a0caf7c7$var$EMPTY;
    var objType = $5831ddb3a0caf7c7$var$ObjProto[$5831ddb3a0caf7c7$var$TO_STRING][$5831ddb3a0caf7c7$var$CALL](object);
    if (objType === $5831ddb3a0caf7c7$var$ERROR_TYPE) object = {
        stack: $5831ddb3a0caf7c7$export$590567be997858b6(object.stack),
        message: $5831ddb3a0caf7c7$export$590567be997858b6(object.message),
        name: $5831ddb3a0caf7c7$export$590567be997858b6(object.name)
    };
    try {
        propertyValueDump = JSON.stringify(object, $5831ddb3a0caf7c7$var$NULL_VALUE, format ? typeof format === "number" ? format : 4 : $5831ddb3a0caf7c7$var$UNDEF_VALUE);
        propertyValueDump = (propertyValueDump ? propertyValueDump.replace(/"(\w+)"\s*:\s{0,1}/g, "$1: ") : $5831ddb3a0caf7c7$var$NULL_VALUE) || $5831ddb3a0caf7c7$export$590567be997858b6(object);
    } catch (e) {
        propertyValueDump = " - " + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(e, format);
    }
    return objType + ": " + propertyValueDump;
}
function $5831ddb3a0caf7c7$export$8bf7aba4a9e09055(message) {
    throw new Error(message);
}
function $5831ddb3a0caf7c7$export$3f7738bd7dcba681(message) {
    throw new TypeError(message);
}
function $5831ddb3a0caf7c7$export$462e4d432290318e(message) {
    throw new RangeError(message);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$43fe3a9b30d28d1e(obj) {
    if (!$5831ddb3a0caf7c7$export$a6cdc56e425d0d0a(obj) || obj === $5831ddb3a0caf7c7$var$NULL_VALUE) $5831ddb3a0caf7c7$export$3f7738bd7dcba681("non-object " + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(obj));
    var result = [];
    for(var prop in obj)if ($5831ddb3a0caf7c7$export$34e6b98f73578a9c(obj, prop)) result.push(prop);
    return result;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$aba5bd6a473725e4(value) {
    var result = [];
    $5831ddb3a0caf7c7$export$aa0705d5774c95d1(value, function(key, value) {
        result.push([
            key,
            value
        ]);
    });
    return result;
}
var $5831ddb3a0caf7c7$var$_objFreeze = /* #__PURE__ */ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "freeze");
function $5831ddb3a0caf7c7$var$_doNothing(value) {
    return value;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_getProto(value) {
    return value[$5831ddb3a0caf7c7$var$__PROTO__] || $5831ddb3a0caf7c7$var$NULL_VALUE;
}
var $5831ddb3a0caf7c7$export$afe328edc487dcfe = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "assign");
var $5831ddb3a0caf7c7$export$f7628dc18f4211e5 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "keys");
function $5831ddb3a0caf7c7$export$a15782d21797da4c(value) {
    if ($5831ddb3a0caf7c7$var$_objFreeze) $5831ddb3a0caf7c7$export$aa0705d5774c95d1(value, function(key, value) {
        if ($5831ddb3a0caf7c7$export$43bee75e5e14138e(value) || $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a(value)) $5831ddb3a0caf7c7$export$a15782d21797da4c(value);
    });
    return $5831ddb3a0caf7c7$export$5da24d7703175bc5(value);
}
var $5831ddb3a0caf7c7$export$5da24d7703175bc5 = /* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign($5831ddb3a0caf7c7$var$_objFreeze, $5831ddb3a0caf7c7$var$_doNothing);
var $5831ddb3a0caf7c7$export$8bbd42c2bec875c8 = /* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "seal"), $5831ddb3a0caf7c7$var$_doNothing);
var $5831ddb3a0caf7c7$export$743454acee35f1d4 = /* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "getPrototypeOf"), $5831ddb3a0caf7c7$var$_getProto);
var $5831ddb3a0caf7c7$export$5359e3134992ffd2 = /* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "entries"), $5831ddb3a0caf7c7$export$aba5bd6a473725e4);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$37b2eedf6b7b231a(values) {
    return $5831ddb3a0caf7c7$var$_createKeyValueMap(values, 1, 0, $5831ddb3a0caf7c7$export$5da24d7703175bc5);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$db29bd6ce1af3f68(values) {
    return $5831ddb3a0caf7c7$var$_createKeyValueMap(values, 0, 0, $5831ddb3a0caf7c7$export$5da24d7703175bc5);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$dbf89c68f5157b55(values) {
    return $5831ddb3a0caf7c7$var$_createKeyValueMap(values, 1, 1, $5831ddb3a0caf7c7$export$5da24d7703175bc5);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$4cf8c4bb9ca98f0b(values) {
    var mapClass = {};
    $5831ddb3a0caf7c7$export$aa0705d5774c95d1(values, function(key, value) {
        $5831ddb3a0caf7c7$var$_assignMapValue(mapClass, key, value[1]);
        $5831ddb3a0caf7c7$var$_assignMapValue(mapClass, value[0], value[1]);
    });
    return $5831ddb3a0caf7c7$export$5da24d7703175bc5(mapClass);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$a6025b6424227e7e(values) {
    return $5831ddb3a0caf7c7$export$4cf8c4bb9ca98f0b(values);
}
var $5831ddb3a0caf7c7$var$_wellKnownSymbolMap = /*#__PURE__*/ $5831ddb3a0caf7c7$export$db29bd6ce1af3f68({
    asyncIterator: 0,
    hasInstance: 1,
    isConcatSpreadable: 2,
    iterator: 3,
    match: 4,
    matchAll: 5,
    replace: 6,
    search: 7,
    species: 8,
    split: 9,
    toPrimitive: 10,
    toStringTag: 11,
    unscopables: 12
});
var $5831ddb3a0caf7c7$var$GLOBAL_CONFIG_KEY = "__tsUtils$gblCfg";
var $5831ddb3a0caf7c7$var$_globalCfg;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_getGlobalValue() {
    var result;
    if (typeof globalThis !== $5831ddb3a0caf7c7$var$UNDEFINED) result = globalThis;
    if (!result && typeof self !== $5831ddb3a0caf7c7$var$UNDEFINED) result = self;
    if (!result && typeof window !== $5831ddb3a0caf7c7$var$UNDEFINED) result = window;
    if (!result && typeof $parcel$global !== $5831ddb3a0caf7c7$var$UNDEFINED) result = $parcel$global;
    return result;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_getGlobalConfig() {
    if (!$5831ddb3a0caf7c7$var$_globalCfg) {
        var gbl = $5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$var$_getGlobalValue).v || {};
        $5831ddb3a0caf7c7$var$_globalCfg = gbl[$5831ddb3a0caf7c7$var$GLOBAL_CONFIG_KEY] = gbl[$5831ddb3a0caf7c7$var$GLOBAL_CONFIG_KEY] || {};
    }
    return $5831ddb3a0caf7c7$var$_globalCfg;
}
var $5831ddb3a0caf7c7$var$_unwrapFunction = $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly(funcName, clsProto, polyFunc) {
    var clsFn = clsProto ? clsProto[funcName] : $5831ddb3a0caf7c7$var$NULL_VALUE;
    return function(thisArg) {
        var theFunc = (thisArg ? thisArg[funcName] : $5831ddb3a0caf7c7$var$NULL_VALUE) || clsFn;
        if (theFunc || polyFunc) {
            var theArgs = arguments;
            return (theFunc || polyFunc).apply(thisArg, theFunc ? $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](theArgs, 1) : theArgs);
        }
        $5831ddb3a0caf7c7$export$3f7738bd7dcba681('"' + $5831ddb3a0caf7c7$export$590567be997858b6(funcName) + '" not defined for ' + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(thisArg));
    };
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_unwrapProp(propName) {
    return function(thisArg) {
        return thisArg[propName];
    };
}
var $5831ddb3a0caf7c7$export$e411eeaf23dccbe8 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "min");
var $5831ddb3a0caf7c7$export$2ca8010d037f830f = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "max");
var $5831ddb3a0caf7c7$export$aaf2ac896f62f2c3 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("slice", $5831ddb3a0caf7c7$var$StrProto);
var $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("substring", $5831ddb3a0caf7c7$var$StrProto);
var $5831ddb3a0caf7c7$export$25b2a9bb66b0078d = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("substr", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$export$5e0a36ccb324041a);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$5e0a36ccb324041a(value, start, length) {
    if ($5831ddb3a0caf7c7$export$bedb7023a7733221(value)) $5831ddb3a0caf7c7$export$3f7738bd7dcba681("Invalid " + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(value));
    if (length < 0) return $5831ddb3a0caf7c7$var$EMPTY;
    start = start || 0;
    if (start < 0) start = $5831ddb3a0caf7c7$export$2ca8010d037f830f(start + value[$5831ddb3a0caf7c7$var$LENGTH], 0);
    if ($5831ddb3a0caf7c7$export$fce6876652108ab(length)) return $5831ddb3a0caf7c7$export$aaf2ac896f62f2c3(value, start);
    return $5831ddb3a0caf7c7$export$aaf2ac896f62f2c3(value, start, start + length);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$a1120f14ec6f7ada(value, count) {
    return $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87(value, 0, count);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$9fa3d612c59f0874(value, count) {
    return count <= 0 ? $5831ddb3a0caf7c7$var$EMPTY : value[$5831ddb3a0caf7c7$var$LENGTH] > count ? $5831ddb3a0caf7c7$export$aaf2ac896f62f2c3(value, -count) : value;
}
var $5831ddb3a0caf7c7$var$UNIQUE_REGISTRY_ID = "_urid";
var $5831ddb3a0caf7c7$var$_polySymbols;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_globalSymbolRegistry() {
    if (!$5831ddb3a0caf7c7$var$_polySymbols) {
        var gblCfg = $5831ddb3a0caf7c7$var$_getGlobalConfig();
        $5831ddb3a0caf7c7$var$_polySymbols = gblCfg.gblSym = gblCfg.gblSym || {
            k: {},
            s: {}
        };
    }
    return $5831ddb3a0caf7c7$var$_polySymbols;
}
var $5831ddb3a0caf7c7$var$_wellKnownSymbolCache;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$1e4b0b24415108a8(description) {
    var theSymbol = {
        description: $5831ddb3a0caf7c7$export$590567be997858b6(description),
        toString: function() {
            return $5831ddb3a0caf7c7$var$SYMBOL + "(" + description + ")";
        }
    };
    theSymbol[$5831ddb3a0caf7c7$var$POLYFILL_TAG] = true;
    return theSymbol;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$c35d76cf82622c51(key) {
    var registry = $5831ddb3a0caf7c7$var$_globalSymbolRegistry();
    if (!$5831ddb3a0caf7c7$export$34e6b98f73578a9c(registry.k, key)) {
        var newSymbol_1 = $5831ddb3a0caf7c7$export$1e4b0b24415108a8(key);
        var regId_1 = $5831ddb3a0caf7c7$export$f7628dc18f4211e5(registry.s).length;
        newSymbol_1[$5831ddb3a0caf7c7$var$UNIQUE_REGISTRY_ID] = function() {
            return regId_1 + "_" + newSymbol_1[$5831ddb3a0caf7c7$var$TO_STRING]();
        };
        registry.k[key] = newSymbol_1;
        registry.s[newSymbol_1[$5831ddb3a0caf7c7$var$UNIQUE_REGISTRY_ID]()] = $5831ddb3a0caf7c7$export$590567be997858b6(key);
    }
    return registry.k[key];
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$205212be62415f78(sym) {
    if (!sym || !sym[$5831ddb3a0caf7c7$var$TO_STRING] || $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87(sym[$5831ddb3a0caf7c7$var$TO_STRING](), 0, 6) != $5831ddb3a0caf7c7$var$SYMBOL) $5831ddb3a0caf7c7$export$3f7738bd7dcba681(sym + " is not a symbol");
    var regId = sym[$5831ddb3a0caf7c7$var$POLYFILL_TAG] && sym[$5831ddb3a0caf7c7$var$UNIQUE_REGISTRY_ID] && sym[$5831ddb3a0caf7c7$var$UNIQUE_REGISTRY_ID]();
    return regId ? $5831ddb3a0caf7c7$var$_globalSymbolRegistry().s[regId] : undefined;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$b9abc24179dacbc5(name) {
    !$5831ddb3a0caf7c7$var$_wellKnownSymbolCache && ($5831ddb3a0caf7c7$var$_wellKnownSymbolCache = {});
    var result;
    var knownName = $5831ddb3a0caf7c7$var$_wellKnownSymbolMap[name];
    if (knownName) result = $5831ddb3a0caf7c7$var$_wellKnownSymbolCache[knownName] = $5831ddb3a0caf7c7$var$_wellKnownSymbolCache[knownName] || $5831ddb3a0caf7c7$export$1e4b0b24415108a8($5831ddb3a0caf7c7$var$SYMBOL + "." + knownName);
    return result;
}
var $5831ddb3a0caf7c7$var$_globalLazyTestHooks;
function $5831ddb3a0caf7c7$var$_initTestHooks() {
    $5831ddb3a0caf7c7$var$_globalLazyTestHooks = $5831ddb3a0caf7c7$var$_getGlobalConfig();
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$db98eae15987454c(cb) {
    var lazyValue = {};
    !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
    lazyValue.b = $5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy;
    $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(lazyValue, "v", {
        configurable: true,
        get: function() {
            var result = cb();
            if (!$5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy) $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(lazyValue, "v", {
                value: result
            });
            lazyValue.b = $5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy;
            return result;
        }
    });
    return lazyValue;
}
function $5831ddb3a0caf7c7$export$31f2f77e19969b63(newValue) {
    !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
    $5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy = newValue;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$469f6b7560342b84(value) {
    return $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81({
        toJSON: function() {
            return value;
        }
    }, "v", {
        value: value
    });
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$56002f94d10e4cfd(cb) {
    var theValue = {
        toJSON: function() {
            return theValue.v;
        }
    };
    return $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(theValue, "v", {
        get: function() {
            var result = cb();
            cb = $5831ddb3a0caf7c7$var$NULL_VALUE;
            $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(theValue, "v", {
                value: result
            });
            return result;
        },
        configurable: true
    });
}
var $5831ddb3a0caf7c7$var$WINDOW = "window";
var $5831ddb3a0caf7c7$var$_cachedGlobal;
function $5831ddb3a0caf7c7$var$_getGlobalInstFn(getFn, theArgs) {
    var cachedValue;
    return function() {
        !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
        if (!cachedValue || $5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy) cachedValue = $5831ddb3a0caf7c7$export$469f6b7560342b84($5831ddb3a0caf7c7$export$170b8c323eee7bec(getFn, theArgs).v);
        return cachedValue.v;
    };
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$45fd08e1bc14fe1c(name) {
    return $5831ddb3a0caf7c7$export$db98eae15987454c(function() {
        return $5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$export$3df6e51375017edd, [
            name
        ]).v || $5831ddb3a0caf7c7$var$UNDEF_VALUE;
    });
}
function $5831ddb3a0caf7c7$export$a4e55266d2135a7f(useCached) {
    !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
    if (!$5831ddb3a0caf7c7$var$_cachedGlobal || useCached === false || $5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy) $5831ddb3a0caf7c7$var$_cachedGlobal = $5831ddb3a0caf7c7$export$469f6b7560342b84($5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$var$_getGlobalValue).v || $5831ddb3a0caf7c7$var$NULL_VALUE);
    return $5831ddb3a0caf7c7$var$_cachedGlobal.v;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$3df6e51375017edd(name, useCached) {
    var gbl;
    if (!$5831ddb3a0caf7c7$var$_cachedGlobal || useCached === false) gbl = $5831ddb3a0caf7c7$export$a4e55266d2135a7f(useCached);
    else gbl = $5831ddb3a0caf7c7$var$_cachedGlobal.v;
    if (gbl && gbl[name]) return gbl[name];
    if (name === $5831ddb3a0caf7c7$var$WINDOW) try {
        return window;
    } catch (e) {}
    return $5831ddb3a0caf7c7$var$NULL_VALUE;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$c4372eca9c56fe99() {
    return !!/*#__PURE__*/ $5831ddb3a0caf7c7$export$f65ca476c09acec0();
}
var $5831ddb3a0caf7c7$export$f65ca476c09acec0 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_getGlobalInstFn($5831ddb3a0caf7c7$export$3df6e51375017edd, [
    "document"
]);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$fef62134eea24008() {
    return !!/*#__PURE__*/ $5831ddb3a0caf7c7$export$38b2d434cce3ea22();
}
var $5831ddb3a0caf7c7$export$38b2d434cce3ea22 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_getGlobalInstFn($5831ddb3a0caf7c7$export$3df6e51375017edd, [
    $5831ddb3a0caf7c7$var$WINDOW
]);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$bd82d106260417bf() {
    return !!/*#__PURE__*/ $5831ddb3a0caf7c7$export$a56241c767c1d89f();
}
var $5831ddb3a0caf7c7$export$a56241c767c1d89f = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_getGlobalInstFn($5831ddb3a0caf7c7$export$3df6e51375017edd, [
    "navigator"
]);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$b79afd6d47f11781() {
    return !!/*#__PURE__*/ $5831ddb3a0caf7c7$export$f9582a3c130d9538();
}
var $5831ddb3a0caf7c7$export$f9582a3c130d9538 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_getGlobalInstFn($5831ddb3a0caf7c7$export$3df6e51375017edd, [
    "history"
]);
var $5831ddb3a0caf7c7$export$8ee0fc9ee280b4ee = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_getGlobalInstFn(function() {
    return !!/*#__PURE__*/ $5831ddb3a0caf7c7$export$170b8c323eee7bec(function() {
        return $cfae44f0dfdf62c0$exports && ($cfae44f0dfdf62c0$exports.versions || {}).node;
    }).v;
});
var $5831ddb3a0caf7c7$export$97b87b8868ff7a3c = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_getGlobalInstFn(function() {
    return !!/*#__PURE__*/ $5831ddb3a0caf7c7$export$170b8c323eee7bec(function() {
        return self && self instanceof WorkerGlobalScope;
    }).v;
});
var $5831ddb3a0caf7c7$var$_symbol;
var $5831ddb3a0caf7c7$var$_symbolFor;
var $5831ddb3a0caf7c7$var$_symbolKeyFor;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_initSymbol() {
    $5831ddb3a0caf7c7$var$_symbol = /*#__PURE__*/ $5831ddb3a0caf7c7$export$469f6b7560342b84($5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$export$3df6e51375017edd, [
        $5831ddb3a0caf7c7$var$SYMBOL
    ]).v);
    return $5831ddb3a0caf7c7$var$_symbol;
}
function $5831ddb3a0caf7c7$var$_getSymbolKey(key) {
    var gblSym = (!$5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy ? $5831ddb3a0caf7c7$var$_symbol : 0) || $5831ddb3a0caf7c7$var$_initSymbol();
    return gblSym.v ? gblSym.v[key] : $5831ddb3a0caf7c7$var$UNDEF_VALUE;
}
var $5831ddb3a0caf7c7$export$a244864fd9645c7f = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createIs("symbol");
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$1e6e45ea4c3f892c() {
    return !!/*#__PURE__*/ $5831ddb3a0caf7c7$export$57af67db727bc7c7();
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$57af67db727bc7c7() {
    !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
    return ((!$5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy ? $5831ddb3a0caf7c7$var$_symbol : 0) || $5831ddb3a0caf7c7$var$_initSymbol()).v;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$3a9aefdadea26115(name, noPoly) {
    var knownName = $5831ddb3a0caf7c7$var$_wellKnownSymbolMap[name];
    !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
    var sym = (!$5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy ? $5831ddb3a0caf7c7$var$_symbol : 0) || $5831ddb3a0caf7c7$var$_initSymbol();
    return sym.v ? sym.v[knownName || name] : !noPoly ? $5831ddb3a0caf7c7$export$b9abc24179dacbc5(name) : $5831ddb3a0caf7c7$var$UNDEF_VALUE;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$70503d621eee7e7b(description, noPoly) {
    !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
    var sym = (!$5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy ? $5831ddb3a0caf7c7$var$_symbol : 0) || $5831ddb3a0caf7c7$var$_initSymbol();
    return sym.v ? sym.v(description) : !noPoly ? $5831ddb3a0caf7c7$export$1e4b0b24415108a8(description) : $5831ddb3a0caf7c7$var$NULL_VALUE;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$4d0ba04d25a41f31(key) {
    !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
    $5831ddb3a0caf7c7$var$_symbolFor = (!$5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy ? $5831ddb3a0caf7c7$var$_symbolFor : 0) || /*#__PURE__*/ $5831ddb3a0caf7c7$export$469f6b7560342b84($5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$var$_getSymbolKey, [
        "for"
    ]).v);
    return ($5831ddb3a0caf7c7$var$_symbolFor.v || $5831ddb3a0caf7c7$export$c35d76cf82622c51)(key);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$5cc35ecfe266eba7(sym) {
    !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
    $5831ddb3a0caf7c7$var$_symbolKeyFor = (!$5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy ? $5831ddb3a0caf7c7$var$_symbolKeyFor : 0) || /*#__PURE__*/ $5831ddb3a0caf7c7$export$469f6b7560342b84($5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$var$_getSymbolKey, [
        "keyFor"
    ]).v);
    return ($5831ddb3a0caf7c7$var$_symbolKeyFor.v || $5831ddb3a0caf7c7$export$205212be62415f78)(sym);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$50db6e277db66ea0(value) {
    return !!value && $5831ddb3a0caf7c7$export$f6e2535fb5126e54(value.next);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$9652023d9040757(value) {
    return !$5831ddb3a0caf7c7$export$3388cdee8977b866(value) && $5831ddb3a0caf7c7$export$f6e2535fb5126e54(value[$5831ddb3a0caf7c7$export$3a9aefdadea26115(3)]);
}
var $5831ddb3a0caf7c7$var$_iterSymbol$1;
function $5831ddb3a0caf7c7$export$1180a64ad833b902(iter, callbackfn, thisArg) {
    if (iter) {
        if (!$5831ddb3a0caf7c7$export$50db6e277db66ea0(iter)) {
            !$5831ddb3a0caf7c7$var$_iterSymbol$1 && ($5831ddb3a0caf7c7$var$_iterSymbol$1 = $5831ddb3a0caf7c7$export$469f6b7560342b84($5831ddb3a0caf7c7$export$3a9aefdadea26115(3)));
            iter = iter[$5831ddb3a0caf7c7$var$_iterSymbol$1.v] ? iter[$5831ddb3a0caf7c7$var$_iterSymbol$1.v]() : $5831ddb3a0caf7c7$var$NULL_VALUE;
        }
        if ($5831ddb3a0caf7c7$export$50db6e277db66ea0(iter)) {
            var err = $5831ddb3a0caf7c7$var$UNDEF_VALUE;
            var iterResult = $5831ddb3a0caf7c7$var$UNDEF_VALUE;
            try {
                var count = 0;
                while(!(iterResult = iter.next()).done){
                    if (callbackfn[$5831ddb3a0caf7c7$var$CALL](thisArg || iter, iterResult.value, count, iter) === -1) break;
                    count++;
                }
            } catch (failed) {
                err = {
                    e: failed
                };
                if (iter.throw) {
                    iterResult = $5831ddb3a0caf7c7$var$NULL_VALUE;
                    iter.throw(err);
                }
            } finally{
                try {
                    if (iterResult && !iterResult.done) iter.return && iter.return(iterResult);
                } finally{
                    if (err) // eslint-disable-next-line no-unsafe-finally
                    throw err.e;
                }
            }
        }
    }
}
function $5831ddb3a0caf7c7$export$2801572b9d3736b5(fn, thisArg, argArray) {
    return fn.apply(thisArg, argArray);
}
function $5831ddb3a0caf7c7$export$4b40e215736a9426(fn, thisArg) {
    return fn.apply(thisArg, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments, 2));
}
function $5831ddb3a0caf7c7$export$af9753654a45407f(fn, thisArg) {
    return fn.bind.apply(fn, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments, 1));
}
function $5831ddb3a0caf7c7$export$69c7b96f216fdf7b(target, elms) {
    if (!$5831ddb3a0caf7c7$export$fce6876652108ab(elms) && target) {
        if ($5831ddb3a0caf7c7$export$43bee75e5e14138e(elms)) $5831ddb3a0caf7c7$export$2801572b9d3736b5(target.push, target, elms);
        else if ($5831ddb3a0caf7c7$export$50db6e277db66ea0(elms) || $5831ddb3a0caf7c7$export$9652023d9040757(elms)) $5831ddb3a0caf7c7$export$1180a64ad833b902(elms, function(elm) {
            target.push(elm);
        });
        else target.push(elms);
    }
    return target;
}
var $5831ddb3a0caf7c7$export$a456dfa2a32ba463 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("every", $5831ddb3a0caf7c7$var$ArrProto);
var $5831ddb3a0caf7c7$export$4028a8780eeac59b = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("filter", $5831ddb3a0caf7c7$var$ArrProto);
function $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586(theArray, callbackfn, thisArg) {
    if (theArray) {
        var len = theArray[$5831ddb3a0caf7c7$var$LENGTH] >>> 0;
        for(var idx = 0; idx < len; idx++)if (idx in theArray) {
            if (callbackfn[$5831ddb3a0caf7c7$var$CALL](thisArg || theArray, theArray[idx], idx, theArray) === -1) break;
        }
    }
}
var $5831ddb3a0caf7c7$export$9f3b3ffa84393d30 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("indexOf", $5831ddb3a0caf7c7$var$ArrProto);
var $5831ddb3a0caf7c7$export$ef8741fcdb4b04c8 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("lastIndexOf", $5831ddb3a0caf7c7$var$ArrProto);
var $5831ddb3a0caf7c7$export$76f1a28030e24fa6 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("map", $5831ddb3a0caf7c7$var$ArrProto);
function $5831ddb3a0caf7c7$export$1bea104a0e2567f0(theArray, start, end) {
    return ((theArray ? theArray["slice"] : $5831ddb3a0caf7c7$var$NULL_VALUE) || $5831ddb3a0caf7c7$var$ArrSlice).apply(theArray, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments, 1));
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$cc916d431d083b34(value) {
    if ($5831ddb3a0caf7c7$export$bedb7023a7733221(value)) return false;
    return $5831ddb3a0caf7c7$export$3cbb80dec8953997(value) === "[object Array]";
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$736940c79a4f6caa(theArray, searchElement, fromIndex) {
    return $5831ddb3a0caf7c7$export$9f3b3ffa84393d30(theArray, searchElement, fromIndex) !== -1;
}
function $5831ddb3a0caf7c7$export$dcd90af2789cc4fb(theArray, callbackFn, thisArg) {
    var result;
    var idx = $5831ddb3a0caf7c7$export$76dacc098dca1b23(theArray, callbackFn, thisArg);
    return idx !== -1 ? theArray[idx] : result;
}
function $5831ddb3a0caf7c7$export$76dacc098dca1b23(theArray, callbackFn, thisArg) {
    var result = -1;
    $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586(theArray, function(value, index) {
        if (callbackFn[$5831ddb3a0caf7c7$var$CALL](thisArg | theArray, value, index, theArray)) {
            result = index;
            return -1;
        }
    });
    return result;
}
function $5831ddb3a0caf7c7$export$9d4e32e380b66a8e(theArray, callbackFn, thisArg) {
    var result;
    var idx = $5831ddb3a0caf7c7$export$cef06c5d5cf144f1(theArray, callbackFn, thisArg);
    return idx !== -1 ? theArray[idx] : result;
}
function $5831ddb3a0caf7c7$export$cef06c5d5cf144f1(theArray, callbackFn, thisArg) {
    var result = -1;
    var len = theArray[$5831ddb3a0caf7c7$var$LENGTH] >>> 0;
    for(var idx = len - 1; idx >= 0; idx--)if (idx in theArray && callbackFn[$5831ddb3a0caf7c7$var$CALL](thisArg | theArray, theArray[idx], idx, theArray)) {
        result = idx;
        break;
    }
    return result;
}
function $5831ddb3a0caf7c7$export$f12f44c17d4fb318(theValue, mapFn, thisArg) {
    if ($5831ddb3a0caf7c7$export$43bee75e5e14138e(theValue)) {
        var result_1 = $5831ddb3a0caf7c7$export$1bea104a0e2567f0(theValue);
        return mapFn ? $5831ddb3a0caf7c7$export$76f1a28030e24fa6(result_1, mapFn, thisArg) : result_1;
    }
    var result = [];
    $5831ddb3a0caf7c7$export$1180a64ad833b902(theValue, function(value, cnt) {
        return result.push(mapFn ? mapFn[$5831ddb3a0caf7c7$var$CALL](thisArg, value, cnt) : value);
    });
    return result;
}
var $5831ddb3a0caf7c7$export$3cb758d993f67d76 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("find", $5831ddb3a0caf7c7$var$ArrProto, $5831ddb3a0caf7c7$export$dcd90af2789cc4fb);
var $5831ddb3a0caf7c7$export$62c3fd54f456ac05 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("findIndex", $5831ddb3a0caf7c7$var$ArrProto, $5831ddb3a0caf7c7$export$76dacc098dca1b23);
var $5831ddb3a0caf7c7$export$cde52e8eba9adf83 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("findLast", $5831ddb3a0caf7c7$var$ArrProto, $5831ddb3a0caf7c7$export$9d4e32e380b66a8e);
var $5831ddb3a0caf7c7$export$8ca1e4aa314ced30 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("findLastIndex", $5831ddb3a0caf7c7$var$ArrProto, $5831ddb3a0caf7c7$export$cef06c5d5cf144f1);
var $5831ddb3a0caf7c7$export$7b9440edbb83caa4 = /* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ArrCls, "from"), $5831ddb3a0caf7c7$export$f12f44c17d4fb318);
var $5831ddb3a0caf7c7$export$fa3af84817874a27 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("includes", $5831ddb3a0caf7c7$var$ArrProto, $5831ddb3a0caf7c7$export$736940c79a4f6caa);
var $5831ddb3a0caf7c7$export$fb75cfad7c4b6a08 = $5831ddb3a0caf7c7$export$fa3af84817874a27;
var $5831ddb3a0caf7c7$export$a16e2b23dbd5466c = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("reduce", $5831ddb3a0caf7c7$var$ArrProto);
var $5831ddb3a0caf7c7$export$dff8f5be8b2ae7a2 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("some", $5831ddb3a0caf7c7$var$ArrProto);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$d9e878335f2ef4a7(hostFn, funcName) {
    return function() {
        var theArgs = $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments);
        var theHost = hostFn();
        return $5831ddb3a0caf7c7$export$2801572b9d3736b5(theHost[funcName], theHost, theArgs);
    };
}
function $5831ddb3a0caf7c7$export$9bf51b747c7699ea(target, host, funcDefs) {
    if (target && host && $5831ddb3a0caf7c7$export$43bee75e5e14138e(funcDefs)) {
        var isDeferred_1 = $5831ddb3a0caf7c7$export$f6e2535fb5126e54(host);
        $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586(funcDefs, function(funcDef) {
            var targetName = funcDef.as || funcDef.n;
            if (funcDef.rp === false && target[targetName]) return;
            target[targetName] = isDeferred_1 ? $5831ddb3a0caf7c7$export$d9e878335f2ef4a7(host, funcDef.n) : $5831ddb3a0caf7c7$export$af9753654a45407f(host[funcDef.n], host);
        });
    }
    return target;
}
var $5831ddb3a0caf7c7$var$_iterSymbol;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$3c428921980810ca(theArgs, start, end) {
    if (!$5831ddb3a0caf7c7$export$34e6b98f73578a9c(theArgs, $5831ddb3a0caf7c7$var$LENGTH)) {
        !$5831ddb3a0caf7c7$var$_iterSymbol && ($5831ddb3a0caf7c7$var$_iterSymbol = $5831ddb3a0caf7c7$export$469f6b7560342b84($5831ddb3a0caf7c7$export$1e6e45ea4c3f892c() && $5831ddb3a0caf7c7$export$3a9aefdadea26115(3)));
        var iterFn = void 0;
        if ($5831ddb3a0caf7c7$var$_iterSymbol.v) iterFn = theArgs[$5831ddb3a0caf7c7$var$_iterSymbol.v];
        if (iterFn) {
            var values_1 = [];
            var from_1 = start === $5831ddb3a0caf7c7$var$UNDEF_VALUE || start < 0 ? 0 : start;
            var to_1 = end < 0 || start < 0 ? $5831ddb3a0caf7c7$var$UNDEF_VALUE : end;
            $5831ddb3a0caf7c7$export$1180a64ad833b902(iterFn[$5831ddb3a0caf7c7$var$CALL](theArgs), function(value, cnt) {
                if (to_1 !== $5831ddb3a0caf7c7$var$UNDEF_VALUE && cnt >= to_1) return -1;
                if (cnt >= from_1) values_1.push(value);
            });
            if ((start === $5831ddb3a0caf7c7$var$UNDEF_VALUE || start >= 0) && (end === $5831ddb3a0caf7c7$var$UNDEF_VALUE || end >= 0)) return values_1;
            theArgs = values_1;
        }
    }
    return $5831ddb3a0caf7c7$export$1bea104a0e2567f0(theArgs, start, end);
}
var $5831ddb3a0caf7c7$export$c09f2411a4ae511b = /* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "create"), $5831ddb3a0caf7c7$var$polyObjCreate);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$polyObjCreate(obj) {
    if (!obj) return {};
    var type = typeof obj;
    if (type !== $5831ddb3a0caf7c7$var$OBJECT && type !== $5831ddb3a0caf7c7$var$FUNCTION) $5831ddb3a0caf7c7$export$3f7738bd7dcba681("Prototype must be an Object or function: " + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(obj));
    function tempFunc() {}
    tempFunc[$5831ddb3a0caf7c7$var$PROTOTYPE] = obj;
    return new tempFunc();
}
var $5831ddb3a0caf7c7$var$_isProtoArray;
function $5831ddb3a0caf7c7$export$97268f64d317ba65(obj, proto) {
    var fn = $5831ddb3a0caf7c7$var$ObjClass["setPrototypeOf"] || function(d, b) {
        var _a;
        !$5831ddb3a0caf7c7$var$_isProtoArray && ($5831ddb3a0caf7c7$var$_isProtoArray = $5831ddb3a0caf7c7$export$469f6b7560342b84((_a = {}, _a[$5831ddb3a0caf7c7$var$__PROTO__] = [], _a) instanceof Array));
        $5831ddb3a0caf7c7$var$_isProtoArray.v ? d[$5831ddb3a0caf7c7$var$__PROTO__] = b : $5831ddb3a0caf7c7$export$aa0705d5774c95d1(b, function(key, value) {
            return d[key] = value;
        });
    };
    return fn(obj, proto);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_createCustomError(name, d, b) {
    $5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$export$d0d2ebf910ad6e2, [
        d,
        $5831ddb3a0caf7c7$var$NAME,
        {
            v: name,
            c: true,
            e: false
        }
    ]);
    d = $5831ddb3a0caf7c7$export$97268f64d317ba65(d, b);
    function __() {
        this[$5831ddb3a0caf7c7$var$CONSTRUCTOR] = d;
        $5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$export$d0d2ebf910ad6e2, [
            this,
            $5831ddb3a0caf7c7$var$NAME,
            {
                v: name,
                c: true,
                e: false
            }
        ]);
    }
    d[$5831ddb3a0caf7c7$var$PROTOTYPE] = b === $5831ddb3a0caf7c7$var$NULL_VALUE ? $5831ddb3a0caf7c7$export$c09f2411a4ae511b(b) : (__[$5831ddb3a0caf7c7$var$PROTOTYPE] = b[$5831ddb3a0caf7c7$var$PROTOTYPE], new __());
    return d;
}
function $5831ddb3a0caf7c7$var$_setName(baseClass, name) {
    name && (baseClass[$5831ddb3a0caf7c7$var$NAME] = name);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$435492119a21bab3(name, constructCb, errorBase) {
    var theBaseClass = errorBase || Error;
    var orgName = theBaseClass[$5831ddb3a0caf7c7$var$PROTOTYPE][$5831ddb3a0caf7c7$var$NAME];
    var captureFn = Error.captureStackTrace;
    return $5831ddb3a0caf7c7$var$_createCustomError(name, function() {
        var _this = this;
        var theArgs = arguments;
        try {
            $5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$var$_setName, [
                theBaseClass,
                name
            ]);
            var _self = $5831ddb3a0caf7c7$export$2801572b9d3736b5(theBaseClass, _this, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](theArgs)) || _this;
            if (_self !== _this) {
                var orgProto = $5831ddb3a0caf7c7$export$743454acee35f1d4(_this);
                if (orgProto !== $5831ddb3a0caf7c7$export$743454acee35f1d4(_self)) $5831ddb3a0caf7c7$export$97268f64d317ba65(_self, orgProto);
            }
            captureFn && captureFn(_self, _this[$5831ddb3a0caf7c7$var$CONSTRUCTOR]);
            constructCb && constructCb(_self, theArgs);
            return _self;
        } finally{
            $5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$var$_setName, [
                theBaseClass,
                orgName
            ]);
        }
    }, theBaseClass);
}
var $5831ddb3a0caf7c7$var$_unsupportedError;
function $5831ddb3a0caf7c7$export$6523a1bd3b6e3128(message) {
    if (!$5831ddb3a0caf7c7$var$_unsupportedError) $5831ddb3a0caf7c7$var$_unsupportedError = $5831ddb3a0caf7c7$export$435492119a21bab3("UnsupportedError");
    throw new $5831ddb3a0caf7c7$var$_unsupportedError(message);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$a56f095995763cca() {
    return (Date.now || $5831ddb3a0caf7c7$export$dc8a201911902710)();
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$dc8a201911902710() {
    return new Date().getTime();
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_createTrimFn(exp) {
    return function _doTrim(value) {
        if ($5831ddb3a0caf7c7$export$bedb7023a7733221(value)) $5831ddb3a0caf7c7$export$3f7738bd7dcba681("strTrim called [" + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(value) + "]");
        if (value && value.replace) value = value.replace(exp, $5831ddb3a0caf7c7$var$EMPTY);
        return value;
    };
}
var $5831ddb3a0caf7c7$export$f662cd8e6ce31dc2 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createTrimFn(/^\s+|(?=\s)\s+$/g);
var $5831ddb3a0caf7c7$export$bb2565d3c45fa8e8 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createTrimFn(/^\s+/g);
var $5831ddb3a0caf7c7$export$78c6fe435b4cfdc5 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createTrimFn(/(?=\s)\s+$/g);
var $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("trim", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$export$f662cd8e6ce31dc2);
var $5831ddb3a0caf7c7$export$cc516ea7d6f0e796 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("trimStart", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$export$bb2565d3c45fa8e8);
var $5831ddb3a0caf7c7$export$54a8ea2dce045d2d = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign($5831ddb3a0caf7c7$export$cc516ea7d6f0e796);
var $5831ddb3a0caf7c7$export$2f86eefb8e93fce1 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("trimEnd", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$export$78c6fe435b4cfdc5);
var $5831ddb3a0caf7c7$export$9c947579c164a1bf = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign($5831ddb3a0caf7c7$export$2f86eefb8e93fce1);
var $5831ddb3a0caf7c7$export$f719256e30f2ebe5 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("toUpperCase", $5831ddb3a0caf7c7$var$StrProto);
var $5831ddb3a0caf7c7$export$389a34274c2f7137 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("toLowerCase", $5831ddb3a0caf7c7$var$StrProto);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_convertCase(value, newPrefix, upperWord) {
    return $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7($5831ddb3a0caf7c7$export$590567be997858b6(value)).replace(/((_|\W)+(\w){0,1}|([a-z])([A-Z]))/g, function(_match, _g1, _g2, wordStart, upperPrefix, upperLetter) {
        var convertMatch = wordStart || upperLetter || $5831ddb3a0caf7c7$var$EMPTY;
        if (upperWord) convertMatch = $5831ddb3a0caf7c7$export$f719256e30f2ebe5(convertMatch);
        return (upperPrefix || $5831ddb3a0caf7c7$var$EMPTY) + newPrefix + convertMatch;
    });
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$9d31ddd596700d21(value) {
    return $5831ddb3a0caf7c7$export$590567be997858b6(value).replace(/(_|\b)\w/g, $5831ddb3a0caf7c7$export$f719256e30f2ebe5);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$fca2281e8ae838f(value, upperFirst) {
    var result = $5831ddb3a0caf7c7$var$_convertCase(value, "", true);
    return result.replace(/^\w/, upperFirst ? $5831ddb3a0caf7c7$export$f719256e30f2ebe5 : $5831ddb3a0caf7c7$export$389a34274c2f7137);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$4b115658c011a193(value, scream) {
    var result = $5831ddb3a0caf7c7$var$_convertCase(value, "-");
    return (scream ? $5831ddb3a0caf7c7$export$f719256e30f2ebe5 : $5831ddb3a0caf7c7$export$389a34274c2f7137)(result);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$e48063a1e49453b7(value, scream) {
    var result = $5831ddb3a0caf7c7$var$_convertCase(value, "_");
    return (scream ? $5831ddb3a0caf7c7$export$f719256e30f2ebe5 : $5831ddb3a0caf7c7$export$389a34274c2f7137)(result);
}
var $5831ddb3a0caf7c7$export$c6301bc99a7f80a7 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "floor");
var $5831ddb3a0caf7c7$export$cf129980c996e186 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "ceil");
var $5831ddb3a0caf7c7$export$faee793222d6047e = /* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "trunc"), $5831ddb3a0caf7c7$var$polyMathTrunc);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$polyMathTrunc(value) {
    var theValue = +value;
    return (theValue > 0 ? $5831ddb3a0caf7c7$export$c6301bc99a7f80a7 : $5831ddb3a0caf7c7$export$cf129980c996e186)(theValue);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$930e69fac432072(value, throwInfinity) {
    var result = +value;
    if (result == Infinity && throwInfinity) $5831ddb3a0caf7c7$export$462e4d432290318e("invalid value [" + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(value) + "]");
    return result !== result || result === 0 ? 0 : $5831ddb3a0caf7c7$export$faee793222d6047e(result);
}
var $5831ddb3a0caf7c7$export$e944713c974c3850 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("repeat", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$var$polyStrRepeat);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$polyStrRepeat(value, count) {
    if ($5831ddb3a0caf7c7$export$bedb7023a7733221(value)) $5831ddb3a0caf7c7$export$3f7738bd7dcba681("can't convert [" + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(value) + "]");
    count = $5831ddb3a0caf7c7$export$930e69fac432072(count, true);
    if (count < 0) $5831ddb3a0caf7c7$export$462e4d432290318e("invalid count must be >= 0 && < Infinity");
    var pad = $5831ddb3a0caf7c7$export$844ec244b1367d54(value) ? value : $5831ddb3a0caf7c7$export$590567be997858b6(value);
    var result = $5831ddb3a0caf7c7$var$EMPTY;
    for(; count > 0; (count >>>= 1) && (pad += pad))if (count & 1) result += pad;
    return result;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_padValue(value, targetLength, padString) {
    var result = $5831ddb3a0caf7c7$var$EMPTY;
    targetLength = $5831ddb3a0caf7c7$export$930e69fac432072(targetLength, true);
    targetLength >>= 0;
    var len = value[$5831ddb3a0caf7c7$var$LENGTH];
    if (len < targetLength) {
        result = $5831ddb3a0caf7c7$export$bedb7023a7733221(padString) ? " " : $5831ddb3a0caf7c7$export$590567be997858b6(padString);
        targetLength = targetLength - len;
        if (targetLength > result[$5831ddb3a0caf7c7$var$LENGTH]) result = $5831ddb3a0caf7c7$export$e944713c974c3850(result, $5831ddb3a0caf7c7$export$cf129980c996e186(targetLength / result[$5831ddb3a0caf7c7$var$LENGTH]));
        if (result[$5831ddb3a0caf7c7$var$LENGTH] > targetLength) result = $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87(result, 0, targetLength);
    }
    return result;
}
var $5831ddb3a0caf7c7$export$5883ba0f525e6e64 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("padStart", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$var$polyStrPadStart);
var $5831ddb3a0caf7c7$export$1679063bd52155c = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("padEnd", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$var$polyStrPadEnd);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$polyStrPadStart(value, targetLength, padString) {
    return $5831ddb3a0caf7c7$var$_padValue(value, targetLength, padString) + value;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$polyStrPadEnd(value, targetLength, padString) {
    return value + $5831ddb3a0caf7c7$var$_padValue(value, targetLength, padString);
}
var $5831ddb3a0caf7c7$var$DBL_QUOTE = '"';
var $5831ddb3a0caf7c7$var$INVALID_JS_NAME = /([^\w\d_$])/g;
var $5831ddb3a0caf7c7$var$_htmlEntityCache;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$f60443f194e40bc2(jsName, camelCase) {
    var result = $5831ddb3a0caf7c7$export$590567be997858b6(jsName).replace($5831ddb3a0caf7c7$var$INVALID_JS_NAME, "_");
    return !$5831ddb3a0caf7c7$export$fce6876652108ab(camelCase) ? $5831ddb3a0caf7c7$export$fca2281e8ae838f(result, !camelCase) : result;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$bc8dd9487ff4d994(value, format) {
    var result;
    if ($5831ddb3a0caf7c7$export$844ec244b1367d54(value)) result = $5831ddb3a0caf7c7$var$DBL_QUOTE + value.replace(/[^\w .,\-!@#$%\^&*\(\)_+={}\[\]:;|<>?]/g, function(match) {
        if (match === $5831ddb3a0caf7c7$var$DBL_QUOTE || match === "\\") return "\\" + match;
        var hex = match.charCodeAt(0)[$5831ddb3a0caf7c7$var$TO_STRING](16);
        return "\\u" + $5831ddb3a0caf7c7$export$5883ba0f525e6e64($5831ddb3a0caf7c7$export$f719256e30f2ebe5(hex), 4, "0");
    }) + $5831ddb3a0caf7c7$var$DBL_QUOTE;
    else try {
        result = JSON.stringify(value, $5831ddb3a0caf7c7$var$NULL_VALUE, format ? $5831ddb3a0caf7c7$export$7e4aa119212bc614(format) ? format : 4 : $5831ddb3a0caf7c7$var$UNDEF_VALUE);
    } catch (e) {
        result = $5831ddb3a0caf7c7$var$DBL_QUOTE + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(e) + $5831ddb3a0caf7c7$var$DBL_QUOTE;
    }
    return result;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$c41e0bfda0ab0f0d(value) {
    !$5831ddb3a0caf7c7$var$_htmlEntityCache && ($5831ddb3a0caf7c7$var$_htmlEntityCache = {
        "&": "amp",
        "<": "lt",
        ">": "gt",
        '"': "quot",
        "'": "#39"
    });
    return $5831ddb3a0caf7c7$export$590567be997858b6(value).replace(/[&<>"']/g, function(match) {
        return "&" + $5831ddb3a0caf7c7$var$_htmlEntityCache[match] + ";";
    });
}
var $5831ddb3a0caf7c7$var$_fnToString;
var $5831ddb3a0caf7c7$var$_objCtrFnString;
var $5831ddb3a0caf7c7$var$_gblWindow;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$53b83ca8eaab0383(value) {
    if (!value || typeof value !== $5831ddb3a0caf7c7$var$OBJECT) return false;
    if (!$5831ddb3a0caf7c7$var$_gblWindow) $5831ddb3a0caf7c7$var$_gblWindow = $5831ddb3a0caf7c7$export$fef62134eea24008() ? $5831ddb3a0caf7c7$export$38b2d434cce3ea22() : true;
    var result = false;
    if (value !== $5831ddb3a0caf7c7$var$_gblWindow) {
        if (!$5831ddb3a0caf7c7$var$_objCtrFnString) {
            $5831ddb3a0caf7c7$var$_fnToString = Function[$5831ddb3a0caf7c7$var$PROTOTYPE][$5831ddb3a0caf7c7$var$TO_STRING];
            $5831ddb3a0caf7c7$var$_objCtrFnString = $5831ddb3a0caf7c7$var$_fnToString[$5831ddb3a0caf7c7$var$CALL]($5831ddb3a0caf7c7$var$ObjClass);
        }
        try {
            var proto = $5831ddb3a0caf7c7$export$743454acee35f1d4(value);
            result = !proto;
            if (!result) {
                if ($5831ddb3a0caf7c7$export$d76937f5d45b7158(proto, $5831ddb3a0caf7c7$var$CONSTRUCTOR)) proto = proto[$5831ddb3a0caf7c7$var$CONSTRUCTOR];
                result = !!(proto && typeof proto === $5831ddb3a0caf7c7$var$FUNCTION && $5831ddb3a0caf7c7$var$_fnToString[$5831ddb3a0caf7c7$var$CALL](proto) === $5831ddb3a0caf7c7$var$_objCtrFnString);
            }
        } catch (ex) {}
    }
    return result;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_defaultDeepCopyHandler(details) {
    details.value && $5831ddb3a0caf7c7$export$7d1ebb7d4f033054(details);
    return true;
}
var $5831ddb3a0caf7c7$var$defaultDeepCopyHandlers = [
    $5831ddb3a0caf7c7$export$cc4db57f4a8fbdc7,
    $5831ddb3a0caf7c7$export$7d1ebb7d4f033054,
    $5831ddb3a0caf7c7$export$56ca4b82c6e32658,
    $5831ddb3a0caf7c7$export$2b6207be55b7460b
];
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_getSetVisited(visitMap, source, newPath, cb) {
    var theEntry;
    $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586(visitMap, function(entry) {
        if (entry.k === source) {
            theEntry = entry;
            return -1;
        }
    });
    if (!theEntry) {
        theEntry = {
            k: source,
            v: source
        };
        visitMap.push(theEntry);
        cb(theEntry);
    }
    return theEntry.v;
}
function $5831ddb3a0caf7c7$var$_deepCopy(visitMap, value, ctx, key) {
    var userHandler = ctx.handler;
    var newPath = ctx.path ? key ? ctx.path.concat(key) : ctx.path : [];
    var newCtx = {
        handler: ctx.handler,
        src: ctx.src,
        path: newPath
    };
    var theType = typeof value;
    var isPlain = false;
    var isPrim = value === $5831ddb3a0caf7c7$var$NULL_VALUE;
    if (!isPrim) {
        if (value && theType === $5831ddb3a0caf7c7$var$OBJECT) isPlain = $5831ddb3a0caf7c7$export$53b83ca8eaab0383(value);
        else isPrim = $5831ddb3a0caf7c7$export$1f3b27a0956fac0e(theType);
    }
    var details = {
        type: theType,
        isPrim: isPrim,
        isPlain: isPlain,
        value: value,
        result: value,
        path: newPath,
        origin: ctx.src,
        copy: function(source, newKey) {
            return $5831ddb3a0caf7c7$var$_deepCopy(visitMap, source, newKey ? newCtx : ctx, newKey);
        },
        copyTo: function(target, source) {
            return $5831ddb3a0caf7c7$var$_copyProps(visitMap, target, source, newCtx);
        }
    };
    if (!details.isPrim) return $5831ddb3a0caf7c7$var$_getSetVisited(visitMap, value, newPath, function(newEntry) {
        $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2(details, "result", {
            g: function() {
                return newEntry.v;
            },
            s: function(newValue) {
                newEntry.v = newValue;
            }
        });
        var idx = 0;
        var handler = userHandler;
        while(!(handler || (idx < $5831ddb3a0caf7c7$var$defaultDeepCopyHandlers.length ? $5831ddb3a0caf7c7$var$defaultDeepCopyHandlers[idx++] : $5831ddb3a0caf7c7$var$_defaultDeepCopyHandler))[$5831ddb3a0caf7c7$var$CALL](ctx, details))handler = $5831ddb3a0caf7c7$var$NULL_VALUE;
    });
    if (userHandler && userHandler[$5831ddb3a0caf7c7$var$CALL](ctx, details)) return details.result;
    return value;
}
function $5831ddb3a0caf7c7$var$_copyProps(visitMap, target, source, ctx) {
    if (!$5831ddb3a0caf7c7$export$bedb7023a7733221(source)) for(var key in source)target[key] = $5831ddb3a0caf7c7$var$_deepCopy(visitMap, source[key], ctx, key);
    return target;
}
function $5831ddb3a0caf7c7$export$eee89407658fa201(target, source, handler) {
    var ctx = {
        handler: handler,
        src: source,
        path: []
    };
    return $5831ddb3a0caf7c7$var$_copyProps([], target, source, ctx);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$ee1b2e0d6501c954(source, handler) {
    var ctx = {
        handler: handler,
        src: source
    };
    return $5831ddb3a0caf7c7$var$_deepCopy([], source, ctx);
}
function $5831ddb3a0caf7c7$export$cc4db57f4a8fbdc7(details) {
    var value = details.value;
    if ($5831ddb3a0caf7c7$export$43bee75e5e14138e(value)) {
        var target = details.result = [];
        target.length = value.length;
        details.copyTo(target, value);
        return true;
    }
    return false;
}
function $5831ddb3a0caf7c7$export$2b6207be55b7460b(details) {
    var value = details.value;
    if ($5831ddb3a0caf7c7$export$871608497c498473(value)) {
        details.result = new Date(value.getTime());
        return true;
    }
    return false;
}
function $5831ddb3a0caf7c7$export$56ca4b82c6e32658(details) {
    if (details.type === $5831ddb3a0caf7c7$var$FUNCTION) return true;
    return false;
}
function $5831ddb3a0caf7c7$export$7d1ebb7d4f033054(details) {
    var value = details.value;
    if (value && details.isPlain) {
        var target = details.result = {};
        details.copyTo(target, value);
        return true;
    }
    return false;
}
function $5831ddb3a0caf7c7$var$_doExtend(target, theArgs) {
    $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586(theArgs, function(theArg) {
        $5831ddb3a0caf7c7$export$eee89407658fa201(target, theArg);
    });
    return target;
}
function $5831ddb3a0caf7c7$export$54e9fb29908872fa(target, obj1, obj2, obj3, obj4, obj5, obj6) {
    return $5831ddb3a0caf7c7$var$_doExtend($5831ddb3a0caf7c7$export$ee1b2e0d6501c954(target) || {}, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments));
}
function $5831ddb3a0caf7c7$export$a7f7e50f928053df(target, obj1, obj2, obj3, obj4, obj5, obj6) {
    return $5831ddb3a0caf7c7$var$_doExtend(target || {}, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments));
}
var $5831ddb3a0caf7c7$export$f0d11c074a923179 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapProp($5831ddb3a0caf7c7$var$LENGTH);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$1bc10eefc0289e0a(value, defValue) {
    if (!$5831ddb3a0caf7c7$export$bedb7023a7733221(value)) {
        if ($5831ddb3a0caf7c7$export$7e4aa119212bc614(value)) return value;
        var theValue = parseInt(value, 10);
        return isNaN(theValue) ? defValue : theValue;
    }
    return defValue;
}
var $5831ddb3a0caf7c7$var$_perf;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$581add2462e763c2() {
    return !!$5831ddb3a0caf7c7$export$28a0276e10aa78d7();
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$28a0276e10aa78d7() {
    !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
    if (!$5831ddb3a0caf7c7$var$_perf || $5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy) $5831ddb3a0caf7c7$var$_perf = $5831ddb3a0caf7c7$export$469f6b7560342b84($5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$export$3df6e51375017edd, [
        "performance"
    ]).v);
    return $5831ddb3a0caf7c7$var$_perf.v;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$ba2b1ec760f018ed() {
    var perf = $5831ddb3a0caf7c7$export$28a0276e10aa78d7();
    if (perf && perf.now) return perf.now();
    return $5831ddb3a0caf7c7$export$a56f095995763cca();
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$1ea91570c695dfb2(startTime) {
    return $5831ddb3a0caf7c7$export$ba2b1ec760f018ed() - startTime;
}
var $5831ddb3a0caf7c7$var$MATCH_ANY = "(.*)";
var $5831ddb3a0caf7c7$var$MATCH_SINGLE = "(.)";
function $5831ddb3a0caf7c7$var$_createRegExp(value, escapeRgx, replaceFn, ignoreCase, fullMatch) {
    // eslint-disable-next-line security/detect-non-literal-regexp
    return new RegExp((fullMatch ? "^" : $5831ddb3a0caf7c7$var$EMPTY) + replaceFn(value.replace(escapeRgx, "\\$1")) + (fullMatch ? "$" : $5831ddb3a0caf7c7$var$EMPTY), ignoreCase ? "i" : "");
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$81333aadf7b6e1f7(value, ignoreCase, fullMatch) {
    return $5831ddb3a0caf7c7$var$_createRegExp($5831ddb3a0caf7c7$export$590567be997858b6(value), /([-+|^$#.\?{}()\[\]\\/\"\'])/g, function(value) {
        return value.replace(/\*/g, $5831ddb3a0caf7c7$var$MATCH_ANY);
    }, !!ignoreCase, fullMatch);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$d5a6cf2d39a760ca(value, ignoreCase, fullMatch) {
    return $5831ddb3a0caf7c7$var$_createRegExp($5831ddb3a0caf7c7$export$590567be997858b6(value), /([-+|^$#.{}()\\\/\[\]\"\'])/g, function(value) {
        return value.replace(/(\\\\|\\\/|\*|\?)/g, function(_all, g1) {
            if (g1 == "\\/" || g1 == "\\\\") return "[\\\\\\/]{1}";
            return g1 == "*" ? $5831ddb3a0caf7c7$var$MATCH_ANY : $5831ddb3a0caf7c7$var$MATCH_SINGLE;
        });
    }, !!ignoreCase, fullMatch);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$3dedd7e7feca328f(value, ignoreCase, fullMatch) {
    return $5831ddb3a0caf7c7$var$_createRegExp($5831ddb3a0caf7c7$export$590567be997858b6(value), /([-+|^$#.{}()\\\/\[\]\"\'])/g, function(value) {
        return value.replace(/(\*\*\\[\\\/]|\\\\|\\\/|\*\*|\*|\?)/g, function(_all, g1) {
            if (g1 == "**\\/" || g1 == "**\\\\") return "(.*[\\\\\\/])*";
            if (g1 === "\\/" || g1 == "\\\\") return "[\\\\\\/]{1}";
            if (g1 === "**") return $5831ddb3a0caf7c7$var$MATCH_ANY;
            return g1 === "*" ? "([^\\\\\\/]*)" : "([^\\\\\\/]{1})";
        });
    }, !!ignoreCase, fullMatch);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$c6675fd9042172d2(cb, defValue) {
    return $5831ddb3a0caf7c7$export$db98eae15987454c(function() {
        var result = $5831ddb3a0caf7c7$export$170b8c323eee7bec(cb);
        return result.e ? defValue : result.v;
    });
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_checkLength(value, props) {
    var result;
    $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586(props, function(prop) {
        if (prop in value) {
            var propValue = value[prop];
            result = ($5831ddb3a0caf7c7$export$f6e2535fb5126e54(propValue) ? propValue() : propValue) > 0;
            return -1;
        }
    });
    return result;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_hasValue(value, depth) {
    var result = value === false || value === 0;
    if (!result && !$5831ddb3a0caf7c7$export$bedb7023a7733221(value)) {
        if ($5831ddb3a0caf7c7$export$43bee75e5e14138e(value)) result = value[$5831ddb3a0caf7c7$var$LENGTH] > 0;
        else if ($5831ddb3a0caf7c7$export$871608497c498473(value)) result = !isNaN(value.getTime());
        else if ($5831ddb3a0caf7c7$export$f9ce7b637dfbe238(value)) return true;
        else if ($5831ddb3a0caf7c7$export$a6cdc56e425d0d0a(value)) {
            try {
                var chkValue = $5831ddb3a0caf7c7$var$_checkLength(value, [
                    $5831ddb3a0caf7c7$var$LENGTH,
                    "byteLength",
                    "size",
                    "count"
                ]);
                if ($5831ddb3a0caf7c7$export$f9ce7b637dfbe238(chkValue)) return chkValue;
                if ($5831ddb3a0caf7c7$export$f6e2535fb5126e54(value.valueOf) && depth < 5) return $5831ddb3a0caf7c7$var$_hasValue(value.valueOf(), ++depth);
            } catch (e) {}
            return !!$5831ddb3a0caf7c7$export$f7628dc18f4211e5(value)[$5831ddb3a0caf7c7$var$LENGTH];
        } else result = $5831ddb3a0caf7c7$export$8f9cae6546f97a9f(value);
    }
    return result;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$96bdbc84526f3739(value) {
    return $5831ddb3a0caf7c7$var$_hasValue(value, 0);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$f9c2f07d6e2a6221(ctx) {
    return $5831ddb3a0caf7c7$export$a110d95e992bd193({}, ctx);
}
function $5831ddb3a0caf7c7$export$a110d95e992bd193(target, ctx) {
    var itSymbol = $5831ddb3a0caf7c7$export$3a9aefdadea26115(3);
    function _createIterator() {
        return $5831ddb3a0caf7c7$export$7342c78d7e13e778(ctx);
    }
    target[itSymbol] = _createIterator;
    return target;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$7342c78d7e13e778(ctx) {
    var isDone = false;
    function _value() {
        return ctx.v;
    }
    function _next() {
        if (!isDone) isDone = ctx.n ? ctx.n(arguments) : true;
        var result = {
            done: isDone
        };
        if (!isDone) $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2(result, "value", {
            g: _value
        });
        return result;
    }
    function _return(value) {
        isDone = true;
        return {
            done: true,
            value: ctx.r && ctx.r(value)
        };
    }
    function _throw(e) {
        isDone = true;
        return {
            done: true,
            value: ctx.t && ctx.t(e)
        };
    }
    var theIterator = {
        next: _next
    };
    if (ctx.r) theIterator.return = _return;
    if (ctx.t) theIterator.throw = _throw;
    return theIterator;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$347cf8d764bc2c7d(values) {
    var idx = -1;
    var theValues = values ? values.slice() : [];
    var len = theValues[$5831ddb3a0caf7c7$var$LENGTH];
    function _value() {
        if (idx >= 0 && idx < len) return theValues[idx];
    }
    function _getNext() {
        idx++;
        return idx >= len;
    }
    var ctx = {
        n: _getNext
    };
    $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2(ctx, "v", {
        g: _value
    });
    return $5831ddb3a0caf7c7$export$7342c78d7e13e778(ctx);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$9164d977cc95ce6f(start, end, step) {
    var nextValue = start;
    var theValue = $5831ddb3a0caf7c7$var$UNDEF_VALUE;
    if ($5831ddb3a0caf7c7$export$bedb7023a7733221(end)) end = start;
    var theStep = step;
    if (!theStep) theStep = start <= end ? 1 : -1;
    function _value() {
        return theValue;
    }
    function _getNext() {
        var isDone = theStep > 0 ? nextValue > end : nextValue < end;
        if (!isDone) {
            theValue = nextValue;
            nextValue += theStep;
        }
        return isDone;
    }
    return $5831ddb3a0caf7c7$export$7342c78d7e13e778($5831ddb3a0caf7c7$export$d0d2ebf910ad6e2({
        n: _getNext
    }, "v", {
        g: _value
    }));
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$662922279874f264(value, splitter, limit) {
    var splitFn = splitter ? splitter[$5831ddb3a0caf7c7$export$3a9aefdadea26115(9)] : $5831ddb3a0caf7c7$var$UNDEF_VALUE;
    return splitFn ? splitFn(value, limit) : [
        value
    ];
}
var $5831ddb3a0caf7c7$export$c07560e259c81ec6 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("split", $5831ddb3a0caf7c7$var$StrProto);
var $5831ddb3a0caf7c7$export$c2a2794de8b8ee4e = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("split", $5831ddb3a0caf7c7$var$StrProto, !$5831ddb3a0caf7c7$export$1e6e45ea4c3f892c() ? $5831ddb3a0caf7c7$export$662922279874f264 : $5831ddb3a0caf7c7$var$NULL_VALUE);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$a81fc8ab8c0b1254(target, path, defValue) {
    if (!path || !target) return defValue;
    var parts = $5831ddb3a0caf7c7$export$c07560e259c81ec6(path, ".");
    var cnt = parts.length;
    for(var lp = 0; lp < cnt && !$5831ddb3a0caf7c7$export$bedb7023a7733221(target); lp++)target = target[parts[lp]];
    return !$5831ddb3a0caf7c7$export$bedb7023a7733221(target) ? target : defValue;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$9054a6f0ccd5e6fd(target, iter, defValue) {
    if (!iter || !target) return defValue;
    $5831ddb3a0caf7c7$export$1180a64ad833b902(iter, function(value) {
        if ($5831ddb3a0caf7c7$export$bedb7023a7733221(target)) return -1;
        target = target[value];
    });
    return !$5831ddb3a0caf7c7$export$bedb7023a7733221(target) ? target : defValue;
}
function $5831ddb3a0caf7c7$export$7dee18238d098123(target, path, value) {
    if (target && path) {
        var parts = $5831ddb3a0caf7c7$export$c07560e259c81ec6(path, ".");
        var lastKey = parts.pop();
        $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586(parts, function(key) {
            if ($5831ddb3a0caf7c7$export$bedb7023a7733221(target[key])) target[key] = {};
            target = target[key];
        });
        target[lastKey] = value;
    }
}
function $5831ddb3a0caf7c7$export$4eaf2d2fdfc0ba46(target, iter, value) {
    if (target && iter) {
        var lastKey_1;
        $5831ddb3a0caf7c7$export$1180a64ad833b902(iter, function(key) {
            if (lastKey_1) {
                if ($5831ddb3a0caf7c7$export$bedb7023a7733221(target[lastKey_1])) target[lastKey_1] = {};
                target = target[lastKey_1];
            }
            lastKey_1 = key;
        });
        target[lastKey_1] = value;
    }
}
var $5831ddb3a0caf7c7$export$5222b9460f3ddbec = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("endsWith", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$var$polyStrEndsWith);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$polyStrEndsWith(value, searchString, length) {
    if (!$5831ddb3a0caf7c7$export$844ec244b1367d54(value)) $5831ddb3a0caf7c7$export$3f7738bd7dcba681("'" + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(value) + "' is not a string");
    var searchValue = $5831ddb3a0caf7c7$export$844ec244b1367d54(searchString) ? searchString : $5831ddb3a0caf7c7$export$590567be997858b6(searchString);
    var end = !$5831ddb3a0caf7c7$export$fce6876652108ab(length) && length < value[$5831ddb3a0caf7c7$var$LENGTH] ? length : value[$5831ddb3a0caf7c7$var$LENGTH];
    return $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87(value, end - searchValue[$5831ddb3a0caf7c7$var$LENGTH], end) === searchValue;
}
var $5831ddb3a0caf7c7$export$7c0888b0c4641088 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("indexOf", $5831ddb3a0caf7c7$var$StrProto);
var $5831ddb3a0caf7c7$export$107c6a87f2040ede = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("lastIndexOf", $5831ddb3a0caf7c7$var$StrProto);
var $5831ddb3a0caf7c7$export$58605e31a7a30d86 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("includes", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$export$524f0a69f7e45237);
var $5831ddb3a0caf7c7$export$3185d777c612e61f = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign($5831ddb3a0caf7c7$export$58605e31a7a30d86);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$524f0a69f7e45237(value, searchString, position) {
    if ($5831ddb3a0caf7c7$export$49841c62b9eff15(searchString)) $5831ddb3a0caf7c7$export$3f7738bd7dcba681("'searchString' must not be a regular expression" + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(searchString));
    return $5831ddb3a0caf7c7$export$7c0888b0c4641088(value, $5831ddb3a0caf7c7$export$590567be997858b6(searchString), position) !== -1;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$e042a3f6c540f833(value) {
    if ($5831ddb3a0caf7c7$export$844ec244b1367d54(value)) return value.replace(/[\s\t\r\n\f]+/g, $5831ddb3a0caf7c7$var$EMPTY) === $5831ddb3a0caf7c7$var$EMPTY;
    return $5831ddb3a0caf7c7$export$bedb7023a7733221(value);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$a610cc6364f8352(value) {
    if ($5831ddb3a0caf7c7$export$844ec244b1367d54(value)) return value === $5831ddb3a0caf7c7$var$EMPTY;
    return $5831ddb3a0caf7c7$export$bedb7023a7733221(value);
}
var $5831ddb3a0caf7c7$export$da061769d961e150 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("startsWith", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$var$polyStrStartsWith);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$polyStrStartsWith(value, searchString, position) {
    if (!$5831ddb3a0caf7c7$export$844ec244b1367d54(value)) $5831ddb3a0caf7c7$export$3f7738bd7dcba681("'" + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(value) + "' is not a string");
    var searchValue = $5831ddb3a0caf7c7$export$844ec244b1367d54(searchString) ? searchString : $5831ddb3a0caf7c7$export$590567be997858b6(searchString);
    var pos = position > 0 ? position : 0;
    return $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87(value, pos, pos + searchValue[$5831ddb3a0caf7c7$var$LENGTH]) === searchValue;
}
var $5831ddb3a0caf7c7$var$REF = "ref";
var $5831ddb3a0caf7c7$var$UNREF = "unref";
var $5831ddb3a0caf7c7$var$HAS_REF = "hasRef";
var $5831ddb3a0caf7c7$var$ENABLED = "enabled";
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_createTimerHandler(startTimer, refreshFn, cancelFn) {
    var ref = true;
    var timerId = startTimer ? refreshFn($5831ddb3a0caf7c7$var$NULL_VALUE) : $5831ddb3a0caf7c7$var$NULL_VALUE;
    var theTimerHandler;
    function _unref() {
        ref = false;
        timerId && timerId[$5831ddb3a0caf7c7$var$UNREF] && timerId[$5831ddb3a0caf7c7$var$UNREF]();
        return theTimerHandler;
    }
    function _cancel() {
        timerId && cancelFn(timerId);
        timerId = $5831ddb3a0caf7c7$var$NULL_VALUE;
    }
    function _refresh() {
        timerId = refreshFn(timerId);
        if (!ref) _unref();
        return theTimerHandler;
    }
    function _setEnabled(value) {
        !value && timerId && _cancel();
        value && !timerId && _refresh();
    }
    theTimerHandler = {
        cancel: _cancel,
        refresh: _refresh
    };
    theTimerHandler[$5831ddb3a0caf7c7$var$HAS_REF] = function() {
        if (timerId && timerId[$5831ddb3a0caf7c7$var$HAS_REF]) return timerId[$5831ddb3a0caf7c7$var$HAS_REF]();
        return ref;
    };
    theTimerHandler[$5831ddb3a0caf7c7$var$REF] = function() {
        ref = true;
        timerId && timerId[$5831ddb3a0caf7c7$var$REF] && timerId[$5831ddb3a0caf7c7$var$REF]();
        return theTimerHandler;
    };
    theTimerHandler[$5831ddb3a0caf7c7$var$UNREF] = _unref;
    theTimerHandler = $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(theTimerHandler, $5831ddb3a0caf7c7$var$ENABLED, {
        get: function() {
            return !!timerId;
        },
        set: _setEnabled
    });
    return {
        h: theTimerHandler,
        dn: function() {
            timerId = $5831ddb3a0caf7c7$var$NULL_VALUE;
        }
    };
}
function $5831ddb3a0caf7c7$var$_createTimeoutWith(startTimer, overrideFn, theArgs) {
    var isArr = $5831ddb3a0caf7c7$export$43bee75e5e14138e(overrideFn);
    var len = isArr ? overrideFn.length : 0;
    var setFn = (len > 0 ? overrideFn[0] : !isArr ? overrideFn : $5831ddb3a0caf7c7$var$UNDEF_VALUE) || setTimeout;
    var clearFn = (len > 1 ? overrideFn[1] : $5831ddb3a0caf7c7$var$UNDEF_VALUE) || clearTimeout;
    var timerFn = theArgs[0];
    theArgs[0] = function() {
        handler.dn();
        $5831ddb3a0caf7c7$export$2801572b9d3736b5(timerFn, $5831ddb3a0caf7c7$var$UNDEF_VALUE, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments));
    };
    var handler = $5831ddb3a0caf7c7$var$_createTimerHandler(startTimer, function(timerId) {
        if (timerId) {
            if (timerId.refresh) {
                timerId.refresh();
                return timerId;
            }
            $5831ddb3a0caf7c7$export$2801572b9d3736b5(clearFn, $5831ddb3a0caf7c7$var$UNDEF_VALUE, [
                timerId
            ]);
        }
        return $5831ddb3a0caf7c7$export$2801572b9d3736b5(setFn, $5831ddb3a0caf7c7$var$UNDEF_VALUE, theArgs);
    }, function(timerId) {
        $5831ddb3a0caf7c7$export$2801572b9d3736b5(clearFn, $5831ddb3a0caf7c7$var$UNDEF_VALUE, [
            timerId
        ]);
    });
    return handler.h;
}
function $5831ddb3a0caf7c7$export$5f4d6617421d489b(callback, timeout) {
    return $5831ddb3a0caf7c7$var$_createTimeoutWith(true, $5831ddb3a0caf7c7$var$UNDEF_VALUE, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments));
}
function $5831ddb3a0caf7c7$export$9e7e48cc39f2a8d3(overrideFn, callback, timeout) {
    return $5831ddb3a0caf7c7$var$_createTimeoutWith(true, overrideFn, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments, 1));
}
function $5831ddb3a0caf7c7$export$6eae7cf7a129a986(callback, timeout) {
    return $5831ddb3a0caf7c7$var$_createTimeoutWith(false, $5831ddb3a0caf7c7$var$UNDEF_VALUE, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments));
}
function $5831ddb3a0caf7c7$export$320dbce2ee83dc77(overrideFn, callback, timeout) {
    return $5831ddb3a0caf7c7$var$_createTimeoutWith(false, overrideFn, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments, 1));
}
var $5831ddb3a0caf7c7$var$_defaultIdleTimeout = 100;
var $5831ddb3a0caf7c7$var$_maxExecutionTime = 50;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$b9301f2c5b7c2533() {
    return !!/*#__PURE__*/ $5831ddb3a0caf7c7$export$6cb38458be4b5644();
}
var $5831ddb3a0caf7c7$export$6cb38458be4b5644 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_getGlobalInstFn($5831ddb3a0caf7c7$export$3df6e51375017edd, [
    "requestIdleCallback"
]);
var $5831ddb3a0caf7c7$export$2a4da33a3741682a = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_getGlobalInstFn($5831ddb3a0caf7c7$export$3df6e51375017edd, [
    "cancelIdleCallback"
]);
function $5831ddb3a0caf7c7$export$b588248e012cdf5c(timeout) {
    $5831ddb3a0caf7c7$var$_defaultIdleTimeout = timeout;
}
function $5831ddb3a0caf7c7$export$b062c6607588fb47(maxTime) {
    $5831ddb3a0caf7c7$var$_maxExecutionTime = maxTime;
}
function $5831ddb3a0caf7c7$export$553e359f3bef3995(callback, options) {
    function _createDeadline(timedOut) {
        var startTime = $5831ddb3a0caf7c7$export$ba2b1ec760f018ed();
        return {
            didTimeout: timedOut,
            timeRemaining: function() {
                return $5831ddb3a0caf7c7$var$_maxExecutionTime - $5831ddb3a0caf7c7$export$1ea91570c695dfb2(startTime);
            }
        };
    }
    if ($5831ddb3a0caf7c7$export$b9301f2c5b7c2533()) {
        var handler_1 = $5831ddb3a0caf7c7$var$_createTimerHandler(true, function(idleId) {
            idleId && $5831ddb3a0caf7c7$export$2a4da33a3741682a()(idleId);
            return $5831ddb3a0caf7c7$export$6cb38458be4b5644()(function(deadline) {
                handler_1.dn();
                callback(deadline || _createDeadline(false));
            }, options);
        }, function(idleId) {
            $5831ddb3a0caf7c7$export$2a4da33a3741682a()(idleId);
        });
        return handler_1.h;
    }
    var timeout = (options || {}).timeout;
    if ($5831ddb3a0caf7c7$export$fce6876652108ab(timeout)) timeout = $5831ddb3a0caf7c7$var$_defaultIdleTimeout;
    return $5831ddb3a0caf7c7$export$5f4d6617421d489b(function() {
        callback(_createDeadline(true));
    }, timeout);
}
function $5831ddb3a0caf7c7$export$b093775e872b0dcd(callback, timeout) {
    var theArguments = $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments);
    var handler = $5831ddb3a0caf7c7$var$_createTimerHandler(true, function(intervalId) {
        intervalId && clearInterval(intervalId);
        return $5831ddb3a0caf7c7$export$2801572b9d3736b5(setInterval, $5831ddb3a0caf7c7$var$UNDEF_VALUE, theArguments);
    }, function(intervalId) {
        $5831ddb3a0caf7c7$export$2801572b9d3736b5(clearInterval, $5831ddb3a0caf7c7$var$UNDEF_VALUE, [
            intervalId
        ]);
    });
    return handler.h;
}


var $1e9ef78f0556a404$var$_a;
var $1e9ef78f0556a404$var$UNDEFINED = "undefined";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $1e9ef78f0556a404$var$Constructor = "constructor";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $1e9ef78f0556a404$var$Prototype = "prototype";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $1e9ef78f0556a404$var$strFunction = "function";
/**
 * Used to define the name of the instance function lookup table
 * @ignore
 */ var $1e9ef78f0556a404$var$DynInstFuncTable = "_dynInstFuncs";
/**
 * Name used to tag the dynamic prototype function
 * @ignore
 */ var $1e9ef78f0556a404$var$DynProxyTag = "_isDynProxy";
/**
 * Name added to a prototype to define the dynamic prototype "class" name used to lookup the function table
 * @ignore
 */ var $1e9ef78f0556a404$var$DynClassName = "_dynClass";
/**
 * Prefix added to the classname to avoid any name clashes with other instance level properties
 * @ignore
 */ var $1e9ef78f0556a404$var$DynClassNamePrefix = "_dynCls$";
/**
 * A tag which is used to check if we have already to attempted to set the instance function if one is not present
 * @ignore
 */ var $1e9ef78f0556a404$var$DynInstChkTag = "_dynInstChk";
/**
 * A tag which is used to check if we are allows to try and set an instance function is one is not present. Using the same
 * tag name as the function level but a different const name for readability only.
 */ var $1e9ef78f0556a404$var$DynAllowInstChkTag = $1e9ef78f0556a404$var$DynInstChkTag;
/**
 * The global (imported) instances where the global performance options are stored
 */ var $1e9ef78f0556a404$var$DynProtoDefaultOptions = "_dfOpts";
/**
 * Value used as the name of a class when it cannot be determined
 * @ignore
 */ var $1e9ef78f0556a404$var$UnknownValue = "_unknown_";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $1e9ef78f0556a404$var$str__Proto = "__proto__";
/**
 * The polyfill version of __proto__ so that it doesn't cause issues for anyone not expecting it to exist
 */ var $1e9ef78f0556a404$var$DynProtoBaseProto = "_dyn" + $1e9ef78f0556a404$var$str__Proto;
/**
 * Runtime Global holder for dynamicProto settings
 */ var $1e9ef78f0556a404$var$DynProtoGlobalSettings = "__dynProto$Gbl";
/**
 * Track the current prototype for IE8 as you can't look back to get the prototype
 */ var $1e9ef78f0556a404$var$DynProtoCurrent = "_dynInstProto";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $1e9ef78f0556a404$var$strUseBaseInst = "useBaseInst";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $1e9ef78f0556a404$var$strSetInstFuncs = "setInstFuncs";
var $1e9ef78f0556a404$var$Obj = Object;
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */ var $1e9ef78f0556a404$var$_objGetPrototypeOf = $1e9ef78f0556a404$var$Obj["getPrototypeOf"];
/**
 * Pre-lookup to check for the existence of this function
 */ var $1e9ef78f0556a404$var$_objGetOwnProps = $1e9ef78f0556a404$var$Obj["getOwnPropertyNames"];
// Since 1.1.7 moving these to the runtime global to work around mixed version and module issues
// See Issue https://github.com/microsoft/DynamicProto-JS/issues/57 for details
var $1e9ef78f0556a404$var$_gbl = (0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)();
var $1e9ef78f0556a404$var$_gblInst = $1e9ef78f0556a404$var$_gbl[$1e9ef78f0556a404$var$DynProtoGlobalSettings] || ($1e9ef78f0556a404$var$_gbl[$1e9ef78f0556a404$var$DynProtoGlobalSettings] = {
    o: ($1e9ef78f0556a404$var$_a = {}, $1e9ef78f0556a404$var$_a[$1e9ef78f0556a404$var$strSetInstFuncs] = true, $1e9ef78f0556a404$var$_a[$1e9ef78f0556a404$var$strUseBaseInst] = true, $1e9ef78f0556a404$var$_a),
    n: 1000 // Start new global index @ 1000 so we "fix" some cases when mixed with 1.1.6 or earlier
});
/**
 * Helper used to check whether the target is an Object prototype or Array prototype
 * @ignore
 */ function $1e9ef78f0556a404$var$_isObjectOrArrayPrototype(target) {
    return target && (target === $1e9ef78f0556a404$var$Obj[$1e9ef78f0556a404$var$Prototype] || target === Array[$1e9ef78f0556a404$var$Prototype]);
}
/**
 * Helper used to check whether the target is an Object prototype, Array prototype or Function prototype
 * @ignore
 */ function $1e9ef78f0556a404$var$_isObjectArrayOrFunctionPrototype(target) {
    return $1e9ef78f0556a404$var$_isObjectOrArrayPrototype(target) || target === Function[$1e9ef78f0556a404$var$Prototype];
}
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */ function $1e9ef78f0556a404$var$_getObjProto(target) {
    var newProto;
    if (target) {
        // This method doesn't exist in older browsers (e.g. IE8)
        if ($1e9ef78f0556a404$var$_objGetPrototypeOf) return $1e9ef78f0556a404$var$_objGetPrototypeOf(target);
        var curProto = target[$1e9ef78f0556a404$var$str__Proto] || target[$1e9ef78f0556a404$var$Prototype] || (target[$1e9ef78f0556a404$var$Constructor] ? target[$1e9ef78f0556a404$var$Constructor][$1e9ef78f0556a404$var$Prototype] : null);
        // Using the pre-calculated value as IE8 doesn't support looking up the prototype of a prototype and thus fails for more than 1 base class
        newProto = target[$1e9ef78f0556a404$var$DynProtoBaseProto] || curProto;
        if (!(0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(target, $1e9ef78f0556a404$var$DynProtoBaseProto)) {
            // As this prototype doesn't have this property then this is from an inherited class so newProto is the base to return so save it
            // so we can look it up value (which for a multiple hierarchy dynamicProto will be the base class)
            delete target[$1e9ef78f0556a404$var$DynProtoCurrent]; // Delete any current value allocated to this instance so we pick up the value from prototype hierarchy
            newProto = target[$1e9ef78f0556a404$var$DynProtoBaseProto] = target[$1e9ef78f0556a404$var$DynProtoCurrent] || target[$1e9ef78f0556a404$var$DynProtoBaseProto];
            target[$1e9ef78f0556a404$var$DynProtoCurrent] = curProto;
        }
    }
    return newProto;
}
/**
 * Helper to get the properties of an object, including none enumerable ones as functions on a prototype in ES6
 * are not enumerable.
 * @param target
 */ function $1e9ef78f0556a404$var$_forEachProp(target, func) {
    var props = [];
    if ($1e9ef78f0556a404$var$_objGetOwnProps) props = $1e9ef78f0556a404$var$_objGetOwnProps(target);
    else {
        for(var name_1 in target)if (typeof name_1 === "string" && (0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(target, name_1)) props.push(name_1);
    }
    if (props && props.length > 0) for(var lp = 0; lp < props.length; lp++)func(props[lp]);
}
/**
 * Helper function to check whether the provided function name is a potential candidate for dynamic
 * callback and prototype generation.
 * @param target The target object, may be a prototype or class object
 * @param funcName The function name
 * @param skipOwn Skips the check for own property
 * @ignore
 */ function $1e9ef78f0556a404$var$_isDynamicCandidate(target, funcName, skipOwn) {
    return funcName !== $1e9ef78f0556a404$var$Constructor && typeof target[funcName] === $1e9ef78f0556a404$var$strFunction && (skipOwn || (0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(target, funcName)) && funcName !== $1e9ef78f0556a404$var$str__Proto && funcName !== $1e9ef78f0556a404$var$Prototype;
}
/**
 * Helper to throw a TypeError exception
 * @param message the message
 * @ignore
 */ function $1e9ef78f0556a404$var$_throwTypeError(message) {
    (0, $5831ddb3a0caf7c7$export$3f7738bd7dcba681)("DynamicProto: " + message);
}
/**
 * Returns a collection of the instance functions that are defined directly on the thisTarget object, it does
 * not return any inherited functions
 * @param thisTarget The object to get the instance functions from
 * @ignore
 */ function $1e9ef78f0556a404$var$_getInstanceFuncs(thisTarget) {
    // Get the base proto
    var instFuncs = (0, $5831ddb3a0caf7c7$export$c09f2411a4ae511b)(null);
    // Save any existing instance functions
    $1e9ef78f0556a404$var$_forEachProp(thisTarget, function(name) {
        // Don't include any dynamic prototype instances - as we only want the real functions
        if (!instFuncs[name] && $1e9ef78f0556a404$var$_isDynamicCandidate(thisTarget, name, false)) // Create an instance callback for passing the base function to the caller
        instFuncs[name] = thisTarget[name];
    });
    return instFuncs;
}
/**
 * Returns whether the value is included in the array
 * @param values The array of values
 * @param value  The value
 */ function $1e9ef78f0556a404$var$_hasVisited(values, value) {
    for(var lp = values.length - 1; lp >= 0; lp--){
        if (values[lp] === value) return true;
    }
    return false;
}
/**
 * Returns an object that contains callback functions for all "base/super" functions, this is used to "save"
 * enabling calling super.xxx() functions without requiring that the base "class" has defined a prototype references
 * @param target The current instance
 * @ignore
 */ function $1e9ef78f0556a404$var$_getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
    function _instFuncProxy(target, funcHost, funcName) {
        var theFunc = funcHost[funcName];
        if (theFunc[$1e9ef78f0556a404$var$DynProxyTag] && useBaseInst) {
            // grab and reuse the hosted looking function (if available) otherwise the original passed function
            var instFuncTable = target[$1e9ef78f0556a404$var$DynInstFuncTable] || {};
            if (instFuncTable[$1e9ef78f0556a404$var$DynAllowInstChkTag] !== false) theFunc = (instFuncTable[funcHost[$1e9ef78f0556a404$var$DynClassName]] || {})[funcName] || theFunc;
        }
        return function() {
            // eslint-disable-next-line prefer-rest-params
            return theFunc.apply(target, arguments);
        };
    }
    // Start creating a new baseFuncs by creating proxies for the instance functions (as they may get replaced)
    var baseFuncs = (0, $5831ddb3a0caf7c7$export$c09f2411a4ae511b)(null);
    $1e9ef78f0556a404$var$_forEachProp(instFuncs, function(name) {
        // Create an instance callback for passing the base function to the caller
        baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
    });
    // Get the base prototype functions
    var baseProto = $1e9ef78f0556a404$var$_getObjProto(classProto);
    var visited = [];
    // Don't include base object functions for Object, Array or Function
    while(baseProto && !$1e9ef78f0556a404$var$_isObjectArrayOrFunctionPrototype(baseProto) && !$1e9ef78f0556a404$var$_hasVisited(visited, baseProto)){
        // look for prototype functions
        $1e9ef78f0556a404$var$_forEachProp(baseProto, function(name) {
            // Don't include any dynamic prototype instances - as we only want the real functions
            // For IE 7/8 the prototype lookup doesn't provide the full chain so we need to bypass the 
            // hasOwnProperty check we get all of the methods, main difference is that IE7/8 doesn't return
            // the Object prototype methods while bypassing the check
            if (!baseFuncs[name] && $1e9ef78f0556a404$var$_isDynamicCandidate(baseProto, name, !$1e9ef78f0556a404$var$_objGetPrototypeOf)) // Create an instance callback for passing the base function to the caller
            baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
        });
        // We need to find all possible functions that might be overloaded by walking the entire prototype chain
        // This avoids the caller from needing to check whether it's direct base class implements the function or not
        // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
        visited.push(baseProto);
        baseProto = $1e9ef78f0556a404$var$_getObjProto(baseProto);
    }
    return baseFuncs;
}
function $1e9ef78f0556a404$var$_getInstFunc(target, funcName, proto, currentDynProtoProxy) {
    var instFunc = null;
    // We need to check whether the class name is defined directly on this prototype otherwise
    // it will walk the proto chain and return any parent proto classname.
    if (target && (0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(proto, $1e9ef78f0556a404$var$DynClassName)) {
        var instFuncTable = target[$1e9ef78f0556a404$var$DynInstFuncTable] || (0, $5831ddb3a0caf7c7$export$c09f2411a4ae511b)(null);
        instFunc = (instFuncTable[proto[$1e9ef78f0556a404$var$DynClassName]] || (0, $5831ddb3a0caf7c7$export$c09f2411a4ae511b)(null))[funcName];
        if (!instFunc) // Avoid stack overflow from recursive calling the same function
        $1e9ef78f0556a404$var$_throwTypeError("Missing [" + funcName + "] " + $1e9ef78f0556a404$var$strFunction);
        // We have the instance function, lets check it we can speed up further calls
        // by adding the instance function back directly on the instance (avoiding the dynamic func lookup)
        if (!instFunc[$1e9ef78f0556a404$var$DynInstChkTag] && instFuncTable[$1e9ef78f0556a404$var$DynAllowInstChkTag] !== false) {
            // If the instance already has an instance function we can't replace it
            var canAddInst = !(0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(target, funcName);
            // Get current prototype
            var objProto = $1e9ef78f0556a404$var$_getObjProto(target);
            var visited = [];
            // Lookup the function starting at the top (instance level prototype) and traverse down, if the first matching function
            // if nothing is found or if the first hit is a dynamic proto instance then we can safely add an instance shortcut
            while(canAddInst && objProto && !$1e9ef78f0556a404$var$_isObjectArrayOrFunctionPrototype(objProto) && !$1e9ef78f0556a404$var$_hasVisited(visited, objProto)){
                var protoFunc = objProto[funcName];
                if (protoFunc) {
                    canAddInst = protoFunc === currentDynProtoProxy;
                    break;
                }
                // We need to find all possible initial functions to ensure that we don't bypass a valid override function
                visited.push(objProto);
                objProto = $1e9ef78f0556a404$var$_getObjProto(objProto);
            }
            try {
                if (canAddInst) // This instance doesn't have an instance func and the class hierarchy does have a higher level prototype version
                // so it's safe to directly assign for any subsequent calls (for better performance)
                target[funcName] = instFunc;
                // Block further attempts to set the instance function for any
                instFunc[$1e9ef78f0556a404$var$DynInstChkTag] = 1;
            } catch (e) {
                // Don't crash if the object is readonly or the runtime doesn't allow changing this
                // And set a flag so we don't try again for any function
                instFuncTable[$1e9ef78f0556a404$var$DynAllowInstChkTag] = false;
            }
        }
    }
    return instFunc;
}
function $1e9ef78f0556a404$var$_getProtoFunc(funcName, proto, currentDynProtoProxy) {
    var protoFunc = proto[funcName];
    // Check that the prototype function is not a self reference -- try to avoid stack overflow!
    if (protoFunc === currentDynProtoProxy) // It is so lookup the base prototype
    protoFunc = $1e9ef78f0556a404$var$_getObjProto(proto)[funcName];
    if (typeof protoFunc !== $1e9ef78f0556a404$var$strFunction) $1e9ef78f0556a404$var$_throwTypeError("[" + funcName + "] is not a " + $1e9ef78f0556a404$var$strFunction);
    return protoFunc;
}
/**
 * Add the required dynamic prototype methods to the the class prototype
 * @param proto - The class prototype
 * @param className - The instance classname
 * @param target - The target instance
 * @param baseInstFuncs - The base instance functions
 * @param setInstanceFunc - Flag to allow prototype function to reset the instance function if one does not exist
 * @ignore
 */ function $1e9ef78f0556a404$var$_populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
    function _createDynamicPrototype(proto, funcName) {
        var dynProtoProxy = function() {
            // Use the instance or prototype function
            var instFunc = $1e9ef78f0556a404$var$_getInstFunc(this, funcName, proto, dynProtoProxy) || $1e9ef78f0556a404$var$_getProtoFunc(funcName, proto, dynProtoProxy);
            // eslint-disable-next-line prefer-rest-params
            return instFunc.apply(this, arguments);
        };
        // Tag this function as a proxy to support replacing dynamic proxy elements (primary use case is for unit testing
        // via which can dynamically replace the prototype function reference)
        dynProtoProxy[$1e9ef78f0556a404$var$DynProxyTag] = 1;
        return dynProtoProxy;
    }
    if (!$1e9ef78f0556a404$var$_isObjectOrArrayPrototype(proto)) {
        var instFuncTable = target[$1e9ef78f0556a404$var$DynInstFuncTable] = target[$1e9ef78f0556a404$var$DynInstFuncTable] || (0, $5831ddb3a0caf7c7$export$c09f2411a4ae511b)(null);
        if (!$1e9ef78f0556a404$var$_isObjectOrArrayPrototype(instFuncTable)) {
            var instFuncs_1 = instFuncTable[className] = instFuncTable[className] || (0, $5831ddb3a0caf7c7$export$c09f2411a4ae511b)(null); // fetch and assign if as it may not exist yet
            // Set whether we are allow to lookup instances, if someone has set to false then do not re-enable
            if (instFuncTable[$1e9ef78f0556a404$var$DynAllowInstChkTag] !== false) instFuncTable[$1e9ef78f0556a404$var$DynAllowInstChkTag] = !!setInstanceFunc;
            if (!$1e9ef78f0556a404$var$_isObjectOrArrayPrototype(instFuncs_1)) $1e9ef78f0556a404$var$_forEachProp(target, function(name) {
                // Only add overridden functions
                if ($1e9ef78f0556a404$var$_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
                    // Save the instance Function to the lookup table and remove it from the instance as it's not a dynamic proto function
                    instFuncs_1[name] = target[name];
                    delete target[name];
                    // Add a dynamic proto if one doesn't exist or if a prototype function exists and it's not a dynamic one
                    if (!(0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(proto, name) || proto[name] && !proto[name][$1e9ef78f0556a404$var$DynProxyTag]) proto[name] = _createDynamicPrototype(proto, name);
                }
            });
        }
    }
}
/**
 * Checks whether the passed prototype object appears to be correct by walking the prototype hierarchy of the instance
 * @param classProto The class prototype instance
 * @param thisTarget The current instance that will be checked whether the passed prototype instance is in the hierarchy
 * @ignore
 */ function $1e9ef78f0556a404$var$_checkPrototype(classProto, thisTarget) {
    // This method doesn't existing in older browsers (e.g. IE8)
    if ($1e9ef78f0556a404$var$_objGetPrototypeOf) {
        // As this is primarily a coding time check, don't bother checking if running in IE8 or lower
        var visited = [];
        var thisProto = $1e9ef78f0556a404$var$_getObjProto(thisTarget);
        while(thisProto && !$1e9ef78f0556a404$var$_isObjectArrayOrFunctionPrototype(thisProto) && !$1e9ef78f0556a404$var$_hasVisited(visited, thisProto)){
            if (thisProto === classProto) return true;
            // This avoids the caller from needing to check whether it's direct base class implements the function or not
            // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
            visited.push(thisProto);
            thisProto = $1e9ef78f0556a404$var$_getObjProto(thisProto);
        }
        return false;
    }
    // If objGetPrototypeOf doesn't exist then just assume everything is ok.
    return true;
}
/**
 * Gets the current prototype name using the ES6 name if available otherwise falling back to a use unknown as the name.
 * It's not critical for this to return a name, it's used to decorate the generated unique name for easier debugging only.
 * @param target
 * @param unknownValue
 * @ignore
 */ function $1e9ef78f0556a404$var$_getObjName(target, unknownValue) {
    if ((0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(target, $1e9ef78f0556a404$var$Prototype)) // Look like a prototype
    return target.name || unknownValue || $1e9ef78f0556a404$var$UnknownValue;
    return ((target || {})[$1e9ef78f0556a404$var$Constructor] || {}).name || unknownValue || $1e9ef78f0556a404$var$UnknownValue;
}
function $1e9ef78f0556a404$export$2e2bcd8739ae039(theClass, target, delegateFunc, options) {
    // Make sure that the passed theClass argument looks correct
    if (!(0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(theClass, $1e9ef78f0556a404$var$Prototype)) $1e9ef78f0556a404$var$_throwTypeError("theClass is an invalid class definition.");
    // Quick check to make sure that the passed theClass argument looks correct (this is a common copy/paste error)
    var classProto = theClass[$1e9ef78f0556a404$var$Prototype];
    if (!$1e9ef78f0556a404$var$_checkPrototype(classProto, target)) $1e9ef78f0556a404$var$_throwTypeError("[" + $1e9ef78f0556a404$var$_getObjName(theClass) + "] not in hierarchy of [" + $1e9ef78f0556a404$var$_getObjName(target) + "]");
    var className = null;
    if ((0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(classProto, $1e9ef78f0556a404$var$DynClassName)) // Only grab the class name if it's defined on this prototype (i.e. don't walk the prototype chain)
    className = classProto[$1e9ef78f0556a404$var$DynClassName];
    else {
        // As not all browser support name on the prototype creating a unique dynamic one if we have not already
        // assigned one, so we can use a simple string as the lookup rather than an object for the dynamic instance
        // function table lookup.
        className = $1e9ef78f0556a404$var$DynClassNamePrefix + $1e9ef78f0556a404$var$_getObjName(theClass, "_") + "$" + $1e9ef78f0556a404$var$_gblInst.n;
        $1e9ef78f0556a404$var$_gblInst.n++;
        classProto[$1e9ef78f0556a404$var$DynClassName] = className;
    }
    var perfOptions = $1e9ef78f0556a404$export$2e2bcd8739ae039[$1e9ef78f0556a404$var$DynProtoDefaultOptions];
    var useBaseInst = !!perfOptions[$1e9ef78f0556a404$var$strUseBaseInst];
    if (useBaseInst && options && options[$1e9ef78f0556a404$var$strUseBaseInst] !== undefined) useBaseInst = !!options[$1e9ef78f0556a404$var$strUseBaseInst];
    // Get the current instance functions
    var instFuncs = $1e9ef78f0556a404$var$_getInstanceFuncs(target);
    // Get all of the functions for any base instance (before they are potentially overridden)
    var baseFuncs = $1e9ef78f0556a404$var$_getBaseFuncs(classProto, target, instFuncs, useBaseInst);
    // Execute the delegate passing in both the current target "this" and "base" function references
    // Note casting the same type as we don't actually have the base class here and this will provide some intellisense support
    delegateFunc(target, baseFuncs);
    // Don't allow setting instance functions for older IE instances
    var setInstanceFunc = !!$1e9ef78f0556a404$var$_objGetPrototypeOf && !!perfOptions[$1e9ef78f0556a404$var$strSetInstFuncs];
    if (setInstanceFunc && options) setInstanceFunc = !!options[$1e9ef78f0556a404$var$strSetInstFuncs];
    // Populate the Prototype for any overridden instance functions
    $1e9ef78f0556a404$var$_populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
}
/**
 * Exposes the default global options to allow global configuration, if the global values are disabled these will override
 * any passed values. This is primarily exposed to support unit-testing without the need for individual classes to expose
 * their internal usage of dynamic proto.
 */ $1e9ef78f0556a404$export$2e2bcd8739ae039[$1e9ef78f0556a404$var$DynProtoDefaultOptions] = $1e9ef78f0556a404$var$_gblInst.o;


/*
 * Application Insights JavaScript SDK - Web Analytics, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
* ApplicationInsights.ts
* @copyright Microsoft 2018
*/ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var $042f611b66f4fd6f$export$327014e6dfd5ba11 = "function";
var $042f611b66f4fd6f$export$127e9c2439c2ee16 = "object";
var $042f611b66f4fd6f$export$9b7d2d86cf58b987 = "undefined";
var $042f611b66f4fd6f$export$ecddaaeb55ecf049 = "prototype";
var $042f611b66f4fd6f$export$b39d4edf23d6f14c = "default";
var $042f611b66f4fd6f$export$9ec954dd81c90a5d = Object;
var $042f611b66f4fd6f$export$e77bb59b5e655b3d = $042f611b66f4fd6f$export$9ec954dd81c90a5d[$042f611b66f4fd6f$export$ecddaaeb55ecf049];


var $dc463ff9724142dd$export$3a8d60327f425095 = ((0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)() || {})["Symbol"];
var $dc463ff9724142dd$export$904e7a8ad467688a = ((0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)() || {})["Reflect"];
var $dc463ff9724142dd$export$9f6bdf37c7d86dfe = !!$dc463ff9724142dd$export$904e7a8ad467688a;
var $dc463ff9724142dd$var$strDecorate = "decorate";
var $dc463ff9724142dd$var$strMetadata = "metadata";
var $dc463ff9724142dd$var$strGetOwnPropertySymbols = "getOwnPropertySymbols";
var $dc463ff9724142dd$var$strIterator = "iterator";
var $dc463ff9724142dd$var$strHasOwnProperty = "hasOwnProperty";
var $dc463ff9724142dd$export$64ecba31e1fc6f1e = function(t) {
    // tslint:disable-next-line: ban-comma-operator
    for(var s, i = 1, n = arguments.length; i < n; i++){
        s = arguments[i];
        for(var p in s)if ((0, $042f611b66f4fd6f$export$e77bb59b5e655b3d)[$dc463ff9724142dd$var$strHasOwnProperty].call(s, p)) t[p] = s[p];
    }
    return t;
};
var $dc463ff9724142dd$export$b3cf7a802e578501 = (0, $5831ddb3a0caf7c7$export$afe328edc487dcfe) || $dc463ff9724142dd$export$64ecba31e1fc6f1e;
// tslint:disable-next-line: only-arrow-functions
var $dc463ff9724142dd$var$extendStaticsFn = function(d, b) {
    $dc463ff9724142dd$var$extendStaticsFn = (0, $042f611b66f4fd6f$export$9ec954dd81c90a5d)["setPrototypeOf"] || // tslint:disable-next-line: only-arrow-functions
    ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || // tslint:disable-next-line: only-arrow-functions
    function(d, b) {
        for(var p in b)if (b[$dc463ff9724142dd$var$strHasOwnProperty](p)) d[p] = b[p];
    };
    return $dc463ff9724142dd$var$extendStaticsFn(d, b);
};
function $dc463ff9724142dd$export$1f9c32e3fbfb8e62(d, b) {
    if (typeof b !== (0, $042f611b66f4fd6f$export$327014e6dfd5ba11) && b !== null) (0, $5831ddb3a0caf7c7$export$3f7738bd7dcba681)("Class extends value " + String(b) + " is not a constructor or null");
    $dc463ff9724142dd$var$extendStaticsFn(d, b);
    function __() {
        this.constructor = d;
    }
    // tslint:disable-next-line: ban-comma-operator
    d[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049] = b === null ? (0, $5831ddb3a0caf7c7$export$c09f2411a4ae511b)(b) : (__[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049] = b[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049], new __());
}
function $dc463ff9724142dd$export$b0e1e04064f2edd0(s, e) {
    var t = {};
    for(var k in s)if ((0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(s, k) && e.indexOf(k) < 0) t[k] = s[k];
    if (s != null && typeof (0, $042f611b66f4fd6f$export$9ec954dd81c90a5d)[$dc463ff9724142dd$var$strGetOwnPropertySymbols] === (0, $042f611b66f4fd6f$export$327014e6dfd5ba11)) {
        for(var i = 0, p = (0, $042f611b66f4fd6f$export$9ec954dd81c90a5d)[$dc463ff9724142dd$var$strGetOwnPropertySymbols](s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && (0, $042f611b66f4fd6f$export$e77bb59b5e655b3d)["propertyIsEnumerable"].call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $dc463ff9724142dd$export$1f334cb233663b35(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = (0, $042f611b66f4fd6f$export$9ec954dd81c90a5d)["getOwnPropertyDescriptor"](target, key) : desc, d;
    if ($dc463ff9724142dd$export$9f6bdf37c7d86dfe && typeof $dc463ff9724142dd$export$904e7a8ad467688a[$dc463ff9724142dd$var$strDecorate] === (0, $042f611b66f4fd6f$export$327014e6dfd5ba11)) r = $dc463ff9724142dd$export$904e7a8ad467688a[$dc463ff9724142dd$var$strDecorate](decorators, target, key, desc);
    else {
        for(var i = decorators.length - 1; i >= 0; i--)// eslint-disable-next-line no-cond-assign
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }
    // tslint:disable-next-line:ban-comma-operator
    return c > 3 && r && (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(target, key, r), r;
}
function $dc463ff9724142dd$export$a862c09c17c00454(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $dc463ff9724142dd$export$652131891efe9c32(metadataKey, metadataValue) {
    if ($dc463ff9724142dd$export$9f6bdf37c7d86dfe && $dc463ff9724142dd$export$904e7a8ad467688a[$dc463ff9724142dd$var$strMetadata] === (0, $042f611b66f4fd6f$export$327014e6dfd5ba11)) return $dc463ff9724142dd$export$904e7a8ad467688a[$dc463ff9724142dd$var$strMetadata](metadataKey, metadataValue);
}
function $dc463ff9724142dd$export$11150685fa6930db(m, o) {
    for(var p in m)if (p !== (0, $042f611b66f4fd6f$export$b39d4edf23d6f14c) && !(0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(o, p)) $dc463ff9724142dd$export$1ea27411cf67499d(o, m, p);
}
function $dc463ff9724142dd$export$1ea27411cf67499d(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    if (!!(0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)) (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
    else o[k2] = m[k];
}
function $dc463ff9724142dd$export$19cc45bf4f6ae179(o) {
    var s = typeof $dc463ff9724142dd$export$3a8d60327f425095 === (0, $042f611b66f4fd6f$export$327014e6dfd5ba11) && $dc463ff9724142dd$export$3a8d60327f425095[$dc463ff9724142dd$var$strIterator], m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    (0, $5831ddb3a0caf7c7$export$3f7738bd7dcba681)(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $dc463ff9724142dd$export$18637e2f1e451a15(o, n) {
    var m = typeof $dc463ff9724142dd$export$3a8d60327f425095 === (0, $042f611b66f4fd6f$export$327014e6dfd5ba11) && o[$dc463ff9724142dd$export$3a8d60327f425095[$dc463ff9724142dd$var$strIterator]];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            // tslint:disable-next-line:no-conditional-assignment
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) // eslint-disable-next-line no-unsafe-finally
            throw e.error;
        }
    }
    return ar;
}
function $dc463ff9724142dd$export$e4572e1e87bd3458() {
    var theArgs = arguments;
    // Calculate new total size
    for(var s = 0, i = 0, il = theArgs.length; i < il; i++)s += theArgs[i].length;
    // Create new full array
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = theArgs[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $dc463ff9724142dd$export$643fbb7023bc1942(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
}
function $dc463ff9724142dd$export$b4774f2d9ed4def4(cooked, raw) {
    if (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81) (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $dc463ff9724142dd$export$8f42f3b1d1cb5f6d(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== (0, $042f611b66f4fd6f$export$b39d4edf23d6f14c) && Object.prototype.hasOwnProperty.call(mod, k)) $dc463ff9724142dd$export$1ea27411cf67499d(result, mod, k);
    }
    // Set default module
    if (!!(0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)) (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(result, (0, $042f611b66f4fd6f$export$b39d4edf23d6f14c), {
        enumerable: true,
        value: mod
    });
    else result[0, $042f611b66f4fd6f$export$b39d4edf23d6f14c] = mod;
    return result;
}
function $dc463ff9724142dd$export$b2781524d4888cea(mod) {
    return mod && mod.__esModule ? mod : {
        strDefault: mod
    };
}



/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // Licensed under the
/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $45806013ed348c93$export$e4eaee9e01d9baaa = "toLowerCase"; // Count: 11
var $45806013ed348c93$export$9d71a37f0770d87f = "blkVal"; // Count: 5
var $45806013ed348c93$export$6eae51590aaea43 = "length"; // Count: 55
var $45806013ed348c93$export$9e4bb115c58de388 = "rdOnly"; // Count: 4
var $45806013ed348c93$export$6c2b24c6eee14c46 = "notify"; // Count: 4
var $45806013ed348c93$export$667d3cd09d258d38 = "warnToConsole"; // Count: 4
var $45806013ed348c93$export$6c078c21a0c6c1ce = "throwInternal"; // Count: 5
var $45806013ed348c93$export$24caac6d68ff1537 = "setDf"; // Count: 6
var $45806013ed348c93$export$fc59eec8d77f3766 = "watch"; // Count: 8
var $45806013ed348c93$export$e6a243fe757439f9 = "logger"; // Count: 21
var $45806013ed348c93$export$2f85ca6962b15ff8 = "apply"; // Count: 7
var $45806013ed348c93$export$a0a330e7fa1e278c = "push"; // Count: 35
var $45806013ed348c93$export$84020a2e4fe863b0 = "splice"; // Count: 8
var $45806013ed348c93$export$d17a699c20d379ac = "hdlr"; // Count: 6
var $45806013ed348c93$export$bd01c5e3f12db01c = "cancel"; // Count: 6
var $45806013ed348c93$export$65cd33bb52d04675 = "initialize"; // Count: 5
var $45806013ed348c93$export$f001befbf8417151 = "identifier"; // Count: 8
var $45806013ed348c93$export$fc3403fa6f2894ab = "removeNotificationListener"; // Count: 4
var $45806013ed348c93$export$5c8bcfab4f42ca62 = "addNotificationListener"; // Count: 4
var $45806013ed348c93$export$2e2716e9c35a66a8 = "isInitialized"; // Count: 10
var $45806013ed348c93$export$81cfd43387c8dbcc = "instrumentationKey"; // Count: 2
var $45806013ed348c93$export$9a6b45d6a80c20f2 = "INACTIVE"; // Count: 3
var $45806013ed348c93$export$1805af0fa2230c20 = "value"; // Count: 5
var $45806013ed348c93$export$3a09068de032bb32 = "getNotifyMgr"; // Count: 5
var $45806013ed348c93$export$37717a508eca6e2d = "getPlugin"; // Count: 6
var $45806013ed348c93$export$9734b0a24bf02e93 = "name"; // Count: 12
var $45806013ed348c93$export$3ea6750b8a852044 = "iKey"; // Count: 5
var $45806013ed348c93$export$7b5ba5854159c1f0 = "time"; // Count: 6
var $45806013ed348c93$export$5c220169317cd6de = "processNext"; // Count: 15
var $45806013ed348c93$export$474081342bc4baf4 = "getProcessTelContext"; // Count: 2
var $45806013ed348c93$export$538c138266a38409 = "pollInternalLogs"; // Count: 2
var $45806013ed348c93$export$c9b1609f2b84393a = "enabled"; // Count: 6
var $45806013ed348c93$export$8d1c48dba7ad83a = "stopPollingInternalLogs"; // Count: 2
var $45806013ed348c93$export$7eb85b5cba77a43d = "unload"; // Count: 9
var $45806013ed348c93$export$8693bdba21bfca93 = "onComplete"; // Count: 5
var $45806013ed348c93$export$568c4302d11f2b22 = "version"; // Count: 6
var $45806013ed348c93$export$e53d8cae4d527530 = "loggingLevelConsole"; // Count: 2
var $45806013ed348c93$export$1e6514b499ba4d34 = "createNew"; // Count: 7
var $45806013ed348c93$export$7176fb2a7d11927e = "teardown"; // Count: 9
var $45806013ed348c93$export$2cc5b49df2eed261 = "messageId"; // Count: 4
var $45806013ed348c93$export$923606b70907833e = "message"; // Count: 7
var $45806013ed348c93$export$d8114c9e990204cb = "isAsync"; // Count: 6
var $45806013ed348c93$export$c7ff2c36e5c78421 = "diagLog"; // Count: 10
var $45806013ed348c93$export$458d234b616d0745 = "_doTeardown"; // Count: 5
var $45806013ed348c93$export$c9f4bebf02f459de = "update"; // Count: 6
var $45806013ed348c93$export$36754a48de7fd714 = "getNext"; // Count: 12
var $45806013ed348c93$export$55d672a1dc4d50c1 = "setNextPlugin"; // Count: 5
var $45806013ed348c93$export$c02b5cd14a83c390 = "protocol"; // Count: 3
var $45806013ed348c93$export$2e850152cb3355e2 = "userAgent"; // Count: 5
var $45806013ed348c93$export$b889f1d4cb07c706 = "split"; // Count: 7
var $45806013ed348c93$export$aa192ee35fac3196 = "nodeType"; // Count: 3
var $45806013ed348c93$export$ef9ef3ed86c4485 = "replace"; // Count: 9
var $45806013ed348c93$export$6a3333b2109fff2a = "logInternalMessage"; // Count: 2
var $45806013ed348c93$export$8fdcd26070ec159 = "type"; // Count: 14
var $45806013ed348c93$export$b353fcbe1ae31450 = "handler"; // Count: 5
var $45806013ed348c93$export$f8d169088a01f6f2 = "status"; // Count: 5
var $45806013ed348c93$export$40e88b0417c4d28f = "getResponseHeader"; // Count: 2
var $45806013ed348c93$export$78104a8e57e406f7 = "getAllResponseHeaders"; // Count: 2
var $45806013ed348c93$export$3a89026537e5dfec = "isChildEvt"; // Count: 3
var $45806013ed348c93$export$2f5ff0b46814907e = "data"; // Count: 7
var $45806013ed348c93$export$c405fd80acb80a5b = "getCtx"; // Count: 6
var $45806013ed348c93$export$2ec27a3df8fa4130 = "setCtx"; // Count: 10
var $45806013ed348c93$export$b6736e780b133181 = "complete"; // Count: 3
var $45806013ed348c93$export$746df81af2cb9d94 = "itemsReceived"; // Count: 3
var $45806013ed348c93$export$4babcb0997150ae4 = "urlString"; // Count: 5
var $45806013ed348c93$export$601b401fe94b354 = "sendPOST"; // Count: 3
var $45806013ed348c93$export$829ed22a43b4aada = "headers"; // Count: 5
var $45806013ed348c93$export$4a1d5ee7f477d201 = "timeout"; // Count: 6
var $45806013ed348c93$export$84ecd29f369f5b1d = "setRequestHeader"; // Count: 2
var $45806013ed348c93$export$a5eb52c53bba8560 = "traceId"; // Count: 5
var $45806013ed348c93$export$c105b94efa183847 = "spanId"; // Count: 5
var $45806013ed348c93$export$4e92e4b92b41ba2d = "traceFlags"; // Count: 6
var $45806013ed348c93$export$d66b96c7c1022a2e = "getAttribute"; // Count: 3


/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
var $aa96917b132802ee$export$a43287864529b8fd = undefined;
var $aa96917b132802ee$export$5e8607ab26634759 = "";
var $aa96917b132802ee$export$829012af4b2055a2 = "channels";
var $aa96917b132802ee$export$3094ace9cd82ff99 = "core";
var $aa96917b132802ee$export$1cf3476332da55b3 = "createPerfMgr";
var $aa96917b132802ee$export$49e9417944569ae8 = "disabled";
var $aa96917b132802ee$export$ffb2356587263734 = "extensionConfig";
var $aa96917b132802ee$export$a077ce616a1ab4ee = "extensions";
var $aa96917b132802ee$export$820a3bce4a265606 = "processTelemetry";
var $aa96917b132802ee$export$58efcc07763b37be = "priority";
var $aa96917b132802ee$export$bb3c4bc1b1175d3d = "eventsSent";
var $aa96917b132802ee$export$bacb5b2f4c1081b9 = "eventsDiscarded";
var $aa96917b132802ee$export$d75e063cb88a1c25 = "eventsSendRequest";
var $aa96917b132802ee$export$5d265841733c97c3 = "perfEvent";
var $aa96917b132802ee$export$43f876a058c28ba5 = "offlineEventsStored";
var $aa96917b132802ee$export$ae269b8bbb49e700 = "offlineBatchSent";
var $aa96917b132802ee$export$38d218365ccbd2ec = "offlineBatchDrop";
var $aa96917b132802ee$export$f8b08c7de64edfbf = "getPerfMgr";
var $aa96917b132802ee$export$8f3e5386cefa231e = "domain";
var $aa96917b132802ee$export$bdba10701e0ccff3 = "path";
var $aa96917b132802ee$export$80c7dcdabc53a7db = "Not dynamic - ";


/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



// RESTRICT and AVOID circular dependencies you should not import other contained modules or export the contents of this file directly
// Added to help with minification
var $ede407819d2d28c9$var$strGetPrototypeOf = "getPrototypeOf";
var $ede407819d2d28c9$var$rCamelCase = /-([a-z])/g;
var $ede407819d2d28c9$var$rNormalizeInvalid = /([^\w\d_$])/g;
var $ede407819d2d28c9$var$rLeadingNumeric = /^(\d+[\w\d_$])/;
var $ede407819d2d28c9$export$821e81707b1677f9 = Object[$ede407819d2d28c9$var$strGetPrototypeOf];
function $ede407819d2d28c9$export$e7321bf46d18757f(value) {
    return !(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(value);
}
function $ede407819d2d28c9$export$71fc1ee3e76bc1fe(value) {
    return !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(value);
}
function $ede407819d2d28c9$export$f60443f194e40bc2(name) {
    var value = name;
    if (value && (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(value)) {
        // CamelCase everything after the "-" and remove the dash
        value = value[0, $45806013ed348c93$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ]($ede407819d2d28c9$var$rCamelCase, function(_all, letter) {
            return letter.toUpperCase();
        });
        value = value[0, $45806013ed348c93$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ]($ede407819d2d28c9$var$rNormalizeInvalid, "_");
        value = value[0, $45806013ed348c93$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ]($ede407819d2d28c9$var$rLeadingNumeric, function(_all, match) {
            return "_" + match;
        });
    }
    return value;
}
function $ede407819d2d28c9$export$3185d777c612e61f(value, search) {
    if (value && search) return (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(value, search) !== -1;
    return false;
}
function $ede407819d2d28c9$export$dfaaa8705752128f(date) {
    return date && date.toISOString() || "";
}
var $ede407819d2d28c9$export$7e32b29e1cb162e1 = (0, $5831ddb3a0caf7c7$export$a15782d21797da4c);
function $ede407819d2d28c9$export$39c4487b36c98fec(object) {
    if ((0, $5831ddb3a0caf7c7$export$e6127cc7fe7395c3)(object)) return object[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:%2ename */ ];
    return 0, $aa96917b132802ee$export$5e8607ab26634759;
}
function $ede407819d2d28c9$export$80746c6bc6142fc8(target, field, value, valChk, srcChk) {
    var theValue = value;
    if (target) {
        theValue = target[field];
        if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
            theValue = value;
            target[field] = theValue;
        }
    }
    return theValue;
}
function $ede407819d2d28c9$export$51417ccc212471e(target, field, defValue) {
    var theValue;
    if (target) {
        theValue = target[field];
        if (!theValue && (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(theValue)) {
            // Supports having the default as null
            theValue = !(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(defValue) ? defValue : {};
            target[field] = theValue;
        }
    } else // Expanded for performance so we only check defValue if required
    theValue = !(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(defValue) ? defValue : {};
    return theValue;
}
function $ede407819d2d28c9$var$_createProxyFunction(source, funcName) {
    var srcFunc = null;
    var src = null;
    if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(source)) srcFunc = source;
    else src = source;
    return function() {
        // Capture the original arguments passed to the method
        var originalArguments = arguments;
        if (srcFunc) src = srcFunc();
        if (src) return src[funcName][0, $45806013ed348c93$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](src, originalArguments);
    };
}
function $ede407819d2d28c9$export$21c1f632458708da(target, source, chkSet) {
    if (target && source && (0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(target) && (0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(source)) {
        var _loop_1 = function(field) {
            if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(field)) {
                var value = source[field];
                if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(value)) {
                    if (!chkSet || chkSet(field, true, source, target)) // Create a proxy function rather than just copying the (possible) prototype to the new object as an instance function
                    target[field] = $ede407819d2d28c9$var$_createProxyFunction(source, field);
                } else if (!chkSet || chkSet(field, false, source, target)) {
                    if ((0, $5831ddb3a0caf7c7$export$34e6b98f73578a9c)(target, field)) // Remove any previous instance property
                    delete target[field];
                    (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(target, field, {
                        g: function() {
                            return source[field];
                        },
                        s: function(theValue) {
                            source[field] = theValue;
                        }
                    });
                }
            }
        };
        // effectively apply/proxy full source to the target instance
        for(var field in source)_loop_1(field);
    }
    return target;
}
function $ede407819d2d28c9$export$5dd8d245f6f94a18(target, name, source, theFunc, overwriteTarget) {
    if (target && name && source) {
        if (overwriteTarget !== false || (0, $5831ddb3a0caf7c7$export$fce6876652108ab)(target[name])) target[name] = $ede407819d2d28c9$var$_createProxyFunction(source, theFunc);
    }
}
function $ede407819d2d28c9$export$94f4c7fb7e7d8dc7(target, source, functionsToProxy, overwriteTarget) {
    if (target && source && (0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(target) && (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(functionsToProxy)) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(functionsToProxy, function(theFuncName) {
        if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(theFuncName)) $ede407819d2d28c9$export$5dd8d245f6f94a18(target, theFuncName, source, theFuncName, overwriteTarget);
    });
    return target;
}
function $ede407819d2d28c9$export$f0facb5bce2741f0(defaults) {
    return /** @class */ function() {
        function class_1() {
            var _this = this;
            if (defaults) (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(defaults, function(field, value) {
                _this[field] = value;
            });
        }
        return class_1;
    }();
}
function $ede407819d2d28c9$export$3e03fa3fc3e422d7(theObject) {
    // V8 Optimization to cause the JIT compiler to create a new optimized object for looking up the own properties
    // primarily for object with <= 19 properties for >= 20 the effect is reduced or non-existent
    if (theObject && (0, $5831ddb3a0caf7c7$export$afe328edc487dcfe)) theObject = (0, $042f611b66f4fd6f$export$9ec954dd81c90a5d)((0, $5831ddb3a0caf7c7$export$afe328edc487dcfe)({}, theObject));
    return theObject;
}
function $ede407819d2d28c9$export$a7f7e50f928053df(obj1, obj2, obj3, obj4, obj5, obj6) {
    // Variables
    var theArgs = arguments;
    var extended = theArgs[0] || {};
    var argLen = theArgs[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
    var deep = false;
    var idx = 1;
    // Check for "Deep" flag
    if (argLen > 0 && (0, $5831ddb3a0caf7c7$export$f9ce7b637dfbe238)(extended)) {
        deep = extended;
        extended = theArgs[idx] || {};
        idx++;
    }
    // Handle case when target is a string or something (possible in deep copy)
    if (!(0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(extended)) extended = {};
    // Loop through each remaining object and conduct a merge
    for(; idx < argLen; idx++){
        var arg = theArgs[idx];
        var isArgArray = (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(arg);
        var isArgObj = (0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(arg);
        for(var prop in arg){
            var propOk = isArgArray && prop in arg || isArgObj && (0, $5831ddb3a0caf7c7$export$34e6b98f73578a9c)(arg, prop);
            if (!propOk) continue;
            var newValue = arg[prop];
            var isNewArray = void 0;
            // If deep merge and property is an object, merge properties
            if (deep && newValue && ((isNewArray = (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(newValue)) || (0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(newValue))) {
                // Grab the current value of the extended object
                var clone = extended[prop];
                if (isNewArray) {
                    if (!(0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(clone)) // We can't "merge" an array with a non-array so overwrite the original
                    clone = [];
                } else if (!(0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(clone)) // We can't "merge" an object with a non-object
                clone = {};
                // Never move the original objects always clone them
                newValue = $ede407819d2d28c9$export$a7f7e50f928053df(deep, clone, newValue);
            }
            // Assign the new (or previous) value (unless undefined)
            if (newValue !== undefined) extended[prop] = newValue;
        }
    }
    return extended;
}
var $ede407819d2d28c9$export$590567be997858b6 = (0, $5831ddb3a0caf7c7$export$590567be997858b6);
function $ede407819d2d28c9$export$87e0f7dd6dec932f(feature, cfg) {
    var rlt = false;
    var ft = cfg && cfg.featureOptIn && cfg.featureOptIn[feature];
    if (feature && ft) {
        var mode = ft.mode;
        // NOTE: None will be considered as true
        rlt = mode == 3 /* FeatureOptInMode.enable */  || mode == 1 /* FeatureOptInMode.none */ ;
    }
    return rlt;
}
function $ede407819d2d28c9$export$43a870850da980b4(xhr) {
    try {
        return xhr.responseText;
    } catch (e) {
    // Best effort, as XHR may throw while XDR wont so just ignore
    }
    return null;
}
function $ede407819d2d28c9$export$404d535171315d86(xdr, message) {
    if (xdr) return "XDomainRequest,Response:" + $ede407819d2d28c9$export$43a870850da980b4(xdr);
    return message;
}
function $ede407819d2d28c9$export$f826fdf8bca00592(xhr, message) {
    if (xhr) return "XMLHttpRequest,Status:" + xhr[0, $45806013ed348c93$export$f8d169088a01f6f2 /* @min:%2estatus */ ] + ",Response:" + $ede407819d2d28c9$export$43a870850da980b4(xhr) || xhr.response || "";
    return message;
}
function $ede407819d2d28c9$export$d435c252bc2524f(theTransports, newTransports) {
    if (newTransports) {
        if ((0, $5831ddb3a0caf7c7$export$7e4aa119212bc614)(newTransports)) theTransports = [
            newTransports
        ].concat(theTransports);
        else if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(newTransports)) theTransports = newTransports.concat(theTransports);
    }
    return theTransports;
}
var $ede407819d2d28c9$var$strDisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var $ede407819d2d28c9$var$strWithCredentials = "withCredentials";
var $ede407819d2d28c9$var$strTimeout = "timeout";
function $ede407819d2d28c9$export$b028e759972c6d09(method, urlString, withCredentials, disabled, isSync, timeout) {
    if (disabled === void 0) disabled = false;
    if (isSync === void 0) isSync = false;
    function _wrapSetXhrProp(xhr, prop, value) {
        try {
            xhr[prop] = value;
        } catch (e) {
        // - Wrapping as depending on the environment setting the property may fail (non-terminally)
        }
    }
    var xhr = new XMLHttpRequest();
    if (disabled) // Tag the instance so it's not tracked (trackDependency)
    // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
    // cause the request to fail and we no telemetry would be sent
    _wrapSetXhrProp(xhr, $ede407819d2d28c9$var$strDisabledPropertyName, disabled);
    if (withCredentials) // Some libraries require that the withCredentials flag is set "before" open and
    // - Wrapping as IE 10 has started throwing when setting before open
    _wrapSetXhrProp(xhr, $ede407819d2d28c9$var$strWithCredentials, withCredentials);
    xhr.open(method, urlString, !isSync);
    if (withCredentials) // withCredentials should be set AFTER open (https://xhr.spec.whatwg.org/#the-withcredentials-attribute)
    // And older firefox instances from 11+ will throw for sync events (current versions don't) which happens during unload processing
    _wrapSetXhrProp(xhr, $ede407819d2d28c9$var$strWithCredentials, withCredentials);
    // Only set the timeout for asynchronous requests as
    // "Timeout shouldn't be used for synchronous XMLHttpRequests requests used in a document environment or it will throw an InvalidAccessError exception.""
    // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/timeout
    if (!isSync && timeout) _wrapSetXhrProp(xhr, $ede407819d2d28c9$var$strTimeout, timeout);
    return xhr;
}
function $ede407819d2d28c9$export$cc1b6e60efb8c361(headersString) {
    var headers = {};
    if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(headersString)) {
        var headersArray = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(headersString)[0, $45806013ed348c93$export$b889f1d4cb07c706 /* @min:%2esplit */ ](/[\r\n]+/);
        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(headersArray, function(headerEntry) {
            if (headerEntry) {
                var idx = headerEntry.indexOf(": ");
                if (idx !== -1) {
                    // The new spec has the headers returning all as lowercase -- but not all browsers do this yet
                    var header = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(headerEntry.substring(0, idx))[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
                    var value = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(headerEntry.substring(idx + 1));
                    headers[header] = value;
                } else headers[(0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(headerEntry)] = 1;
            }
        });
    }
    return headers;
}
function $ede407819d2d28c9$export$862e212d6324d005(theHeaders, xhr, name) {
    if (!theHeaders[name] && xhr && xhr[0, $45806013ed348c93$export$40e88b0417c4d28f /* @min:%2egetResponseHeader */ ]) {
        var value = xhr[0, $45806013ed348c93$export$40e88b0417c4d28f /* @min:%2egetResponseHeader */ ](name);
        if (value) theHeaders[name] = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(value);
    }
    return theHeaders;
}
var $ede407819d2d28c9$var$STR_KILL_DURATION_HEADER = "kill-duration";
var $ede407819d2d28c9$var$STR_KILL_DURATION_SECONDS_HEADER = "kill-duration-seconds";
var $ede407819d2d28c9$var$STR_TIME_DELTA_HEADER = "time-delta-millis";
function $ede407819d2d28c9$export$801009daa428ec44(xhr, isOneDs) {
    var theHeaders = {};
    if (!xhr[0, $45806013ed348c93$export$78104a8e57e406f7 /* @min:%2egetAllResponseHeaders */ ]) // Firefox 2-63 doesn't have getAllResponseHeaders function but it does have getResponseHeader
    // Only call these if getAllResponseHeaders doesn't exist, otherwise we can get invalid response errors
    // as collector is not currently returning the correct header to allow JS to access these headers
    {
        if (!!isOneDs) {
            theHeaders = $ede407819d2d28c9$export$862e212d6324d005(theHeaders, xhr, $ede407819d2d28c9$var$STR_TIME_DELTA_HEADER);
            theHeaders = $ede407819d2d28c9$export$862e212d6324d005(theHeaders, xhr, $ede407819d2d28c9$var$STR_KILL_DURATION_HEADER);
            theHeaders = $ede407819d2d28c9$export$862e212d6324d005(theHeaders, xhr, $ede407819d2d28c9$var$STR_KILL_DURATION_SECONDS_HEADER);
        }
    } else theHeaders = $ede407819d2d28c9$export$cc1b6e60efb8c361(xhr[0, $45806013ed348c93$export$78104a8e57e406f7 /* @min:%2egetAllResponseHeaders */ ]());
    return theHeaders;
}



"use strict";
/**
 * This file exists to hold environment utilities that are required to check and
 * validate the current operating environment. Unless otherwise required, please
 * only use defined methods (functions) in this class so that users of these
 * functions/properties only need to include those that are used within their own modules.
 */ var $0d2c2fb24388dcf8$var$strDocumentMode = "documentMode";
var $0d2c2fb24388dcf8$var$strLocation = "location";
var $0d2c2fb24388dcf8$var$strConsole = "console";
var $0d2c2fb24388dcf8$var$strJSON = "JSON";
var $0d2c2fb24388dcf8$var$strCrypto = "crypto";
var $0d2c2fb24388dcf8$var$strMsCrypto = "msCrypto";
var $0d2c2fb24388dcf8$var$strReactNative = "ReactNative";
var $0d2c2fb24388dcf8$var$strMsie = "msie";
var $0d2c2fb24388dcf8$var$strTrident = "trident/";
var $0d2c2fb24388dcf8$var$strXMLHttpRequest = "XMLHttpRequest";
var $0d2c2fb24388dcf8$var$_isTrident = null;
var $0d2c2fb24388dcf8$var$_navUserAgentCheck = null;
var $0d2c2fb24388dcf8$var$_enableMocks = false;
var $0d2c2fb24388dcf8$var$_useXDomainRequest = null;
var $0d2c2fb24388dcf8$var$_beaconsSupported = null;
function $0d2c2fb24388dcf8$var$_hasProperty(theClass, property) {
    var supported = false;
    if (theClass) {
        try {
            supported = property in theClass;
            if (!supported) {
                var proto = theClass[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049];
                if (proto) supported = property in proto;
            }
        } catch (e) {
        // Do Nothing
        }
        if (!supported) try {
            var tmp = new theClass();
            supported = !(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(tmp[property]);
        } catch (e) {
        // Do Nothing
        }
    }
    return supported;
}
function $0d2c2fb24388dcf8$export$6b8934f3c937d22f(enabled) {
    $0d2c2fb24388dcf8$var$_enableMocks = enabled;
}
function $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f(checkForMock) {
    if (checkForMock && $0d2c2fb24388dcf8$var$_enableMocks) {
        var mockLocation = (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)("__mockLocation");
        if (mockLocation) return mockLocation;
    }
    if (typeof location === (0, $042f611b66f4fd6f$export$127e9c2439c2ee16) && location) return location;
    return (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)($0d2c2fb24388dcf8$var$strLocation);
}
function $0d2c2fb24388dcf8$export$bbe488cec1edd401() {
    if (typeof console !== (0, $042f611b66f4fd6f$export$9b7d2d86cf58b987)) return console;
    return (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)($0d2c2fb24388dcf8$var$strConsole);
}
function $0d2c2fb24388dcf8$export$a2856ab6913b9fff() {
    return Boolean(typeof JSON === (0, $042f611b66f4fd6f$export$127e9c2439c2ee16) && JSON || (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)($0d2c2fb24388dcf8$var$strJSON) !== null);
}
function $0d2c2fb24388dcf8$export$d047a7c56db64af4() {
    if ($0d2c2fb24388dcf8$export$a2856ab6913b9fff()) return JSON || (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)($0d2c2fb24388dcf8$var$strJSON);
    return null;
}
function $0d2c2fb24388dcf8$export$e003cc239f955cb6() {
    return (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)($0d2c2fb24388dcf8$var$strCrypto);
}
function $0d2c2fb24388dcf8$export$6bc5093edbd2ea6() {
    return (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)($0d2c2fb24388dcf8$var$strMsCrypto);
}
function $0d2c2fb24388dcf8$export$f7a1e23e542d38e3() {
    // If running in React Native, navigator.product will be populated
    var nav = (0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)();
    if (nav && nav.product) return nav.product === $0d2c2fb24388dcf8$var$strReactNative;
    return false;
}
function $0d2c2fb24388dcf8$export$7e7b1a9668aaed8() {
    var nav = (0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)();
    if (nav && (nav[0, $45806013ed348c93$export$2e850152cb3355e2 /* @min:%2euserAgent */ ] !== $0d2c2fb24388dcf8$var$_navUserAgentCheck || $0d2c2fb24388dcf8$var$_isTrident === null)) {
        // Added to support test mocking of the user agent
        $0d2c2fb24388dcf8$var$_navUserAgentCheck = nav[0, $45806013ed348c93$export$2e850152cb3355e2 /* @min:%2euserAgent */ ];
        var userAgent = ($0d2c2fb24388dcf8$var$_navUserAgentCheck || (0, $aa96917b132802ee$export$5e8607ab26634759))[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
        $0d2c2fb24388dcf8$var$_isTrident = (0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, $0d2c2fb24388dcf8$var$strMsie) || (0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, $0d2c2fb24388dcf8$var$strTrident);
    }
    return $0d2c2fb24388dcf8$var$_isTrident;
}
function $0d2c2fb24388dcf8$export$eb7ff627fa81c42e(userAgentStr) {
    if (userAgentStr === void 0) userAgentStr = null;
    if (!userAgentStr) {
        var navigator_1 = (0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)() || {};
        userAgentStr = navigator_1 ? (navigator_1.userAgent || (0, $aa96917b132802ee$export$5e8607ab26634759))[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]() : (0, $aa96917b132802ee$export$5e8607ab26634759);
    }
    var ua = (userAgentStr || (0, $aa96917b132802ee$export$5e8607ab26634759))[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
    // Also check for documentMode in case X-UA-Compatible meta tag was included in HTML.
    if ((0, $ede407819d2d28c9$export$3185d777c612e61f)(ua, $0d2c2fb24388dcf8$var$strMsie)) {
        var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)() || {};
        return Math.max(parseInt(ua[0, $45806013ed348c93$export$b889f1d4cb07c706 /* @min:%2esplit */ ]($0d2c2fb24388dcf8$var$strMsie)[1]), doc[$0d2c2fb24388dcf8$var$strDocumentMode] || 0);
    } else if ((0, $ede407819d2d28c9$export$3185d777c612e61f)(ua, $0d2c2fb24388dcf8$var$strTrident)) {
        var tridentVer = parseInt(ua[0, $45806013ed348c93$export$b889f1d4cb07c706 /* @min:%2esplit */ ]($0d2c2fb24388dcf8$var$strTrident)[1]);
        if (tridentVer) return tridentVer + 4;
    }
    return null;
}
function $0d2c2fb24388dcf8$export$95df08bae54cb4df(userAgentStr) {
    if (!userAgentStr || !(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(userAgentStr)) {
        var navigator_2 = (0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)() || {};
        userAgentStr = navigator_2 ? (navigator_2.userAgent || (0, $aa96917b132802ee$export$5e8607ab26634759))[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]() : (0, $aa96917b132802ee$export$5e8607ab26634759);
    }
    var ua = (userAgentStr || (0, $aa96917b132802ee$export$5e8607ab26634759))[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
    return (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(ua, "safari") >= 0;
}
function $0d2c2fb24388dcf8$export$cf496c79c05967a0(useCached) {
    if ($0d2c2fb24388dcf8$var$_beaconsSupported === null || useCached === false) $0d2c2fb24388dcf8$var$_beaconsSupported = (0, $5831ddb3a0caf7c7$export$bd82d106260417bf)() && Boolean((0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)().sendBeacon);
    return $0d2c2fb24388dcf8$var$_beaconsSupported;
}
function $0d2c2fb24388dcf8$export$f8c1c61350d9749(withKeepAlive) {
    var isSupported = false;
    try {
        isSupported = !!(0, $5831ddb3a0caf7c7$export$3df6e51375017edd)("fetch");
        var request = (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)("Request");
        if (isSupported && withKeepAlive && request) isSupported = $0d2c2fb24388dcf8$var$_hasProperty(request, "keepalive");
    } catch (e) {
    // Just Swallow any failure during availability checks
    }
    return isSupported;
}
function $0d2c2fb24388dcf8$export$b9f2bc09e5ac0fa5() {
    if ($0d2c2fb24388dcf8$var$_useXDomainRequest === null) {
        $0d2c2fb24388dcf8$var$_useXDomainRequest = typeof XDomainRequest !== (0, $042f611b66f4fd6f$export$9b7d2d86cf58b987);
        if ($0d2c2fb24388dcf8$var$_useXDomainRequest && $0d2c2fb24388dcf8$export$cfeac9aa070f0108()) $0d2c2fb24388dcf8$var$_useXDomainRequest = $0d2c2fb24388dcf8$var$_useXDomainRequest && !$0d2c2fb24388dcf8$var$_hasProperty((0, $5831ddb3a0caf7c7$export$3df6e51375017edd)($0d2c2fb24388dcf8$var$strXMLHttpRequest), "withCredentials");
    }
    return $0d2c2fb24388dcf8$var$_useXDomainRequest;
}
function $0d2c2fb24388dcf8$export$cfeac9aa070f0108() {
    var isSupported = false;
    try {
        var xmlHttpRequest = (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)($0d2c2fb24388dcf8$var$strXMLHttpRequest);
        isSupported = !!xmlHttpRequest;
    } catch (e) {
    // Just Swallow any failure during availability checks
    }
    return isSupported;
}
function $0d2c2fb24388dcf8$var$_getNamedValue(values, name) {
    if (values) for(var i = 0; i < values[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
        var value = values[i];
        if (value[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:%2ename */ ]) {
            if (value[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:%2ename */ ] === name) return value;
        }
    }
    return {};
}
function $0d2c2fb24388dcf8$export$cdb9869d6805c74f(name) {
    var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
    if (doc && name) // Look for a meta-tag
    return $0d2c2fb24388dcf8$var$_getNamedValue(doc.querySelectorAll("meta"), name).content;
    return null;
}
function $0d2c2fb24388dcf8$export$a25efeeb107534e6(name) {
    var value;
    var perf = (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)();
    if (perf) {
        // Try looking for a server-timing header
        var navPerf = perf.getEntriesByType("navigation") || [];
        value = $0d2c2fb24388dcf8$var$_getNamedValue((navPerf[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0 ? navPerf[0] : {}).serverTiming, name).description;
    }
    return value;
}
function $0d2c2fb24388dcf8$export$716a11175c03fb4e(target, evnt) {
    if (target && target.dispatchEvent && evnt) {
        target.dispatchEvent(evnt);
        return true;
    }
    return false;
}
function $0d2c2fb24388dcf8$export$8e16c003644f99f2(eventName, details) {
    var event = null;
    var detail = {
        detail: details || null
    };
    if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(CustomEvent)) event = new CustomEvent(eventName, detail);
    else {
        var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
        if (doc && doc.createEvent) {
            event = doc.createEvent("CustomEvent");
            event.initCustomEvent(eventName, true, true, detail);
        }
    }
    return event;
}
function $0d2c2fb24388dcf8$export$af531f0ca2964c96(evtName, cfg, customDetails) {
    var global = (0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)();
    if (global && global.CustomEvent) try {
        var details = {
            cfg: cfg || null,
            customDetails: customDetails || null
        };
        return $0d2c2fb24388dcf8$export$716a11175c03fb4e(global, $0d2c2fb24388dcf8$export$8e16c003644f99f2(evtName, details));
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
    return false;
}



var $dfdef4661b59546e$var$UInt32Mask = 0x100000000;
var $dfdef4661b59546e$var$MaxUInt32 = 0xffffffff;
var $dfdef4661b59546e$var$SEED1 = 123456789;
var $dfdef4661b59546e$var$SEED2 = 987654321;
// MWC based Random generator (for IE)
var $dfdef4661b59546e$var$_mwcSeeded = false;
var $dfdef4661b59546e$var$_mwcW = $dfdef4661b59546e$var$SEED1;
var $dfdef4661b59546e$var$_mwcZ = $dfdef4661b59546e$var$SEED2;
// Takes any integer
function $dfdef4661b59546e$var$_mwcSeed(seedValue) {
    if (seedValue < 0) // Make sure we end up with a positive number and not -ve one.
    seedValue >>>= 0;
    $dfdef4661b59546e$var$_mwcW = $dfdef4661b59546e$var$SEED1 + seedValue & $dfdef4661b59546e$var$MaxUInt32;
    $dfdef4661b59546e$var$_mwcZ = $dfdef4661b59546e$var$SEED2 - seedValue & $dfdef4661b59546e$var$MaxUInt32;
    $dfdef4661b59546e$var$_mwcSeeded = true;
}
function $dfdef4661b59546e$var$_autoSeedMwc() {
    // Simple initialization using default Math.random() - So we inherit any entropy from the browser
    // and bitwise XOR with the current milliseconds
    try {
        var now = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)() & 0x7fffffff;
        $dfdef4661b59546e$var$_mwcSeed((Math.random() * $dfdef4661b59546e$var$UInt32Mask ^ now) + now);
    } catch (e) {
    // Don't crash if something goes wrong
    }
}
function $dfdef4661b59546e$export$b2cfcb5c32671fa4(maxValue) {
    if (maxValue > 0) return Math.floor($dfdef4661b59546e$export$aec042b223b6f5f9() / $dfdef4661b59546e$var$MaxUInt32 * (maxValue + 1)) >>> 0;
    return 0;
}
function $dfdef4661b59546e$export$aec042b223b6f5f9(signed) {
    var value = 0;
    var c = (0, $0d2c2fb24388dcf8$export$e003cc239f955cb6)() || (0, $0d2c2fb24388dcf8$export$6bc5093edbd2ea6)();
    if (c && c.getRandomValues) // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
    value = c.getRandomValues(new Uint32Array(1))[0] & $dfdef4661b59546e$var$MaxUInt32;
    if (value === 0 && (0, $0d2c2fb24388dcf8$export$7e7b1a9668aaed8)()) {
        // For IE 6, 7, 8 (especially on XP) Math.random is not very random
        if (!$dfdef4661b59546e$var$_mwcSeeded) // Set the seed for the Mwc algorithm
        $dfdef4661b59546e$var$_autoSeedMwc();
        // Don't use Math.random for IE
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = $dfdef4661b59546e$export$3ffb74f7babdd68f() & $dfdef4661b59546e$var$MaxUInt32;
    }
    if (value === 0) // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
    value = Math.floor($dfdef4661b59546e$var$UInt32Mask * Math.random() | 0);
    if (!signed) // Make sure we end up with a positive number and not -ve one.
    value >>>= 0;
    return value;
}
function $dfdef4661b59546e$export$195aff7adbfe974f(value) {
    if (!value) $dfdef4661b59546e$var$_autoSeedMwc();
    else $dfdef4661b59546e$var$_mwcSeed(value);
}
function $dfdef4661b59546e$export$3ffb74f7babdd68f(signed) {
    $dfdef4661b59546e$var$_mwcZ = 36969 * ($dfdef4661b59546e$var$_mwcZ & 0xFFFF) + ($dfdef4661b59546e$var$_mwcZ >> 16) & $dfdef4661b59546e$var$MaxUInt32;
    $dfdef4661b59546e$var$_mwcW = 18000 * ($dfdef4661b59546e$var$_mwcW & 0xFFFF) + ($dfdef4661b59546e$var$_mwcW >> 16) & $dfdef4661b59546e$var$MaxUInt32;
    var value = ($dfdef4661b59546e$var$_mwcZ << 16) + ($dfdef4661b59546e$var$_mwcW & 0xFFFF) >>> 0 & $dfdef4661b59546e$var$MaxUInt32 | 0;
    if (!signed) // Make sure we end up with a positive number and not -ve one.
    value >>>= 0;
    return value;
}
function $dfdef4661b59546e$export$9ffd10a3fbdc175b(maxLength) {
    if (maxLength === void 0) maxLength = 22;
    var base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Start with an initial random number, consuming the value in reverse byte order
    var number = $dfdef4661b59546e$export$aec042b223b6f5f9() >>> 0; // Make sure it's a +ve number
    var chars = 0;
    var result = (0, $aa96917b132802ee$export$5e8607ab26634759);
    while(result[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] < maxLength){
        chars++;
        result += base64chars.charAt(number & 0x3F);
        number >>>= 6; // Zero fill with right shift
        if (chars === 5) {
            // 5 base64 characters === 30 bits so we don't have enough bits for another base64 char
            // So add on another 30 bits and make sure it's +ve
            number = ($dfdef4661b59546e$export$aec042b223b6f5f9() << 2 & 0xFFFFFFFF | number & 0x03) >>> 0;
            chars = 0; // We need to reset the number every 5 chars (30 bits)
        }
    }
    return result;
}


"use strict";
var $61bcf5b470259c00$export$3bac393b8225adab = (0, $042f611b66f4fd6f$export$9b7d2d86cf58b987);
function $61bcf5b470259c00$export$665eeb3ced5fba0b() {
    var uuid = $61bcf5b470259c00$export$58d1fad45f39d957();
    return (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(uuid, 0, 8) + "-" + (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(uuid, 8, 12) + "-" + (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(uuid, 12, 16) + "-" + (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(uuid, 16, 20) + "-" + (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(uuid, 20);
}
function $61bcf5b470259c00$export$5222b9460f3ddbec(value, search) {
    if (value && search) {
        var len = value[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
        var start = len - search[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
        return (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(value, start >= 0 ? start : 0, len) === search;
    }
    return false;
}
function $61bcf5b470259c00$export$58d1fad45f39d957() {
    var hexValues = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f"
    ];
    // rfc4122 version 4 UUID without dashes and with lowercase letters
    var oct = (0, $aa96917b132802ee$export$5e8607ab26634759), tmp;
    for(var a = 0; a < 4; a++){
        tmp = (0, $dfdef4661b59546e$export$aec042b223b6f5f9)();
        oct += hexValues[tmp & 0xF] + hexValues[tmp >> 4 & 0xF] + hexValues[tmp >> 8 & 0xF] + hexValues[tmp >> 12 & 0xF] + hexValues[tmp >> 16 & 0xF] + hexValues[tmp >> 20 & 0xF] + hexValues[tmp >> 24 & 0xF] + hexValues[tmp >> 28 & 0xF];
    }
    // "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
    var clockSequenceHi = hexValues[8 + ((0, $dfdef4661b59546e$export$aec042b223b6f5f9)() & 0x03) | 0];
    return (0, $5831ddb3a0caf7c7$export$25b2a9bb66b0078d)(oct, 0, 8) + (0, $5831ddb3a0caf7c7$export$25b2a9bb66b0078d)(oct, 9, 4) + "4" + (0, $5831ddb3a0caf7c7$export$25b2a9bb66b0078d)(oct, 13, 3) + clockSequenceHi + (0, $5831ddb3a0caf7c7$export$25b2a9bb66b0078d)(oct, 16, 3) + (0, $5831ddb3a0caf7c7$export$25b2a9bb66b0078d)(oct, 19, 12);
}




// using {0,16} for leading and trailing whitespace just to constrain the possible runtime of a random string
var $4726195e2d737947$var$TRACE_PARENT_REGEX = /^([\da-f]{2})-([\da-f]{32})-([\da-f]{16})-([\da-f]{2})(-[^\s]{1,64})?$/i;
var $4726195e2d737947$var$DEFAULT_VERSION = "00";
var $4726195e2d737947$var$INVALID_VERSION = "ff";
var $4726195e2d737947$var$INVALID_TRACE_ID = "00000000000000000000000000000000";
var $4726195e2d737947$var$INVALID_SPAN_ID = "0000000000000000";
var $4726195e2d737947$var$SAMPLED_FLAG = 0x01;
function $4726195e2d737947$var$_isValid(value, len, invalidValue) {
    if (value && value[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] === len && value !== invalidValue) return !!value.match(/^[\da-f]*$/i);
    return false;
}
function $4726195e2d737947$var$_formatValue(value, len, defValue) {
    if ($4726195e2d737947$var$_isValid(value, len)) return value;
    return defValue;
}
function $4726195e2d737947$var$_formatFlags(value) {
    if (isNaN(value) || value < 0 || value > 255) value = 0x01;
    var result = value.toString(16);
    while(result[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] < 2)result = "0" + result;
    return result;
}
function $4726195e2d737947$export$2f21fe23413fe96b(traceId, spanId, flags, version) {
    var _a;
    return _a = {}, _a[0, $45806013ed348c93$export$568c4302d11f2b22 /* @min:version */ ] = $4726195e2d737947$var$_isValid(version, 2, $4726195e2d737947$var$INVALID_VERSION) ? version : $4726195e2d737947$var$DEFAULT_VERSION, _a[0, $45806013ed348c93$export$a5eb52c53bba8560 /* @min:traceId */ ] = $4726195e2d737947$export$29dd34cf1269f6da(traceId) ? traceId : (0, $61bcf5b470259c00$export$58d1fad45f39d957)(), _a[0, $45806013ed348c93$export$c105b94efa183847 /* @min:spanId */ ] = $4726195e2d737947$export$8e51c6d8f0586aff(spanId) ? spanId : (0, $5831ddb3a0caf7c7$export$a1120f14ec6f7ada)((0, $61bcf5b470259c00$export$58d1fad45f39d957)(), 16), _a.traceFlags = flags >= 0 && flags <= 0xFF ? flags : 1, _a;
}
function $4726195e2d737947$export$f4d87f8901a93f5d(value, selectIdx) {
    var _a;
    if (!value) // Don't pass a null/undefined or empty string
    return null;
    if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(value)) // The value may have been encoded on the page into an array so handle this automatically
    value = value[0] || "";
    if (!value || !(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(value) || value[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 8192) // limit potential processing based on total length
    return null;
    if (value.indexOf(",") !== -1) {
        var values = value[0, $45806013ed348c93$export$b889f1d4cb07c706 /* @min:%2esplit */ ](",");
        value = values[selectIdx > 0 && values[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > selectIdx ? selectIdx : 0];
    }
    // See https://www.w3.org/TR/trace-context/#versioning-of-traceparent
    var match = $4726195e2d737947$var$TRACE_PARENT_REGEX.exec((0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(value));
    if (!match || // No match
    match[1] === $4726195e2d737947$var$INVALID_VERSION || // version ff is forbidden
    match[2] === $4726195e2d737947$var$INVALID_TRACE_ID || // All zeros is considered to be invalid
    match[3] === $4726195e2d737947$var$INVALID_SPAN_ID) return null;
    return _a = {
        version: (match[1] || (0, $aa96917b132802ee$export$5e8607ab26634759))[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ](),
        traceId: (match[2] || (0, $aa96917b132802ee$export$5e8607ab26634759))[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ](),
        spanId: (match[3] || (0, $aa96917b132802ee$export$5e8607ab26634759))[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]()
    }, _a[0, $45806013ed348c93$export$4e92e4b92b41ba2d /* @min:traceFlags */ ] = parseInt(match[4], 16), _a;
}
function $4726195e2d737947$export$29dd34cf1269f6da(value) {
    return $4726195e2d737947$var$_isValid(value, 32, $4726195e2d737947$var$INVALID_TRACE_ID);
}
function $4726195e2d737947$export$8e51c6d8f0586aff(value) {
    return $4726195e2d737947$var$_isValid(value, 16, $4726195e2d737947$var$INVALID_SPAN_ID);
}
function $4726195e2d737947$export$a210ed246a03bbf(value) {
    if (!value || !$4726195e2d737947$var$_isValid(value[0, $45806013ed348c93$export$568c4302d11f2b22 /* @min:%2eversion */ ], 2, $4726195e2d737947$var$INVALID_VERSION) || !$4726195e2d737947$var$_isValid(value[0, $45806013ed348c93$export$a5eb52c53bba8560 /* @min:%2etraceId */ ], 32, $4726195e2d737947$var$INVALID_TRACE_ID) || !$4726195e2d737947$var$_isValid(value[0, $45806013ed348c93$export$c105b94efa183847 /* @min:%2espanId */ ], 16, $4726195e2d737947$var$INVALID_SPAN_ID) || !$4726195e2d737947$var$_isValid($4726195e2d737947$var$_formatFlags(value[0, $45806013ed348c93$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ]), 2)) // Each known field must contain a valid value
    return false;
    return true;
}
function $4726195e2d737947$export$8577d514cd55191e(value) {
    if ($4726195e2d737947$export$a210ed246a03bbf(value)) return (value[0, $45806013ed348c93$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] & $4726195e2d737947$var$SAMPLED_FLAG) === $4726195e2d737947$var$SAMPLED_FLAG;
    return false;
}
function $4726195e2d737947$export$55f8c39d2c902d0d(value) {
    if (value) {
        // Special Note: This only supports formatting as version 00, future versions should encode any known supported version
        // So parsing a future version will populate the correct version value but reformatting will reduce it to version 00.
        var flags = $4726195e2d737947$var$_formatFlags(value[0, $45806013ed348c93$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ]);
        if (!$4726195e2d737947$var$_isValid(flags, 2)) flags = "01";
        var version = value[0, $45806013ed348c93$export$568c4302d11f2b22 /* @min:%2eversion */ ] || $4726195e2d737947$var$DEFAULT_VERSION;
        if (version !== "00" && version !== "ff") // Reduce version to "00"
        version = $4726195e2d737947$var$DEFAULT_VERSION;
        // Format as version 00
        return "".concat(version.toLowerCase(), "-").concat($4726195e2d737947$var$_formatValue(value.traceId, 32, $4726195e2d737947$var$INVALID_TRACE_ID).toLowerCase(), "-").concat($4726195e2d737947$var$_formatValue(value.spanId, 16, $4726195e2d737947$var$INVALID_SPAN_ID).toLowerCase(), "-").concat(flags.toLowerCase());
    }
    return "";
}
function $4726195e2d737947$export$2a00dfdbe257ef74(selectIdx) {
    var name = "traceparent";
    var traceParent = $4726195e2d737947$export$f4d87f8901a93f5d((0, $0d2c2fb24388dcf8$export$cdb9869d6805c74f)(name), selectIdx);
    if (!traceParent) traceParent = $4726195e2d737947$export$f4d87f8901a93f5d((0, $0d2c2fb24388dcf8$export$a25efeeb107534e6)(name), selectIdx);
    return traceParent;
}
function $4726195e2d737947$export$1329d5a456df56f(doc) {
    var scripts = doc.getElementsByTagName("script");
    var result = [];
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(scripts, function(script) {
        var src = script[0, $45806013ed348c93$export$d66b96c7c1022a2e /* @min:%2egetAttribute */ ]("src");
        if (src) {
            var crossOrigin = script[0, $45806013ed348c93$export$d66b96c7c1022a2e /* @min:%2egetAttribute */ ]("crossorigin");
            var async = script.hasAttribute("async") === true;
            var defer = script.hasAttribute("defer") === true;
            var referrerPolicy = script[0, $45806013ed348c93$export$d66b96c7c1022a2e /* @min:%2egetAttribute */ ]("referrerpolicy");
            var info = {
                url: src
            };
            if (crossOrigin) info.crossOrigin = crossOrigin;
            if (async) info.async = async;
            if (defer) info.defer = defer;
            if (referrerPolicy) info.referrerPolicy = referrerPolicy;
            result[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](info);
        }
    });
    return result;
}



/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
 * This is an internal property used to cause internal (reporting) requests to be ignored from reporting
 * additional telemetry, to handle polyfil implementations ALL urls used with a disabled request will
 * also be ignored for future requests even when this property is not provided.
 * Tagging as Ignore as this is an internal value and is not expected to be used outside of the SDK
 * @ignore
 */ var $8ac3b4fe9182f568$export$7c6abff2f2bdd9c0 = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var $8ac3b4fe9182f568$export$dc288b6444e20c04 = "sampleRate";
var $8ac3b4fe9182f568$export$ea8a69bf327def66 = "ProcessLegacy";
var $8ac3b4fe9182f568$export$8343e6f32f5246de = "http.method";
var $8ac3b4fe9182f568$export$5c9ec0fce655ebcf = "https://dc.services.visualstudio.com";
var $8ac3b4fe9182f568$export$e6c0f3431c6cd728 = "/v2/track";
var $8ac3b4fe9182f568$export$4003f5e1672d759 = "not_specified";
var $8ac3b4fe9182f568$export$7d566319b90dbb26 = "iKey";


/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $b49c449a24f657f6$export$fd52abd0b2703048 = (0, $5831ddb3a0caf7c7$export$37b2eedf6b7b231a);
var $b49c449a24f657f6$export$8980fe7abaa99712 = (0, $5831ddb3a0caf7c7$export$a6025b6424227e7e);


var $921552b7fb658c3b$export$e499e02a1fe05177 = (0, $b49c449a24f657f6$export$8980fe7abaa99712)({
    requestContextHeader: [
        0 /* eRequestHeaders.requestContextHeader */ ,
        "Request-Context"
    ],
    requestContextTargetKey: [
        1 /* eRequestHeaders.requestContextTargetKey */ ,
        "appId"
    ],
    requestContextAppIdFormat: [
        2 /* eRequestHeaders.requestContextAppIdFormat */ ,
        "appId=cid-v1:"
    ],
    requestIdHeader: [
        3 /* eRequestHeaders.requestIdHeader */ ,
        "Request-Id"
    ],
    traceParentHeader: [
        4 /* eRequestHeaders.traceParentHeader */ ,
        "traceparent"
    ],
    traceStateHeader: [
        5 /* eRequestHeaders.traceStateHeader */ ,
        "tracestate"
    ],
    sdkContextHeader: [
        6 /* eRequestHeaders.sdkContextHeader */ ,
        "Sdk-Context"
    ],
    sdkContextHeaderAppIdRequest: [
        7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */ ,
        "appId"
    ],
    requestContextHeaderLowerCase: [
        8 /* eRequestHeaders.requestContextHeaderLowerCase */ ,
        "request-context"
    ]
});


/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




var $0e058b881c0798ff$var$version = "3.3.3";
var $0e058b881c0798ff$var$instanceName = "." + (0, $dfdef4661b59546e$export$9ffd10a3fbdc175b)(6);
var $0e058b881c0798ff$var$_dataUid = 0;
// Accepts only:
//  - Node
//    - Node.ELEMENT_NODE
//    - Node.DOCUMENT_NODE
//  - Object
//    - Any
function $0e058b881c0798ff$var$_canAcceptData(target) {
    return target[0, $45806013ed348c93$export$aa192ee35fac3196 /* @min:%2enodeType */ ] === 1 || target[0, $45806013ed348c93$export$aa192ee35fac3196 /* @min:%2enodeType */ ] === 9 || !+target[0, $45806013ed348c93$export$aa192ee35fac3196 /* @min:%2enodeType */ ];
}
function $0e058b881c0798ff$var$_getCache(data, target) {
    var theCache = target[data.id];
    if (!theCache) {
        theCache = {};
        try {
            if ($0e058b881c0798ff$var$_canAcceptData(target)) (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(target, data.id, {
                e: false,
                v: theCache
            });
        } catch (e) {
        // Not all environments allow extending all objects, so just ignore the cache in those cases
        }
    }
    return theCache;
}
function $0e058b881c0798ff$export$eb4a6badb18ead04(name, includeVersion) {
    if (includeVersion === void 0) includeVersion = false;
    return (0, $ede407819d2d28c9$export$f60443f194e40bc2)(name + $0e058b881c0798ff$var$_dataUid++ + (includeVersion ? "." + $0e058b881c0798ff$var$version : (0, $aa96917b132802ee$export$5e8607ab26634759)) + $0e058b881c0798ff$var$instanceName);
}
function $0e058b881c0798ff$export$b95c3438408d78aa(name) {
    var data = {
        id: $0e058b881c0798ff$export$eb4a6badb18ead04("_aiData-" + (name || (0, $aa96917b132802ee$export$5e8607ab26634759)) + "." + $0e058b881c0798ff$var$version),
        accept: function(target) {
            return $0e058b881c0798ff$var$_canAcceptData(target);
        },
        get: function(target, name, defValue, addDefault) {
            var theCache = target[data.id];
            if (!theCache) {
                if (addDefault) {
                    // Side effect is adds the cache
                    theCache = $0e058b881c0798ff$var$_getCache(data, target);
                    theCache[(0, $ede407819d2d28c9$export$f60443f194e40bc2)(name)] = defValue;
                }
                return defValue;
            }
            return theCache[(0, $ede407819d2d28c9$export$f60443f194e40bc2)(name)];
        },
        kill: function(target, name) {
            if (target && target[name]) try {
                delete target[name];
            } catch (e) {
            // Just cleaning up, so if this fails -- ignore
            }
        }
    };
    return data;
}




/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

function $2858d2db0bf490e5$var$_isConfigDefaults(value) {
    return value && (0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(value) && (value.isVal || value.fb || (0, $5831ddb3a0caf7c7$export$34e6b98f73578a9c)(value, "v") || (0, $5831ddb3a0caf7c7$export$34e6b98f73578a9c)(value, "mrg") || (0, $5831ddb3a0caf7c7$export$34e6b98f73578a9c)(value, "ref") || value.set);
}
function $2858d2db0bf490e5$var$_getDefault(dynamicHandler, theConfig, cfgDefaults) {
    var defValue;
    var isDefaultValid = cfgDefaults.dfVal || (0, $5831ddb3a0caf7c7$export$4e62c701997796c1);
    // There is a fallback config key so try and grab that first
    if (theConfig && cfgDefaults.fb) {
        var fallbacks = cfgDefaults.fb;
        if (!(0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(fallbacks)) fallbacks = [
            fallbacks
        ];
        for(var lp = 0; lp < fallbacks[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++){
            var fallback = fallbacks[lp];
            var fbValue = theConfig[fallback];
            if (isDefaultValid(fbValue)) defValue = fbValue;
            else if (dynamicHandler) {
                // Needed to ensure that the fallback value (and potentially) new field is also dynamic even if null/undefined
                fbValue = dynamicHandler.cfg[fallback];
                if (isDefaultValid(fbValue)) defValue = fbValue;
                // Needed to ensure that the fallback value (and potentially) new field is also dynamic even if null/undefined
                dynamicHandler.set(dynamicHandler.cfg, (0, $5831ddb3a0caf7c7$export$590567be997858b6)(fallback), fbValue);
            }
            if (isDefaultValid(defValue)) break;
        }
    }
    // If the value is still not defined and we have a default value then use that
    if (!isDefaultValid(defValue) && isDefaultValid(cfgDefaults.v)) defValue = cfgDefaults.v;
    return defValue;
}
/**
 * Recursively resolve the default value
 * @param dynamicHandler
 * @param theConfig
 * @param cfgDefaults
 * @returns
 */ function $2858d2db0bf490e5$var$_resolveDefaultValue(dynamicHandler, theConfig, cfgDefaults) {
    var theValue = cfgDefaults;
    if (cfgDefaults && $2858d2db0bf490e5$var$_isConfigDefaults(cfgDefaults)) theValue = $2858d2db0bf490e5$var$_getDefault(dynamicHandler, theConfig, cfgDefaults);
    if (theValue) {
        if ($2858d2db0bf490e5$var$_isConfigDefaults(theValue)) theValue = $2858d2db0bf490e5$var$_resolveDefaultValue(dynamicHandler, theConfig, theValue);
        var newValue_1;
        if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(theValue)) {
            newValue_1 = [];
            newValue_1[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] = theValue[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
        } else if ((0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(theValue)) newValue_1 = {};
        if (newValue_1) {
            (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(theValue, function(key, value) {
                if (value && $2858d2db0bf490e5$var$_isConfigDefaults(value)) value = $2858d2db0bf490e5$var$_resolveDefaultValue(dynamicHandler, theConfig, value);
                newValue_1[key] = value;
            });
            theValue = newValue_1;
        }
    }
    return theValue;
}
function $2858d2db0bf490e5$export$f11b7d3a4617b9e9(dynamicHandler, theConfig, name, defaultValue) {
    // Resolve the initial config value from the provided value or use the defined default
    var isValid;
    var setFn;
    var defValue;
    var cfgDefaults = defaultValue;
    var mergeDf;
    var reference;
    var readOnly;
    var blkDynamicValue;
    if ($2858d2db0bf490e5$var$_isConfigDefaults(cfgDefaults)) {
        // looks like a IConfigDefault
        isValid = cfgDefaults.isVal;
        setFn = cfgDefaults.set;
        readOnly = cfgDefaults[0, $45806013ed348c93$export$9e4bb115c58de388 /* @min:%2erdOnly */ ];
        blkDynamicValue = cfgDefaults[0, $45806013ed348c93$export$9d71a37f0770d87f /* @min:%2eblkVal */ ];
        mergeDf = cfgDefaults.mrg;
        reference = cfgDefaults.ref;
        if (!reference && (0, $5831ddb3a0caf7c7$export$fce6876652108ab)(reference)) reference = !!mergeDf;
        defValue = $2858d2db0bf490e5$var$_getDefault(dynamicHandler, theConfig, cfgDefaults);
    } else defValue = defaultValue;
    if (blkDynamicValue) // Mark the property so that any value assigned will be blocked from conversion, we need to do this
    // before assigning or fetching the value to ensure it's not converted
    dynamicHandler[0, $45806013ed348c93$export$9d71a37f0770d87f /* @min:%2eblkVal */ ](theConfig, name);
    // Set the value to the default value;
    var theValue;
    var usingDefault = true;
    var cfgValue = theConfig[name];
    // try and get and user provided values
    if (cfgValue || !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(cfgValue)) {
        // Use the defined theConfig[name] value
        theValue = cfgValue;
        usingDefault = false;
        // The values are different and we have a special default value check, which is used to
        // override config values like empty strings to continue using the default
        if (isValid && theValue !== defValue && !isValid(theValue)) {
            theValue = defValue;
            usingDefault = true;
        }
        if (setFn) {
            theValue = setFn(theValue, defValue, theConfig);
            usingDefault = theValue === defValue;
        }
    }
    if (!usingDefault) {
        if ((0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(theValue) || (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(defValue)) // we are using the user supplied value and it's an object
        {
            if (mergeDf && defValue && ((0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(defValue) || (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(defValue))) // Resolve/apply the defaults
            (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(defValue, function(dfName, dfValue) {
                // Sets the value and makes it dynamic (if it doesn't already exist)
                $2858d2db0bf490e5$export$f11b7d3a4617b9e9(dynamicHandler, theValue, dfName, dfValue);
            });
        }
    } else if (defValue) // Just resolve the default
    theValue = $2858d2db0bf490e5$var$_resolveDefaultValue(dynamicHandler, theConfig, defValue);
    else theValue = defValue;
    // if (theValue && usingDefault && (isPlainObject(theValue) || isArray(theValue))) {
    //     theValue = _cfgDeepCopy(theValue);
    // }
    // Needed to ensure that the (potentially) new field is dynamic even if null/undefined
    dynamicHandler.set(theConfig, name, theValue);
    if (reference) dynamicHandler.ref(theConfig, name);
    if (readOnly) dynamicHandler[0, $45806013ed348c93$export$9e4bb115c58de388 /* @min:%2erdOnly */ ](theConfig, name);
}


/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

var $d3c38d6d6e53b9ed$export$3af51e1f665d1d72 = (0, $5831ddb3a0caf7c7$export$4d0ba04d25a41f31)("[[ai_dynCfg_1]]");
/**
 * @internal
 * @ignore
 * The symbol to tag objects / arrays with if they should not be converted
 */ var $d3c38d6d6e53b9ed$var$BLOCK_DYNAMIC = (0, $5831ddb3a0caf7c7$export$4d0ba04d25a41f31)("[[ai_blkDynCfg_1]]");
/**
 * @internal
 * @ignore
 * The symbol to tag objects to indicate that when included into the configuration that
 * they should be converted into a trackable dynamic object.
 */ var $d3c38d6d6e53b9ed$var$FORCE_DYNAMIC = (0, $5831ddb3a0caf7c7$export$4d0ba04d25a41f31)("[[ai_frcDynCfg_1]]");
function $d3c38d6d6e53b9ed$export$36c4765ffcb8ffc1(source) {
    if (source) {
        var target_1;
        if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(source)) {
            target_1 = [];
            target_1[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] = source[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
        } else if ((0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(source)) target_1 = {};
        if (target_1) {
            // Copying index values by property name as the extensionConfig can be an array or object
            (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(source, function(key, value) {
                // Perform a deep copy of the object
                target_1[key] = $d3c38d6d6e53b9ed$export$36c4765ffcb8ffc1(value);
            });
            return target_1;
        }
    }
    return source;
}
function $d3c38d6d6e53b9ed$export$ebfc7adde882cbe6(value) {
    if (value) {
        var handler = value[$d3c38d6d6e53b9ed$export$3af51e1f665d1d72] || value;
        if (handler.cfg && (handler.cfg === value || handler.cfg[$d3c38d6d6e53b9ed$export$3af51e1f665d1d72] === handler)) return handler;
    }
    return null;
}
function $d3c38d6d6e53b9ed$export$9ab6a1069e1e797e(value) {
    if (value && ((0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(value) || (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(value))) try {
        value[$d3c38d6d6e53b9ed$var$BLOCK_DYNAMIC] = true;
    } catch (e) {
    // Don't throw for this case as it's an ask only
    }
    return value;
}
function $d3c38d6d6e53b9ed$export$89d2831ef182f832(value) {
    if (value) try {
        value[$d3c38d6d6e53b9ed$var$FORCE_DYNAMIC] = true;
    } catch (e) {
    // Don't throw for this case as it's an ask only
    }
    return value;
}
function $d3c38d6d6e53b9ed$export$d4b814eca8f802e7(getFunc, state, value) {
    var result = false;
    // Object must exist and be truthy
    if (value && !getFunc[state.blkVal]) {
        // Tagged as always convert
        result = value[$d3c38d6d6e53b9ed$var$FORCE_DYNAMIC];
        // Check that it's not explicitly tagged as blocked
        if (!result && !value[$d3c38d6d6e53b9ed$var$BLOCK_DYNAMIC]) // Only convert plain objects or arrays by default
        result = (0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(value) || (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(value);
    }
    return result;
}
function $d3c38d6d6e53b9ed$export$e2aa058b2c3c7959(message) {
    (0, $5831ddb3a0caf7c7$export$3f7738bd7dcba681)("InvalidAccess:" + message);
}


var $20d06ced4f112551$var$arrayMethodsToPatch = [
    "push",
    "pop",
    "shift",
    "unshift",
    "splice"
];
var $20d06ced4f112551$export$6103ab389f3208de = function(logger, name, desc, e) {
    logger && logger[0, $45806013ed348c93$export$6c078c21a0c6c1ce /* @min:%2ethrowInternal */ ](3 /* eLoggingSeverity.DEBUG */ , 108 /* _eInternalMessageId.DynamicConfigException */ , "".concat(desc, " [").concat(name, "] failed - ") + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
};
function $20d06ced4f112551$var$_patchArray(state, target, name) {
    if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(target)) // Monkey Patch the methods that might change the array
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)($20d06ced4f112551$var$arrayMethodsToPatch, function(method) {
        var orgMethod = target[method];
        target[method] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var result = orgMethod[0, $45806013ed348c93$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](this, args);
            // items may be added, removed or moved so need to make some new dynamic properties
            $20d06ced4f112551$export$f24b4ed0a40d3d27(state, target, name, "Patching");
            return result;
        };
    });
}
function $20d06ced4f112551$var$_getOwnPropGetter(target, name) {
    var propDesc = (0, $5831ddb3a0caf7c7$export$1bd5e8b059facbe9)(target, name);
    return propDesc && propDesc.get;
}
function $20d06ced4f112551$var$_createDynamicProperty(state, theConfig, name, value) {
    // Does not appear to be dynamic so lets make it so
    var detail = {
        n: name,
        h: [],
        trk: function(handler) {
            if (handler && handler.fn) {
                if ((0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(detail.h, handler) === -1) // Add this handler to the collection that should be notified when the value changes
                detail.h[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](handler);
                state.trk(handler, detail);
            }
        },
        clr: function(handler) {
            var idx = (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(detail.h, handler);
            if (idx !== -1) detail.h[0, $45806013ed348c93$export$84020a2e4fe863b0 /* @min:%2esplice */ ](idx, 1);
        }
    };
    // Flag to optimize lookup response time by avoiding additional function calls
    var checkDynamic = true;
    var isObjectOrArray = false;
    function _getProperty() {
        if (checkDynamic) {
            isObjectOrArray = isObjectOrArray || (0, $d3c38d6d6e53b9ed$export$d4b814eca8f802e7)(_getProperty, state, value);
            // Make sure that if it's an object that we make it dynamic
            if (value && !value[0, $d3c38d6d6e53b9ed$export$3af51e1f665d1d72] && isObjectOrArray) // It doesn't look like it's already dynamic so lets make sure it's converted the object into a dynamic Config as well
            value = $20d06ced4f112551$export$f24b4ed0a40d3d27(state, value, name, "Converting");
            // If it needed to be converted it now has been
            checkDynamic = false;
        }
        // If there is an active handler then add it to the tracking set of handlers
        var activeHandler = state.act;
        if (activeHandler) detail.trk(activeHandler);
        return value;
    }
    // Tag this getter as our dynamic property and provide shortcut for notifying a change
    _getProperty[state.prop] = {
        chng: function() {
            state.add(detail);
        }
    };
    function _setProperty(newValue) {
        if (value !== newValue) {
            if (!!_getProperty[state.ro] && !state.upd) // field is marked as readonly so return false
            (0, $d3c38d6d6e53b9ed$export$e2aa058b2c3c7959)("[" + name + "] is read-only:" + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(theConfig));
            if (checkDynamic) {
                isObjectOrArray = isObjectOrArray || (0, $d3c38d6d6e53b9ed$export$d4b814eca8f802e7)(_getProperty, state, value);
                checkDynamic = false;
            }
            // The value must be a plain object or an array to enforce the reference (in-place updates)
            var isReferenced = isObjectOrArray && _getProperty[state.rf];
            if (isObjectOrArray) {
                // We are about to replace a plain object or an array
                if (isReferenced) {
                    // Reassign the properties from the current value to the same properties from the newValue
                    // This will set properties not in the newValue to undefined
                    (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(value, function(key) {
                        value[key] = newValue ? newValue[key] : (0, $aa96917b132802ee$export$a43287864529b8fd);
                    });
                    // Now assign / re-assign value with all of the keys from newValue
                    try {
                        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(newValue, function(key, theValue) {
                            $20d06ced4f112551$export$7d85a661fa08a14d(state, value, key, theValue);
                        });
                        // Now drop newValue so when we assign value later it keeps the existing reference
                        newValue = value;
                    } catch (e) {
                        // Unable to convert to dynamic property so just leave as non-dynamic
                        $20d06ced4f112551$export$6103ab389f3208de((state.hdlr || {})[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ], name, "Assigning", e);
                        // Mark as not an object or array so we don't try and do this again
                        isObjectOrArray = false;
                    }
                } else if (value && value[0, $d3c38d6d6e53b9ed$export$3af51e1f665d1d72]) // As we are replacing the value, if it's already dynamic then we need to notify the listeners
                // for every property it has already
                (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(value, function(key) {
                    // Check if the value is dynamic
                    var getter = $20d06ced4f112551$var$_getOwnPropGetter(value, key);
                    if (getter) {
                        // And if it is tell it's listeners that the value has changed
                        var valueState = getter[state.prop];
                        valueState && valueState.chng();
                    }
                });
            }
            if (newValue !== value) {
                var newIsObjectOrArray = newValue && (0, $d3c38d6d6e53b9ed$export$d4b814eca8f802e7)(_getProperty, state, newValue);
                if (!isReferenced && newIsObjectOrArray) // As the newValue is an object/array lets preemptively make it dynamic
                newValue = $20d06ced4f112551$export$f24b4ed0a40d3d27(state, newValue, name, "Converting");
                // Now assign the internal "value" to the newValue
                value = newValue;
                isObjectOrArray = newIsObjectOrArray;
            }
            // Cause any listeners to be scheduled for notification
            state.add(detail);
        }
    }
    (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(theConfig, detail.n, {
        g: _getProperty,
        s: _setProperty
    });
}
function $20d06ced4f112551$export$7d85a661fa08a14d(state, target, name, value) {
    if (target) {
        // To be a dynamic property it needs to have a get function
        var getter = $20d06ced4f112551$var$_getOwnPropGetter(target, name);
        var isDynamic = getter && !!getter[state.prop];
        if (!isDynamic) $20d06ced4f112551$var$_createDynamicProperty(state, target, name, value);
        else // Looks like it's already dynamic just assign the new value
        target[name] = value;
    }
    return target;
}
function $20d06ced4f112551$export$945b6f6a011a9f7a(state, target, name, flags) {
    if (target) {
        // To be a dynamic property it needs to have a get function
        var getter = $20d06ced4f112551$var$_getOwnPropGetter(target, name);
        var isDynamic = getter && !!getter[state.prop];
        var inPlace = flags && flags[0 /* _eSetDynamicPropertyFlags.inPlace */ ];
        var rdOnly = flags && flags[1 /* _eSetDynamicPropertyFlags.readOnly */ ];
        var blkProp = flags && flags[2 /* _eSetDynamicPropertyFlags.blockDynamicProperty */ ];
        if (!isDynamic) {
            if (blkProp) try {
                // Attempt to mark the target as blocked from conversion
                (0, $d3c38d6d6e53b9ed$export$9ab6a1069e1e797e)(target);
            } catch (e) {
                $20d06ced4f112551$export$6103ab389f3208de((state.hdlr || {})[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ], name, "Blocking", e);
            }
            try {
                // Make sure it's dynamic so that we can tag the property as per the state
                $20d06ced4f112551$export$7d85a661fa08a14d(state, target, name, target[name]);
                getter = $20d06ced4f112551$var$_getOwnPropGetter(target, name);
            } catch (e) {
                // Unable to convert to dynamic property so just leave as non-dynamic
                $20d06ced4f112551$export$6103ab389f3208de((state.hdlr || {})[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ], name, "State", e);
            }
        }
        // Assign the optional flags if true
        if (inPlace) getter[state.rf] = inPlace;
        if (rdOnly) getter[state.ro] = rdOnly;
        if (blkProp) getter[state.blkVal] = true;
    }
    return target;
}
function $20d06ced4f112551$export$f24b4ed0a40d3d27(state, target, name, desc) {
    try {
        // Assign target with new value properties (converting into dynamic properties in the process)
        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(target, function(key, value) {
            // Assign and/or make the property dynamic
            $20d06ced4f112551$export$7d85a661fa08a14d(state, target, key, value);
        });
        if (!target[0, $d3c38d6d6e53b9ed$export$3af51e1f665d1d72]) {
            // Link the config back to the dynamic config details
            (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(target, (0, $d3c38d6d6e53b9ed$export$3af51e1f665d1d72), {
                get: function() {
                    return state[0, $45806013ed348c93$export$d17a699c20d379ac /* @min:%2ehdlr */ ];
                }
            });
            $20d06ced4f112551$var$_patchArray(state, target, name);
        }
    } catch (e) {
        // Unable to convert to dynamic property so just leave as non-dynamic
        $20d06ced4f112551$export$6103ab389f3208de((state.hdlr || {})[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ], name, desc, e);
    }
    return target;
}


/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

var $5fcb42e6bd7b9b68$var$aggregationErrorType;
function $5fcb42e6bd7b9b68$export$a2765bc4230e591f(message, sourceErrors) {
    if (!$5fcb42e6bd7b9b68$var$aggregationErrorType) $5fcb42e6bd7b9b68$var$aggregationErrorType = (0, $5831ddb3a0caf7c7$export$435492119a21bab3)("AggregationError", function(self, args) {
        if (args[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 1) // Save the provided errors
        self.errors = args[1];
    });
    var theMessage = message || "One or more errors occurred.";
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(sourceErrors, function(srcError, idx) {
        theMessage += "\n".concat(idx, " > ").concat((0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(srcError));
    });
    throw new $5fcb42e6bd7b9b68$var$aggregationErrorType(theMessage, sourceErrors || []);
}



var $4845cb9b52e402e2$var$symPrefix = "[[ai_";
var $4845cb9b52e402e2$var$symPostfix = "]]";
function $4845cb9b52e402e2$export$8b125ae28a27d4c(cfgHandler) {
    var _a;
    var dynamicPropertySymbol = (0, $5831ddb3a0caf7c7$export$70503d621eee7e7b)($4845cb9b52e402e2$var$symPrefix + "get" + cfgHandler.uid + $4845cb9b52e402e2$var$symPostfix);
    var dynamicPropertyReadOnly = (0, $5831ddb3a0caf7c7$export$70503d621eee7e7b)($4845cb9b52e402e2$var$symPrefix + "ro" + cfgHandler.uid + $4845cb9b52e402e2$var$symPostfix);
    var dynamicPropertyReferenced = (0, $5831ddb3a0caf7c7$export$70503d621eee7e7b)($4845cb9b52e402e2$var$symPrefix + "rf" + cfgHandler.uid + $4845cb9b52e402e2$var$symPostfix);
    var dynamicPropertyBlockValue = (0, $5831ddb3a0caf7c7$export$70503d621eee7e7b)($4845cb9b52e402e2$var$symPrefix + "blkVal" + cfgHandler.uid + $4845cb9b52e402e2$var$symPostfix);
    var dynamicPropertyDetail = (0, $5831ddb3a0caf7c7$export$70503d621eee7e7b)($4845cb9b52e402e2$var$symPrefix + "dtl" + cfgHandler.uid + $4845cb9b52e402e2$var$symPostfix);
    var _waitingHandlers = null;
    var _watcherTimer = null;
    var theState;
    function _useHandler(activeHandler, callback) {
        var prevWatcher = theState.act;
        try {
            theState.act = activeHandler;
            if (activeHandler && activeHandler[dynamicPropertyDetail]) {
                // Clear out the previously tracked details for this handler, so that access are re-evaluated
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(activeHandler[dynamicPropertyDetail], function(detail) {
                    detail.clr(activeHandler);
                });
                activeHandler[dynamicPropertyDetail] = [];
            }
            callback({
                cfg: cfgHandler.cfg,
                set: cfgHandler.set.bind(cfgHandler),
                setDf: cfgHandler[0, $45806013ed348c93$export$24caac6d68ff1537 /* @min:%2esetDf */ ].bind(cfgHandler),
                ref: cfgHandler.ref.bind(cfgHandler),
                rdOnly: cfgHandler[0, $45806013ed348c93$export$9e4bb115c58de388 /* @min:%2erdOnly */ ].bind(cfgHandler)
            });
        } catch (e) {
            var logger = cfgHandler[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ];
            if (logger) // Don't let one individual failure break everyone
            logger[0, $45806013ed348c93$export$6c078c21a0c6c1ce /* @min:%2ethrowInternal */ ](1 /* eLoggingSeverity.CRITICAL */ , 107 /* _eInternalMessageId.ConfigWatcherException */ , (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
            // Re-throw the exception so that any true "error" is reported back to the called
            throw e;
        } finally{
            theState.act = prevWatcher || null;
        }
    }
    function _notifyWatchers() {
        if (_waitingHandlers) {
            var notifyHandlers = _waitingHandlers;
            _waitingHandlers = null;
            // Stop any timer as we are running them now anyway
            _watcherTimer && _watcherTimer[0, $45806013ed348c93$export$bd01c5e3f12db01c /* @min:%2ecancel */ ]();
            _watcherTimer = null;
            var watcherFailures_1 = [];
            // Now run the handlers
            (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(notifyHandlers, function(handler) {
                if (handler) {
                    if (handler[dynamicPropertyDetail]) {
                        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(handler[dynamicPropertyDetail], function(detail) {
                            // Clear out this handler from  previously tracked details, so that access are re-evaluated
                            detail.clr(handler);
                        });
                        handler[dynamicPropertyDetail] = null;
                    }
                    // The handler may have self removed as part of another handler so re-check
                    if (handler.fn) try {
                        _useHandler(handler, handler.fn);
                    } catch (e) {
                        // Don't let a single failing watcher cause other watches to fail
                        watcherFailures_1[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](e);
                    }
                }
            });
            // During notification we may have had additional updates -- so notify those updates as well
            if (_waitingHandlers) try {
                _notifyWatchers();
            } catch (e) {
                watcherFailures_1[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](e);
            }
            if (watcherFailures_1[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) (0, $5fcb42e6bd7b9b68$export$a2765bc4230e591f)("Watcher error(s): ", watcherFailures_1);
        }
    }
    function _addWatcher(detail) {
        if (detail && detail.h[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
            if (!_waitingHandlers) _waitingHandlers = [];
            if (!_watcherTimer) _watcherTimer = (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
                _watcherTimer = null;
                _notifyWatchers();
            }, 0);
            // Add all of the handlers for this detail (if not already present) - using normal for-loop for performance
            for(var idx = 0; idx < detail.h[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]; idx++){
                var handler = detail.h[idx];
                // Add this handler to the collection of handlers to re-execute
                if (handler && (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(_waitingHandlers, handler) === -1) _waitingHandlers[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](handler);
            }
        }
    }
    function _trackHandler(handler, detail) {
        if (handler) {
            var details = handler[dynamicPropertyDetail] = handler[dynamicPropertyDetail] || [];
            if ((0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(details, detail) === -1) // If this detail is not already listed as tracked then add it so that we re-evaluate it's usage
            details[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](detail);
        }
    }
    theState = (_a = {
        prop: dynamicPropertySymbol,
        ro: dynamicPropertyReadOnly,
        rf: dynamicPropertyReferenced
    }, _a[0, $45806013ed348c93$export$9d71a37f0770d87f /* @min:blkVal */ ] = dynamicPropertyBlockValue, _a[0, $45806013ed348c93$export$d17a699c20d379ac /* @min:hdlr */ ] = cfgHandler, _a.add = _addWatcher, _a[0, $45806013ed348c93$export$6c2b24c6eee14c46 /* @min:notify */ ] = _notifyWatchers, _a.use = _useHandler, _a.trk = _trackHandler, _a);
    return theState;
}



/**
 * Identifies a function which will be re-called whenever any of it's accessed configuration values
 * change.
 * @param configHandler - The callback that will be called for the initial request and then whenever any
 * accessed configuration changes are identified.
 */ function $6387583e0b25820c$var$_createAndUseHandler(state, configHandler) {
    var handler = {
        fn: configHandler,
        rm: function() {
            // Clear all references to the handler so it can be garbage collected
            // This will also cause this handler to never get called and eventually removed
            handler.fn = null;
            state = null;
            configHandler = null;
        }
    };
    (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(handler, "toJSON", {
        v: function() {
            return "WatcherHandler" + (handler.fn ? "" : "[X]");
        }
    });
    state.use(handler, configHandler);
    return handler;
}
/**
 * Creates the dynamic config handler and associates with the target config as the root object
 * @param target - The config that you want to be root of the dynamic config
 * @param inPlace - Should the passed config be converted in-place or a new proxy returned
 * @returns The existing dynamic handler or a new instance with the provided config values
 */ function $6387583e0b25820c$var$_createDynamicHandler(logger, target, inPlace) {
    var _a;
    var dynamicHandler = (0, $d3c38d6d6e53b9ed$export$ebfc7adde882cbe6)(target);
    if (dynamicHandler) // The passed config is already dynamic so return it's tracker
    return dynamicHandler;
    var uid = (0, $0e058b881c0798ff$export$eb4a6badb18ead04)("dyncfg", true);
    var newTarget = target && inPlace !== false ? target : (0, $d3c38d6d6e53b9ed$export$36c4765ffcb8ffc1)(target);
    var theState;
    function _notifyWatchers() {
        theState[0, $45806013ed348c93$export$6c2b24c6eee14c46 /* @min:%2enotify */ ]();
    }
    function _setValue(target, name, value) {
        try {
            target = (0, $20d06ced4f112551$export$7d85a661fa08a14d)(theState, target, name, value);
        } catch (e) {
            // Unable to convert to dynamic property so just leave as non-dynamic
            (0, $20d06ced4f112551$export$6103ab389f3208de)(logger, name, "Setting value", e);
        }
        return target[name];
    }
    function _watch(configHandler) {
        return $6387583e0b25820c$var$_createAndUseHandler(theState, configHandler);
    }
    function _block(configHandler, allowUpdate) {
        theState.use(null, function(details) {
            var prevUpd = theState.upd;
            try {
                if (!(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(allowUpdate)) theState.upd = allowUpdate;
                configHandler(details);
            } finally{
                theState.upd = prevUpd;
            }
        });
    }
    function _ref(target, name) {
        var _a;
        // Make sure it's dynamic and mark as referenced with it's current value
        return (0, $20d06ced4f112551$export$945b6f6a011a9f7a)(theState, target, name, (_a = {}, _a[0 /* _eSetDynamicPropertyFlags.inPlace */ ] = true, _a))[name];
    }
    function _rdOnly(target, name) {
        var _a;
        // Make sure it's dynamic and mark as readonly with it's current value
        return (0, $20d06ced4f112551$export$945b6f6a011a9f7a)(theState, target, name, (_a = {}, _a[1 /* _eSetDynamicPropertyFlags.readOnly */ ] = true, _a))[name];
    }
    function _blkPropValue(target, name) {
        var _a;
        // Make sure it's dynamic and mark as readonly with it's current value
        return (0, $20d06ced4f112551$export$945b6f6a011a9f7a)(theState, target, name, (_a = {}, _a[2 /* _eSetDynamicPropertyFlags.blockDynamicProperty */ ] = true, _a))[name];
    }
    function _applyDefaults(theConfig, defaultValues) {
        if (defaultValues) // Resolve/apply the defaults
        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(defaultValues, function(name, value) {
            // Sets the value and makes it dynamic (if it doesn't already exist)
            (0, $2858d2db0bf490e5$export$f11b7d3a4617b9e9)(cfgHandler, theConfig, name, value);
        });
        return theConfig;
    }
    var cfgHandler = (_a = {
        uid: null,
        cfg: newTarget
    }, _a[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:logger */ ] = logger, _a[0, $45806013ed348c93$export$6c2b24c6eee14c46 /* @min:notify */ ] = _notifyWatchers, _a.set = _setValue, _a[0, $45806013ed348c93$export$24caac6d68ff1537 /* @min:setDf */ ] = _applyDefaults, _a[0, $45806013ed348c93$export$fc59eec8d77f3766 /* @min:watch */ ] = _watch, _a.ref = _ref, _a[0, $45806013ed348c93$export$9e4bb115c58de388 /* @min:rdOnly */ ] = _rdOnly, _a[0, $45806013ed348c93$export$9d71a37f0770d87f /* @min:blkVal */ ] = _blkPropValue, _a._block = _block, _a);
    (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(cfgHandler, "uid", {
        c: false,
        e: false,
        w: false,
        v: uid
    });
    theState = (0, $4845cb9b52e402e2$export$8b125ae28a27d4c)(cfgHandler);
    // Setup tracking for all defined default keys
    (0, $20d06ced4f112551$export$f24b4ed0a40d3d27)(theState, newTarget, "config", "Creating");
    return cfgHandler;
}
/**
 * Log an invalid access message to the console
 * @param message
 */ function $6387583e0b25820c$var$_logInvalidAccess(logger, message) {
    if (logger) {
        logger[0, $45806013ed348c93$export$667d3cd09d258d38 /* @min:%2ewarnToConsole */ ](message);
        logger[0, $45806013ed348c93$export$6c078c21a0c6c1ce /* @min:%2ethrowInternal */ ](2 /* eLoggingSeverity.WARNING */ , 108 /* _eInternalMessageId.DynamicConfigException */ , message);
    } else // We don't have a logger so just throw an exception
    (0, $d3c38d6d6e53b9ed$export$e2aa058b2c3c7959)(message);
}
function $6387583e0b25820c$export$3a9e9180c14487fd(config, defaultConfig, logger, inPlace) {
    var dynamicHandler = $6387583e0b25820c$var$_createDynamicHandler(logger, config || {}, inPlace);
    if (defaultConfig) dynamicHandler[0, $45806013ed348c93$export$24caac6d68ff1537 /* @min:%2esetDf */ ](dynamicHandler.cfg, defaultConfig);
    return dynamicHandler;
}
function $6387583e0b25820c$export$454a433e4deb244f(config, configHandler, logger) {
    var handler = config[0, $d3c38d6d6e53b9ed$export$3af51e1f665d1d72] || config;
    if (handler.cfg && (handler.cfg === config || handler.cfg[0, $d3c38d6d6e53b9ed$export$3af51e1f665d1d72] === handler)) return handler[0, $45806013ed348c93$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](configHandler);
    $6387583e0b25820c$var$_logInvalidAccess(logger, (0, $aa96917b132802ee$export$80c7dcdabc53a7db) + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(config));
    return $6387583e0b25820c$export$3a9e9180c14487fd(config, null, logger)[0, $45806013ed348c93$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](configHandler);
}



/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $2662e05d52c419bb$var$listenerFuncs = [
    (0, $aa96917b132802ee$export$bb3c4bc1b1175d3d),
    (0, $aa96917b132802ee$export$bacb5b2f4c1081b9),
    (0, $aa96917b132802ee$export$d75e063cb88a1c25),
    (0, $aa96917b132802ee$export$5d265841733c97c3)
];
var $2662e05d52c419bb$var$_aiNamespace = null;
var $2662e05d52c419bb$var$_debugListener;
function $2662e05d52c419bb$var$_listenerProxyFunc(name, config) {
    return function() {
        var args = arguments;
        var dbgExt = $2662e05d52c419bb$export$a0b1f407ae6b45dc(config);
        if (dbgExt) {
            var listener = dbgExt.listener;
            if (listener && listener[name]) listener[name][0, $45806013ed348c93$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](listener, args);
        }
    };
}
function $2662e05d52c419bb$var$_getExtensionNamespace() {
    // Cache the lookup of the global namespace object
    var target = (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)("Microsoft");
    if (target) $2662e05d52c419bb$var$_aiNamespace = target["ApplicationInsights"];
    return $2662e05d52c419bb$var$_aiNamespace;
}
function $2662e05d52c419bb$export$a0b1f407ae6b45dc(config) {
    var ns = $2662e05d52c419bb$var$_aiNamespace;
    if (!ns && config.disableDbgExt !== true) ns = $2662e05d52c419bb$var$_aiNamespace || $2662e05d52c419bb$var$_getExtensionNamespace();
    return ns ? ns["ChromeDbgExt"] : null;
}
function $2662e05d52c419bb$export$dae5ac50a0df0f5f(config) {
    if (!$2662e05d52c419bb$var$_debugListener) {
        $2662e05d52c419bb$var$_debugListener = {};
        for(var lp = 0; lp < $2662e05d52c419bb$var$listenerFuncs[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++)$2662e05d52c419bb$var$_debugListener[$2662e05d52c419bb$var$listenerFuncs[lp]] = $2662e05d52c419bb$var$_listenerProxyFunc($2662e05d52c419bb$var$listenerFuncs[lp], config);
    }
    return $2662e05d52c419bb$var$_debugListener;
}




"use strict";
var $bacca83328a730a7$var$_a;
var $bacca83328a730a7$var$STR_WARN_TO_CONSOLE = "warnToConsole";
/**
 * For user non actionable traces use AI Internal prefix.
 */ var $bacca83328a730a7$var$AiNonUserActionablePrefix = "AI (Internal): ";
/**
 * Prefix of the traces in portal.
 */ var $bacca83328a730a7$var$AiUserActionablePrefix = "AI: ";
/**
 *  Session storage key for the prefix for the key indicating message type already logged
 */ var $bacca83328a730a7$var$AIInternalMessagePrefix = "AITR_";
var $bacca83328a730a7$var$defaultValues = {
    loggingLevelConsole: 0,
    loggingLevelTelemetry: 1,
    maxMessageLimit: 25,
    enableDebug: false
};
var $bacca83328a730a7$var$_logFuncs = ($bacca83328a730a7$var$_a = {}, $bacca83328a730a7$var$_a[0 /* eLoggingSeverity.DISABLED */ ] = null, $bacca83328a730a7$var$_a[1 /* eLoggingSeverity.CRITICAL */ ] = "errorToConsole", $bacca83328a730a7$var$_a[2 /* eLoggingSeverity.WARNING */ ] = $bacca83328a730a7$var$STR_WARN_TO_CONSOLE, $bacca83328a730a7$var$_a[3 /* eLoggingSeverity.DEBUG */ ] = "debugToConsole", $bacca83328a730a7$var$_a);
function $bacca83328a730a7$var$_sanitizeDiagnosticText(text) {
    if (text) return '"' + text[0, $45806013ed348c93$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ](/\"/g, (0, $aa96917b132802ee$export$5e8607ab26634759)) + '"';
    return 0, $aa96917b132802ee$export$5e8607ab26634759;
}
function $bacca83328a730a7$var$_logToConsole(func, message) {
    var theConsole = (0, $0d2c2fb24388dcf8$export$bbe488cec1edd401)();
    if (!!theConsole) {
        var logFunc = "log";
        if (theConsole[func]) logFunc = func;
        if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(theConsole[logFunc])) theConsole[logFunc](message);
    }
}
var $bacca83328a730a7$export$70ef838ed08aad47 = /** @class */ function() {
    function _InternalLogMessage(msgId, msg, isUserAct, properties) {
        if (isUserAct === void 0) isUserAct = false;
        var _self = this;
        _self[0, $45806013ed348c93$export$2cc5b49df2eed261 /* @min:%2emessageId */ ] = msgId;
        _self[0, $45806013ed348c93$export$923606b70907833e /* @min:%2emessage */ ] = (isUserAct ? $bacca83328a730a7$var$AiUserActionablePrefix : $bacca83328a730a7$var$AiNonUserActionablePrefix) + msgId;
        var strProps = (0, $aa96917b132802ee$export$5e8607ab26634759);
        if ((0, $0d2c2fb24388dcf8$export$a2856ab6913b9fff)()) strProps = (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)().stringify(properties);
        var diagnosticText = (msg ? " message:" + $bacca83328a730a7$var$_sanitizeDiagnosticText(msg) : (0, $aa96917b132802ee$export$5e8607ab26634759)) + (properties ? " props:" + $bacca83328a730a7$var$_sanitizeDiagnosticText(strProps) : (0, $aa96917b132802ee$export$5e8607ab26634759));
        _self[0, $45806013ed348c93$export$923606b70907833e /* @min:%2emessage */ ] += diagnosticText;
    }
    _InternalLogMessage.dataType = "MessageData";
    return _InternalLogMessage;
}();
function $bacca83328a730a7$export$5102d32ea1d740a(core, config) {
    return (core || {})[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ] || new $bacca83328a730a7$export$4f80edb2e10dc14c(config);
}
var $bacca83328a730a7$export$4f80edb2e10dc14c = /** @class */ function() {
    function DiagnosticLogger(config) {
        this.identifier = "DiagnosticLogger";
        /**
         * The internal logging queue
         */ this.queue = [];
        /**
         * Count of internal messages sent
         */ var _messageCount = 0;
        /**
         * Holds information about what message types were already logged to console or sent to server.
         */ var _messageLogged = {};
        var _loggingLevelConsole;
        var _loggingLevelTelemetry;
        var _maxInternalMessageLimit;
        var _enableDebug;
        var _unloadHandler;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(DiagnosticLogger, this, function(_self) {
            _unloadHandler = _setDefaultsFromConfig(config || {});
            _self.consoleLoggingLevel = function() {
                return _loggingLevelConsole;
            };
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity - {LoggingSeverity} - The severity of the log message
             * @param message - {_InternalLogMessage} - The log message.
             */ _self[0, $45806013ed348c93$export$6c078c21a0c6c1ce /* @min:%2ethrowInternal */ ] = function(severity, msgId, msg, properties, isUserAct) {
                if (isUserAct === void 0) isUserAct = false;
                var message = new $bacca83328a730a7$export$70ef838ed08aad47(msgId, msg, isUserAct, properties);
                if (_enableDebug) throw (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(message);
                else {
                    // Get the logging function and fallback to warnToConsole of for some reason errorToConsole doesn't exist
                    var logFunc = $bacca83328a730a7$var$_logFuncs[severity] || $bacca83328a730a7$var$STR_WARN_TO_CONSOLE;
                    if (!(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(message[0, $45806013ed348c93$export$923606b70907833e /* @min:%2emessage */ ])) {
                        if (isUserAct) {
                            // check if this message type was already logged to console for this page view and if so, don't log it again
                            var messageKey = +message[0, $45806013ed348c93$export$2cc5b49df2eed261 /* @min:%2emessageId */ ];
                            if (!_messageLogged[messageKey] && _loggingLevelConsole >= severity) {
                                _self[logFunc](message[0, $45806013ed348c93$export$923606b70907833e /* @min:%2emessage */ ]);
                                _messageLogged[messageKey] = true;
                            }
                        } else // Only log traces if the console Logging Level is >= the throwInternal severity level
                        if (_loggingLevelConsole >= severity) _self[logFunc](message[0, $45806013ed348c93$export$923606b70907833e /* @min:%2emessage */ ]);
                        _logInternalMessage(severity, message);
                    } else _debugExtMsg("throw" + (severity === 1 /* eLoggingSeverity.CRITICAL */  ? "Critical" : "Warning"), message);
                }
            };
            _self.debugToConsole = function(message) {
                $bacca83328a730a7$var$_logToConsole("debug", message);
                _debugExtMsg("warning", message);
            };
            _self[0, $45806013ed348c93$export$667d3cd09d258d38 /* @min:%2ewarnToConsole */ ] = function(message) {
                $bacca83328a730a7$var$_logToConsole("warn", message);
                _debugExtMsg("warning", message);
            };
            _self.errorToConsole = function(message) {
                $bacca83328a730a7$var$_logToConsole("error", message);
                _debugExtMsg("error", message);
            };
            _self.resetInternalMessageCount = function() {
                _messageCount = 0;
                _messageLogged = {};
            };
            _self[0, $45806013ed348c93$export$6a3333b2109fff2a /* @min:%2elogInternalMessage */ ] = _logInternalMessage;
            _self[0, $45806013ed348c93$export$7eb85b5cba77a43d /* @min:%2eunload */ ] = function(isAsync) {
                _unloadHandler && _unloadHandler.rm();
                _unloadHandler = null;
            };
            function _logInternalMessage(severity, message) {
                if (_areInternalMessagesThrottled()) return;
                // check if this message type was already logged for this session and if so, don't log it again
                var logMessage = true;
                var messageKey = $bacca83328a730a7$var$AIInternalMessagePrefix + message[0, $45806013ed348c93$export$2cc5b49df2eed261 /* @min:%2emessageId */ ];
                // if the session storage is not available, limit to only one message type per page view
                if (_messageLogged[messageKey]) logMessage = false;
                else _messageLogged[messageKey] = true;
                if (logMessage) {
                    // Push the event in the internal queue
                    if (severity <= _loggingLevelTelemetry) {
                        _self.queue[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](message);
                        _messageCount++;
                        _debugExtMsg(severity === 1 /* eLoggingSeverity.CRITICAL */  ? "error" : "warn", message);
                    }
                    // When throttle limit reached, send a special event
                    if (_messageCount === _maxInternalMessageLimit) {
                        var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
                        var throttleMessage = new $bacca83328a730a7$export$70ef838ed08aad47(23 /* _eInternalMessageId.MessageLimitPerPVExceeded */ , throttleLimitMessage, false);
                        _self.queue[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](throttleMessage);
                        if (severity === 1 /* eLoggingSeverity.CRITICAL */ ) _self.errorToConsole(throttleLimitMessage);
                        else _self[0, $45806013ed348c93$export$667d3cd09d258d38 /* @min:%2ewarnToConsole */ ](throttleLimitMessage);
                    }
                }
            }
            function _setDefaultsFromConfig(config) {
                // make sure the config is dynamic
                return (0, $6387583e0b25820c$export$454a433e4deb244f)((0, $6387583e0b25820c$export$3a9e9180c14487fd)(config, $bacca83328a730a7$var$defaultValues, _self).cfg, function(details) {
                    var config = details.cfg;
                    _loggingLevelConsole = config[0, $45806013ed348c93$export$e53d8cae4d527530 /* @min:%2eloggingLevelConsole */ ];
                    _loggingLevelTelemetry = config.loggingLevelTelemetry;
                    _maxInternalMessageLimit = config.maxMessageLimit;
                    _enableDebug = config.enableDebug;
                });
            }
            function _areInternalMessagesThrottled() {
                return _messageCount >= _maxInternalMessageLimit;
            }
            function _debugExtMsg(name, data) {
                var dbgExt = (0, $2662e05d52c419bb$export$a0b1f407ae6b45dc)(config || {});
                if (dbgExt && dbgExt[0, $45806013ed348c93$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]) dbgExt[0, $45806013ed348c93$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](name, data);
            }
        });
    }
    // Removed Stub for DiagnosticLogger.prototype.consoleLoggingLevel.
    // Removed Stub for DiagnosticLogger.prototype.throwInternal.
    // Removed Stub for DiagnosticLogger.prototype.debugToConsole.
    // Removed Stub for DiagnosticLogger.prototype.warnToConsole.
    // Removed Stub for DiagnosticLogger.prototype.errorToConsole.
    // Removed Stub for DiagnosticLogger.prototype.resetInternalMessageCount.
    // Removed Stub for DiagnosticLogger.prototype.logInternalMessage.
    // Removed Stub for DiagnosticLogger.prototype.unload.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    DiagnosticLogger.__ieDyn = 1;
    return DiagnosticLogger;
}();
function $bacca83328a730a7$var$_getLogger(logger) {
    return logger || new $bacca83328a730a7$export$4f80edb2e10dc14c();
}
function $bacca83328a730a7$export$c7ca1fcbf1d310c4(logger, severity, msgId, msg, properties, isUserAct) {
    if (isUserAct === void 0) isUserAct = false;
    $bacca83328a730a7$var$_getLogger(logger)[0, $45806013ed348c93$export$6c078c21a0c6c1ce /* @min:%2ethrowInternal */ ](severity, msgId, msg, properties, isUserAct);
}
function $bacca83328a730a7$export$25fb4cb97863f0a8(logger, message) {
    $bacca83328a730a7$var$_getLogger(logger)[0, $45806013ed348c93$export$667d3cd09d258d38 /* @min:%2ewarnToConsole */ ](message);
}
function $bacca83328a730a7$export$e15fbe42d9bc9d3d(logger, severity, message) {
    $bacca83328a730a7$var$_getLogger(logger)[0, $45806013ed348c93$export$6a3333b2109fff2a /* @min:%2elogInternalMessage */ ](severity, message);
}



/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $b863566731035422$export$b889f1d4cb07c706 = "split"; // Count: 6
var $b863566731035422$export$6eae51590aaea43 = "length"; // Count: 41
var $b863566731035422$export$e4eaee9e01d9baaa = "toLowerCase"; // Count: 6
var $b863566731035422$export$3960f2eafedb8f1 = "ingestionendpoint"; // Count: 6
var $b863566731035422$export$e2818d11505fa034 = "toString"; // Count: 9
var $b863566731035422$export$a0a330e7fa1e278c = "push"; // Count: 5
var $b863566731035422$export$596e0e0dc14a1e9b = "removeItem"; // Count: 3
var $b863566731035422$export$9734b0a24bf02e93 = "name"; // Count: 11
var $b863566731035422$export$923606b70907833e = "message"; // Count: 10
var $b863566731035422$export$e9679ef501b0d1 = "count"; // Count: 8
var $b863566731035422$export$89a9ed6e0f1c703a = "preTriggerDate"; // Count: 4
var $b863566731035422$export$bf48f5cc9167f468 = "disabled"; // Count: 3
var $b863566731035422$export$67d4e5d95e63e1b3 = "interval"; // Count: 3
var $b863566731035422$export$ffc8d7f1d37c54ec = "daysOfMonth"; // Count: 3
var $b863566731035422$export$abbddaba4ad71f38 = "date"; // Count: 5
var $b863566731035422$export$44cd8e854cee592d = "getUTCDate"; // Count: 3
var $b863566731035422$export$a318a8141fc98747 = "stringify"; // Count: 4
var $b863566731035422$export$34ec22d747521ad = "pathname"; // Count: 4
var $b863566731035422$export$89ce3552c03e8ec9 = "correlationHeaderExcludePatterns"; // Count: 2
var $b863566731035422$export$e298802ab42a3b7f = "extensionConfig"; // Count: 4
var $b863566731035422$export$967696d490ed5a4a = "exceptions"; // Count: 6
var $b863566731035422$export$4b848bcab7cafe5d = "parsedStack"; // Count: 13
var $b863566731035422$export$14814e6f9bf337b4 = "properties"; // Count: 9
var $b863566731035422$export$32fc64677eb5b7a2 = "measurements"; // Count: 9
var $b863566731035422$export$59a1581bc81a9aae = "sizeInBytes"; // Count: 11
var $b863566731035422$export$6008dba8ea08a587 = "typeName"; // Count: 11
var $b863566731035422$export$2675b0014c60aa10 = "severityLevel"; // Count: 5
var $b863566731035422$export$5bc84cbcfe97e161 = "problemGroup"; // Count: 3
var $b863566731035422$export$880f71e9a894c474 = "isManual"; // Count: 3
var $b863566731035422$export$aadef743ee7d1db8 = "CreateFromInterface"; // Count: 2
var $b863566731035422$export$7e3ee7b01672f321 = "assembly"; // Count: 7
var $b863566731035422$export$8ea03ef8a4bcfeeb = "fileName"; // Count: 8
var $b863566731035422$export$b1b7551538b2085 = "hasFullStack"; // Count: 6
var $b863566731035422$export$25f3022e0cda8855 = "level"; // Count: 5
var $b863566731035422$export$47d30bd816d62bdc = "method"; // Count: 7
var $b863566731035422$export$138215f6c1f0eedf = "line"; // Count: 6
var $b863566731035422$export$aa395e58f404db90 = "duration"; // Count: 4
var $b863566731035422$export$e046465ee502552 = "receivedResponse"; // Count: 2


function $3ad7e6398fcf0cbb$export$1e3742b0a5fad0e9(logger, key, map) {
    var origLength = key[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ];
    var field = $3ad7e6398fcf0cbb$export$100c3b44eeb2bd0b(logger, key);
    // validation truncated the length.  We need to add uniqueness
    if (field[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] !== origLength) {
        var i = 0;
        var uniqueField = field;
        while(map[uniqueField] !== undefined){
            i++;
            uniqueField = (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(field, 0, 147) + $3ad7e6398fcf0cbb$export$d924cb9df01a6484(i);
        }
        field = uniqueField;
    }
    return field;
}
function $3ad7e6398fcf0cbb$export$100c3b44eeb2bd0b(logger, name) {
    var nameTrunc;
    if (name) {
        // Remove any leading or trailing whitespace
        name = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)((0, $5831ddb3a0caf7c7$export$590567be997858b6)(name));
        // truncate the string to 150 chars
        if (name[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ ) {
            nameTrunc = (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(name, 0, 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ );
            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 57 /* _eInternalMessageId.NameTooLong */ , "name is too long.  It has been truncated to 150 characters.", {
                name: name
            }, true);
        }
    }
    return nameTrunc || name;
}
function $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8(logger, value, maxLength) {
    if (maxLength === void 0) maxLength = 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */ ;
    var valueTrunc;
    if (value) {
        maxLength = maxLength ? maxLength : 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */ ; // in case default parameters dont work
        value = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)((0, $5831ddb3a0caf7c7$export$590567be997858b6)(value));
        if (value[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > maxLength) {
            valueTrunc = (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(value, 0, maxLength);
            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 61 /* _eInternalMessageId.StringValueTooLong */ , "string value is too long. It has been truncated to " + maxLength + " characters.", {
                value: value
            }, true);
        }
    }
    return valueTrunc || value;
}
function $3ad7e6398fcf0cbb$export$356146502a9f860c(logger, url) {
    return $3ad7e6398fcf0cbb$export$8860beb3484248f1(logger, url, 2048 /* DataSanitizerValues.MAX_URL_LENGTH */ , 66 /* _eInternalMessageId.UrlTooLong */ );
}
function $3ad7e6398fcf0cbb$export$dff84a9939b48dc0(logger, message) {
    var messageTrunc;
    if (message) {
        if (message[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */ ) {
            messageTrunc = (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(message, 0, 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */ );
            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 56 /* _eInternalMessageId.MessageTruncated */ , "message is too long, it has been truncated to 32768 characters.", {
                message: message
            }, true);
        }
    }
    return messageTrunc || message;
}
function $3ad7e6398fcf0cbb$export$e47d8a961052f8bc(logger, exception) {
    var exceptionTrunc;
    if (exception) {
        // Make surte its a string
        var value = "" + exception;
        if (value[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */ ) {
            exceptionTrunc = (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(value, 0, 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */ );
            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 52 /* _eInternalMessageId.ExceptionTruncated */ , "exception is too long, it has been truncated to 32768 characters.", {
                exception: exception
            }, true);
        }
    }
    return exceptionTrunc || exception;
}
function $3ad7e6398fcf0cbb$export$efba9e468fe3b2cf(logger, properties) {
    if (properties) {
        var tempProps_1 = {};
        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(properties, function(prop, value) {
            if ((0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(value) && (0, $0d2c2fb24388dcf8$export$a2856ab6913b9fff)()) // Stringify any part C properties
            try {
                value = (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)()[0, $b863566731035422$export$a318a8141fc98747 /* @min:%2estringify */ ](value);
            } catch (e) {
                (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */ , "custom property is not valid", {
                    exception: e
                }, true);
            }
            value = $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8(logger, value, 8192 /* DataSanitizerValues.MAX_PROPERTY_LENGTH */ );
            prop = $3ad7e6398fcf0cbb$export$1e3742b0a5fad0e9(logger, prop, tempProps_1);
            tempProps_1[prop] = value;
        });
        properties = tempProps_1;
    }
    return properties;
}
function $3ad7e6398fcf0cbb$export$3f0e10abe91e800b(logger, measurements) {
    if (measurements) {
        var tempMeasurements_1 = {};
        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(measurements, function(measure, value) {
            measure = $3ad7e6398fcf0cbb$export$1e3742b0a5fad0e9(logger, measure, tempMeasurements_1);
            tempMeasurements_1[measure] = value;
        });
        measurements = tempMeasurements_1;
    }
    return measurements;
}
function $3ad7e6398fcf0cbb$export$808d3905d3d31f01(logger, id) {
    return id ? $3ad7e6398fcf0cbb$export$8860beb3484248f1(logger, id, 128 /* DataSanitizerValues.MAX_ID_LENGTH */ , 69 /* _eInternalMessageId.IdTooLong */ )[0, $b863566731035422$export$e2818d11505fa034 /* @min:%2etoString */ ]() : id;
}
function $3ad7e6398fcf0cbb$export$8860beb3484248f1(logger, input, maxLength, _msgId) {
    var inputTrunc;
    if (input) {
        input = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)((0, $5831ddb3a0caf7c7$export$590567be997858b6)(input));
        if (input[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > maxLength) {
            inputTrunc = (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(input, 0, maxLength);
            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", {
                data: input
            }, true);
        }
    }
    return inputTrunc || input;
}
function $3ad7e6398fcf0cbb$export$d924cb9df01a6484(num) {
    var s = "00" + num;
    return (0, $5831ddb3a0caf7c7$export$25b2a9bb66b0078d)(s, s[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] - 3);
}


/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

var $b5e9e2ed66fb6b5a$var$_document = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)() || {};
var $b5e9e2ed66fb6b5a$var$_htmlAnchorIdx = 0;
// Use an array of temporary values as it's possible for multiple calls to parseUrl() will be called with different URLs
// Using a cache size of 5 for now as it current depth usage is at least 2, so adding a minor buffer to handle future updates
var $b5e9e2ed66fb6b5a$var$_htmlAnchorElement = [
    null,
    null,
    null,
    null,
    null
];
function $b5e9e2ed66fb6b5a$export$7121b8cb971a9df2(url) {
    var anchorIdx = $b5e9e2ed66fb6b5a$var$_htmlAnchorIdx;
    var anchorCache = $b5e9e2ed66fb6b5a$var$_htmlAnchorElement;
    var tempAnchor = anchorCache[anchorIdx];
    if (!$b5e9e2ed66fb6b5a$var$_document.createElement) // Always create the temp instance if createElement is not available
    tempAnchor = {
        host: $b5e9e2ed66fb6b5a$export$ff1d1b7a9bae98f(url, true)
    };
    else if (!anchorCache[anchorIdx]) // Create and cache the unattached anchor instance
    tempAnchor = anchorCache[anchorIdx] = $b5e9e2ed66fb6b5a$var$_document.createElement("a");
    tempAnchor.href = url;
    // Move the cache index forward
    anchorIdx++;
    if (anchorIdx >= anchorCache[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ]) anchorIdx = 0;
    $b5e9e2ed66fb6b5a$var$_htmlAnchorIdx = anchorIdx;
    return tempAnchor;
}
function $b5e9e2ed66fb6b5a$export$a98678973ebe2123(url) {
    var result;
    var a = $b5e9e2ed66fb6b5a$export$7121b8cb971a9df2(url);
    if (a) result = a.href;
    return result;
}
function $b5e9e2ed66fb6b5a$export$d19e0ccf7100cfb3(url) {
    var result;
    var a = $b5e9e2ed66fb6b5a$export$7121b8cb971a9df2(url);
    if (a) result = a[0, $b863566731035422$export$34ec22d747521ad /* @min:%2epathname */ ];
    return result;
}
function $b5e9e2ed66fb6b5a$export$b959f3bc0a239498(method, absoluteUrl) {
    if (method) return method.toUpperCase() + " " + absoluteUrl;
    return absoluteUrl;
}
function $b5e9e2ed66fb6b5a$export$ff1d1b7a9bae98f(url, inclPort) {
    var fullHost = $b5e9e2ed66fb6b5a$export$eac70d47569302de(url, inclPort) || "";
    if (fullHost) {
        var match = fullHost.match(/(www\d{0,5}\.)?([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 3 && (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(match[2]) && match[2][0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) return match[2] + (match[3] || "");
    }
    return fullHost;
}
function $b5e9e2ed66fb6b5a$export$eac70d47569302de(url, inclPort) {
    var result = null;
    if (url) {
        var match = url.match(/(\w{1,150}):\/\/([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 2 && (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(match[2]) && match[2][0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
            result = match[2] || "";
            if (inclPort && match[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 2) {
                var protocol = (match[1] || "")[0, $b863566731035422$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
                var port = match[3] || "";
                // IE includes the standard port so pass it off if it's the same as the protocol
                if (protocol === "http" && port === ":80") port = "";
                else if (protocol === "https" && port === ":443") port = "";
                result += port;
            }
        }
    }
    return result;
}



// listing only non-geo specific locations
var $d98f9809e5d6a7c7$var$_internalEndpoints = [
    (0, $8ac3b4fe9182f568$export$5c9ec0fce655ebcf) + (0, $8ac3b4fe9182f568$export$e6c0f3431c6cd728),
    "https://breeze.aimon.applicationinsights.io" + (0, $8ac3b4fe9182f568$export$e6c0f3431c6cd728),
    "https://dc-int.services.visualstudio.com" + (0, $8ac3b4fe9182f568$export$e6c0f3431c6cd728)
];
var $d98f9809e5d6a7c7$var$_correlationIdPrefix = "cid-v1:";
function $d98f9809e5d6a7c7$export$edade5317663baa4(endpointUrl) {
    return (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)($d98f9809e5d6a7c7$var$_internalEndpoints, endpointUrl[0, $b863566731035422$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]()) !== -1;
}
function $d98f9809e5d6a7c7$export$11cd7bb42a058181(prefix) {
    $d98f9809e5d6a7c7$var$_correlationIdPrefix = prefix;
}
function $d98f9809e5d6a7c7$export$34b74e57304d137() {
    return $d98f9809e5d6a7c7$var$_correlationIdPrefix;
}
function $d98f9809e5d6a7c7$export$a62d10d7f896c08c(config, requestUrl, currentHost) {
    if (!requestUrl || config && config.disableCorrelationHeaders) return false;
    if (config && config[0, $b863566731035422$export$89ce3552c03e8ec9 /* @min:%2ecorrelationHeaderExcludePatterns */ ]) for(var i = 0; i < config.correlationHeaderExcludePatterns[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
        if (config[0, $b863566731035422$export$89ce3552c03e8ec9 /* @min:%2ecorrelationHeaderExcludePatterns */ ][i].test(requestUrl)) return false;
    }
    var requestHost = (0, $b5e9e2ed66fb6b5a$export$7121b8cb971a9df2)(requestUrl).host[0, $b863566731035422$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
    if (requestHost && ((0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(requestHost, ":443") !== -1 || (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(requestHost, ":80") !== -1)) // [Bug #1260] IE can include the port even for http and https URLs so if present
    // try and parse it to remove if it matches the default protocol port
    requestHost = ((0, $b5e9e2ed66fb6b5a$export$eac70d47569302de)(requestUrl, true) || "")[0, $b863566731035422$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
    if ((!config || !config.enableCorsCorrelation) && requestHost && requestHost !== currentHost) return false;
    var includedDomains = config && config.correlationHeaderDomains;
    if (includedDomains) {
        var matchExists_1;
        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(includedDomains, function(domain) {
            var regex = new RegExp(domain.toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
            matchExists_1 = matchExists_1 || regex.test(requestHost);
        });
        if (!matchExists_1) return false;
    }
    var excludedDomains = config && config.correlationHeaderExcludedDomains;
    if (!excludedDomains || excludedDomains[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] === 0) return true;
    for(var i = 0; i < excludedDomains[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
        var regex = new RegExp(excludedDomains[i].toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
        if (regex.test(requestHost)) return false;
    }
    // if we don't know anything about the requestHost, require the user to use included/excludedDomains.
    // Previously we always returned false for a falsy requestHost
    return requestHost && requestHost[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 0;
}
function $d98f9809e5d6a7c7$export$dbaf37203f788583(responseHeader) {
    if (responseHeader) {
        var correlationId = $d98f9809e5d6a7c7$export$23620a0eaa22fb00(responseHeader, (0, $921552b7fb658c3b$export$e499e02a1fe05177)[1 /* eRequestHeaders.requestContextTargetKey */ ]);
        if (correlationId && correlationId !== $d98f9809e5d6a7c7$var$_correlationIdPrefix) return correlationId;
    }
}
function $d98f9809e5d6a7c7$export$23620a0eaa22fb00(responseHeader, key) {
    if (responseHeader) {
        var keyValues = responseHeader[0, $b863566731035422$export$b889f1d4cb07c706 /* @min:%2esplit */ ](",");
        for(var i = 0; i < keyValues[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ]; ++i){
            var keyValue = keyValues[i][0, $b863566731035422$export$b889f1d4cb07c706 /* @min:%2esplit */ ]("=");
            if (keyValue[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] === 2 && keyValue[0] === key) return keyValue[1];
        }
    }
}
function $d98f9809e5d6a7c7$export$92b0aba7cb1d0e30(logger, absoluteUrl, method, commandName) {
    var target, name = commandName, data = commandName;
    if (absoluteUrl && absoluteUrl[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
        var parsedUrl = (0, $b5e9e2ed66fb6b5a$export$7121b8cb971a9df2)(absoluteUrl);
        target = parsedUrl.host;
        if (!name) {
            if (parsedUrl[0, $b863566731035422$export$34ec22d747521ad /* @min:%2epathname */ ] != null) {
                var pathName = parsedUrl.pathname[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] === 0 ? "/" : parsedUrl[0, $b863566731035422$export$34ec22d747521ad /* @min:%2epathname */ ];
                if (pathName.charAt(0) !== "/") pathName = "/" + pathName;
                data = parsedUrl[0, $b863566731035422$export$34ec22d747521ad /* @min:%2epathname */ ];
                name = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, method ? method + " " + pathName : pathName);
            } else name = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, absoluteUrl);
        }
    } else {
        target = commandName;
        name = commandName;
    }
    return {
        target: target,
        name: name,
        data: data
    };
}
function $d98f9809e5d6a7c7$export$30a447e32c58a836() {
    // returns the window or webworker performance object
    var perf = (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)();
    if (perf && perf.now && perf.timing) {
        var now = perf.now() + perf.timing.navigationStart;
        // Known issue with IE where this calculation can be negative, so if it is then ignore and fallback
        if (now > 0) return now;
    }
    return (0, $5831ddb3a0caf7c7$export$a56f095995763cca)();
}
function $d98f9809e5d6a7c7$export$bfc7deb7f4f00987(start, end) {
    var result = null;
    if (start !== 0 && end !== 0 && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(start) && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(end)) result = end - start;
    return result;
}
function $d98f9809e5d6a7c7$export$847d5dabba5fabb9(telemetryTrace, parentCtx) {
    var trace = telemetryTrace || {};
    return {
        getName: function() {
            return trace[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ];
        },
        setName: function(newValue) {
            parentCtx && parentCtx.setName(newValue);
            trace[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ] = newValue;
        },
        getTraceId: function() {
            return trace.traceID;
        },
        setTraceId: function(newValue) {
            parentCtx && parentCtx.setTraceId(newValue);
            if ((0, $4726195e2d737947$export$29dd34cf1269f6da)(newValue)) trace.traceID = newValue;
        },
        getSpanId: function() {
            return trace.parentID;
        },
        setSpanId: function(newValue) {
            parentCtx && parentCtx.setSpanId(newValue);
            if ((0, $4726195e2d737947$export$8e51c6d8f0586aff)(newValue)) trace.parentID = newValue;
        },
        getTraceFlags: function() {
            return trace.traceFlags;
        },
        setTraceFlags: function(newTraceFlags) {
            parentCtx && parentCtx.setTraceFlags(newTraceFlags);
            trace.traceFlags = newTraceFlags;
        }
    };
}


/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $21d2736f26313761$export$d5f3ec63cad061d9 = (0, $b49c449a24f657f6$export$fd52abd0b2703048)({
    LocalStorage: 0 /* eStorageType.LocalStorage */ ,
    SessionStorage: 1 /* eStorageType.SessionStorage */ 
});
var $21d2736f26313761$export$29bb472f6d62625c = (0, $b49c449a24f657f6$export$fd52abd0b2703048)({
    AI: 0 /* eDistributedTracingModes.AI */ ,
    AI_AND_W3C: 1 /* eDistributedTracingModes.AI_AND_W3C */ ,
    W3C: 2 /* eDistributedTracingModes.W3C */ 
});
var $21d2736f26313761$export$a34b2dc7368de4d3 = (0, $b49c449a24f657f6$export$fd52abd0b2703048)({
    /**
     * Normal persistence.
     */ Normal: 1 /* EventPersistenceValue.Normal */ ,
    /**
     * Critical persistence.
     */ Critical: 2 /* EventPersistenceValue.Critical */ 
});



var $3fab9bbcce274f86$var$_canUseLocalStorage = undefined;
var $3fab9bbcce274f86$var$_canUseSessionStorage = undefined;
var $3fab9bbcce274f86$var$_storagePrefix = "";
/**
 * Gets the localStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */ function $3fab9bbcce274f86$var$_getLocalStorageObject() {
    if ($3fab9bbcce274f86$export$f28746933126d63f()) return $3fab9bbcce274f86$var$_getVerifiedStorageObject((0, $21d2736f26313761$export$d5f3ec63cad061d9).LocalStorage);
    return null;
}
/**
 * Tests storage object (localStorage or sessionStorage) to verify that it is usable
 * More details here: https://mathiasbynens.be/notes/localstorage-pattern
 * @param storageType - Type of storage
 * @return {Storage} Returns storage object verified that it is usable
 */ function $3fab9bbcce274f86$var$_getVerifiedStorageObject(storageType) {
    try {
        if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)((0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)())) return null;
        var uid = (new Date)[0, $b863566731035422$export$e2818d11505fa034 /* @min:%2etoString */ ]();
        var storage = (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)(storageType === (0, $21d2736f26313761$export$d5f3ec63cad061d9).LocalStorage ? "localStorage" : "sessionStorage");
        var name_1 = $3fab9bbcce274f86$var$_storagePrefix + uid;
        storage.setItem(name_1, uid);
        var fail = storage.getItem(name_1) !== uid;
        storage[0, $b863566731035422$export$596e0e0dc14a1e9b /* @min:%2eremoveItem */ ](name_1);
        if (!fail) return storage;
    } catch (exception) {
    // eslint-disable-next-line no-empty
    }
    return null;
}
/**
 * Gets the sessionStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */ function $3fab9bbcce274f86$var$_getSessionStorageObject() {
    if ($3fab9bbcce274f86$export$c81985c4209bac26()) return $3fab9bbcce274f86$var$_getVerifiedStorageObject((0, $21d2736f26313761$export$d5f3ec63cad061d9).SessionStorage);
    return null;
}
function $3fab9bbcce274f86$export$53ddd0ab7db9403() {
    $3fab9bbcce274f86$var$_canUseLocalStorage = false;
    $3fab9bbcce274f86$var$_canUseSessionStorage = false;
}
function $3fab9bbcce274f86$export$a08dccf4adbf6df9(storagePrefix) {
    $3fab9bbcce274f86$var$_storagePrefix = storagePrefix || "";
}
function $3fab9bbcce274f86$export$f08cf9bcd292b981() {
    $3fab9bbcce274f86$var$_canUseLocalStorage = $3fab9bbcce274f86$export$f28746933126d63f(true);
    $3fab9bbcce274f86$var$_canUseSessionStorage = $3fab9bbcce274f86$export$c81985c4209bac26(true);
}
function $3fab9bbcce274f86$export$f28746933126d63f(reset) {
    if (reset || $3fab9bbcce274f86$var$_canUseLocalStorage === undefined) $3fab9bbcce274f86$var$_canUseLocalStorage = !!$3fab9bbcce274f86$var$_getVerifiedStorageObject((0, $21d2736f26313761$export$d5f3ec63cad061d9).LocalStorage);
    return $3fab9bbcce274f86$var$_canUseLocalStorage;
}
function $3fab9bbcce274f86$export$c3876355f131c85c(logger, name) {
    var storage = $3fab9bbcce274f86$var$_getLocalStorageObject();
    if (storage !== null) try {
        return storage.getItem(name);
    } catch (e) {
        $3fab9bbcce274f86$var$_canUseLocalStorage = false;
        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 1 /* _eInternalMessageId.BrowserCannotReadLocalStorage */ , "Browser failed read of local storage. " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
            exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
        });
    }
    return null;
}
function $3fab9bbcce274f86$export$631bce20500dc098(logger, name, data) {
    var storage = $3fab9bbcce274f86$var$_getLocalStorageObject();
    if (storage !== null) try {
        storage.setItem(name, data);
        return true;
    } catch (e) {
        $3fab9bbcce274f86$var$_canUseLocalStorage = false;
        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 3 /* _eInternalMessageId.BrowserCannotWriteLocalStorage */ , "Browser failed write to local storage. " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
            exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
        });
    }
    return false;
}
function $3fab9bbcce274f86$export$63137c65c2cc6743(logger, name) {
    var storage = $3fab9bbcce274f86$var$_getLocalStorageObject();
    if (storage !== null) try {
        storage[0, $b863566731035422$export$596e0e0dc14a1e9b /* @min:%2eremoveItem */ ](name);
        return true;
    } catch (e) {
        $3fab9bbcce274f86$var$_canUseLocalStorage = false;
        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 5 /* _eInternalMessageId.BrowserFailedRemovalFromLocalStorage */ , "Browser failed removal of local storage item. " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
            exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
        });
    }
    return false;
}
function $3fab9bbcce274f86$export$c81985c4209bac26(reset) {
    if (reset || $3fab9bbcce274f86$var$_canUseSessionStorage === undefined) $3fab9bbcce274f86$var$_canUseSessionStorage = !!$3fab9bbcce274f86$var$_getVerifiedStorageObject((0, $21d2736f26313761$export$d5f3ec63cad061d9).SessionStorage);
    return $3fab9bbcce274f86$var$_canUseSessionStorage;
}
function $3fab9bbcce274f86$export$42f95336fa01d38e() {
    var keys = [];
    if ($3fab9bbcce274f86$export$c81985c4209bac26()) (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)((0, $5831ddb3a0caf7c7$export$3df6e51375017edd)("sessionStorage"), function(key) {
        keys[0, $b863566731035422$export$a0a330e7fa1e278c /* @min:%2epush */ ](key);
    });
    return keys;
}
function $3fab9bbcce274f86$export$a398bd2f40e2eb6e(logger, name) {
    var storage = $3fab9bbcce274f86$var$_getSessionStorageObject();
    if (storage !== null) try {
        return storage.getItem(name);
    } catch (e) {
        $3fab9bbcce274f86$var$_canUseSessionStorage = false;
        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 2 /* _eInternalMessageId.BrowserCannotReadSessionStorage */ , "Browser failed read of session storage. " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
            exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
        });
    }
    return null;
}
function $3fab9bbcce274f86$export$21abea3a85fee3f5(logger, name, data) {
    var storage = $3fab9bbcce274f86$var$_getSessionStorageObject();
    if (storage !== null) try {
        storage.setItem(name, data);
        return true;
    } catch (e) {
        $3fab9bbcce274f86$var$_canUseSessionStorage = false;
        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 4 /* _eInternalMessageId.BrowserCannotWriteSessionStorage */ , "Browser failed write to session storage. " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
            exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
        });
    }
    return false;
}
function $3fab9bbcce274f86$export$9f411b4ea05fb92a(logger, name) {
    var storage = $3fab9bbcce274f86$var$_getSessionStorageObject();
    if (storage !== null) try {
        storage[0, $b863566731035422$export$596e0e0dc14a1e9b /* @min:%2eremoveItem */ ](name);
        return true;
    } catch (e) {
        $3fab9bbcce274f86$var$_canUseSessionStorage = false;
        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 6 /* _eInternalMessageId.BrowserFailedRemovalFromSessionStorage */ , "Browser failed removal of session storage item. " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
            exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
        });
    }
    return false;
}



var $855be7931ba802b6$var$THROTTLE_STORAGE_PREFIX = "appInsightsThrottle";
var $855be7931ba802b6$export$a6e7e472befd3464 = /** @class */ function() {
    function ThrottleMgr(core, namePrefix) {
        var _self = this;
        var _canUseLocalStorage;
        var _logger;
        var _config;
        var _localStorageObj;
        var _isTriggered; //_isTriggered is to make sure that we only trigger throttle once a day
        var _namePrefix;
        var _queue;
        var _isReady = false;
        var _isSpecificDaysGiven = false;
        _initConfig();
        // Special internal method to allow the unit tests and DebugPlugin to hook embedded objects
        _self["_getDbgPlgTargets"] = function() {
            return [
                _queue
            ];
        };
        _self.getConfig = function() {
            return _config;
        };
        /**
         * Check if it is the correct day to send message.
         * If _isTriggered is true, even if canThrottle returns true, message will not be sent,
         * because we only allow triggering sendMessage() once a day.
         * @returns if the current date is the valid date to send message
         */ _self.canThrottle = function(msgId) {
            var localObj = _getLocalStorageObjByKey(msgId);
            var cfg = _getCfgByKey(msgId);
            return _canThrottle(cfg, _canUseLocalStorage, localObj);
        };
        /**
         * Check if throttle is triggered on current day(UTC)
         * if canThrottle returns false, isTriggered will return false
         * @returns if throttle is triggered on current day(UTC)
         */ _self.isTriggered = function(msgId) {
            return _isTrigger(msgId);
        };
        /**
         * Before isReady set to true, all message will be stored in queue.
         * Message will only be sent out after isReady set to true.
         * Initial and default value: false
         * @returns isReady state
         */ _self.isReady = function() {
            return _isReady;
        };
        /**
         * Flush all message with given message key in queue with isReady state set to true.
         * @returns if message queue is flushed
         */ _self.flush = function(msgId) {
            try {
                var queue = _getQueueByKey(msgId);
                if (queue && queue[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    var items = queue.slice(0);
                    _queue[msgId] = [];
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(items, function(item) {
                        _flushMessage(item.msgID, item[0, $b863566731035422$export$923606b70907833e /* @min:%2emessage */ ], item.severity, false);
                    });
                    return true;
                }
            } catch (err) {
            // eslint-disable-next-line no-empty
            }
            return false;
        };
        /**
         * Flush all message in queue with isReady state set to true.
         * @returns if message queue is flushed
         */ _self.flushAll = function() {
            try {
                if (_queue) {
                    var result_1 = true;
                    (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(_queue, function(key) {
                        var isFlushed = _self.flush(parseInt(key));
                        result_1 = result_1 && isFlushed;
                    });
                    return result_1;
                }
            } catch (err) {
            // eslint-disable-next-line no-empty
            }
            return false;
        };
        /**
         * Set isReady State
         * if isReady set to true, message queue will be flushed automatically.
         * @param isReady isReady State
         * @pa
         * @returns if message queue is flushed
         */ _self.onReadyState = function(isReady, flushAll) {
            if (flushAll === void 0) flushAll = true;
            _isReady = (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(isReady) ? true : isReady;
            if (_isReady && flushAll) return _self.flushAll();
            return null;
        };
        _self.sendMessage = function(msgID, message, severity) {
            return _flushMessage(msgID, message, severity, true);
        };
        function _flushMessage(msgID, message, severity, saveUnsentMsg) {
            if (_isReady) {
                var isSampledIn = _canSampledIn(msgID);
                if (!isSampledIn) return;
                var cfg = _getCfgByKey(msgID);
                var localStorageObj = _getLocalStorageObjByKey(msgID);
                var canThrottle = _canThrottle(cfg, _canUseLocalStorage, localStorageObj);
                var throttled = false;
                var number = 0;
                var isTriggered = _isTrigger(msgID);
                try {
                    if (canThrottle && !isTriggered) {
                        number = Math.min(cfg.limit.maxSendNumber, localStorageObj[0, $b863566731035422$export$e9679ef501b0d1 /* @min:%2ecount */ ] + 1);
                        localStorageObj[0, $b863566731035422$export$e9679ef501b0d1 /* @min:%2ecount */ ] = 0;
                        throttled = true;
                        _isTriggered[msgID] = true;
                        localStorageObj[0, $b863566731035422$export$89a9ed6e0f1c703a /* @min:%2epreTriggerDate */ ] = new Date();
                    } else {
                        _isTriggered[msgID] = canThrottle;
                        localStorageObj[0, $b863566731035422$export$e9679ef501b0d1 /* @min:%2ecount */ ] += 1;
                    }
                    var localStorageName = _getLocalStorageName(msgID);
                    _resetLocalStorage(_logger, localStorageName, localStorageObj);
                    for(var i = 0; i < number; i++)_sendMessage(msgID, _logger, message, severity);
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return {
                    isThrottled: throttled,
                    throttleNum: number
                };
            } else if (!!saveUnsentMsg) {
                var queue = _getQueueByKey(msgID);
                queue[0, $b863566731035422$export$a0a330e7fa1e278c /* @min:%2epush */ ]({
                    msgID: msgID,
                    message: message,
                    severity: severity
                });
            }
            return null;
        }
        function _initConfig() {
            _logger = (0, $bacca83328a730a7$export$5102d32ea1d740a)(core);
            _isTriggered = {};
            _localStorageObj = {};
            _queue = {};
            _config = {};
            _setCfgByKey(109 /* _eInternalMessageId.DefaultThrottleMsgKey */ );
            _namePrefix = (0, $ede407819d2d28c9$export$71fc1ee3e76bc1fe)(namePrefix) ? namePrefix : "";
            core.addUnloadHook((0, $6387583e0b25820c$export$454a433e4deb244f)(core.config, function(details) {
                var coreConfig = details.cfg;
                _canUseLocalStorage = (0, $3fab9bbcce274f86$export$f28746933126d63f)();
                var configMgr = coreConfig.throttleMgrCfg || {};
                (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(configMgr, function(key, cfg) {
                    _setCfgByKey(parseInt(key), cfg);
                });
            }));
        }
        function _getCfgByKey(msgID) {
            return _config[msgID] || _config[109 /* _eInternalMessageId.DefaultThrottleMsgKey */ ];
        }
        function _setCfgByKey(msgID, config) {
            var _a, _b;
            try {
                var cfg = config || {};
                var curCfg = {};
                curCfg[0, $b863566731035422$export$bf48f5cc9167f468 /* @min:%2edisabled */ ] = !!cfg[0, $b863566731035422$export$bf48f5cc9167f468 /* @min:%2edisabled */ ];
                var configInterval = cfg[0, $b863566731035422$export$67d4e5d95e63e1b3 /* @min:%2einterval */ ] || {};
                _isSpecificDaysGiven = (configInterval === null || configInterval === void 0 ? void 0 : configInterval.daysOfMonth) && (configInterval === null || configInterval === void 0 ? void 0 : configInterval.daysOfMonth[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ]) > 0;
                curCfg[0, $b863566731035422$export$67d4e5d95e63e1b3 /* @min:%2einterval */ ] = _getIntervalConfig(configInterval);
                var limit = {
                    samplingRate: ((_a = cfg.limit) === null || _a === void 0 ? void 0 : _a.samplingRate) || 100,
                    // dafault: every time sent only 1 event
                    maxSendNumber: ((_b = cfg.limit) === null || _b === void 0 ? void 0 : _b.maxSendNumber) || 1
                };
                curCfg.limit = limit;
                _config[msgID] = curCfg;
            } catch (e) {
            // eslint-disable-next-line no-empty
            }
        }
        function _getIntervalConfig(interval) {
            interval = interval || {};
            var monthInterval = interval === null || interval === void 0 ? void 0 : interval.monthInterval;
            var dayInterval = interval === null || interval === void 0 ? void 0 : interval.dayInterval;
            // default: send data every 3 month each year
            if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(monthInterval) && (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(dayInterval)) {
                interval.monthInterval = 3;
                if (!_isSpecificDaysGiven) {
                    // default: send data on 28th
                    interval[0, $b863566731035422$export$ffc8d7f1d37c54ec /* @min:%2edaysOfMonth */ ] = [
                        28
                    ];
                    _isSpecificDaysGiven = true;
                }
            }
            interval = {
                // dafault: sent every three months
                monthInterval: interval === null || interval === void 0 ? void 0 : interval.monthInterval,
                dayInterval: interval === null || interval === void 0 ? void 0 : interval.dayInterval,
                daysOfMonth: interval === null || interval === void 0 ? void 0 : interval.daysOfMonth
            };
            return interval;
        }
        function _canThrottle(config, canUseLocalStorage, localStorageObj) {
            if (config && !config[0, $b863566731035422$export$bf48f5cc9167f468 /* @min:%2edisabled */ ] && canUseLocalStorage && (0, $ede407819d2d28c9$export$71fc1ee3e76bc1fe)(localStorageObj)) {
                var curDate = _getThrottleDate();
                var date = localStorageObj[0, $b863566731035422$export$abbddaba4ad71f38 /* @min:%2edate */ ];
                var interval = config[0, $b863566731035422$export$67d4e5d95e63e1b3 /* @min:%2einterval */ ];
                var monthCheck = 1;
                if (interval === null || interval === void 0 ? void 0 : interval.monthInterval) {
                    var monthExpand = (curDate.getUTCFullYear() - date.getUTCFullYear()) * 12 + curDate.getUTCMonth() - date.getUTCMonth();
                    monthCheck = _checkInterval(interval.monthInterval, 0, monthExpand);
                }
                var dayCheck = 1;
                if (_isSpecificDaysGiven) dayCheck = (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(interval[0, $b863566731035422$export$ffc8d7f1d37c54ec /* @min:%2edaysOfMonth */ ], curDate[0, $b863566731035422$export$44cd8e854cee592d /* @min:%2egetUTCDate */ ]());
                else if (interval === null || interval === void 0 ? void 0 : interval.dayInterval) {
                    var daySpan = Math.floor((curDate.getTime() - date.getTime()) / 86400000);
                    dayCheck = _checkInterval(interval.dayInterval, 0, daySpan);
                }
                return monthCheck >= 0 && dayCheck >= 0;
            }
            return false;
        }
        function _getLocalStorageName(msgKey, prefix) {
            var fix = (0, $ede407819d2d28c9$export$71fc1ee3e76bc1fe)(prefix) ? prefix : "";
            if (msgKey) return $855be7931ba802b6$var$THROTTLE_STORAGE_PREFIX + fix + "-" + msgKey;
            return null;
        }
        // returns if throttle is triggered on current Date
        function _isTriggeredOnCurDate(preTriggerDate) {
            try {
                if (preTriggerDate) {
                    var curDate = new Date();
                    return preTriggerDate.getUTCFullYear() === curDate.getUTCFullYear() && preTriggerDate.getUTCMonth() === curDate.getUTCMonth() && preTriggerDate[0, $b863566731035422$export$44cd8e854cee592d /* @min:%2egetUTCDate */ ]() === curDate[0, $b863566731035422$export$44cd8e854cee592d /* @min:%2egetUTCDate */ ]();
                }
            } catch (e) {
            // eslint-disable-next-line no-empty
            }
            return false;
        }
        // transfer local storage string value to object that identifies start date, current count and preTriggerDate
        function _getLocalStorageObj(value, logger, storageName) {
            try {
                var storageObj = {
                    date: _getThrottleDate(),
                    count: 0
                };
                if (value) {
                    var obj = JSON.parse(value);
                    var curObj = {
                        date: _getThrottleDate(obj[0, $b863566731035422$export$abbddaba4ad71f38 /* @min:%2edate */ ]) || storageObj[0, $b863566731035422$export$abbddaba4ad71f38 /* @min:%2edate */ ],
                        count: obj[0, $b863566731035422$export$e9679ef501b0d1 /* @min:%2ecount */ ] || storageObj[0, $b863566731035422$export$e9679ef501b0d1 /* @min:%2ecount */ ],
                        preTriggerDate: obj.preTriggerDate ? _getThrottleDate(obj[0, $b863566731035422$export$89a9ed6e0f1c703a /* @min:%2epreTriggerDate */ ]) : undefined
                    };
                    return curObj;
                } else {
                    _resetLocalStorage(logger, storageName, storageObj);
                    return storageObj;
                }
            } catch (e) {
            // eslint-disable-next-line no-empty
            }
            return null;
        }
        // if datestr is not defined, current date will be returned
        function _getThrottleDate(dateStr) {
            // if new Date() can't be created through the provided dateStr, null will be returned.
            try {
                if (dateStr) {
                    var date = new Date(dateStr);
                    //make sure it is a valid Date Object
                    if (!isNaN(date.getDate())) return date;
                } else return new Date();
            } catch (e) {
            // eslint-disable-next-line no-empty
            }
            return null;
        }
        function _resetLocalStorage(logger, storageName, obj) {
            try {
                return (0, $3fab9bbcce274f86$export$631bce20500dc098)(logger, storageName, (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(JSON[0, $b863566731035422$export$a318a8141fc98747 /* @min:%2estringify */ ](obj)));
            } catch (e) {
            // eslint-disable-next-line no-empty
            }
            return false;
        }
        function _checkInterval(interval, start, current) {
            if (interval <= 0) return 1;
            // count from start year
            return current >= start && (current - start) % interval == 0 ? Math.floor((current - start) / interval) + 1 : -1;
        }
        function _sendMessage(msgID, logger, message, severity) {
            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, severity || 1 /* eLoggingSeverity.CRITICAL */ , msgID, message);
        }
        // NOTE: config.limit.samplingRate is set to 4 decimal places,
        // so config.limit.samplingRate = 1 means 0.0001%
        function _canSampledIn(msgID) {
            try {
                var cfg = _getCfgByKey(msgID);
                return (0, $dfdef4661b59546e$export$b2cfcb5c32671fa4)(1000000) <= cfg.limit.samplingRate;
            } catch (e) {
            // eslint-disable-next-line no-empty
            }
            return false;
        }
        function _getLocalStorageObjByKey(key) {
            try {
                var curObj = _localStorageObj[key];
                if (!curObj) {
                    var localStorageName = _getLocalStorageName(key, _namePrefix);
                    curObj = _getLocalStorageObj((0, $3fab9bbcce274f86$export$c3876355f131c85c)(_logger, localStorageName), _logger, localStorageName);
                    _localStorageObj[key] = curObj;
                }
                return _localStorageObj[key];
            } catch (e) {
            // eslint-disable-next-line no-empty
            }
            return null;
        }
        function _isTrigger(key) {
            var isTrigger = _isTriggered[key];
            if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(isTrigger)) {
                isTrigger = false;
                var localStorageObj = _getLocalStorageObjByKey(key);
                if (localStorageObj) isTrigger = _isTriggeredOnCurDate(localStorageObj[0, $b863566731035422$export$89a9ed6e0f1c703a /* @min:%2epreTriggerDate */ ]);
                _isTriggered[key] = isTrigger;
            }
            return _isTriggered[key];
        }
        function _getQueueByKey(key) {
            _queue = _queue || {};
            if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_queue[key])) _queue[key] = [];
            return _queue[key];
        }
    }
    return ThrottleMgr;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $ca7f93f92bf1443c$var$_FIELDS_SEPARATOR = ";";
var $ca7f93f92bf1443c$var$_FIELD_KEY_VALUE_SEPARATOR = "=";
function $ca7f93f92bf1443c$export$6369f286b474466d(connectionString) {
    if (!connectionString) return {};
    var kvPairs = connectionString[0, $b863566731035422$export$b889f1d4cb07c706 /* @min:%2esplit */ ]($ca7f93f92bf1443c$var$_FIELDS_SEPARATOR);
    var result = (0, $5831ddb3a0caf7c7$export$a16e2b23dbd5466c)(kvPairs, function(fields, kv) {
        var kvParts = kv[0, $b863566731035422$export$b889f1d4cb07c706 /* @min:%2esplit */ ]($ca7f93f92bf1443c$var$_FIELD_KEY_VALUE_SEPARATOR);
        if (kvParts[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] === 2) {
            var key = kvParts[0][0, $b863566731035422$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
            var value = kvParts[1];
            fields[key] = value;
        }
        return fields;
    }, {});
    if ((0, $5831ddb3a0caf7c7$export$f7628dc18f4211e5)(result)[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
        // this is a valid connection string, so parse the results
        if (result.endpointsuffix) {
            // apply the default endpoints
            var locationPrefix = result.location ? result.location + "." : "";
            result[0, $b863566731035422$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ] = result[0, $b863566731035422$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ] || "https://" + locationPrefix + "dc." + result.endpointsuffix;
        }
        // apply user override endpoint or the default endpoints
        result[0, $b863566731035422$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ] = result[0, $b863566731035422$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ] || (0, $8ac3b4fe9182f568$export$5c9ec0fce655ebcf);
        if ((0, $5831ddb3a0caf7c7$export$5222b9460f3ddbec)(result[0, $b863566731035422$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ], "/")) result[0, $b863566731035422$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ] = result[0, $b863566731035422$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ].slice(0, -1);
    }
    return result;
}
var $ca7f93f92bf1443c$export$9fc8be9be2105769 = {
    parse: $ca7f93f92bf1443c$export$6369f286b474466d
};




/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



var $9a1ea820994e6e6d$export$4e2d65a9843399df = /** @class */ function() {
    /**
     * Constructs a new instance of telemetry data.
     */ function Envelope(logger, data, name) {
        var _this = this;
        var _self = this;
        _self.ver = 1;
        _self.sampleRate = 100.0;
        _self.tags = {};
        _self[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ] = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, name) || (0, $8ac3b4fe9182f568$export$4003f5e1672d759);
        _self.data = data;
        _self.time = (0, $ede407819d2d28c9$export$dfaaa8705752128f)(new Date());
        _self.aiDataContract = {
            time: 1 /* FieldType.Required */ ,
            iKey: 1 /* FieldType.Required */ ,
            name: 1 /* FieldType.Required */ ,
            sampleRate: function() {
                return _this.sampleRate === 100 ? 4 /* FieldType.Hidden */  : 1 /* FieldType.Required */ ;
            },
            tags: 1 /* FieldType.Required */ ,
            data: 1 /* FieldType.Required */ 
        };
    }
    return Envelope;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $62713924cc3cd966$export$d61e24a684f9e51 = /** @class */ function() {
    /**
     * Constructs a new instance of the EventTelemetry object
     */ function Event(logger, name, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            name: 1 /* FieldType.Required */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ] = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, name) || (0, $8ac3b4fe9182f568$export$4003f5e1672d759);
        _self[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $3ad7e6398fcf0cbb$export$efba9e468fe3b2cf)(logger, properties);
        _self[0, $b863566731035422$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $3ad7e6398fcf0cbb$export$3f0e10abe91e800b)(logger, measurements);
    }
    Event.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
    Event.dataType = "EventData";
    return Event;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 





var $a35c931c4df783c8$var$NoMethod = "<no_method>";
var $a35c931c4df783c8$var$strError = "error";
var $a35c931c4df783c8$var$strStack = "stack";
var $a35c931c4df783c8$var$strStackDetails = "stackDetails";
var $a35c931c4df783c8$var$strErrorSrc = "errorSrc";
var $a35c931c4df783c8$var$strMessage = "message";
var $a35c931c4df783c8$var$strDescription = "description";
function $a35c931c4df783c8$var$_stringify(value, convertToString) {
    var result = value;
    if (result && !(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(result)) {
        if (JSON && JSON[0, $b863566731035422$export$a318a8141fc98747 /* @min:%2estringify */ ]) {
            result = JSON[0, $b863566731035422$export$a318a8141fc98747 /* @min:%2estringify */ ](value);
            if (convertToString && (!result || result === "{}")) {
                if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(value[0, $b863566731035422$export$e2818d11505fa034 /* @min:%2etoString */ ])) result = value[0, $b863566731035422$export$e2818d11505fa034 /* @min:%2etoString */ ]();
                else result = "" + value;
            }
        } else result = "" + value + " - (Missing JSON.stringify)";
    }
    return result || "";
}
function $a35c931c4df783c8$var$_formatMessage(theEvent, errorType) {
    var evtMessage = theEvent;
    if (theEvent) {
        if (evtMessage && !(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(evtMessage)) evtMessage = theEvent[$a35c931c4df783c8$var$strMessage] || theEvent[$a35c931c4df783c8$var$strDescription] || evtMessage;
        // Make sure the message is a string
        if (evtMessage && !(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(evtMessage)) // tslint:disable-next-line: prefer-conditional-expression
        evtMessage = $a35c931c4df783c8$var$_stringify(evtMessage, true);
        if (theEvent["filename"]) // Looks like an event object with filename
        evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
    }
    // Automatically add the error type to the message if it does already appear to be present
    if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(evtMessage || "", errorType) === -1) evtMessage = errorType + ": " + evtMessage;
    return evtMessage || "";
}
function $a35c931c4df783c8$var$_isExceptionDetailsInternal(value) {
    try {
        if ((0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(value)) return "hasFullStack" in value && "typeName" in value;
    } catch (e) {
    // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function $a35c931c4df783c8$var$_isExceptionInternal(value) {
    try {
        if ((0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(value)) return "ver" in value && "exceptions" in value && "properties" in value;
    } catch (e) {
    // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function $a35c931c4df783c8$var$_isStackDetails(details) {
    return details && details.src && (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(details.src) && details.obj && (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(details.obj);
}
function $a35c931c4df783c8$var$_convertStackObj(errorStack) {
    var src = errorStack || "";
    if (!(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(src)) {
        if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(src[$a35c931c4df783c8$var$strStack])) src = src[$a35c931c4df783c8$var$strStack];
        else src = "" + src;
    }
    var items = src[0, $b863566731035422$export$b889f1d4cb07c706 /* @min:%2esplit */ ]("\n");
    return {
        src: src,
        obj: items
    };
}
function $a35c931c4df783c8$var$_getOperaStack(errorMessage) {
    var stack = [];
    var lines = errorMessage[0, $b863566731035422$export$b889f1d4cb07c706 /* @min:%2esplit */ ]("\n");
    for(var lp = 0; lp < lines[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++){
        var entry = lines[lp];
        if (lines[lp + 1]) {
            entry += "@" + lines[lp + 1];
            lp++;
        }
        stack[0, $b863566731035422$export$a0a330e7fa1e278c /* @min:%2epush */ ](entry);
    }
    return {
        src: errorMessage,
        obj: stack
    };
}
function $a35c931c4df783c8$var$_getStackFromErrorObj(errorObj) {
    var details = null;
    if (errorObj) try {
        /* Using bracket notation is support older browsers (IE 7/8 -- dont remember the version) that throw when using dot
            notation for undefined objects and we don't want to loose the error from being reported */ if (errorObj[$a35c931c4df783c8$var$strStack]) // Chrome/Firefox
        details = $a35c931c4df783c8$var$_convertStackObj(errorObj[$a35c931c4df783c8$var$strStack]);
        else if (errorObj[$a35c931c4df783c8$var$strError] && errorObj[$a35c931c4df783c8$var$strError][$a35c931c4df783c8$var$strStack]) // Edge error event provides the stack and error object
        details = $a35c931c4df783c8$var$_convertStackObj(errorObj[$a35c931c4df783c8$var$strError][$a35c931c4df783c8$var$strStack]);
        else if (errorObj["exception"] && errorObj.exception[$a35c931c4df783c8$var$strStack]) details = $a35c931c4df783c8$var$_convertStackObj(errorObj.exception[$a35c931c4df783c8$var$strStack]);
        else if ($a35c931c4df783c8$var$_isStackDetails(errorObj)) details = errorObj;
        else if ($a35c931c4df783c8$var$_isStackDetails(errorObj[$a35c931c4df783c8$var$strStackDetails])) details = errorObj[$a35c931c4df783c8$var$strStackDetails];
        else if ((0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)() && (0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)()["opera"] && errorObj[$a35c931c4df783c8$var$strMessage]) // Opera
        details = $a35c931c4df783c8$var$_getOperaStack(errorObj[0, $b863566731035422$export$923606b70907833e /* @min:%2emessage */ ]);
        else if (errorObj["reason"] && errorObj.reason[$a35c931c4df783c8$var$strStack]) // UnhandledPromiseRejection
        details = $a35c931c4df783c8$var$_convertStackObj(errorObj.reason[$a35c931c4df783c8$var$strStack]);
        else if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(errorObj)) details = $a35c931c4df783c8$var$_convertStackObj(errorObj);
        else {
            var evtMessage = errorObj[$a35c931c4df783c8$var$strMessage] || errorObj[$a35c931c4df783c8$var$strDescription] || "";
            if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(errorObj[$a35c931c4df783c8$var$strErrorSrc])) {
                if (evtMessage) evtMessage += "\n";
                evtMessage += " from " + errorObj[$a35c931c4df783c8$var$strErrorSrc];
            }
            if (evtMessage) details = $a35c931c4df783c8$var$_convertStackObj(evtMessage);
        }
    } catch (e) {
        // something unexpected happened so to avoid failing to report any error lets swallow the exception
        // and fallback to the callee/caller method
        details = $a35c931c4df783c8$var$_convertStackObj(e);
    }
    return details || {
        src: "",
        obj: null
    };
}
function $a35c931c4df783c8$var$_formatStackTrace(stackDetails) {
    var stack = "";
    if (stackDetails) {
        if (stackDetails.obj) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(stackDetails.obj, function(entry) {
            stack += entry + "\n";
        });
        else stack = stackDetails.src || "";
    }
    return stack;
}
function $a35c931c4df783c8$var$_parseStack(stack) {
    var parsedStack;
    var frames = stack.obj;
    if (frames && frames[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
        parsedStack = [];
        var level_1 = 0;
        var totalSizeInBytes_1 = 0;
        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(frames, function(frame) {
            var theFrame = frame[0, $b863566731035422$export$e2818d11505fa034 /* @min:%2etoString */ ]();
            if ($a35c931c4df783c8$export$b9d0519a34c90616.regex.test(theFrame)) {
                var parsedFrame = new $a35c931c4df783c8$export$b9d0519a34c90616(theFrame, level_1++);
                totalSizeInBytes_1 += parsedFrame[0, $b863566731035422$export$59a1581bc81a9aae /* @min:%2esizeInBytes */ ];
                parsedStack[0, $b863566731035422$export$a0a330e7fa1e278c /* @min:%2epush */ ](parsedFrame);
            }
        });
        // DP Constraint - exception parsed stack must be < 32KB
        // remove frames from the middle to meet the threshold
        var exceptionParsedStackThreshold = 32768;
        if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
            var left = 0;
            var right = parsedStack[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] - 1;
            var size = 0;
            var acceptedLeft = left;
            var acceptedRight = right;
            while(left < right){
                // check size
                var lSize = parsedStack[left][0, $b863566731035422$export$59a1581bc81a9aae /* @min:%2esizeInBytes */ ];
                var rSize = parsedStack[right][0, $b863566731035422$export$59a1581bc81a9aae /* @min:%2esizeInBytes */ ];
                size += lSize + rSize;
                if (size > exceptionParsedStackThreshold) {
                    // remove extra frames from the middle
                    var howMany = acceptedRight - acceptedLeft + 1;
                    parsedStack.splice(acceptedLeft, howMany);
                    break;
                }
                // update pointers
                acceptedLeft = left;
                acceptedRight = right;
                left++;
                right--;
            }
        }
    }
    return parsedStack;
}
function $a35c931c4df783c8$var$_getErrorType(errorType) {
    // Gets the Error Type by passing the constructor (used to get the true type of native error object).
    var typeName = "";
    if (errorType) {
        typeName = errorType.typeName || errorType[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ] || "";
        if (!typeName) try {
            var funcNameRegex = /function (.{1,200})\(/;
            var results = funcNameRegex.exec(errorType.constructor[0, $b863566731035422$export$e2818d11505fa034 /* @min:%2etoString */ ]());
            typeName = results && results[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 1 ? results[1] : "";
        } catch (e) {
        // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
        }
    }
    return typeName;
}
function $a35c931c4df783c8$export$7eb96e918bb60d21(errorObj) {
    if (errorObj) try {
        if (!(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(errorObj)) {
            var errorType = $a35c931c4df783c8$var$_getErrorType(errorObj);
            var result = $a35c931c4df783c8$var$_stringify(errorObj, false);
            if (!result || result === "{}") {
                if (errorObj[$a35c931c4df783c8$var$strError]) {
                    // Looks like an MS Error Event
                    errorObj = errorObj[$a35c931c4df783c8$var$strError];
                    errorType = $a35c931c4df783c8$var$_getErrorType(errorObj);
                }
                result = $a35c931c4df783c8$var$_stringify(errorObj, true);
            }
            if ((0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(result, errorType) !== 0 && errorType !== "String") return errorType + ":" + result;
            return result;
        }
    } catch (e) {
    // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
    }
    // Fallback to just letting the object format itself into a string
    return "" + (errorObj || "");
}
var $a35c931c4df783c8$export$e2f174de097e0bcd = /** @class */ function() {
    /**
     * Constructs a new instance of the ExceptionTelemetry object
     */ function Exception(logger, exception, properties, measurements, severityLevel, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            exceptions: 1 /* FieldType.Required */ ,
            severityLevel: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2; // TODO: handle the CS"4.0" ==> breeze 2 conversion in a better way
        if (!$a35c931c4df783c8$var$_isExceptionInternal(exception)) {
            if (!properties) properties = {};
            if (id) properties.id = id;
            _self[0, $b863566731035422$export$967696d490ed5a4a /* @min:%2eexceptions */ ] = [
                new $a35c931c4df783c8$export$39152eac9dc76c5e(logger, exception, properties)
            ];
            _self[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $3ad7e6398fcf0cbb$export$efba9e468fe3b2cf)(logger, properties);
            _self[0, $b863566731035422$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $3ad7e6398fcf0cbb$export$3f0e10abe91e800b)(logger, measurements);
            if (severityLevel) _self[0, $b863566731035422$export$2675b0014c60aa10 /* @min:%2eseverityLevel */ ] = severityLevel;
            if (id) _self.id = id;
        } else {
            _self[0, $b863566731035422$export$967696d490ed5a4a /* @min:%2eexceptions */ ] = exception[0, $b863566731035422$export$967696d490ed5a4a /* @min:%2eexceptions */ ] || [];
            _self[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = exception[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ];
            _self[0, $b863566731035422$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = exception[0, $b863566731035422$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ];
            if (exception[0, $b863566731035422$export$2675b0014c60aa10 /* @min:%2eseverityLevel */ ]) _self[0, $b863566731035422$export$2675b0014c60aa10 /* @min:%2eseverityLevel */ ] = exception[0, $b863566731035422$export$2675b0014c60aa10 /* @min:%2eseverityLevel */ ];
            if (exception.id) {
                _self.id = exception.id;
                exception[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ].id = exception.id;
            }
            if (exception[0, $b863566731035422$export$5bc84cbcfe97e161 /* @min:%2eproblemGroup */ ]) _self[0, $b863566731035422$export$5bc84cbcfe97e161 /* @min:%2eproblemGroup */ ] = exception[0, $b863566731035422$export$5bc84cbcfe97e161 /* @min:%2eproblemGroup */ ];
            // bool/int types, use isNullOrUndefined
            if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(exception[0, $b863566731035422$export$880f71e9a894c474 /* @min:%2eisManual */ ])) _self[0, $b863566731035422$export$880f71e9a894c474 /* @min:%2eisManual */ ] = exception[0, $b863566731035422$export$880f71e9a894c474 /* @min:%2eisManual */ ];
        }
    }
    Exception.CreateAutoException = function(message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
        var _a;
        var errorType = $a35c931c4df783c8$var$_getErrorType(error || evt || message);
        return _a = {}, _a[0, $b863566731035422$export$923606b70907833e /* @min:message */ ] = $a35c931c4df783c8$var$_formatMessage(message, errorType), _a.url = url, _a.lineNumber = lineNumber, _a.columnNumber = columnNumber, _a.error = $a35c931c4df783c8$export$7eb96e918bb60d21(error || evt || message), _a.evt = $a35c931c4df783c8$export$7eb96e918bb60d21(evt || message), _a[0, $b863566731035422$export$6008dba8ea08a587 /* @min:typeName */ ] = errorType, _a.stackDetails = $a35c931c4df783c8$var$_getStackFromErrorObj(stack || error || evt), _a.errorSrc = errorSrc, _a;
    };
    Exception.CreateFromInterface = function(logger, exception, properties, measurements) {
        var exceptions = exception[0, $b863566731035422$export$967696d490ed5a4a /* @min:%2eexceptions */ ] && (0, $5831ddb3a0caf7c7$export$76f1a28030e24fa6)(exception[0, $b863566731035422$export$967696d490ed5a4a /* @min:%2eexceptions */ ], function(ex) {
            return $a35c931c4df783c8$export$39152eac9dc76c5e[0, $b863566731035422$export$aadef743ee7d1db8 /* @min:%2eCreateFromInterface */ ](logger, ex);
        });
        var exceptionData = new Exception(logger, (0, $dc463ff9724142dd$export$b3cf7a802e578501)((0, $dc463ff9724142dd$export$b3cf7a802e578501)({}, exception), {
            exceptions: exceptions
        }), properties, measurements);
        return exceptionData;
    };
    Exception.prototype.toInterface = function() {
        var _a;
        var _b = this, exceptions = _b.exceptions, properties = _b.properties, measurements = _b.measurements, severityLevel = _b.severityLevel, problemGroup = _b.problemGroup, id = _b.id, isManual = _b.isManual;
        var exceptionDetailsInterface = exceptions instanceof Array && (0, $5831ddb3a0caf7c7$export$76f1a28030e24fa6)(exceptions, function(exception) {
            return exception.toInterface();
        }) || undefined;
        return _a = {
            ver: "4.0"
        }, _a[0, $b863566731035422$export$967696d490ed5a4a /* @min:exceptions */ ] = exceptionDetailsInterface, _a.severityLevel = severityLevel, _a.properties = properties, _a.measurements = measurements, _a.problemGroup = problemGroup, _a.id = id, _a.isManual = isManual, _a;
    };
    /**
     * Creates a simple exception with 1 stack frame. Useful for manual constracting of exception.
     */ Exception.CreateSimpleException = function(message, typeName, assembly, fileName, details, line) {
        var _a;
        return {
            exceptions: [
                (_a = {}, _a[0, $b863566731035422$export$b1b7551538b2085 /* @min:hasFullStack */ ] = true, _a.message = message, _a.stack = details, _a.typeName = typeName, _a)
            ]
        };
    };
    Exception.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception";
    Exception.dataType = "ExceptionData";
    Exception.formatError = $a35c931c4df783c8$export$7eb96e918bb60d21;
    return Exception;
}();
var $a35c931c4df783c8$export$39152eac9dc76c5e = /** @class */ function() {
    function _ExceptionDetails(logger, exception, properties) {
        this.aiDataContract = {
            id: 0 /* FieldType.Default */ ,
            outerId: 0 /* FieldType.Default */ ,
            typeName: 1 /* FieldType.Required */ ,
            message: 1 /* FieldType.Required */ ,
            hasFullStack: 0 /* FieldType.Default */ ,
            stack: 0 /* FieldType.Default */ ,
            parsedStack: 2 /* FieldType.Array */ 
        };
        var _self = this;
        if (!$a35c931c4df783c8$var$_isExceptionDetailsInternal(exception)) {
            var error = exception;
            var evt = error && error.evt;
            if (!(0, $5831ddb3a0caf7c7$export$e6127cc7fe7395c3)(error)) error = error[$a35c931c4df783c8$var$strError] || evt || error;
            _self[0, $b863566731035422$export$6008dba8ea08a587 /* @min:%2etypeName */ ] = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, $a35c931c4df783c8$var$_getErrorType(error)) || (0, $8ac3b4fe9182f568$export$4003f5e1672d759);
            _self[0, $b863566731035422$export$923606b70907833e /* @min:%2emessage */ ] = (0, $3ad7e6398fcf0cbb$export$dff84a9939b48dc0)(logger, $a35c931c4df783c8$var$_formatMessage(exception || error, _self[0, $b863566731035422$export$6008dba8ea08a587 /* @min:%2etypeName */ ])) || (0, $8ac3b4fe9182f568$export$4003f5e1672d759);
            var stack = exception[$a35c931c4df783c8$var$strStackDetails] || $a35c931c4df783c8$var$_getStackFromErrorObj(exception);
            _self[0, $b863566731035422$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ] = $a35c931c4df783c8$var$_parseStack(stack);
            // after parsedStack is inited, iterate over each frame object, sanitize its assembly field
            if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(_self[0, $b863566731035422$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ])) (0, $5831ddb3a0caf7c7$export$76f1a28030e24fa6)(_self[0, $b863566731035422$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ], function(frame) {
                frame[0, $b863566731035422$export$7e3ee7b01672f321 /* @min:%2eassembly */ ] = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, frame[0, $b863566731035422$export$7e3ee7b01672f321 /* @min:%2eassembly */ ]);
                frame[0, $b863566731035422$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ] = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, frame[0, $b863566731035422$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ]);
            });
            _self[$a35c931c4df783c8$var$strStack] = (0, $3ad7e6398fcf0cbb$export$e47d8a961052f8bc)(logger, $a35c931c4df783c8$var$_formatStackTrace(stack));
            _self.hasFullStack = (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(_self.parsedStack) && _self.parsedStack[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 0;
            if (properties) properties[0, $b863566731035422$export$6008dba8ea08a587 /* @min:%2etypeName */ ] = properties[0, $b863566731035422$export$6008dba8ea08a587 /* @min:%2etypeName */ ] || _self[0, $b863566731035422$export$6008dba8ea08a587 /* @min:%2etypeName */ ];
        } else {
            _self[0, $b863566731035422$export$6008dba8ea08a587 /* @min:%2etypeName */ ] = exception[0, $b863566731035422$export$6008dba8ea08a587 /* @min:%2etypeName */ ];
            _self[0, $b863566731035422$export$923606b70907833e /* @min:%2emessage */ ] = exception[0, $b863566731035422$export$923606b70907833e /* @min:%2emessage */ ];
            _self[$a35c931c4df783c8$var$strStack] = exception[$a35c931c4df783c8$var$strStack];
            _self[0, $b863566731035422$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ] = exception[0, $b863566731035422$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ] || [];
            _self[0, $b863566731035422$export$b1b7551538b2085 /* @min:%2ehasFullStack */ ] = exception[0, $b863566731035422$export$b1b7551538b2085 /* @min:%2ehasFullStack */ ];
        }
    }
    _ExceptionDetails.prototype.toInterface = function() {
        var _a;
        var _self = this;
        var parsedStack = _self[0, $b863566731035422$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ] instanceof Array && (0, $5831ddb3a0caf7c7$export$76f1a28030e24fa6)(_self[0, $b863566731035422$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ], function(frame) {
            return frame.toInterface();
        });
        var exceptionDetailsInterface = (_a = {
            id: _self.id,
            outerId: _self.outerId,
            typeName: _self[0, $b863566731035422$export$6008dba8ea08a587 /* @min:%2etypeName */ ],
            message: _self[0, $b863566731035422$export$923606b70907833e /* @min:%2emessage */ ],
            hasFullStack: _self[0, $b863566731035422$export$b1b7551538b2085 /* @min:%2ehasFullStack */ ],
            stack: _self[$a35c931c4df783c8$var$strStack]
        }, _a[0, $b863566731035422$export$4b848bcab7cafe5d /* @min:parsedStack */ ] = parsedStack || undefined, _a);
        return exceptionDetailsInterface;
    };
    _ExceptionDetails.CreateFromInterface = function(logger, exception) {
        var parsedStack = exception[0, $b863566731035422$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ] instanceof Array && (0, $5831ddb3a0caf7c7$export$76f1a28030e24fa6)(exception[0, $b863566731035422$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ], function(frame) {
            return $a35c931c4df783c8$export$b9d0519a34c90616[0, $b863566731035422$export$aadef743ee7d1db8 /* @min:%2eCreateFromInterface */ ](frame);
        }) || exception[0, $b863566731035422$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ];
        var exceptionDetails = new _ExceptionDetails(logger, (0, $dc463ff9724142dd$export$b3cf7a802e578501)((0, $dc463ff9724142dd$export$b3cf7a802e578501)({}, exception), {
            parsedStack: parsedStack
        }));
        return exceptionDetails;
    };
    return _ExceptionDetails;
}();
var $a35c931c4df783c8$export$b9d0519a34c90616 = /** @class */ function() {
    function _StackFrame(sourceFrame, level) {
        this.aiDataContract = {
            level: 1 /* FieldType.Required */ ,
            method: 1 /* FieldType.Required */ ,
            assembly: 0 /* FieldType.Default */ ,
            fileName: 0 /* FieldType.Default */ ,
            line: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self[0, $b863566731035422$export$59a1581bc81a9aae /* @min:%2esizeInBytes */ ] = 0;
        // Not converting this to isString() as typescript uses this logic to "understand" the different
        // types for the 2 different code paths
        if (typeof sourceFrame === "string") {
            var frame = sourceFrame;
            _self[0, $b863566731035422$export$25f3022e0cda8855 /* @min:%2elevel */ ] = level;
            _self[0, $b863566731035422$export$47d30bd816d62bdc /* @min:%2emethod */ ] = $a35c931c4df783c8$var$NoMethod;
            _self[0, $b863566731035422$export$7e3ee7b01672f321 /* @min:%2eassembly */ ] = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(frame);
            _self[0, $b863566731035422$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ] = "";
            _self[0, $b863566731035422$export$138215f6c1f0eedf /* @min:%2eline */ ] = 0;
            var matches = frame.match(_StackFrame.regex);
            if (matches && matches[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] >= 5) {
                _self[0, $b863566731035422$export$47d30bd816d62bdc /* @min:%2emethod */ ] = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(matches[2]) || _self[0, $b863566731035422$export$47d30bd816d62bdc /* @min:%2emethod */ ];
                _self[0, $b863566731035422$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ] = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(matches[4]);
                _self[0, $b863566731035422$export$138215f6c1f0eedf /* @min:%2eline */ ] = parseInt(matches[5]) || 0;
            }
        } else {
            _self[0, $b863566731035422$export$25f3022e0cda8855 /* @min:%2elevel */ ] = sourceFrame[0, $b863566731035422$export$25f3022e0cda8855 /* @min:%2elevel */ ];
            _self[0, $b863566731035422$export$47d30bd816d62bdc /* @min:%2emethod */ ] = sourceFrame[0, $b863566731035422$export$47d30bd816d62bdc /* @min:%2emethod */ ];
            _self[0, $b863566731035422$export$7e3ee7b01672f321 /* @min:%2eassembly */ ] = sourceFrame[0, $b863566731035422$export$7e3ee7b01672f321 /* @min:%2eassembly */ ];
            _self[0, $b863566731035422$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ] = sourceFrame[0, $b863566731035422$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ];
            _self[0, $b863566731035422$export$138215f6c1f0eedf /* @min:%2eline */ ] = sourceFrame[0, $b863566731035422$export$138215f6c1f0eedf /* @min:%2eline */ ];
            _self[0, $b863566731035422$export$59a1581bc81a9aae /* @min:%2esizeInBytes */ ] = 0;
        }
        _self.sizeInBytes += _self.method[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ];
        _self.sizeInBytes += _self.fileName[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ];
        _self.sizeInBytes += _self.assembly[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ];
        // todo: these might need to be removed depending on how the back-end settles on their size calculation
        _self[0, $b863566731035422$export$59a1581bc81a9aae /* @min:%2esizeInBytes */ ] += _StackFrame.baseSize;
        _self.sizeInBytes += _self.level.toString()[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ];
        _self.sizeInBytes += _self.line.toString()[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ];
    }
    _StackFrame.CreateFromInterface = function(frame) {
        return new _StackFrame(frame, null);
    };
    _StackFrame.prototype.toInterface = function() {
        var _self = this;
        return {
            level: _self[0, $b863566731035422$export$25f3022e0cda8855 /* @min:%2elevel */ ],
            method: _self[0, $b863566731035422$export$47d30bd816d62bdc /* @min:%2emethod */ ],
            assembly: _self[0, $b863566731035422$export$7e3ee7b01672f321 /* @min:%2eassembly */ ],
            fileName: _self[0, $b863566731035422$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ],
            line: _self[0, $b863566731035422$export$138215f6c1f0eedf /* @min:%2eline */ ]
        };
    };
    // regex to match stack frames from ie/chrome/ff
    // methodName=$2, fileName=$4, lineNo=$5, column=$6
    _StackFrame.regex = /^([\s]+at)?[\s]{0,50}([^\@\()]+?)[\s]{0,50}(\@|\()([^\(\n]+):([0-9]+):([0-9]+)(\)?)$/;
    _StackFrame.baseSize = 58; // '{"method":"","level":,"assembly":"","fileName":"","line":}'.length
    return _StackFrame;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $1b80a12d00de7474$export$7e0232b0f089a6b8 = /** @class */ function() {
    function DataPoint() {
        /**
         * The data contract for serializing this object.
         */ this.aiDataContract = {
            name: 1 /* FieldType.Required */ ,
            kind: 0 /* FieldType.Default */ ,
            value: 1 /* FieldType.Required */ ,
            count: 0 /* FieldType.Default */ ,
            min: 0 /* FieldType.Default */ ,
            max: 0 /* FieldType.Default */ ,
            stdDev: 0 /* FieldType.Default */ 
        };
        /**
         * Metric type. Single measurement or the aggregated value.
         */ this.kind = 0 /* DataPointType.Measurement */ ;
    }
    return DataPoint;
}();



var $5db807982a2eef93$export$efdd3e096bc27746 = /** @class */ function() {
    /**
     * Constructs a new instance of the MetricTelemetry object
     */ function Metric(logger, name, value, count, min, max, stdDev, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            metrics: 1 /* FieldType.Required */ ,
            properties: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        var dataPoint = new (0, $1b80a12d00de7474$export$7e0232b0f089a6b8)();
        dataPoint[0, $b863566731035422$export$e9679ef501b0d1 /* @min:%2ecount */ ] = count > 0 ? count : undefined;
        dataPoint.max = isNaN(max) || max === null ? undefined : max;
        dataPoint.min = isNaN(min) || min === null ? undefined : min;
        dataPoint[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ] = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, name) || (0, $8ac3b4fe9182f568$export$4003f5e1672d759);
        dataPoint.value = value;
        dataPoint.stdDev = isNaN(stdDev) || stdDev === null ? undefined : stdDev;
        _self.metrics = [
            dataPoint
        ];
        _self[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $3ad7e6398fcf0cbb$export$efba9e468fe3b2cf)(logger, properties);
        _self[0, $b863566731035422$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $3ad7e6398fcf0cbb$export$3f0e10abe91e800b)(logger, measurements);
    }
    Metric.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric";
    Metric.dataType = "MetricData";
    return Metric;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

var $7c0ecef5df4b34f7$var$strEmpty = "";
function $7c0ecef5df4b34f7$export$4e47185aa280358c(str, defaultValue) {
    if (defaultValue === void 0) defaultValue = false;
    if (str === undefined || str === null) return defaultValue;
    return str.toString()[0, $b863566731035422$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]() === "true";
}
function $7c0ecef5df4b34f7$export$4460ed97e7c4a927(totalms) {
    if (isNaN(totalms) || totalms < 0) totalms = 0;
    totalms = Math.round(totalms);
    var ms = $7c0ecef5df4b34f7$var$strEmpty + totalms % 1000;
    var sec = $7c0ecef5df4b34f7$var$strEmpty + Math.floor(totalms / 1000) % 60;
    var min = $7c0ecef5df4b34f7$var$strEmpty + Math.floor(totalms / 60000) % 60;
    var hour = $7c0ecef5df4b34f7$var$strEmpty + Math.floor(totalms / 3600000) % 24;
    var days = Math.floor(totalms / 86400000);
    ms = ms[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] === 1 ? "00" + ms : ms[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] === 2 ? "0" + ms : ms;
    sec = sec[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] < 2 ? "0" + sec : sec;
    min = min[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] < 2 ? "0" + min : min;
    hour = hour[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] < 2 ? "0" + hour : hour;
    return (days > 0 ? days + "." : $7c0ecef5df4b34f7$var$strEmpty) + hour + ":" + min + ":" + sec + "." + ms;
}
function $7c0ecef5df4b34f7$export$80a37ba429dff231(extensions, identifier) {
    var extension = null;
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(extensions, function(value) {
        if (value.identifier === identifier) {
            extension = value;
            return -1;
        }
    });
    return extension;
}
function $7c0ecef5df4b34f7$export$8c465f5f14327ccd(message, url, lineNumber, columnNumber, error) {
    return !error && (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(message) && (message === "Script error." || message === "Script error");
}




var $3e77672805d15946$export$12c0fdede1c6bc6c = /** @class */ function() {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */ function PageView(logger, name, url, durationMs, properties, measurements, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            name: 0 /* FieldType.Default */ ,
            url: 0 /* FieldType.Default */ ,
            duration: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ ,
            id: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self.id = (0, $3ad7e6398fcf0cbb$export$808d3905d3d31f01)(logger, id);
        _self.url = (0, $3ad7e6398fcf0cbb$export$356146502a9f860c)(logger, url);
        _self[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ] = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, name) || (0, $8ac3b4fe9182f568$export$4003f5e1672d759);
        if (!isNaN(durationMs)) _self[0, $b863566731035422$export$aa395e58f404db90 /* @min:%2eduration */ ] = (0, $7c0ecef5df4b34f7$export$4460ed97e7c4a927)(durationMs);
        _self[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $3ad7e6398fcf0cbb$export$efba9e468fe3b2cf)(logger, properties);
        _self[0, $b863566731035422$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $3ad7e6398fcf0cbb$export$3f0e10abe91e800b)(logger, measurements);
    }
    PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
    PageView.dataType = "PageviewData";
    return PageView;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



var $97ca5e424f1910ef$export$a7b48490930dbffa = /** @class */ function() {
    /**
     * Constructs a new instance of the RemoteDependencyData object
     */ function RemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
        if (requestAPI === void 0) requestAPI = "Ajax";
        this.aiDataContract = {
            id: 1 /* FieldType.Required */ ,
            ver: 1 /* FieldType.Required */ ,
            name: 0 /* FieldType.Default */ ,
            resultCode: 0 /* FieldType.Default */ ,
            duration: 0 /* FieldType.Default */ ,
            success: 0 /* FieldType.Default */ ,
            data: 0 /* FieldType.Default */ ,
            target: 0 /* FieldType.Default */ ,
            type: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ ,
            kind: 0 /* FieldType.Default */ ,
            value: 0 /* FieldType.Default */ ,
            count: 0 /* FieldType.Default */ ,
            min: 0 /* FieldType.Default */ ,
            max: 0 /* FieldType.Default */ ,
            stdDev: 0 /* FieldType.Default */ ,
            dependencyKind: 0 /* FieldType.Default */ ,
            dependencySource: 0 /* FieldType.Default */ ,
            commandName: 0 /* FieldType.Default */ ,
            dependencyTypeName: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self.id = id;
        _self[0, $b863566731035422$export$aa395e58f404db90 /* @min:%2eduration */ ] = (0, $7c0ecef5df4b34f7$export$4460ed97e7c4a927)(value);
        _self.success = success;
        _self.resultCode = resultCode + "";
        _self.type = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, requestAPI);
        var dependencyFields = (0, $d98f9809e5d6a7c7$export$92b0aba7cb1d0e30)(logger, absoluteUrl, method, commandName);
        _self.data = (0, $3ad7e6398fcf0cbb$export$356146502a9f860c)(logger, commandName) || dependencyFields.data; // get a value from hosturl if commandName not available
        _self.target = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, dependencyFields.target);
        if (correlationContext) _self.target = "".concat(_self.target, " | ").concat(correlationContext);
        _self[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ] = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, dependencyFields[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ]);
        _self[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $3ad7e6398fcf0cbb$export$efba9e468fe3b2cf)(logger, properties);
        _self[0, $b863566731035422$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $3ad7e6398fcf0cbb$export$3f0e10abe91e800b)(logger, measurements);
    }
    RemoteDependencyData.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
    RemoteDependencyData.dataType = "RemoteDependencyData";
    return RemoteDependencyData;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $adb0678ebd5d1780$export$78e1bea9036f120f = /** @class */ function() {
    /**
     * Constructs a new instance of the TraceTelemetry object
     */ function Trace(logger, message, severityLevel, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            message: 1 /* FieldType.Required */ ,
            severityLevel: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        message = message || (0, $8ac3b4fe9182f568$export$4003f5e1672d759);
        _self[0, $b863566731035422$export$923606b70907833e /* @min:%2emessage */ ] = (0, $3ad7e6398fcf0cbb$export$dff84a9939b48dc0)(logger, message);
        _self[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $3ad7e6398fcf0cbb$export$efba9e468fe3b2cf)(logger, properties);
        _self[0, $b863566731035422$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $3ad7e6398fcf0cbb$export$3f0e10abe91e800b)(logger, measurements);
        if (severityLevel) _self[0, $b863566731035422$export$2675b0014c60aa10 /* @min:%2eseverityLevel */ ] = severityLevel;
    }
    Trace.envelopeType = "Microsoft.ApplicationInsights.{0}.Message";
    Trace.dataType = "MessageData";
    return Trace;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $03ee94b6fff0696e$export$709aae57ec681346 = /** @class */ function() {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */ function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            name: 0 /* FieldType.Default */ ,
            url: 0 /* FieldType.Default */ ,
            duration: 0 /* FieldType.Default */ ,
            perfTotal: 0 /* FieldType.Default */ ,
            networkConnect: 0 /* FieldType.Default */ ,
            sentRequest: 0 /* FieldType.Default */ ,
            receivedResponse: 0 /* FieldType.Default */ ,
            domProcessing: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self.url = (0, $3ad7e6398fcf0cbb$export$356146502a9f860c)(logger, url);
        _self[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ] = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, name) || (0, $8ac3b4fe9182f568$export$4003f5e1672d759);
        _self[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $3ad7e6398fcf0cbb$export$efba9e468fe3b2cf)(logger, properties);
        _self[0, $b863566731035422$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $3ad7e6398fcf0cbb$export$3f0e10abe91e800b)(logger, measurements);
        if (cs4BaseData) {
            _self.domProcessing = cs4BaseData.domProcessing;
            _self[0, $b863566731035422$export$aa395e58f404db90 /* @min:%2eduration */ ] = cs4BaseData[0, $b863566731035422$export$aa395e58f404db90 /* @min:%2eduration */ ];
            _self.networkConnect = cs4BaseData.networkConnect;
            _self.perfTotal = cs4BaseData.perfTotal;
            _self[0, $b863566731035422$export$e046465ee502552 /* @min:%2ereceivedResponse */ ] = cs4BaseData[0, $b863566731035422$export$e046465ee502552 /* @min:%2ereceivedResponse */ ];
            _self.sentRequest = cs4BaseData.sentRequest;
        }
    }
    PageViewPerformance.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance";
    PageViewPerformance.dataType = "PageviewPerformanceData";
    return PageViewPerformance;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $1b13bacff23d2e52$export$2d0294657ab35f1b = /** @class */ function() {
    /**
     * Constructs a new instance of telemetry data.
     */ function Data(baseType, data) {
        /**
         * The data contract for serializing this object.
         */ this.aiDataContract = {
            baseType: 1 /* FieldType.Required */ ,
            baseData: 1 /* FieldType.Required */ 
        };
        this.baseType = baseType;
        this.baseData = data;
    }
    return Data;
}();




/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

function $24e80801a3d6c8ab$var$_aiNameFunc(baseName) {
    var aiName = "ai." + baseName + ".";
    return function(name) {
        return aiName + name;
    };
}
var $24e80801a3d6c8ab$var$_aiApplication = $24e80801a3d6c8ab$var$_aiNameFunc("application");
var $24e80801a3d6c8ab$var$_aiDevice = $24e80801a3d6c8ab$var$_aiNameFunc("device");
var $24e80801a3d6c8ab$var$_aiLocation = $24e80801a3d6c8ab$var$_aiNameFunc("location");
var $24e80801a3d6c8ab$var$_aiOperation = $24e80801a3d6c8ab$var$_aiNameFunc("operation");
var $24e80801a3d6c8ab$var$_aiSession = $24e80801a3d6c8ab$var$_aiNameFunc("session");
var $24e80801a3d6c8ab$var$_aiUser = $24e80801a3d6c8ab$var$_aiNameFunc("user");
var $24e80801a3d6c8ab$var$_aiCloud = $24e80801a3d6c8ab$var$_aiNameFunc("cloud");
var $24e80801a3d6c8ab$var$_aiInternal = $24e80801a3d6c8ab$var$_aiNameFunc("internal");
var $24e80801a3d6c8ab$export$8e2bcdf18620784a = /** @class */ function(_super) {
    (0, $dc463ff9724142dd$export$1f9c32e3fbfb8e62)(ContextTagKeys, _super);
    function ContextTagKeys() {
        return _super.call(this) || this;
    }
    return ContextTagKeys;
}((0, $ede407819d2d28c9$export$f0facb5bce2741f0)({
    applicationVersion: $24e80801a3d6c8ab$var$_aiApplication("ver"),
    applicationBuild: $24e80801a3d6c8ab$var$_aiApplication("build"),
    applicationTypeId: $24e80801a3d6c8ab$var$_aiApplication("typeId"),
    applicationId: $24e80801a3d6c8ab$var$_aiApplication("applicationId"),
    applicationLayer: $24e80801a3d6c8ab$var$_aiApplication("layer"),
    deviceId: $24e80801a3d6c8ab$var$_aiDevice("id"),
    deviceIp: $24e80801a3d6c8ab$var$_aiDevice("ip"),
    deviceLanguage: $24e80801a3d6c8ab$var$_aiDevice("language"),
    deviceLocale: $24e80801a3d6c8ab$var$_aiDevice("locale"),
    deviceModel: $24e80801a3d6c8ab$var$_aiDevice("model"),
    deviceFriendlyName: $24e80801a3d6c8ab$var$_aiDevice("friendlyName"),
    deviceNetwork: $24e80801a3d6c8ab$var$_aiDevice("network"),
    deviceNetworkName: $24e80801a3d6c8ab$var$_aiDevice("networkName"),
    deviceOEMName: $24e80801a3d6c8ab$var$_aiDevice("oemName"),
    deviceOS: $24e80801a3d6c8ab$var$_aiDevice("os"),
    deviceOSVersion: $24e80801a3d6c8ab$var$_aiDevice("osVersion"),
    deviceRoleInstance: $24e80801a3d6c8ab$var$_aiDevice("roleInstance"),
    deviceRoleName: $24e80801a3d6c8ab$var$_aiDevice("roleName"),
    deviceScreenResolution: $24e80801a3d6c8ab$var$_aiDevice("screenResolution"),
    deviceType: $24e80801a3d6c8ab$var$_aiDevice("type"),
    deviceMachineName: $24e80801a3d6c8ab$var$_aiDevice("machineName"),
    deviceVMName: $24e80801a3d6c8ab$var$_aiDevice("vmName"),
    deviceBrowser: $24e80801a3d6c8ab$var$_aiDevice("browser"),
    deviceBrowserVersion: $24e80801a3d6c8ab$var$_aiDevice("browserVersion"),
    locationIp: $24e80801a3d6c8ab$var$_aiLocation("ip"),
    locationCountry: $24e80801a3d6c8ab$var$_aiLocation("country"),
    locationProvince: $24e80801a3d6c8ab$var$_aiLocation("province"),
    locationCity: $24e80801a3d6c8ab$var$_aiLocation("city"),
    operationId: $24e80801a3d6c8ab$var$_aiOperation("id"),
    operationName: $24e80801a3d6c8ab$var$_aiOperation("name"),
    operationParentId: $24e80801a3d6c8ab$var$_aiOperation("parentId"),
    operationRootId: $24e80801a3d6c8ab$var$_aiOperation("rootId"),
    operationSyntheticSource: $24e80801a3d6c8ab$var$_aiOperation("syntheticSource"),
    operationCorrelationVector: $24e80801a3d6c8ab$var$_aiOperation("correlationVector"),
    sessionId: $24e80801a3d6c8ab$var$_aiSession("id"),
    sessionIsFirst: $24e80801a3d6c8ab$var$_aiSession("isFirst"),
    sessionIsNew: $24e80801a3d6c8ab$var$_aiSession("isNew"),
    userAccountAcquisitionDate: $24e80801a3d6c8ab$var$_aiUser("accountAcquisitionDate"),
    userAccountId: $24e80801a3d6c8ab$var$_aiUser("accountId"),
    userAgent: $24e80801a3d6c8ab$var$_aiUser("userAgent"),
    userId: $24e80801a3d6c8ab$var$_aiUser("id"),
    userStoreRegion: $24e80801a3d6c8ab$var$_aiUser("storeRegion"),
    userAuthUserId: $24e80801a3d6c8ab$var$_aiUser("authUserId"),
    userAnonymousUserAcquisitionDate: $24e80801a3d6c8ab$var$_aiUser("anonUserAcquisitionDate"),
    userAuthenticatedUserAcquisitionDate: $24e80801a3d6c8ab$var$_aiUser("authUserAcquisitionDate"),
    cloudName: $24e80801a3d6c8ab$var$_aiCloud("name"),
    cloudRole: $24e80801a3d6c8ab$var$_aiCloud("role"),
    cloudRoleVer: $24e80801a3d6c8ab$var$_aiCloud("roleVer"),
    cloudRoleInstance: $24e80801a3d6c8ab$var$_aiCloud("roleInstance"),
    cloudEnvironment: $24e80801a3d6c8ab$var$_aiCloud("environment"),
    cloudLocation: $24e80801a3d6c8ab$var$_aiCloud("location"),
    cloudDeploymentUnit: $24e80801a3d6c8ab$var$_aiCloud("deploymentUnit"),
    internalNodeName: $24e80801a3d6c8ab$var$_aiInternal("nodeName"),
    internalSdkVersion: $24e80801a3d6c8ab$var$_aiInternal("sdkVersion"),
    internalAgentVersion: $24e80801a3d6c8ab$var$_aiInternal("agentVersion"),
    internalSnippet: $24e80801a3d6c8ab$var$_aiInternal("snippet"),
    internalSdkSrc: $24e80801a3d6c8ab$var$_aiInternal("sdkSrc")
}));



/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



function $f5d319867b0979c9$export$2dc41327de8d98f1(item, baseType, envelopeName, logger, customProperties, systemProperties) {
    var _a;
    envelopeName = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, envelopeName) || (0, $8ac3b4fe9182f568$export$4003f5e1672d759);
    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(item) || (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(baseType) || (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(envelopeName)) (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)("Input doesn't contain all required fields");
    var iKey = "";
    if (item[0, $8ac3b4fe9182f568$export$7d566319b90dbb26]) {
        iKey = item[0, $8ac3b4fe9182f568$export$7d566319b90dbb26];
        delete item[0, $8ac3b4fe9182f568$export$7d566319b90dbb26];
    }
    var telemetryItem = (_a = {}, _a[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:name */ ] = envelopeName, _a.time = (0, $ede407819d2d28c9$export$dfaaa8705752128f)(new Date()), _a.iKey = iKey, _a.ext = systemProperties ? systemProperties : {}, _a.tags = [], _a.data = {}, _a.baseType = baseType, _a.baseData = item // Part B
    , _a);
    // Part C
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customProperties)) (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(customProperties, function(prop, value) {
        telemetryItem.data[prop] = value;
    });
    return telemetryItem;
}
var $f5d319867b0979c9$export$7af32501561f3b4a = /** @class */ function() {
    function TelemetryItemCreator() {}
    /**
     * Create a telemetry item that the 1DS channel understands
     * @param item - domain specific properties; part B
     * @param baseType - telemetry item type. ie PageViewData
     * @param envelopeName - name of the envelope. ie Microsoft.ApplicationInsights.<instrumentation key>.PageView
     * @param customProperties - user defined custom properties; part C
     * @param systemProperties - system properties that are added to the context; part A
     * @returns ITelemetryItem that is sent to channel
     */ TelemetryItemCreator.create = $f5d319867b0979c9$export$2dc41327de8d98f1;
    return TelemetryItemCreator;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $6e37c6a219f9960f$export$152f4bb29f8263d0 = {
    UserExt: "user",
    DeviceExt: "device",
    TraceExt: "trace",
    WebExt: "web",
    AppExt: "app",
    OSExt: "os",
    SessionExt: "ses",
    SDKExt: "sdk"
};
var $6e37c6a219f9960f$export$ebc7727f2a4272f6 = new (0, $24e80801a3d6c8ab$export$8e2bcdf18620784a)();





/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
function $26e033f7638321e5$export$58aa8b47bf337bc8(eventName) {
    var event = null;
    if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(Event)) event = new Event(eventName);
    else {
        var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
        if (doc && doc.createEvent) {
            event = doc.createEvent("Event");
            event.initEvent(eventName, true, true);
        }
    }
    return event;
}




/*
 * Application Insights JavaScript SDK - Common, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



// Added to help with minfication
var $02f0ede5277c99cd$var$strOnPrefix = "on";
var $02f0ede5277c99cd$var$strAttachEvent = "attachEvent";
var $02f0ede5277c99cd$var$strAddEventHelper = "addEventListener";
var $02f0ede5277c99cd$var$strDetachEvent = "detachEvent";
var $02f0ede5277c99cd$var$strRemoveEventListener = "removeEventListener";
var $02f0ede5277c99cd$var$strEvents = "events";
var $02f0ede5277c99cd$var$strVisibilityChangeEvt = "visibilitychange";
var $02f0ede5277c99cd$var$strPageHide = "pagehide";
var $02f0ede5277c99cd$var$strPageShow = "pageshow";
var $02f0ede5277c99cd$var$strUnload = "unload";
var $02f0ede5277c99cd$var$strBeforeUnload = "beforeunload";
var $02f0ede5277c99cd$var$strPageHideNamespace = (0, $0e058b881c0798ff$export$eb4a6badb18ead04)("aiEvtPageHide");
var $02f0ede5277c99cd$var$strPageShowNamespace = (0, $0e058b881c0798ff$export$eb4a6badb18ead04)("aiEvtPageShow");
var $02f0ede5277c99cd$var$rRemoveEmptyNs = /\.[\.]+/g;
var $02f0ede5277c99cd$var$rRemoveTrailingEmptyNs = /[\.]+$/;
var $02f0ede5277c99cd$var$_guid = 1;
var $02f0ede5277c99cd$var$elmNodeData = (0, $0e058b881c0798ff$export$b95c3438408d78aa)("events");
var $02f0ede5277c99cd$var$eventNamespace = /^([^.]*)(?:\.(.+)|)/;
function $02f0ede5277c99cd$var$_normalizeNamespace(name) {
    if (name && name[0, $45806013ed348c93$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ]) return name[0, $45806013ed348c93$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g, (0, $aa96917b132802ee$export$5e8607ab26634759));
    return name;
}
function $02f0ede5277c99cd$var$_getEvtNamespace(eventName, evtNamespace) {
    var _a;
    if (evtNamespace) {
        var theNamespace_1 = (0, $aa96917b132802ee$export$5e8607ab26634759);
        if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(evtNamespace)) {
            theNamespace_1 = (0, $aa96917b132802ee$export$5e8607ab26634759);
            (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(evtNamespace, function(name) {
                name = $02f0ede5277c99cd$var$_normalizeNamespace(name);
                if (name) {
                    if (name[0] !== ".") name = "." + name;
                    theNamespace_1 += name;
                }
            });
        } else theNamespace_1 = $02f0ede5277c99cd$var$_normalizeNamespace(evtNamespace);
        if (theNamespace_1) {
            if (theNamespace_1[0] !== ".") theNamespace_1 = "." + theNamespace_1;
            // We may only have the namespace and not an eventName
            eventName = (eventName || (0, $aa96917b132802ee$export$5e8607ab26634759)) + theNamespace_1;
        }
    }
    var parsedEvent = $02f0ede5277c99cd$var$eventNamespace.exec(eventName || (0, $aa96917b132802ee$export$5e8607ab26634759)) || [];
    return _a = {}, _a[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:type */ ] = parsedEvent[1], _a.ns = (parsedEvent[2] || (0, $aa96917b132802ee$export$5e8607ab26634759)).replace($02f0ede5277c99cd$var$rRemoveEmptyNs, ".").replace($02f0ede5277c99cd$var$rRemoveTrailingEmptyNs, (0, $aa96917b132802ee$export$5e8607ab26634759))[0, $45806013ed348c93$export$b889f1d4cb07c706 /* @min:%2esplit */ ](".").sort().join("."), _a;
}
function $02f0ede5277c99cd$export$e2bcc16f65e2a5d2(target, eventName, evtNamespace) {
    var theEvents = [];
    var eventCache = $02f0ede5277c99cd$var$elmNodeData.get(target, $02f0ede5277c99cd$var$strEvents, {}, false);
    var evtName = $02f0ede5277c99cd$var$_getEvtNamespace(eventName, evtNamespace);
    (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(eventCache, function(evtType, registeredEvents) {
        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(registeredEvents, function(value) {
            var _a;
            if (!evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ] || evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ] === value.evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ]) {
                if (!evtName.ns || evtName.ns === evtName.ns) theEvents[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ]((_a = {}, _a[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:name */ ] = value.evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ] + (value.evtName.ns ? "." + value.evtName.ns : (0, $aa96917b132802ee$export$5e8607ab26634759)), _a.handler = value[0, $45806013ed348c93$export$b353fcbe1ae31450 /* @min:%2ehandler */ ], _a));
            }
        });
    });
    return theEvents;
}
// Exported for internal unit testing only
function $02f0ede5277c99cd$var$_getRegisteredEvents(target, evtName, addDefault) {
    if (addDefault === void 0) addDefault = true;
    var aiEvts = $02f0ede5277c99cd$var$elmNodeData.get(target, $02f0ede5277c99cd$var$strEvents, {}, addDefault);
    var registeredEvents = aiEvts[evtName];
    if (!registeredEvents) registeredEvents = aiEvts[evtName] = [];
    return registeredEvents;
}
function $02f0ede5277c99cd$var$_doDetach(obj, evtName, handlerRef, useCapture) {
    if (obj && evtName && evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ]) {
        if (obj[$02f0ede5277c99cd$var$strRemoveEventListener]) obj[$02f0ede5277c99cd$var$strRemoveEventListener](evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ], handlerRef, useCapture);
        else if (obj[$02f0ede5277c99cd$var$strDetachEvent]) obj[$02f0ede5277c99cd$var$strDetachEvent]($02f0ede5277c99cd$var$strOnPrefix + evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ], handlerRef);
    }
}
function $02f0ede5277c99cd$var$_doAttach(obj, evtName, handlerRef, useCapture) {
    var result = false;
    if (obj && evtName && evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ] && handlerRef) {
        if (obj[$02f0ede5277c99cd$var$strAddEventHelper]) {
            // all browsers except IE before version 9
            obj[$02f0ede5277c99cd$var$strAddEventHelper](evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ], handlerRef, useCapture);
            result = true;
        } else if (obj[$02f0ede5277c99cd$var$strAttachEvent]) {
            // IE before version 9
            obj[$02f0ede5277c99cd$var$strAttachEvent]($02f0ede5277c99cd$var$strOnPrefix + evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ], handlerRef);
            result = true;
        }
    }
    return result;
}
function $02f0ede5277c99cd$var$_doUnregister(target, events, evtName, unRegFn) {
    var idx = events[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
    while(idx--){
        var theEvent = events[idx];
        if (theEvent) {
            if (!evtName.ns || evtName.ns === theEvent.evtName.ns) {
                if (!unRegFn || unRegFn(theEvent)) {
                    $02f0ede5277c99cd$var$_doDetach(target, theEvent.evtName, theEvent[0, $45806013ed348c93$export$b353fcbe1ae31450 /* @min:%2ehandler */ ], theEvent.capture);
                    // Remove the registered event
                    events[0, $45806013ed348c93$export$84020a2e4fe863b0 /* @min:%2esplice */ ](idx, 1);
                }
            }
        }
    }
}
function $02f0ede5277c99cd$var$_unregisterEvents(target, evtName, unRegFn) {
    if (evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ]) $02f0ede5277c99cd$var$_doUnregister(target, $02f0ede5277c99cd$var$_getRegisteredEvents(target, evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ]), evtName, unRegFn);
    else {
        var eventCache = $02f0ede5277c99cd$var$elmNodeData.get(target, $02f0ede5277c99cd$var$strEvents, {});
        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(eventCache, function(evtType, events) {
            $02f0ede5277c99cd$var$_doUnregister(target, events, evtName, unRegFn);
        });
        // Cleanup
        if ((0, $5831ddb3a0caf7c7$export$f7628dc18f4211e5)(eventCache)[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] === 0) $02f0ede5277c99cd$var$elmNodeData.kill(target, $02f0ede5277c99cd$var$strEvents);
    }
}
function $02f0ede5277c99cd$export$3f37a50e0edde3be(theNamespace, namespaces) {
    var newNamespaces;
    if (namespaces) {
        if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(namespaces)) newNamespaces = [
            theNamespace
        ].concat(namespaces);
        else newNamespaces = [
            theNamespace,
            namespaces
        ];
        // resort the namespaces so they are always in order
        newNamespaces = $02f0ede5277c99cd$var$_getEvtNamespace("xx", newNamespaces).ns[0, $45806013ed348c93$export$b889f1d4cb07c706 /* @min:%2esplit */ ](".");
    } else newNamespaces = theNamespace;
    return newNamespaces;
}
function $02f0ede5277c99cd$export$324ab159353a60a9(target, eventName, handlerRef, evtNamespace, useCapture) {
    var _a;
    if (useCapture === void 0) useCapture = false;
    var result = false;
    if (target) try {
        var evtName = $02f0ede5277c99cd$var$_getEvtNamespace(eventName, evtNamespace);
        result = $02f0ede5277c99cd$var$_doAttach(target, evtName, handlerRef, useCapture);
        if (result && $02f0ede5277c99cd$var$elmNodeData.accept(target)) {
            var registeredEvent = (_a = {
                guid: $02f0ede5277c99cd$var$_guid++,
                evtName: evtName
            }, _a[0, $45806013ed348c93$export$b353fcbe1ae31450 /* @min:handler */ ] = handlerRef, _a.capture = useCapture, _a);
            $02f0ede5277c99cd$var$_getRegisteredEvents(target, evtName.type)[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](registeredEvent);
        }
    } catch (e) {
    // Just Ignore any error so that we don't break any execution path
    }
    return result;
}
function $02f0ede5277c99cd$export$51dedceb7c784eff(target, eventName, handlerRef, evtNamespace, useCapture) {
    if (useCapture === void 0) useCapture = false;
    if (target) try {
        var evtName_1 = $02f0ede5277c99cd$var$_getEvtNamespace(eventName, evtNamespace);
        var found_1 = false;
        $02f0ede5277c99cd$var$_unregisterEvents(target, evtName_1, function(regEvent) {
            if (evtName_1.ns && !handlerRef || regEvent[0, $45806013ed348c93$export$b353fcbe1ae31450 /* @min:%2ehandler */ ] === handlerRef) {
                found_1 = true;
                return true;
            }
            return false;
        });
        if (!found_1) // fallback to try and remove as requested
        $02f0ede5277c99cd$var$_doDetach(target, evtName_1, handlerRef, useCapture);
    } catch (e) {
    // Just Ignore any error so that we don't break any execution path
    }
}
function $02f0ede5277c99cd$export$c7861dcba2385fcd(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) useCapture = false;
    return $02f0ede5277c99cd$export$324ab159353a60a9(obj, eventNameWithoutOn, handlerRef, null, useCapture);
}
function $02f0ede5277c99cd$export$647f6b935c1d6b6(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) useCapture = false;
    $02f0ede5277c99cd$export$51dedceb7c784eff(obj, eventNameWithoutOn, handlerRef, null, useCapture);
}
function $02f0ede5277c99cd$export$3b37be979ee3303a(eventName, callback, evtNamespace) {
    var result = false;
    var w = (0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)();
    if (w) {
        result = $02f0ede5277c99cd$export$324ab159353a60a9(w, eventName, callback, evtNamespace);
        result = $02f0ede5277c99cd$export$324ab159353a60a9(w["body"], eventName, callback, evtNamespace) || result;
    }
    var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
    if (doc) result = $02f0ede5277c99cd$export$324ab159353a60a9(doc, eventName, callback, evtNamespace) || result;
    return result;
}
function $02f0ede5277c99cd$export$546f5991fce5bf06(eventName, callback, evtNamespace) {
    var w = (0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)();
    if (w) {
        $02f0ede5277c99cd$export$51dedceb7c784eff(w, eventName, callback, evtNamespace);
        $02f0ede5277c99cd$export$51dedceb7c784eff(w["body"], eventName, callback, evtNamespace);
    }
    var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
    if (doc) $02f0ede5277c99cd$export$51dedceb7c784eff(doc, eventName, callback, evtNamespace);
}
/**
 * Bind the listener to the array of events
 * @param events - An string array of event names to bind the listener to
 * @param listener - The event callback to call when the event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */ function $02f0ede5277c99cd$var$_addEventListeners(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && events[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(events, function(name) {
        if (name) {
            if (!excludeEvents || (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(excludeEvents, name) === -1) added = $02f0ede5277c99cd$export$3b37be979ee3303a(name, listener, evtNamespace) || added;
        }
    });
    return added;
}
function $02f0ede5277c99cd$export$40a4ed63e5cb7043(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(events)) {
        added = $02f0ede5277c99cd$var$_addEventListeners(events, listener, excludeEvents, evtNamespace);
        if (!added && excludeEvents && excludeEvents[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) // Failed to add any listeners and we excluded some, so just attempt to add the excluded events
        added = $02f0ede5277c99cd$var$_addEventListeners(events, listener, null, evtNamespace);
    }
    return added;
}
function $02f0ede5277c99cd$export$8c7b13b21690651d(events, listener, evtNamespace) {
    if (events && (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(events)) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(events, function(name) {
        if (name) $02f0ede5277c99cd$export$546f5991fce5bf06(name, listener, evtNamespace);
    });
}
function $02f0ede5277c99cd$export$f16ce149aca77fdd(listener, excludeEvents, evtNamespace) {
    // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
    // As just hooking the window does not always fire (on chrome) for page navigation's.
    return $02f0ede5277c99cd$export$40a4ed63e5cb7043([
        $02f0ede5277c99cd$var$strBeforeUnload,
        $02f0ede5277c99cd$var$strUnload,
        $02f0ede5277c99cd$var$strPageHide
    ], listener, excludeEvents, evtNamespace);
}
function $02f0ede5277c99cd$export$272dc813b0b2654c(listener, evtNamespace) {
    $02f0ede5277c99cd$export$8c7b13b21690651d([
        $02f0ede5277c99cd$var$strBeforeUnload,
        $02f0ede5277c99cd$var$strUnload,
        $02f0ede5277c99cd$var$strPageHide
    ], listener, evtNamespace);
}
function $02f0ede5277c99cd$export$46744aee53e5e558(listener, excludeEvents, evtNamespace) {
    function _handlePageVisibility(evt) {
        var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
        if (listener && doc && doc.visibilityState === "hidden") listener(evt);
    }
    // add the unique page show namespace to any provided namespace so we can only remove the ones added by "pagehide"
    var newNamespaces = $02f0ede5277c99cd$export$3f37a50e0edde3be($02f0ede5277c99cd$var$strPageHideNamespace, evtNamespace);
    var pageUnloadAdded = $02f0ede5277c99cd$var$_addEventListeners([
        $02f0ede5277c99cd$var$strPageHide
    ], listener, excludeEvents, newNamespaces);
    if (!excludeEvents || (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(excludeEvents, $02f0ede5277c99cd$var$strVisibilityChangeEvt) === -1) pageUnloadAdded = $02f0ede5277c99cd$var$_addEventListeners([
        $02f0ede5277c99cd$var$strVisibilityChangeEvt
    ], _handlePageVisibility, excludeEvents, newNamespaces) || pageUnloadAdded;
    if (!pageUnloadAdded && excludeEvents) // Failed to add any listeners and we where requested to exclude some, so just call again without excluding anything
    pageUnloadAdded = $02f0ede5277c99cd$export$46744aee53e5e558(listener, null, evtNamespace);
    return pageUnloadAdded;
}
function $02f0ede5277c99cd$export$6aca6ee3a147169f(listener, evtNamespace) {
    // add the unique page show namespace to any provided namespace so we only remove the ones added by "pagehide"
    var newNamespaces = $02f0ede5277c99cd$export$3f37a50e0edde3be($02f0ede5277c99cd$var$strPageHideNamespace, evtNamespace);
    $02f0ede5277c99cd$export$8c7b13b21690651d([
        $02f0ede5277c99cd$var$strPageHide
    ], listener, newNamespaces);
    $02f0ede5277c99cd$export$8c7b13b21690651d([
        $02f0ede5277c99cd$var$strVisibilityChangeEvt
    ], null, newNamespaces);
}
function $02f0ede5277c99cd$export$cce4a6563c734c0(listener, excludeEvents, evtNamespace) {
    function _handlePageVisibility(evt) {
        var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
        if (listener && doc && doc.visibilityState === "visible") listener(evt);
    }
    // add the unique page show namespace to any provided namespace so we can only remove the ones added by "pageshow"
    var newNamespaces = $02f0ede5277c99cd$export$3f37a50e0edde3be($02f0ede5277c99cd$var$strPageShowNamespace, evtNamespace);
    var pageShowAdded = $02f0ede5277c99cd$var$_addEventListeners([
        $02f0ede5277c99cd$var$strPageShow
    ], listener, excludeEvents, newNamespaces);
    pageShowAdded = $02f0ede5277c99cd$var$_addEventListeners([
        $02f0ede5277c99cd$var$strVisibilityChangeEvt
    ], _handlePageVisibility, excludeEvents, newNamespaces) || pageShowAdded;
    if (!pageShowAdded && excludeEvents) // Failed to add any listeners and we where requested to exclude some, so just call again without excluding anything
    pageShowAdded = $02f0ede5277c99cd$export$cce4a6563c734c0(listener, null, evtNamespace);
    return pageShowAdded;
}
function $02f0ede5277c99cd$export$c49093a8bd06690f(listener, evtNamespace) {
    // add the unique page show namespace to any provided namespace so we only remove the ones added by "pageshow"
    var newNamespaces = $02f0ede5277c99cd$export$3f37a50e0edde3be($02f0ede5277c99cd$var$strPageShowNamespace, evtNamespace);
    $02f0ede5277c99cd$export$8c7b13b21690651d([
        $02f0ede5277c99cd$var$strPageShow
    ], listener, newNamespaces);
    $02f0ede5277c99cd$export$8c7b13b21690651d([
        $02f0ede5277c99cd$var$strVisibilityChangeEvt
    ], null, newNamespaces);
}



function $f77eaff1f963d24b$var$_disableEvents(target, evtNamespace) {
    (0, $02f0ede5277c99cd$export$51dedceb7c784eff)(target, null, null, evtNamespace);
}
function $f77eaff1f963d24b$export$798b7fe42d5e3d06(parentEvtNamespace) {
    var _document = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
    var _navigator = (0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)(); // Gets the window.navigator or workerNavigator depending on the global
    var _isListening = false;
    var listenerList = [];
    // Set the initial state
    // rState is changed by the browser, both via events and when we check the navigator.onLine property
    var rState = 1 /* eOfflineValue.Online */ ;
    if (_navigator && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_navigator.onLine) && !_navigator.onLine) rState = 2 /* eOfflineValue.Offline */ ;
    // ustate is changed by the user calling setOnlineState
    var uState = 0 /* eOfflineValue.Unknown */ ;
    // current state would be updated each time rState or uState is changed
    // it is a resolved value of rState and uState
    var _currentState = calCurrentState();
    var _evtNamespace = (0, $02f0ede5277c99cd$export$3f37a50e0edde3be)((0, $0e058b881c0798ff$export$eb4a6badb18ead04)("OfflineListener"), parentEvtNamespace);
    try {
        if (_enableEvents((0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)())) _isListening = true;
        if (_document) {
            // Also attach to the document.body or document
            var target = _document.body || _document;
            if (target.ononline) {
                if (_enableEvents(target)) _isListening = true;
            }
        }
    } catch (e) {
        // this makes react-native less angry
        _isListening = false;
    }
    function _enableEvents(target) {
        var enabled = false;
        if (target) {
            enabled = (0, $02f0ede5277c99cd$export$324ab159353a60a9)(target, "online", _setOnline, _evtNamespace);
            if (enabled) (0, $02f0ede5277c99cd$export$324ab159353a60a9)(target, "offline", _setOffline, _evtNamespace);
        }
        return enabled;
    }
    function _isOnline() {
        return _currentState;
    }
    function calCurrentState() {
        if (uState === 2 /* eOfflineValue.Offline */  || rState === 2 /* eOfflineValue.Offline */ ) return false;
        return true; // if both unknown, then we assume the network is good
    }
    function listnerNoticeCheck() {
        // we were offline and are now online or we were online and now offline
        var newState = calCurrentState();
        if (_currentState !== newState) {
            _currentState = newState; // use the resolved state to update
            // send all the callbacks with the current state
            (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(listenerList, function(callback) {
                var offlineState = {
                    isOnline: _currentState,
                    rState: rState,
                    uState: uState
                };
                try {
                    callback(offlineState);
                } catch (e) {
                // Do nothing, just making sure we run all of the callbacks
                }
            });
        }
    }
    function setOnlineState(newState) {
        uState = newState;
        listnerNoticeCheck();
    }
    function _setOnline() {
        rState = 1 /* eOfflineValue.Online */ ;
        listnerNoticeCheck();
    }
    function _setOffline() {
        rState = 2 /* eOfflineValue.Offline */ ;
        listnerNoticeCheck();
    }
    function _unload() {
        var win = (0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)();
        if (win && _isListening) {
            $f77eaff1f963d24b$var$_disableEvents(win, _evtNamespace);
            if (_document) {
                // Also attach to the document.body or document
                var target = _document.body || _document;
                if (!(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(target.ononline)) $f77eaff1f963d24b$var$_disableEvents(target, _evtNamespace);
            }
            _isListening = false;
        }
    }
    function addListener(callback) {
        listenerList[0, $b863566731035422$export$a0a330e7fa1e278c /* @min:%2epush */ ](callback);
        // Define rm as an instance of IUnloadHook
        return {
            rm: function() {
                var index = listenerList.indexOf(callback);
                if (index > -1) return listenerList.splice(index, 1);
                else return;
            }
        };
    }
    return {
        isOnline: _isOnline,
        isListening: function() {
            return _isListening;
        },
        unload: _unload,
        addListener: addListener,
        setOnlineState: setOnlineState
    };
}


var $5343a490b8ca01c7$export$2268e69a6d93b7cc = "AppInsightsPropertiesPlugin";
var $5343a490b8ca01c7$export$a714a094d3058c99 = "AppInsightsChannelPlugin";
var $5343a490b8ca01c7$export$862d858b0002f352 = "ApplicationInsightsAnalytics";


/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 






/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 






/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



var $67947f06182dbd51$var$strExecutionContextKey = "ctx";
var $67947f06182dbd51$var$strParentContextKey = "ParentContextKey";
var $67947f06182dbd51$var$strChildrenContextKey = "ChildrenContextKey";
var $67947f06182dbd51$var$_defaultPerfManager = null;
var $67947f06182dbd51$export$e3556d2ce46cdae0 = /** @class */ function() {
    function PerfEvent(name, payloadDetails, isAsync) {
        var _self = this;
        _self.start = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)();
        _self[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:%2ename */ ] = name;
        _self[0, $45806013ed348c93$export$d8114c9e990204cb /* @min:%2eisAsync */ ] = isAsync;
        _self[0, $45806013ed348c93$export$3a89026537e5dfec /* @min:%2eisChildEvt */ ] = function() {
            return false;
        };
        if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(payloadDetails)) {
            // Create an accessor to minimize the potential performance impact of executing the payloadDetails callback
            var theDetails_1;
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "payload", {
                g: function() {
                    // Delay the execution of the payloadDetails until needed
                    if (!theDetails_1 && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(payloadDetails)) {
                        theDetails_1 = payloadDetails();
                        // clear it out now so the referenced objects can be garbage collected
                        payloadDetails = null;
                    }
                    return theDetails_1;
                }
            });
        }
        _self[0, $45806013ed348c93$export$c405fd80acb80a5b /* @min:%2egetCtx */ ] = function(key) {
            if (key) {
                // The parent and child links are located directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent[$67947f06182dbd51$var$strParentContextKey] || key === PerfEvent[$67947f06182dbd51$var$strChildrenContextKey]) return _self[key];
                return (_self[$67947f06182dbd51$var$strExecutionContextKey] || {})[key];
            }
            return null;
        };
        _self[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ] = function(key, value) {
            if (key) {
                // Put the parent and child links directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent[$67947f06182dbd51$var$strParentContextKey]) {
                    // Simple assumption, if we are setting a parent then we must be a child
                    if (!_self[key]) _self[0, $45806013ed348c93$export$3a89026537e5dfec /* @min:%2eisChildEvt */ ] = function() {
                        return true;
                    };
                    _self[key] = value;
                } else if (key === PerfEvent[$67947f06182dbd51$var$strChildrenContextKey]) _self[key] = value;
                else {
                    var ctx = _self[$67947f06182dbd51$var$strExecutionContextKey] = _self[$67947f06182dbd51$var$strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            }
        };
        _self[0, $45806013ed348c93$export$b6736e780b133181 /* @min:%2ecomplete */ ] = function() {
            var childTime = 0;
            var childEvts = _self[0, $45806013ed348c93$export$c405fd80acb80a5b /* @min:%2egetCtx */ ](PerfEvent[$67947f06182dbd51$var$strChildrenContextKey]);
            if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(childEvts)) for(var lp = 0; lp < childEvts[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++){
                var childEvt = childEvts[lp];
                if (childEvt) childTime += childEvt[0, $45806013ed348c93$export$7b5ba5854159c1f0 /* @min:%2etime */ ];
            }
            _self[0, $45806013ed348c93$export$7b5ba5854159c1f0 /* @min:%2etime */ ] = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)() - _self.start;
            _self.exTime = _self[0, $45806013ed348c93$export$7b5ba5854159c1f0 /* @min:%2etime */ ] - childTime;
            _self[0, $45806013ed348c93$export$b6736e780b133181 /* @min:%2ecomplete */ ] = function() {};
        };
    }
    PerfEvent.ParentContextKey = "parent";
    PerfEvent.ChildrenContextKey = "childEvts";
    return PerfEvent;
}();
var $67947f06182dbd51$export$cbeb6df2e8e9b5ae = /** @class */ function() {
    function PerfManager(manager) {
        /**
         * General bucket used for execution context set and retrieved via setCtx() and getCtx.
         * Defined as private so it can be visualized via the DebugPlugin
         */ this.ctx = {};
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(PerfManager, this, function(_self) {
            _self.create = function(src, payloadDetails, isAsync) {
                // TODO (@MSNev): at some point we will want to add additional configuration to "select" which events to instrument
                // for now this is just a simple do everything.
                return new $67947f06182dbd51$export$e3556d2ce46cdae0(src, payloadDetails, isAsync);
            };
            _self.fire = function(perfEvent) {
                if (perfEvent) {
                    perfEvent[0, $45806013ed348c93$export$b6736e780b133181 /* @min:%2ecomplete */ ]();
                    if (manager && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(manager[0, $aa96917b132802ee$export$5d265841733c97c3 /* @min:%2eperfEvent */ ])) manager[0, $aa96917b132802ee$export$5d265841733c97c3 /* @min:%2eperfEvent */ ](perfEvent);
                }
            };
            _self[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ] = function(key, value) {
                if (key) {
                    var ctx = _self[$67947f06182dbd51$var$strExecutionContextKey] = _self[$67947f06182dbd51$var$strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            };
            _self[0, $45806013ed348c93$export$c405fd80acb80a5b /* @min:%2egetCtx */ ] = function(key) {
                return (_self[$67947f06182dbd51$var$strExecutionContextKey] || {})[key];
            };
        });
    }
    // Removed Stub for PerfManager.prototype.create.
    // Removed Stub for PerfManager.prototype.fire.
    // Removed Stub for PerfManager.prototype.setCtx.
    // Removed Stub for PerfManager.prototype.getCtx.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PerfManager.__ieDyn = 1;
    return PerfManager;
}();
var $67947f06182dbd51$var$doPerfActiveKey = "CoreUtils.doPerf";
function $67947f06182dbd51$export$c6fbeb260600c482(mgrSource, getSource, func, details, isAsync) {
    if (mgrSource) {
        var perfMgr = mgrSource;
        if (perfMgr[0, $aa96917b132802ee$export$f8b08c7de64edfbf]) // Looks like a perf manager provider object
        perfMgr = perfMgr[0, $aa96917b132802ee$export$f8b08c7de64edfbf]();
        if (perfMgr) {
            var perfEvt = void 0;
            var currentActive = perfMgr[0, $45806013ed348c93$export$c405fd80acb80a5b /* @min:%2egetCtx */ ]($67947f06182dbd51$var$doPerfActiveKey);
            try {
                perfEvt = perfMgr.create(getSource(), details, isAsync);
                if (perfEvt) {
                    if (currentActive && perfEvt[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]) {
                        perfEvt[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]($67947f06182dbd51$export$e3556d2ce46cdae0[$67947f06182dbd51$var$strParentContextKey], currentActive);
                        if (currentActive[0, $45806013ed348c93$export$c405fd80acb80a5b /* @min:%2egetCtx */ ] && currentActive[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]) {
                            var children = currentActive[0, $45806013ed348c93$export$c405fd80acb80a5b /* @min:%2egetCtx */ ]($67947f06182dbd51$export$e3556d2ce46cdae0[$67947f06182dbd51$var$strChildrenContextKey]);
                            if (!children) {
                                children = [];
                                currentActive[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]($67947f06182dbd51$export$e3556d2ce46cdae0[$67947f06182dbd51$var$strChildrenContextKey], children);
                            }
                            children[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](perfEvt);
                        }
                    }
                    // Set this event as the active event now
                    perfMgr[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]($67947f06182dbd51$var$doPerfActiveKey, perfEvt);
                    return func(perfEvt);
                }
            } catch (ex) {
                if (perfEvt && perfEvt[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]) perfEvt[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]("exception", ex);
            } finally{
                // fire the perf event
                if (perfEvt) perfMgr.fire(perfEvt);
                // Reset the active event to the previous value
                perfMgr[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]($67947f06182dbd51$var$doPerfActiveKey, currentActive);
            }
        }
    }
    return func();
}
function $67947f06182dbd51$export$1e94af82fd6977f1(perfManager) {
    $67947f06182dbd51$var$_defaultPerfManager = perfManager;
}
function $67947f06182dbd51$export$6cdbf3f34ace6568() {
    return $67947f06182dbd51$var$_defaultPerfManager;
}


/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




"use strict";
var $e144361666ed071d$var$pluginStateData = (0, $0e058b881c0798ff$export$b95c3438408d78aa)("plugin");
function $e144361666ed071d$export$37cfaecb9b4b1b3b(plugin) {
    return $e144361666ed071d$var$pluginStateData.get(plugin, "state", {}, true);
}
function $e144361666ed071d$export$be211df7b1eeb33e(processContext, extensions) {
    // Set the next plugin and identified the uninitialized plugins
    var initPlugins = [];
    var lastPlugin = null;
    var proxy = processContext[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ]();
    var pluginState;
    while(proxy){
        var thePlugin = proxy[0, $45806013ed348c93$export$37717a508eca6e2d /* @min:%2egetPlugin */ ]();
        if (thePlugin) {
            if (lastPlugin && lastPlugin[0, $45806013ed348c93$export$55d672a1dc4d50c1 /* @min:%2esetNextPlugin */ ] && thePlugin[0, $aa96917b132802ee$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ]) // Set this plugin as the next for the previous one
            lastPlugin[0, $45806013ed348c93$export$55d672a1dc4d50c1 /* @min:%2esetNextPlugin */ ](thePlugin);
            pluginState = $e144361666ed071d$export$37cfaecb9b4b1b3b(thePlugin);
            var isInitialized = !!pluginState[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ];
            if (thePlugin[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ]) isInitialized = thePlugin[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ]();
            if (!isInitialized) initPlugins[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](thePlugin);
            lastPlugin = thePlugin;
            proxy = proxy[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ]();
        }
    }
    // Now initialize the plugins
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(initPlugins, function(thePlugin) {
        var core = processContext[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ]();
        thePlugin[0, $45806013ed348c93$export$65cd33bb52d04675 /* @min:%2einitialize */ ](processContext.getCfg(), core, extensions, processContext[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ]());
        pluginState = $e144361666ed071d$export$37cfaecb9b4b1b3b(thePlugin);
        // Only add the core to the state if the plugin didn't set it (doesn't extend from BaseTelemetryPlugin)
        if (!thePlugin[0, $aa96917b132802ee$export$3094ace9cd82ff99] && !pluginState[0, $aa96917b132802ee$export$3094ace9cd82ff99]) pluginState[0, $aa96917b132802ee$export$3094ace9cd82ff99] = core;
        pluginState[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ] = true;
        delete pluginState[0, $45806013ed348c93$export$7176fb2a7d11927e /* @min:%2eteardown */ ];
    });
}
function $e144361666ed071d$export$478771939b7b39a2(plugins) {
    // Sort by priority
    return plugins.sort(function(extA, extB) {
        var result = 0;
        if (extB) {
            var bHasProcess = extB[0, $aa96917b132802ee$export$820a3bce4a265606];
            if (extA[0, $aa96917b132802ee$export$820a3bce4a265606]) result = bHasProcess ? extA[0, $aa96917b132802ee$export$58efcc07763b37be] - extB[0, $aa96917b132802ee$export$58efcc07763b37be] : 1;
            else if (bHasProcess) result = -1;
        } else result = extA ? 1 : -1;
        return result;
    });
// sort complete
}
function $e144361666ed071d$export$24978f1b175640d9(components, unloadCtx, unloadState, asyncCallback) {
    var idx = 0;
    function _doUnload() {
        while(idx < components[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]){
            var component = components[idx++];
            if (component) {
                var func = component._doUnload || component[0, $45806013ed348c93$export$458d234b616d0745 /* @min:%2e_doTeardown */ ];
                if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(func)) {
                    if (func.call(component, unloadCtx, unloadState, _doUnload) === true) return true;
                }
            }
        }
    }
    return _doUnload();
}
function $e144361666ed071d$export$10fa4480433f402c(parentCtx) {
    var trace = {};
    return {
        getName: function() {
            return trace[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:%2ename */ ];
        },
        setName: function(newValue) {
            parentCtx && parentCtx.setName(newValue);
            trace[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:%2ename */ ] = newValue;
        },
        getTraceId: function() {
            return trace[0, $45806013ed348c93$export$a5eb52c53bba8560 /* @min:%2etraceId */ ];
        },
        setTraceId: function(newValue) {
            parentCtx && parentCtx.setTraceId(newValue);
            if ((0, $4726195e2d737947$export$29dd34cf1269f6da)(newValue)) trace[0, $45806013ed348c93$export$a5eb52c53bba8560 /* @min:%2etraceId */ ] = newValue;
        },
        getSpanId: function() {
            return trace[0, $45806013ed348c93$export$c105b94efa183847 /* @min:%2espanId */ ];
        },
        setSpanId: function(newValue) {
            parentCtx && parentCtx.setSpanId(newValue);
            if ((0, $4726195e2d737947$export$8e51c6d8f0586aff)(newValue)) trace[0, $45806013ed348c93$export$c105b94efa183847 /* @min:%2espanId */ ] = newValue;
        },
        getTraceFlags: function() {
            return trace[0, $45806013ed348c93$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ];
        },
        setTraceFlags: function(newTraceFlags) {
            parentCtx && parentCtx.setTraceFlags(newTraceFlags);
            trace[0, $45806013ed348c93$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] = newTraceFlags;
        }
    };
}


"use strict";
var $21bc92e23804c647$var$strTelemetryPluginChain = "TelemetryPluginChain";
var $21bc92e23804c647$var$strHasRunFlags = "_hasRun";
var $21bc92e23804c647$var$strGetTelCtx = "_getTelCtx";
var $21bc92e23804c647$var$_chainId = 0;
function $21bc92e23804c647$var$_getNextProxyStart(proxy, core, startAt) {
    while(proxy){
        if (proxy[0, $45806013ed348c93$export$37717a508eca6e2d /* @min:%2egetPlugin */ ]() === startAt) return proxy;
        proxy = proxy[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ]();
    }
    // This wasn't found in the existing chain so create an isolated one with just this plugin
    return $21bc92e23804c647$export$107e639207cdf742([
        startAt
    ], core.config || {}, core);
}
/**
 * @ignore
 * @param telemetryChain
 * @param dynamicHandler
 * @param core
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 * @returns
 */ function $21bc92e23804c647$var$_createInternalContext(telemetryChain, dynamicHandler, core, startAt) {
    // We have a special case where we want to start execution from this specific plugin
    // or we simply reuse the existing telemetry plugin chain (normal execution case)
    var _nextProxy = null; // By Default set as no next plugin
    var _onComplete = [];
    if (!dynamicHandler) dynamicHandler = (0, $6387583e0b25820c$export$3a9e9180c14487fd)({}, null, core[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ]);
    if (startAt !== null) // There is no next element (null) vs not defined (undefined) so use the full chain
    _nextProxy = startAt ? $21bc92e23804c647$var$_getNextProxyStart(telemetryChain, core, startAt) : telemetryChain;
    var context = {
        _next: _moveNext,
        ctx: {
            core: function() {
                return core;
            },
            diagLog: function() {
                return (0, $bacca83328a730a7$export$5102d32ea1d740a)(core, dynamicHandler.cfg);
            },
            getCfg: function() {
                return dynamicHandler.cfg;
            },
            getExtCfg: _resolveExtCfg,
            getConfig: _getConfig,
            hasNext: function() {
                return !!_nextProxy;
            },
            getNext: function() {
                return _nextProxy;
            },
            setNext: function(nextPlugin) {
                _nextProxy = nextPlugin;
            },
            iterate: _iterateChain,
            onComplete: _addOnComplete
        }
    };
    function _addOnComplete(onComplete, that) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        if (onComplete) _onComplete[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ]({
            func: onComplete,
            self: !(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(that) ? that : context.ctx,
            args: args
        });
    }
    function _moveNext() {
        var nextProxy = _nextProxy;
        // Automatically move to the next plugin
        _nextProxy = nextProxy ? nextProxy[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ]() : null;
        if (!nextProxy) {
            var onComplete = _onComplete;
            if (onComplete && onComplete[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(onComplete, function(completeDetails) {
                    try {
                        completeDetails.func.call(completeDetails.self, completeDetails.args);
                    } catch (e) {
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(core[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ], 2 /* eLoggingSeverity.WARNING */ , 73 /* _eInternalMessageId.PluginException */ , "Unexpected Exception during onComplete - " + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
                    }
                });
                _onComplete = [];
            }
        }
        return nextProxy;
    }
    function _getExtCfg(identifier, createIfMissing) {
        var idCfg = null;
        var cfg = dynamicHandler.cfg;
        if (cfg && identifier) {
            var extCfg = cfg[0, $aa96917b132802ee$export$ffb2356587263734 /* @min:%2eextensionConfig */ ];
            if (!extCfg && createIfMissing) extCfg = {};
            // Always set the value so that the property always exists
            cfg[0, $aa96917b132802ee$export$ffb2356587263734] = extCfg; // Note: it is valid for the "value" to be undefined
            // Calling `ref()` has a side effect of causing the referenced property to become dynamic  (if not already)
            extCfg = dynamicHandler.ref(cfg, (0, $aa96917b132802ee$export$ffb2356587263734));
            if (extCfg) {
                idCfg = extCfg[identifier];
                if (!idCfg && createIfMissing) idCfg = {};
                // Always set the value so that the property always exists
                extCfg[identifier] = idCfg; // Note: it is valid for the "value" to be undefined
                // Calling `ref()` has a side effect of causing the referenced property to become dynamic  (if not already)
                idCfg = dynamicHandler.ref(extCfg, identifier);
            }
        }
        return idCfg;
    }
    function _resolveExtCfg(identifier, defaultValues) {
        var newConfig = _getExtCfg(identifier, true);
        if (defaultValues) // Enumerate over the defaultValues and if not already populated attempt to
        // find a value from the root config or use the default value
        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(defaultValues, function(field, defaultValue) {
            // for each unspecified field, set the default value
            if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(newConfig[field])) {
                var cfgValue = dynamicHandler.cfg[field];
                if (cfgValue || !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(cfgValue)) newConfig[field] = cfgValue;
            }
            (0, $2858d2db0bf490e5$export$f11b7d3a4617b9e9)(dynamicHandler, newConfig, field, defaultValue);
        });
        return dynamicHandler[0, $45806013ed348c93$export$24caac6d68ff1537 /* @min:%2esetDf */ ](newConfig, defaultValues);
    }
    function _getConfig(identifier, field, defaultValue) {
        if (defaultValue === void 0) defaultValue = false;
        var theValue;
        var extConfig = _getExtCfg(identifier, false);
        var rootConfig = dynamicHandler.cfg;
        if (extConfig && (extConfig[field] || !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(extConfig[field]))) theValue = extConfig[field];
        else if (rootConfig[field] || !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(rootConfig[field])) theValue = rootConfig[field];
        return theValue || !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(theValue) ? theValue : defaultValue;
    }
    function _iterateChain(cb) {
        // Keep processing until we reach the end of the chain
        var nextPlugin;
        while(!!(nextPlugin = context._next())){
            var plugin = nextPlugin[0, $45806013ed348c93$export$37717a508eca6e2d /* @min:%2egetPlugin */ ]();
            if (plugin) // callback with the current on
            cb(plugin);
        }
    }
    return context;
}
function $21bc92e23804c647$export$ca98f11e981bcfd6(telemetryChain, cfg, core, startAt) {
    var config = (0, $6387583e0b25820c$export$3a9e9180c14487fd)(cfg);
    var internalContext = $21bc92e23804c647$var$_createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(env) {
        var nextPlugin = internalContext._next();
        if (nextPlugin) // Run the next plugin which will call "processNext()"
        nextPlugin[0, $aa96917b132802ee$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ](env, context);
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) plugins = null;
        if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(plugins)) plugins = $21bc92e23804c647$export$107e639207cdf742(plugins, config.cfg, core, startAt);
        return $21bc92e23804c647$export$ca98f11e981bcfd6(plugins || context[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ](), config.cfg, core, startAt);
    }
    context[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ] = _processNext;
    context[0, $45806013ed348c93$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ] = _createNew;
    return context;
}
function $21bc92e23804c647$export$91bbbd4999751948(telemetryChain, core, startAt) {
    var config = (0, $6387583e0b25820c$export$3a9e9180c14487fd)(core.config);
    var internalContext = $21bc92e23804c647$var$_createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(unloadState) {
        var nextPlugin = internalContext._next();
        nextPlugin && nextPlugin[0, $45806013ed348c93$export$7eb85b5cba77a43d /* @min:%2eunload */ ](context, unloadState);
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) plugins = null;
        if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(plugins)) plugins = $21bc92e23804c647$export$107e639207cdf742(plugins, config.cfg, core, startAt);
        return $21bc92e23804c647$export$91bbbd4999751948(plugins || context[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ](), core, startAt);
    }
    context[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ] = _processNext;
    context[0, $45806013ed348c93$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ] = _createNew;
    return context;
}
function $21bc92e23804c647$export$e4c32b40c4fbf98a(telemetryChain, core, startAt) {
    var config = (0, $6387583e0b25820c$export$3a9e9180c14487fd)(core.config);
    var internalContext = $21bc92e23804c647$var$_createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(updateState) {
        return context.iterate(function(plugin) {
            if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(plugin[0, $45806013ed348c93$export$c9f4bebf02f459de /* @min:%2eupdate */ ])) plugin[0, $45806013ed348c93$export$c9f4bebf02f459de /* @min:%2eupdate */ ](context, updateState);
        });
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) plugins = null;
        if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(plugins)) plugins = $21bc92e23804c647$export$107e639207cdf742(plugins, config.cfg, core, startAt);
        return $21bc92e23804c647$export$e4c32b40c4fbf98a(plugins || context[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ](), core, startAt);
    }
    context[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ] = _processNext;
    context[0, $45806013ed348c93$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ] = _createNew;
    return context;
}
function $21bc92e23804c647$export$107e639207cdf742(plugins, config, core, startAt) {
    var firstProxy = null;
    var add = startAt ? false : true;
    if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(plugins) && plugins[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
        // Create the proxies and wire up the next plugin chain
        var lastProxy_1 = null;
        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(plugins, function(thePlugin) {
            if (!add && startAt === thePlugin) add = true;
            if (add && thePlugin && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(thePlugin[0, $aa96917b132802ee$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ])) {
                // Only add plugins that are processors
                var newProxy = $21bc92e23804c647$export$7f7b955927f4ae5e(thePlugin, config, core);
                if (!firstProxy) firstProxy = newProxy;
                if (lastProxy_1) // Set this new proxy as the next for the previous one
                lastProxy_1._setNext(newProxy);
                lastProxy_1 = newProxy;
            }
        });
    }
    if (startAt && !firstProxy) // Special case where the "startAt" was not in the original list of plugins
    return $21bc92e23804c647$export$107e639207cdf742([
        startAt
    ], config, core);
    return firstProxy;
}
function $21bc92e23804c647$export$7f7b955927f4ae5e(plugin, config, core) {
    var nextProxy = null;
    var hasProcessTelemetry = (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(plugin[0, $aa96917b132802ee$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ]);
    var hasSetNext = (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(plugin[0, $45806013ed348c93$export$55d672a1dc4d50c1 /* @min:%2esetNextPlugin */ ]);
    var chainId;
    if (plugin) chainId = plugin[0, $45806013ed348c93$export$f001befbf8417151 /* @min:%2eidentifier */ ] + "-" + plugin[0, $aa96917b132802ee$export$58efcc07763b37be /* @min:%2epriority */ ] + "-" + $21bc92e23804c647$var$_chainId++;
    else chainId = "Unknown-0-" + $21bc92e23804c647$var$_chainId++;
    var proxyChain = {
        getPlugin: function() {
            return plugin;
        },
        getNext: function() {
            return nextProxy;
        },
        processTelemetry: _processTelemetry,
        unload: _unloadPlugin,
        update: _updatePlugin,
        _id: chainId,
        _setNext: function(nextPlugin) {
            nextProxy = nextPlugin;
        }
    };
    function _getTelCtx() {
        var itemCtx;
        // Looks like a plugin didn't pass the (optional) context, so create a new one
        if (plugin && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(plugin[$21bc92e23804c647$var$strGetTelCtx])) // This plugin extends from the BaseTelemetryPlugin so lets use it
        itemCtx = plugin[$21bc92e23804c647$var$strGetTelCtx]();
        if (!itemCtx) // Create a temporary one
        itemCtx = $21bc92e23804c647$export$ca98f11e981bcfd6(proxyChain, config, core);
        return itemCtx;
    }
    function _processChain(itemCtx, processPluginFn, name, details, isAsync) {
        var hasRun = false;
        var identifier = plugin ? plugin[0, $45806013ed348c93$export$f001befbf8417151 /* @min:%2eidentifier */ ] : $21bc92e23804c647$var$strTelemetryPluginChain;
        var hasRunContext = itemCtx[$21bc92e23804c647$var$strHasRunFlags];
        if (!hasRunContext) // Assign and populate
        hasRunContext = itemCtx[$21bc92e23804c647$var$strHasRunFlags] = {};
        // Ensure that we keep the context in sync
        itemCtx.setNext(nextProxy);
        if (plugin) (0, $67947f06182dbd51$export$c6fbeb260600c482)(itemCtx[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ](), function() {
            return identifier + ":" + name;
        }, function() {
            // Mark this component as having run
            hasRunContext[chainId] = true;
            try {
                // Set a flag on the next plugin so we know if it was attempted to be executed
                var nextId = nextProxy ? nextProxy._id : (0, $aa96917b132802ee$export$5e8607ab26634759);
                if (nextId) hasRunContext[nextId] = false;
                hasRun = processPluginFn(itemCtx);
            } catch (error) {
                var hasNextRun = nextProxy ? hasRunContext[nextProxy._id] : true;
                if (hasNextRun) // The next plugin after us has already run so set this one as complete
                hasRun = true;
                if (!nextProxy || !hasNextRun) // Either we have no next plugin or the current one did not attempt to call the next plugin
                // Which means the current one is the root of the failure so log/report this failure
                (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(itemCtx[0, $45806013ed348c93$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 73 /* _eInternalMessageId.PluginException */ , "Plugin [" + identifier + "] failed during " + name + " - " + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(error) + ", run flags: " + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(hasRunContext));
            }
        }, details, isAsync);
        return hasRun;
    }
    function _processTelemetry(env, itemCtx) {
        itemCtx = itemCtx || _getTelCtx();
        function _callProcessTelemetry(itemCtx) {
            if (!plugin || !hasProcessTelemetry) return false;
            var pluginState = (0, $e144361666ed071d$export$37cfaecb9b4b1b3b)(plugin);
            if (pluginState[0, $45806013ed348c93$export$7176fb2a7d11927e /* @min:%2eteardown */ ] || pluginState[0, $aa96917b132802ee$export$49e9417944569ae8]) return false;
            // Ensure that we keep the context in sync (for processNext()), just in case a plugin
            // doesn't calls processTelemetry() instead of itemContext.processNext() or some
            // other form of error occurred
            if (hasSetNext) // Backward compatibility setting the next plugin on the instance
            plugin[0, $45806013ed348c93$export$55d672a1dc4d50c1 /* @min:%2esetNextPlugin */ ](nextProxy);
            plugin[0, $aa96917b132802ee$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ](env, itemCtx);
            // Process Telemetry is expected to call itemCtx.processNext() or nextPlugin.processTelemetry()
            return true;
        }
        if (!_processChain(itemCtx, _callProcessTelemetry, "processTelemetry", function() {
            return {
                item: env
            };
        }, !env.sync)) // The underlying plugin is either not defined, not enabled or does not have a processTelemetry implementation
        // so we still want the next plugin to be executed.
        itemCtx[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](env);
    }
    function _unloadPlugin(unloadCtx, unloadState) {
        function _callTeardown() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = (0, $e144361666ed071d$export$37cfaecb9b4b1b3b)(plugin);
                var pluginCore = plugin[0, $aa96917b132802ee$export$3094ace9cd82ff99] || pluginState[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ];
                // Only teardown the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === unloadCtx.core()) && !pluginState[0, $45806013ed348c93$export$7176fb2a7d11927e /* @min:%2eteardown */ ]) {
                    // Handle plugins that don't extend from the BaseTelemetryPlugin
                    pluginState[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ] = null;
                    pluginState[0, $45806013ed348c93$export$7176fb2a7d11927e /* @min:%2eteardown */ ] = true;
                    pluginState[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ] = false;
                    if (plugin[0, $45806013ed348c93$export$7176fb2a7d11927e /* @min:%2eteardown */ ] && plugin[0, $45806013ed348c93$export$7176fb2a7d11927e /* @min:%2eteardown */ ](unloadCtx, unloadState) === true) // plugin told us that it was going to (or has) call unloadCtx.processNext()
                    hasRun = true;
                }
            }
            return hasRun;
        }
        if (!_processChain(unloadCtx, _callTeardown, "unload", function() {}, unloadState[0, $45806013ed348c93$export$d8114c9e990204cb /* @min:%2eisAsync */ ])) // Only called if we hasRun was not true
        unloadCtx[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](unloadState);
    }
    function _updatePlugin(updateCtx, updateState) {
        function _callUpdate() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = (0, $e144361666ed071d$export$37cfaecb9b4b1b3b)(plugin);
                var pluginCore = plugin[0, $aa96917b132802ee$export$3094ace9cd82ff99] || pluginState[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ];
                // Only update the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === updateCtx.core()) && !pluginState[0, $45806013ed348c93$export$7176fb2a7d11927e /* @min:%2eteardown */ ]) {
                    if (plugin[0, $45806013ed348c93$export$c9f4bebf02f459de /* @min:%2eupdate */ ] && plugin[0, $45806013ed348c93$export$c9f4bebf02f459de /* @min:%2eupdate */ ](updateCtx, updateState) === true) // plugin told us that it was going to (or has) call unloadCtx.processNext()
                    hasRun = true;
                }
            }
            return hasRun;
        }
        if (!_processChain(updateCtx, _callUpdate, "update", function() {}, false)) // Only called if we hasRun was not true
        updateCtx[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](updateState);
    }
    return (0, $5831ddb3a0caf7c7$export$5da24d7703175bc5)(proxyChain);
}
/**
 * This class will be removed!
 * @deprecated use createProcessTelemetryContext() instead
 */ var $21bc92e23804c647$export$7c2ac74a00234af1 = /** @class */ function() {
    /**
     * Creates a new Telemetry Item context with the current config, core and plugin execution chain
     * @param plugins - The plugin instances that will be executed
     * @param config - The current config
     * @param core - The current core instance
     */ function ProcessTelemetryContext(pluginChain, config, core, startAt) {
        var _self = this;
        var context = $21bc92e23804c647$export$ca98f11e981bcfd6(pluginChain, config, core, startAt);
        // Proxy all functions of the context to this object
        (0, $ede407819d2d28c9$export$94f4c7fb7e7d8dc7)(_self, context, (0, $5831ddb3a0caf7c7$export$f7628dc18f4211e5)(context));
    }
    return ProcessTelemetryContext;
}();


/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


function $0af4a0f2b45a17f9$export$1dd1604aeaf8cfed() {
    var handlers = [];
    function _addHandler(handler) {
        if (handler) handlers[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](handler);
    }
    function _runHandlers(unloadCtx, unloadState) {
        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(handlers, function(handler) {
            try {
                handler(unloadCtx, unloadState);
            } catch (e) {
                (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(unloadCtx[0, $45806013ed348c93$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 73 /* _eInternalMessageId.PluginException */ , "Unexpected error calling unload handler - " + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
            }
        });
        handlers = [];
    }
    return {
        add: _addHandler,
        run: _runHandlers
    };
}


/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $10c5f1b2f69c7ec4$var$_maxHooks;
var $10c5f1b2f69c7ec4$var$_hookAddMonitor;
function $10c5f1b2f69c7ec4$export$53f204aaf3e08551(maxHooks, addMonitor) {
    $10c5f1b2f69c7ec4$var$_maxHooks = maxHooks;
    $10c5f1b2f69c7ec4$var$_hookAddMonitor = addMonitor;
}
function $10c5f1b2f69c7ec4$export$31fa167f9d342989() {
    var _hooks = [];
    function _doUnload(logger) {
        var oldHooks = _hooks;
        _hooks = [];
        // Remove all registered unload hooks
        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(oldHooks, function(fn) {
            // allow either rm or remove callback function
            try {
                (fn.rm || fn.remove).call(fn);
            } catch (e) {
                (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 73 /* _eInternalMessageId.PluginException */ , "Unloading:" + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
            }
        });
        if ($10c5f1b2f69c7ec4$var$_maxHooks && oldHooks[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > $10c5f1b2f69c7ec4$var$_maxHooks) $10c5f1b2f69c7ec4$var$_hookAddMonitor ? $10c5f1b2f69c7ec4$var$_hookAddMonitor("doUnload", oldHooks) : (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(null, 1 /* eLoggingSeverity.CRITICAL */ , 48 /* _eInternalMessageId.MaxUnloadHookExceeded */ , "Max unload hooks exceeded. An excessive number of unload hooks has been detected.");
    }
    function _addHook(hooks) {
        if (hooks) {
            (0, $5831ddb3a0caf7c7$export$69c7b96f216fdf7b)(_hooks, hooks);
            if ($10c5f1b2f69c7ec4$var$_maxHooks && _hooks[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > $10c5f1b2f69c7ec4$var$_maxHooks) $10c5f1b2f69c7ec4$var$_hookAddMonitor ? $10c5f1b2f69c7ec4$var$_hookAddMonitor("Add", _hooks) : (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(null, 1 /* eLoggingSeverity.CRITICAL */ , 48 /* _eInternalMessageId.MaxUnloadHookExceeded */ , "Max unload hooks exceeded. An excessive number of unload hooks has been detected.");
        }
    }
    return {
        run: _doUnload,
        add: _addHook
    };
}


"use strict";
var $dc0100a6f2a9749a$var$_a;
var $dc0100a6f2a9749a$var$strGetPlugin = "getPlugin";
var $dc0100a6f2a9749a$var$defaultValues = ($dc0100a6f2a9749a$var$_a = {}, $dc0100a6f2a9749a$var$_a[0, $aa96917b132802ee$export$ffb2356587263734] = {
    isVal: (0, $ede407819d2d28c9$export$71fc1ee3e76bc1fe),
    v: {}
}, $dc0100a6f2a9749a$var$_a);
/**
 * BaseTelemetryPlugin provides a basic implementation of the ITelemetryPlugin interface so that plugins
 * can avoid implementation the same set of boiler plate code as well as provide a base
 * implementation so that new default implementations can be added without breaking all plugins.
 */ var $dc0100a6f2a9749a$export$64a11c2f90e6766c = /** @class */ function() {
    function BaseTelemetryPlugin() {
        var _self = this; // Setting _self here as it's used outside of the dynamicProto as well
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _isinitialized;
        var _rootCtx; // Used as the root context, holding the current config and initialized core
        var _nextPlugin; // Used for backward compatibility where plugins don't call the main pipeline
        var _unloadHandlerContainer;
        var _hookContainer;
        _initDefaults();
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(BaseTelemetryPlugin, _self, function(_self) {
            _self[0, $45806013ed348c93$export$65cd33bb52d04675 /* @min:%2einitialize */ ] = function(config, core, extensions, pluginChain) {
                _setDefaults(config, core, pluginChain);
                _isinitialized = true;
            };
            _self[0, $45806013ed348c93$export$7176fb2a7d11927e /* @min:%2eteardown */ ] = function(unloadCtx, unloadState) {
                var _a;
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ];
                if (!core || unloadCtx && core !== unloadCtx[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ]()) // Do Nothing as either the plugin is not initialized or was not initialized by the current core
                return;
                var result;
                var unloadDone = false;
                var theUnloadCtx = unloadCtx || (0, $21bc92e23804c647$export$91bbbd4999751948)(null, core, _nextPlugin && _nextPlugin[$dc0100a6f2a9749a$var$strGetPlugin] ? _nextPlugin[$dc0100a6f2a9749a$var$strGetPlugin]() : _nextPlugin);
                var theUnloadState = unloadState || (_a = {
                    reason: 0 /* TelemetryUnloadReason.ManualTeardown */ 
                }, _a[0, $45806013ed348c93$export$d8114c9e990204cb /* @min:isAsync */ ] = false, _a);
                function _unloadCallback() {
                    if (!unloadDone) {
                        unloadDone = true;
                        _unloadHandlerContainer.run(theUnloadCtx, unloadState);
                        _hookContainer.run(theUnloadCtx[0, $45806013ed348c93$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]());
                        if (result === true) theUnloadCtx[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](theUnloadState);
                        _initDefaults();
                    }
                }
                if (!_self[0, $45806013ed348c93$export$458d234b616d0745 /* @min:%2e_doTeardown */ ] || _self[0, $45806013ed348c93$export$458d234b616d0745 /* @min:%2e_doTeardown */ ](theUnloadCtx, theUnloadState, _unloadCallback) !== true) _unloadCallback();
                else // Tell the caller that we will be calling processNext()
                result = true;
                return result;
            };
            _self[0, $45806013ed348c93$export$c9f4bebf02f459de /* @min:%2eupdate */ ] = function(updateCtx, updateState) {
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ];
                if (!core || updateCtx && core !== updateCtx[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ]()) // Do Nothing
                return;
                var result;
                var updateDone = false;
                var theUpdateCtx = updateCtx || (0, $21bc92e23804c647$export$e4c32b40c4fbf98a)(null, core, _nextPlugin && _nextPlugin[$dc0100a6f2a9749a$var$strGetPlugin] ? _nextPlugin[$dc0100a6f2a9749a$var$strGetPlugin]() : _nextPlugin);
                var theUpdateState = updateState || {
                    reason: 0 /* TelemetryUpdateReason.Unknown */ 
                };
                function _updateCallback() {
                    if (!updateDone) {
                        updateDone = true;
                        _setDefaults(theUpdateCtx.getCfg(), theUpdateCtx.core(), theUpdateCtx[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ]());
                    }
                }
                if (!_self._doUpdate || _self._doUpdate(theUpdateCtx, theUpdateState, _updateCallback) !== true) _updateCallback();
                else result = true;
                return result;
            };
            (0, $ede407819d2d28c9$export$5dd8d245f6f94a18)(_self, "_addUnloadCb", function() {
                return _unloadHandlerContainer;
            }, "add");
            (0, $ede407819d2d28c9$export$5dd8d245f6f94a18)(_self, "_addHook", function() {
                return _hookContainer;
            }, "add");
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "_unloadHooks", {
                g: function() {
                    return _hookContainer;
                }
            });
        });
        // These are added after the dynamicProto so that are not moved to the prototype
        _self[0, $45806013ed348c93$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ] = function(itemCtx) {
            return _getTelCtx(itemCtx)[0, $45806013ed348c93$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]();
        };
        _self[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ] = function() {
            return _isinitialized;
        };
        _self.setInitialized = function(isInitialized) {
            _isinitialized = isInitialized;
        };
        // _self.getNextPlugin = () => DO NOT IMPLEMENT
        // Sub-classes of this base class *should* not be relying on this value and instead
        // should use processNext() function. If you require access to the plugin use the
        // IProcessTelemetryContext.getNext().getPlugin() while in the pipeline, Note getNext() may return null.
        _self[0, $45806013ed348c93$export$55d672a1dc4d50c1 /* @min:%2esetNextPlugin */ ] = function(next) {
            _nextPlugin = next;
        };
        _self[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ] = function(env, itemCtx) {
            if (itemCtx) // Normal core execution sequence
            itemCtx[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](env);
            else if (_nextPlugin && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(_nextPlugin[0, $aa96917b132802ee$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ])) // Looks like backward compatibility or out of band processing. And as it looks
            // like a ITelemetryPlugin or ITelemetryPluginChain, just call processTelemetry
            _nextPlugin[0, $aa96917b132802ee$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ](env, null);
        };
        _self._getTelCtx = _getTelCtx;
        function _getTelCtx(currentCtx) {
            if (currentCtx === void 0) currentCtx = null;
            var itemCtx = currentCtx;
            if (!itemCtx) {
                var rootCtx = _rootCtx || (0, $21bc92e23804c647$export$ca98f11e981bcfd6)(null, {}, _self[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ]);
                // tslint:disable-next-line: prefer-conditional-expression
                if (_nextPlugin && _nextPlugin[$dc0100a6f2a9749a$var$strGetPlugin]) // Looks like a chain object
                itemCtx = rootCtx[0, $45806013ed348c93$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ](null, _nextPlugin[$dc0100a6f2a9749a$var$strGetPlugin]);
                else itemCtx = rootCtx[0, $45806013ed348c93$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ](null, _nextPlugin);
            }
            return itemCtx;
        }
        function _setDefaults(config, core, pluginChain) {
            // Make sure the extensionConfig exists and the config is dynamic
            (0, $6387583e0b25820c$export$3a9e9180c14487fd)(config, $dc0100a6f2a9749a$var$defaultValues, (0, $bacca83328a730a7$export$5102d32ea1d740a)(core));
            if (!pluginChain && core) // Get the first plugin from the core
            pluginChain = core[0, $45806013ed348c93$export$474081342bc4baf4 /* @min:%2egetProcessTelContext */ ]()[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ]();
            var nextPlugin = _nextPlugin;
            if (_nextPlugin && _nextPlugin[$dc0100a6f2a9749a$var$strGetPlugin]) // If it looks like a proxy/chain then get the plugin
            nextPlugin = _nextPlugin[$dc0100a6f2a9749a$var$strGetPlugin]();
            // Support legacy plugins where core was defined as a property
            _self[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ] = core;
            _rootCtx = (0, $21bc92e23804c647$export$ca98f11e981bcfd6)(pluginChain, config, core, nextPlugin);
        }
        function _initDefaults() {
            _isinitialized = false;
            _self[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ] = null;
            _rootCtx = null;
            _nextPlugin = null;
            _hookContainer = (0, $10c5f1b2f69c7ec4$export$31fa167f9d342989)();
            _unloadHandlerContainer = (0, $0af4a0f2b45a17f9$export$1dd1604aeaf8cfed)();
        }
    }
    // Removed Stub for BaseTelemetryPlugin.prototype.initialize.
    // Removed Stub for BaseTelemetryPlugin.prototype.teardown.
    // Removed Stub for BaseTelemetryPlugin.prototype.update.
    // Removed Stub for BaseTelemetryPlugin.prototype._addUnloadCb.
    // Removed Stub for BaseTelemetryPlugin.prototype._addHook.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    BaseTelemetryPlugin.__ieDyn = 1;
    return BaseTelemetryPlugin;
}();

/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/**
 * @internal
 * @ignore
 * @param str
 * @param defaultValue
 * @returns
 */ function $3b63eef6ee7529a9$var$_stringToBoolOrDefault(theValue, defaultValue, theConfig) {
    if (!theValue && (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(theValue)) return defaultValue;
    if ((0, $5831ddb3a0caf7c7$export$f9ce7b637dfbe238)(theValue)) return theValue;
    return (0, $5831ddb3a0caf7c7$export$590567be997858b6)(theValue)[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]() === "true";
}
function $3b63eef6ee7529a9$export$5d17fe34e1e248ba(defaultValue) {
    return {
        mrg: true,
        v: defaultValue
    };
}
function $3b63eef6ee7529a9$export$e86b712d02676c90(setter, defaultValue) {
    return {
        set: setter,
        v: defaultValue
    };
}
function $3b63eef6ee7529a9$export$d0884590a6a82e6c(validator, defaultValue, fallBackName) {
    return {
        fb: fallBackName,
        isVal: validator,
        v: defaultValue
    };
}
function $3b63eef6ee7529a9$export$bad0d7bace730ae(defaultValue, fallBackName) {
    return {
        fb: fallBackName,
        set: $3b63eef6ee7529a9$var$_stringToBoolOrDefault,
        v: !!defaultValue
    };
}
function $3b63eef6ee7529a9$export$4308728f2256db2f(defaultValue) {
    return {
        isVal: (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54),
        v: defaultValue || null
    };
}
function $3b63eef6ee7529a9$export$75965e1022d5969a(defaultValue) {
    return {
        isVal: (0, $5831ddb3a0caf7c7$export$844ec244b1367d54),
        v: (0, $5831ddb3a0caf7c7$export$590567be997858b6)(defaultValue || (0, $aa96917b132802ee$export$5e8607ab26634759))
    };
}
function $3b63eef6ee7529a9$export$4ebeffd29cffbfb(defaultValue) {
    var _a;
    return _a = {}, _a[0, $45806013ed348c93$export$9d71a37f0770d87f /* @min:blkVal */ ] = true, _a.v = defaultValue, _a;
}

/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



var $b3babfece552aa67$var$aiInstrumentHooks = "_aiHooks";
var $b3babfece552aa67$var$cbNames = [
    "req",
    "rsp",
    "hkErr",
    "fnErr"
];
/** @ignore */ function $b3babfece552aa67$var$_arrLoop(arr, fn) {
    if (arr) for(var lp = 0; lp < arr[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++){
        if (fn(arr[lp], lp)) break;
    }
}
/** @ignore */ function $b3babfece552aa67$var$_doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
    if (type >= 0 /* CallbackType.Request */  && type <= 2 /* CallbackType.HookError */ ) $b3babfece552aa67$var$_arrLoop(hooks, function(hook, idx) {
        var cbks = hook.cbks;
        var cb = cbks[$b3babfece552aa67$var$cbNames[type]];
        if (cb) {
            // Set the specific hook context implementation using a lazy creation pattern
            callDetails.ctx = function() {
                var ctx = hookCtx[idx] = hookCtx[idx] || {};
                return ctx;
            };
            try {
                cb[0, $45806013ed348c93$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](callDetails.inst, cbArgs);
            } catch (err) {
                var orgEx = callDetails.err;
                try {
                    // Report Hook error via the callback
                    var hookErrorCb = cbks[$b3babfece552aa67$var$cbNames[2 /* CallbackType.HookError */ ]];
                    if (hookErrorCb) {
                        callDetails.err = err;
                        hookErrorCb[0, $45806013ed348c93$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](callDetails.inst, cbArgs);
                    }
                } catch (e) {
                // Not much we can do here -- swallowing the exception to avoid crashing the hosting app
                } finally{
                    // restore the original exception (if any)
                    callDetails.err = orgEx;
                }
            }
        }
    });
}
/** @ignore */ function $b3babfece552aa67$var$_createFunctionHook(aiHook) {
    // Define a temporary method that queues-up a the real method call
    return function() {
        var _a;
        var funcThis = this;
        // Capture the original arguments passed to the method
        var orgArgs = arguments;
        var hooks = aiHook.h;
        var funcArgs = (_a = {}, _a[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:name */ ] = aiHook.n, _a.inst = funcThis, _a.ctx = null, _a.set = _replaceArg, _a);
        var hookCtx = [];
        var cbArgs = _createArgs([
            funcArgs
        ], orgArgs);
        funcArgs.evt = (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)("event");
        function _createArgs(target, theArgs) {
            $b3babfece552aa67$var$_arrLoop(theArgs, function(arg) {
                target[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](arg);
            });
            return target;
        }
        function _replaceArg(idx, value) {
            orgArgs = _createArgs([], orgArgs);
            orgArgs[idx] = value;
            cbArgs = _createArgs([
                funcArgs
            ], orgArgs);
        }
        // Call the pre-request hooks
        $b3babfece552aa67$var$_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0 /* CallbackType.Request */ );
        // Call the original function was called
        var theFunc = aiHook.f;
        if (theFunc) try {
            funcArgs.rslt = theFunc[0, $45806013ed348c93$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](funcThis, orgArgs);
        } catch (err) {
            // Report the request callback
            funcArgs.err = err;
            $b3babfece552aa67$var$_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3 /* CallbackType.FunctionError */ );
            // rethrow the original exception so anyone listening for it can catch the exception
            throw err;
        }
        // Call the post-request hooks
        $b3babfece552aa67$var$_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1 /* CallbackType.Response */ );
        return funcArgs.rslt;
    };
}
/** @ignore */ function $b3babfece552aa67$var$_getOwner(target, name, checkPrototype, checkParentProto) {
    var owner = null;
    if (target) {
        if ((0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(target, name)) owner = target;
        else if (checkPrototype) owner = $b3babfece552aa67$var$_getOwner((0, $ede407819d2d28c9$export$821e81707b1677f9)(target), name, checkParentProto, false);
    }
    return owner;
}
function $b3babfece552aa67$export$6b32104a5f4313f6(target, funcName, callbacks) {
    if (target) return $b3babfece552aa67$export$152e6c4c396a57a(target[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049], funcName, callbacks, false);
    return null;
}
function $b3babfece552aa67$export$aaa214566a8b50d(target, funcNames, callbacks) {
    if (target) return $b3babfece552aa67$export$3bccad25f6aafea4(target[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049], funcNames, callbacks, false);
    return null;
}
function $b3babfece552aa67$var$_createInstrumentHook(owner, funcName, fn, callbacks) {
    var aiHook = fn && fn[$b3babfece552aa67$var$aiInstrumentHooks];
    if (!aiHook) {
        // Only hook the function once
        aiHook = {
            i: 0,
            n: funcName,
            f: fn,
            h: []
        };
        // Override (hook) the original function
        var newFunc = $b3babfece552aa67$var$_createFunctionHook(aiHook);
        newFunc[$b3babfece552aa67$var$aiInstrumentHooks] = aiHook; // Tag and store the function hooks
        owner[funcName] = newFunc;
    }
    var theHook = {
        // tslint:disable:object-literal-shorthand
        id: aiHook.i,
        cbks: callbacks,
        rm: function() {
            // DO NOT Use () => { shorthand for the function as the this gets replaced
            // with the outer this and not the this for theHook instance.
            var id = this.id;
            $b3babfece552aa67$var$_arrLoop(aiHook.h, function(hook, idx) {
                if (hook.id === id) {
                    aiHook.h[0, $45806013ed348c93$export$84020a2e4fe863b0 /* @min:%2esplice */ ](idx, 1);
                    return 1;
                }
            });
        }
    };
    aiHook.i++;
    aiHook.h[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](theHook);
    return theHook;
}
function $b3babfece552aa67$export$152e6c4c396a57a(target, funcName, callbacks, checkPrototype, checkParentProto) {
    if (checkPrototype === void 0) checkPrototype = true;
    if (target && funcName && callbacks) {
        var owner = $b3babfece552aa67$var$_getOwner(target, funcName, checkPrototype, checkParentProto);
        if (owner) {
            var fn = owner[funcName];
            if (typeof fn === (0, $042f611b66f4fd6f$export$327014e6dfd5ba11)) return $b3babfece552aa67$var$_createInstrumentHook(owner, funcName, fn, callbacks);
        }
    }
    return null;
}
function $b3babfece552aa67$export$3bccad25f6aafea4(target, funcNames, callbacks, checkPrototype, checkParentProto) {
    if (checkPrototype === void 0) checkPrototype = true;
    var hooks = null;
    $b3babfece552aa67$var$_arrLoop(funcNames, function(funcName) {
        var hook = $b3babfece552aa67$export$152e6c4c396a57a(target, funcName, callbacks, checkPrototype, checkParentProto);
        if (hook) {
            if (!hooks) hooks = [];
            hooks[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](hook);
        }
    });
    return hooks;
}
function $b3babfece552aa67$export$b96f6cbe9b035430(target, evtName, callbacks, checkPrototype, checkParentProto) {
    if (target && evtName && callbacks) {
        var owner = $b3babfece552aa67$var$_getOwner(target, evtName, checkPrototype, checkParentProto) || target;
        if (owner) return $b3babfece552aa67$var$_createInstrumentHook(owner, evtName, owner[evtName], callbacks);
    }
    return null;
}

/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 







var $aaa64f3935d14265$var$_a, $aaa64f3935d14265$var$_b;
var $aaa64f3935d14265$var$strToGMTString = "toGMTString";
var $aaa64f3935d14265$var$strToUTCString = "toUTCString";
var $aaa64f3935d14265$var$strCookie = "cookie";
var $aaa64f3935d14265$var$strExpires = "expires";
var $aaa64f3935d14265$var$strIsCookieUseDisabled = "isCookieUseDisabled";
var $aaa64f3935d14265$var$strDisableCookiesUsage = "disableCookiesUsage";
var $aaa64f3935d14265$var$strConfigCookieMgr = "_ckMgr";
var $aaa64f3935d14265$var$_supportsCookies = null;
var $aaa64f3935d14265$var$_allowUaSameSite = null;
var $aaa64f3935d14265$var$_parsedCookieValue = null;
var $aaa64f3935d14265$var$_doc;
var $aaa64f3935d14265$var$_cookieCache = {};
var $aaa64f3935d14265$var$_globalCookieConfig = {};
// // `isCookieUseDisabled` is deprecated, so explicitly casting as a key of IConfiguration to avoid typing error
// // when both isCookieUseDisabled and disableCookiesUsage are used disableCookiesUsage will take precedent, which is
// // why its listed first
/**
 * Set the supported dynamic config values as undefined (or an empty object) so that
 * any listeners will be informed of any changes.
 * Explicitly NOT including the deprecated `isCookieUseDisabled` as we don't want to support
 * the v1 deprecated field as dynamic for updates
 */ var $aaa64f3935d14265$var$rootDefaultConfig = ($aaa64f3935d14265$var$_a = {
    cookieCfg: (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)(($aaa64f3935d14265$var$_b = {}, $aaa64f3935d14265$var$_b[0, $aa96917b132802ee$export$8f3e5386cefa231e] = {
        fb: "cookieDomain",
        dfVal: (0, $ede407819d2d28c9$export$71fc1ee3e76bc1fe)
    }, $aaa64f3935d14265$var$_b.path = {
        fb: "cookiePath",
        dfVal: (0, $ede407819d2d28c9$export$71fc1ee3e76bc1fe)
    }, $aaa64f3935d14265$var$_b.enabled = (0, $aa96917b132802ee$export$a43287864529b8fd), $aaa64f3935d14265$var$_b.ignoreCookies = (0, $aa96917b132802ee$export$a43287864529b8fd), $aaa64f3935d14265$var$_b.blockedCookies = (0, $aa96917b132802ee$export$a43287864529b8fd), $aaa64f3935d14265$var$_b)),
    cookieDomain: (0, $aa96917b132802ee$export$a43287864529b8fd),
    cookiePath: (0, $aa96917b132802ee$export$a43287864529b8fd)
}, $aaa64f3935d14265$var$_a[$aaa64f3935d14265$var$strDisableCookiesUsage] = (0, $aa96917b132802ee$export$a43287864529b8fd), $aaa64f3935d14265$var$_a);
function $aaa64f3935d14265$var$_getDoc() {
    !$aaa64f3935d14265$var$_doc && ($aaa64f3935d14265$var$_doc = (0, $5831ddb3a0caf7c7$export$db98eae15987454c)(function() {
        return (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
    }));
}
/**
 * @ignore
 * DO NOT USE or export from the module, this is exposed as public to support backward compatibility of previous static utility methods only.
 * If you want to manager cookies either use the ICookieMgr available from the core instance via getCookieMgr() or create
 * your own instance of the CookieMgr and use that.
 * Using this directly for enabling / disabling cookie handling will not only affect your usage but EVERY user of cookies.
 * Example, if you are using a shared component that is also using Application Insights you will affect their cookie handling.
 * @param logger - The DiagnosticLogger to use for reporting errors.
 */ function $aaa64f3935d14265$var$_gblCookieMgr(config, logger) {
    // Stash the global instance against the BaseCookieMgr class
    var inst = $aaa64f3935d14265$export$2ae082191ac44e5a[$aaa64f3935d14265$var$strConfigCookieMgr] || $aaa64f3935d14265$var$_globalCookieConfig[$aaa64f3935d14265$var$strConfigCookieMgr];
    if (!inst) {
        // Note: not using the getSetValue() helper as that would require always creating a temporary cookieMgr
        // that ultimately is never used
        inst = $aaa64f3935d14265$export$2ae082191ac44e5a[$aaa64f3935d14265$var$strConfigCookieMgr] = $aaa64f3935d14265$export$2ae082191ac44e5a(config, logger);
        $aaa64f3935d14265$var$_globalCookieConfig[$aaa64f3935d14265$var$strConfigCookieMgr] = inst;
    }
    return inst;
}
function $aaa64f3935d14265$var$_isMgrEnabled(cookieMgr) {
    if (cookieMgr) return cookieMgr.isEnabled();
    return true;
}
function $aaa64f3935d14265$var$_isIgnoredCookie(cookieMgrCfg, name) {
    if (name && cookieMgrCfg && (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(cookieMgrCfg.ignoreCookies)) return (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(cookieMgrCfg.ignoreCookies, name) !== -1;
    return false;
}
function $aaa64f3935d14265$var$_isBlockedCookie(cookieMgrCfg, name) {
    if (name && cookieMgrCfg && (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(cookieMgrCfg.blockedCookies)) {
        if ((0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(cookieMgrCfg.blockedCookies, name) !== -1) return true;
    }
    return $aaa64f3935d14265$var$_isIgnoredCookie(cookieMgrCfg, name);
}
function $aaa64f3935d14265$var$_isCfgEnabled(rootConfig, cookieMgrConfig) {
    var isCfgEnabled = cookieMgrConfig[0, $45806013ed348c93$export$c9b1609f2b84393a /* @min:%2eenabled */ ];
    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(isCfgEnabled)) {
        // Set the enabled from the provided setting or the legacy root values
        var cookieEnabled = void 0;
        // This field is deprecated and dynamic updates will not be fully supported
        if (!(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(rootConfig[$aaa64f3935d14265$var$strIsCookieUseDisabled])) cookieEnabled = !rootConfig[$aaa64f3935d14265$var$strIsCookieUseDisabled];
        // If this value is defined it takes precedent over the above
        if (!(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(rootConfig[$aaa64f3935d14265$var$strDisableCookiesUsage])) cookieEnabled = !rootConfig[$aaa64f3935d14265$var$strDisableCookiesUsage];
        // Not setting the cookieMgrConfig.enabled as that will update (set) the global dynamic config
        // So future "updates" then may not be as expected
        isCfgEnabled = cookieEnabled;
    }
    return isCfgEnabled;
}
function $aaa64f3935d14265$export$76c0b273586c25c7(core, config) {
    var cookieMgr;
    if (core) // Always returns an instance
    cookieMgr = core.getCookieMgr();
    else if (config) {
        var cookieCfg = config.cookieCfg;
        if (cookieCfg && cookieCfg[$aaa64f3935d14265$var$strConfigCookieMgr]) cookieMgr = cookieCfg[$aaa64f3935d14265$var$strConfigCookieMgr];
        else cookieMgr = $aaa64f3935d14265$export$2ae082191ac44e5a(config);
    }
    if (!cookieMgr) // Get or initialize the default global (legacy) cookie manager if we couldn't find one
    cookieMgr = $aaa64f3935d14265$var$_gblCookieMgr(config, (core || {})[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ]);
    return cookieMgr;
}
function $aaa64f3935d14265$export$2ae082191ac44e5a(rootConfig, logger) {
    var _a;
    var cookieMgrConfig;
    var _path;
    var _domain;
    var unloadHandler;
    // Explicitly checking against false, so that setting to undefined will === true
    var _enabled;
    var _getCookieFn;
    var _setCookieFn;
    var _delCookieFn;
    // Make sure the root config is dynamic as it may be the global config
    rootConfig = (0, $6387583e0b25820c$export$3a9e9180c14487fd)(rootConfig || $aaa64f3935d14265$var$_globalCookieConfig, null, logger).cfg;
    // Will get recalled if the referenced configuration is changed
    unloadHandler = (0, $6387583e0b25820c$export$454a433e4deb244f)(rootConfig, function(details) {
        // Make sure the root config has all of the the defaults to the root config to ensure they are dynamic
        details[0, $45806013ed348c93$export$24caac6d68ff1537 /* @min:%2esetDf */ ](details.cfg, $aaa64f3935d14265$var$rootDefaultConfig);
        // Create and apply the defaults to the cookieCfg element
        cookieMgrConfig = details.ref(details.cfg, "cookieCfg"); // details.setDf(details.cfg.cookieCfg, defaultConfig);
        _path = cookieMgrConfig[0, $aa96917b132802ee$export$bdba10701e0ccff3 /* @min:%2epath */ ] || "/";
        _domain = cookieMgrConfig[0, $aa96917b132802ee$export$8f3e5386cefa231e /* @min:%2edomain */ ];
        // Explicitly checking against false, so that setting to undefined will === true
        _enabled = $aaa64f3935d14265$var$_isCfgEnabled(rootConfig, cookieMgrConfig) !== false;
        _getCookieFn = cookieMgrConfig.getCookie || $aaa64f3935d14265$var$_getCookieValue;
        _setCookieFn = cookieMgrConfig.setCookie || $aaa64f3935d14265$var$_setCookieValue;
        _delCookieFn = cookieMgrConfig.delCookie || $aaa64f3935d14265$var$_setCookieValue;
    }, logger);
    var cookieMgr = (_a = {
        isEnabled: function() {
            var enabled = $aaa64f3935d14265$var$_isCfgEnabled(rootConfig, cookieMgrConfig) !== false && _enabled && $aaa64f3935d14265$export$25d06da9c29ef62a(logger);
            // Using an indirect lookup for any global cookie manager to support tree shaking for SDK's
            // that don't use the "applicationinsights-core" version of the default cookie function
            var gblManager = $aaa64f3935d14265$var$_globalCookieConfig[$aaa64f3935d14265$var$strConfigCookieMgr];
            if (enabled && gblManager && cookieMgr !== gblManager) // Make sure the GlobalCookie Manager instance (if not this instance) is also enabled.
            // As the global (deprecated) functions may have been called (for backward compatibility)
            enabled = $aaa64f3935d14265$var$_isMgrEnabled(gblManager);
            return enabled;
        },
        setEnabled: function(value) {
            // Explicitly checking against false, so that setting to undefined will === true
            _enabled = value !== false;
            cookieMgrConfig[0, $45806013ed348c93$export$c9b1609f2b84393a /* @min:%2eenabled */ ] = value;
        },
        set: function(name, value, maxAgeSec, domain, path) {
            var result = false;
            if ($aaa64f3935d14265$var$_isMgrEnabled(cookieMgr) && !$aaa64f3935d14265$var$_isBlockedCookie(cookieMgrConfig, name)) {
                var values = {};
                var theValue = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(value || (0, $aa96917b132802ee$export$5e8607ab26634759));
                var idx = (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(theValue, ";");
                if (idx !== -1) {
                    theValue = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)((0, $5831ddb3a0caf7c7$export$a1120f14ec6f7ada)(value, idx));
                    values = $aaa64f3935d14265$var$_extractParts((0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(value, idx + 1));
                }
                // Only update domain if not already present (isUndefined) and the value is truthy (not null, undefined or empty string)
                (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(values, (0, $aa96917b132802ee$export$8f3e5386cefa231e), domain || _domain, (0, $5831ddb3a0caf7c7$export$8f9cae6546f97a9f), (0, $5831ddb3a0caf7c7$export$fce6876652108ab));
                if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(maxAgeSec)) {
                    var _isIE = (0, $0d2c2fb24388dcf8$export$7e7b1a9668aaed8)();
                    if ((0, $5831ddb3a0caf7c7$export$fce6876652108ab)(values[$aaa64f3935d14265$var$strExpires])) {
                        var nowMs = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)();
                        // Only add expires if not already present
                        var expireMs = nowMs + maxAgeSec * 1000;
                        // Sanity check, if zero or -ve then ignore
                        if (expireMs > 0) {
                            var expiry = new Date();
                            expiry.setTime(expireMs);
                            (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(values, $aaa64f3935d14265$var$strExpires, $aaa64f3935d14265$var$_formatDate(expiry, !_isIE ? $aaa64f3935d14265$var$strToUTCString : $aaa64f3935d14265$var$strToGMTString) || $aaa64f3935d14265$var$_formatDate(expiry, _isIE ? $aaa64f3935d14265$var$strToGMTString : $aaa64f3935d14265$var$strToUTCString) || (0, $aa96917b132802ee$export$5e8607ab26634759), (0, $5831ddb3a0caf7c7$export$8f9cae6546f97a9f));
                        }
                    }
                    if (!_isIE) // Only replace if not already present
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(values, "max-age", (0, $aa96917b132802ee$export$5e8607ab26634759) + maxAgeSec, null, (0, $5831ddb3a0caf7c7$export$fce6876652108ab));
                }
                var location_1 = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)();
                if (location_1 && location_1[0, $45806013ed348c93$export$c02b5cd14a83c390 /* @min:%2eprotocol */ ] === "https:") {
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(values, "secure", null, null, (0, $5831ddb3a0caf7c7$export$fce6876652108ab));
                    // Only set same site if not also secure
                    if ($aaa64f3935d14265$var$_allowUaSameSite === null) $aaa64f3935d14265$var$_allowUaSameSite = !$aaa64f3935d14265$export$e44499c7a8a6a268(((0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)() || {})[0, $45806013ed348c93$export$2e850152cb3355e2 /* @min:%2euserAgent */ ]);
                    if ($aaa64f3935d14265$var$_allowUaSameSite) (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(values, "SameSite", "None", null, (0, $5831ddb3a0caf7c7$export$fce6876652108ab));
                }
                (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(values, (0, $aa96917b132802ee$export$bdba10701e0ccff3), path || _path, null, (0, $5831ddb3a0caf7c7$export$fce6876652108ab));
                //let setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
                _setCookieFn(name, $aaa64f3935d14265$var$_formatCookieValue(theValue, values));
                result = true;
            }
            return result;
        },
        get: function(name) {
            var value = (0, $aa96917b132802ee$export$5e8607ab26634759);
            if ($aaa64f3935d14265$var$_isMgrEnabled(cookieMgr) && !$aaa64f3935d14265$var$_isIgnoredCookie(cookieMgrConfig, name)) value = _getCookieFn(name);
            return value;
        },
        del: function(name, path) {
            var result = false;
            if ($aaa64f3935d14265$var$_isMgrEnabled(cookieMgr)) // Only remove the cookie if the manager and cookie support has not been disabled
            result = cookieMgr.purge(name, path);
            return result;
        },
        purge: function(name, path) {
            var _a;
            var result = false;
            if ($aaa64f3935d14265$export$25d06da9c29ef62a(logger)) {
                // Setting the expiration date in the past immediately removes the cookie
                var values = (_a = {}, _a[0, $aa96917b132802ee$export$bdba10701e0ccff3] = path ? path : "/", _a[$aaa64f3935d14265$var$strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT", _a);
                if (!(0, $0d2c2fb24388dcf8$export$7e7b1a9668aaed8)()) // Set max age to expire now
                values["max-age"] = "0";
                // let delCookie = cookieMgrConfig.delCookie || _setCookieValue;
                _delCookieFn(name, $aaa64f3935d14265$var$_formatCookieValue((0, $aa96917b132802ee$export$5e8607ab26634759), values));
                result = true;
            }
            return result;
        }
    }, _a[0, $45806013ed348c93$export$7eb85b5cba77a43d /* @min:unload */ ] = function(isAsync) {
        unloadHandler && unloadHandler.rm();
        unloadHandler = null;
    }, _a);
    // Associated this cookie manager with the config
    cookieMgr[$aaa64f3935d14265$var$strConfigCookieMgr] = cookieMgr;
    return cookieMgr;
}
function $aaa64f3935d14265$export$25d06da9c29ef62a(logger) {
    if ($aaa64f3935d14265$var$_supportsCookies === null) {
        $aaa64f3935d14265$var$_supportsCookies = false;
        !$aaa64f3935d14265$var$_doc && $aaa64f3935d14265$var$_getDoc();
        try {
            var doc = $aaa64f3935d14265$var$_doc.v || {};
            $aaa64f3935d14265$var$_supportsCookies = doc[$aaa64f3935d14265$var$strCookie] !== undefined;
        } catch (e) {
            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 68 /* _eInternalMessageId.CannotAccessCookie */ , "Cannot access document.cookie - " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
            });
        }
    }
    return $aaa64f3935d14265$var$_supportsCookies;
}
function $aaa64f3935d14265$var$_extractParts(theValue) {
    var values = {};
    if (theValue && theValue[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]) {
        var parts = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(theValue)[0, $45806013ed348c93$export$b889f1d4cb07c706 /* @min:%2esplit */ ](";");
        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(parts, function(thePart) {
            thePart = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(thePart || (0, $aa96917b132802ee$export$5e8607ab26634759));
            if (thePart) {
                var idx = (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(thePart, "=");
                if (idx === -1) values[thePart] = null;
                else values[(0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)((0, $5831ddb3a0caf7c7$export$a1120f14ec6f7ada)(thePart, idx))] = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)((0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(thePart, idx + 1));
            }
        });
    }
    return values;
}
function $aaa64f3935d14265$var$_formatDate(theDate, func) {
    if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(theDate[func])) return theDate[func]();
    return null;
}
function $aaa64f3935d14265$var$_formatCookieValue(value, values) {
    var cookieValue = value || (0, $aa96917b132802ee$export$5e8607ab26634759);
    (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(values, function(name, theValue) {
        cookieValue += "; " + name + (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(theValue) ? "=" + theValue : (0, $aa96917b132802ee$export$5e8607ab26634759));
    });
    return cookieValue;
}
function $aaa64f3935d14265$var$_getCookieValue(name) {
    var cookieValue = (0, $aa96917b132802ee$export$5e8607ab26634759);
    !$aaa64f3935d14265$var$_doc && $aaa64f3935d14265$var$_getDoc();
    if ($aaa64f3935d14265$var$_doc.v) {
        var theCookie = $aaa64f3935d14265$var$_doc.v[$aaa64f3935d14265$var$strCookie] || (0, $aa96917b132802ee$export$5e8607ab26634759);
        if ($aaa64f3935d14265$var$_parsedCookieValue !== theCookie) {
            $aaa64f3935d14265$var$_cookieCache = $aaa64f3935d14265$var$_extractParts(theCookie);
            $aaa64f3935d14265$var$_parsedCookieValue = theCookie;
        }
        cookieValue = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)($aaa64f3935d14265$var$_cookieCache[name] || (0, $aa96917b132802ee$export$5e8607ab26634759));
    }
    return cookieValue;
}
function $aaa64f3935d14265$var$_setCookieValue(name, cookieValue) {
    !$aaa64f3935d14265$var$_doc && $aaa64f3935d14265$var$_getDoc();
    if ($aaa64f3935d14265$var$_doc.v) $aaa64f3935d14265$var$_doc.v[$aaa64f3935d14265$var$strCookie] = name + "=" + cookieValue;
}
function $aaa64f3935d14265$export$e44499c7a8a6a268(userAgent) {
    if (!(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(userAgent)) return false;
    // Cover all iOS based browsers here. This includes:
    // - Safari on iOS 12 for iPhone, iPod Touch, iPad
    // - WkWebview on iOS 12 for iPhone, iPod Touch, iPad
    // - Chrome on iOS 12 for iPhone, iPod Touch, iPad
    // All of which are broken by SameSite=None, because they use the iOS networking stack
    if ((0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "CPU iPhone OS 12") || (0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "iPad; CPU OS 12")) return true;
    // Cover Mac OS X based browsers that use the Mac OS networking stack. This includes:
    // - Safari on Mac OS X
    // This does not include:
    // - Internal browser on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if ((0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "Macintosh; Intel Mac OS X 10_14") && (0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "Version/") && (0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "Safari")) return true;
    // Cover Mac OS X internal browsers that use the Mac OS networking stack. This includes:
    // - Internal browser on Mac OS X
    // This does not include:
    // - Safari on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if ((0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "Macintosh; Intel Mac OS X 10_14") && (0, $5831ddb3a0caf7c7$export$5222b9460f3ddbec)(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) return true;
    // Cover Chrome 50-69, because some versions are broken by SameSite=None, and none in this range require it.
    // Note: this covers some pre-Chromium Edge versions, but pre-Chromim Edge does not require SameSite=None, so this is fine.
    // Note: this regex applies to Windows, Mac OS X, and Linux, deliberately.
    if ((0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "Chrome/5") || (0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "Chrome/6")) return true;
    // Unreal Engine runs Chromium 59, but does not advertise as Chrome until 4.23. Treat versions of Unreal
    // that don't specify their Chrome version as lacking support for SameSite=None.
    if ((0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "UnrealEngine") && !(0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "Chrome")) return true;
    // UCBrowser < 12.13.2 ignores Set-Cookie headers with SameSite=None
    // NB: this rule isn't complete - you need regex to make a complete rule.
    // See: https://www.chromium.org/updates/same-site/incompatible-clients
    if ((0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "UCBrowser/12") || (0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "UCBrowser/11")) return true;
    return false;
}



/*
 * Application Insights JavaScript SDK - Web Analytics, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $771c93189b0d88d2$export$e2818d11505fa034 = "toString"; // Count: 4
var $771c93189b0d88d2$export$f357d96937d91514 = "isStorageUseDisabled"; // Count: 3
var $771c93189b0d88d2$export$3b3afe26ca0e015c = "_addHook"; // Count: 6
var $771c93189b0d88d2$export$f9ae8d0acf86503e = "core"; // Count: 7
var $771c93189b0d88d2$export$9e16762ab4f2648 = "dataType"; // Count: 8
var $771c93189b0d88d2$export$2672d4f7ccc80348 = "envelopeType"; // Count: 7
var $771c93189b0d88d2$export$c7ff2c36e5c78421 = "diagLog"; // Count: 13
var $771c93189b0d88d2$export$548634e98b3af9c4 = "track"; // Count: 7
var $771c93189b0d88d2$export$ab1a8669316b7a02 = "trackPageView"; // Count: 4
var $771c93189b0d88d2$export$5b63a890d51a5194 = "trackPreviousPageVisit"; // Count: 3
var $771c93189b0d88d2$export$e4d43b697816aae1 = "sendPageViewInternal"; // Count: 7
var $771c93189b0d88d2$export$69cac26425c8ea23 = "startTime"; // Count: 6
var $771c93189b0d88d2$export$14814e6f9bf337b4 = "properties"; // Count: 5
var $771c93189b0d88d2$export$aa395e58f404db90 = "duration"; // Count: 12
var $771c93189b0d88d2$export$fe3039bd0e70dd3f = "sendPageViewPerformanceInternal"; // Count: 3
var $771c93189b0d88d2$export$20270e2265c2a185 = "populatePageViewPerformanceEvent"; // Count: 3
var $771c93189b0d88d2$export$8d0bd9d006f3ecea = "href"; // Count: 6
var $771c93189b0d88d2$export$5414b86ab837cb07 = "sendExceptionInternal"; // Count: 2
var $771c93189b0d88d2$export$4852fd87b68a6e1f = "exception"; // Count: 3
var $771c93189b0d88d2$export$ff0a0f80c43edd37 = "error"; // Count: 5
var $771c93189b0d88d2$export$31fe7bcf0f7c83e8 = "_onerror"; // Count: 3
var $771c93189b0d88d2$export$d190ee0b6bfe36d8 = "errorSrc"; // Count: 3
var $771c93189b0d88d2$export$4d19a8ea486d5967 = "lineNumber"; // Count: 5
var $771c93189b0d88d2$export$91a182df12726bcd = "columnNumber"; // Count: 5
var $771c93189b0d88d2$export$923606b70907833e = "message"; // Count: 4
var $771c93189b0d88d2$export$3dedbd38aa3b0c11 = "CreateAutoException"; // Count: 3
var $771c93189b0d88d2$export$935b759388157821 = "addTelemetryInitializer"; // Count: 4
var $771c93189b0d88d2$export$c653a2fea2d8252a = "overridePageViewDuration"; // Count: 2
var $771c93189b0d88d2$export$e4892641d6ea1b45 = "autoTrackPageVisitTime"; // Count: 2
var $771c93189b0d88d2$export$204917ab19f7a461 = "isBrowserLinkTrackingEnabled"; // Count: 2
var $771c93189b0d88d2$export$6eae51590aaea43 = "length"; // Count: 5
var $771c93189b0d88d2$export$6390687f17a52950 = "enableAutoRouteTracking"; // Count: 2
var $771c93189b0d88d2$export$72fe3f7aecc0d015 = "enableUnhandledPromiseRejectionTracking"; // Count: 2
var $771c93189b0d88d2$export$527cc291f0159d2a = "autoUnhandledPromiseInstrumented"; // Count: 3
var $771c93189b0d88d2$export$96ba0dffa6c93bb1 = "getEntriesByType"; // Count: 5
var $771c93189b0d88d2$export$379c72358869fe15 = "isPerformanceTimingSupported"; // Count: 2
var $771c93189b0d88d2$export$f80d3e3d3d24d8e2 = "getPerformanceTiming"; // Count: 2
var $771c93189b0d88d2$export$f8670e269dbf7411 = "navigationStart"; // Count: 4
var $771c93189b0d88d2$export$7d974758a7a955a6 = "shouldCollectDuration"; // Count: 3
var $771c93189b0d88d2$export$2e020f7b1a6ecc9d = "isPerformanceTimingDataReady"; // Count: 2
var $771c93189b0d88d2$export$efd7bea2390142dc = "responseStart"; // Count: 5
var $771c93189b0d88d2$export$2a979904ebe4c805 = "requestStart"; // Count: 3
var $771c93189b0d88d2$export$3e2743adb5050880 = "loadEventEnd"; // Count: 4
var $771c93189b0d88d2$export$cb472b94f03785cf = "responseEnd"; // Count: 5
var $771c93189b0d88d2$export$ade5c25ec120f74e = "connectEnd"; // Count: 4
var $771c93189b0d88d2$export$204c1f54732d882 = "pageVisitStartTime"; // Count: 2


/*
 * Application Insights JavaScript SDK - Web Analytics, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




/**
 * Class encapsulates sending page views and page view performance telemetry.
 */ var $89593731a05de0fb$export$5bb8d6768724bf86 = /** @class */ function() {
    function PageViewManager(appInsights, overridePageViewDuration, core, pageViewPerformanceManager) {
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(PageViewManager, this, function(_self) {
            var queueTimer = null;
            var itemQueue = [];
            var pageViewPerformanceSent = false;
            var firstPageViewSent = false;
            var _logger;
            if (core) _logger = core.logger;
            function _flushChannels(isAsync) {
                if (core) core.flush(isAsync, function() {
                // Event flushed, callback added to prevent promise creation
                });
            }
            function _startTimer() {
                if (!queueTimer) queueTimer = (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
                    queueTimer = null;
                    var allItems = itemQueue.slice(0);
                    var doFlush = false;
                    itemQueue = [];
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(allItems, function(item) {
                        if (!item()) // Not processed so rescheduled
                        itemQueue.push(item);
                        else doFlush = true;
                    });
                    if (itemQueue[0, $771c93189b0d88d2$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) _startTimer();
                    if (doFlush) // We process at least one item so flush the queue
                    _flushChannels(true);
                }, 100);
            }
            function _addQueue(cb) {
                itemQueue.push(cb);
                _startTimer();
            }
            _self[0, $771c93189b0d88d2$export$ab1a8669316b7a02 /* @min:%2etrackPageView */ ] = function(pageView, customProperties) {
                var name = pageView.name;
                if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(name) || typeof name !== "string") {
                    var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
                    name = pageView.name = doc && doc.title || "";
                }
                var uri = pageView.uri;
                if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(uri) || typeof uri !== "string") {
                    var location_1 = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)();
                    uri = pageView.uri = location_1 && location_1[0, $771c93189b0d88d2$export$8d0bd9d006f3ecea /* @min:%2ehref */ ] || "";
                }
                if (!firstPageViewSent) {
                    var perf = (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)();
                    // Access the performance timing object
                    var navigationEntries = perf && perf[0, $771c93189b0d88d2$export$96ba0dffa6c93bb1 /* @min:%2egetEntriesByType */ ] && perf[0, $771c93189b0d88d2$export$96ba0dffa6c93bb1 /* @min:%2egetEntriesByType */ ]("navigation");
                    // Edge Case the navigation Entries may return an empty array and the timeOrigin is not supported on IE
                    if (navigationEntries && navigationEntries[0] && !(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(perf.timeOrigin)) {
                        // Get the value of loadEventStart
                        var loadEventStart = navigationEntries[0].loadEventStart;
                        pageView[0, $771c93189b0d88d2$export$69cac26425c8ea23 /* @min:%2estartTime */ ] = new Date(perf.timeOrigin + loadEventStart);
                    } else {
                        // calculate the start time manually
                        var duration_1 = (customProperties || pageView[0, $771c93189b0d88d2$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] || {})[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ] || 0;
                        pageView[0, $771c93189b0d88d2$export$69cac26425c8ea23 /* @min:%2estartTime */ ] = new Date(new Date().getTime() - duration_1);
                    }
                    firstPageViewSent = true;
                }
                // case 1a. if performance timing is not supported by the browser, send the page view telemetry with the duration provided by the user. If the user
                // do not provide the duration, set duration to undefined
                // Also this is case 4
                if (!pageViewPerformanceManager[0, $771c93189b0d88d2$export$379c72358869fe15 /* @min:%2eisPerformanceTimingSupported */ ]()) {
                    appInsights[0, $771c93189b0d88d2$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                    _flushChannels(true);
                    if (!(0, $5831ddb3a0caf7c7$export$97b87b8868ff7a3c)()) // no navigation timing (IE 8, iOS Safari 8.4, Opera Mini 8 - see http://caniuse.com/#feat=nav-timing)
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 25 /* _eInternalMessageId.NavigationTimingNotSupported */ , "trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");
                    return;
                }
                var pageViewSent = false;
                var customDuration;
                // if the performance timing is supported by the browser, calculate the custom duration
                var start = pageViewPerformanceManager[0, $771c93189b0d88d2$export$f80d3e3d3d24d8e2 /* @min:%2egetPerformanceTiming */ ]()[0, $771c93189b0d88d2$export$f8670e269dbf7411 /* @min:%2enavigationStart */ ];
                if (start > 0) {
                    customDuration = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(start, +new Date);
                    if (!pageViewPerformanceManager[0, $771c93189b0d88d2$export$7d974758a7a955a6 /* @min:%2eshouldCollectDuration */ ](customDuration)) customDuration = undefined;
                }
                // if the user has provided duration, send a page view telemetry with the provided duration. Otherwise, if
                // overridePageViewDuration is set to true, send a page view telemetry with the custom duration calculated earlier
                var duration;
                if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customProperties) && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customProperties[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ])) duration = customProperties[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ];
                if (overridePageViewDuration || !isNaN(duration)) {
                    if (isNaN(duration)) {
                        // case 3
                        if (!customProperties) customProperties = {};
                        customProperties[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ] = customDuration;
                    }
                    // case 2
                    appInsights[0, $771c93189b0d88d2$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                    _flushChannels(true);
                    pageViewSent = true;
                }
                // now try to send the page view performance telemetry
                var maxDurationLimit = 60000;
                if (!customProperties) customProperties = {};
                // Queue the event for processing
                _addQueue(function() {
                    var processed = false;
                    try {
                        if (pageViewPerformanceManager[0, $771c93189b0d88d2$export$2e020f7b1a6ecc9d /* @min:%2eisPerformanceTimingDataReady */ ]()) {
                            processed = true;
                            var pageViewPerformance = {
                                name: name,
                                uri: uri
                            };
                            pageViewPerformanceManager[0, $771c93189b0d88d2$export$20270e2265c2a185 /* @min:%2epopulatePageViewPerformanceEvent */ ](pageViewPerformance);
                            if (!pageViewPerformance.isValid && !pageViewSent) {
                                // If navigation timing gives invalid numbers, then go back to "override page view duration" mode.
                                // That's the best value we can get that makes sense.
                                customProperties[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ] = customDuration;
                                appInsights[0, $771c93189b0d88d2$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                            } else {
                                if (!pageViewSent) {
                                    customProperties[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ] = pageViewPerformance.durationMs;
                                    appInsights[0, $771c93189b0d88d2$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                                }
                                if (!pageViewPerformanceSent) {
                                    appInsights[0, $771c93189b0d88d2$export$fe3039bd0e70dd3f /* @min:%2esendPageViewPerformanceInternal */ ](pageViewPerformance, customProperties);
                                    pageViewPerformanceSent = true;
                                }
                            }
                        } else if (start > 0 && (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(start, +new Date) > maxDurationLimit) {
                            // if performance timings are not ready but we exceeded the maximum duration limit, just log a page view telemetry
                            // with the maximum duration limit. Otherwise, keep waiting until performance timings are ready
                            processed = true;
                            if (!pageViewSent) {
                                customProperties[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ] = maxDurationLimit;
                                appInsights[0, $771c93189b0d88d2$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                            }
                        }
                    } catch (e) {
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 1 /* eLoggingSeverity.CRITICAL */ , 38 /* _eInternalMessageId.TrackPVFailedCalc */ , "trackPageView failed on page load calculation: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                            exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                        });
                    }
                    return processed;
                });
            };
            _self.teardown = function(unloadCtx, unloadState) {
                if (queueTimer) {
                    queueTimer.cancel();
                    queueTimer = null;
                    var allItems = itemQueue.slice(0);
                    var doFlush_1 = false;
                    itemQueue = [];
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(allItems, function(item) {
                        if (item()) doFlush_1 = true;
                    });
                }
            };
        });
    }
    // Removed Stub for PageViewManager.prototype.trackPageView.
    // Removed Stub for PageViewManager.prototype.teardown.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PageViewManager.__ieDyn = 1;
    return PageViewManager;
}();


/*
 * Application Insights JavaScript SDK - Web Analytics, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




var $b9c3d156d6cc38c0$var$MAX_DURATION_ALLOWED = 3600000; // 1h
var $b9c3d156d6cc38c0$var$botAgentNames = [
    "googlebot",
    "adsbot-google",
    "apis-google",
    "mediapartners-google"
];
function $b9c3d156d6cc38c0$var$_isPerformanceTimingSupported() {
    var perf = (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)();
    return perf && !!perf.timing;
}
function $b9c3d156d6cc38c0$var$_isPerformanceNavigationTimingSupported() {
    var perf = (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)();
    return perf && perf.getEntriesByType && perf.getEntriesByType("navigation")[0, $771c93189b0d88d2$export$6eae51590aaea43 /* @min:%2elength */ ] > 0;
}
function $b9c3d156d6cc38c0$var$_isPerformanceTimingDataReady() {
    var perf = (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)();
    var timing = perf ? perf.timing : 0;
    return timing && timing.domainLookupStart > 0 && timing[0, $771c93189b0d88d2$export$f8670e269dbf7411 /* @min:%2enavigationStart */ ] > 0 && timing[0, $771c93189b0d88d2$export$efd7bea2390142dc /* @min:%2eresponseStart */ ] > 0 && timing[0, $771c93189b0d88d2$export$2a979904ebe4c805 /* @min:%2erequestStart */ ] > 0 && timing[0, $771c93189b0d88d2$export$3e2743adb5050880 /* @min:%2eloadEventEnd */ ] > 0 && timing[0, $771c93189b0d88d2$export$cb472b94f03785cf /* @min:%2eresponseEnd */ ] > 0 && timing[0, $771c93189b0d88d2$export$ade5c25ec120f74e /* @min:%2econnectEnd */ ] > 0 && timing.domLoading > 0;
}
function $b9c3d156d6cc38c0$var$_getPerformanceTiming() {
    if ($b9c3d156d6cc38c0$var$_isPerformanceTimingSupported()) return (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)().timing;
    return null;
}
function $b9c3d156d6cc38c0$var$_getPerformanceNavigationTiming() {
    if ($b9c3d156d6cc38c0$var$_isPerformanceNavigationTimingSupported()) return (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)()[0, $771c93189b0d88d2$export$96ba0dffa6c93bb1 /* @min:%2egetEntriesByType */ ]("navigation")[0];
    return null;
}
/**
* This method tells if given durations should be excluded from collection.
*/ function $b9c3d156d6cc38c0$var$_shouldCollectDuration() {
    var durations = [];
    for(var _i = 0; _i < arguments.length; _i++)durations[_i] = arguments[_i];
    var _navigator = (0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)() || {};
    // a full list of Google crawlers user agent strings - https://support.google.com/webmasters/answer/1061943?hl=en
    var userAgent = _navigator.userAgent;
    var isGoogleBot = false;
    if (userAgent) for(var i = 0; i < $b9c3d156d6cc38c0$var$botAgentNames[0, $771c93189b0d88d2$export$6eae51590aaea43 /* @min:%2elength */ ]; i++)isGoogleBot = isGoogleBot || (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(userAgent.toLowerCase(), $b9c3d156d6cc38c0$var$botAgentNames[i]) !== -1;
    if (isGoogleBot) // Don't report durations for GoogleBot, it is returning invalid values in performance.timing API.
    return false;
    else // for other page views, don't report if it's outside of a reasonable range
    for(var i = 0; i < durations[0, $771c93189b0d88d2$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
        if (durations[i] < 0 || durations[i] >= $b9c3d156d6cc38c0$var$MAX_DURATION_ALLOWED) return false;
    }
    return true;
}
/**
 * Class encapsulates sending page view performance telemetry.
 */ var $b9c3d156d6cc38c0$export$da80ef98bc1bafa6 = /** @class */ function() {
    function PageViewPerformanceManager(core) {
        var _logger = (0, $bacca83328a730a7$export$5102d32ea1d740a)(core);
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(PageViewPerformanceManager, this, function(_self) {
            _self[0, $771c93189b0d88d2$export$20270e2265c2a185 /* @min:%2epopulatePageViewPerformanceEvent */ ] = function(pageViewPerformance) {
                pageViewPerformance.isValid = false;
                /*
                 * http://www.w3.org/TR/navigation-timing/#processing-model
                 *  |-navigationStart
                 *  |             |-connectEnd
                 *  |             ||-requestStart
                 *  |             ||             |-responseStart
                 *  |             ||             |              |-responseEnd
                 *  |             ||             |              |
                 *  |             ||             |              |         |-loadEventEnd
                 *  |---network---||---request---|---response---|---dom---|
                 *  |--------------------------total----------------------|
                 *
                 *  total = The difference between the load event of the current document is completed and the first recorded timestamp of the performance entry : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#duration
                 *  network = Redirect time + App Cache + DNS lookup time + TCP connection time
                 *  request = Request time : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#request_time
                 *  response = Response time
                 *  dom = Document load time : https://html.spec.whatwg.org/multipage/dom.html#document-load-timing-info
                 *      = Document processing time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#document_processing
                 *      + Loading time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#loading
                 */ var navigationTiming = $b9c3d156d6cc38c0$var$_getPerformanceNavigationTiming();
                var timing = $b9c3d156d6cc38c0$var$_getPerformanceTiming();
                var total = 0;
                var network = 0;
                var request = 0;
                var response = 0;
                var dom = 0;
                if (navigationTiming || timing) {
                    if (navigationTiming) {
                        total = navigationTiming[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ];
                        /**
                         * support both cases:
                         * - startTime is always zero: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
                         * - for older browsers where the startTime is not zero
                         */ network = navigationTiming[0, $771c93189b0d88d2$export$69cac26425c8ea23 /* @min:%2estartTime */ ] === 0 ? navigationTiming[0, $771c93189b0d88d2$export$ade5c25ec120f74e /* @min:%2econnectEnd */ ] : (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(navigationTiming[0, $771c93189b0d88d2$export$69cac26425c8ea23 /* @min:%2estartTime */ ], navigationTiming[0, $771c93189b0d88d2$export$ade5c25ec120f74e /* @min:%2econnectEnd */ ]);
                        request = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(navigationTiming.requestStart, navigationTiming[0, $771c93189b0d88d2$export$efd7bea2390142dc /* @min:%2eresponseStart */ ]);
                        response = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(navigationTiming[0, $771c93189b0d88d2$export$efd7bea2390142dc /* @min:%2eresponseStart */ ], navigationTiming[0, $771c93189b0d88d2$export$cb472b94f03785cf /* @min:%2eresponseEnd */ ]);
                        dom = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(navigationTiming.responseEnd, navigationTiming[0, $771c93189b0d88d2$export$3e2743adb5050880 /* @min:%2eloadEventEnd */ ]);
                    } else {
                        total = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(timing[0, $771c93189b0d88d2$export$f8670e269dbf7411 /* @min:%2enavigationStart */ ], timing[0, $771c93189b0d88d2$export$3e2743adb5050880 /* @min:%2eloadEventEnd */ ]);
                        network = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(timing[0, $771c93189b0d88d2$export$f8670e269dbf7411 /* @min:%2enavigationStart */ ], timing[0, $771c93189b0d88d2$export$ade5c25ec120f74e /* @min:%2econnectEnd */ ]);
                        request = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(timing.requestStart, timing[0, $771c93189b0d88d2$export$efd7bea2390142dc /* @min:%2eresponseStart */ ]);
                        response = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(timing[0, $771c93189b0d88d2$export$efd7bea2390142dc /* @min:%2eresponseStart */ ], timing[0, $771c93189b0d88d2$export$cb472b94f03785cf /* @min:%2eresponseEnd */ ]);
                        dom = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(timing.responseEnd, timing[0, $771c93189b0d88d2$export$3e2743adb5050880 /* @min:%2eloadEventEnd */ ]);
                    }
                    if (total === 0) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 10 /* _eInternalMessageId.ErrorPVCalc */ , "error calculating page view performance.", {
                        total: total,
                        network: network,
                        request: request,
                        response: response,
                        dom: dom
                    });
                    else if (!_self[0, $771c93189b0d88d2$export$7d974758a7a955a6 /* @min:%2eshouldCollectDuration */ ](total, network, request, response, dom)) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 45 /* _eInternalMessageId.InvalidDurationValue */ , "Invalid page load duration value. Browser perf data won't be sent.", {
                        total: total,
                        network: network,
                        request: request,
                        response: response,
                        dom: dom
                    });
                    else if (total < Math.floor(network) + Math.floor(request) + Math.floor(response) + Math.floor(dom)) // some browsers may report individual components incorrectly so that the sum of the parts will be bigger than total PLT
                    // in this case, don't report client performance from this page
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 8 /* _eInternalMessageId.ClientPerformanceMathError */ , "client performance math error.", {
                        total: total,
                        network: network,
                        request: request,
                        response: response,
                        dom: dom
                    });
                    else {
                        pageViewPerformance.durationMs = total;
                        // // convert to timespans
                        pageViewPerformance.perfTotal = pageViewPerformance[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ] = (0, $7c0ecef5df4b34f7$export$4460ed97e7c4a927)(total);
                        pageViewPerformance.networkConnect = (0, $7c0ecef5df4b34f7$export$4460ed97e7c4a927)(network);
                        pageViewPerformance.sentRequest = (0, $7c0ecef5df4b34f7$export$4460ed97e7c4a927)(request);
                        pageViewPerformance.receivedResponse = (0, $7c0ecef5df4b34f7$export$4460ed97e7c4a927)(response);
                        pageViewPerformance.domProcessing = (0, $7c0ecef5df4b34f7$export$4460ed97e7c4a927)(dom);
                        pageViewPerformance.isValid = true;
                    }
                }
            };
            _self[0, $771c93189b0d88d2$export$f80d3e3d3d24d8e2 /* @min:%2egetPerformanceTiming */ ] = $b9c3d156d6cc38c0$var$_getPerformanceTiming;
            _self[0, $771c93189b0d88d2$export$379c72358869fe15 /* @min:%2eisPerformanceTimingSupported */ ] = $b9c3d156d6cc38c0$var$_isPerformanceTimingSupported;
            _self[0, $771c93189b0d88d2$export$2e020f7b1a6ecc9d /* @min:%2eisPerformanceTimingDataReady */ ] = $b9c3d156d6cc38c0$var$_isPerformanceTimingDataReady;
            _self[0, $771c93189b0d88d2$export$7d974758a7a955a6 /* @min:%2eshouldCollectDuration */ ] = $b9c3d156d6cc38c0$var$_shouldCollectDuration;
        });
    }
    // Removed Stub for PageViewPerformanceManager.prototype.populatePageViewPerformanceEvent.
    // Removed Stub for PageViewPerformanceManager.prototype.getPerformanceTiming.
    // Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingSupported.
    // Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingDataReady.
    // Removed Stub for PageViewPerformanceManager.prototype.shouldCollectDuration.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PageViewPerformanceManager.__ieDyn = 1;
    return PageViewPerformanceManager;
}();


/*
 * Application Insights JavaScript SDK - Web Analytics, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




/**
 * Used to track page visit durations
 */ var $1e4790eb1573bab6$export$f6fdd81afb2fe76 = /** @class */ function() {
    /**
     * Creates a new instance of PageVisitTimeManager
     * @param pageVisitTimeTrackingHandler - Delegate that will be called to send telemetry data to AI (when trackPreviousPageVisit is called)
     * @returns {}
     */ function PageVisitTimeManager(logger, pageVisitTimeTrackingHandler) {
        var prevPageVisitDataKeyName = "prevPageVisitData";
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(PageVisitTimeManager, this, function(_self) {
            _self[0, $771c93189b0d88d2$export$5b63a890d51a5194 /* @min:%2etrackPreviousPageVisit */ ] = function(currentPageName, currentPageUrl) {
                try {
                    // Restart timer for new page view
                    var prevPageVisitTimeData = restartPageVisitTimer(currentPageName, currentPageUrl);
                    // If there was a page already being timed, track the visit time for it now.
                    if (prevPageVisitTimeData) pageVisitTimeTrackingHandler(prevPageVisitTimeData.pageName, prevPageVisitTimeData.pageUrl, prevPageVisitTimeData.pageVisitTime);
                } catch (e) {
                    (0, $bacca83328a730a7$export$25fb4cb97863f0a8)(logger, "Auto track page visit time failed, metric will not be collected: " + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
                }
            };
            /**
             * Stops timing of current page (if exists) and starts timing for duration of visit to pageName
             * @param pageName - Name of page to begin timing visit duration
             * @returns {PageVisitData} Page visit data (including duration) of pageName from last call to start or restart, if exists. Null if not.
             */ function restartPageVisitTimer(pageName, pageUrl) {
                var prevPageVisitData = null;
                try {
                    prevPageVisitData = stopPageVisitTimer();
                    if ((0, $3fab9bbcce274f86$export$c81985c4209bac26)()) {
                        if ((0, $3fab9bbcce274f86$export$a398bd2f40e2eb6e)(logger, prevPageVisitDataKeyName) != null) (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)("Cannot call startPageVisit consecutively without first calling stopPageVisit");
                        var currPageVisitDataStr = (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)().stringify(new $1e4790eb1573bab6$export$513202441432a369(pageName, pageUrl));
                        (0, $3fab9bbcce274f86$export$21abea3a85fee3f5)(logger, prevPageVisitDataKeyName, currPageVisitDataStr);
                    }
                } catch (e) {
                    (0, $bacca83328a730a7$export$25fb4cb97863f0a8)(logger, "Call to restart failed: " + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
                    prevPageVisitData = null;
                }
                return prevPageVisitData;
            }
            /**
             * Stops timing of current page, if exists.
             * @returns {PageVisitData} Page visit data (including duration) of pageName from call to start, if exists. Null if not.
             */ function stopPageVisitTimer() {
                var prevPageVisitData = null;
                try {
                    if ((0, $3fab9bbcce274f86$export$c81985c4209bac26)()) {
                        // Define end time of page's visit
                        var pageVisitEndTime = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)();
                        // Try to retrieve  page name and start time from session storage
                        var pageVisitDataJsonStr = (0, $3fab9bbcce274f86$export$a398bd2f40e2eb6e)(logger, prevPageVisitDataKeyName);
                        if (pageVisitDataJsonStr && (0, $0d2c2fb24388dcf8$export$a2856ab6913b9fff)()) {
                            // if previous page data exists, set end time of visit
                            prevPageVisitData = (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)().parse(pageVisitDataJsonStr);
                            prevPageVisitData.pageVisitTime = pageVisitEndTime - prevPageVisitData[0, $771c93189b0d88d2$export$204c1f54732d882 /* @min:%2epageVisitStartTime */ ];
                            // Remove data from storage since we already used it
                            (0, $3fab9bbcce274f86$export$9f411b4ea05fb92a)(logger, prevPageVisitDataKeyName);
                        }
                    }
                } catch (e) {
                    (0, $bacca83328a730a7$export$25fb4cb97863f0a8)(logger, "Stop page visit timer failed: " + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
                    prevPageVisitData = null;
                }
                return prevPageVisitData;
            }
            // For backward compatibility
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "_logger", {
                g: function() {
                    return logger;
                }
            });
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "pageVisitTimeTrackingHandler", {
                g: function() {
                    return pageVisitTimeTrackingHandler;
                }
            });
        });
    }
    // Removed Stub for PageVisitTimeManager.prototype.trackPreviousPageVisit.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PageVisitTimeManager.__ieDyn = 1;
    return PageVisitTimeManager;
}();
var $1e4790eb1573bab6$export$513202441432a369 = /** @class */ function() {
    function PageVisitData(pageName, pageUrl) {
        this[0, $771c93189b0d88d2$export$204c1f54732d882 /* @min:%2epageVisitStartTime */ ] = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)();
        this.pageName = pageName;
        this.pageUrl = pageUrl;
    }
    return PageVisitData;
}();


/*
 * Application Insights JavaScript SDK - Web Analytics, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

/**
 * Used to record timed events and page views.
 */ var $a8a86e0b8e3fa866$export$ef1e5872612852d1 = /** @class */ function() {
    function Timing(logger, name) {
        var _self = this;
        var _events = {};
        _self.start = function(name) {
            if (typeof _events[name] !== "undefined") (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 62 /* _eInternalMessageId.StartCalledMoreThanOnce */ , "start was called more than once for this event without calling stop.", {
                name: name,
                key: name
            }, true);
            _events[name] = +new Date;
        };
        _self.stop = function(name, url, properties, measurements) {
            var start = _events[name];
            if (isNaN(start)) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 63 /* _eInternalMessageId.StopCalledWithoutStart */ , "stop was called without a corresponding start.", {
                name: name,
                key: name
            }, true);
            else {
                var end = +new Date;
                var duration = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(start, end);
                _self.action(name, url, duration, properties, measurements);
            }
            delete _events[name];
            _events[name] = undefined;
        };
    }
    return Timing;
}();


var $f8c459c2dab16ec4$var$_a;
var $f8c459c2dab16ec4$var$strEvent = "event";
function $f8c459c2dab16ec4$var$_dispatchEvent(target, evnt) {
    if (target && target.dispatchEvent && evnt) target.dispatchEvent(evnt);
}
function $f8c459c2dab16ec4$var$_getReason(error) {
    if (error && error.reason) {
        var reason = error.reason;
        if (!(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(reason) && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(reason[0, $771c93189b0d88d2$export$e2818d11505fa034 /* @min:%2etoString */ ])) return reason[0, $771c93189b0d88d2$export$e2818d11505fa034 /* @min:%2etoString */ ]();
        return (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(reason);
    }
    // Pass the original object down which will eventually get evaluated for any message or description
    return error || "";
}
var $f8c459c2dab16ec4$var$MinMilliSeconds = 60000;
var $f8c459c2dab16ec4$var$defaultValues = (0, $5831ddb3a0caf7c7$export$a15782d21797da4c)(($f8c459c2dab16ec4$var$_a = {
    sessionRenewalMs: (0, $3b63eef6ee7529a9$export$e86b712d02676c90)($f8c459c2dab16ec4$var$_chkConfigMilliseconds, 1800000),
    sessionExpirationMs: (0, $3b63eef6ee7529a9$export$e86b712d02676c90)($f8c459c2dab16ec4$var$_chkConfigMilliseconds, 86400000),
    disableExceptionTracking: (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)()
}, $f8c459c2dab16ec4$var$_a[0, $771c93189b0d88d2$export$e4892641d6ea1b45 /* @min:autoTrackPageVisitTime */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $f8c459c2dab16ec4$var$_a[0, $771c93189b0d88d2$export$c653a2fea2d8252a /* @min:overridePageViewDuration */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $f8c459c2dab16ec4$var$_a[0, $771c93189b0d88d2$export$72fe3f7aecc0d015 /* @min:enableUnhandledPromiseRejectionTracking */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $f8c459c2dab16ec4$var$_a[0, $771c93189b0d88d2$export$527cc291f0159d2a /* @min:autoUnhandledPromiseInstrumented */ ] = false, $f8c459c2dab16ec4$var$_a.samplingPercentage = (0, $3b63eef6ee7529a9$export$d0884590a6a82e6c)($f8c459c2dab16ec4$var$_chkSampling, 100), $f8c459c2dab16ec4$var$_a[0, $771c93189b0d88d2$export$f357d96937d91514 /* @min:isStorageUseDisabled */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $f8c459c2dab16ec4$var$_a[0, $771c93189b0d88d2$export$204917ab19f7a461 /* @min:isBrowserLinkTrackingEnabled */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $f8c459c2dab16ec4$var$_a[0, $771c93189b0d88d2$export$6390687f17a52950 /* @min:enableAutoRouteTracking */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $f8c459c2dab16ec4$var$_a.namePrefix = (0, $3b63eef6ee7529a9$export$75965e1022d5969a)(), $f8c459c2dab16ec4$var$_a.enableDebug = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $f8c459c2dab16ec4$var$_a.disableFlushOnBeforeUnload = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $f8c459c2dab16ec4$var$_a.disableFlushOnUnload = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(false, "disableFlushOnBeforeUnload"), $f8c459c2dab16ec4$var$_a.expCfg = (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)({
    inclScripts: false,
    expLog: undefined,
    maxLogs: 50
}), $f8c459c2dab16ec4$var$_a));
function $f8c459c2dab16ec4$var$_chkConfigMilliseconds(value, defValue) {
    value = value || defValue;
    if (value < $f8c459c2dab16ec4$var$MinMilliSeconds) value = $f8c459c2dab16ec4$var$MinMilliSeconds;
    return +value;
}
function $f8c459c2dab16ec4$var$_chkSampling(value) {
    return !isNaN(value) && value > 0 && value <= 100;
}
function $f8c459c2dab16ec4$var$_updateStorageUsage(extConfig) {
    // Not resetting the storage usage as someone may have manually called utlDisableStorage, so this will only
    // reset based if the configuration option is provided
    if (!(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(extConfig[0, $771c93189b0d88d2$export$f357d96937d91514 /* @min:%2eisStorageUseDisabled */ ])) {
        if (extConfig[0, $771c93189b0d88d2$export$f357d96937d91514 /* @min:%2eisStorageUseDisabled */ ]) (0, $3fab9bbcce274f86$export$53ddd0ab7db9403)();
        else (0, $3fab9bbcce274f86$export$f08cf9bcd292b981)();
    }
}
var $f8c459c2dab16ec4$export$ca681bfeb2cf0fca = /** @class */ function(_super) {
    (0, $dc463ff9724142dd$export$1f9c32e3fbfb8e62)(AnalyticsPlugin, _super);
    function AnalyticsPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = (0, $5343a490b8ca01c7$export$862d858b0002f352); // do not change name or priority
        _this.priority = 180; // take from reserved priority range 100- 200
        _this.autoRoutePVDelay = 500; // ms; Time to wait after a route change before triggering a pageview to allow DOM changes to take place
        var _eventTracking;
        var _pageTracking;
        var _pageViewManager;
        var _pageViewPerformanceManager;
        var _pageVisitTimeManager;
        var _preInitTelemetryInitializers;
        var _isBrowserLinkTrackingEnabled;
        var _browserLinkInitializerAdded;
        var _enableAutoRouteTracking;
        var _historyListenerAdded;
        var _disableExceptionTracking;
        var _autoExceptionInstrumented;
        var _enableUnhandledPromiseRejectionTracking;
        var _autoUnhandledPromiseInstrumented;
        var _extConfig;
        var _autoTrackPageVisitTime;
        var _expCfg;
        // Counts number of trackAjax invocations.
        // By default we only monitor X ajax call per view to avoid too much load.
        // Default value is set in config.
        // This counter keeps increasing even after the limit is reached.
        var _trackAjaxAttempts = 0;
        // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
        var _prevUri; // Assigned in the constructor
        var _currUri;
        var _evtNamespace;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(AnalyticsPlugin, _this, function(_self, _base) {
            var _addHook = _base[0, $771c93189b0d88d2$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ];
            _initDefaults();
            _self.getCookieMgr = function() {
                return (0, $aaa64f3935d14265$export$76c0b273586c25c7)(_self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ]);
            };
            _self.processTelemetry = function(env, itemCtx) {
                _self.processNext(env, itemCtx);
            };
            _self.trackEvent = function(event, customProperties) {
                try {
                    var telemetryItem = (0, $f5d319867b0979c9$export$2dc41327de8d98f1)(event, (0, $62713924cc3cd966$export$d61e24a684f9e51)[0, $771c93189b0d88d2$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $62713924cc3cd966$export$d61e24a684f9e51)[0, $771c93189b0d88d2$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), customProperties);
                    _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
                } catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */ , 39 /* _eInternalMessageId.TrackTraceFailed */ , "trackTrace failed, trace will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * Start timing an extended event. Call `stopTrackEvent` to log the event when it ends.
             * @param   name    A string that identifies this event uniquely within the document.
             */ _self.startTrackEvent = function(name) {
                try {
                    _eventTracking.start(name);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 29 /* _eInternalMessageId.StartTrackEventFailed */ , "startTrackEvent failed, event will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * Log an extended event that you started timing with `startTrackEvent`.
             * @param   name    The string you used to identify this event in `startTrackEvent`.
             * @param   properties  map[string, string] - additional data used to filter events and metrics in the portal. Defaults to empty.
             * @param   measurements    map[string, number] - metrics associated with this event, displayed in Metrics Explorer on the portal. Defaults to empty.
             */ _self.stopTrackEvent = function(name, properties, measurements) {
                try {
                    _eventTracking.stop(name, undefined, properties, measurements);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 30 /* _eInternalMessageId.StopTrackEventFailed */ , "stopTrackEvent failed, event will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * @description Log a diagnostic message
             * @param trace
             * @param ICustomProperties.
             * @memberof ApplicationInsights
             */ _self.trackTrace = function(trace, customProperties) {
                try {
                    var telemetryItem = (0, $f5d319867b0979c9$export$2dc41327de8d98f1)(trace, (0, $adb0678ebd5d1780$export$78e1bea9036f120f)[0, $771c93189b0d88d2$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $adb0678ebd5d1780$export$78e1bea9036f120f)[0, $771c93189b0d88d2$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), customProperties);
                    _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
                } catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */ , 39 /* _eInternalMessageId.TrackTraceFailed */ , "trackTrace failed, trace will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * @description Log a numeric value that is not associated with a specific event. Typically
             * used to send regular reports of performance indicators. To send single measurement, just
             * use the name and average fields of {@link IMetricTelemetry}. If you take measurements
             * frequently, you can reduce the telemetry bandwidth by aggregating multiple measurements
             * and sending the resulting average at intervals
             * @param metric - input object argument. Only name and average are mandatory.
             * @param } customProperties additional data used to filter metrics in the
             * portal. Defaults to empty.
             * @memberof ApplicationInsights
             */ _self.trackMetric = function(metric, customProperties) {
                try {
                    var telemetryItem = (0, $f5d319867b0979c9$export$2dc41327de8d98f1)(metric, (0, $5db807982a2eef93$export$efdd3e096bc27746)[0, $771c93189b0d88d2$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $5db807982a2eef93$export$efdd3e096bc27746)[0, $771c93189b0d88d2$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), customProperties);
                    _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 36 /* _eInternalMessageId.TrackMetricFailed */ , "trackMetric failed, metric will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * Logs that a page or other item was viewed.
             * @param IPageViewTelemetry - The string you used as the name in startTrackPage. Defaults to the document title.
             * @param customProperties - Additional data used to filter events and metrics. Defaults to empty.
             * If a user wants to provide duration for pageLoad, it'll have to be in pageView.properties.duration
             */ _self[0, $771c93189b0d88d2$export$ab1a8669316b7a02 /* @min:%2etrackPageView */ ] = function(pageView, customProperties) {
                try {
                    var inPv = pageView || {};
                    _pageViewManager[0, $771c93189b0d88d2$export$ab1a8669316b7a02 /* @min:%2etrackPageView */ ](inPv, (0, $dc463ff9724142dd$export$b3cf7a802e578501)((0, $dc463ff9724142dd$export$b3cf7a802e578501)((0, $dc463ff9724142dd$export$b3cf7a802e578501)({}, inPv.properties), inPv.measurements), customProperties));
                    if (_autoTrackPageVisitTime) _pageVisitTimeManager[0, $771c93189b0d88d2$export$5b63a890d51a5194 /* @min:%2etrackPreviousPageVisit */ ](inPv.name, inPv.uri);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 37 /* _eInternalMessageId.TrackPVFailed */ , "trackPageView failed, page view will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * Create a page view telemetry item and send it to the SDK pipeline through the core.track API
             * @param pageView - Page view item to be sent
             * @param properties - Custom properties (Part C) that a user can add to the telemetry item
             * @param systemProperties - System level properties (Part A) that a user can add to the telemetry item
             */ _self[0, $771c93189b0d88d2$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ] = function(pageView, properties, systemProperties) {
                var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
                if (doc) pageView.refUri = pageView.refUri === undefined ? doc.referrer : pageView.refUri;
                if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(pageView[0, $771c93189b0d88d2$export$69cac26425c8ea23 /* @min:%2estartTime */ ])) {
                    // calculate the start time manually
                    var duration = (properties || pageView[0, $771c93189b0d88d2$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] || {})[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ] || 0;
                    pageView[0, $771c93189b0d88d2$export$69cac26425c8ea23 /* @min:%2estartTime */ ] = new Date(new Date().getTime() - duration);
                }
                var telemetryItem = (0, $f5d319867b0979c9$export$2dc41327de8d98f1)(pageView, (0, $3e77672805d15946$export$12c0fdede1c6bc6c)[0, $771c93189b0d88d2$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $3e77672805d15946$export$12c0fdede1c6bc6c)[0, $771c93189b0d88d2$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), properties, systemProperties);
                _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
                // reset ajaxes counter
                _trackAjaxAttempts = 0;
            };
            /**
             * @ignore INTERNAL ONLY
             * @param pageViewPerformance
             * @param properties
             */ _self[0, $771c93189b0d88d2$export$fe3039bd0e70dd3f /* @min:%2esendPageViewPerformanceInternal */ ] = function(pageViewPerformance, properties, systemProperties) {
                var telemetryItem = (0, $f5d319867b0979c9$export$2dc41327de8d98f1)(pageViewPerformance, (0, $03ee94b6fff0696e$export$709aae57ec681346)[0, $771c93189b0d88d2$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $03ee94b6fff0696e$export$709aae57ec681346)[0, $771c93189b0d88d2$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), properties, systemProperties);
                _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
            };
            /**
             * Send browser performance metrics.
             * @param pageViewPerformance
             * @param customProperties
             */ _self.trackPageViewPerformance = function(pageViewPerformance, customProperties) {
                var inPvp = pageViewPerformance || {};
                try {
                    _pageViewPerformanceManager[0, $771c93189b0d88d2$export$20270e2265c2a185 /* @min:%2epopulatePageViewPerformanceEvent */ ](inPvp);
                    _self[0, $771c93189b0d88d2$export$fe3039bd0e70dd3f /* @min:%2esendPageViewPerformanceInternal */ ](inPvp, customProperties);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 37 /* _eInternalMessageId.TrackPVFailed */ , "trackPageViewPerformance failed, page view will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * Starts the timer for tracking a page load time. Use this instead of `trackPageView` if you want to control when the page view timer starts and stops,
             * but don't want to calculate the duration yourself. This method doesn't send any telemetry. Call `stopTrackPage` to log the end of the page view
             * and send the event.
             * @param name - A string that idenfities this item, unique within this HTML document. Defaults to the document title.
             */ _self.startTrackPage = function(name) {
                try {
                    if (typeof name !== "string") {
                        var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
                        name = doc && doc.title || "";
                    }
                    _pageTracking.start(name);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 31 /* _eInternalMessageId.StartTrackFailed */ , "startTrackPage failed, page view may not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * Stops the timer that was started by calling `startTrackPage` and sends the pageview load time telemetry with the specified properties and measurements.
             * The duration of the page view will be the time between calling `startTrackPage` and `stopTrackPage`.
             * @param   name  The string you used as the name in startTrackPage. Defaults to the document title.
             * @param   url   String - a relative or absolute URL that identifies the page or other item. Defaults to the window location.
             * @param   properties  map[string, string] - additional data used to filter pages and metrics in the portal. Defaults to empty.
             * @param   measurements    map[string, number] - metrics associated with this page, displayed in Metrics Explorer on the portal. Defaults to empty.
             */ _self.stopTrackPage = function(name, url, properties, measurement) {
                try {
                    if (typeof name !== "string") {
                        var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
                        name = doc && doc.title || "";
                    }
                    if (typeof url !== "string") {
                        var loc = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)();
                        url = loc && loc[0, $771c93189b0d88d2$export$8d0bd9d006f3ecea /* @min:%2ehref */ ] || "";
                    }
                    _pageTracking.stop(name, url, properties, measurement);
                    if (_autoTrackPageVisitTime) _pageVisitTimeManager[0, $771c93189b0d88d2$export$5b63a890d51a5194 /* @min:%2etrackPreviousPageVisit */ ](name, url);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 32 /* _eInternalMessageId.StopTrackFailed */ , "stopTrackPage failed, page view will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
            * @ignore INTERNAL ONLY
            * @param exception
            * @param properties
            * @param systemProperties
            */ _self[0, $771c93189b0d88d2$export$5414b86ab837cb07 /* @min:%2esendExceptionInternal */ ] = function(exception, customProperties, systemProperties) {
                // Adding additional edge cases to handle
                // - Not passing anything (null / undefined)
                var theError = exception && (exception[0, $771c93189b0d88d2$export$4852fd87b68a6e1f /* @min:%2eexception */ ] || exception[0, $771c93189b0d88d2$export$ff0a0f80c43edd37 /* @min:%2eerror */ ]) || // - Handle someone calling trackException based of v1 API where the exception was the Error
                (0, $5831ddb3a0caf7c7$export$e6127cc7fe7395c3)(exception) && exception || // - Handles no error being defined and instead of creating a new Error() instance attempt to map so any stacktrace
                //   is preserved and does not list ApplicationInsights code as the source
                {
                    name: exception && typeof exception,
                    message: exception || (0, $8ac3b4fe9182f568$export$4003f5e1672d759)
                };
                // If no exception object was passed assign to an empty object to avoid internal exceptions
                exception = exception || {};
                var exceptionPartB = new (0, $a35c931c4df783c8$export$e2f174de097e0bcd)(_self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), theError, exception[0, $771c93189b0d88d2$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] || customProperties, exception.measurements, exception.severityLevel, exception.id).toInterface();
                var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
                if (doc && (_expCfg === null || _expCfg === void 0 ? void 0 : _expCfg.inclScripts)) {
                    var scriptsInfo = (0, $4726195e2d737947$export$1329d5a456df56f)(doc);
                    exceptionPartB[0, $771c93189b0d88d2$export$14814e6f9bf337b4 /* @min:%2eproperties */ ]["exceptionScripts"] = JSON.stringify(scriptsInfo);
                }
                if (_expCfg === null || _expCfg === void 0 ? void 0 : _expCfg.expLog) {
                    var logs = _expCfg.expLog();
                    if (logs && logs.logs && (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(logs.logs)) exceptionPartB[0, $771c93189b0d88d2$export$14814e6f9bf337b4 /* @min:%2eproperties */ ]["exceptionLog"] = logs.logs.slice(0, _expCfg.maxLogs).join("\n");
                }
                var telemetryItem = (0, $f5d319867b0979c9$export$2dc41327de8d98f1)(exceptionPartB, (0, $a35c931c4df783c8$export$e2f174de097e0bcd)[0, $771c93189b0d88d2$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $a35c931c4df783c8$export$e2f174de097e0bcd)[0, $771c93189b0d88d2$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), customProperties, systemProperties);
                _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
            };
            /**
             * Log an exception you have caught.
             *
             * @param exception -   Object which contains exception to be sent
             * @param } customProperties   Additional data used to filter pages and metrics in the portal. Defaults to empty.
             *
             * Any property of type double will be considered a measurement, and will be treated by Application Insights as a metric.
             * @memberof ApplicationInsights
             */ _self.trackException = function(exception, customProperties) {
                if (exception && !exception[0, $771c93189b0d88d2$export$4852fd87b68a6e1f /* @min:%2eexception */ ] && exception[0, $771c93189b0d88d2$export$ff0a0f80c43edd37 /* @min:%2eerror */ ]) exception[0, $771c93189b0d88d2$export$4852fd87b68a6e1f /* @min:%2eexception */ ] = exception[0, $771c93189b0d88d2$export$ff0a0f80c43edd37 /* @min:%2eerror */ ];
                try {
                    _self[0, $771c93189b0d88d2$export$5414b86ab837cb07 /* @min:%2esendExceptionInternal */ ](exception, customProperties);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 35 /* _eInternalMessageId.TrackExceptionFailed */ , "trackException failed, exception will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * @description Custom error handler for Application Insights Analytics
             * @param exception
             * @memberof ApplicationInsights
             */ _self[0, $771c93189b0d88d2$export$31fe7bcf0f7c83e8 /* @min:%2e_onerror */ ] = function(exception) {
                var error = exception && exception[0, $771c93189b0d88d2$export$ff0a0f80c43edd37 /* @min:%2eerror */ ];
                var evt = exception && exception.evt;
                try {
                    if (!evt) {
                        var _window = (0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)();
                        if (_window) evt = _window[$f8c459c2dab16ec4$var$strEvent];
                    }
                    var url = exception && exception.url || ((0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)() || {}).URL;
                    // If no error source is provided assume the default window.onerror handler
                    var errorSrc = exception[0, $771c93189b0d88d2$export$d190ee0b6bfe36d8 /* @min:%2eerrorSrc */ ] || "window.onerror@" + url + ":" + (exception[0, $771c93189b0d88d2$export$4d19a8ea486d5967 /* @min:%2elineNumber */ ] || 0) + ":" + (exception[0, $771c93189b0d88d2$export$91a182df12726bcd /* @min:%2ecolumnNumber */ ] || 0);
                    var properties = {
                        errorSrc: errorSrc,
                        url: url,
                        lineNumber: exception[0, $771c93189b0d88d2$export$4d19a8ea486d5967 /* @min:%2elineNumber */ ] || 0,
                        columnNumber: exception[0, $771c93189b0d88d2$export$91a182df12726bcd /* @min:%2ecolumnNumber */ ] || 0,
                        message: exception[0, $771c93189b0d88d2$export$923606b70907833e /* @min:%2emessage */ ]
                    };
                    if ((0, $7c0ecef5df4b34f7$export$8c465f5f14327ccd)(exception.message, exception.url, exception.lineNumber, exception.columnNumber, exception[0, $771c93189b0d88d2$export$ff0a0f80c43edd37 /* @min:%2eerror */ ])) _sendCORSException((0, $a35c931c4df783c8$export$e2f174de097e0bcd)[0, $771c93189b0d88d2$export$3dedbd38aa3b0c11 /* @min:%2eCreateAutoException */ ]("Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.", url, exception[0, $771c93189b0d88d2$export$4d19a8ea486d5967 /* @min:%2elineNumber */ ] || 0, exception[0, $771c93189b0d88d2$export$91a182df12726bcd /* @min:%2ecolumnNumber */ ] || 0, error, evt, null, errorSrc), properties);
                    else {
                        if (!exception[0, $771c93189b0d88d2$export$d190ee0b6bfe36d8 /* @min:%2eerrorSrc */ ]) exception[0, $771c93189b0d88d2$export$d190ee0b6bfe36d8 /* @min:%2eerrorSrc */ ] = errorSrc;
                        _self.trackException({
                            exception: exception,
                            severityLevel: 3 /* eSeverityLevel.Error */ 
                        }, properties);
                    }
                } catch (e) {
                    var errorString = error ? error.name + ", " + error[0, $771c93189b0d88d2$export$923606b70907833e /* @min:%2emessage */ ] : "null";
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 11 /* _eInternalMessageId.ExceptionWhileLoggingError */ , "_onError threw exception while logging error, error will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e),
                        errorString: errorString
                    });
                }
            };
            _self[0, $771c93189b0d88d2$export$935b759388157821 /* @min:%2eaddTelemetryInitializer */ ] = function(telemetryInitializer) {
                if (_self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ]) // Just add to the core
                return _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$935b759388157821 /* @min:%2eaddTelemetryInitializer */ ](telemetryInitializer);
                // Handle "pre-initialization" telemetry initializers (for backward compatibility)
                if (!_preInitTelemetryInitializers) _preInitTelemetryInitializers = [];
                _preInitTelemetryInitializers.push(telemetryInitializer);
            };
            _self.initialize = function(config, core, extensions, pluginChain) {
                if (_self.isInitialized()) return;
                if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(core)) (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)("Error initializing");
                _base.initialize(config, core, extensions, pluginChain);
                try {
                    _evtNamespace = (0, $02f0ede5277c99cd$export$3f37a50e0edde3be)((0, $0e058b881c0798ff$export$eb4a6badb18ead04)(_self.identifier), core.evtNamespace && core.evtNamespace());
                    if (_preInitTelemetryInitializers) {
                        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_preInitTelemetryInitializers, function(initializer) {
                            core[0, $771c93189b0d88d2$export$935b759388157821 /* @min:%2eaddTelemetryInitializer */ ](initializer);
                        });
                        _preInitTelemetryInitializers = null;
                    }
                    _populateDefaults(config);
                    _pageViewPerformanceManager = new (0, $b9c3d156d6cc38c0$export$da80ef98bc1bafa6)(_self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ]);
                    _pageViewManager = new (0, $89593731a05de0fb$export$5bb8d6768724bf86)(_self, _extConfig.overridePageViewDuration, _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ], _pageViewPerformanceManager);
                    _pageVisitTimeManager = new (0, $1e4790eb1573bab6$export$f6fdd81afb2fe76)(_self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), function(pageName, pageUrl, pageVisitTime) {
                        return trackPageVisitTime(pageName, pageUrl, pageVisitTime);
                    });
                    _eventTracking = new (0, $a8a86e0b8e3fa866$export$ef1e5872612852d1)(_self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), "trackEvent");
                    _eventTracking.action = function(name, url, duration, properties, measurements) {
                        if (!properties) properties = {};
                        if (!measurements) measurements = {};
                        properties.duration = duration[0, $771c93189b0d88d2$export$e2818d11505fa034 /* @min:%2etoString */ ]();
                        _self.trackEvent({
                            name: name,
                            properties: properties,
                            measurements: measurements
                        });
                    };
                    // initialize page view timing
                    _pageTracking = new (0, $a8a86e0b8e3fa866$export$ef1e5872612852d1)(_self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), "trackPageView");
                    _pageTracking.action = function(name, url, duration, properties, measurements) {
                        // duration must be a custom property in order for the collector to extract it
                        if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(properties)) properties = {};
                        properties.duration = duration[0, $771c93189b0d88d2$export$e2818d11505fa034 /* @min:%2etoString */ ]();
                        var pageViewItem = {
                            name: name,
                            uri: url,
                            properties: properties,
                            measurements: measurements
                        };
                        _self[0, $771c93189b0d88d2$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ](pageViewItem, properties);
                    };
                    if ((0, $5831ddb3a0caf7c7$export$fef62134eea24008)()) {
                        _updateExceptionTracking();
                        _updateLocationChange();
                    }
                } catch (e) {
                    // resetting the initialized state because of failure
                    _self.setInitialized(false);
                    throw e;
                }
            };
            _self._doTeardown = function(unloadCtx, unloadState) {
                _pageViewManager && _pageViewManager.teardown(unloadCtx, unloadState);
                // Just register to remove all events associated with this namespace
                (0, $02f0ede5277c99cd$export$51dedceb7c784eff)(window, null, null, _evtNamespace);
                _initDefaults();
            };
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ];
                _self[0, $771c93189b0d88d2$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $6387583e0b25820c$export$454a433e4deb244f)(config, function() {
                    var ctx = (0, $21bc92e23804c647$export$ca98f11e981bcfd6)(null, config, core);
                    _extConfig = ctx.getExtCfg(identifier, $f8c459c2dab16ec4$var$defaultValues);
                    _expCfg = _extConfig.expCfg;
                    _autoTrackPageVisitTime = _extConfig[0, $771c93189b0d88d2$export$e4892641d6ea1b45 /* @min:%2eautoTrackPageVisitTime */ ];
                    if (config.storagePrefix) (0, $3fab9bbcce274f86$export$a08dccf4adbf6df9)(config.storagePrefix);
                    $f8c459c2dab16ec4$var$_updateStorageUsage(_extConfig);
                    // _updateBrowserLinkTracking
                    _isBrowserLinkTrackingEnabled = _extConfig[0, $771c93189b0d88d2$export$204917ab19f7a461 /* @min:%2eisBrowserLinkTrackingEnabled */ ];
                    _addDefaultTelemetryInitializers();
                }));
            }
            /**
             * Log a page visit time
             * @param    pageName    Name of page
             * @param    pageVisitDuration Duration of visit to the page in milliseconds
             */ function trackPageVisitTime(pageName, pageUrl, pageVisitTime) {
                var properties = {
                    PageName: pageName,
                    PageUrl: pageUrl
                };
                _self.trackMetric({
                    name: "PageVisitTime",
                    average: pageVisitTime,
                    max: pageVisitTime,
                    min: pageVisitTime,
                    sampleCount: 1
                }, properties);
            }
            function _addDefaultTelemetryInitializers() {
                if (!_browserLinkInitializerAdded && _isBrowserLinkTrackingEnabled) {
                    var browserLinkPaths_1 = [
                        "/browserLinkSignalR/",
                        "/__browserLink/"
                    ];
                    var dropBrowserLinkRequests = function(envelope) {
                        if (_isBrowserLinkTrackingEnabled && envelope.baseType === (0, $97ca5e424f1910ef$export$a7b48490930dbffa)[0, $771c93189b0d88d2$export$9e16762ab4f2648 /* @min:%2edataType */ ]) {
                            var remoteData = envelope.baseData;
                            if (remoteData) for(var i = 0; i < browserLinkPaths_1[0, $771c93189b0d88d2$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
                                if (remoteData.target && (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(remoteData.target, browserLinkPaths_1[i]) >= 0) return false;
                            }
                        }
                        return true;
                    };
                    _self[0, $771c93189b0d88d2$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ](_self[0, $771c93189b0d88d2$export$935b759388157821 /* @min:%2eaddTelemetryInitializer */ ](dropBrowserLinkRequests));
                    _browserLinkInitializerAdded = true;
                }
            }
            function _sendCORSException(exception, properties) {
                var telemetryItem = (0, $f5d319867b0979c9$export$2dc41327de8d98f1)(exception, (0, $a35c931c4df783c8$export$e2f174de097e0bcd)[0, $771c93189b0d88d2$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $a35c931c4df783c8$export$e2f174de097e0bcd)[0, $771c93189b0d88d2$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), properties);
                _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
            }
            function _updateExceptionTracking() {
                var _window = (0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)();
                var locn = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)(true);
                _self[0, $771c93189b0d88d2$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $6387583e0b25820c$export$454a433e4deb244f)(_extConfig, function() {
                    _disableExceptionTracking = _extConfig.disableExceptionTracking;
                    if (!_disableExceptionTracking && !_autoExceptionInstrumented && !_extConfig.autoExceptionInstrumented) {
                        // We want to enable exception auto collection and it has not been done so yet
                        _addHook((0, $b3babfece552aa67$export$b96f6cbe9b035430)(_window, "onerror", {
                            ns: _evtNamespace,
                            rsp: function(callDetails, message, url, lineNumber, columnNumber, error) {
                                if (!_disableExceptionTracking && callDetails.rslt !== true) _self[0, $771c93189b0d88d2$export$31fe7bcf0f7c83e8 /* @min:%2e_onerror */ ]((0, $a35c931c4df783c8$export$e2f174de097e0bcd)[0, $771c93189b0d88d2$export$3dedbd38aa3b0c11 /* @min:%2eCreateAutoException */ ](message, url, lineNumber, columnNumber, error, callDetails.evt));
                            }
                        }, false));
                        _autoExceptionInstrumented = true;
                    }
                }));
                _addUnhandledPromiseRejectionTracking(_window, locn);
            }
            function _updateLocationChange() {
                var win = (0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)();
                var locn = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)(true);
                _self[0, $771c93189b0d88d2$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $6387583e0b25820c$export$454a433e4deb244f)(_extConfig, function() {
                    _enableAutoRouteTracking = _extConfig[0, $771c93189b0d88d2$export$6390687f17a52950 /* @min:%2eenableAutoRouteTracking */ ] === true;
                    /**
                     * Create a custom "locationchange" event which is triggered each time the history object is changed
                     */ if (win && _enableAutoRouteTracking && !_historyListenerAdded && (0, $5831ddb3a0caf7c7$export$b79afd6d47f11781)()) {
                        var _history = (0, $5831ddb3a0caf7c7$export$f9582a3c130d9538)();
                        if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(_history.pushState) && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(_history.replaceState) && typeof Event !== (0, $042f611b66f4fd6f$export$9b7d2d86cf58b987)) _addHistoryListener(win, _history, locn);
                    }
                }));
            }
            function _getDistributedTraceCtx() {
                var distributedTraceCtx = null;
                if (_self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ] && _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ].getTraceCtx) distributedTraceCtx = _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ].getTraceCtx(false);
                if (!distributedTraceCtx) {
                    // Fallback when using an older Core and PropertiesPlugin
                    var properties = _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ].getPlugin((0, $5343a490b8ca01c7$export$2268e69a6d93b7cc));
                    if (properties) {
                        var context = properties.plugin.context;
                        if (context) distributedTraceCtx = (0, $d98f9809e5d6a7c7$export$847d5dabba5fabb9)(context.telemetryTrace);
                    }
                }
                return distributedTraceCtx;
            }
            /**
             * Create a custom "locationchange" event which is triggered each time the history object is changed
             */ function _addHistoryListener(win, history, locn) {
                if (_historyListenerAdded) return;
                // Name Prefix is only referenced during the initial initialization and cannot be changed afterwards
                var namePrefix = _extConfig.namePrefix || "";
                function _popstateHandler() {
                    if (_enableAutoRouteTracking) $f8c459c2dab16ec4$var$_dispatchEvent(win, (0, $26e033f7638321e5$export$58aa8b47bf337bc8)(namePrefix + "locationchange"));
                }
                function _locationChangeHandler() {
                    // We always track the changes (if the handler is installed) to handle the feature being disabled between location changes
                    if (_currUri) {
                        _prevUri = _currUri;
                        _currUri = locn && locn[0, $771c93189b0d88d2$export$8d0bd9d006f3ecea /* @min:%2ehref */ ] || "";
                    } else _currUri = locn && locn[0, $771c93189b0d88d2$export$8d0bd9d006f3ecea /* @min:%2ehref */ ] || "";
                    if (_enableAutoRouteTracking) {
                        var distributedTraceCtx = _getDistributedTraceCtx();
                        if (distributedTraceCtx) {
                            distributedTraceCtx.setTraceId((0, $61bcf5b470259c00$export$58d1fad45f39d957)());
                            var traceLocationName = "_unknown_";
                            if (locn && locn.pathname) traceLocationName = locn.pathname + (locn.hash || "");
                            // This populates the ai.operation.name which has a maximum size of 1024 so we need to sanitize it
                            distributedTraceCtx.setName((0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(_self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), traceLocationName));
                        }
                        (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)((function(uri) {
                            // todo: override start time so that it is not affected by autoRoutePVDelay
                            _self[0, $771c93189b0d88d2$export$ab1a8669316b7a02 /* @min:%2etrackPageView */ ]({
                                refUri: uri,
                                properties: {
                                    duration: 0
                                }
                            }); // SPA route change loading durations are undefined, so send 0
                        }).bind(_self, _prevUri), _self.autoRoutePVDelay);
                    }
                }
                _addHook((0, $b3babfece552aa67$export$b96f6cbe9b035430)(history, "pushState", {
                    ns: _evtNamespace,
                    rsp: function() {
                        if (_enableAutoRouteTracking) {
                            $f8c459c2dab16ec4$var$_dispatchEvent(win, (0, $26e033f7638321e5$export$58aa8b47bf337bc8)(namePrefix + "pushState"));
                            $f8c459c2dab16ec4$var$_dispatchEvent(win, (0, $26e033f7638321e5$export$58aa8b47bf337bc8)(namePrefix + "locationchange"));
                        }
                    }
                }, true));
                _addHook((0, $b3babfece552aa67$export$b96f6cbe9b035430)(history, "replaceState", {
                    ns: _evtNamespace,
                    rsp: function() {
                        if (_enableAutoRouteTracking) {
                            $f8c459c2dab16ec4$var$_dispatchEvent(win, (0, $26e033f7638321e5$export$58aa8b47bf337bc8)(namePrefix + "replaceState"));
                            $f8c459c2dab16ec4$var$_dispatchEvent(win, (0, $26e033f7638321e5$export$58aa8b47bf337bc8)(namePrefix + "locationchange"));
                        }
                    }
                }, true));
                (0, $02f0ede5277c99cd$export$324ab159353a60a9)(win, namePrefix + "popstate", _popstateHandler, _evtNamespace);
                (0, $02f0ede5277c99cd$export$324ab159353a60a9)(win, namePrefix + "locationchange", _locationChangeHandler, _evtNamespace);
                _historyListenerAdded = true;
            }
            function _addUnhandledPromiseRejectionTracking(_window, _location) {
                _self[0, $771c93189b0d88d2$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $6387583e0b25820c$export$454a433e4deb244f)(_extConfig, function() {
                    _enableUnhandledPromiseRejectionTracking = _extConfig[0, $771c93189b0d88d2$export$72fe3f7aecc0d015 /* @min:%2eenableUnhandledPromiseRejectionTracking */ ] === true;
                    _autoExceptionInstrumented = _autoExceptionInstrumented || _extConfig[0, $771c93189b0d88d2$export$527cc291f0159d2a /* @min:%2eautoUnhandledPromiseInstrumented */ ];
                    if (_enableUnhandledPromiseRejectionTracking && !_autoUnhandledPromiseInstrumented) {
                        // We want to enable exception auto collection and it has not been done so yet
                        _addHook((0, $b3babfece552aa67$export$b96f6cbe9b035430)(_window, "onunhandledrejection", {
                            ns: _evtNamespace,
                            rsp: function(callDetails, error) {
                                if (_enableUnhandledPromiseRejectionTracking && callDetails.rslt !== true) _self[0, $771c93189b0d88d2$export$31fe7bcf0f7c83e8 /* @min:%2e_onerror */ ]((0, $a35c931c4df783c8$export$e2f174de097e0bcd)[0, $771c93189b0d88d2$export$3dedbd38aa3b0c11 /* @min:%2eCreateAutoException */ ]($f8c459c2dab16ec4$var$_getReason(error), _location ? _location[0, $771c93189b0d88d2$export$8d0bd9d006f3ecea /* @min:%2ehref */ ] : "", 0, 0, error, callDetails.evt));
                            }
                        }, false));
                        _extConfig[0, $771c93189b0d88d2$export$527cc291f0159d2a /* @min:%2eautoUnhandledPromiseInstrumented */ ] = _autoUnhandledPromiseInstrumented = true;
                    }
                }));
            }
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity - {eLoggingSeverity} - The severity of the log message
             * @param msgId - {_eInternalLogMessage} - The log message.
             */ function _throwInternal(severity, msgId, msg, properties, isUserAct) {
                _self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]().throwInternal(severity, msgId, msg, properties, isUserAct);
            }
            function _initDefaults() {
                _eventTracking = null;
                _pageTracking = null;
                _pageViewManager = null;
                _pageViewPerformanceManager = null;
                _pageVisitTimeManager = null;
                _preInitTelemetryInitializers = null;
                _isBrowserLinkTrackingEnabled = false;
                _browserLinkInitializerAdded = false;
                _enableAutoRouteTracking = false;
                _historyListenerAdded = false;
                _disableExceptionTracking = false;
                _autoExceptionInstrumented = false;
                _enableUnhandledPromiseRejectionTracking = false;
                _autoUnhandledPromiseInstrumented = false;
                _autoTrackPageVisitTime = false;
                // Counts number of trackAjax invocations.
                // By default we only monitor X ajax call per view to avoid too much load.
                // Default value is set in config.
                // This counter keeps increasing even after the limit is reached.
                _trackAjaxAttempts = 0;
                // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
                var location = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)(true);
                _prevUri = location && location[0, $771c93189b0d88d2$export$8d0bd9d006f3ecea /* @min:%2ehref */ ] || "";
                _currUri = null;
                _evtNamespace = null;
                _extConfig = null;
                // Define _self.config
                (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "config", {
                    g: function() {
                        return _extConfig;
                    }
                });
            }
            // For backward compatibility
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "_pageViewManager", {
                g: function() {
                    return _pageViewManager;
                }
            });
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "_pageViewPerformanceManager", {
                g: function() {
                    return _pageViewPerformanceManager;
                }
            });
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "_pageVisitTimeManager", {
                g: function() {
                    return _pageVisitTimeManager;
                }
            });
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "_evtNamespace", {
                g: function() {
                    return "." + _evtNamespace;
                }
            });
        });
        return _this;
    }
    // Removed Stub for AnalyticsPlugin.prototype.getCookieMgr.
    // Removed Stub for AnalyticsPlugin.prototype.processTelemetry.
    // Removed Stub for AnalyticsPlugin.prototype.trackEvent.
    // Removed Stub for AnalyticsPlugin.prototype.startTrackEvent.
    // Removed Stub for AnalyticsPlugin.prototype.stopTrackEvent.
    // Removed Stub for AnalyticsPlugin.prototype.trackTrace.
    // Removed Stub for AnalyticsPlugin.prototype.trackMetric.
    // Removed Stub for AnalyticsPlugin.prototype.trackPageView.
    // Removed Stub for AnalyticsPlugin.prototype.sendPageViewInternal.
    // Removed Stub for AnalyticsPlugin.prototype.sendPageViewPerformanceInternal.
    // Removed Stub for AnalyticsPlugin.prototype.trackPageViewPerformance.
    // Removed Stub for AnalyticsPlugin.prototype.startTrackPage.
    // Removed Stub for AnalyticsPlugin.prototype.stopTrackPage.
    // Removed Stub for AnalyticsPlugin.prototype.sendExceptionInternal.
    // Removed Stub for AnalyticsPlugin.prototype.trackException.
    // Removed Stub for AnalyticsPlugin.prototype._onerror.
    // Removed Stub for AnalyticsPlugin.prototype.addTelemetryInitializer.
    // Removed Stub for AnalyticsPlugin.prototype.initialize.
    AnalyticsPlugin.Version = "3.3.3"; // Not currently used anywhere
    return AnalyticsPlugin;
}((0, $dc0100a6f2a9749a$export$64a11c2f90e6766c));


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
* CfgSyncPlugin.ts
* @copyright Microsoft 2018
*/ 


/*!
 * NevWare21 Solutions LLC - ts-async, 0.5.3
 * https://github.com/nevware21/ts-async
 * Copyright (c) NevWare21 Solutions LLC and contributors. All rights reserved.
 * Licensed under the MIT license.
 */ 

var $4121df0a705d038e$var$STR_PROMISE = "Promise";
var $4121df0a705d038e$var$DONE = "done";
var $4121df0a705d038e$var$VALUE = "value";
var $4121df0a705d038e$var$RETURN = "return";
var $4121df0a705d038e$var$REJECTED = "rejected";
function $4121df0a705d038e$export$856fe465480fa77a(value, cb) {
    return $4121df0a705d038e$export$96acbd3e4fcaef01(value, function(value) {
        return cb ? cb({
            status: "fulfilled",
            rejected: false,
            value: value
        }) : value;
    }, function(reason) {
        return cb ? cb({
            status: $4121df0a705d038e$var$REJECTED,
            rejected: true,
            reason: reason
        }) : reason;
    });
}
function $4121df0a705d038e$export$96acbd3e4fcaef01(value, resolveFn, rejectFn, finallyFn) {
    var result = value;
    try {
        if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(value)) {
            if (resolveFn || rejectFn) result = value.then(resolveFn, rejectFn);
        } else try {
            if (resolveFn) result = resolveFn(value);
        } catch (err) {
            if (rejectFn) result = rejectFn(err);
            else throw err;
        }
    } finally{
        if (finallyFn) $4121df0a705d038e$export$8a7042cf3f497261(result, finallyFn);
    }
    return result;
}
function $4121df0a705d038e$export$8a7042cf3f497261(value, finallyFn) {
    var result = value;
    if (finallyFn) {
        if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(value)) {
            if (value.finally) result = value.finally(finallyFn);
            else result = value.then(function(value) {
                finallyFn();
                return value;
            }, function(reason) {
                finallyFn();
                throw reason;
            });
        } else finallyFn();
    }
    return result;
}
var $4121df0a705d038e$var$_debugState;
var $4121df0a705d038e$var$_debugResult;
var $4121df0a705d038e$var$_debugHandled;
var $4121df0a705d038e$var$_promiseDebugEnabled = false;
function $4121df0a705d038e$var$_addDebugState$1(thePromise, stateFn, resultFn, handledFn) {
    $4121df0a705d038e$var$_debugState = $4121df0a705d038e$var$_debugState || {
        toString: function() {
            return "[[PromiseState]]";
        }
    };
    $4121df0a705d038e$var$_debugResult = $4121df0a705d038e$var$_debugResult || {
        toString: function() {
            return "[[PromiseResult]]";
        }
    };
    $4121df0a705d038e$var$_debugHandled = $4121df0a705d038e$var$_debugHandled || {
        toString: function() {
            return "[[PromiseIsHandled]]";
        }
    };
    var props = {};
    props[$4121df0a705d038e$var$_debugState] = {
        get: stateFn
    };
    props[$4121df0a705d038e$var$_debugResult] = {
        get: resultFn
    };
    props[$4121df0a705d038e$var$_debugHandled] = {
        get: handledFn
    };
    (0, $5831ddb3a0caf7c7$export$aa4c975d12edd698)(thePromise, props);
}
function $4121df0a705d038e$export$8e8a3d6691d8254(enabled, logger) {
    $4121df0a705d038e$var$_promiseDebugEnabled = enabled;
}
var $4121df0a705d038e$var$STRING_STATES = [
    "pending",
    "resolving",
    "resolved",
    $4121df0a705d038e$var$REJECTED
];
var $4121df0a705d038e$var$DISPATCH_EVENT = "dispatchEvent";
var $4121df0a705d038e$var$_hasInitEvent;
function $4121df0a705d038e$var$_hasInitEventFn(doc) {
    var evt;
    if (doc && doc.createEvent) evt = doc.createEvent("Event");
    return !!evt && evt.initEvent;
}
function $4121df0a705d038e$var$emitEvent(target, evtName, populateEvent, useNewEvent) {
    var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
    !$4121df0a705d038e$var$_hasInitEvent && ($4121df0a705d038e$var$_hasInitEvent = (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)(!!(0, $5831ddb3a0caf7c7$export$170b8c323eee7bec)($4121df0a705d038e$var$_hasInitEventFn, [
        doc
    ]).v));
    var theEvt = $4121df0a705d038e$var$_hasInitEvent.v ? doc.createEvent("Event") : useNewEvent ? new Event(evtName) : {};
    populateEvent && populateEvent(theEvt);
    if ($4121df0a705d038e$var$_hasInitEvent.v) theEvt.initEvent(evtName, false, true);
    if (theEvt && target[$4121df0a705d038e$var$DISPATCH_EVENT]) target[$4121df0a705d038e$var$DISPATCH_EVENT](theEvt);
    else {
        var handler = target["on" + evtName];
        if (handler) handler(theEvt);
        else {
            var theConsole = (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)("console");
            theConsole && (theConsole["error"] || theConsole["log"])(evtName, (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(theEvt));
        }
    }
}
var $4121df0a705d038e$var$NODE_UNHANDLED_REJECTION = "unhandledRejection";
var $4121df0a705d038e$var$UNHANDLED_REJECTION = $4121df0a705d038e$var$NODE_UNHANDLED_REJECTION.toLowerCase();
var $4121df0a705d038e$var$_currentPromiseId = [];
var $4121df0a705d038e$var$_uniquePromiseId = 0;
var $4121df0a705d038e$var$_unhandledRejectionTimeout = 10;
var $4121df0a705d038e$var$_aggregationError;
var $4121df0a705d038e$var$_hasPromiseRejectionEvent;
function $4121df0a705d038e$var$dumpFnObj(value) {
    if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(value)) return value.toString();
    return (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(value);
}
/*#__NO_SIDE_EFFECTS__*/ function $4121df0a705d038e$var$_createAggregationError(values) {
    !$4121df0a705d038e$var$_aggregationError && ($4121df0a705d038e$var$_aggregationError = (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)((0, $5831ddb3a0caf7c7$export$170b8c323eee7bec)((0, $5831ddb3a0caf7c7$export$3df6e51375017edd), [
        "AggregationError"
    ]).v || (0, $5831ddb3a0caf7c7$export$435492119a21bab3)("AggregationError", function(self, args) {
        self.errors = args[0];
    })));
    return new $4121df0a705d038e$var$_aggregationError.v(values);
}
function $4121df0a705d038e$var$_createPromise(newPromise, processor, executor) {
    var additionalArgs = (0, $5831ddb3a0caf7c7$export$1bea104a0e2567f0)(arguments, 3);
    var _state = 0;
    var _hasResolved = false;
    var _settledValue;
    var _queue = [];
    var _id = $4121df0a705d038e$var$_uniquePromiseId++;
    var _parentId = $4121df0a705d038e$var$_currentPromiseId.length > 0 ? $4121df0a705d038e$var$_currentPromiseId[$4121df0a705d038e$var$_currentPromiseId.length - 1] : undefined;
    var _handled = false;
    var _unHandledRejectionHandler = null;
    var _thePromise;
    function _then(onResolved, onRejected) {
        try {
            $4121df0a705d038e$var$_currentPromiseId.push(_id);
            _handled = true;
            _unHandledRejectionHandler && _unHandledRejectionHandler.cancel();
            _unHandledRejectionHandler = null;
            var thenPromise = newPromise(function(resolve, reject) {
                _queue.push(function() {
                    try {
                        var handler = _state === 2 ? onResolved : onRejected;
                        var value = (0, $5831ddb3a0caf7c7$export$fce6876652108ab)(handler) ? _settledValue : (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(handler) ? handler(_settledValue) : handler;
                        if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(value)) value.then(resolve, reject);
                        else if (handler) resolve(value);
                        else if (_state === 3) reject(value);
                        else resolve(value);
                    } catch (e) {
                        reject(e);
                    }
                });
                if (_hasResolved) _processQueue();
            }, additionalArgs);
            return thenPromise;
        } finally{
            $4121df0a705d038e$var$_currentPromiseId.pop();
        }
    }
    function _catch(onRejected) {
        return _then(undefined, onRejected);
    }
    function _finally(onFinally) {
        var thenFinally = onFinally;
        var catchFinally = onFinally;
        if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(onFinally)) {
            thenFinally = function(value) {
                onFinally && onFinally();
                return value;
            };
            catchFinally = function(reason) {
                onFinally && onFinally();
                throw reason;
            };
        }
        return _then(thenFinally, catchFinally);
    }
    function _strState() {
        return $4121df0a705d038e$var$STRING_STATES[_state];
    }
    function _processQueue() {
        if (_queue.length > 0) {
            var pending = _queue.slice();
            _queue = [];
            _handled = true;
            _unHandledRejectionHandler && _unHandledRejectionHandler.cancel();
            _unHandledRejectionHandler = null;
            processor(pending);
        }
    }
    function _createSettleIfFn(newState, allowState) {
        return function(theValue) {
            if (_state === allowState) {
                if (newState === 2 && (0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(theValue)) {
                    _state = 1;
                    theValue.then(_createSettleIfFn(2, 1), _createSettleIfFn(3, 1));
                    return;
                }
                _state = newState;
                _hasResolved = true;
                _settledValue = theValue;
                _processQueue();
                if (!_handled && newState === 3 && !_unHandledRejectionHandler) _unHandledRejectionHandler = (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(_notifyUnhandledRejection, $4121df0a705d038e$var$_unhandledRejectionTimeout);
            }
        };
    }
    function _notifyUnhandledRejection() {
        if (!_handled) {
            _handled = true;
            if ((0, $5831ddb3a0caf7c7$export$8ee0fc9ee280b4ee)()) $cfae44f0dfdf62c0$exports.emit($4121df0a705d038e$var$NODE_UNHANDLED_REJECTION, _settledValue, _thePromise);
            else {
                var gbl = (0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)() || (0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)();
                !$4121df0a705d038e$var$_hasPromiseRejectionEvent && ($4121df0a705d038e$var$_hasPromiseRejectionEvent = (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)((0, $5831ddb3a0caf7c7$export$170b8c323eee7bec)((0, $5831ddb3a0caf7c7$export$3df6e51375017edd), [
                    $4121df0a705d038e$var$STR_PROMISE + "RejectionEvent"
                ]).v));
                $4121df0a705d038e$var$emitEvent(gbl, $4121df0a705d038e$var$UNHANDLED_REJECTION, function(theEvt) {
                    (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(theEvt, "promise", {
                        g: function() {
                            return _thePromise;
                        }
                    });
                    theEvt.reason = _settledValue;
                    return theEvt;
                }, !!$4121df0a705d038e$var$_hasPromiseRejectionEvent.v);
            }
        }
    }
    _thePromise = {
        then: _then,
        "catch": _catch,
        finally: _finally
    };
    (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(_thePromise, "state", {
        get: _strState
    });
    if ($4121df0a705d038e$var$_promiseDebugEnabled) $4121df0a705d038e$var$_addDebugState$1(_thePromise, _strState, function() {
        return (0, $5831ddb3a0caf7c7$export$3cbb80dec8953997)(_settledValue);
    }, function() {
        return _handled;
    });
    if ((0, $5831ddb3a0caf7c7$export$1e6e45ea4c3f892c)()) _thePromise[(0, $5831ddb3a0caf7c7$export$3a9aefdadea26115)(11)] = "IPromise";
    function _toString() {
        return "IPromise" + ($4121df0a705d038e$var$_promiseDebugEnabled ? "[" + _id + (!(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(_parentId) ? ":" + _parentId : "") + "]" : "") + " " + _strState() + (_hasResolved ? " - " + $4121df0a705d038e$var$dumpFnObj(_settledValue) : "") + "";
    }
    _thePromise.toString = _toString;
    (function _initialize() {
        if (!(0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(executor)) (0, $5831ddb3a0caf7c7$export$3f7738bd7dcba681)($4121df0a705d038e$var$STR_PROMISE + ": executor is not a function - " + $4121df0a705d038e$var$dumpFnObj(executor));
        var _rejectFn = _createSettleIfFn(3, 0);
        try {
            executor.call(_thePromise, _createSettleIfFn(2, 0), _rejectFn);
        } catch (e) {
            _rejectFn(e);
        }
    })();
    return _thePromise;
}
/*#__NO_SIDE_EFFECTS__*/ function $4121df0a705d038e$var$_createAllPromise(newPromise) {
    return function(input) {
        var additionalArgs = (0, $5831ddb3a0caf7c7$export$1bea104a0e2567f0)(arguments, 1);
        return newPromise(function(resolve, reject) {
            try {
                var values_1 = [];
                var pending_1 = 1;
                (0, $5831ddb3a0caf7c7$export$1180a64ad833b902)(input, function(item, idx) {
                    if (item) {
                        pending_1++;
                        $4121df0a705d038e$export$96acbd3e4fcaef01(item, function(value) {
                            values_1[idx] = value;
                            if (--pending_1 === 0) resolve(values_1);
                        }, reject);
                    }
                });
                pending_1--;
                if (pending_1 === 0) resolve(values_1);
            } catch (e) {
                reject(e);
            }
        }, additionalArgs);
    };
}
/*#__NO_SIDE_EFFECTS__*/ function $4121df0a705d038e$var$_createResolvedPromise(newPromise) {
    return function(value) {
        var additionalArgs = (0, $5831ddb3a0caf7c7$export$1bea104a0e2567f0)(arguments, 1);
        if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(value)) return value;
        return newPromise(function(resolve) {
            resolve(value);
        }, additionalArgs);
    };
}
/*#__NO_SIDE_EFFECTS__*/ function $4121df0a705d038e$var$_createRejectedPromise(newPromise) {
    return function(reason) {
        var additionalArgs = (0, $5831ddb3a0caf7c7$export$1bea104a0e2567f0)(arguments, 1);
        return newPromise(function(_resolve, reject) {
            reject(reason);
        }, additionalArgs);
    };
}
/*#__NO_SIDE_EFFECTS__*/ function $4121df0a705d038e$var$_createAllSettledPromise(newPromise) {
    return (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)(function(input) {
        var additionalArgs = (0, $5831ddb3a0caf7c7$export$1bea104a0e2567f0)(arguments, 1);
        return newPromise(function(resolve, reject) {
            var values = [];
            var pending = 1;
            function processItem(item, idx) {
                pending++;
                $4121df0a705d038e$export$856fe465480fa77a(item, function(value) {
                    if (value.rejected) values[idx] = {
                        status: $4121df0a705d038e$var$REJECTED,
                        reason: value.reason
                    };
                    else values[idx] = {
                        status: "fulfilled",
                        value: value.value
                    };
                    if (--pending === 0) resolve(values);
                });
            }
            try {
                if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(input)) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(input, processItem);
                else if ((0, $5831ddb3a0caf7c7$export$9652023d9040757)(input)) (0, $5831ddb3a0caf7c7$export$1180a64ad833b902)(input, processItem);
                else (0, $5831ddb3a0caf7c7$export$3f7738bd7dcba681)("Input is not an iterable");
                pending--;
                if (pending === 0) resolve(values);
            } catch (e) {
                reject(e);
            }
        }, additionalArgs);
    });
}
/*#__NO_SIDE_EFFECTS__*/ function $4121df0a705d038e$var$_createRacePromise(newPromise) {
    return (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)(function(input) {
        var additionalArgs = (0, $5831ddb3a0caf7c7$export$1bea104a0e2567f0)(arguments, 1);
        return newPromise(function(resolve, reject) {
            var isDone = false;
            function processItem(item) {
                $4121df0a705d038e$export$856fe465480fa77a(item, function(value) {
                    if (!isDone) {
                        isDone = true;
                        if (value.rejected) reject(value.reason);
                        else resolve(value.value);
                    }
                });
            }
            try {
                if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(input)) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(input, processItem);
                else if ((0, $5831ddb3a0caf7c7$export$9652023d9040757)(input)) (0, $5831ddb3a0caf7c7$export$1180a64ad833b902)(input, processItem);
                else (0, $5831ddb3a0caf7c7$export$3f7738bd7dcba681)("Input is not an iterable");
            } catch (e) {
                reject(e);
            }
        }, additionalArgs);
    });
}
/*#__NO_SIDE_EFFECTS__*/ function $4121df0a705d038e$var$_createAnyPromise(newPromise) {
    return (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)(function(input) {
        var additionalArgs = (0, $5831ddb3a0caf7c7$export$1bea104a0e2567f0)(arguments, 1);
        return newPromise(function(resolve, reject) {
            var theErros = [];
            var pending = 1;
            var isDone = false;
            function processItem(item, idx) {
                pending++;
                $4121df0a705d038e$export$856fe465480fa77a(item, function(value) {
                    if (!value.rejected) {
                        isDone = true;
                        resolve(value.value);
                        return;
                    } else theErros[idx] = value.reason;
                    if (--pending === 0 && !isDone) reject($4121df0a705d038e$var$_createAggregationError(theErros));
                });
            }
            try {
                if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(input)) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(input, processItem);
                else if ((0, $5831ddb3a0caf7c7$export$9652023d9040757)(input)) (0, $5831ddb3a0caf7c7$export$1180a64ad833b902)(input, processItem);
                else (0, $5831ddb3a0caf7c7$export$3f7738bd7dcba681)("Input is not an iterable");
                pending--;
                if (pending === 0 && !isDone) reject($4121df0a705d038e$var$_createAggregationError(theErros));
            } catch (e) {
                reject(e);
            }
        }, additionalArgs);
    });
}
function $4121df0a705d038e$var$syncItemProcessor(pending) {
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(pending, function(fn) {
        try {
            fn();
        } catch (e) {}
    });
}
function $4121df0a705d038e$var$timeoutItemProcessor(timeout) {
    var callbackTimeout = (0, $5831ddb3a0caf7c7$export$7e4aa119212bc614)(timeout) ? timeout : 0;
    return function(pending) {
        (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
            $4121df0a705d038e$var$syncItemProcessor(pending);
        }, callbackTimeout);
    };
}
function $4121df0a705d038e$var$idleItemProcessor(timeout) {
    var options;
    if (timeout >= 0) options = {
        timeout: +timeout
    };
    return function(pending) {
        (0, $5831ddb3a0caf7c7$export$553e359f3bef3995)(function(deadline) {
            $4121df0a705d038e$var$syncItemProcessor(pending);
        }, options);
    };
}
var $4121df0a705d038e$var$_allAsyncSettledCreator;
var $4121df0a705d038e$var$_raceAsyncCreator;
var $4121df0a705d038e$var$_anyAsyncCreator;
function $4121df0a705d038e$export$74d26603c0c38da8(executor, timeout) {
    return $4121df0a705d038e$var$_createPromise($4121df0a705d038e$export$74d26603c0c38da8, $4121df0a705d038e$var$timeoutItemProcessor(timeout), executor, timeout);
}
var $4121df0a705d038e$export$1735e21d720f8bc0 = /*#__PURE__*/ $4121df0a705d038e$var$_createAllPromise($4121df0a705d038e$export$74d26603c0c38da8);
var $4121df0a705d038e$export$f2163a387efd1843 = /*#__PURE__*/ $4121df0a705d038e$var$_createResolvedPromise($4121df0a705d038e$export$74d26603c0c38da8);
var $4121df0a705d038e$export$adb3940d4617f918 = /*#__PURE__*/ $4121df0a705d038e$var$_createRejectedPromise($4121df0a705d038e$export$74d26603c0c38da8);
function $4121df0a705d038e$export$56c0d8a059168096(input, timeout) {
    !$4121df0a705d038e$var$_allAsyncSettledCreator && ($4121df0a705d038e$var$_allAsyncSettledCreator = $4121df0a705d038e$var$_createAllSettledPromise($4121df0a705d038e$export$74d26603c0c38da8));
    return $4121df0a705d038e$var$_allAsyncSettledCreator.v(input, timeout);
}
function $4121df0a705d038e$export$600e257dfd344b6d(values, timeout) {
    !$4121df0a705d038e$var$_raceAsyncCreator && ($4121df0a705d038e$var$_raceAsyncCreator = $4121df0a705d038e$var$_createRacePromise($4121df0a705d038e$export$74d26603c0c38da8));
    return $4121df0a705d038e$var$_raceAsyncCreator.v(values, timeout);
}
function $4121df0a705d038e$export$26906e5a78118d20(values, timeout) {
    !$4121df0a705d038e$var$_anyAsyncCreator && ($4121df0a705d038e$var$_anyAsyncCreator = $4121df0a705d038e$var$_createAnyPromise($4121df0a705d038e$export$74d26603c0c38da8));
    return $4121df0a705d038e$var$_anyAsyncCreator.v(values, timeout);
}
var $4121df0a705d038e$var$_promiseCls;
var $4121df0a705d038e$var$_allCreator;
var $4121df0a705d038e$var$_allNativeSettledCreator;
var $4121df0a705d038e$var$_raceNativeCreator;
var $4121df0a705d038e$var$_anyNativeCreator;
/*#__NO_SIDE_EFFECTS__*/ function $4121df0a705d038e$var$_createNativePromiseHelper(name, func) {
    !$4121df0a705d038e$var$_promiseCls && ($4121df0a705d038e$var$_promiseCls = (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)((0, $5831ddb3a0caf7c7$export$170b8c323eee7bec)((0, $5831ddb3a0caf7c7$export$3df6e51375017edd), [
        $4121df0a705d038e$var$STR_PROMISE
    ]).v || null));
    if ($4121df0a705d038e$var$_promiseCls.v && $4121df0a705d038e$var$_promiseCls.v[name]) return (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)(function(input, timeout) {
        return $4121df0a705d038e$export$7edeaca5327f34ec(function(resolve, reject) {
            $4121df0a705d038e$var$_promiseCls.v[name](input).then(resolve, reject);
        });
    });
    return func();
}
function $4121df0a705d038e$export$7edeaca5327f34ec(executor, timeout) {
    !$4121df0a705d038e$var$_promiseCls && ($4121df0a705d038e$var$_promiseCls = (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)((0, $5831ddb3a0caf7c7$export$170b8c323eee7bec)((0, $5831ddb3a0caf7c7$export$3df6e51375017edd), [
        $4121df0a705d038e$var$STR_PROMISE
    ]).v || null));
    var PrmCls = $4121df0a705d038e$var$_promiseCls.v;
    if (!PrmCls) return $4121df0a705d038e$export$74d26603c0c38da8(executor);
    if (!(0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(executor)) (0, $5831ddb3a0caf7c7$export$3f7738bd7dcba681)($4121df0a705d038e$var$STR_PROMISE + ": executor is not a function - " + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(executor));
    var _state = 0;
    function _strState() {
        return $4121df0a705d038e$var$STRING_STATES[_state];
    }
    var thePromise = new PrmCls(function(resolve, reject) {
        function _resolve(value) {
            _state = 2;
            resolve(value);
        }
        function _reject(reason) {
            _state = 3;
            reject(reason);
        }
        executor(_resolve, _reject);
    });
    (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(thePromise, "state", {
        get: _strState
    });
    return thePromise;
}
function $4121df0a705d038e$export$9eb857118f5fb9d3(input, timeout) {
    !$4121df0a705d038e$var$_allCreator && ($4121df0a705d038e$var$_allCreator = $4121df0a705d038e$var$_createNativePromiseHelper("all", function() {
        return (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)($4121df0a705d038e$var$_createAllPromise($4121df0a705d038e$export$7edeaca5327f34ec));
    }));
    return $4121df0a705d038e$var$_allCreator.v(input, timeout);
}
var $4121df0a705d038e$export$c6f7d656137b22c7 = /*#__PURE__*/ $4121df0a705d038e$var$_createResolvedPromise($4121df0a705d038e$export$7edeaca5327f34ec);
var $4121df0a705d038e$export$ff6e17a8cb47ba93 = /*#__PURE__*/ $4121df0a705d038e$var$_createRejectedPromise($4121df0a705d038e$export$7edeaca5327f34ec);
function $4121df0a705d038e$export$8713c23077300cc8(input, timeout) {
    !$4121df0a705d038e$var$_allNativeSettledCreator && ($4121df0a705d038e$var$_allNativeSettledCreator = $4121df0a705d038e$var$_createNativePromiseHelper("allSettled", function() {
        return $4121df0a705d038e$var$_createAllSettledPromise($4121df0a705d038e$export$7edeaca5327f34ec);
    }));
    return $4121df0a705d038e$var$_allNativeSettledCreator.v(input, timeout);
}
function $4121df0a705d038e$export$8ed049fd905f1727(values, timeout) {
    !$4121df0a705d038e$var$_raceNativeCreator && ($4121df0a705d038e$var$_raceNativeCreator = $4121df0a705d038e$var$_createNativePromiseHelper("race", function() {
        return $4121df0a705d038e$var$_createRacePromise($4121df0a705d038e$export$7edeaca5327f34ec);
    }));
    return $4121df0a705d038e$var$_raceNativeCreator.v(values, timeout);
}
function $4121df0a705d038e$export$6fedbe2aec1ec46e(values, timeout) {
    !$4121df0a705d038e$var$_anyNativeCreator && ($4121df0a705d038e$var$_anyNativeCreator = $4121df0a705d038e$var$_createNativePromiseHelper("any", function() {
        return $4121df0a705d038e$var$_createAnyPromise($4121df0a705d038e$export$7edeaca5327f34ec);
    }));
    return $4121df0a705d038e$var$_anyNativeCreator.v(values, timeout);
}
var $4121df0a705d038e$var$_allSyncSettledCreator;
var $4121df0a705d038e$var$_raceSyncCreator;
var $4121df0a705d038e$var$_anySyncCreator;
function $4121df0a705d038e$export$87a90c443c3ca3ef(executor) {
    return $4121df0a705d038e$var$_createPromise($4121df0a705d038e$export$87a90c443c3ca3ef, $4121df0a705d038e$var$syncItemProcessor, executor);
}
var $4121df0a705d038e$export$a24f68ae71d4e00c = /*#__PURE__*/ $4121df0a705d038e$var$_createAllPromise($4121df0a705d038e$export$87a90c443c3ca3ef);
var $4121df0a705d038e$export$59c8ba01697b2799 = /*#__PURE__*/ $4121df0a705d038e$var$_createResolvedPromise($4121df0a705d038e$export$87a90c443c3ca3ef);
var $4121df0a705d038e$export$30a7efd4e673586 = /*#__PURE__*/ $4121df0a705d038e$var$_createRejectedPromise($4121df0a705d038e$export$87a90c443c3ca3ef);
function $4121df0a705d038e$export$c235d06856522848(input, timeout) {
    !$4121df0a705d038e$var$_allSyncSettledCreator && ($4121df0a705d038e$var$_allSyncSettledCreator = $4121df0a705d038e$var$_createAllSettledPromise($4121df0a705d038e$export$87a90c443c3ca3ef));
    return $4121df0a705d038e$var$_allSyncSettledCreator.v(input, timeout);
}
function $4121df0a705d038e$export$480418a4f5b8e503(values, timeout) {
    !$4121df0a705d038e$var$_raceSyncCreator && ($4121df0a705d038e$var$_raceSyncCreator = $4121df0a705d038e$var$_createRacePromise($4121df0a705d038e$export$87a90c443c3ca3ef));
    return $4121df0a705d038e$var$_raceSyncCreator.v(values, timeout);
}
function $4121df0a705d038e$export$99acc8d1bfcb0209(values, timeout) {
    !$4121df0a705d038e$var$_anySyncCreator && ($4121df0a705d038e$var$_anySyncCreator = $4121df0a705d038e$var$_createAnyPromise($4121df0a705d038e$export$87a90c443c3ca3ef));
    return $4121df0a705d038e$var$_anySyncCreator.v(values, timeout);
}
var $4121df0a705d038e$var$_defaultIdleTimeout;
var $4121df0a705d038e$var$_allIdleSettledCreator;
var $4121df0a705d038e$var$_raceIdleCreator;
var $4121df0a705d038e$var$_anyIdleCreator;
function $4121df0a705d038e$export$fd5c05c29ab034ec(idleDeadline) {
    $4121df0a705d038e$var$_defaultIdleTimeout = idleDeadline;
}
var $4121df0a705d038e$export$b588248e012cdf5c = $4121df0a705d038e$export$fd5c05c29ab034ec;
function $4121df0a705d038e$export$4e33ded44831dd3d(executor, timeout) {
    var theTimeout = (0, $5831ddb3a0caf7c7$export$fce6876652108ab)(timeout) ? $4121df0a705d038e$var$_defaultIdleTimeout : timeout;
    return $4121df0a705d038e$var$_createPromise($4121df0a705d038e$export$4e33ded44831dd3d, $4121df0a705d038e$var$idleItemProcessor(theTimeout), executor, theTimeout);
}
var $4121df0a705d038e$export$2c25fa87b8ad2dc0 = /*#__PURE__*/ $4121df0a705d038e$var$_createAllPromise($4121df0a705d038e$export$4e33ded44831dd3d);
var $4121df0a705d038e$export$ebba556db12b8de2 = /*#__PURE__*/ $4121df0a705d038e$var$_createResolvedPromise($4121df0a705d038e$export$4e33ded44831dd3d);
var $4121df0a705d038e$export$c0cc0d7545d2f2ac = /*#__PURE__*/ $4121df0a705d038e$var$_createRejectedPromise($4121df0a705d038e$export$4e33ded44831dd3d);
function $4121df0a705d038e$export$dcc8ce90289bfb19(input, timeout) {
    !$4121df0a705d038e$var$_allIdleSettledCreator && ($4121df0a705d038e$var$_allIdleSettledCreator = $4121df0a705d038e$var$_createAllSettledPromise($4121df0a705d038e$export$4e33ded44831dd3d));
    return $4121df0a705d038e$var$_allIdleSettledCreator.v(input, timeout);
}
function $4121df0a705d038e$export$dd8eeb7df534942(values, timeout) {
    !$4121df0a705d038e$var$_raceIdleCreator && ($4121df0a705d038e$var$_raceIdleCreator = $4121df0a705d038e$var$_createRacePromise($4121df0a705d038e$export$4e33ded44831dd3d));
    return $4121df0a705d038e$var$_raceIdleCreator.v(values, timeout);
}
function $4121df0a705d038e$export$42b449f8b2be4a2d(values, timeout) {
    !$4121df0a705d038e$var$_anyIdleCreator && ($4121df0a705d038e$var$_anyIdleCreator = $4121df0a705d038e$var$_createAnyPromise($4121df0a705d038e$export$4e33ded44831dd3d));
    return $4121df0a705d038e$var$_anyIdleCreator.v(values, timeout);
}
var $4121df0a705d038e$var$_promiseCreator;
var $4121df0a705d038e$var$_allSettledCreator;
var $4121df0a705d038e$var$_raceCreator;
var $4121df0a705d038e$var$_anyCreator;
function $4121df0a705d038e$export$c6c514c2f7329b79(creator) {
    $4121df0a705d038e$var$_promiseCreator = creator ? (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)(creator) : null;
}
function $4121df0a705d038e$export$5a1eb20c68656e88(executor, timeout) {
    !$4121df0a705d038e$var$_promiseCreator && ($4121df0a705d038e$var$_promiseCreator = (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)($4121df0a705d038e$export$7edeaca5327f34ec));
    return $4121df0a705d038e$var$_promiseCreator.v.call(this, executor, timeout);
}
var $4121df0a705d038e$export$1ed2fd8fe9f5c6 = /*#__PURE__*/ $4121df0a705d038e$var$_createAllPromise($4121df0a705d038e$export$5a1eb20c68656e88);
var $4121df0a705d038e$export$c6056e052f93dbce = /*#__PURE__*/ $4121df0a705d038e$var$_createResolvedPromise($4121df0a705d038e$export$5a1eb20c68656e88);
var $4121df0a705d038e$export$d22877ef6074ba31 = /*#__PURE__*/ $4121df0a705d038e$var$_createRejectedPromise($4121df0a705d038e$export$5a1eb20c68656e88);
function $4121df0a705d038e$export$18e9f1dec14b409f(input, timeout) {
    !$4121df0a705d038e$var$_allSettledCreator && ($4121df0a705d038e$var$_allSettledCreator = $4121df0a705d038e$var$_createAllSettledPromise($4121df0a705d038e$export$5a1eb20c68656e88));
    return $4121df0a705d038e$var$_allSettledCreator.v(input, timeout);
}
function $4121df0a705d038e$export$ed7d6046dc702a09(values, timeout) {
    !$4121df0a705d038e$var$_raceCreator && ($4121df0a705d038e$var$_raceCreator = $4121df0a705d038e$var$_createRacePromise($4121df0a705d038e$export$5a1eb20c68656e88));
    return $4121df0a705d038e$var$_raceCreator.v(values, timeout);
}
function $4121df0a705d038e$export$28d4602081696f5(values, timeout) {
    !$4121df0a705d038e$var$_anyCreator && ($4121df0a705d038e$var$_anyCreator = $4121df0a705d038e$var$_createAnyPromise($4121df0a705d038e$export$5a1eb20c68656e88));
    return $4121df0a705d038e$var$_anyCreator.v(values, timeout);
}
function $4121df0a705d038e$export$a0da96ad278b0532(timeout, resolveReject, message) {
    return $4121df0a705d038e$export$5a1eb20c68656e88(function(resolve, reject) {
        (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
            (resolveReject ? resolve : reject)(!(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(message) ? message : "Timeout of " + timeout + "ms exceeded");
        }, timeout);
    });
}
function $4121df0a705d038e$var$_doneChk(isDone, state, value, thisArg) {
    var result = isDone;
    state.res = value;
    if (!result) {
        if (state.isDone && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(state.isDone)) return $4121df0a705d038e$export$96acbd3e4fcaef01(state.isDone.call(thisArg, state), function(done) {
            state.iter++;
            return !!done;
        });
        else result = !!state.isDone;
    }
    state.iter++;
    return result;
}
function $4121df0a705d038e$export$a3cbfee43e77c4e7(callbackFn, isDoneFn, thisArg) {
    var promise;
    var resolve;
    var reject = function(reason) {
        isDone = true;
        throw reason;
    };
    var isDone = false;
    var state = {
        st: (0, $5831ddb3a0caf7c7$export$a56f095995763cca)(),
        iter: 0,
        isDone: isDoneFn || false
    };
    if (callbackFn) {
        var _createPromise_1 = function() {
            return $4121df0a705d038e$export$5a1eb20c68656e88(function(res, rej) {
                resolve = res;
                reject = rej;
            });
        };
        var _handleAsyncDone_1 = function(done) {
            isDone = !!done;
            if (!isDone) _processNext_1();
            else resolve(state.res);
        };
        var _processNext_1 = function() {
            while(!isDone)try {
                var cbResult = callbackFn.call(thisArg, state);
                if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(cbResult)) {
                    promise = promise || _createPromise_1();
                    $4121df0a705d038e$export$96acbd3e4fcaef01(cbResult, function(res) {
                        try {
                            $4121df0a705d038e$export$96acbd3e4fcaef01($4121df0a705d038e$var$_doneChk(isDone, state, res, thisArg), _handleAsyncDone_1, reject);
                        } catch (e) {
                            reject(e);
                        }
                    }, reject);
                    return promise;
                } else {
                    var dnRes = $4121df0a705d038e$var$_doneChk(isDone, state, cbResult, thisArg);
                    if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(dnRes)) {
                        promise = promise || _createPromise_1();
                        $4121df0a705d038e$export$96acbd3e4fcaef01(dnRes, _handleAsyncDone_1, reject);
                        return promise;
                    } else isDone = !!dnRes;
                }
            } catch (e) {
                reject(e);
                return promise;
            }
            if (isDone && resolve) resolve(state.res);
            return promise || state.res;
        };
        return _processNext_1();
    }
}
function $4121df0a705d038e$export$3b1f331280179db8(theArray, callbackFn, thisArg) {
    if (theArray) {
        var len_1 = (0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(theArray);
        if (len_1) {
            var isDone = function(state) {
                if (state.iter >= len_1 || state.res === -1) return true;
            };
            return $4121df0a705d038e$export$a3cbfee43e77c4e7(function(state) {
                var idx = state.iter;
                if (idx in theArray) return callbackFn.call(thisArg || theArray, theArray[idx], idx, theArray);
            }, isDone);
        }
    }
}
var $4121df0a705d038e$var$_iterSymbol;
var $4121df0a705d038e$var$_iterAsyncSymbol;
function $4121df0a705d038e$export$2c3e4cf1b08124bc(iter, callbackFn, thisArg) {
    var err;
    var iterResult;
    var theIter = iter;
    function onFailed(failed) {
        err = {
            e: failed
        };
        if (theIter.throw) {
            iterResult = null;
            theIter.throw(err);
        }
        throw failed;
    }
    function onFinally() {
        try {
            if (iterResult && !iterResult[$4121df0a705d038e$var$DONE]) theIter[$4121df0a705d038e$var$RETURN] && theIter[$4121df0a705d038e$var$RETURN](iterResult);
        } finally{
            if (err) throw err.e;
        }
    }
    if (iter) {
        if (!(0, $5831ddb3a0caf7c7$export$50db6e277db66ea0)(iter)) {
            !$4121df0a705d038e$var$_iterAsyncSymbol && ($4121df0a705d038e$var$_iterAsyncSymbol = (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)((0, $5831ddb3a0caf7c7$export$3a9aefdadea26115)(0)));
            theIter = iter[$4121df0a705d038e$var$_iterAsyncSymbol.v] ? iter[$4121df0a705d038e$var$_iterAsyncSymbol.v]() : null;
            if (!theIter) {
                !$4121df0a705d038e$var$_iterSymbol && ($4121df0a705d038e$var$_iterSymbol = (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)((0, $5831ddb3a0caf7c7$export$3a9aefdadea26115)(3)));
                theIter = iter[$4121df0a705d038e$var$_iterSymbol.v] ? iter[$4121df0a705d038e$var$_iterSymbol.v]() : null;
            }
        }
        if (theIter && (0, $5831ddb3a0caf7c7$export$50db6e277db66ea0)(theIter)) {
            var result = void 0;
            try {
                result = $4121df0a705d038e$export$a3cbfee43e77c4e7(function(state) {
                    return $4121df0a705d038e$export$96acbd3e4fcaef01(theIter.next(), function(res) {
                        iterResult = res;
                        if (!res[$4121df0a705d038e$var$DONE]) return (0, $5831ddb3a0caf7c7$export$4b40e215736a9426)(callbackFn, thisArg || theIter, iterResult[$4121df0a705d038e$var$VALUE], state.iter, theIter);
                    }, function(reason) {
                        state.isDone = true;
                        onFailed(reason);
                    });
                }, function(state) {
                    if (!iterResult || iterResult[$4121df0a705d038e$var$DONE] || state.res === -1) {
                        onFinally();
                        return true;
                    }
                }, thisArg || theIter);
                if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(result)) result = $4121df0a705d038e$export$8a7042cf3f497261(result.catch(onFailed), onFinally);
                return result;
            } catch (failed) {
                onFailed(failed);
            } finally{
                if (result && !(0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(result)) onFinally();
            }
        }
    }
}
var $4121df0a705d038e$var$REJECT = "reject";
var $4121df0a705d038e$var$REJECTED_ERROR = "Rejected";
var $4121df0a705d038e$var$_schedulerId = 0;
var $4121df0a705d038e$var$_debugName;
var $4121df0a705d038e$var$_debugIntState;
var $4121df0a705d038e$var$_customErrors = {};
function $4121df0a705d038e$var$_rejectDone() {}
function $4121df0a705d038e$var$_createError(type, evt, message) {
    !$4121df0a705d038e$var$_customErrors[type] && ($4121df0a705d038e$var$_customErrors[type] = (0, $5831ddb3a0caf7c7$export$435492119a21bab3)(type));
    var now = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)();
    return new $4121df0a705d038e$var$_customErrors[type]("Task [".concat(evt.id, "] ").concat(message || "", "- ").concat(evt.st ? "Running" : "Waiting", ": ").concat($4121df0a705d038e$var$_calcTime(now, evt.st || evt.cr)));
}
function $4121df0a705d038e$var$_calcTime(now, start) {
    return (now - start || "0") + " ms";
}
function $4121df0a705d038e$var$_abortStaleTasks(taskQueue, staleTimeoutPeriod) {
    var now = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)();
    var expired = now - staleTimeoutPeriod;
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(taskQueue, function(evt) {
        if (evt && !evt.rj && evt.st && evt.st < expired || !evt.st && evt.cr && evt.cr < expired) evt && evt[$4121df0a705d038e$var$REJECT](evt.rj || $4121df0a705d038e$var$_createError("Aborted", evt, "Stale "));
    });
}
function $4121df0a705d038e$var$_removeTask(queue, taskDetail) {
    var idx = (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(queue, taskDetail);
    if (idx !== -1) queue.splice(idx, 1);
}
function $4121df0a705d038e$var$_addDebugState(theScheduler, nameFn, stateFn) {
    $4121df0a705d038e$var$_debugName = $4121df0a705d038e$var$_debugName || {
        toString: function() {
            return "[[SchedulerName]]";
        }
    };
    $4121df0a705d038e$var$_debugIntState = $4121df0a705d038e$var$_debugIntState || {
        toString: function() {
            return "[[SchedulerState]]";
        }
    };
    (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(theScheduler, $4121df0a705d038e$var$_debugName, {
        get: nameFn
    });
    (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(theScheduler, $4121df0a705d038e$var$_debugIntState, {
        get: stateFn
    });
}
function $4121df0a705d038e$export$b8e809f247dcf830(newPromise, name) {
    var _theTask;
    var _running = [];
    var _waiting = [];
    var _staleTimeoutPeriod = 600000;
    var _staleTimeoutCheckPeriod = _staleTimeoutPeriod / 10;
    var _taskCount = 0;
    var _schedulerName = (name ? name + "." : "") + $4121df0a705d038e$var$_schedulerId++;
    var _blockedTimer;
    newPromise = newPromise || $4121df0a705d038e$export$5a1eb20c68656e88;
    var _startBlockedTimer = function() {
        var hasTasks = (0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(_running) + (0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(_waiting) > 0;
        if (_staleTimeoutPeriod > 0) {
            if (!_blockedTimer) {
                _blockedTimer = (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
                    $4121df0a705d038e$var$_abortStaleTasks(_running, _staleTimeoutPeriod);
                    $4121df0a705d038e$var$_abortStaleTasks(_waiting, _staleTimeoutPeriod);
                    _blockedTimer && (_blockedTimer.enabled = (0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(_running) + (0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(_waiting) > 0);
                }, _staleTimeoutCheckPeriod);
                _blockedTimer.unref();
            }
            _blockedTimer && (_blockedTimer.enabled = hasTasks);
        }
    };
    var _queueTask = function(startAction, taskName, timeout) {
        var _a;
        var taskId = _schedulerName + "." + _taskCount++;
        if (taskName) taskId += "-(" + taskName + ")";
        var newTask = (_a = {
            id: taskId,
            cr: (0, $5831ddb3a0caf7c7$export$a56f095995763cca)(),
            to: timeout
        }, _a[$4121df0a705d038e$var$REJECT] = function(reason) {
            newTask.rj = reason || $4121df0a705d038e$var$_createError($4121df0a705d038e$var$REJECTED_ERROR, newTask);
            newTask[$4121df0a705d038e$var$REJECT] = $4121df0a705d038e$var$_rejectDone;
        }, _a);
        if (!_theTask) newTask.p = newPromise(_runTask(newTask, startAction));
        else newTask.p = _waitForPreviousTask(newTask, _theTask, startAction);
        _theTask = newTask;
        return newTask.p;
    };
    var _runTask = function(taskDetail, startAction) {
        taskDetail.st = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)();
        _running.push(taskDetail);
        _startBlockedTimer();
        return function(onTaskResolve, onTaskReject) {
            var _promiseReject = function(reason) {
                taskDetail.rj = taskDetail.rj || reason || $4121df0a705d038e$var$_createError($4121df0a705d038e$var$REJECTED_ERROR, taskDetail);
                taskDetail[$4121df0a705d038e$var$REJECT] = $4121df0a705d038e$var$_rejectDone;
                _doCleanup(taskDetail);
                onTaskResolve = null;
                onTaskReject && onTaskReject(reason);
                onTaskReject = null;
            };
            var taskId = taskDetail.id;
            if (taskDetail.rj) _promiseReject(taskDetail.rj);
            else {
                taskDetail[$4121df0a705d038e$var$REJECT] = _promiseReject;
                try {
                    var startResult = startAction(taskId);
                    if (taskDetail.to && (0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(startResult)) taskDetail.t = (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
                        _promiseReject($4121df0a705d038e$var$_createError("Timeout", taskDetail));
                    }, taskDetail.to);
                    $4121df0a705d038e$export$96acbd3e4fcaef01(startResult, function(theResult) {
                        _doCleanup(taskDetail);
                        try {
                            onTaskResolve && onTaskResolve(theResult);
                        } catch (e) {
                            onTaskReject && onTaskReject(e);
                        }
                        onTaskReject = null;
                        onTaskResolve = null;
                    }, _promiseReject);
                } catch (e) {
                    _promiseReject(e);
                }
            }
        };
    };
    var _waitForPreviousTask = function(taskDetail, prevTask, startAction) {
        _waiting.push(taskDetail);
        _startBlockedTimer();
        return newPromise(function(onWaitResolve, onWaitReject) {
            $4121df0a705d038e$export$856fe465480fa77a(prevTask.p, function() {
                $4121df0a705d038e$var$_removeTask(_waiting, taskDetail);
                _runTask(taskDetail, startAction)(onWaitResolve, onWaitReject);
            });
        });
    };
    var _doCleanup = function(taskDetail) {
        $4121df0a705d038e$var$_removeTask(_running, taskDetail);
        taskDetail.t && taskDetail.t.cancel();
        taskDetail.t = null;
        if (_theTask && _theTask === taskDetail) {
            _theTask = null;
            if ((0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(_running) + (0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(_waiting) === 0) {
                _blockedTimer && _blockedTimer.cancel();
                _blockedTimer = null;
            }
        }
    };
    var theScheduler = {
        idle: true,
        queue: _queueTask,
        setStaleTimeout: function(staleTimeout, staleCheckPeriod) {
            _blockedTimer && _blockedTimer.cancel();
            _blockedTimer = null;
            _staleTimeoutPeriod = staleTimeout;
            _staleTimeoutCheckPeriod = staleCheckPeriod || staleTimeout / 10;
            _startBlockedTimer();
        }
    };
    (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(theScheduler, "idle", {
        g: function() {
            return (0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(_running) + (0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(_waiting) === 0;
        }
    });
    $4121df0a705d038e$var$_addDebugState(theScheduler, function() {
        return _schedulerName;
    }, function() {
        return {
            l: _theTask,
            r: _running,
            w: _waiting
        };
    });
    return theScheduler;
}
var $4121df0a705d038e$var$toStringTagSymbol = (0, $5831ddb3a0caf7c7$export$3a9aefdadea26115)(11);
var $4121df0a705d038e$export$66bd3447b1c9a4ff = /*#__PURE__*/ function() {
    function PolyPromiseImpl(executor) {
        this._$ = $4121df0a705d038e$export$74d26603c0c38da8(executor);
        if ($4121df0a705d038e$var$toStringTagSymbol) this[$4121df0a705d038e$var$toStringTagSymbol] = "Promise";
        (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(this, "state", {
            get: function() {
                return this._$.state;
            }
        });
    }
    PolyPromiseImpl.all = $4121df0a705d038e$export$1735e21d720f8bc0;
    PolyPromiseImpl.race = $4121df0a705d038e$export$600e257dfd344b6d;
    PolyPromiseImpl.any = $4121df0a705d038e$export$26906e5a78118d20;
    PolyPromiseImpl.reject = $4121df0a705d038e$export$adb3940d4617f918;
    PolyPromiseImpl.resolve = $4121df0a705d038e$export$f2163a387efd1843;
    PolyPromiseImpl.allSettled = $4121df0a705d038e$export$56c0d8a059168096;
    var theProto = PolyPromiseImpl.prototype;
    theProto.then = function(onResolved, onRejected) {
        return this._$.then(onResolved, onRejected);
    };
    theProto.catch = function(onRejected) {
        return this._$.catch(onRejected);
    };
    theProto.finally = function(onfinally) {
        return this._$.finally(onfinally);
    };
    return PolyPromiseImpl;
}();



/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $b2bb8b1c98486f95$export$fecb95562bb928a0 = "featureOptIn"; // Count: 4
var $b2bb8b1c98486f95$export$eef7b4d6bd236fca = "onCfgChangeReceive"; // Count: 2
var $b2bb8b1c98486f95$export$ed6d89b1e073c7c9 = "nonOverrideConfigs"; // Count: 2
var $b2bb8b1c98486f95$export$f48a0de15f844102 = "scheduleFetchTimeout"; // Count: 2


function $dc26cd3b06f2c35c$export$b4df6e888f21a5d1(cfg, nonOverrideConfigs, curLevel, maxLevel) {
    try {
        var exceedMaxLevel = curLevel > maxLevel;
        if (exceedMaxLevel) cfg = null;
        var curCfg_1 = curLevel == 0 ? (0, $5831ddb3a0caf7c7$export$a7f7e50f928053df)({}, cfg) : cfg; // only copy cfg at the begining level
        if (curCfg_1 && nonOverrideConfigs && !exceedMaxLevel) (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(curCfg_1, function(key) {
            var nonOverrideVal = nonOverrideConfigs[key];
            if (!!nonOverrideVal) {
                if ((0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(curCfg_1[key]) && (0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(nonOverrideVal)) curCfg_1[key] = $dc26cd3b06f2c35c$export$b4df6e888f21a5d1(curCfg_1[key], nonOverrideVal, ++curLevel, maxLevel);
                else delete curCfg_1[key];
            }
        });
        return curCfg_1;
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
    // if errors happen, do nothing
    return cfg;
}
//                                                     CDN Mode, value = B (CDN value = B)
//                                |--------------------------------------------------------------------------|-----------|
//                                |                    | none        | disabled    | enabled     | forceOn   | forceOff  |
//                                | ------------------ | ----------- | ----------- | ----------- | --------- | --------- |
// | User Mode, value = A         | none               | none        | disabled    | enabled     | enabled   | disabled  |
// (user Value = A)               | disabled           | disabled    | disabled    | disabled    | enabled   | disabled  |
//                                | enabled            | enabled     | disabled    | enabled     | enabled   | disabled  |
//                                | none(blockCdn)     | none        | none        | none        | none      | none      |
//                                | disabled(blockCdn) | disabled    | disabled    | disabled    | disabled  | disabled  |
//                                | enabled(blockCdn)  | enabled     | enabled     | enabled     | enabled   | enabled   |
// This matrix identifies how feature based overrides are selected (if present)
//                                cdn Mode (cdn Value = B)
//                   |---------------------------------------------------------------------------|
//                   |                    | none     | disabled | enabled  | forceOn  | forceOff |
//                   | ------------------ | ---------| ---------| ---------| ---------|----------|
// | User Mode       | none               | A        | A        | A || B   | B || A   | B || A   |
// (user Value = A)  | disabled           | A        | A        | A        | B || A   | B || A   |
//                   | enabled            | A        | A        | A || B   | B || A   | B || A   |
//                   | none(blockCdn)     | A        | A        | A        | A        | A        |
//                   | disabled(blockCdn) | A        | A        | A        | A        | A        |
//                   | enabled(blockCdn)  | A        | A        | A        | A        | A        |
// Note:
// Where the "value" is an object (map) of encoded key/values which will be used to override the real configuration
// A = either the user supplied enable/disable value (via the `config.featureOptIn[name]`) or if not defined by the user the SDK defaults of the same.
// B = The enable/disable value obtained from the CDN for the named feature
// These are evaluated based on the above matrix to either
// - A (Always the user/sdk value)
// - B (Always the value from the CDN)
// - A || B (If A is null or undefined use the value from the CDN (B) otherwise A)
// - B || A (If B is null or undefined use the user/SDK value otherwise use the value from the CDN)
//
// The result of the value may also be null / undefined, which means there are no overrides to apply when the feature is enabled
var $dc26cd3b06f2c35c$var$F = "featureOptIn.";
var $dc26cd3b06f2c35c$var$M = ".mode";
var $dc26cd3b06f2c35c$var$ON = ".onCfg";
var $dc26cd3b06f2c35c$var$OFF = ".offCfg";
function $dc26cd3b06f2c35c$export$767059b9bcd02c8(field, cdnCfg, userOptInDetails) {
    var _a;
    // cdn conifg value
    if (!cdnCfg || !cdnCfg.enabled) return null;
    var cdnFt = (cdnCfg[0, $b2bb8b1c98486f95$export$fecb95562bb928a0 /* @min:%2efeatureOptIn */ ] || {})[field] || {
        mode: 1 /* CdnFeatureMode.none */ 
    };
    var cdnM = cdnFt.mode;
    var cdnOnV = cdnFt.onCfg;
    var cdnOffV = cdnFt.offCfg;
    var userFt = (userOptInDetails || {})[field] || {
        mode: 2 /* FeatureOptInMode.disable */ 
    }; // default user mode is disable
    var userM = userFt.mode;
    var userOnV = userFt.onCfg;
    var userOffV = userFt.offCfg;
    var blockCdn = !!userFt.blockCdnCfg;
    var mFld = $dc26cd3b06f2c35c$var$F + field + $dc26cd3b06f2c35c$var$M;
    var onFld = $dc26cd3b06f2c35c$var$F + field + $dc26cd3b06f2c35c$var$ON;
    var offFld = $dc26cd3b06f2c35c$var$F + field + $dc26cd3b06f2c35c$var$OFF;
    var mode = userM;
    var onV = userOnV;
    var offV = userOffV;
    if (!blockCdn) {
        if (cdnM === 4 /* CdnFeatureMode.forceOn */  || cdnM === 5 /* CdnFeatureMode.forceOff */ ) {
            mode = cdnM == 4 /* CdnFeatureMode.forceOn */  ? 3 /* FeatureOptInMode.enable */  : 2 /* FeatureOptInMode.disable */ ;
            onV = cdnOnV || userOnV;
            offV = cdnOffV || userOffV;
        } else if (cdnM === 2 /* CdnFeatureMode.disable */  || userM === 2 /* FeatureOptInMode.disable */ ) {
            mode = 2 /* FeatureOptInMode.disable */ ;
            onV = userOnV || cdnOnV;
            offV = userOffV || cdnOffV;
        } else if (cdnM === 3 /* CdnFeatureMode.enable */ ) {
            mode = 3 /* FeatureOptInMode.enable */ ;
            onV = userOnV || cdnOnV;
            offV = userOffV || cdnOffV;
        } else if (cdnM === 1 /* CdnFeatureMode.none */  && userM === 1 /* FeatureOptInMode.none */ ) mode = 1 /* FeatureOptInMode.none */ ;
    }
    return _a = {}, _a[mFld] = mode, _a[onFld] = onV, _a[offFld] = offV, _a;
}
function $dc26cd3b06f2c35c$export$fdfda4484470ef4d(cdnCfg, core) {
    try {
        if (!cdnCfg || !cdnCfg.enabled) return null;
        if (!cdnCfg[0, $b2bb8b1c98486f95$export$fecb95562bb928a0 /* @min:%2efeatureOptIn */ ]) return cdnCfg.config;
        var optInMap = cdnCfg[0, $b2bb8b1c98486f95$export$fecb95562bb928a0 /* @min:%2efeatureOptIn */ ];
        var cdnConfig_1 = cdnCfg.config || {};
        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(optInMap, function(key) {
            var featureVal = $dc26cd3b06f2c35c$export$767059b9bcd02c8(key, cdnCfg, core.config[0, $b2bb8b1c98486f95$export$fecb95562bb928a0 /* @min:%2efeatureOptIn */ ]);
            if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(featureVal)) {
                (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(featureVal, function(config, val) {
                    (0, $5831ddb3a0caf7c7$export$7dee18238d098123)(cdnConfig_1, config, val);
                });
                $dc26cd3b06f2c35c$var$_overrideCdnCfgByFeature(key, featureVal, cdnConfig_1);
            }
        });
        return cdnConfig_1;
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
    return null;
}
function $dc26cd3b06f2c35c$var$_overrideCdnCfgByFeature(field, ftVal, config) {
    var mode = ftVal[$dc26cd3b06f2c35c$var$F + field + $dc26cd3b06f2c35c$var$M];
    var val = ftVal[$dc26cd3b06f2c35c$var$F + field + $dc26cd3b06f2c35c$var$ON];
    var dVal = ftVal[$dc26cd3b06f2c35c$var$F + field + $dc26cd3b06f2c35c$var$OFF];
    var target = null;
    if (mode === 3 /* FeatureOptInMode.enable */ ) target = val;
    if (mode === 2 /* FeatureOptInMode.disable */ ) target = dVal;
    if (target) (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(target, function(key, cfg) {
        (0, $5831ddb3a0caf7c7$export$7dee18238d098123)(config, key, cfg);
    });
}



var $c0d1696c8c7ba142$var$_a;
var $c0d1696c8c7ba142$var$EVENT_NAME = "ai_cfgsync";
var $c0d1696c8c7ba142$var$STR_GET_METHOD = "GET";
var $c0d1696c8c7ba142$var$FETCH_TIMEOUT = 1800000; // 30 minutes
var $c0d1696c8c7ba142$var$udfVal = undefined;
var $c0d1696c8c7ba142$var$defaultNonOverrideCfg = {
    instrumentationKey: true,
    connectionString: true,
    endpointUrl: true
};
var $c0d1696c8c7ba142$var$_defaultConfig = (0, $5831ddb3a0caf7c7$export$a15782d21797da4c)(($c0d1696c8c7ba142$var$_a = {
    syncMode: 1 /* ICfgSyncMode.Broadcast */ ,
    blkCdnCfg: $c0d1696c8c7ba142$var$udfVal,
    customEvtName: $c0d1696c8c7ba142$var$udfVal,
    cfgUrl: $c0d1696c8c7ba142$var$udfVal,
    overrideSyncFn: $c0d1696c8c7ba142$var$udfVal,
    overrideFetchFn: $c0d1696c8c7ba142$var$udfVal
}, $c0d1696c8c7ba142$var$_a[0, $b2bb8b1c98486f95$export$eef7b4d6bd236fca /* @min:onCfgChangeReceive */ ] = $c0d1696c8c7ba142$var$udfVal, $c0d1696c8c7ba142$var$_a[0, $b2bb8b1c98486f95$export$f48a0de15f844102 /* @min:scheduleFetchTimeout */ ] = $c0d1696c8c7ba142$var$FETCH_TIMEOUT, $c0d1696c8c7ba142$var$_a[0, $b2bb8b1c98486f95$export$ed6d89b1e073c7c9 /* @min:nonOverrideConfigs */ ] = $c0d1696c8c7ba142$var$defaultNonOverrideCfg, $c0d1696c8c7ba142$var$_a));
var $c0d1696c8c7ba142$export$30ebafc03af98b74 = /** @class */ function(_super) {
    (0, $dc463ff9724142dd$export$1f9c32e3fbfb8e62)(CfgSyncPlugin, _super);
    function CfgSyncPlugin() {
        var _this = _super.call(this) || this;
        _this.priority = 198;
        _this.identifier = "AppInsightsCfgSyncPlugin";
        var _extensionConfig;
        var _mainConfig; // throttle config should be wrapped in IConfiguration
        var _evtName;
        var _evtNamespace;
        var _cfgUrl;
        var _timeoutHandle;
        var _receiveChanges;
        var _broadcastChanges;
        var _blkCdnCfg;
        var _fetchTimeout;
        var _retryCnt;
        var _onCfgChangeReceive;
        var _nonOverrideConfigs;
        var _fetchFn;
        var _overrideFetchFn;
        var _overrideSyncFn;
        var _paused = false;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(CfgSyncPlugin, _this, function(_self, _base) {
            _initDefaults();
            _self.initialize = function(config, core, extensions, pluginChain) {
                _base.initialize(config, core, extensions, pluginChain);
                _evtNamespace = (0, $02f0ede5277c99cd$export$3f37a50e0edde3be)((0, $0e058b881c0798ff$export$eb4a6badb18ead04)(_self.identifier), core.evtNamespace && core.evtNamespace());
                _populateDefaults(config);
            };
            _self.getCfg = function() {
                return _mainConfig;
            };
            _self.pause = function() {
                _paused = true;
                _clearScheduledTimer();
            };
            _self.resume = function() {
                _paused = false;
                _setupTimer();
            };
            // used for V2 to manaully trigger config udpate
            _self.setCfg = function(config) {
                return _setCfg(config);
            };
            _self.sync = function(customDetails) {
                return _sendCfgsyncEvents(customDetails);
            };
            _self.updateEventListenerName = function(eventName) {
                return _updateEventListenerName(eventName);
            };
            _self._doTeardown = function(unloadCtx, unloadState) {
                _eventOff();
                _clearScheduledTimer();
                _initDefaults();
            };
            _self["_getDbgPlgTargets"] = function() {
                return [
                    _broadcastChanges,
                    _receiveChanges,
                    _evtName,
                    _blkCdnCfg,
                    _nonOverrideConfigs
                ];
            };
            function _initDefaults() {
                _mainConfig = null;
                _evtName = null;
                _evtNamespace = null;
                _cfgUrl = null;
                _receiveChanges = null;
                _broadcastChanges = null;
                _nonOverrideConfigs = null;
                _timeoutHandle = null;
                _fetchTimeout = null;
                _retryCnt = null;
                _blkCdnCfg = null;
                _overrideFetchFn = null;
                _overrideSyncFn = null;
                _onCfgChangeReceive = null;
            }
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self.core;
                _self._addHook((0, $6387583e0b25820c$export$454a433e4deb244f)(config, function() {
                    var ctx = (0, $21bc92e23804c647$export$ca98f11e981bcfd6)(null, config, core);
                    _extensionConfig = ctx.getExtCfg(identifier, $c0d1696c8c7ba142$var$_defaultConfig);
                    var preBlkCdn = _blkCdnCfg;
                    _blkCdnCfg = !!_extensionConfig.blkCdnCfg;
                    // avoid initial call
                    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(preBlkCdn) && preBlkCdn !== _blkCdnCfg) {
                        if (!_blkCdnCfg && _cfgUrl) _fetchFn && _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
                        else _clearScheduledTimer();
                    }
                    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_receiveChanges)) _receiveChanges = _extensionConfig.syncMode === 2 /* ICfgSyncMode.Receive */ ;
                    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_broadcastChanges)) _broadcastChanges = _extensionConfig.syncMode === 1 /* ICfgSyncMode.Broadcast */ ;
                    var newEvtName = _extensionConfig.customEvtName || $c0d1696c8c7ba142$var$EVENT_NAME;
                    if (_evtName !== newEvtName) {
                        if (_receiveChanges) _updateEventListenerName(newEvtName);
                        else {
                            _eventOff();
                            _evtName = newEvtName;
                        }
                    }
                    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_cfgUrl)) _cfgUrl = _extensionConfig.cfgUrl;
                    // if cfgUrl is set, we will ignore core config change
                    if (!_cfgUrl) {
                        _mainConfig = config;
                        if (_broadcastChanges) _sendCfgsyncEvents();
                    }
                }));
                _overrideSyncFn = _extensionConfig.overrideSyncFn;
                _overrideFetchFn = _extensionConfig.overrideFetchFn;
                _onCfgChangeReceive = _extensionConfig[0, $b2bb8b1c98486f95$export$eef7b4d6bd236fca /* @min:%2eonCfgChangeReceive */ ];
                _nonOverrideConfigs = _extensionConfig[0, $b2bb8b1c98486f95$export$ed6d89b1e073c7c9 /* @min:%2enonOverrideConfigs */ ]; // override values should not be changed
                _fetchTimeout = _extensionConfig[0, $b2bb8b1c98486f95$export$f48a0de15f844102 /* @min:%2escheduleFetchTimeout */ ];
                _fetchFn = _getFetchFnInterface();
                _retryCnt = 0;
                // NOT support cfgURL change to avoid mutiple fetch calls
                if (_cfgUrl && !_blkCdnCfg) _fetchFn && _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
            }
            function _setCfg(config, isAutoSync) {
                if (config) {
                    _mainConfig = config;
                    if (!!isAutoSync && !_paused) return _sendCfgsyncEvents();
                    if (_receiveChanges && !_paused) {
                        _self.core.updateCfg(config);
                        return true;
                    }
                }
                return false;
            }
            function _eventOff() {
                try {
                    var global_1 = (0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)();
                    if (global_1) (0, $02f0ede5277c99cd$export$51dedceb7c784eff)(global_1, null, null, _evtNamespace);
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
            }
            function _sendCfgsyncEvents(customDetails) {
                try {
                    if (!!_overrideSyncFn && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(_overrideSyncFn)) return _overrideSyncFn(_mainConfig, customDetails);
                    return (0, $0d2c2fb24388dcf8$export$af531f0ca2964c96)(_evtName, _mainConfig, customDetails);
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return false;
            }
            function _updateEventListenerName(name) {
                try {
                    _eventOff();
                    if (name) {
                        _evtName = name;
                        _addEventListener();
                    }
                    return true;
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return false;
            }
            function _getFetchFnInterface() {
                var _fetchFn = _overrideFetchFn;
                if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_fetchFn)) {
                    if ((0, $0d2c2fb24388dcf8$export$f8c1c61350d9749)()) _fetchFn = _fetchSender;
                    else if ((0, $0d2c2fb24388dcf8$export$cfeac9aa070f0108)()) _fetchFn = _xhrSender;
                }
                return _fetchFn;
            }
            function _fetchSender(url, oncomplete, isAutoSync) {
                var global = (0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)();
                var fetchFn = global && global.fetch || null;
                if (url && fetchFn && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(fetchFn)) try {
                    var init = {
                        method: $c0d1696c8c7ba142$var$STR_GET_METHOD
                    };
                    var request = new Request(url, init);
                    (0, $4121df0a705d038e$export$856fe465480fa77a)(fetch(request), function(result) {
                        var response = result.value;
                        if (!result.rejected) {
                            if (response.ok) (0, $4121df0a705d038e$export$856fe465480fa77a)(response.text(), function(res) {
                                _doOnComplete(oncomplete, response.status, res.value, isAutoSync);
                            });
                            else _doOnComplete(oncomplete, response.status, null, isAutoSync);
                        } else _doOnComplete(oncomplete, 400);
                    });
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
            }
            function _xhrSender(url, oncomplete, isAutoSync) {
                try {
                    var xhr_1 = new XMLHttpRequest();
                    xhr_1.open($c0d1696c8c7ba142$var$STR_GET_METHOD, url);
                    xhr_1.onreadystatechange = function() {
                        if (xhr_1.readyState === XMLHttpRequest.DONE) _doOnComplete(oncomplete, xhr_1.status, xhr_1.responseText, isAutoSync);
                    };
                    xhr_1.onerror = function() {
                        _doOnComplete(oncomplete, 400);
                    };
                    xhr_1.ontimeout = function() {
                        _doOnComplete(oncomplete, 400);
                    };
                    xhr_1.send();
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
            }
            function _onFetchComplete(status, response, isAutoSync) {
                try {
                    if (status >= 200 && status < 400 && response) {
                        _retryCnt = 0; // any successful response will reset retry count to 0
                        var JSON_1 = (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)();
                        if (JSON_1) {
                            var cdnCfg = JSON_1.parse(response); //comments are not allowed
                            var cfg = (0, $dc26cd3b06f2c35c$export$fdfda4484470ef4d)(cdnCfg, _self.core);
                            var newCfg = cfg && (0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(cfg) && _replaceTartgetByKeys(cfg);
                            newCfg && _setCfg(newCfg, isAutoSync);
                        //cfg && _setCfg(cfg, isAutoSync);
                        }
                    } else _retryCnt++;
                    if (_retryCnt < 3) _setupTimer();
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
            }
            function _doOnComplete(oncomplete, status, response, isAutoSync) {
                try {
                    oncomplete(status, response, isAutoSync);
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
            }
            function _addEventListener() {
                if (_receiveChanges) {
                    var global_2 = (0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)();
                    if (global_2) try {
                        (0, $02f0ede5277c99cd$export$324ab159353a60a9)(global_2, _evtName, function(event) {
                            // TODO: add more validation here
                            // may include a "name" or some other features to check
                            var cfgEvent = event && event.detail;
                            if (_onCfgChangeReceive && cfgEvent) _onCfgChangeReceive(cfgEvent);
                            else {
                                var cfg = cfgEvent && cfgEvent.cfg;
                                var newCfg = cfg && (0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(cfg) && _replaceTartgetByKeys(cfg);
                                newCfg && _setCfg(newCfg);
                            }
                        }, _evtNamespace, true);
                    } catch (e) {
                    // eslint-disable-next-line no-empty
                    }
                }
            }
            // 4 levels
            function _replaceTartgetByKeys(cfg, level) {
                var _cfg = null;
                try {
                    if (cfg) _cfg = (0, $dc26cd3b06f2c35c$export$b4df6e888f21a5d1)(cfg, _nonOverrideConfigs, 0, 5);
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return _cfg;
            }
            /**
             * Sets up the timer which triggers fetching cdn every 30mins after inital call
             */ function _setupTimer() {
                if (!_timeoutHandle && _fetchTimeout) {
                    _timeoutHandle = (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
                        _timeoutHandle = null;
                        _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
                    }, _fetchTimeout);
                    _timeoutHandle.unref();
                }
            }
            function _clearScheduledTimer() {
                _timeoutHandle && _timeoutHandle.cancel();
                _timeoutHandle = null;
                _retryCnt = 0;
            }
            _self.processTelemetry = function(env, itemCtx) {
                _self.processNext(env, itemCtx);
            };
        });
        return _this;
    }
    // Removed Stub for CfgSyncPlugin.prototype.initialize.
    // Removed Stub for CfgSyncPlugin.prototype.getCfg.
    // Removed Stub for CfgSyncPlugin.prototype.setCfg.
    // Removed Stub for CfgSyncPlugin.prototype.sync.
    // Removed Stub for CfgSyncPlugin.prototype.updateEventListenerName.
    // Removed Stub for CfgSyncPlugin.prototype.pause.
    // Removed Stub for CfgSyncPlugin.prototype.resume.
    //// Removed Stub for CfgSyncPlugin.prototype.processTelemetry.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    CfgSyncPlugin.__ieDyn = 1;
    return CfgSyncPlugin;
}((0, $dc0100a6f2a9749a$export$64a11c2f90e6766c));


/*
 * Application Insights JavaScript SDK - Channel, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $452a7a5f1b634188$export$bc7f1ae22a2680b3 = (0, $b49c449a24f657f6$export$fd52abd0b2703048)({
    NONE: 0 /* eActiveStatus.NONE */ ,
    PENDING: 3 /* eActiveStatus.PENDING */ ,
    INACTIVE: 1 /* eActiveStatus.INACTIVE */ ,
    ACTIVE: 2 /* eActiveStatus.ACTIVE */ 
});

/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



function $248db41a83147c13$export$ba14d9a5a581e827(response, diagLog) {
    try {
        if (response && response !== "") {
            var result = (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)().parse(response);
            if (result && result[0, $45806013ed348c93$export$746df81af2cb9d94 /* @min:%2eitemsReceived */ ] && result[0, $45806013ed348c93$export$746df81af2cb9d94 /* @min:%2eitemsReceived */ ] >= result.itemsAccepted && result.itemsReceived - result.itemsAccepted === result.errors[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]) return result;
        }
    } catch (e) {
        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(diagLog, 1 /* eLoggingSeverity.CRITICAL */ , 43 /* _eInternalMessageId.InvalidBackendResponse */ , "Cannot parse the response. " + (e[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:%2ename */ ] || (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)), {
            response: response
        });
    }
    return null;
}

/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


function $59a25debd846dee6$export$86347c3dd68c03f6(target, isAsync) {
    if (target && target[0, $45806013ed348c93$export$7eb85b5cba77a43d /* @min:%2eunload */ ]) return target[0, $45806013ed348c93$export$7eb85b5cba77a43d /* @min:%2eunload */ ](isAsync);
}
function $59a25debd846dee6$export$bc81824d13c51ef3(targets, isAsync, done) {
    var result;
    if (!done) result = (0, $4121df0a705d038e$export$5a1eb20c68656e88)(function(resolved) {
        done = resolved;
    });
    if (targets && (0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(targets) > 0) (0, $4121df0a705d038e$export$856fe465480fa77a)($59a25debd846dee6$export$86347c3dd68c03f6(targets[0], isAsync), function() {
        $59a25debd846dee6$export$bc81824d13c51ef3((0, $5831ddb3a0caf7c7$export$1bea104a0e2567f0)(targets, 1), isAsync, done);
    });
    else done();
    return result;
}

/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $585383ffe353022e$export$a1373ad9f192f374 = 500;
var $585383ffe353022e$export$7c6abff2f2bdd9c0 = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation"; // export const SampleRate = "sampleRate";
 // export const ProcessLegacy = "ProcessLegacy";
 // export const HttpMethod = "http.method";
 // export const DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
 // export const DEFAULT_BREEZE_PATH = "/v2/track";
 // export const strNotSpecified = "not_specified";
 // export const strIkey = "iKey";





var $7928109a8e3dfbfa$var$STR_EMPTY = "";
var $7928109a8e3dfbfa$var$STR_NO_RESPONSE_BODY = "NoResponseBody";
var $7928109a8e3dfbfa$var$_noResponseQs = "&" + $7928109a8e3dfbfa$var$STR_NO_RESPONSE_BODY + "=true";
var $7928109a8e3dfbfa$var$STR_POST_METHOD = "POST";
/**
 * This Internal component
 * Manager SendPost functions
 * SendPostManger
 * @internal for internal use only
 */ var $7928109a8e3dfbfa$export$e3388bef22319dfd = /** @class */ function() {
    function SenderPostManager() {
        var _syncFetchPayload = 0; // Keep track of the outstanding sync fetch payload total (as sync fetch has limits)
        var _enableSendPromise;
        var _isInitialized;
        var _diagLog;
        var _isOneDs;
        var _onCompleteFuncs;
        var _disableCredentials;
        var _fetchCredentials;
        var _fallbackInst;
        var _disableXhr;
        var _disableBeacon;
        var _disableBeaconSync;
        var _disableFetchKeepAlive;
        var _addNoResponse;
        var _timeoutWrapper;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(SenderPostManager, this, function(_self, _base) {
            var _sendCredentials = true; // for 1ds
            _initDefaults();
            _self[0, $45806013ed348c93$export$65cd33bb52d04675 /* @min:%2einitialize */ ] = function(config, diagLog) {
                _diagLog = diagLog;
                if (_isInitialized) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_diagLog, 1 /* eLoggingSeverity.CRITICAL */ , 28 /* _eInternalMessageId.SenderNotInitialized */ , "Sender is already initialized");
                _self.SetConfig(config);
                _isInitialized = true;
            };
            _self["_getDbgPlgTargets"] = function() {
                return [
                    _isInitialized,
                    _isOneDs,
                    _disableCredentials,
                    _enableSendPromise
                ];
            };
            // This componet might get its config from sender, offline sender, 1ds post
            // so set this function to mock dynamic changes
            _self.SetConfig = function(config) {
                try {
                    _onCompleteFuncs = config.senderOnCompleteCallBack || {};
                    _disableCredentials = !!config.disableCredentials;
                    _fetchCredentials = config.fetchCredentials;
                    _isOneDs = !!config.isOneDs;
                    _enableSendPromise = !!config.enableSendPromise;
                    _disableXhr = !!config.disableXhr;
                    _disableBeacon = !!config.disableBeacon;
                    _disableBeaconSync = !!config.disableBeaconSync;
                    _timeoutWrapper = config.timeWrapper;
                    _addNoResponse = !!config.addNoResponse;
                    _disableFetchKeepAlive = !!config.disableFetchKeepAlive;
                    _fallbackInst = {
                        sendPOST: _xhrSender
                    };
                    if (!_isOneDs) _sendCredentials = false; // for appInsights, set it to false always
                    if (_disableCredentials) {
                        var location_1 = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)();
                        if (location_1 && location_1.protocol && location_1.protocol[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]() === "file:") // Special case where a local html file fails with a CORS error on Chromium browsers
                        _sendCredentials = false;
                    }
                    return true;
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return false;
            };
            _self.getSyncFetchPayload = function() {
                return _syncFetchPayload;
            };
            _self.getSenderInst = function(transports, sync) {
                if (transports && transports[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]) return _getSenderInterface(transports, sync);
                return null;
            };
            _self.getFallbackInst = function() {
                return _fallbackInst;
            };
            _self[0, $45806013ed348c93$export$458d234b616d0745 /* @min:%2e_doTeardown */ ] = function(unloadCtx, unloadState) {
                _initDefaults();
            };
            /**
             * success handler
             */ function _onSuccess(res, onComplete) {
                _doOnComplete(onComplete, 200, {}, res);
            }
            /**
             * error handler
             */ function _onError(message, onComplete) {
                (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_diagLog, 2 /* eLoggingSeverity.WARNING */ , 26 /* _eInternalMessageId.OnError */ , "Failed to send telemetry.", {
                    message: message
                });
                _doOnComplete(onComplete, 400, {});
            }
            function _onNoPayloadUrl(onComplete) {
                _onError("No endpoint url is provided for the batch", onComplete);
            }
            function _getSenderInterface(transports, syncSupport) {
                var _a;
                var transportType = 0 /* TransportType.NotSet */ ;
                var sendPostFunc = null;
                var lp = 0;
                while(sendPostFunc == null && lp < transports[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]){
                    transportType = transports[lp];
                    if (!_disableXhr && transportType === 1 /* TransportType.Xhr */ ) {
                        if ((0, $0d2c2fb24388dcf8$export$b9f2bc09e5ac0fa5)()) // IE 8 and 9
                        sendPostFunc = _xdrSender;
                        else if ((0, $0d2c2fb24388dcf8$export$cfeac9aa070f0108)()) sendPostFunc = _xhrSender;
                    } else if (transportType === 2 /* TransportType.Fetch */  && (0, $0d2c2fb24388dcf8$export$f8c1c61350d9749)(syncSupport) && (!syncSupport || !_disableFetchKeepAlive)) sendPostFunc = _doFetchSender;
                    else if (transportType === 3 /* TransportType.Beacon */  && (0, $0d2c2fb24388dcf8$export$cf496c79c05967a0)() && (syncSupport ? !_disableBeaconSync : !_disableBeacon)) sendPostFunc = _beaconSender;
                    lp++;
                }
                if (sendPostFunc) return _a = {
                    _transport: transportType,
                    _isSync: syncSupport
                }, _a[0, $45806013ed348c93$export$601b401fe94b354 /* @min:sendPOST */ ] = sendPostFunc, _a;
                return null;
            }
            function _doOnComplete(oncomplete, status, headers, response) {
                try {
                    oncomplete && oncomplete(status, headers, response);
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
            }
            function _doBeaconSend(payload, oncomplete) {
                var nav = (0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)();
                var url = payload[0, $45806013ed348c93$export$4babcb0997150ae4 /* @min:%2eurlString */ ];
                if (!url) {
                    _onNoPayloadUrl(oncomplete);
                    // return true here, because we don't want to retry it with fallback sender
                    return true;
                }
                url = payload[0, $45806013ed348c93$export$4babcb0997150ae4 /* @min:%2eurlString */ ] + (_addNoResponse ? $7928109a8e3dfbfa$var$_noResponseQs : $7928109a8e3dfbfa$var$STR_EMPTY);
                var data = payload[0, $45806013ed348c93$export$2f5ff0b46814907e /* @min:%2edata */ ];
                // Chrome only allows CORS-safelisted values for the sendBeacon data argument
                // see: https://bugs.chromium.org/p/chromium/issues/detail?id=720283
                // Chrome only allows CORS-safelisted values for the sendBeacon data argument
                // see: https://bugs.chromium.org/p/chromium/issues/detail?id=720283
                var plainTextBatch = _isOneDs ? data : new Blob([
                    data
                ], {
                    type: "text/plain;charset=UTF-8"
                });
                // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                var queued = nav.sendBeacon(url, plainTextBatch);
                return queued;
            }
            /**
             * Send Beacon API request
             * @param payload - {string} - The data payload to be sent.
             * @param sync - {boolean} - not used
             * Note: Beacon API does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */ function _beaconSender(payload, oncomplete, sync) {
                var data = payload[0, $45806013ed348c93$export$2f5ff0b46814907e /* @min:%2edata */ ];
                try {
                    if (data) {
                        // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                        if (!_doBeaconSend(payload, oncomplete)) {
                            var onRetry = _onCompleteFuncs && _onCompleteFuncs.beaconOnRetry;
                            if (onRetry && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(onRetry)) onRetry(payload, oncomplete, _doBeaconSend);
                            else {
                                _fallbackInst && _fallbackInst[0, $45806013ed348c93$export$601b401fe94b354 /* @min:%2esendPOST */ ](payload, oncomplete, true);
                                (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_diagLog, 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Failed to send telemetry with Beacon API, retried with normal sender.");
                            }
                        } else // if can send
                        _onSuccess($7928109a8e3dfbfa$var$STR_EMPTY, oncomplete);
                    }
                } catch (e) {
                    _isOneDs && (0, $bacca83328a730a7$export$25fb4cb97863f0a8)(_diagLog, "Failed to send telemetry using sendBeacon API. Ex:" + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
                    _doOnComplete(oncomplete, _isOneDs ? 0 : 400, {}, $7928109a8e3dfbfa$var$STR_EMPTY);
                }
                return;
            }
            /**
             * Send XMLHttpRequest
             * @param payload - {string} - The data payload to be sent.
             * @param sync - {boolean} - Indicates if the request should be sent synchronously
             */ function _xhrSender(payload, oncomplete, sync) {
                //let  internalPayload = payload as IInternalPayloadData;
                var thePromise;
                var resolveFunc;
                var rejectFunc;
                var headers = payload[0, $45806013ed348c93$export$829ed22a43b4aada /* @min:%2eheaders */ ] || {};
                if (!sync && _enableSendPromise) thePromise = (0, $4121df0a705d038e$export$5a1eb20c68656e88)(function(resolve, reject) {
                    resolveFunc = resolve;
                    rejectFunc = reject;
                });
                if (_isOneDs && sync && payload.disableXhrSync) sync = false;
                //const xhr = new XMLHttpRequest();
                var endPointUrl = payload[0, $45806013ed348c93$export$4babcb0997150ae4 /* @min:%2eurlString */ ];
                if (!endPointUrl) {
                    _onNoPayloadUrl(oncomplete);
                    resolveFunc && resolveFunc(false);
                    return;
                }
                var xhr = (0, $ede407819d2d28c9$export$b028e759972c6d09)($7928109a8e3dfbfa$var$STR_POST_METHOD, endPointUrl, _sendCredentials, true, sync, payload[0, $45806013ed348c93$export$4a1d5ee7f477d201 /* @min:%2etimeout */ ]);
                if (!_isOneDs) // application/json should NOT add to 1ds post by default
                xhr[0, $45806013ed348c93$export$84ecd29f369f5b1d /* @min:%2esetRequestHeader */ ]("Content-type", "application/json");
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)((0, $5831ddb3a0caf7c7$export$f7628dc18f4211e5)(headers), function(headerName) {
                    xhr[0, $45806013ed348c93$export$84ecd29f369f5b1d /* @min:%2esetRequestHeader */ ](headerName, headers[headerName]);
                });
                xhr.onreadystatechange = function() {
                    if (!_isOneDs) {
                        _doOnReadyFunc(xhr);
                        if (xhr.readyState === 4) resolveFunc && resolveFunc(true);
                    }
                };
                xhr.onload = function() {
                    if (_isOneDs) _doOnReadyFunc(xhr);
                };
                function _doOnReadyFunc(xhr) {
                    var onReadyFunc = _onCompleteFuncs && _onCompleteFuncs.xhrOnComplete;
                    var onReadyFuncExist = onReadyFunc && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(onReadyFunc);
                    if (onReadyFuncExist) onReadyFunc(xhr, oncomplete, payload);
                    else {
                        var response = (0, $ede407819d2d28c9$export$43a870850da980b4)(xhr);
                        _doOnComplete(oncomplete, xhr[0, $45806013ed348c93$export$f8d169088a01f6f2 /* @min:%2estatus */ ], (0, $ede407819d2d28c9$export$801009daa428ec44)(xhr, _isOneDs), response);
                    }
                }
                xhr.onerror = function(event) {
                    _doOnComplete(oncomplete, _isOneDs ? xhr[0, $45806013ed348c93$export$f8d169088a01f6f2 /* @min:%2estatus */ ] : 400, (0, $ede407819d2d28c9$export$801009daa428ec44)(xhr, _isOneDs), _isOneDs ? $7928109a8e3dfbfa$var$STR_EMPTY : (0, $ede407819d2d28c9$export$f826fdf8bca00592)(xhr));
                    rejectFunc && rejectFunc(event);
                };
                xhr.ontimeout = function() {
                    _doOnComplete(oncomplete, _isOneDs ? xhr[0, $45806013ed348c93$export$f8d169088a01f6f2 /* @min:%2estatus */ ] : 500, (0, $ede407819d2d28c9$export$801009daa428ec44)(xhr, _isOneDs), _isOneDs ? $7928109a8e3dfbfa$var$STR_EMPTY : (0, $ede407819d2d28c9$export$f826fdf8bca00592)(xhr));
                    resolveFunc && resolveFunc(false);
                };
                xhr.send(payload[0, $45806013ed348c93$export$2f5ff0b46814907e /* @min:%2edata */ ]);
                return thePromise;
            }
            /**
             * Send fetch API request
             * @param payload - {string} - The data payload to be sent.
             * @param sync - {boolean} - For fetch this identifies whether we are "unloading" (false) or a normal request
             */ function _doFetchSender(payload, oncomplete, sync) {
                var _a;
                var endPointUrl = payload[0, $45806013ed348c93$export$4babcb0997150ae4 /* @min:%2eurlString */ ];
                var batch = payload[0, $45806013ed348c93$export$2f5ff0b46814907e /* @min:%2edata */ ];
                var plainTextBatch = _isOneDs ? batch : new Blob([
                    batch
                ], {
                    type: "application/json"
                });
                var thePromise;
                var resolveFunc;
                var rejectFunc;
                var requestHeaders = new Headers();
                var batchLength = batch[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
                var ignoreResponse = false;
                var responseHandled = false;
                var headers = payload[0, $45806013ed348c93$export$829ed22a43b4aada /* @min:%2eheaders */ ] || {};
                //TODO: handle time out for 1ds
                var init = (_a = {
                    method: $7928109a8e3dfbfa$var$STR_POST_METHOD,
                    body: plainTextBatch
                }, _a[0, $585383ffe353022e$export$7c6abff2f2bdd9c0] = true // Mark so we don't attempt to track this request
                , _a);
                // Only add headers if there are headers to add, due to issue with some polyfills
                if (payload.headers && (0, $5831ddb3a0caf7c7$export$f7628dc18f4211e5)(payload.headers)[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)((0, $5831ddb3a0caf7c7$export$f7628dc18f4211e5)(headers), function(headerName) {
                        requestHeaders.append(headerName, headers[headerName]);
                    });
                    init[0, $45806013ed348c93$export$829ed22a43b4aada /* @min:%2eheaders */ ] = requestHeaders;
                }
                if (_fetchCredentials) init.credentials = _fetchCredentials;
                else if (_sendCredentials && _isOneDs) // for 1ds, Don't send credentials when URL is file://
                init.credentials = "include";
                if (sync) {
                    init.keepalive = true;
                    _syncFetchPayload += batchLength;
                    if (_isOneDs) {
                        if (payload["_sendReason"] === 2 /* SendRequestReason.Unload */ ) {
                            // As a sync request (during unload), it is unlikely that we will get a chance to process the response so
                            // just like beacon send assume that the events have been accepted and processed
                            ignoreResponse = true;
                            if (_addNoResponse) endPointUrl += $7928109a8e3dfbfa$var$_noResponseQs;
                        }
                    } else // for appinsights, set to true for all sync request
                    ignoreResponse = true;
                }
                var request = new Request(endPointUrl, init);
                try {
                    // Also try and tag the request (just in case the value in init is not copied over)
                    request[0, $585383ffe353022e$export$7c6abff2f2bdd9c0] = true;
                } catch (e) {
                // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
                // cause the request to fail and we no telemetry would be sent
                }
                if (!sync && _enableSendPromise) thePromise = (0, $4121df0a705d038e$export$5a1eb20c68656e88)(function(resolve, reject) {
                    resolveFunc = resolve;
                    rejectFunc = reject;
                });
                if (!endPointUrl) {
                    _onNoPayloadUrl(oncomplete);
                    resolveFunc && resolveFunc(false);
                    return;
                }
                function _handleError(res) {
                    // In case there is an error in the request. Set the status to 0 for 1ds and 400 for appInsights
                    // so that the events can be retried later.
                    _doOnComplete(oncomplete, _isOneDs ? 0 : 400, {}, _isOneDs ? $7928109a8e3dfbfa$var$STR_EMPTY : res);
                }
                function _onFetchComplete(response, payload, value) {
                    var status = response[0, $45806013ed348c93$export$f8d169088a01f6f2 /* @min:%2estatus */ ];
                    var onCompleteFunc = _onCompleteFuncs.fetchOnComplete;
                    if (onCompleteFunc && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(onCompleteFunc)) onCompleteFunc(response, oncomplete, value || $7928109a8e3dfbfa$var$STR_EMPTY, payload);
                    else _doOnComplete(oncomplete, status, {}, value || $7928109a8e3dfbfa$var$STR_EMPTY);
                }
                try {
                    (0, $4121df0a705d038e$export$856fe465480fa77a)(fetch(_isOneDs ? endPointUrl : request, _isOneDs ? init : null), function(result) {
                        if (sync) {
                            _syncFetchPayload -= batchLength;
                            batchLength = 0;
                        }
                        if (!responseHandled) {
                            responseHandled = true;
                            if (!result.rejected) {
                                var response_1 = result[0, $45806013ed348c93$export$1805af0fa2230c20 /* @min:%2evalue */ ];
                                try {
                                    /**
                                     * The Promise returned from fetch() won’t reject on HTTP error status even if the response is an HTTP 404 or 500.
                                     * Instead, it will resolve normally (with ok status set to false), and it will only reject on network failure
                                     * or if anything prevented the request from completing.
                                     */ if (!_isOneDs && !response_1.ok) {
                                        // this is for appInsights only
                                        _handleError(response_1.statusText);
                                        resolveFunc && resolveFunc(false);
                                    } else if (_isOneDs && !response_1.body) {
                                        _onFetchComplete(response_1, null, $7928109a8e3dfbfa$var$STR_EMPTY);
                                        resolveFunc && resolveFunc(true);
                                    } else (0, $4121df0a705d038e$export$856fe465480fa77a)(response_1.text(), function(resp) {
                                        _onFetchComplete(response_1, payload, resp[0, $45806013ed348c93$export$1805af0fa2230c20 /* @min:%2evalue */ ]);
                                        resolveFunc && resolveFunc(true);
                                    });
                                } catch (e) {
                                    _handleError((0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
                                    rejectFunc && rejectFunc(e);
                                }
                            } else {
                                _handleError(result.reason && result.reason[0, $45806013ed348c93$export$923606b70907833e /* @min:%2emessage */ ]);
                                rejectFunc && rejectFunc(result.reason);
                            }
                        }
                    });
                } catch (e) {
                    if (!responseHandled) {
                        _handleError((0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
                        rejectFunc && rejectFunc(e);
                    }
                }
                if (ignoreResponse && !responseHandled) {
                    // Assume success during unload processing as we most likely won't get the response
                    responseHandled = true;
                    _doOnComplete(oncomplete, 200, {});
                    resolveFunc && resolveFunc(true);
                }
                if (_isOneDs && !responseHandled && payload[0, $45806013ed348c93$export$4a1d5ee7f477d201 /* @min:%2etimeout */ ] > 0) // Simulate timeout
                _timeoutWrapper && _timeoutWrapper.set(function() {
                    if (!responseHandled) {
                        // Assume a 500 response (which will cause a retry)
                        responseHandled = true;
                        _doOnComplete(oncomplete, 500, {});
                        resolveFunc && resolveFunc(true);
                    }
                }, payload[0, $45806013ed348c93$export$4a1d5ee7f477d201 /* @min:%2etimeout */ ]);
                return thePromise;
            }
            /**
             * Send XDomainRequest
             * @param payload - {string} - The data payload to be sent.
             * @param sync - {boolean} - Indicates if the request should be sent synchronously
             *
             * Note: XDomainRequest does not support sync requests. This 'isAsync' parameter is added
             * to maintain consistency with the xhrSender's contract
             * Note: XDomainRequest does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */ function _xdrSender(payload, oncomplete, sync) {
                // It doesn't support custom headers, so no action is taken with current requestHeaders
                var _window = (0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)();
                var xdr = new XDomainRequest();
                var data = payload[0, $45806013ed348c93$export$2f5ff0b46814907e /* @min:%2edata */ ];
                xdr.onload = function() {
                    var response = (0, $ede407819d2d28c9$export$43a870850da980b4)(xdr);
                    var onloadFunc = _onCompleteFuncs && _onCompleteFuncs.xdrOnComplete;
                    if (onloadFunc && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(onloadFunc)) onloadFunc(xdr, oncomplete, payload);
                    else _doOnComplete(oncomplete, 200, {}, response);
                };
                xdr.onerror = function() {
                    _doOnComplete(oncomplete, 400, {}, _isOneDs ? $7928109a8e3dfbfa$var$STR_EMPTY : (0, $ede407819d2d28c9$export$404d535171315d86)(xdr));
                };
                xdr.ontimeout = function() {
                    _doOnComplete(oncomplete, 500, {});
                };
                xdr.onprogress = function() {};
                // XDomainRequest requires the same protocol as the hosting page.
                // If the protocol doesn't match, we can't send the telemetry :(.
                var hostingProtocol = _window && _window.location && _window.location[0, $45806013ed348c93$export$c02b5cd14a83c390 /* @min:%2eprotocol */ ] || "";
                var endpoint = payload[0, $45806013ed348c93$export$4babcb0997150ae4 /* @min:%2eurlString */ ];
                if (!endpoint) {
                    _onNoPayloadUrl(oncomplete);
                    return;
                }
                if (!_isOneDs && endpoint.lastIndexOf(hostingProtocol, 0) !== 0) {
                    var msg = "Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.";
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_diagLog, 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". " + msg);
                    _onError(msg, oncomplete);
                    return;
                }
                var endpointUrl = _isOneDs ? endpoint : endpoint[0, $45806013ed348c93$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ](/^(https?:)/, "");
                xdr.open($7928109a8e3dfbfa$var$STR_POST_METHOD, endpointUrl);
                if (payload[0, $45806013ed348c93$export$4a1d5ee7f477d201 /* @min:%2etimeout */ ]) xdr[0, $45806013ed348c93$export$4a1d5ee7f477d201 /* @min:%2etimeout */ ] = payload[0, $45806013ed348c93$export$4a1d5ee7f477d201 /* @min:%2etimeout */ ];
                xdr.send(data);
                if (_isOneDs && sync) _timeoutWrapper && _timeoutWrapper.set(function() {
                    xdr.send(data);
                }, 0);
                else xdr.send(data);
            }
            function _initDefaults() {
                _syncFetchPayload = 0;
                _isInitialized = false;
                _enableSendPromise = false;
                _diagLog = null;
                _isOneDs = null;
                _onCompleteFuncs = null;
                _disableCredentials = null;
                _fetchCredentials = null;
                _fallbackInst = null;
                _disableXhr = false;
                _disableBeacon = false;
                _disableBeaconSync = false;
                _disableFetchKeepAlive = false;
                _addNoResponse = false;
                _timeoutWrapper = null;
            }
        });
    }
    // Removed Stub for SenderPostManager.prototype.initialize.
    // Removed Stub for SenderPostManager.prototype.getSyncFetchPayload.
    // Removed Stub for SenderPostManager.prototype.SetConfig.
    // Removed Stub for SenderPostManager.prototype.getSenderInst.
    // Removed Stub for SenderPostManager.prototype.getFallbackInst.
    // Removed Stub for SenderPostManager.prototype._doTeardown.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    SenderPostManager.__ieDyn = 1;
    return SenderPostManager;
}();



/*
 * Application Insights JavaScript SDK - Channel, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Channel, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var $7fa712059cae73d1$export$be41298b7716c698 = "duration";


/*
 * Application Insights JavaScript SDK - Channel, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $07716e087fcf5bbc$export$d0f526aa8043f6d7 = "tags"; // Count: 17
var $07716e087fcf5bbc$export$f393dda3e1c87f59 = "deviceType"; // Count: 3
var $07716e087fcf5bbc$export$2f5ff0b46814907e = "data"; // Count: 15
var $07716e087fcf5bbc$export$9734b0a24bf02e93 = "name"; // Count: 8
var $07716e087fcf5bbc$export$a5eb52c53bba8560 = "traceID"; // Count: 5
var $07716e087fcf5bbc$export$6eae51590aaea43 = "length"; // Count: 38
var $07716e087fcf5bbc$export$a318a8141fc98747 = "stringify"; // Count: 5
var $07716e087fcf5bbc$export$32fc64677eb5b7a2 = "measurements"; // Count: 7
var $07716e087fcf5bbc$export$9e16762ab4f2648 = "dataType"; // Count: 10
var $07716e087fcf5bbc$export$2672d4f7ccc80348 = "envelopeType"; // Count: 7
var $07716e087fcf5bbc$export$e2818d11505fa034 = "toString"; // Count: 7
var $07716e087fcf5bbc$export$7768b9624b4c70a6 = "_get"; // Count: 5
var $07716e087fcf5bbc$export$4aae77f3ba3c48b4 = "enqueue"; // Count: 7
var $07716e087fcf5bbc$export$e9679ef501b0d1 = "count"; // Count: 7
var $07716e087fcf5bbc$export$c8dd872dc774fa7c = "eventsLimitInMem"; // Count: 2
var $07716e087fcf5bbc$export$a0a330e7fa1e278c = "push"; // Count: 9
var $07716e087fcf5bbc$export$7a8bb3cc4a906992 = "item"; // Count: 6
var $07716e087fcf5bbc$export$b18aabdfc0aaf6b = "emitLineDelimitedJson"; // Count: 3
var $07716e087fcf5bbc$export$5eeb73fac03da74a = "clear"; // Count: 6
var $07716e087fcf5bbc$export$1e6514b499ba4d34 = "createNew"; // Count: 3
var $07716e087fcf5bbc$export$52e50651d87300e3 = "markAsSent"; // Count: 4
var $07716e087fcf5bbc$export$13da1b5a005ef035 = "clearSent"; // Count: 5
var $07716e087fcf5bbc$export$4637bcb72c509e60 = "bufferOverride"; // Count: 3
var $07716e087fcf5bbc$export$63ab2dad6d8a60ed = "BUFFER_KEY"; // Count: 5
var $07716e087fcf5bbc$export$d03f333763905c89 = "SENT_BUFFER_KEY"; // Count: 8
var $07716e087fcf5bbc$export$706142eb912dc2a = "concat"; // Count: 6
var $07716e087fcf5bbc$export$20d3a25105cda3b1 = "MAX_BUFFER_SIZE"; // Count: 5
var $07716e087fcf5bbc$export$df21ab0de9057cc4 = "triggerSend"; // Count: 5
var $07716e087fcf5bbc$export$c7ff2c36e5c78421 = "diagLog"; // Count: 16
var $07716e087fcf5bbc$export$65cd33bb52d04675 = "initialize"; // Count: 3
var $07716e087fcf5bbc$export$e5390b88ba6f1b04 = "_sender"; // Count: 5
var $07716e087fcf5bbc$export$bfa1c9e5dcf1e78 = "endpointUrl"; // Count: 5
var $07716e087fcf5bbc$export$81cfd43387c8dbcc = "instrumentationKey"; // Count: 5
var $07716e087fcf5bbc$export$dbe59923e879fdc5 = "customHeaders"; // Count: 3
var $07716e087fcf5bbc$export$803d432e48ba5ceb = "maxBatchSizeInBytes"; // Count: 2
var $07716e087fcf5bbc$export$6b8e1dc9b77f253c = "onunloadDisableBeacon"; // Count: 3
var $07716e087fcf5bbc$export$f5629284a6f7ec3d = "isBeaconApiDisabled"; // Count: 3
var $07716e087fcf5bbc$export$87044a2824fddfb0 = "alwaysUseXhrOverride"; // Count: 2
var $07716e087fcf5bbc$export$85f018eb7798fb52 = "disableXhr"; // Count: 3
var $07716e087fcf5bbc$export$c9210d86ca1dd637 = "enableSessionStorageBuffer"; // Count: 2
var $07716e087fcf5bbc$export$3f8a6394c5f7e7be = "_buffer"; // Count: 9
var $07716e087fcf5bbc$export$fa88a131053c3501 = "onunloadDisableFetch"; // Count: 2
var $07716e087fcf5bbc$export$78c7449d94867b7f = "disableSendBeaconSplit"; // Count: 2
var $07716e087fcf5bbc$export$1c777603d483e31f = "enableSendPromise"; // Count: 2
var $07716e087fcf5bbc$export$f8d641d56432a4fc = "getSenderInst"; // Count: 4
var $07716e087fcf5bbc$export$94f25b4060c75779 = "unloadTransports"; // Count: 2
var $07716e087fcf5bbc$export$12df46deb7379c67 = "convertUndefined"; // Count: 2
var $07716e087fcf5bbc$export$983774f06380e463 = "maxBatchInterval"; // Count: 2
var $07716e087fcf5bbc$export$3726a43a9362600c = "serialize"; // Count: 4
var $07716e087fcf5bbc$export$fd0c91d4da43d71b = "_onError"; // Count: 7
var $07716e087fcf5bbc$export$689c49d56ac33585 = "_onPartialSuccess"; // Count: 3
var $07716e087fcf5bbc$export$82a109ffee49e423 = "_onSuccess"; // Count: 6
var $07716e087fcf5bbc$export$746df81af2cb9d94 = "itemsReceived"; // Count: 3
var $07716e087fcf5bbc$export$fb8523c8667e286a = "itemsAccepted"; // Count: 3
var $07716e087fcf5bbc$export$649529ba72435000 = "oriPayload"; // Count: 3
var $07716e087fcf5bbc$export$aa558e99f83347cf = "baseType"; // Count: 4
var $07716e087fcf5bbc$export$c2afe23fa18f9dff = "sampleRate"; // Count: 4
var $07716e087fcf5bbc$export$298b8388870fcfe9 = "eventsSendRequest"; // Count: 2
var $07716e087fcf5bbc$export$2c3af30a5c45aa6e = "getSamplingScore"; // Count: 2
var $07716e087fcf5bbc$export$d676f8c50f371355 = "getHashCodeScore"; // Count: 4


// these two constants are used to filter out properties not needed when trying to extract custom properties and measurements from the incoming payload
var $53141cdecfc05483$var$strBaseType = "baseType";
var $53141cdecfc05483$var$strBaseData = "baseData";
var $53141cdecfc05483$var$strProperties = "properties";
var $53141cdecfc05483$var$strTrue = "true";
function $53141cdecfc05483$var$_setValueIf(target, field, value) {
    return (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(target, field, value, (0, $5831ddb3a0caf7c7$export$8f9cae6546f97a9f));
}
/*
 * Maps Part A data from CS 4.0
 */ function $53141cdecfc05483$var$_extractPartAExtensions(logger, item, env) {
    // todo: switch to keys from common in this method
    var envTags = env[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] = env[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] || {};
    var itmExt = item.ext = item.ext || {};
    var itmTags = item[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] = item[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] || [];
    var extUser = itmExt.user;
    if (extUser) {
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).userAuthUserId, extUser.authId);
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).userId, extUser.id || extUser.localId);
    }
    var extApp = itmExt.app;
    if (extApp) $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).sessionId, extApp.sesId);
    var extDevice = itmExt.device;
    if (extDevice) {
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).deviceId, extDevice.id || extDevice.localId);
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6)[0, $07716e087fcf5bbc$export$f393dda3e1c87f59 /* @min:%2edeviceType */ ], extDevice.deviceClass);
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).deviceIp, extDevice.ip);
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).deviceModel, extDevice.model);
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6)[0, $07716e087fcf5bbc$export$f393dda3e1c87f59 /* @min:%2edeviceType */ ], extDevice[0, $07716e087fcf5bbc$export$f393dda3e1c87f59 /* @min:%2edeviceType */ ]);
    }
    var web = item.ext.web;
    if (web) {
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).deviceLanguage, web.browserLang);
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).deviceBrowserVersion, web.browserVer);
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).deviceBrowser, web.browser);
        var envData = env[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ] = env[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ] || {};
        var envBaseData = envData[$53141cdecfc05483$var$strBaseData] = envData[$53141cdecfc05483$var$strBaseData] || {};
        var envProps = envBaseData[$53141cdecfc05483$var$strProperties] = envBaseData[$53141cdecfc05483$var$strProperties] || {};
        $53141cdecfc05483$var$_setValueIf(envProps, "domain", web.domain);
        $53141cdecfc05483$var$_setValueIf(envProps, "isManual", web.isManual ? $53141cdecfc05483$var$strTrue : null);
        $53141cdecfc05483$var$_setValueIf(envProps, "screenRes", web.screenRes);
        $53141cdecfc05483$var$_setValueIf(envProps, "userConsent", web.userConsent ? $53141cdecfc05483$var$strTrue : null);
    }
    var extOs = itmExt.os;
    if (extOs) {
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).deviceOS, extOs[0, $07716e087fcf5bbc$export$9734b0a24bf02e93 /* @min:%2ename */ ]);
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).deviceOSVersion, extOs.osVer);
    }
    // No support for mapping Trace.traceState to 2.0 as it is currently empty
    var extTrace = itmExt.trace;
    if (extTrace) {
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).operationParentId, extTrace.parentID);
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).operationName, (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, extTrace[0, $07716e087fcf5bbc$export$9734b0a24bf02e93 /* @min:%2ename */ ]));
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).operationId, extTrace[0, $07716e087fcf5bbc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ]);
    }
    // Sample 4.0 schema
    //  {
    //     "time" : "2018-09-05T22:51:22.4936Z",
    //     "name" : "MetricWithNamespace",
    //     "iKey" : "ABC-5a4cbd20-e601-4ef5-a3c6-5d6577e4398e",
    //     "ext": {  "cloud": {
    //          "role": "WATSON3",
    //          "roleInstance": "CO4AEAP00000260"
    //      },
    //      "device": {}, "correlation": {} },
    //      "tags": [
    //        { "amazon.region" : "east2" },
    //        { "os.expid" : "wp:02df239" }
    //     ]
    //   }
    var tgs = {};
    // deals with tags.push({object})
    for(var i = itmTags[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] - 1; i >= 0; i--){
        var tg = itmTags[i];
        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(tg, function(key, value) {
            tgs[key] = value;
        });
        itmTags.splice(i, 1);
    }
    // deals with tags[key]=value (and handles hasOwnProperty)
    (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(itmTags, function(tg, value) {
        tgs[tg] = value;
    });
    var theTags = (0, $dc463ff9724142dd$export$b3cf7a802e578501)((0, $dc463ff9724142dd$export$b3cf7a802e578501)({}, envTags), tgs);
    if (!theTags[(0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).internalSdkVersion]) // Append a version in case it is not already set
    theTags[(0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).internalSdkVersion] = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, "javascript:".concat($53141cdecfc05483$export$3f11c9a3e644970c.Version), 64);
    env[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] = (0, $ede407819d2d28c9$export$3e03fa3fc3e422d7)(theTags);
}
function $53141cdecfc05483$var$_extractPropsAndMeasurements(data, properties, measurements) {
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(data)) (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(data, function(key, value) {
        if ((0, $5831ddb3a0caf7c7$export$7e4aa119212bc614)(value)) measurements[key] = value;
        else if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(value)) properties[key] = value;
        else if ((0, $0d2c2fb24388dcf8$export$a2856ab6913b9fff)()) properties[key] = (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)()[0, $07716e087fcf5bbc$export$a318a8141fc98747 /* @min:%2estringify */ ](value);
    });
}
function $53141cdecfc05483$var$_convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue) {
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(properties)) (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(properties, function(key, value) {
        properties[key] = value || customUndefinedValue;
    });
}
// TODO: Do we want this to take logger as arg or use this._logger as nonstatic?
function $53141cdecfc05483$var$_createEnvelope(logger, envelopeType, telemetryItem, data) {
    var envelope = new (0, $9a1ea820994e6e6d$export$4e2d65a9843399df)(logger, data, envelopeType);
    $53141cdecfc05483$var$_setValueIf(envelope, "sampleRate", telemetryItem[0, $8ac3b4fe9182f568$export$dc288b6444e20c04]);
    if ((telemetryItem[$53141cdecfc05483$var$strBaseData] || {}).startTime) // Starting from Version 3.0.3, the time property will be assigned by the startTime value,
    // which records the loadEvent time for the pageView event.
    envelope.time = (0, $ede407819d2d28c9$export$dfaaa8705752128f)(telemetryItem[$53141cdecfc05483$var$strBaseData].startTime);
    envelope.iKey = telemetryItem.iKey;
    var iKeyNoDashes = telemetryItem.iKey.replace(/-/g, "");
    envelope[0, $07716e087fcf5bbc$export$9734b0a24bf02e93 /* @min:%2ename */ ] = envelope[0, $07716e087fcf5bbc$export$9734b0a24bf02e93 /* @min:%2ename */ ].replace("{0}", iKeyNoDashes);
    // extract all extensions from ctx
    $53141cdecfc05483$var$_extractPartAExtensions(logger, telemetryItem, envelope);
    // loop through the envelope tags (extension of Part A) and pick out the ones that should go in outgoing envelope tags
    telemetryItem[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] = telemetryItem[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] || [];
    return (0, $ede407819d2d28c9$export$3e03fa3fc3e422d7)(envelope);
}
function $53141cdecfc05483$var$EnvelopeCreatorInit(logger, telemetryItem) {
    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(telemetryItem[$53141cdecfc05483$var$strBaseData])) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 46 /* _eInternalMessageId.TelemetryEnvelopeInvalid */ , "telemetryItem.baseData cannot be null.");
}
var $53141cdecfc05483$export$3f11c9a3e644970c = {
    Version: "3.3.3"
};
function $53141cdecfc05483$export$74e603a08a7deabe(logger, telemetryItem, customUndefinedValue) {
    $53141cdecfc05483$var$EnvelopeCreatorInit(logger, telemetryItem);
    var customMeasurements = telemetryItem[$53141cdecfc05483$var$strBaseData][0, $07716e087fcf5bbc$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    var customProperties = telemetryItem[$53141cdecfc05483$var$strBaseData][$53141cdecfc05483$var$strProperties] || {};
    $53141cdecfc05483$var$_extractPropsAndMeasurements(telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ], customProperties, customMeasurements);
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customUndefinedValue)) $53141cdecfc05483$var$_convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    var bd = telemetryItem[$53141cdecfc05483$var$strBaseData];
    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(bd)) {
        (0, $bacca83328a730a7$export$25fb4cb97863f0a8)(logger, "Invalid input for dependency data");
        return null;
    }
    var method = bd[$53141cdecfc05483$var$strProperties] && bd[$53141cdecfc05483$var$strProperties][0, $8ac3b4fe9182f568$export$8343e6f32f5246de] ? bd[$53141cdecfc05483$var$strProperties][0, $8ac3b4fe9182f568$export$8343e6f32f5246de] : "GET";
    var remoteDepData = new (0, $97ca5e424f1910ef$export$a7b48490930dbffa)(logger, bd.id, bd.target, bd[0, $07716e087fcf5bbc$export$9734b0a24bf02e93 /* @min:%2ename */ ], bd[0, $7fa712059cae73d1$export$be41298b7716c698 /* @min:%2eduration */ ], bd.success, bd.responseCode, method, bd.type, bd.correlationContext, customProperties, customMeasurements);
    var data = new (0, $1b13bacff23d2e52$export$2d0294657ab35f1b)((0, $97ca5e424f1910ef$export$a7b48490930dbffa)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ], remoteDepData);
    return $53141cdecfc05483$var$_createEnvelope(logger, (0, $97ca5e424f1910ef$export$a7b48490930dbffa)[0, $07716e087fcf5bbc$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $53141cdecfc05483$export$b74153364c2066d1(logger, telemetryItem, customUndefinedValue) {
    $53141cdecfc05483$var$EnvelopeCreatorInit(logger, telemetryItem);
    var customProperties = {};
    var customMeasurements = {};
    if (telemetryItem[$53141cdecfc05483$var$strBaseType] !== (0, $62713924cc3cd966$export$d61e24a684f9e51)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ]) customProperties["baseTypeSource"] = telemetryItem[$53141cdecfc05483$var$strBaseType]; // save the passed in base type as a property
    if (telemetryItem[$53141cdecfc05483$var$strBaseType] === (0, $62713924cc3cd966$export$d61e24a684f9e51)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ]) {
        customProperties = telemetryItem[$53141cdecfc05483$var$strBaseData][$53141cdecfc05483$var$strProperties] || {};
        customMeasurements = telemetryItem[$53141cdecfc05483$var$strBaseData][0, $07716e087fcf5bbc$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    } else if (telemetryItem[$53141cdecfc05483$var$strBaseData]) $53141cdecfc05483$var$_extractPropsAndMeasurements(telemetryItem[$53141cdecfc05483$var$strBaseData], customProperties, customMeasurements);
    // Extract root level properties from part C telemetryItem.data
    $53141cdecfc05483$var$_extractPropsAndMeasurements(telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ], customProperties, customMeasurements);
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customUndefinedValue)) $53141cdecfc05483$var$_convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    var eventName = telemetryItem[$53141cdecfc05483$var$strBaseData][0, $07716e087fcf5bbc$export$9734b0a24bf02e93 /* @min:%2ename */ ];
    var eventData = new (0, $62713924cc3cd966$export$d61e24a684f9e51)(logger, eventName, customProperties, customMeasurements);
    var data = new (0, $1b13bacff23d2e52$export$2d0294657ab35f1b)((0, $62713924cc3cd966$export$d61e24a684f9e51)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ], eventData);
    return $53141cdecfc05483$var$_createEnvelope(logger, (0, $62713924cc3cd966$export$d61e24a684f9e51)[0, $07716e087fcf5bbc$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $53141cdecfc05483$export$eca78b65eeb356ed(logger, telemetryItem, customUndefinedValue) {
    $53141cdecfc05483$var$EnvelopeCreatorInit(logger, telemetryItem);
    // Extract root level properties from part C telemetryItem.data
    var customMeasurements = telemetryItem[$53141cdecfc05483$var$strBaseData][0, $07716e087fcf5bbc$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    var customProperties = telemetryItem[$53141cdecfc05483$var$strBaseData][$53141cdecfc05483$var$strProperties] || {};
    $53141cdecfc05483$var$_extractPropsAndMeasurements(telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ], customProperties, customMeasurements);
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customUndefinedValue)) $53141cdecfc05483$var$_convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    var bd = telemetryItem[$53141cdecfc05483$var$strBaseData];
    var exData = (0, $a35c931c4df783c8$export$e2f174de097e0bcd).CreateFromInterface(logger, bd, customProperties, customMeasurements);
    var data = new (0, $1b13bacff23d2e52$export$2d0294657ab35f1b)((0, $a35c931c4df783c8$export$e2f174de097e0bcd)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ], exData);
    return $53141cdecfc05483$var$_createEnvelope(logger, (0, $a35c931c4df783c8$export$e2f174de097e0bcd)[0, $07716e087fcf5bbc$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $53141cdecfc05483$export$bb5bee4039a2e495(logger, telemetryItem, customUndefinedValue) {
    $53141cdecfc05483$var$EnvelopeCreatorInit(logger, telemetryItem);
    var baseData = telemetryItem[$53141cdecfc05483$var$strBaseData];
    var props = baseData[$53141cdecfc05483$var$strProperties] || {};
    var measurements = baseData[0, $07716e087fcf5bbc$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    $53141cdecfc05483$var$_extractPropsAndMeasurements(telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ], props, measurements);
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customUndefinedValue)) $53141cdecfc05483$var$_convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    var baseMetricData = new (0, $5db807982a2eef93$export$efdd3e096bc27746)(logger, baseData[0, $07716e087fcf5bbc$export$9734b0a24bf02e93 /* @min:%2ename */ ], baseData.average, baseData.sampleCount, baseData.min, baseData.max, baseData.stdDev, props, measurements);
    var data = new (0, $1b13bacff23d2e52$export$2d0294657ab35f1b)((0, $5db807982a2eef93$export$efdd3e096bc27746)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ], baseMetricData);
    return $53141cdecfc05483$var$_createEnvelope(logger, (0, $5db807982a2eef93$export$efdd3e096bc27746)[0, $07716e087fcf5bbc$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $53141cdecfc05483$export$edbb8a2c6529947a(logger, telemetryItem, customUndefinedValue) {
    $53141cdecfc05483$var$EnvelopeCreatorInit(logger, telemetryItem);
    // Since duration is not part of the domain properties in Common Schema, extract it from part C
    var duration;
    var baseData = telemetryItem[$53141cdecfc05483$var$strBaseData];
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(baseData) && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(baseData[$53141cdecfc05483$var$strProperties]) && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(baseData[$53141cdecfc05483$var$strProperties][0, $7fa712059cae73d1$export$be41298b7716c698])) {
        duration = baseData[$53141cdecfc05483$var$strProperties][0, $7fa712059cae73d1$export$be41298b7716c698];
        delete baseData[$53141cdecfc05483$var$strProperties][0, $7fa712059cae73d1$export$be41298b7716c698];
    } else if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ]) && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ][0, $7fa712059cae73d1$export$be41298b7716c698])) {
        duration = telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ][0, $7fa712059cae73d1$export$be41298b7716c698];
        delete telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ][0, $7fa712059cae73d1$export$be41298b7716c698];
    }
    var bd = telemetryItem[$53141cdecfc05483$var$strBaseData];
    // special case: pageview.id is grabbed from current operation id. Analytics plugin is decoupled from properties plugin, so this is done here instead. This can be made a default telemetry intializer instead if needed to be decoupled from channel
    var currentContextId;
    if (((telemetryItem.ext || {}).trace || {})[0, $07716e087fcf5bbc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ]) currentContextId = telemetryItem.ext.trace[0, $07716e087fcf5bbc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ];
    var id = bd.id || currentContextId;
    var name = bd[0, $07716e087fcf5bbc$export$9734b0a24bf02e93 /* @min:%2ename */ ];
    var url = bd.uri;
    var properties = bd[$53141cdecfc05483$var$strProperties] || {};
    var measurements = bd[0, $07716e087fcf5bbc$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    // refUri is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(bd.refUri)) properties["refUri"] = bd.refUri;
    // pageType is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(bd.pageType)) properties["pageType"] = bd.pageType;
    // isLoggedIn is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(bd.isLoggedIn)) properties["isLoggedIn"] = bd.isLoggedIn[0, $07716e087fcf5bbc$export$e2818d11505fa034 /* @min:%2etoString */ ]();
    // pageTags is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(bd[$53141cdecfc05483$var$strProperties])) {
        var pageTags = bd[$53141cdecfc05483$var$strProperties];
        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(pageTags, function(key, value) {
            properties[key] = value;
        });
    }
    $53141cdecfc05483$var$_extractPropsAndMeasurements(telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ], properties, measurements);
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customUndefinedValue)) $53141cdecfc05483$var$_convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    var pageViewData = new (0, $3e77672805d15946$export$12c0fdede1c6bc6c)(logger, name, url, duration, properties, measurements, id);
    var data = new (0, $1b13bacff23d2e52$export$2d0294657ab35f1b)((0, $3e77672805d15946$export$12c0fdede1c6bc6c)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ], pageViewData);
    return $53141cdecfc05483$var$_createEnvelope(logger, (0, $3e77672805d15946$export$12c0fdede1c6bc6c)[0, $07716e087fcf5bbc$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $53141cdecfc05483$export$bb801863268e7049(logger, telemetryItem, customUndefinedValue) {
    $53141cdecfc05483$var$EnvelopeCreatorInit(logger, telemetryItem);
    var bd = telemetryItem[$53141cdecfc05483$var$strBaseData];
    var name = bd[0, $07716e087fcf5bbc$export$9734b0a24bf02e93 /* @min:%2ename */ ];
    var url = bd.uri || bd.url;
    var properties = bd[$53141cdecfc05483$var$strProperties] || {};
    var measurements = bd[0, $07716e087fcf5bbc$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    $53141cdecfc05483$var$_extractPropsAndMeasurements(telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ], properties, measurements);
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customUndefinedValue)) $53141cdecfc05483$var$_convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    var baseData = new (0, $03ee94b6fff0696e$export$709aae57ec681346)(logger, name, url, undefined, properties, measurements, bd);
    var data = new (0, $1b13bacff23d2e52$export$2d0294657ab35f1b)((0, $03ee94b6fff0696e$export$709aae57ec681346)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ], baseData);
    return $53141cdecfc05483$var$_createEnvelope(logger, (0, $03ee94b6fff0696e$export$709aae57ec681346)[0, $07716e087fcf5bbc$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $53141cdecfc05483$export$bc9e843f2eb8a61c(logger, telemetryItem, customUndefinedValue) {
    $53141cdecfc05483$var$EnvelopeCreatorInit(logger, telemetryItem);
    var message = telemetryItem[$53141cdecfc05483$var$strBaseData].message;
    var severityLevel = telemetryItem[$53141cdecfc05483$var$strBaseData].severityLevel;
    var props = telemetryItem[$53141cdecfc05483$var$strBaseData][$53141cdecfc05483$var$strProperties] || {};
    var measurements = telemetryItem[$53141cdecfc05483$var$strBaseData][0, $07716e087fcf5bbc$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    $53141cdecfc05483$var$_extractPropsAndMeasurements(telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ], props, measurements);
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customUndefinedValue)) $53141cdecfc05483$var$_convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    var baseData = new (0, $adb0678ebd5d1780$export$78e1bea9036f120f)(logger, message, severityLevel, props, measurements);
    var data = new (0, $1b13bacff23d2e52$export$2d0294657ab35f1b)((0, $adb0678ebd5d1780$export$78e1bea9036f120f)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ], baseData);
    return $53141cdecfc05483$var$_createEnvelope(logger, (0, $adb0678ebd5d1780$export$78e1bea9036f120f)[0, $07716e087fcf5bbc$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}


/*
 * Application Insights JavaScript SDK - Channel, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




var $1fa48c075af358bb$var$BaseSendBuffer = /** @class */ function() {
    function BaseSendBuffer(logger, config) {
        var _buffer = [];
        var _bufferFullMessageSent = false;
        var _maxRetryCnt = config.maxRetryCnt;
        this[0, $07716e087fcf5bbc$export$7768b9624b4c70a6 /* @min:%2e_get */ ] = function() {
            return _buffer;
        };
        this._set = function(buffer) {
            _buffer = buffer;
            return _buffer;
        };
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(BaseSendBuffer, this, function(_self) {
            _self[0, $07716e087fcf5bbc$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ] = function(payload) {
                if (_self[0, $07716e087fcf5bbc$export$e9679ef501b0d1 /* @min:%2ecount */ ]() >= config[0, $07716e087fcf5bbc$export$c8dd872dc774fa7c /* @min:%2eeventsLimitInMem */ ]) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 105 /* _eInternalMessageId.InMemoryStorageBufferFull */ , "Maximum in-memory buffer size reached: " + _self[0, $07716e087fcf5bbc$export$e9679ef501b0d1 /* @min:%2ecount */ ](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                payload.cnt = payload.cnt || 0;
                // max retry is defined, and max retry is reached, do not add the payload to buffer
                if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_maxRetryCnt)) {
                    if (payload.cnt > _maxRetryCnt) // TODO: add log here on dropping payloads
                    return;
                }
                _buffer[0, $07716e087fcf5bbc$export$a0a330e7fa1e278c /* @min:%2epush */ ](payload);
                return;
            };
            _self[0, $07716e087fcf5bbc$export$e9679ef501b0d1 /* @min:%2ecount */ ] = function() {
                return _buffer[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ];
            };
            _self.size = function() {
                var size = _buffer[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ];
                for(var lp = 0; lp < _buffer[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++)size += _buffer[lp].item[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ];
                if (!config[0, $07716e087fcf5bbc$export$b18aabdfc0aaf6b /* @min:%2eemitLineDelimitedJson */ ]) size += 2;
                return size;
            };
            _self[0, $07716e087fcf5bbc$export$5eeb73fac03da74a /* @min:%2eclear */ ] = function() {
                _buffer = [];
                _bufferFullMessageSent = false;
            };
            _self.getItems = function() {
                return _buffer.slice(0);
            };
            _self.batchPayloads = function(payloads) {
                if (payloads && payloads[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    var payloadStr_1 = [];
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(payloads, function(payload) {
                        payloadStr_1[0, $07716e087fcf5bbc$export$a0a330e7fa1e278c /* @min:%2epush */ ](payload[0, $07716e087fcf5bbc$export$7a8bb3cc4a906992 /* @min:%2eitem */ ]);
                    });
                    var batch = config[0, $07716e087fcf5bbc$export$b18aabdfc0aaf6b /* @min:%2eemitLineDelimitedJson */ ] ? payloadStr_1.join("\n") : "[" + payloadStr_1.join(",") + "]";
                    return batch;
                }
                return null;
            };
            _self[0, $07716e087fcf5bbc$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ] = function(newLogger, newConfig, canUseSessionStorage) {
                var items = _buffer.slice(0);
                newLogger = newLogger || logger;
                newConfig = newConfig || {};
                var newBuffer = !!canUseSessionStorage ? new $1fa48c075af358bb$export$dcb776947c16915f(newLogger, newConfig) : new $1fa48c075af358bb$export$d706e5fd60d36d56(newLogger, newConfig);
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(items, function(payload) {
                    newBuffer[0, $07716e087fcf5bbc$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ](payload);
                });
                return newBuffer;
            };
        });
    }
    // Removed Stub for BaseSendBuffer.prototype.enqueue.
    // Removed Stub for BaseSendBuffer.prototype.count.
    // Removed Stub for BaseSendBuffer.prototype.size.
    // Removed Stub for BaseSendBuffer.prototype.clear.
    // Removed Stub for BaseSendBuffer.prototype.getItems.
    // Removed Stub for BaseSendBuffer.prototype.batchPayloads.
    // Removed Stub for BaseSendBuffer.prototype.createNew.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    BaseSendBuffer.__ieDyn = 1;
    return BaseSendBuffer;
}();
/*
 * An array based send buffer.
 */ var $1fa48c075af358bb$export$d706e5fd60d36d56 = /** @class */ function(_super) {
    (0, $dc463ff9724142dd$export$1f9c32e3fbfb8e62)(ArraySendBuffer, _super);
    function ArraySendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(ArraySendBuffer, _this, function(_self, _base) {
            _self[0, $07716e087fcf5bbc$export$52e50651d87300e3 /* @min:%2emarkAsSent */ ] = function(payload) {
                _base[0, $07716e087fcf5bbc$export$5eeb73fac03da74a /* @min:%2eclear */ ]();
            };
            _self[0, $07716e087fcf5bbc$export$13da1b5a005ef035 /* @min:%2eclearSent */ ] = function(payload) {
            // not supported
            };
        });
        return _this;
    }
    // Removed Stub for ArraySendBuffer.prototype.markAsSent.
    // Removed Stub for ArraySendBuffer.prototype.clearSent.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    ArraySendBuffer.__ieDyn = 1;
    return ArraySendBuffer;
}($1fa48c075af358bb$var$BaseSendBuffer);
var $1fa48c075af358bb$var$PREVIOUS_KEYS = [
    "AI_buffer",
    "AI_sentBuffer"
];
/*
 * Session storage buffer holds a copy of all unsent items in the browser session storage.
 */ var $1fa48c075af358bb$export$dcb776947c16915f = /** @class */ function(_super) {
    (0, $dc463ff9724142dd$export$1f9c32e3fbfb8e62)(SessionStorageSendBuffer, _super);
    function SessionStorageSendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        var _bufferFullMessageSent = false;
        //Note: should not use config.namePrefix directly, because it will always refers to the latest namePrefix
        var _namePrefix = config === null || config === void 0 ? void 0 : config.namePrefix;
        // TODO: add remove buffer override as well
        var _b = config[0, $07716e087fcf5bbc$export$4637bcb72c509e60 /* @min:%2ebufferOverride */ ] || {
            getItem: (0, $3fab9bbcce274f86$export$a398bd2f40e2eb6e),
            setItem: (0, $3fab9bbcce274f86$export$21abea3a85fee3f5)
        }, getItem = _b.getItem, setItem = _b.setItem;
        var _maxRetryCnt = config.maxRetryCnt;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(SessionStorageSendBuffer, _this, function(_self, _base) {
            var bufferItems = _getBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$63ab2dad6d8a60ed /* @min:%2eBUFFER_KEY */ ]);
            var itemsInSentBuffer = _getBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ]);
            var previousItems = _getPreviousEvents();
            var notDeliveredItems = itemsInSentBuffer[0, $07716e087fcf5bbc$export$706142eb912dc2a /* @min:%2econcat */ ](previousItems);
            var buffer = _self._set(bufferItems[0, $07716e087fcf5bbc$export$706142eb912dc2a /* @min:%2econcat */ ](notDeliveredItems));
            // If the buffer has too many items, drop items from the end.
            if (buffer[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] > SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$20d3a25105cda3b1 /* @min:%2eMAX_BUFFER_SIZE */ ]) buffer[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] = SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$20d3a25105cda3b1 /* @min:%2eMAX_BUFFER_SIZE */ ];
            _setBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ], []);
            _setBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$63ab2dad6d8a60ed /* @min:%2eBUFFER_KEY */ ], buffer);
            _self[0, $07716e087fcf5bbc$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ] = function(payload) {
                if (_self[0, $07716e087fcf5bbc$export$e9679ef501b0d1 /* @min:%2ecount */ ]() >= SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$20d3a25105cda3b1 /* @min:%2eMAX_BUFFER_SIZE */ ]) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 67 /* _eInternalMessageId.SessionStorageBufferFull */ , "Maximum buffer size reached: " + _self[0, $07716e087fcf5bbc$export$e9679ef501b0d1 /* @min:%2ecount */ ](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                payload.cnt = payload.cnt || 0;
                // max retry is defined, and max retry is reached, do not add the payload to buffer
                if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_maxRetryCnt)) {
                    if (payload.cnt > _maxRetryCnt) // TODO: add log here on dropping payloads
                    return;
                }
                _base[0, $07716e087fcf5bbc$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ](payload);
                _setBuffer(SessionStorageSendBuffer.BUFFER_KEY, _self[0, $07716e087fcf5bbc$export$7768b9624b4c70a6 /* @min:%2e_get */ ]());
            };
            _self[0, $07716e087fcf5bbc$export$5eeb73fac03da74a /* @min:%2eclear */ ] = function() {
                _base[0, $07716e087fcf5bbc$export$5eeb73fac03da74a /* @min:%2eclear */ ]();
                _setBuffer(SessionStorageSendBuffer.BUFFER_KEY, _self[0, $07716e087fcf5bbc$export$7768b9624b4c70a6 /* @min:%2e_get */ ]());
                _setBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ], []);
                _bufferFullMessageSent = false;
            };
            _self[0, $07716e087fcf5bbc$export$52e50651d87300e3 /* @min:%2emarkAsSent */ ] = function(payload) {
                _setBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$63ab2dad6d8a60ed /* @min:%2eBUFFER_KEY */ ], _self._set(_removePayloadsFromBuffer(payload, _self[0, $07716e087fcf5bbc$export$7768b9624b4c70a6 /* @min:%2e_get */ ]())));
                var sentElements = _getBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ]);
                if (sentElements instanceof Array && payload instanceof Array) {
                    sentElements = sentElements[0, $07716e087fcf5bbc$export$706142eb912dc2a /* @min:%2econcat */ ](payload);
                    if (sentElements[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] > SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$20d3a25105cda3b1 /* @min:%2eMAX_BUFFER_SIZE */ ]) {
                        // We send telemetry normally. If the SENT_BUFFER is too big we don't add new elements
                        // until we receive a response from the backend and the buffer has free space again (see clearSent method)
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 67 /* _eInternalMessageId.SessionStorageBufferFull */ , "Sent buffer reached its maximum size: " + sentElements[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ], true);
                        sentElements[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] = SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$20d3a25105cda3b1 /* @min:%2eMAX_BUFFER_SIZE */ ];
                    }
                    _setBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ], sentElements);
                }
            };
            _self[0, $07716e087fcf5bbc$export$13da1b5a005ef035 /* @min:%2eclearSent */ ] = function(payload) {
                var sentElements = _getBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ]);
                sentElements = _removePayloadsFromBuffer(payload, sentElements);
                _setBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ], sentElements);
            };
            _self[0, $07716e087fcf5bbc$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ] = function(newLogger, newConfig, canUseSessionStorage) {
                canUseSessionStorage = !!canUseSessionStorage;
                var unsentItems = _self[0, $07716e087fcf5bbc$export$7768b9624b4c70a6 /* @min:%2e_get */ ]().slice(0);
                var sentItems = _getBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ]).slice(0);
                newLogger = newLogger || logger;
                newConfig = newConfig || {};
                // to make sure that we do not send duplicated payloads when it is switched back to previous one
                _self[0, $07716e087fcf5bbc$export$5eeb73fac03da74a /* @min:%2eclear */ ]();
                var newBuffer = canUseSessionStorage ? new SessionStorageSendBuffer(newLogger, newConfig) : new $1fa48c075af358bb$export$d706e5fd60d36d56(newLogger, newConfig);
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(unsentItems, function(payload) {
                    newBuffer[0, $07716e087fcf5bbc$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ](payload);
                });
                if (canUseSessionStorage) // arr buffer will clear all payloads if markAsSent() is called
                newBuffer[0, $07716e087fcf5bbc$export$52e50651d87300e3 /* @min:%2emarkAsSent */ ](sentItems);
                return newBuffer;
            };
            function _removePayloadsFromBuffer(payloads, buffer) {
                var remaining = [];
                var payloadStr = [];
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(payloads, function(payload) {
                    payloadStr[0, $07716e087fcf5bbc$export$a0a330e7fa1e278c /* @min:%2epush */ ](payload[0, $07716e087fcf5bbc$export$7a8bb3cc4a906992 /* @min:%2eitem */ ]);
                });
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(buffer, function(value) {
                    if (!(0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(value) && (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(payloadStr, value[0, $07716e087fcf5bbc$export$7a8bb3cc4a906992 /* @min:%2eitem */ ]) === -1) remaining[0, $07716e087fcf5bbc$export$a0a330e7fa1e278c /* @min:%2epush */ ](value);
                });
                return remaining;
            }
            function _getBuffer(key) {
                var prefixedKey = key;
                prefixedKey = _namePrefix ? _namePrefix + "_" + prefixedKey : prefixedKey;
                return _getBufferBase(prefixedKey);
            }
            function _getBufferBase(key) {
                try {
                    var bufferJson = getItem(logger, key);
                    if (bufferJson) {
                        var buffer_1 = (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)().parse(bufferJson);
                        if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(buffer_1)) // When using some version prototype.js the stringify / parse cycle does not decode array's correctly
                        buffer_1 = (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)().parse(buffer_1);
                        if (buffer_1 && (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(buffer_1)) return buffer_1;
                    }
                } catch (e) {
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 42 /* _eInternalMessageId.FailedToRestoreStorageBuffer */ , " storage key: " + key + ", " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
                return [];
            }
            function _setBuffer(key, buffer) {
                var prefixedKey = key;
                try {
                    prefixedKey = _namePrefix ? _namePrefix + "_" + prefixedKey : prefixedKey;
                    var bufferJson = JSON[0, $07716e087fcf5bbc$export$a318a8141fc98747 /* @min:%2estringify */ ](buffer);
                    setItem(logger, prefixedKey, bufferJson);
                } catch (e) {
                    // if there was an error, clear the buffer
                    // telemetry is stored in the _buffer array so we won't loose any items
                    setItem(logger, prefixedKey, JSON[0, $07716e087fcf5bbc$export$a318a8141fc98747 /* @min:%2estringify */ ]([]));
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 41 /* _eInternalMessageId.FailedToSetStorageBuffer */ , " storage key: " + prefixedKey + ", " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e) + ". Buffer cleared", {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            }
            // this removes buffer with prefix+key
            function _getPreviousEvents() {
                var items = [];
                try {
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)($1fa48c075af358bb$var$PREVIOUS_KEYS, function(key) {
                        var events = _getItemsFromPreviousKey(key);
                        items = items[0, $07716e087fcf5bbc$export$706142eb912dc2a /* @min:%2econcat */ ](events);
                        // to make sure that we also transfer items from old prefixed + key buffer
                        if (_namePrefix) {
                            var prefixedKey = _namePrefix + "_" + key;
                            var prefixEvents = _getItemsFromPreviousKey(prefixedKey);
                            items = items[0, $07716e087fcf5bbc$export$706142eb912dc2a /* @min:%2econcat */ ](prefixEvents);
                        }
                    });
                    return items;
                } catch (e) {
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 41 /* _eInternalMessageId.FailedToSetStorageBuffer */ , "Transfer events from previous buffers: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e) + ". previous Buffer items can not be removed", {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
                return [];
            }
            // transform string[] to IInternalStorageItem[]
            function _getItemsFromPreviousKey(key) {
                try {
                    var items = _getBufferBase(key);
                    var transFormedItems_1 = [];
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(items, function(item) {
                        var internalItem = {
                            item: item,
                            cnt: 0 // previous events will be default to 0 count
                        };
                        transFormedItems_1[0, $07716e087fcf5bbc$export$a0a330e7fa1e278c /* @min:%2epush */ ](internalItem);
                    });
                    // remove the session storage if we can add events back
                    (0, $3fab9bbcce274f86$export$9f411b4ea05fb92a)(logger, key);
                    return transFormedItems_1;
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return [];
            }
        });
        return _this;
    }
    // Removed Stub for SessionStorageSendBuffer.prototype.enqueue.
    // Removed Stub for SessionStorageSendBuffer.prototype.clear.
    // Removed Stub for SessionStorageSendBuffer.prototype.markAsSent.
    // Removed Stub for SessionStorageSendBuffer.prototype.clearSent.
    // Removed Stub for SessionStorageSendBuffer.prototype.createNew.
    var _a;
    _a = SessionStorageSendBuffer;
    SessionStorageSendBuffer.VERSION = "_1";
    SessionStorageSendBuffer.BUFFER_KEY = "AI_buffer" + _a.VERSION;
    SessionStorageSendBuffer.SENT_BUFFER_KEY = "AI_sentBuffer" + _a.VERSION;
    // Maximum number of payloads stored in the buffer. If the buffer is full, new elements will be dropped.
    SessionStorageSendBuffer.MAX_BUFFER_SIZE = 2000;
    return SessionStorageSendBuffer;
}($1fa48c075af358bb$var$BaseSendBuffer);


/*
 * Application Insights JavaScript SDK - Channel, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $ffeedac495e2c7a7$export$ef852775387a0be7 = /** @class */ function() {
    function Serializer(logger) {
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(Serializer, this, function(_self) {
            /**
             * Serializes the current object to a JSON string.
             */ _self[0, $07716e087fcf5bbc$export$3726a43a9362600c /* @min:%2eserialize */ ] = function(input) {
                var output = _serializeObject(input, "root");
                try {
                    return (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)()[0, $07716e087fcf5bbc$export$a318a8141fc98747 /* @min:%2estringify */ ](output);
                } catch (e) {
                    // if serialization fails return an empty string
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 48 /* _eInternalMessageId.CannotSerializeObject */ , e && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(e[0, $07716e087fcf5bbc$export$e2818d11505fa034 /* @min:%2etoString */ ]) ? e[0, $07716e087fcf5bbc$export$e2818d11505fa034 /* @min:%2etoString */ ]() : "Error serializing object", null, true);
                }
            };
            function _serializeObject(source, name) {
                var circularReferenceCheck = "__aiCircularRefCheck";
                var output = {};
                if (!source) {
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 48 /* _eInternalMessageId.CannotSerializeObject */ , "cannot serialize object because it is null or undefined", {
                        name: name
                    }, true);
                    return output;
                }
                if (source[circularReferenceCheck]) {
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 50 /* _eInternalMessageId.CircularReferenceDetected */ , "Circular reference detected while serializing object", {
                        name: name
                    }, true);
                    return output;
                }
                if (!source.aiDataContract) {
                    // special case for measurements/properties/tags
                    if (name === "measurements") output = _serializeStringMap(source, "number", name);
                    else if (name === "properties") output = _serializeStringMap(source, "string", name);
                    else if (name === "tags") output = _serializeStringMap(source, "string", name);
                    else if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(source)) output = _serializeArray(source, name);
                    else {
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */ , "Attempting to serialize an object which does not implement ISerializable", {
                            name: name
                        }, true);
                        try {
                            // verify that the object can be stringified
                            (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)()[0, $07716e087fcf5bbc$export$a318a8141fc98747 /* @min:%2estringify */ ](source);
                            output = source;
                        } catch (e) {
                            // if serialization fails return an empty string
                            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 48 /* _eInternalMessageId.CannotSerializeObject */ , e && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(e[0, $07716e087fcf5bbc$export$e2818d11505fa034 /* @min:%2etoString */ ]) ? e[0, $07716e087fcf5bbc$export$e2818d11505fa034 /* @min:%2etoString */ ]() : "Error serializing object", null, true);
                        }
                    }
                    return output;
                }
                source[circularReferenceCheck] = true;
                (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(source.aiDataContract, function(field, contract) {
                    var isRequired = (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(contract) ? contract() & 1 /* FieldType.Required */  : contract & 1 /* FieldType.Required */ ;
                    var isHidden = (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(contract) ? contract() & 4 /* FieldType.Hidden */  : contract & 4 /* FieldType.Hidden */ ;
                    var isArray = contract & 2 /* FieldType.Array */ ;
                    var isPresent = source[field] !== undefined;
                    var isObj = (0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(source[field]) && source[field] !== null;
                    if (isRequired && !isPresent && !isArray) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 24 /* _eInternalMessageId.MissingRequiredFieldSpecification */ , "Missing required field specification. The field is required but not present on source", {
                        field: field,
                        name: name
                    });
                    else if (!isHidden) {
                        var value = void 0;
                        if (isObj) {
                            if (isArray) // special case; recurse on each object in the source array
                            value = _serializeArray(source[field], field);
                            else // recurse on the source object in this field
                            value = _serializeObject(source[field], field);
                        } else // assign the source field to the output even if undefined or required
                        value = source[field];
                        // only emit this field if the value is defined
                        if (value !== undefined) output[field] = value;
                    }
                });
                delete source[circularReferenceCheck];
                return output;
            }
            function _serializeArray(sources, name) {
                var output;
                if (!!sources) {
                    if (!(0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(sources)) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 54 /* _eInternalMessageId.ItemNotInArray */ , "This field was specified as an array in the contract but the item is not an array.\r\n", {
                        name: name
                    }, true);
                    else {
                        output = [];
                        for(var i = 0; i < sources[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
                            var source = sources[i];
                            var item = _serializeObject(source, name + "[" + i + "]");
                            output[0, $07716e087fcf5bbc$export$a0a330e7fa1e278c /* @min:%2epush */ ](item);
                        }
                    }
                }
                return output;
            }
            function _serializeStringMap(map, expectedType, name) {
                var output;
                if (map) {
                    output = {};
                    (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(map, function(field, value) {
                        if (expectedType === "string") {
                            if (value === undefined) output[field] = "undefined";
                            else if (value === null) output[field] = "null";
                            else if (!value[0, $07716e087fcf5bbc$export$e2818d11505fa034 /* @min:%2etoString */ ]) output[field] = "invalid field: toString() is not defined.";
                            else output[field] = value[0, $07716e087fcf5bbc$export$e2818d11505fa034 /* @min:%2etoString */ ]();
                        } else if (expectedType === "number") {
                            if (value === undefined) output[field] = "undefined";
                            else if (value === null) output[field] = "null";
                            else {
                                var num = parseFloat(value);
                                output[field] = num;
                            }
                        } else {
                            output[field] = "invalid field: " + name + " is of unknown type.";
                            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , output[field], null, true);
                        }
                    });
                }
                return output;
            }
        });
    }
    // Removed Stub for Serializer.prototype.serialize.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    Serializer.__ieDyn = 1;
    return Serializer;
}();


/*
 * Application Insights JavaScript SDK - Channel, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Channel, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

/*
 * Application Insights JavaScript SDK - Channel, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
// (Magic number) DJB algorithm can't work on shorter strings (results in poor distribution
var $861a98abcb781c4a$var$MIN_INPUT_LENGTH = 8;
var $861a98abcb781c4a$export$e2bdf7ff70742e42 = /** @class */ function() {
    function HashCodeScoreGenerator() {}
    HashCodeScoreGenerator.prototype.getHashCodeScore = function(key) {
        var score = this.getHashCode(key) / HashCodeScoreGenerator.INT_MAX_VALUE;
        return score * 100;
    };
    HashCodeScoreGenerator.prototype.getHashCode = function(input) {
        if (input === "") return 0;
        while(input[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] < $861a98abcb781c4a$var$MIN_INPUT_LENGTH)input = input[0, $07716e087fcf5bbc$export$706142eb912dc2a /* @min:%2econcat */ ](input);
        // 5381 is a magic number: http://stackoverflow.com/questions/10696223/reason-for-5381-number-in-djb-hash-function
        var hash = 5381;
        for(var i = 0; i < input[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]; ++i){
            hash = (hash << 5) + hash + input.charCodeAt(i);
            // 'hash' is of number type which means 53 bit integer (http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types-number-type)
            // 'hash & hash' will keep it 32 bit integer - just to make it clearer what the result is.
            hash = hash & hash;
        }
        return Math.abs(hash);
    };
    // We're using 32 bit math, hence max value is (2^31 - 1)
    HashCodeScoreGenerator.INT_MAX_VALUE = 2147483647;
    return HashCodeScoreGenerator;
}();


var $ef3ed600da8dd282$export$4526db980ad5b8a1 = /** @class */ function() {
    function SamplingScoreGenerator() {
        var _self = this;
        var hashCodeGenerator = new (0, $861a98abcb781c4a$export$e2bdf7ff70742e42)();
        var keys = new (0, $24e80801a3d6c8ab$export$8e2bcdf18620784a)();
        _self[0, $07716e087fcf5bbc$export$2c3af30a5c45aa6e /* @min:%2egetSamplingScore */ ] = function(item) {
            var score = 0;
            if (item[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] && item[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ][keys.userId]) score = hashCodeGenerator.getHashCodeScore(item[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ][keys.userId]);
            else if (item.ext && item.ext.user && item.ext.user.id) score = hashCodeGenerator[0, $07716e087fcf5bbc$export$d676f8c50f371355 /* @min:%2egetHashCodeScore */ ](item.ext.user.id);
            else if (item[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] && item[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ][keys.operationId]) score = hashCodeGenerator.getHashCodeScore(item[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ][keys.operationId]);
            else if (item.ext && item.ext.telemetryTrace && item.ext.telemetryTrace[0, $07716e087fcf5bbc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ]) score = hashCodeGenerator.getHashCodeScore(item.ext.telemetryTrace[0, $07716e087fcf5bbc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ]);
            else // tslint:disable-next-line:insecure-random
            score = Math.random() * 100;
            return score;
        };
    }
    return SamplingScoreGenerator;
}();


var $be1c115b9b440698$export$21a3eccb8a1780eb = /** @class */ function() {
    function Sample(sampleRate, logger) {
        // We're using 32 bit math, hence max value is (2^31 - 1)
        this.INT_MAX_VALUE = 2147483647;
        var _logger = logger || (0, $bacca83328a730a7$export$5102d32ea1d740a)(null);
        if (sampleRate > 100 || sampleRate < 0) {
            _logger.throwInternal(2 /* eLoggingSeverity.WARNING */ , 58 /* _eInternalMessageId.SampleRateOutOfRange */ , "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", {
                samplingRate: sampleRate
            }, true);
            sampleRate = 100;
        }
        this[0, $07716e087fcf5bbc$export$c2afe23fa18f9dff /* @min:%2esampleRate */ ] = sampleRate;
        this.samplingScoreGenerator = new (0, $ef3ed600da8dd282$export$4526db980ad5b8a1)();
    }
    /**
    * Determines if an envelope is sampled in (i.e. will be sent) or not (i.e. will be dropped).
    */ Sample.prototype.isSampledIn = function(envelope) {
        var samplingPercentage = this[0, $07716e087fcf5bbc$export$c2afe23fa18f9dff /* @min:%2esampleRate */ ]; // 0 - 100
        var isSampledIn = false;
        if (samplingPercentage === null || samplingPercentage === undefined || samplingPercentage >= 100) return true;
        else if (envelope.baseType === (0, $5db807982a2eef93$export$efdd3e096bc27746)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ]) // exclude MetricData telemetry from sampling
        return true;
        isSampledIn = this.samplingScoreGenerator[0, $07716e087fcf5bbc$export$2c3af30a5c45aa6e /* @min:%2egetSamplingScore */ ](envelope) < samplingPercentage;
        return isSampledIn;
    };
    return Sample;
}();



var $7f068950e30577d3$var$_a, $7f068950e30577d3$var$_b;
var $7f068950e30577d3$var$UNDEFINED_VALUE = undefined;
var $7f068950e30577d3$var$EMPTY_STR = "";
var $7f068950e30577d3$var$FetchSyncRequestSizeLimitBytes = 65000; // approx 64kb (the current Edge, Firefox and Chrome max limit)
function $7f068950e30577d3$var$_getResponseText(xhr) {
    try {
        return xhr.responseText;
    } catch (e) {
    // Best effort, as XHR may throw while XDR wont so just ignore
    }
    return null;
}
function $7f068950e30577d3$var$isOverrideFn(httpXHROverride) {
    return httpXHROverride && httpXHROverride.sendPOST;
}
var $7f068950e30577d3$var$defaultAppInsightsChannelConfig = (0, $5831ddb3a0caf7c7$export$a15782d21797da4c)(($7f068950e30577d3$var$_a = {
    // Use the default value (handles empty string in the configuration)
    endpointUrl: (0, $3b63eef6ee7529a9$export$d0884590a6a82e6c)((0, $5831ddb3a0caf7c7$export$8f9cae6546f97a9f), (0, $8ac3b4fe9182f568$export$5c9ec0fce655ebcf) + (0, $8ac3b4fe9182f568$export$e6c0f3431c6cd728))
}, $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$b18aabdfc0aaf6b /* @min:emitLineDelimitedJson */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$983774f06380e463 /* @min:maxBatchInterval */ ] = 15000, $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$803d432e48ba5ceb /* @min:maxBatchSizeInBytes */ ] = 102400, $7f068950e30577d3$var$_a.disableTelemetry = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$c9210d86ca1dd637 /* @min:enableSessionStorageBuffer */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(true), $7f068950e30577d3$var$_a.isRetryDisabled = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$f5629284a6f7ec3d /* @min:isBeaconApiDisabled */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(true), $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$78c7449d94867b7f /* @min:disableSendBeaconSplit */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(true), $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$85f018eb7798fb52 /* @min:disableXhr */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$fa88a131053c3501 /* @min:onunloadDisableFetch */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$6b8e1dc9b77f253c /* @min:onunloadDisableBeacon */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$81cfd43387c8dbcc /* @min:instrumentationKey */ ] = $7f068950e30577d3$var$UNDEFINED_VALUE, $7f068950e30577d3$var$_a.namePrefix = $7f068950e30577d3$var$UNDEFINED_VALUE, $7f068950e30577d3$var$_a.samplingPercentage = (0, $3b63eef6ee7529a9$export$d0884590a6a82e6c)($7f068950e30577d3$var$_chkSampling, 100), $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$dbe59923e879fdc5 /* @min:customHeaders */ ] = $7f068950e30577d3$var$UNDEFINED_VALUE, $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$12df46deb7379c67 /* @min:convertUndefined */ ] = $7f068950e30577d3$var$UNDEFINED_VALUE, $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$c8dd872dc774fa7c /* @min:eventsLimitInMem */ ] = 10000, $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$4637bcb72c509e60 /* @min:bufferOverride */ ] = false, $7f068950e30577d3$var$_a.httpXHROverride = {
    isVal: $7f068950e30577d3$var$isOverrideFn,
    v: $7f068950e30577d3$var$UNDEFINED_VALUE
}, $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$87044a2824fddfb0 /* @min:alwaysUseXhrOverride */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $7f068950e30577d3$var$_a.transports = $7f068950e30577d3$var$UNDEFINED_VALUE, $7f068950e30577d3$var$_a.retryCodes = $7f068950e30577d3$var$UNDEFINED_VALUE, $7f068950e30577d3$var$_a.maxRetryCnt = {
    isVal: (0, $5831ddb3a0caf7c7$export$7e4aa119212bc614),
    v: 10
}, $7f068950e30577d3$var$_a));
function $7f068950e30577d3$var$_chkSampling(value) {
    return !isNaN(value) && value > 0 && value <= 100;
}
var $7f068950e30577d3$var$EnvelopeTypeCreator = ($7f068950e30577d3$var$_b = {}, $7f068950e30577d3$var$_b[(0, $62713924cc3cd966$export$d61e24a684f9e51).dataType] = (0, $53141cdecfc05483$export$b74153364c2066d1), $7f068950e30577d3$var$_b[(0, $adb0678ebd5d1780$export$78e1bea9036f120f).dataType] = (0, $53141cdecfc05483$export$bc9e843f2eb8a61c), $7f068950e30577d3$var$_b[(0, $3e77672805d15946$export$12c0fdede1c6bc6c).dataType] = (0, $53141cdecfc05483$export$edbb8a2c6529947a), $7f068950e30577d3$var$_b[(0, $03ee94b6fff0696e$export$709aae57ec681346).dataType] = (0, $53141cdecfc05483$export$bb801863268e7049), $7f068950e30577d3$var$_b[(0, $a35c931c4df783c8$export$e2f174de097e0bcd).dataType] = (0, $53141cdecfc05483$export$eca78b65eeb356ed), $7f068950e30577d3$var$_b[(0, $5db807982a2eef93$export$efdd3e096bc27746).dataType] = (0, $53141cdecfc05483$export$bb5bee4039a2e495), $7f068950e30577d3$var$_b[(0, $97ca5e424f1910ef$export$a7b48490930dbffa).dataType] = (0, $53141cdecfc05483$export$74e603a08a7deabe), $7f068950e30577d3$var$_b);
var $7f068950e30577d3$export$c5a96f3e01fb6582 = /** @class */ function(_super) {
    (0, $dc463ff9724142dd$export$1f9c32e3fbfb8e62)(Sender, _super);
    function Sender() {
        var _this = _super.call(this) || this;
        _this.priority = 1001;
        _this.identifier = (0, $5343a490b8ca01c7$export$a714a094d3058c99);
        // Don't set the defaults here, set them in the _initDefaults() as this is also called during unload
        var _consecutiveErrors; // How many times in a row a retryable error condition has occurred.
        var _retryAt; // The time to retry at in milliseconds from 1970/01/01 (this makes the timer calculation easy).
        var _lastSend; // The time of the last send operation.
        var _paused; // Flag indicating that the sending should be paused
        var _timeoutHandle; // Handle to the timer for delayed sending of batches of data.
        var _serializer;
        var _stamp_specific_redirects;
        var _headers;
        var _syncFetchPayload = 0; // Keep track of the outstanding sync fetch payload total (as sync fetch has limits)
        var _syncUnloadSender; // The identified sender to use for the synchronous unload stage
        var _offlineListener;
        var _evtNamespace;
        var _endpointUrl;
        var _orgEndpointUrl;
        var _maxBatchSizeInBytes;
        var _beaconSupported;
        var _beaconOnUnloadSupported;
        var _beaconNormalSupported;
        var _customHeaders;
        var _disableTelemetry;
        var _instrumentationKey;
        var _convertUndefined;
        var _isRetryDisabled;
        var _maxBatchInterval;
        var _sessionStorageUsed;
        var _bufferOverrideUsed;
        var _namePrefix;
        var _enableSendPromise;
        var _alwaysUseCustomSend;
        var _disableXhr;
        var _fetchKeepAlive;
        var _xhrSend;
        var _fallbackSend;
        var _disableBeaconSplit;
        var _sendPostMgr;
        var _retryCodes;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(Sender, _this, function(_self, _base) {
            _initDefaults();
            _self.pause = function() {
                _clearScheduledTimer();
                _paused = true;
            };
            _self.resume = function() {
                if (_paused) {
                    _paused = false;
                    _retryAt = null;
                    // flush if we have exceeded the max-size already
                    _checkMaxSize();
                    _setupTimer();
                }
            };
            _self.flush = function(isAsync, callBack, sendReason) {
                if (isAsync === void 0) isAsync = true;
                if (!_paused) {
                    // Clear the normal schedule timer as we are going to try and flush ASAP
                    _clearScheduledTimer();
                    try {
                        return _self[0, $07716e087fcf5bbc$export$df21ab0de9057cc4 /* @min:%2etriggerSend */ ](isAsync, null, sendReason || 1 /* SendRequestReason.ManualFlush */ );
                    } catch (e) {
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 22 /* _eInternalMessageId.FlushFailed */ , "flush failed, telemetry will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                            exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                        });
                    }
                }
            };
            _self.onunloadFlush = function() {
                if (!_paused) {
                    if (_beaconSupported || _alwaysUseCustomSend) try {
                        return _self[0, $07716e087fcf5bbc$export$df21ab0de9057cc4 /* @min:%2etriggerSend */ ](true, _doUnloadSend, 2 /* SendRequestReason.Unload */ );
                    } catch (e) {
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 20 /* _eInternalMessageId.FailedToSendQueuedTelemetry */ , "failed to flush with beacon sender on page unload, telemetry will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                            exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                        });
                    }
                    else _self.flush(false);
                }
            };
            _self.addHeader = function(name, value) {
                _headers[name] = value;
            };
            _self[0, $07716e087fcf5bbc$export$65cd33bb52d04675 /* @min:%2einitialize */ ] = function(config, core, extensions, pluginChain) {
                if (_self.isInitialized()) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 28 /* _eInternalMessageId.SenderNotInitialized */ , "Sender is already initialized");
                _base[0, $07716e087fcf5bbc$export$65cd33bb52d04675 /* @min:%2einitialize */ ](config, core, extensions, pluginChain);
                var identifier = _self.identifier;
                _serializer = new (0, $ffeedac495e2c7a7$export$ef852775387a0be7)(core.logger);
                _consecutiveErrors = 0;
                _retryAt = null;
                _lastSend = 0;
                _self[0, $07716e087fcf5bbc$export$e5390b88ba6f1b04 /* @min:%2e_sender */ ] = null;
                _stamp_specific_redirects = 0;
                var diagLog = _self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]();
                _evtNamespace = (0, $02f0ede5277c99cd$export$3f37a50e0edde3be)((0, $0e058b881c0798ff$export$eb4a6badb18ead04)("Sender"), core.evtNamespace && core.evtNamespace());
                _offlineListener = (0, $f77eaff1f963d24b$export$798b7fe42d5e3d06)(_evtNamespace);
                // This function will be re-called whenever any referenced configuration is changed
                _self._addHook((0, $6387583e0b25820c$export$454a433e4deb244f)(config, function(details) {
                    var config = details.cfg;
                    if (config.storagePrefix) (0, $3fab9bbcce274f86$export$a08dccf4adbf6df9)(config.storagePrefix);
                    var ctx = (0, $21bc92e23804c647$export$ca98f11e981bcfd6)(null, config, core);
                    // getExtCfg only finds undefined values from core
                    var senderConfig = ctx.getExtCfg(identifier, $7f068950e30577d3$var$defaultAppInsightsChannelConfig);
                    if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(senderConfig[0, $07716e087fcf5bbc$export$bfa1c9e5dcf1e78 /* @min:%2eendpointUrl */ ])) // if it is promise, means the endpoint url is from core.endpointurl
                    senderConfig[0, $07716e087fcf5bbc$export$bfa1c9e5dcf1e78 /* @min:%2eendpointUrl */ ] = config[0, $07716e087fcf5bbc$export$bfa1c9e5dcf1e78 /* @min:%2eendpointUrl */ ];
                    if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(senderConfig[0, $07716e087fcf5bbc$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ])) // if it is promise, means the endpoint url is from core.endpointurl
                    senderConfig[0, $07716e087fcf5bbc$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ] = config[0, $07716e087fcf5bbc$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ];
                    (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "_senderConfig", {
                        g: function() {
                            return senderConfig;
                        }
                    });
                    // Only update the endpoint if the original config !== the current config
                    // This is so any redirect endpointUrl is not overwritten
                    if (_orgEndpointUrl !== senderConfig[0, $07716e087fcf5bbc$export$bfa1c9e5dcf1e78 /* @min:%2eendpointUrl */ ]) {
                        _orgEndpointUrl;
                        _endpointUrl = _orgEndpointUrl = senderConfig[0, $07716e087fcf5bbc$export$bfa1c9e5dcf1e78 /* @min:%2eendpointUrl */ ];
                    }
                    // or is not string
                    if (core.activeStatus() === (0, $452a7a5f1b634188$export$bc7f1ae22a2680b3).PENDING) // waiting for core promises to be resolved
                    // NOTE: if active status is set to pending, stop sending, clear timer here
                    _self.pause();
                    else if (core.activeStatus() === (0, $452a7a5f1b634188$export$bc7f1ae22a2680b3).ACTIVE) // core status changed from pending to other status
                    _self.resume();
                    if (_customHeaders && _customHeaders !== senderConfig[0, $07716e087fcf5bbc$export$dbe59923e879fdc5 /* @min:%2ecustomHeaders */ ]) // Removing any previously defined custom headers as they have changed
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_customHeaders, function(customHeader) {
                        delete _headers[customHeader.header];
                    });
                    _maxBatchSizeInBytes = senderConfig[0, $07716e087fcf5bbc$export$803d432e48ba5ceb /* @min:%2emaxBatchSizeInBytes */ ];
                    _beaconSupported = (senderConfig[0, $07716e087fcf5bbc$export$6b8e1dc9b77f253c /* @min:%2eonunloadDisableBeacon */ ] === false || senderConfig[0, $07716e087fcf5bbc$export$f5629284a6f7ec3d /* @min:%2eisBeaconApiDisabled */ ] === false) && (0, $0d2c2fb24388dcf8$export$cf496c79c05967a0)();
                    _beaconOnUnloadSupported = senderConfig[0, $07716e087fcf5bbc$export$6b8e1dc9b77f253c /* @min:%2eonunloadDisableBeacon */ ] === false && (0, $0d2c2fb24388dcf8$export$cf496c79c05967a0)();
                    _beaconNormalSupported = senderConfig[0, $07716e087fcf5bbc$export$f5629284a6f7ec3d /* @min:%2eisBeaconApiDisabled */ ] === false && (0, $0d2c2fb24388dcf8$export$cf496c79c05967a0)();
                    _alwaysUseCustomSend = senderConfig[0, $07716e087fcf5bbc$export$87044a2824fddfb0 /* @min:%2ealwaysUseXhrOverride */ ];
                    _disableXhr = !!senderConfig[0, $07716e087fcf5bbc$export$85f018eb7798fb52 /* @min:%2edisableXhr */ ];
                    _retryCodes = senderConfig.retryCodes;
                    var bufferOverride = senderConfig[0, $07716e087fcf5bbc$export$4637bcb72c509e60 /* @min:%2ebufferOverride */ ];
                    var canUseSessionStorage = !!senderConfig[0, $07716e087fcf5bbc$export$c9210d86ca1dd637 /* @min:%2eenableSessionStorageBuffer */ ] && (!!bufferOverride || (0, $3fab9bbcce274f86$export$c81985c4209bac26)());
                    var namePrefix = senderConfig.namePrefix;
                    //Note: emitLineDelimitedJson and eventsLimitInMem is directly accessed via config in senderBuffer
                    //Therefore, if canUseSessionStorage is not changed, we do not need to re initialize a new one
                    var shouldUpdate = canUseSessionStorage !== _sessionStorageUsed || canUseSessionStorage && _namePrefix !== namePrefix // prefixName is only used in session storage
                     || canUseSessionStorage && _bufferOverrideUsed !== bufferOverride;
                    if (_self[0, $07716e087fcf5bbc$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ]) {
                        // case1 (Pre and Now enableSessionStorageBuffer settings are same)
                        // if namePrefix changes, transfer current buffer to new buffer
                        // else no action needed
                        //case2 (Pre and Now enableSessionStorageBuffer settings are changed)
                        // transfer current buffer to new buffer
                        if (shouldUpdate) try {
                            _self._buffer = _self._buffer[0, $07716e087fcf5bbc$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ](diagLog, senderConfig, canUseSessionStorage);
                        } catch (e) {
                            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 12 /* _eInternalMessageId.FailedAddingTelemetryToBuffer */ , "failed to transfer telemetry to different buffer storage, telemetry will be lost: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                                exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                            });
                        }
                        _checkMaxSize();
                    } else _self[0, $07716e087fcf5bbc$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ] = canUseSessionStorage ? new (0, $1fa48c075af358bb$export$dcb776947c16915f)(diagLog, senderConfig) : new (0, $1fa48c075af358bb$export$d706e5fd60d36d56)(diagLog, senderConfig);
                    _namePrefix = namePrefix;
                    _sessionStorageUsed = canUseSessionStorage;
                    _bufferOverrideUsed = bufferOverride;
                    _fetchKeepAlive = !senderConfig[0, $07716e087fcf5bbc$export$fa88a131053c3501 /* @min:%2eonunloadDisableFetch */ ] && (0, $0d2c2fb24388dcf8$export$f8c1c61350d9749)(true);
                    _disableBeaconSplit = !!senderConfig[0, $07716e087fcf5bbc$export$78c7449d94867b7f /* @min:%2edisableSendBeaconSplit */ ];
                    _self._sample = new (0, $be1c115b9b440698$export$21a3eccb8a1780eb)(senderConfig.samplingPercentage, diagLog);
                    _instrumentationKey = senderConfig[0, $07716e087fcf5bbc$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ];
                    if (!(0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(_instrumentationKey) && !_validateInstrumentationKey(_instrumentationKey, config)) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(diagLog, 1 /* eLoggingSeverity.CRITICAL */ , 100 /* _eInternalMessageId.InvalidInstrumentationKey */ , "Invalid Instrumentation key " + _instrumentationKey);
                    _customHeaders = senderConfig[0, $07716e087fcf5bbc$export$dbe59923e879fdc5 /* @min:%2ecustomHeaders */ ];
                    if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(_endpointUrl) && !(0, $d98f9809e5d6a7c7$export$edade5317663baa4)(_endpointUrl) && _customHeaders && _customHeaders[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_customHeaders, function(customHeader) {
                        _this.addHeader(customHeader.header, customHeader.value);
                    });
                    else _customHeaders = null;
                    _enableSendPromise = senderConfig[0, $07716e087fcf5bbc$export$1c777603d483e31f /* @min:%2eenableSendPromise */ ];
                    var sendPostConfig = _getSendPostMgrConfig();
                    // only init it once
                    if (!_sendPostMgr) {
                        _sendPostMgr = new (0, $7928109a8e3dfbfa$export$e3388bef22319dfd)();
                        _sendPostMgr[0, $07716e087fcf5bbc$export$65cd33bb52d04675 /* @min:%2einitialize */ ](sendPostConfig, diagLog);
                    } else _sendPostMgr.SetConfig(sendPostConfig);
                    var customInterface = senderConfig.httpXHROverride;
                    var httpInterface = null;
                    var syncInterface = null;
                    // User requested transport(s) values > Beacon > Fetch > XHR
                    // Beacon would be filtered out if user has set disableBeaconApi to true at _getSenderInterface
                    var theTransports = (0, $ede407819d2d28c9$export$d435c252bc2524f)([
                        3 /* TransportType.Beacon */ ,
                        1 /* TransportType.Xhr */ ,
                        2 /* TransportType.Fetch */ 
                    ], senderConfig.transports);
                    httpInterface = _sendPostMgr && _sendPostMgr[0, $07716e087fcf5bbc$export$f8d641d56432a4fc /* @min:%2egetSenderInst */ ](theTransports, false);
                    var xhrInterface = _sendPostMgr && _sendPostMgr.getFallbackInst();
                    _xhrSend = function(payload, isAsync) {
                        return _doSend(xhrInterface, payload, isAsync);
                    };
                    _fallbackSend = function(payload, isAsync) {
                        return _doSend(xhrInterface, payload, isAsync, false);
                    };
                    httpInterface = _alwaysUseCustomSend ? customInterface : httpInterface || customInterface || xhrInterface;
                    _self[0, $07716e087fcf5bbc$export$e5390b88ba6f1b04 /* @min:%2e_sender */ ] = function(payload, isAsync) {
                        return _doSend(httpInterface, payload, isAsync);
                    };
                    if (_fetchKeepAlive) // Try and use the fetch with keepalive
                    _syncUnloadSender = _fetchKeepAliveSender;
                    var syncTransports = (0, $ede407819d2d28c9$export$d435c252bc2524f)([
                        3 /* TransportType.Beacon */ ,
                        1 /* TransportType.Xhr */ 
                    ], senderConfig[0, $07716e087fcf5bbc$export$94f25b4060c75779 /* @min:%2eunloadTransports */ ]);
                    if (!_fetchKeepAlive) // remove fetch from theTransports
                    syncTransports = syncTransports.filter(function(transport) {
                        return transport !== 2 /* TransportType.Fetch */ ;
                    });
                    syncInterface = _sendPostMgr && _sendPostMgr[0, $07716e087fcf5bbc$export$f8d641d56432a4fc /* @min:%2egetSenderInst */ ](syncTransports, true);
                    syncInterface = _alwaysUseCustomSend ? customInterface : syncInterface || customInterface;
                    if ((_alwaysUseCustomSend || senderConfig[0, $07716e087fcf5bbc$export$94f25b4060c75779 /* @min:%2eunloadTransports */ ] || !_syncUnloadSender) && syncInterface) _syncUnloadSender = function(payload, isAsync) {
                        return _doSend(syncInterface, payload, isAsync);
                    };
                    if (!_syncUnloadSender) _syncUnloadSender = _xhrSend;
                    _disableTelemetry = senderConfig.disableTelemetry;
                    _convertUndefined = senderConfig[0, $07716e087fcf5bbc$export$12df46deb7379c67 /* @min:%2econvertUndefined */ ] || $7f068950e30577d3$var$UNDEFINED_VALUE;
                    _isRetryDisabled = senderConfig.isRetryDisabled;
                    _maxBatchInterval = senderConfig[0, $07716e087fcf5bbc$export$983774f06380e463 /* @min:%2emaxBatchInterval */ ];
                }));
            };
            _self.processTelemetry = function(telemetryItem, itemCtx) {
                var _a;
                itemCtx = _self._getTelCtx(itemCtx);
                var diagLogger = itemCtx[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]();
                try {
                    var isValidate = _validate(telemetryItem, diagLogger);
                    if (!isValidate) return;
                    var aiEnvelope = _getEnvelope(telemetryItem, diagLogger);
                    if (!aiEnvelope) return;
                    // check if the incoming payload is too large, truncate if necessary
                    var payload = _serializer[0, $07716e087fcf5bbc$export$3726a43a9362600c /* @min:%2eserialize */ ](aiEnvelope);
                    // flush if we would exceed the max-size limit by adding this item
                    var buffer = _self[0, $07716e087fcf5bbc$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ];
                    _checkMaxSize(payload);
                    var payloadItem = (_a = {}, _a[0, $07716e087fcf5bbc$export$7a8bb3cc4a906992 /* @min:item */ ] = payload, _a.cnt = 0 // inital cnt will always be 0
                    , _a);
                    // enqueue the payload
                    buffer[0, $07716e087fcf5bbc$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ](payloadItem);
                    // ensure an invocation timeout is set
                    _setupTimer();
                } catch (e) {
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(diagLogger, 2 /* eLoggingSeverity.WARNING */ , 12 /* _eInternalMessageId.FailedAddingTelemetryToBuffer */ , "Failed adding telemetry to the sender's buffer, some telemetry will be lost: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
                // hand off the telemetry item to the next plugin
                _self.processNext(telemetryItem, itemCtx);
            };
            _self.isCompletelyIdle = function() {
                return !_paused && _syncFetchPayload === 0 && _self._buffer[0, $07716e087fcf5bbc$export$e9679ef501b0d1 /* @min:%2ecount */ ]() === 0;
            };
            /**
             * xhr state changes
             */ _self._xhrReadyStateChange = function(xhr, payload, countOfItemsInPayload) {
                // since version 3.2.0, this function is no-op
                if (_isStringArr(payload)) return;
                return _xhrReadyStateChange(xhr, payload, countOfItemsInPayload);
            };
            /**
             * Immediately send buffered data
             * @param async - {boolean} - Indicates if the events should be sent asynchronously
             * @param forcedSender - {SenderFunction} - Indicates the forcedSender, undefined if not passed
             */ _self[0, $07716e087fcf5bbc$export$df21ab0de9057cc4 /* @min:%2etriggerSend */ ] = function(async, forcedSender, sendReason) {
                if (async === void 0) async = true;
                var result;
                if (!_paused) try {
                    var buffer = _self[0, $07716e087fcf5bbc$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ];
                    // Send data only if disableTelemetry is false
                    if (!_disableTelemetry) {
                        if (buffer[0, $07716e087fcf5bbc$export$e9679ef501b0d1 /* @min:%2ecount */ ]() > 0) {
                            var payload = buffer.getItems();
                            _notifySendRequest(sendReason || 0 /* SendRequestReason.Undefined */ , async);
                            // invoke send
                            if (forcedSender) result = forcedSender.call(_self, payload, async);
                            else result = _self[0, $07716e087fcf5bbc$export$e5390b88ba6f1b04 /* @min:%2e_sender */ ](payload, async);
                        }
                        // update lastSend time to enable throttling
                        _lastSend = +new Date;
                    } else buffer[0, $07716e087fcf5bbc$export$5eeb73fac03da74a /* @min:%2eclear */ ]();
                    _clearScheduledTimer();
                } catch (e) {
                    /* Ignore this error for IE under v10 */ var ieVer = (0, $0d2c2fb24388dcf8$export$eb7ff627fa81c42e)();
                    if (!ieVer || ieVer > 9) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 40 /* _eInternalMessageId.TransmissionFailed */ , "Telemetry transmission failed, some telemetry will be lost: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
                return result;
            };
            _self.getOfflineSupport = function() {
                var _a;
                return _a = {
                    getUrl: function() {
                        return _endpointUrl;
                    },
                    createPayload: _createPayload
                }, _a[0, $07716e087fcf5bbc$export$3726a43a9362600c /* @min:serialize */ ] = _serialize, _a.batch = _batch, _a.shouldProcess = function(evt) {
                    return !!_validate(evt);
                }, _a;
            };
            _self._doTeardown = function(unloadCtx, unloadState) {
                _self.onunloadFlush();
                (0, $59a25debd846dee6$export$86347c3dd68c03f6)(_offlineListener, false);
                _initDefaults();
            };
            /**
             * error handler
             */ _self[0, $07716e087fcf5bbc$export$fd0c91d4da43d71b /* @min:%2e_onError */ ] = function(payload, message, event) {
                // since version 3.1.3, string[] is no-op
                if (_isStringArr(payload)) return;
                return _onError(payload, message, event);
            };
            /**
             * partial success handler
             */ _self[0, $07716e087fcf5bbc$export$689c49d56ac33585 /* @min:%2e_onPartialSuccess */ ] = function(payload, results) {
                // since version 3.1.3, string[] is no-op
                if (_isStringArr(payload)) return;
                return _onPartialSuccess(payload, results);
            };
            /**
             * success handler
             */ _self[0, $07716e087fcf5bbc$export$82a109ffee49e423 /* @min:%2e_onSuccess */ ] = function(payload, countOfItemsInPayload) {
                // since version 3.1.3, string[] is no-op
                if (_isStringArr(payload)) return;
                return _onSuccess(payload, countOfItemsInPayload);
            //_self._buffer && _self._buffer.clearSent(payload);
            };
            /**
             * xdr state changes
             */ _self._xdrOnLoad = function(xdr, payload) {
                // since version 3.1.3, string[] is no-op
                if (_isStringArr(payload)) return;
                return _xdrOnLoad(xdr, payload);
            };
            function _xdrOnLoad(xdr, payload) {
                var responseText = $7f068950e30577d3$var$_getResponseText(xdr);
                if (xdr && (responseText + "" === "200" || responseText === "")) {
                    _consecutiveErrors = 0;
                    _self[0, $07716e087fcf5bbc$export$82a109ffee49e423 /* @min:%2e_onSuccess */ ](payload, 0);
                } else {
                    var results = (0, $248db41a83147c13$export$ba14d9a5a581e827)(responseText);
                    if (results && results[0, $07716e087fcf5bbc$export$746df81af2cb9d94 /* @min:%2eitemsReceived */ ] && results[0, $07716e087fcf5bbc$export$746df81af2cb9d94 /* @min:%2eitemsReceived */ ] > results[0, $07716e087fcf5bbc$export$fb8523c8667e286a /* @min:%2eitemsAccepted */ ] && !_isRetryDisabled) _self[0, $07716e087fcf5bbc$export$689c49d56ac33585 /* @min:%2e_onPartialSuccess */ ](payload, results);
                    else _self[0, $07716e087fcf5bbc$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](payload, (0, $ede407819d2d28c9$export$404d535171315d86)(xdr));
                }
            }
            function _getSendPostMgrConfig() {
                var _a;
                try {
                    var onCompleteFuncs = {
                        xdrOnComplete: function(xdr, oncomplete, payload) {
                            var data = _getPayloadArr(payload);
                            if (!data) return;
                            return _xdrOnLoad(xdr, data);
                        },
                        fetchOnComplete: function(response, onComplete, resValue, payload) {
                            var data = _getPayloadArr(payload);
                            if (!data) return;
                            return _checkResponsStatus(response.status, data, response.url, data[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ], response.statusText, resValue || "");
                        },
                        xhrOnComplete: function(request, oncomplete, payload) {
                            var data = _getPayloadArr(payload);
                            if (!data) return;
                            return _xhrReadyStateChange(request, data, data[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]);
                        },
                        beaconOnRetry: function(data, onComplete, canSend) {
                            return _onBeaconRetry(data, onComplete, canSend);
                        }
                    };
                    var config = (_a = {}, _a[0, $07716e087fcf5bbc$export$1c777603d483e31f /* @min:enableSendPromise */ ] = _enableSendPromise, _a.isOneDs = false, _a.disableCredentials = false, _a[0, $07716e087fcf5bbc$export$85f018eb7798fb52 /* @min:disableXhr */ ] = _disableXhr, _a.disableBeacon = !_beaconNormalSupported, _a.disableBeaconSync = !_beaconOnUnloadSupported, _a.senderOnCompleteCallBack = onCompleteFuncs, _a);
                    return config;
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return null;
            }
            /**
             * xhr state changes
             */ function _xhrReadyStateChange(xhr, payload, countOfItemsInPayload) {
                if (xhr.readyState === 4) _checkResponsStatus(xhr.status, payload, xhr.responseURL, countOfItemsInPayload, (0, $ede407819d2d28c9$export$f826fdf8bca00592)(xhr), $7f068950e30577d3$var$_getResponseText(xhr) || xhr.response);
            }
            /**
             * error handler
             */ function _onError(payload, message, event) {
                (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 26 /* _eInternalMessageId.OnError */ , "Failed to send telemetry.", {
                    message: message
                });
                _self._buffer && _self._buffer[0, $07716e087fcf5bbc$export$13da1b5a005ef035 /* @min:%2eclearSent */ ](payload);
            }
            /**
             * partial success handler
             */ function _onPartialSuccess(payload, results) {
                var failed = [];
                var retry = [];
                // Iterate through the reversed array of errors so that splicing doesn't have invalid indexes after the first item.
                var errors = results.errors.reverse();
                for(var _i = 0, errors_1 = errors; _i < errors_1.length; _i++){
                    var error = errors_1[_i];
                    var extracted = payload.splice(error.index, 1)[0];
                    if (_isRetriable(error.statusCode)) retry[0, $07716e087fcf5bbc$export$a0a330e7fa1e278c /* @min:%2epush */ ](extracted);
                    else // All other errors, including: 402 (Monthly quota exceeded) and 439 (Too many requests and refresh cache).
                    failed[0, $07716e087fcf5bbc$export$a0a330e7fa1e278c /* @min:%2epush */ ](extracted);
                }
                if (payload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) _self[0, $07716e087fcf5bbc$export$82a109ffee49e423 /* @min:%2e_onSuccess */ ](payload, results[0, $07716e087fcf5bbc$export$fb8523c8667e286a /* @min:%2eitemsAccepted */ ]);
                if (failed[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) _self[0, $07716e087fcf5bbc$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](failed, (0, $ede407819d2d28c9$export$f826fdf8bca00592)(null, [
                    "partial success",
                    results[0, $07716e087fcf5bbc$export$fb8523c8667e286a /* @min:%2eitemsAccepted */ ],
                    "of",
                    results.itemsReceived
                ].join(" ")));
                if (retry[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    _resendPayload(retry);
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , "Partial success. Delivered: " + payload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] + ", Failed: " + failed[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] + ". Will retry to send " + retry[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] + " our of " + results[0, $07716e087fcf5bbc$export$746df81af2cb9d94 /* @min:%2eitemsReceived */ ] + " items");
                }
            }
            /**
             * success handler
             */ function _onSuccess(payload, countOfItemsInPayload) {
                _self._buffer && _self._buffer[0, $07716e087fcf5bbc$export$13da1b5a005ef035 /* @min:%2eclearSent */ ](payload);
            }
            function _getPayloadArr(payload) {
                try {
                    if (payload) {
                        var internalPayload = payload;
                        var arr = internalPayload[0, $07716e087fcf5bbc$export$649529ba72435000 /* @min:%2eoriPayload */ ];
                        if (arr && arr[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]) return arr;
                        return null;
                    }
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return null;
            }
            function _validate(telemetryItem, diagLogger) {
                if (_disableTelemetry) // Do not send/save data
                return false;
                // validate input
                if (!telemetryItem) {
                    diagLogger && (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 7 /* _eInternalMessageId.CannotSendEmptyTelemetry */ , "Cannot send empty telemetry");
                    return false;
                }
                // validate event
                if (telemetryItem.baseData && !telemetryItem[0, $07716e087fcf5bbc$export$aa558e99f83347cf /* @min:%2ebaseType */ ]) {
                    diagLogger && (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 70 /* _eInternalMessageId.InvalidEvent */ , "Cannot send telemetry without baseData and baseType");
                    return false;
                }
                if (!telemetryItem[0, $07716e087fcf5bbc$export$aa558e99f83347cf /* @min:%2ebaseType */ ]) // Default
                telemetryItem[0, $07716e087fcf5bbc$export$aa558e99f83347cf /* @min:%2ebaseType */ ] = "EventData";
                // ensure a sender was constructed
                if (!_self[0, $07716e087fcf5bbc$export$e5390b88ba6f1b04 /* @min:%2e_sender */ ]) {
                    diagLogger && (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 28 /* _eInternalMessageId.SenderNotInitialized */ , "Sender was not initialized");
                    return false;
                }
                // check if this item should be sampled in, else add sampleRate tag
                if (!_isSampledIn(telemetryItem)) {
                    // Item is sampled out, do not send it
                    diagLogger && (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(diagLogger, 2 /* eLoggingSeverity.WARNING */ , 33 /* _eInternalMessageId.TelemetrySampledAndNotSent */ , "Telemetry item was sampled out and not sent", {
                        SampleRate: _self._sample[0, $07716e087fcf5bbc$export$c2afe23fa18f9dff /* @min:%2esampleRate */ ]
                    });
                    return false;
                } else telemetryItem[0, $8ac3b4fe9182f568$export$dc288b6444e20c04] = _self._sample[0, $07716e087fcf5bbc$export$c2afe23fa18f9dff /* @min:%2esampleRate */ ];
                return true;
            }
            function _getEnvelope(telemetryItem, diagLogger) {
                // construct an envelope that Application Insights endpoint can understand
                // if ikey of telemetry is provided and not empty, envelope will use this iKey instead of senderConfig iKey
                var defaultEnvelopeIkey = telemetryItem.iKey || _instrumentationKey;
                var aiEnvelope = Sender.constructEnvelope(telemetryItem, defaultEnvelopeIkey, diagLogger, _convertUndefined);
                if (!aiEnvelope) {
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 47 /* _eInternalMessageId.CreateEnvelopeError */ , "Unable to create an AppInsights envelope");
                    return;
                }
                var doNotSendItem = false;
                // this is for running in legacy mode, where customer may already have a custom initializer present
                if (telemetryItem[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] && telemetryItem[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ][0, $8ac3b4fe9182f568$export$ea8a69bf327def66]) {
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(telemetryItem[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ][0, $8ac3b4fe9182f568$export$ea8a69bf327def66], function(callBack) {
                        try {
                            if (callBack && callBack(aiEnvelope) === false) {
                                doNotSendItem = true;
                                (0, $bacca83328a730a7$export$25fb4cb97863f0a8)(diagLogger, "Telemetry processor check returns false");
                            }
                        } catch (e) {
                            // log error but dont stop executing rest of the telemetry initializers
                            // doNotSendItem = true;
                            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 64 /* _eInternalMessageId.TelemetryInitializerFailed */ , "One of telemetry initializers failed, telemetry item will not be sent: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                                exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                            }, true);
                        }
                    });
                    delete telemetryItem[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ][0, $8ac3b4fe9182f568$export$ea8a69bf327def66];
                }
                if (doNotSendItem) return; // do not send, no need to execute next plugin
                return aiEnvelope;
            }
            function _serialize(item) {
                var rlt = $7f068950e30577d3$var$EMPTY_STR;
                var diagLogger = _self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]();
                try {
                    var valid = _validate(item, diagLogger);
                    var envelope = null;
                    if (valid) envelope = _getEnvelope(item, diagLogger);
                    if (envelope) rlt = _serializer[0, $07716e087fcf5bbc$export$3726a43a9362600c /* @min:%2eserialize */ ](envelope);
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return rlt;
            }
            function _batch(arr) {
                var rlt = $7f068950e30577d3$var$EMPTY_STR;
                if (arr && arr[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]) rlt = "[" + arr.join(",") + "]";
                return rlt;
            }
            function _createPayload(data) {
                var _a;
                var headers = _getHeaders();
                return _a = {
                    urlString: _endpointUrl
                }, _a[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:data */ ] = data, _a.headers = headers, _a;
            }
            function _isSampledIn(envelope) {
                return _self._sample.isSampledIn(envelope);
            }
            function _getOnComplete(payload, status, headers, response) {
                // ***********************************************************************************************
                //TODO: handle other status codes
                if (status === 200 && payload) _self._onSuccess(payload, payload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]);
                else response && _self[0, $07716e087fcf5bbc$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](payload, response);
            }
            function _doSend(sendInterface, payload, isAsync, markAsSent) {
                if (markAsSent === void 0) markAsSent = true;
                var onComplete = function(status, headers, response) {
                    return _getOnComplete(payload, status, headers, response);
                };
                var payloadData = _getPayload(payload);
                var sendPostFunc = sendInterface && sendInterface.sendPOST;
                if (sendPostFunc && payloadData) {
                    // ***********************************************************************************************
                    // mark payload as sent at the beginning of calling each send function
                    if (markAsSent) _self._buffer[0, $07716e087fcf5bbc$export$52e50651d87300e3 /* @min:%2emarkAsSent */ ](payload);
                    return sendPostFunc(payloadData, onComplete, !isAsync);
                }
                return null;
            }
            function _getPayload(payload) {
                var _a;
                if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(payload) && payload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    var batch = _self[0, $07716e087fcf5bbc$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ].batchPayloads(payload);
                    var headers = _getHeaders();
                    var payloadData = (_a = {}, _a[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:data */ ] = batch, _a.urlString = _endpointUrl, _a.headers = headers, _a.disableXhrSync = _disableXhr, _a.disableFetchKeepAlive = !_fetchKeepAlive, _a[0, $07716e087fcf5bbc$export$649529ba72435000 /* @min:oriPayload */ ] = payload, _a);
                    return payloadData;
                }
                return null;
            }
            function _getHeaders() {
                try {
                    var headers = _headers || {};
                    if ((0, $d98f9809e5d6a7c7$export$edade5317663baa4)(_endpointUrl)) headers[(0, $921552b7fb658c3b$export$e499e02a1fe05177)[6 /* eRequestHeaders.sdkContextHeader */ ]] = (0, $921552b7fb658c3b$export$e499e02a1fe05177)[7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */ ];
                    return headers;
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return null;
            }
            function _checkMaxSize(incomingPayload) {
                var incomingSize = incomingPayload ? incomingPayload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] : 0;
                if (_self[0, $07716e087fcf5bbc$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ].size() + incomingSize > _maxBatchSizeInBytes) {
                    if (!_offlineListener || _offlineListener.isOnline()) _self[0, $07716e087fcf5bbc$export$df21ab0de9057cc4 /* @min:%2etriggerSend */ ](true, null, 10 /* SendRequestReason.MaxBatchSize */ );
                    return true;
                }
                return false;
            }
            function _checkResponsStatus(status, payload, responseUrl, countOfItemsInPayload, errorMessage, res) {
                var response = null;
                if (!_self._appId) {
                    response = (0, $248db41a83147c13$export$ba14d9a5a581e827)(res);
                    if (response && response.appId) _self._appId = response.appId;
                }
                if ((status < 200 || status >= 300) && status !== 0) {
                    // Update End Point url if permanent redirect or moved permanently
                    // Updates the end point url before retry
                    if (status === 301 || status === 307 || status === 308) {
                        if (!_checkAndUpdateEndPointUrl(responseUrl)) {
                            _self[0, $07716e087fcf5bbc$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](payload, errorMessage);
                            return;
                        }
                    }
                    if (_offlineListener && !_offlineListener.isOnline()) {
                        // Note: Don't check for status == 0, since adblock gives this code
                        if (!_isRetryDisabled) {
                            var offlineBackOffMultiplier = 10; // arbritrary number
                            _resendPayload(payload, offlineBackOffMultiplier);
                            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Offline - Response Code: ".concat(status, ". Offline status: ").concat(!_offlineListener.isOnline(), ". Will retry to send ").concat(payload.length, " items."));
                        }
                        return;
                    }
                    if (!_isRetryDisabled && _isRetriable(status)) {
                        _resendPayload(payload);
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Response code " + status + ". Will retry to send " + payload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] + " items.");
                    } else _self[0, $07716e087fcf5bbc$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](payload, errorMessage);
                } else {
                    // check if the xhr's responseURL or fetch's response.url is same as endpoint url
                    // TODO after 10 redirects force send telemetry with 'redirect=false' as query parameter.
                    _checkAndUpdateEndPointUrl(responseUrl);
                    if (status === 206) {
                        if (!response) response = (0, $248db41a83147c13$export$ba14d9a5a581e827)(res);
                        if (response && !_isRetryDisabled) _self[0, $07716e087fcf5bbc$export$689c49d56ac33585 /* @min:%2e_onPartialSuccess */ ](payload, response);
                        else _self[0, $07716e087fcf5bbc$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](payload, errorMessage);
                    } else {
                        _consecutiveErrors = 0;
                        _self[0, $07716e087fcf5bbc$export$82a109ffee49e423 /* @min:%2e_onSuccess */ ](payload, countOfItemsInPayload);
                    }
                }
            }
            function _checkAndUpdateEndPointUrl(responseUrl) {
                // Maximum stamp specific redirects allowed(uncomment this when breeze is ready with not allowing redirects feature)
                if (_stamp_specific_redirects >= 10) //  _self._senderConfig.endpointUrl = () => Sender._getDefaultAppInsightsChannelConfig().endpointUrl()+"/?redirect=false";
                //  _stamp_specific_redirects = 0;
                return false;
                if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(responseUrl) && responseUrl !== "") {
                    if (responseUrl !== _endpointUrl) {
                        _endpointUrl = responseUrl;
                        ++_stamp_specific_redirects;
                        return true;
                    }
                }
                return false;
            }
            function _doUnloadSend(payload, isAsync) {
                if (_syncUnloadSender) // We are unloading so always call the sender with sync set to false
                _syncUnloadSender(payload, false);
                else {
                    // Fallback to the previous beacon Sender (which causes a CORB warning on chrome now)
                    var beaconInst = _sendPostMgr && _sendPostMgr[0, $07716e087fcf5bbc$export$f8d641d56432a4fc /* @min:%2egetSenderInst */ ]([
                        3 /* TransportType.Beacon */ 
                    ], true);
                    return _doSend(beaconInst, payload, isAsync);
                }
            }
            function _onBeaconRetry(payload, onComplete, canSend) {
                var internalPayload = payload;
                var data = internalPayload && internalPayload[0, $07716e087fcf5bbc$export$649529ba72435000 /* @min:%2eoriPayload */ ];
                if (!_disableBeaconSplit) {
                    // Failed to send entire payload so try and split data and try to send as much events as possible
                    var droppedPayload = [];
                    for(var lp = 0; lp < data[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++){
                        var thePayload = data[lp];
                        var arr = [
                            thePayload
                        ];
                        var item = _getPayload(arr);
                        if (!canSend(item, onComplete)) // Can't send anymore, so split the batch and drop the rest
                        droppedPayload[0, $07716e087fcf5bbc$export$a0a330e7fa1e278c /* @min:%2epush */ ](thePayload);
                        else _self._onSuccess(arr, arr[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]);
                    }
                    if (droppedPayload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                        _fallbackSend && _fallbackSend(droppedPayload, true);
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Failed to send telemetry with Beacon API, retried with normal sender.");
                    }
                } else {
                    _fallbackSend && _fallbackSend(data, true);
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Failed to send telemetry with Beacon API, retried with normal sender.");
                }
            }
            function _isStringArr(arr) {
                try {
                    if (arr && arr[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]) return (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(arr[0]);
                } catch (e) {
                //TODO: log, sender use IInternalStorageItem instead of string since 3.1.3
                }
                return null;
            }
            function _fetchKeepAliveSender(payload, isAsync) {
                var transport = null;
                if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(payload)) {
                    var payloadSize = payload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ];
                    for(var lp = 0; lp < payload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++)payloadSize += payload[lp].item[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ];
                    var syncFetchPayload = _sendPostMgr.getSyncFetchPayload();
                    if (syncFetchPayload + payloadSize <= $7f068950e30577d3$var$FetchSyncRequestSizeLimitBytes) transport = 2 /* TransportType.Fetch */ ;
                    else if ((0, $0d2c2fb24388dcf8$export$cf496c79c05967a0)()) // Fallback to beacon sender as we at least get told which events can't be scheduled
                    transport = 3 /* TransportType.Beacon */ ;
                    else {
                        // Payload is going to be too big so just try and send via XHR
                        transport = 1 /* TransportType.Xhr */ ;
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Failed to send telemetry with Beacon API, retried with xhrSender.");
                    }
                    var inst = _sendPostMgr && _sendPostMgr[0, $07716e087fcf5bbc$export$f8d641d56432a4fc /* @min:%2egetSenderInst */ ]([
                        transport
                    ], true);
                    return _doSend(inst, payload, isAsync);
                }
                return null;
            }
            /**
             * Resend payload. Adds payload back to the send buffer and setup a send timer (with exponential backoff).
             * @param payload
             */ function _resendPayload(payload, linearFactor) {
                if (linearFactor === void 0) linearFactor = 1;
                if (!payload || payload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] === 0) return;
                var buffer = _self[0, $07716e087fcf5bbc$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ];
                buffer[0, $07716e087fcf5bbc$export$13da1b5a005ef035 /* @min:%2eclearSent */ ](payload);
                _consecutiveErrors++;
                for(var _i = 0, payload_1 = payload; _i < payload_1.length; _i++){
                    var item = payload_1[_i];
                    item.cnt = item.cnt || 0; // to make sure we have cnt for each payload
                    item.cnt++; // when resend, increase cnt
                    buffer[0, $07716e087fcf5bbc$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ](item);
                }
                // setup timer
                _setRetryTime(linearFactor);
                _setupTimer();
            }
            /**
             * Calculates the time to wait before retrying in case of an error based on
             * http://en.wikipedia.org/wiki/Exponential_backoff
             */ function _setRetryTime(linearFactor) {
                var SlotDelayInSeconds = 10;
                var delayInSeconds;
                if (_consecutiveErrors <= 1) delayInSeconds = SlotDelayInSeconds;
                else {
                    var backOffSlot = (Math.pow(2, _consecutiveErrors) - 1) / 2;
                    // tslint:disable-next-line:insecure-random
                    var backOffDelay = Math.floor(Math.random() * backOffSlot * SlotDelayInSeconds) + 1;
                    backOffDelay = linearFactor * backOffDelay;
                    delayInSeconds = Math.max(Math.min(backOffDelay, 3600), SlotDelayInSeconds);
                }
                // TODO: Log the backoff time like the C# version does.
                var retryAfterTimeSpan = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)() + delayInSeconds * 1000;
                // TODO: Log the retry at time like the C# version does.
                _retryAt = retryAfterTimeSpan;
            }
            /**
             * Sets up the timer which triggers actually sending the data.
             */ function _setupTimer() {
                if (!_timeoutHandle && !_paused) {
                    var retryInterval = _retryAt ? Math.max(0, _retryAt - (0, $5831ddb3a0caf7c7$export$a56f095995763cca)()) : 0;
                    var timerValue = Math.max(_maxBatchInterval, retryInterval);
                    _timeoutHandle = (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
                        _timeoutHandle = null;
                        _self[0, $07716e087fcf5bbc$export$df21ab0de9057cc4 /* @min:%2etriggerSend */ ](true, null, 1 /* SendRequestReason.NormalSchedule */ );
                    }, timerValue);
                }
            }
            function _clearScheduledTimer() {
                _timeoutHandle && _timeoutHandle.cancel();
                _timeoutHandle = null;
                _retryAt = null;
            }
            /**
             * Checks if the SDK should resend the payload after receiving this status code from the backend.
             * @param statusCode
             */ function _isRetriable(statusCode) {
                // retryCodes = [] means should not retry
                if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_retryCodes)) return _retryCodes[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] && _retryCodes.indexOf(statusCode) > -1;
                return statusCode === 401 // Unauthorized
                 || statusCode === 408 // Timeout
                 || statusCode === 429 // Too many requests.
                 || statusCode === 500 // Internal server error.
                 || statusCode === 502 // Bad Gateway.
                 || statusCode === 503 // Service unavailable.
                 || statusCode === 504; // Gateway timeout.
            }
            // Using function lookups for backward compatibility as the getNotifyMgr() did not exist until after v2.5.6
            function _getNotifyMgr() {
                var func = "getNotifyMgr";
                if (_self.core[func]) return _self.core[func]();
                // using _self.core['_notificationManager'] for backward compatibility
                return _self.core["_notificationManager"];
            }
            function _notifySendRequest(sendRequest, isAsync) {
                var manager = _getNotifyMgr();
                if (manager && manager[0, $07716e087fcf5bbc$export$298b8388870fcfe9 /* @min:%2eeventsSendRequest */ ]) try {
                    manager[0, $07716e087fcf5bbc$export$298b8388870fcfe9 /* @min:%2eeventsSendRequest */ ](sendRequest, isAsync);
                } catch (e) {
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 74 /* _eInternalMessageId.NotificationException */ , "send request notification failed: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            }
            /**
             * Validate UUID Format
             * Specs taken from https://tools.ietf.org/html/rfc4122 and breeze repo
             */ function _validateInstrumentationKey(instrumentationKey, config) {
                var disableValidation = config.disableInstrumentationKeyValidation;
                var disableIKeyValidationFlag = (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(disableValidation) ? false : disableValidation;
                if (disableIKeyValidationFlag) return true;
                var UUID_Regex = "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$";
                var regexp = new RegExp(UUID_Regex);
                return regexp.test(instrumentationKey);
            }
            function _initDefaults() {
                _self[0, $07716e087fcf5bbc$export$e5390b88ba6f1b04 /* @min:%2e_sender */ ] = null;
                _self[0, $07716e087fcf5bbc$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ] = null;
                _self._appId = null;
                _self._sample = null;
                _headers = {};
                _offlineListener = null;
                _consecutiveErrors = 0;
                _retryAt = null;
                _lastSend = null;
                _paused = false;
                _timeoutHandle = null;
                _serializer = null;
                _stamp_specific_redirects = 0;
                _syncFetchPayload = 0;
                _syncUnloadSender = null;
                _evtNamespace = null;
                _endpointUrl = null;
                _orgEndpointUrl = null;
                _maxBatchSizeInBytes = 0;
                _beaconSupported = false;
                _customHeaders = null;
                _disableTelemetry = false;
                _instrumentationKey = null;
                _convertUndefined = $7f068950e30577d3$var$UNDEFINED_VALUE;
                _isRetryDisabled = false;
                _sessionStorageUsed = null;
                _namePrefix = $7f068950e30577d3$var$UNDEFINED_VALUE;
                _disableXhr = false;
                _fetchKeepAlive = false;
                _disableBeaconSplit = false;
                _xhrSend = null;
                _fallbackSend = null;
                _sendPostMgr = null;
                (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "_senderConfig", {
                    g: function() {
                        return (0, $ede407819d2d28c9$export$a7f7e50f928053df)({}, $7f068950e30577d3$var$defaultAppInsightsChannelConfig);
                    }
                });
            }
        });
        return _this;
    }
    Sender.constructEnvelope = function(orig, iKey, logger, convertUndefined) {
        var envelope;
        if (iKey !== orig.iKey && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(iKey)) envelope = (0, $dc463ff9724142dd$export$b3cf7a802e578501)((0, $dc463ff9724142dd$export$b3cf7a802e578501)({}, orig), {
            iKey: iKey
        });
        else envelope = orig;
        var creator = $7f068950e30577d3$var$EnvelopeTypeCreator[envelope.baseType] || (0, $53141cdecfc05483$export$b74153364c2066d1);
        return creator(logger, envelope, convertUndefined);
    };
    // Removed Stub for Sender.prototype.pause.
    // Removed Stub for Sender.prototype.resume.
    // Removed Stub for Sender.prototype.flush.
    // Removed Stub for Sender.prototype.onunloadFlush.
    // Removed Stub for Sender.prototype.initialize.
    // Removed Stub for Sender.prototype.processTelemetry.
    // Removed Stub for Sender.prototype._xhrReadyStateChange.
    // Removed Stub for Sender.prototype.triggerSend.
    // Removed Stub for Sender.prototype._onError.
    // Removed Stub for Sender.prototype._onPartialSuccess.
    // Removed Stub for Sender.prototype._onSuccess.
    // Removed Stub for Sender.prototype._xdrOnLoad.
    // Removed Stub for Sender.prototype.addHeader.
    // Removed Stub for Sender.prototype.isCompletelyIdle.
    // Removed Stub for Sender.prototype.getOfflineSupport.
    return Sender;
}((0, $dc0100a6f2a9749a$export$64a11c2f90e6766c));



/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 














/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 





var $0dd57305094095f6$var$defaultValues = {
    perfEvtsSendAll: false
};
function $0dd57305094095f6$var$_runScheduledListeners(asyncNotifications) {
    asyncNotifications.h = null;
    var callbacks = asyncNotifications.cb;
    asyncNotifications.cb = [];
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(callbacks, function(cb) {
        // Run the listener in a try-catch to ensure that a single listener failing doesn't prevent the others from running
        (0, $5831ddb3a0caf7c7$export$170b8c323eee7bec)(cb.fn, [
            cb.arg
        ]);
    });
}
// This function is used to combine the logic of running the listeners and handling the async notifications so that they don't
// create multiple timers if there are multiple async listeners.
function $0dd57305094095f6$var$_runListeners(listeners, name, asyncNotifications, callback) {
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(listeners, function(listener) {
        if (listener && listener[name]) {
            if (asyncNotifications) {
                // Schedule the callback to be called after the current call stack has cleared.
                asyncNotifications.cb[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ]({
                    fn: callback,
                    arg: listener
                });
                asyncNotifications.h = asyncNotifications.h || (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)($0dd57305094095f6$var$_runScheduledListeners, 0, asyncNotifications);
            } else // Run the listener in a try-catch to ensure that a single listener failing doesn't prevent the others from running
            (0, $5831ddb3a0caf7c7$export$170b8c323eee7bec)(callback, [
                listener
            ]);
        }
    });
}
/**
 * Class to manage sending notifications to all the listeners.
 */ var $0dd57305094095f6$export$dfa1f14b6290f8c5 = /** @class */ function() {
    function NotificationManager(config) {
        this.listeners = [];
        var perfEvtsSendAll;
        var unloadHandler;
        var _listeners = [];
        var _asyncNotifications = {
            h: null,
            cb: []
        };
        var cfgHandler = (0, $6387583e0b25820c$export$3a9e9180c14487fd)(config, $0dd57305094095f6$var$defaultValues);
        unloadHandler = cfgHandler[0, $45806013ed348c93$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](function(details) {
            perfEvtsSendAll = !!details.cfg.perfEvtsSendAll;
        });
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(NotificationManager, this, function(_self) {
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "listeners", {
                g: function() {
                    return _listeners;
                }
            });
            _self[0, $45806013ed348c93$export$5c8bcfab4f42ca62 /* @min:%2eaddNotificationListener */ ] = function(listener) {
                _listeners[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](listener);
            };
            /**
             * Removes all instances of the listener.
             * @param listener - AWTNotificationListener to remove.
             */ _self[0, $45806013ed348c93$export$fc3403fa6f2894ab /* @min:%2eremoveNotificationListener */ ] = function(listener) {
                var index = (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(_listeners, listener);
                while(index > -1){
                    _listeners[0, $45806013ed348c93$export$84020a2e4fe863b0 /* @min:%2esplice */ ](index, 1);
                    index = (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(_listeners, listener);
                }
            };
            /**
             * Notification for events sent.
             * @param events - The array of events that have been sent.
             */ _self[0, $aa96917b132802ee$export$bb3c4bc1b1175d3d /* @min:%2eeventsSent */ ] = function(events) {
                $0dd57305094095f6$var$_runListeners(_listeners, (0, $aa96917b132802ee$export$bb3c4bc1b1175d3d), _asyncNotifications, function(listener) {
                    listener[0, $aa96917b132802ee$export$bb3c4bc1b1175d3d /* @min:%2eeventsSent */ ](events);
                });
            };
            /**
             * Notification for events being discarded.
             * @param events - The array of events that have been discarded by the SDK.
             * @param reason - The reason for which the SDK discarded the events. The EventsDiscardedReason
             * constant should be used to check the different values.
             */ _self[0, $aa96917b132802ee$export$bacb5b2f4c1081b9 /* @min:%2eeventsDiscarded */ ] = function(events, reason) {
                $0dd57305094095f6$var$_runListeners(_listeners, (0, $aa96917b132802ee$export$bacb5b2f4c1081b9), _asyncNotifications, function(listener) {
                    listener[0, $aa96917b132802ee$export$bacb5b2f4c1081b9 /* @min:%2eeventsDiscarded */ ](events, reason);
                });
            };
            /**
             * [Optional] A function called when the events have been requested to be sent to the sever.
             * @param sendReason - The reason why the event batch is being sent.
             * @param isAsync - A flag which identifies whether the requests are being sent in an async or sync manner.
             */ _self[0, $aa96917b132802ee$export$d75e063cb88a1c25 /* @min:%2eeventsSendRequest */ ] = function(sendReason, isAsync) {
                $0dd57305094095f6$var$_runListeners(_listeners, (0, $aa96917b132802ee$export$d75e063cb88a1c25), isAsync ? _asyncNotifications : null, function(listener) {
                    listener[0, $aa96917b132802ee$export$d75e063cb88a1c25 /* @min:%2eeventsSendRequest */ ](sendReason, isAsync);
                });
            };
            _self[0, $aa96917b132802ee$export$5d265841733c97c3 /* @min:%2eperfEvent */ ] = function(perfEvent) {
                if (perfEvent) // Send all events or only parent events
                {
                    if (perfEvtsSendAll || !perfEvent[0, $45806013ed348c93$export$3a89026537e5dfec /* @min:%2eisChildEvt */ ]()) $0dd57305094095f6$var$_runListeners(_listeners, (0, $aa96917b132802ee$export$5d265841733c97c3), null, function(listener) {
                        if (perfEvent[0, $45806013ed348c93$export$d8114c9e990204cb /* @min:%2eisAsync */ ]) (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
                            return listener[0, $aa96917b132802ee$export$5d265841733c97c3 /* @min:%2eperfEvent */ ](perfEvent);
                        }, 0);
                        else listener[0, $aa96917b132802ee$export$5d265841733c97c3 /* @min:%2eperfEvent */ ](perfEvent);
                    });
                }
            };
            _self[0, $aa96917b132802ee$export$43f876a058c28ba5 /* @min:%2eofflineEventsStored */ ] = function(events) {
                if (events && events[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]) $0dd57305094095f6$var$_runListeners(_listeners, (0, $aa96917b132802ee$export$43f876a058c28ba5), _asyncNotifications, function(listener) {
                    listener[0, $aa96917b132802ee$export$43f876a058c28ba5 /* @min:%2eofflineEventsStored */ ](events);
                });
            };
            _self[0, $aa96917b132802ee$export$ae269b8bbb49e700 /* @min:%2eofflineBatchSent */ ] = function(batch) {
                if (batch && batch[0, $45806013ed348c93$export$2f5ff0b46814907e /* @min:%2edata */ ]) $0dd57305094095f6$var$_runListeners(_listeners, (0, $aa96917b132802ee$export$ae269b8bbb49e700), _asyncNotifications, function(listener) {
                    listener[0, $aa96917b132802ee$export$ae269b8bbb49e700 /* @min:%2eofflineBatchSent */ ](batch);
                });
            };
            _self[0, $aa96917b132802ee$export$38d218365ccbd2ec /* @min:%2eofflineBatchDrop */ ] = function(cnt, reason) {
                if (cnt > 0) {
                    var rn_1 = reason || 0; // default is unknown
                    $0dd57305094095f6$var$_runListeners(_listeners, (0, $aa96917b132802ee$export$38d218365ccbd2ec), _asyncNotifications, function(listener) {
                        listener[0, $aa96917b132802ee$export$38d218365ccbd2ec /* @min:%2eofflineBatchDrop */ ](cnt, rn_1);
                    });
                }
            };
            _self[0, $45806013ed348c93$export$7eb85b5cba77a43d /* @min:%2eunload */ ] = function(isAsync) {
                var _finishUnload = function() {
                    unloadHandler && unloadHandler.rm();
                    unloadHandler = null;
                    _listeners = [];
                    // Clear any async listener
                    _asyncNotifications.h && _asyncNotifications.h[0, $45806013ed348c93$export$bd01c5e3f12db01c /* @min:%2ecancel */ ]();
                    _asyncNotifications.h = null;
                    _asyncNotifications.cb = [];
                };
                var waiting;
                $0dd57305094095f6$var$_runListeners(_listeners, "unload", null, function(listener) {
                    var asyncUnload = listener[0, $45806013ed348c93$export$7eb85b5cba77a43d /* @min:%2eunload */ ](isAsync);
                    if (asyncUnload) {
                        if (!waiting) waiting = [];
                        waiting[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](asyncUnload);
                    }
                });
                if (waiting) return (0, $4121df0a705d038e$export$5a1eb20c68656e88)(function(resolve) {
                    return (0, $4121df0a705d038e$export$856fe465480fa77a)((0, $4121df0a705d038e$export$1ed2fd8fe9f5c6)(waiting), function() {
                        _finishUnload();
                        resolve();
                    });
                });
                else _finishUnload();
            };
        });
    }
    // Removed Stub for NotificationManager.prototype.addNotificationListener.
    // Removed Stub for NotificationManager.prototype.removeNotificationListener.
    // Removed Stub for NotificationManager.prototype.eventsSent.
    // Removed Stub for NotificationManager.prototype.eventsDiscarded.
    // Removed Stub for NotificationManager.prototype.eventsSendRequest.
    // Removed Stub for NotificationManager.prototype.perfEvent.
    // Removed Stub for NotificationManager.prototype.unload.
    // Removed Stub for NotificationManager.prototype.offlineEventsStored.
    // Removed Stub for NotificationManager.prototype.offlineBatchSent.
    // Removed Stub for NotificationManager.prototype.offlineBatchDrop.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    NotificationManager.__ieDyn = 1;
    return NotificationManager;
}();





/*
 * Application Insights JavaScript SDK - Core, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // 
// 








function $7b82afd5e1b31923$var$_addInitializer(_initializers, id, telemetryInitializer) {
    var theInitializer = {
        id: id,
        fn: telemetryInitializer
    };
    (0, $5831ddb3a0caf7c7$export$69c7b96f216fdf7b)(_initializers, theInitializer);
    var handler = {
        remove: function() {
            (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_initializers, function(initializer, idx) {
                if (initializer.id === theInitializer.id) {
                    _initializers[0, $45806013ed348c93$export$84020a2e4fe863b0 /* @min:%2esplice */ ](idx, 1);
                    return -1;
                }
            });
        }
    };
    return handler;
}
function $7b82afd5e1b31923$var$_runInitializers(_initializers, item, logger) {
    var doNotSendItem = false;
    var telemetryInitializersCount = _initializers[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
    for(var i = 0; i < telemetryInitializersCount; ++i){
        var telemetryInitializer = _initializers[i];
        if (telemetryInitializer) try {
            if (telemetryInitializer.fn[0, $45806013ed348c93$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](null, [
                item
            ]) === false) {
                doNotSendItem = true;
                break;
            }
        } catch (e) {
            // log error but dont stop executing rest of the telemetry initializers
            // doNotSendItem = true;
            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 64 /* _eInternalMessageId.TelemetryInitializerFailed */ , "Telemetry initializer failed: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
            }, true);
        }
    }
    return !doNotSendItem;
}
var $7b82afd5e1b31923$export$5da7f32cc3b89dc1 = /** @class */ function(_super) {
    (0, $dc463ff9724142dd$export$1f9c32e3fbfb8e62)(TelemetryInitializerPlugin, _super);
    function TelemetryInitializerPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = "TelemetryInitializerPlugin";
        _this.priority = 199;
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _id;
        var _initializers;
        _initDefaults();
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(TelemetryInitializerPlugin, _this, function(_self, _base) {
            _self.addTelemetryInitializer = function(telemetryInitializer) {
                return $7b82afd5e1b31923$var$_addInitializer(_initializers, _id++, telemetryInitializer);
            };
            _self[0, $aa96917b132802ee$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ] = function(item, itemCtx) {
                if ($7b82afd5e1b31923$var$_runInitializers(_initializers, item, itemCtx ? itemCtx[0, $45806013ed348c93$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]() : _self[0, $45806013ed348c93$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]())) _self[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](item, itemCtx);
            };
            _self[0, $45806013ed348c93$export$458d234b616d0745 /* @min:%2e_doTeardown */ ] = function() {
                _initDefaults();
            };
        });
        function _initDefaults() {
            _id = 0;
            _initializers = [];
        }
        return _this;
    }
    // Removed Stub for TelemetryInitializerPlugin.prototype.addTelemetryInitializer.
    // Removed Stub for TelemetryInitializerPlugin.prototype.processTelemetry.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    TelemetryInitializerPlugin.__ieDyn = 1;
    return TelemetryInitializerPlugin;
}((0, $dc0100a6f2a9749a$export$64a11c2f90e6766c));




"use strict";
var $125d8f3d04332ece$var$_a;
var $125d8f3d04332ece$var$strValidationError = "Plugins must provide initialize method";
var $125d8f3d04332ece$var$strNotificationManager = "_notificationManager";
var $125d8f3d04332ece$var$strSdkUnloadingError = "SDK is still unloading...";
var $125d8f3d04332ece$var$strSdkNotInitialized = "SDK is not initialized";
var $125d8f3d04332ece$var$maxInitQueueSize = 100;
var $125d8f3d04332ece$var$maxInitTimeout = 50000;
// const strPluginUnloadFailed = "Failed to unload plugin";
/**
 * The default settings for the config.
 * WE MUST include all defaults here to ensure that the config is created with all of the properties
 * defined as dynamic.
 */ var $125d8f3d04332ece$var$defaultConfig = (0, $5831ddb3a0caf7c7$export$a15782d21797da4c)(($125d8f3d04332ece$var$_a = {
    cookieCfg: {}
}, $125d8f3d04332ece$var$_a[0, $aa96917b132802ee$export$a077ce616a1ab4ee] = {
    rdOnly: true,
    ref: true,
    v: []
}, $125d8f3d04332ece$var$_a[0, $aa96917b132802ee$export$829012af4b2055a2] = {
    rdOnly: true,
    ref: true,
    v: []
}, $125d8f3d04332ece$var$_a[0, $aa96917b132802ee$export$ffb2356587263734] = {
    ref: true,
    v: {}
}, $125d8f3d04332ece$var$_a[0, $aa96917b132802ee$export$1cf3476332da55b3] = (0, $aa96917b132802ee$export$a43287864529b8fd), $125d8f3d04332ece$var$_a.loggingLevelConsole = 0 /* eLoggingSeverity.DISABLED */ , $125d8f3d04332ece$var$_a.diagnosticLogInterval = (0, $aa96917b132802ee$export$a43287864529b8fd), $125d8f3d04332ece$var$_a));
/**
 * Helper to create the default performance manager
 * @param core
 * @param notificationMgr
 */ function $125d8f3d04332ece$var$_createPerfManager(core, notificationMgr) {
    return new (0, $67947f06182dbd51$export$cbeb6df2e8e9b5ae)(notificationMgr);
}
function $125d8f3d04332ece$var$_validateExtensions(logger, channelPriority, allExtensions) {
    var _a;
    // Concat all available extensions
    var coreExtensions = [];
    var channels = [];
    // Check if any two extensions have the same priority, then warn to console
    // And extract the local extensions from the
    var extPriorities = {};
    // Extension validation
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(allExtensions, function(ext) {
        // Check for ext.initialize
        if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(ext) || (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(ext[0, $45806013ed348c93$export$65cd33bb52d04675 /* @min:%2einitialize */ ])) (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)($125d8f3d04332ece$var$strValidationError);
        var extPriority = ext[0, $aa96917b132802ee$export$58efcc07763b37be /* @min:%2epriority */ ];
        var identifier = ext[0, $45806013ed348c93$export$f001befbf8417151 /* @min:%2eidentifier */ ];
        if (ext && extPriority) {
            if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(extPriorities[extPriority])) (0, $bacca83328a730a7$export$25fb4cb97863f0a8)(logger, "Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
            else // set a value
            extPriorities[extPriority] = identifier;
        }
        // Split extensions to core and channels
        if (!extPriority || extPriority < channelPriority) // Add to core extension that will be managed by AppInsightsCore
        coreExtensions[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](ext);
        else channels[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](ext);
    });
    return _a = {}, _a[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:core */ ] = coreExtensions, _a[0, $aa96917b132802ee$export$829012af4b2055a2 /* @min:channels */ ] = channels, _a;
}
function $125d8f3d04332ece$var$_isPluginPresent(thePlugin, plugins) {
    var exists = false;
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(plugins, function(plugin) {
        if (plugin === thePlugin) {
            exists = true;
            return -1;
        }
    });
    return exists;
}
function $125d8f3d04332ece$var$_deepMergeConfig(details, target, newValues, merge) {
    // Lets assign the new values to the existing config
    if (newValues) (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(newValues, function(key, value) {
        if (merge) {
            if ((0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(value) && (0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(target[key])) // The target is an object and it has a value
            $125d8f3d04332ece$var$_deepMergeConfig(details, target[key], value, merge);
        }
        if (merge && (0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(value) && (0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(target[key])) // The target is an object and it has a value
        $125d8f3d04332ece$var$_deepMergeConfig(details, target[key], value, merge);
        else // Just Assign (replace) and/or make the property dynamic
        details.set(target, key, value);
    });
}
function $125d8f3d04332ece$var$_findWatcher(listeners, newWatcher) {
    var theListener = null;
    var idx = -1;
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(listeners, function(listener, lp) {
        if (listener.w === newWatcher) {
            theListener = listener;
            idx = lp;
            return -1;
        }
    });
    return {
        i: idx,
        l: theListener
    };
}
function $125d8f3d04332ece$var$_addDelayedCfgListener(listeners, newWatcher) {
    var theListener = $125d8f3d04332ece$var$_findWatcher(listeners, newWatcher).l;
    if (!theListener) {
        theListener = {
            w: newWatcher,
            rm: function() {
                var fnd = $125d8f3d04332ece$var$_findWatcher(listeners, newWatcher);
                if (fnd.i !== -1) listeners[0, $45806013ed348c93$export$84020a2e4fe863b0 /* @min:%2esplice */ ](fnd.i, 1);
            }
        };
        listeners[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](theListener);
    }
    return theListener;
}
function $125d8f3d04332ece$var$_registerDelayedCfgListener(config, listeners, logger) {
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(listeners, function(listener) {
        var unloadHdl = (0, $6387583e0b25820c$export$454a433e4deb244f)(config, listener.w, logger);
        delete listener.w; // Clear the listener reference so it will get garbage collected.
        // replace the remove function
        listener.rm = function() {
            unloadHdl.rm();
        };
    });
}
// Moved this outside of the closure to reduce the retained memory footprint
function $125d8f3d04332ece$var$_initDebugListener(configHandler, unloadContainer, notificationManager, debugListener) {
    // Will get recalled if any referenced config values are changed
    unloadContainer.add(configHandler[0, $45806013ed348c93$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](function(details) {
        var disableDbgExt = details.cfg.disableDbgExt;
        if (disableDbgExt === true && debugListener) {
            // Remove any previously loaded debug listener
            notificationManager[0, $45806013ed348c93$export$fc3403fa6f2894ab /* @min:%2eremoveNotificationListener */ ](debugListener);
            debugListener = null;
        }
        if (notificationManager && !debugListener && disableDbgExt !== true) {
            debugListener = (0, $2662e05d52c419bb$export$dae5ac50a0df0f5f)(details.cfg);
            notificationManager[0, $45806013ed348c93$export$5c8bcfab4f42ca62 /* @min:%2eaddNotificationListener */ ](debugListener);
        }
    }));
    return debugListener;
}
// Moved this outside of the closure to reduce the retained memory footprint
function $125d8f3d04332ece$var$_createUnloadHook(unloadHook) {
    return (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)({
        rm: function() {
            unloadHook.rm();
        }
    }, "toJSON", {
        v: function() {
            return "aicore::onCfgChange<" + JSON.stringify(unloadHook) + ">";
        }
    });
}
/**
 * @group Classes
 * @group Entrypoint
 */ var $125d8f3d04332ece$export$e7ac25a6828d23bf = /** @class */ function() {
    function AppInsightsCore() {
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _configHandler;
        var _isInitialized;
        var _logger;
        var _eventQueue;
        var _notificationManager;
        var _perfManager;
        var _cfgPerfManager;
        var _cookieManager;
        var _pluginChain;
        var _configExtensions;
        var _channelConfig;
        var _channels;
        var _isUnloading;
        var _telemetryInitializerPlugin;
        var _internalLogsEventName;
        var _evtNamespace;
        var _unloadHandlers;
        var _hookContainer;
        var _debugListener;
        var _traceCtx;
        var _instrumentationKey;
        var _cfgListeners;
        var _extensions;
        var _pluginVersionStringArr;
        var _pluginVersionString;
        var _activeStatus; // to indicate if ikey or endpoint url promised is resolved or not
        var _endpoint;
        var _initInMemoMaxSize; // max event count limit during wait for init promises to be resolved
        var _isStatusSet; // track if active status is set in case of init timeout and init promises setting the status twice
        var _initTimer;
        /**
         * Internal log poller
         */ var _internalLogPoller;
        var _internalLogPollerListening;
        var _forceStopInternalLogPoller;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(AppInsightsCore, this, function(_self) {
            // Set the default values (also called during teardown)
            _initDefaults();
            // Special internal method to allow the unit tests and DebugPlugin to hook embedded objects
            _self["_getDbgPlgTargets"] = function() {
                return [
                    _extensions,
                    _eventQueue
                ];
            };
            _self[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ] = function() {
                return _isInitialized;
            };
            // since version 3.3.0
            _self.activeStatus = function() {
                return _activeStatus;
            };
            // since version 3.3.0
            // internal
            _self._setPendingStatus = function() {
                _activeStatus = 3 /* eActiveStatus.PENDING */ ;
            };
            // Creating the self.initialize = ()
            _self[0, $45806013ed348c93$export$65cd33bb52d04675 /* @min:%2einitialize */ ] = function(config, extensions, logger, notificationManager) {
                if (_isUnloading) (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)($125d8f3d04332ece$var$strSdkUnloadingError);
                // Make sure core is only initialized once
                if (_self[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ]()) (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)("Core cannot be initialized more than once");
                _configHandler = (0, $6387583e0b25820c$export$3a9e9180c14487fd)(config, $125d8f3d04332ece$var$defaultConfig, logger || _self[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ], false);
                // Re-assigning the local config property so we don't have any references to the passed value and it can be garbage collected
                config = _configHandler.cfg;
                // This will be "re-run" if the referenced config properties are changed
                _addUnloadHook(_configHandler[0, $45806013ed348c93$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](function(details) {
                    var rootCfg = details.cfg;
                    var isPending = _activeStatus === 3 /* eActiveStatus.PENDING */ ;
                    if (isPending) // means waiting for previous promises to be resolved, won't apply new changes
                    return;
                    _initInMemoMaxSize = rootCfg.initInMemoMaxSize || $125d8f3d04332ece$var$maxInitQueueSize;
                    // app Insights core only handle ikey and endpointurl, aisku will handle cs
                    var ikey = rootCfg[0, $45806013ed348c93$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ];
                    var endpointUrl = rootCfg.endpointUrl; // do not need to validate endpoint url, if it is null, default one will be set by sender
                    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(ikey)) {
                        _instrumentationKey = null;
                        // if new ikey is null, set status to be inactive, all new events will be saved in memory or dropped
                        _activeStatus = (0, $452a7a5f1b634188$export$bc7f1ae22a2680b3)[0, $45806013ed348c93$export$9a6b45d6a80c20f2 /* @min:%2eINACTIVE */ ];
                        var msg = "Please provide instrumentation key";
                        if (!_isInitialized) // only throw error during initialization
                        (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)(msg);
                        else {
                            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 1 /* eLoggingSeverity.CRITICAL */ , 100 /* _eInternalMessageId.InvalidInstrumentationKey */ , msg);
                            _releaseQueues();
                        }
                        return;
                    }
                    var promises = [];
                    if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(ikey)) {
                        promises[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](ikey);
                        _instrumentationKey = null; // reset current local ikey variable (otherwise it will always be the previous ikeys if timeout is called before promise cb)
                    } else // string
                    _instrumentationKey = ikey;
                    if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(endpointUrl)) {
                        promises[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](endpointUrl);
                        _endpoint = null; // reset current local endpoint variable (otherwise it will always be the previous urls if timeout is called before promise cb)
                    } else // string or null
                    _endpoint = endpointUrl;
                    // at least have one promise
                    if (promises[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]) {
                        // reset to false for new dynamic changes
                        _isStatusSet = false;
                        _activeStatus = 3 /* eActiveStatus.PENDING */ ;
                        var initTimeout = (0, $ede407819d2d28c9$export$71fc1ee3e76bc1fe)(rootCfg.initTimeOut) ? rootCfg.initTimeOut : $125d8f3d04332ece$var$maxInitTimeout; // rootCfg.initTimeOut could be 0
                        var allPromises = (0, $4121df0a705d038e$export$c235d06856522848)(promises);
                        _initTimer = (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
                            // set _isStatusSet to true
                            // set active status
                            // release queues
                            _initTimer = null;
                            if (!_isStatusSet) _setStatus();
                        }, initTimeout);
                        (0, $4121df0a705d038e$export$856fe465480fa77a)(allPromises, function(response) {
                            try {
                                if (_isStatusSet) // promises take too long to resolve, ignore them
                                // active status should be set by timeout already
                                return;
                                if (!response.rejected) {
                                    var values = response[0, $45806013ed348c93$export$1805af0fa2230c20 /* @min:%2evalue */ ];
                                    if (values && values[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]) {
                                        // ikey
                                        var ikeyRes = values[0];
                                        _instrumentationKey = ikeyRes && ikeyRes[0, $45806013ed348c93$export$1805af0fa2230c20 /* @min:%2evalue */ ];
                                        // endpoint
                                        if (values[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 1) {
                                            var endpointRes = values[1];
                                            _endpoint = endpointRes && endpointRes[0, $45806013ed348c93$export$1805af0fa2230c20 /* @min:%2evalue */ ];
                                        }
                                    }
                                    if (_instrumentationKey) {
                                        // if ikey is null, no need to trigger extra dynamic changes for extensions
                                        config[0, $45806013ed348c93$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ] = _instrumentationKey; // set config.instrumentationKey for extensions to consume
                                        config.endpointUrl = _endpoint; // set config.endpointUrl for extensions to consume
                                    }
                                }
                                // set _isStatusSet to true
                                // set active status
                                // release queues
                                _setStatus();
                            } catch (e) {
                                if (!_isStatusSet) _setStatus();
                            }
                        });
                    } else // means no promises
                    _setStatus();
                    //_instrumentationKey = details.cfg.instrumentationKey;
                    // Mark the extensionConfig and all first level keys as referenced
                    // This is so that calls to getExtCfg() will always return the same object
                    // Even when a user may "re-assign" the plugin properties (or it's unloaded/reloaded)
                    var extCfg = details.ref(details.cfg, (0, $aa96917b132802ee$export$ffb2356587263734));
                    (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(extCfg, function(key) {
                        details.ref(extCfg, key);
                    });
                }));
                _notificationManager = notificationManager;
                // Initialize the debug listener outside of the closure to reduce the retained memory footprint
                _debugListener = $125d8f3d04332ece$var$_initDebugListener(_configHandler, _hookContainer, _notificationManager && _self[0, $45806013ed348c93$export$3a09068de032bb32 /* @min:%2egetNotifyMgr */ ](), _debugListener);
                _initPerfManager();
                _self[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ] = logger;
                var cfgExtensions = config[0, $aa96917b132802ee$export$a077ce616a1ab4ee /* @min:%2eextensions */ ];
                // Extension validation
                _configExtensions = [];
                _configExtensions[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ].apply(_configExtensions, (0, $dc463ff9724142dd$export$643fbb7023bc1942)((0, $dc463ff9724142dd$export$643fbb7023bc1942)([], extensions, false), cfgExtensions, false));
                _channelConfig = config[0, $aa96917b132802ee$export$829012af4b2055a2 /* @min:%2echannels */ ];
                _initPluginChain(null);
                if (!_channels || _channels[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] === 0) (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)("No " + (0, $aa96917b132802ee$export$829012af4b2055a2) + " available");
                if (_channelConfig && _channelConfig[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 1) {
                    var teeController = _self[0, $45806013ed348c93$export$37717a508eca6e2d /* @min:%2egetPlugin */ ]("TeeChannelController");
                    if (!teeController || !teeController.plugin) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 1 /* eLoggingSeverity.CRITICAL */ , 28 /* _eInternalMessageId.SenderNotInitialized */ , "TeeChannel required");
                }
                $125d8f3d04332ece$var$_registerDelayedCfgListener(config, _cfgListeners, _logger);
                _cfgListeners = null;
                _isInitialized = true;
                if (_activeStatus === (0, $452a7a5f1b634188$export$bc7f1ae22a2680b3).ACTIVE) _releaseQueues();
            };
            _self.getChannels = function() {
                var controls = [];
                if (_channels) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_channels, function(channel) {
                    controls[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](channel);
                });
                return (0, $5831ddb3a0caf7c7$export$5da24d7703175bc5)(controls);
            };
            _self.track = function(telemetryItem) {
                (0, $67947f06182dbd51$export$c6fbeb260600c482)(_self[0, $aa96917b132802ee$export$f8b08c7de64edfbf /* @min:%2egetPerfMgr */ ](), function() {
                    return "AppInsightsCore:track";
                }, function() {
                    if (telemetryItem === null) {
                        _notifyInvalidEvent(telemetryItem);
                        // throw error
                        (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)("Invalid telemetry item");
                    }
                    // do basic validation before sending it through the pipeline
                    if (!telemetryItem[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:%2ename */ ] && (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(telemetryItem[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:%2ename */ ])) {
                        _notifyInvalidEvent(telemetryItem);
                        (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)("telemetry name required");
                    }
                    // setup default iKey if not passed in
                    telemetryItem[0, $45806013ed348c93$export$3ea6750b8a852044 /* @min:%2eiKey */ ] = telemetryItem[0, $45806013ed348c93$export$3ea6750b8a852044 /* @min:%2eiKey */ ] || _instrumentationKey;
                    // add default timestamp if not passed in
                    telemetryItem[0, $45806013ed348c93$export$7b5ba5854159c1f0 /* @min:%2etime */ ] = telemetryItem[0, $45806013ed348c93$export$7b5ba5854159c1f0 /* @min:%2etime */ ] || (0, $ede407819d2d28c9$export$dfaaa8705752128f)(new Date());
                    // Common Schema 4.0
                    telemetryItem.ver = telemetryItem.ver || "4.0";
                    if (!_isUnloading && _self[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ]() && _activeStatus === (0, $452a7a5f1b634188$export$bc7f1ae22a2680b3).ACTIVE) // Process the telemetry plugin chain
                    _createTelCtx()[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](telemetryItem);
                    else if (_activeStatus !== (0, $452a7a5f1b634188$export$bc7f1ae22a2680b3)[0, $45806013ed348c93$export$9a6b45d6a80c20f2 /* @min:%2eINACTIVE */ ]) // Queue events until all extensions are initialized
                    {
                        if (_eventQueue[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] <= _initInMemoMaxSize) // set limit, if full, stop adding new events
                        _eventQueue[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](telemetryItem);
                    }
                }, function() {
                    return {
                        item: telemetryItem
                    };
                }, !telemetryItem.sync);
            };
            _self[0, $45806013ed348c93$export$474081342bc4baf4 /* @min:%2egetProcessTelContext */ ] = _createTelCtx;
            _self[0, $45806013ed348c93$export$3a09068de032bb32 /* @min:%2egetNotifyMgr */ ] = function() {
                if (!_notificationManager) {
                    _notificationManager = new (0, $0dd57305094095f6$export$dfa1f14b6290f8c5)(_configHandler.cfg);
                    // For backward compatibility only
                    _self[$125d8f3d04332ece$var$strNotificationManager] = _notificationManager;
                }
                return _notificationManager;
            };
            /**
             * Adds a notification listener. The SDK calls methods on the listener when an appropriate notification is raised.
             * The added plugins must raise notifications. If the plugins do not implement the notifications, then no methods will be
             * called.
             * @param listener - An INotificationListener object.
             */ _self[0, $45806013ed348c93$export$5c8bcfab4f42ca62 /* @min:%2eaddNotificationListener */ ] = function(listener) {
                _self.getNotifyMgr()[0, $45806013ed348c93$export$5c8bcfab4f42ca62 /* @min:%2eaddNotificationListener */ ](listener);
            };
            /**
             * Removes all instances of the listener.
             * @param listener - INotificationListener to remove.
             */ _self[0, $45806013ed348c93$export$fc3403fa6f2894ab /* @min:%2eremoveNotificationListener */ ] = function(listener) {
                if (_notificationManager) _notificationManager[0, $45806013ed348c93$export$fc3403fa6f2894ab /* @min:%2eremoveNotificationListener */ ](listener);
            };
            _self.getCookieMgr = function() {
                if (!_cookieManager) _cookieManager = (0, $aaa64f3935d14265$export$2ae082191ac44e5a)(_configHandler.cfg, _self[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ]);
                return _cookieManager;
            };
            _self.setCookieMgr = function(cookieMgr) {
                if (_cookieManager !== cookieMgr) {
                    (0, $59a25debd846dee6$export$86347c3dd68c03f6)(_cookieManager, false);
                    _cookieManager = cookieMgr;
                }
            };
            _self[0, $aa96917b132802ee$export$f8b08c7de64edfbf /* @min:%2egetPerfMgr */ ] = function() {
                return _perfManager || _cfgPerfManager || (0, $67947f06182dbd51$export$6cdbf3f34ace6568)();
            };
            _self.setPerfMgr = function(perfMgr) {
                _perfManager = perfMgr;
            };
            _self.eventCnt = function() {
                return _eventQueue[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
            };
            _self.releaseQueue = function() {
                if (_isInitialized && _eventQueue[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    var eventQueue = _eventQueue;
                    _eventQueue = [];
                    if (_activeStatus === 2 /* eActiveStatus.ACTIVE */ ) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(eventQueue, function(event) {
                        event[0, $45806013ed348c93$export$3ea6750b8a852044 /* @min:%2eiKey */ ] = event[0, $45806013ed348c93$export$3ea6750b8a852044 /* @min:%2eiKey */ ] || _instrumentationKey;
                        _createTelCtx()[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](event);
                    });
                    else // new one for msg ikey
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 20 /* _eInternalMessageId.FailedToSendQueuedTelemetry */ , "core init status is not active");
                }
            };
            _self[0, $45806013ed348c93$export$538c138266a38409 /* @min:%2epollInternalLogs */ ] = function(eventName) {
                _internalLogsEventName = eventName || null;
                _forceStopInternalLogPoller = false;
                _internalLogPoller && _internalLogPoller[0, $45806013ed348c93$export$bd01c5e3f12db01c /* @min:%2ecancel */ ]();
                return _startLogPoller(true);
            };
            function _setStatus() {
                _isStatusSet = true;
                if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_instrumentationKey)) {
                    _activeStatus = (0, $452a7a5f1b634188$export$bc7f1ae22a2680b3)[0, $45806013ed348c93$export$9a6b45d6a80c20f2 /* @min:%2eINACTIVE */ ];
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 1 /* eLoggingSeverity.CRITICAL */ , 112 /* _eInternalMessageId.InitPromiseException */ , "ikey can't be resolved from promises");
                } else _activeStatus = (0, $452a7a5f1b634188$export$bc7f1ae22a2680b3).ACTIVE;
                _releaseQueues();
            }
            function _releaseQueues() {
                if (_isInitialized) {
                    _self.releaseQueue();
                    _self[0, $45806013ed348c93$export$538c138266a38409 /* @min:%2epollInternalLogs */ ]();
                }
            }
            function _startLogPoller(alwaysStart) {
                if ((!_internalLogPoller || !_internalLogPoller[0, $45806013ed348c93$export$c9b1609f2b84393a /* @min:%2eenabled */ ]) && !_forceStopInternalLogPoller) {
                    var shouldStart = alwaysStart || _logger && _logger.queue[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0;
                    if (shouldStart) {
                        if (!_internalLogPollerListening) {
                            _internalLogPollerListening = true;
                            // listen for any configuration changes so that changes to the
                            // interval will cause the timer to be re-initialized
                            _addUnloadHook(_configHandler[0, $45806013ed348c93$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](function(details) {
                                var interval = details.cfg.diagnosticLogInterval;
                                if (!interval || !(interval > 0)) interval = 10000;
                                var isRunning = false;
                                if (_internalLogPoller) {
                                    // It was already created so remember it's running and cancel
                                    isRunning = _internalLogPoller[0, $45806013ed348c93$export$c9b1609f2b84393a /* @min:%2eenabled */ ];
                                    _internalLogPoller[0, $45806013ed348c93$export$bd01c5e3f12db01c /* @min:%2ecancel */ ]();
                                }
                                // Create / reconfigure
                                _internalLogPoller = (0, $5831ddb3a0caf7c7$export$6eae7cf7a129a986)(_flushInternalLogs, interval);
                                _internalLogPoller.unref();
                                // Restart if previously running
                                _internalLogPoller[0, $45806013ed348c93$export$c9b1609f2b84393a /* @min:%2eenabled */ ] = isRunning;
                            }));
                        }
                        _internalLogPoller[0, $45806013ed348c93$export$c9b1609f2b84393a /* @min:%2eenabled */ ] = true;
                    }
                }
                return _internalLogPoller;
            }
            _self[0, $45806013ed348c93$export$8d1c48dba7ad83a /* @min:%2estopPollingInternalLogs */ ] = function() {
                _forceStopInternalLogPoller = true;
                _internalLogPoller && _internalLogPoller[0, $45806013ed348c93$export$bd01c5e3f12db01c /* @min:%2ecancel */ ]();
                _flushInternalLogs();
            };
            // Add addTelemetryInitializer
            (0, $ede407819d2d28c9$export$94f4c7fb7e7d8dc7)(_self, function() {
                return _telemetryInitializerPlugin;
            }, [
                "addTelemetryInitializer"
            ]);
            _self[0, $45806013ed348c93$export$7eb85b5cba77a43d /* @min:%2eunload */ ] = function(isAsync, unloadComplete, cbTimeout) {
                var _a;
                if (isAsync === void 0) isAsync = true;
                if (!_isInitialized) // The SDK is not initialized
                (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)($125d8f3d04332ece$var$strSdkNotInitialized);
                // Check if the SDK still unloading so throw
                if (_isUnloading) // The SDK is already unloading
                (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)($125d8f3d04332ece$var$strSdkUnloadingError);
                var unloadState = (_a = {
                    reason: 50 /* TelemetryUnloadReason.SdkUnload */ 
                }, _a[0, $45806013ed348c93$export$d8114c9e990204cb /* @min:isAsync */ ] = isAsync, _a.flushComplete = false, _a);
                var result;
                if (isAsync && !unloadComplete) result = (0, $4121df0a705d038e$export$5a1eb20c68656e88)(function(resolve) {
                    // Set the callback to the promise resolve callback
                    unloadComplete = resolve;
                });
                var processUnloadCtx = (0, $21bc92e23804c647$export$91bbbd4999751948)(_getPluginChain(), _self);
                processUnloadCtx[0, $45806013ed348c93$export$8693bdba21bfca93 /* @min:%2eonComplete */ ](function() {
                    _hookContainer.run(_self[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ]);
                    // Run any "unload" functions for the _cookieManager, _notificationManager and _logger
                    (0, $59a25debd846dee6$export$bc81824d13c51ef3)([
                        _cookieManager,
                        _notificationManager,
                        _logger
                    ], isAsync, function() {
                        _initDefaults();
                        unloadComplete && unloadComplete(unloadState);
                    });
                }, _self);
                function _doUnload(flushComplete) {
                    unloadState.flushComplete = flushComplete;
                    _isUnloading = true;
                    // Run all of the unload handlers first (before unloading the plugins)
                    _unloadHandlers.run(processUnloadCtx, unloadState);
                    // Stop polling the internal logs
                    _self[0, $45806013ed348c93$export$8d1c48dba7ad83a /* @min:%2estopPollingInternalLogs */ ]();
                    // Start unloading the components, from this point onwards the SDK should be considered to be in an unstable state
                    processUnloadCtx[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](unloadState);
                }
                _flushInternalLogs();
                if (!_flushChannels(isAsync, _doUnload, 6 /* SendRequestReason.SdkUnload */ , cbTimeout)) _doUnload(false);
                return result;
            };
            _self[0, $45806013ed348c93$export$37717a508eca6e2d /* @min:%2egetPlugin */ ] = _getPlugin;
            _self.addPlugin = function(plugin, replaceExisting, isAsync, addCb) {
                if (!plugin) {
                    addCb && addCb(false);
                    _logOrThrowError($125d8f3d04332ece$var$strValidationError);
                    return;
                }
                var existingPlugin = _getPlugin(plugin[0, $45806013ed348c93$export$f001befbf8417151 /* @min:%2eidentifier */ ]);
                if (existingPlugin && !replaceExisting) {
                    addCb && addCb(false);
                    _logOrThrowError("Plugin [" + plugin[0, $45806013ed348c93$export$f001befbf8417151 /* @min:%2eidentifier */ ] + "] is already loaded!");
                    return;
                }
                var updateState = {
                    reason: 16 /* TelemetryUpdateReason.PluginAdded */ 
                };
                function _addPlugin(removed) {
                    _configExtensions[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](plugin);
                    updateState.added = [
                        plugin
                    ];
                    // Re-Initialize the plugin chain
                    _initPluginChain(updateState);
                    addCb && addCb(true);
                }
                if (existingPlugin) {
                    var removedPlugins_1 = [
                        existingPlugin.plugin
                    ];
                    var unloadState = {
                        reason: 2 /* TelemetryUnloadReason.PluginReplace */ ,
                        isAsync: !!isAsync
                    };
                    _removePlugins(removedPlugins_1, unloadState, function(removed) {
                        if (!removed) // Previous plugin was successfully removed or was not installed
                        addCb && addCb(false);
                        else {
                            updateState.removed = removedPlugins_1;
                            updateState.reason |= 32 /* TelemetryUpdateReason.PluginRemoved */ ;
                            _addPlugin(true);
                        }
                    });
                } else _addPlugin(false);
            };
            _self.updateCfg = function(newConfig, mergeExisting) {
                if (mergeExisting === void 0) mergeExisting = true;
                var updateState;
                if (_self[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ]()) {
                    updateState = {
                        reason: 1 /* TelemetryUpdateReason.ConfigurationChanged */ ,
                        cfg: _configHandler.cfg,
                        oldCfg: (0, $5831ddb3a0caf7c7$export$54e9fb29908872fa)({}, _configHandler.cfg),
                        newConfig: (0, $5831ddb3a0caf7c7$export$54e9fb29908872fa)({}, newConfig),
                        merge: mergeExisting
                    };
                    newConfig = updateState.newConfig;
                    var cfg = _configHandler.cfg;
                    // replace the immutable (if initialized) values
                    // We don't currently allow updating the extensions and channels via the update config
                    // So overwriting any user provided values to reuse the existing values
                    newConfig[0, $aa96917b132802ee$export$a077ce616a1ab4ee /* @min:%2eextensions */ ] = cfg[0, $aa96917b132802ee$export$a077ce616a1ab4ee /* @min:%2eextensions */ ];
                    newConfig[0, $aa96917b132802ee$export$829012af4b2055a2 /* @min:%2echannels */ ] = cfg[0, $aa96917b132802ee$export$829012af4b2055a2 /* @min:%2echannels */ ];
                }
                // Explicitly blocking any previous config watchers so that they don't get called because
                // of this bulk update (Probably not necessary)
                _configHandler._block(function(details) {
                    // Lets assign the new values to the existing config either overwriting or re-assigning
                    var theConfig = details.cfg;
                    $125d8f3d04332ece$var$_deepMergeConfig(details, theConfig, newConfig, mergeExisting);
                    if (!mergeExisting) // Remove (unassign) the values "missing" from the newConfig and also not in the default config
                    (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(theConfig, function(key) {
                        if (!(0, $5831ddb3a0caf7c7$export$34e6b98f73578a9c)(newConfig, key)) // Set the value to undefined
                        details.set(theConfig, key, (0, $aa96917b132802ee$export$a43287864529b8fd));
                    });
                    // Apply defaults to the new config
                    details[0, $45806013ed348c93$export$24caac6d68ff1537 /* @min:%2esetDf */ ](theConfig, $125d8f3d04332ece$var$defaultConfig);
                }, true);
                // Now execute all of the listeners (synchronously) so they update their values immediately
                _configHandler[0, $45806013ed348c93$export$6c2b24c6eee14c46 /* @min:%2enotify */ ]();
                if (updateState) _doUpdate(updateState);
            };
            _self.evtNamespace = function() {
                return _evtNamespace;
            };
            _self.flush = _flushChannels;
            _self.getTraceCtx = function(createNew) {
                if (!_traceCtx) _traceCtx = (0, $e144361666ed071d$export$10fa4480433f402c)();
                return _traceCtx;
            };
            _self.setTraceCtx = function(traceCtx) {
                _traceCtx = traceCtx || null;
            };
            _self.addUnloadHook = _addUnloadHook;
            // Create the addUnloadCb
            (0, $ede407819d2d28c9$export$5dd8d245f6f94a18)(_self, "addUnloadCb", function() {
                return _unloadHandlers;
            }, "add");
            _self.onCfgChange = function(handler) {
                var unloadHook;
                if (!_isInitialized) unloadHook = $125d8f3d04332ece$var$_addDelayedCfgListener(_cfgListeners, handler);
                else unloadHook = (0, $6387583e0b25820c$export$454a433e4deb244f)(_configHandler.cfg, handler, _self[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ]);
                return $125d8f3d04332ece$var$_createUnloadHook(unloadHook);
            };
            _self.getWParam = function() {
                return (0, $5831ddb3a0caf7c7$export$c4372eca9c56fe99)() || !!_configHandler.cfg.enableWParam ? 0 : -1;
            };
            function _setPluginVersions() {
                var thePlugins = {};
                _pluginVersionStringArr = [];
                var _addPluginVersions = function(plugins) {
                    if (plugins) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(plugins, function(plugin) {
                        if (plugin[0, $45806013ed348c93$export$f001befbf8417151 /* @min:%2eidentifier */ ] && plugin[0, $45806013ed348c93$export$568c4302d11f2b22 /* @min:%2eversion */ ] && !thePlugins[plugin.identifier]) {
                            var ver = plugin[0, $45806013ed348c93$export$f001befbf8417151 /* @min:%2eidentifier */ ] + "=" + plugin[0, $45806013ed348c93$export$568c4302d11f2b22 /* @min:%2eversion */ ];
                            _pluginVersionStringArr[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](ver);
                            thePlugins[plugin.identifier] = plugin;
                        }
                    });
                };
                _addPluginVersions(_channels);
                if (_channelConfig) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_channelConfig, function(channels) {
                    _addPluginVersions(channels);
                });
                _addPluginVersions(_configExtensions);
            }
            function _initDefaults() {
                _isInitialized = false;
                // Use a default logger so initialization errors are not dropped on the floor with full logging
                _configHandler = (0, $6387583e0b25820c$export$3a9e9180c14487fd)({}, $125d8f3d04332ece$var$defaultConfig, _self[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ]);
                // Set the logging level to critical so that any critical initialization failures are displayed on the console
                _configHandler.cfg[0, $45806013ed348c93$export$e53d8cae4d527530 /* @min:%2eloggingLevelConsole */ ] = 1 /* eLoggingSeverity.CRITICAL */ ;
                // Define _self.config
                (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "config", {
                    g: function() {
                        return _configHandler.cfg;
                    },
                    s: function(newValue) {
                        _self.updateCfg(newValue, false);
                    }
                });
                (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "pluginVersionStringArr", {
                    g: function() {
                        if (!_pluginVersionStringArr) _setPluginVersions();
                        return _pluginVersionStringArr;
                    }
                });
                (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "pluginVersionString", {
                    g: function() {
                        if (!_pluginVersionString) {
                            if (!_pluginVersionStringArr) _setPluginVersions();
                            _pluginVersionString = _pluginVersionStringArr.join(";");
                        }
                        return _pluginVersionString || (0, $aa96917b132802ee$export$5e8607ab26634759);
                    }
                });
                (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "logger", {
                    g: function() {
                        if (!_logger) {
                            _logger = new (0, $bacca83328a730a7$export$4f80edb2e10dc14c)(_configHandler.cfg);
                            _configHandler[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ] = _logger;
                        }
                        return _logger;
                    },
                    s: function(newLogger) {
                        _configHandler[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ] = newLogger;
                        if (_logger !== newLogger) {
                            (0, $59a25debd846dee6$export$86347c3dd68c03f6)(_logger, false);
                            _logger = newLogger;
                        }
                    }
                });
                _self[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ] = new (0, $bacca83328a730a7$export$4f80edb2e10dc14c)(_configHandler.cfg);
                _extensions = [];
                var cfgExtensions = _self.config[0, $aa96917b132802ee$export$a077ce616a1ab4ee /* @min:%2eextensions */ ] || [];
                cfgExtensions.splice(0, cfgExtensions[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]);
                (0, $5831ddb3a0caf7c7$export$69c7b96f216fdf7b)(cfgExtensions, _extensions);
                _telemetryInitializerPlugin = new (0, $7b82afd5e1b31923$export$5da7f32cc3b89dc1)();
                _eventQueue = [];
                (0, $59a25debd846dee6$export$86347c3dd68c03f6)(_notificationManager, false);
                _notificationManager = null;
                _perfManager = null;
                _cfgPerfManager = null;
                (0, $59a25debd846dee6$export$86347c3dd68c03f6)(_cookieManager, false);
                _cookieManager = null;
                _pluginChain = null;
                _configExtensions = [];
                _channelConfig = null;
                _channels = null;
                _isUnloading = false;
                _internalLogsEventName = null;
                _evtNamespace = (0, $0e058b881c0798ff$export$eb4a6badb18ead04)("AIBaseCore", true);
                _unloadHandlers = (0, $0af4a0f2b45a17f9$export$1dd1604aeaf8cfed)();
                _traceCtx = null;
                _instrumentationKey = null;
                _hookContainer = (0, $10c5f1b2f69c7ec4$export$31fa167f9d342989)();
                _cfgListeners = [];
                _pluginVersionString = null;
                _pluginVersionStringArr = null;
                _forceStopInternalLogPoller = false;
                _internalLogPoller = null;
                _internalLogPollerListening = false;
                _activeStatus = 0 /* eActiveStatus.NONE */ ; // default is None
                _endpoint = null;
                _initInMemoMaxSize = null;
                _isStatusSet = false;
                _initTimer = null;
            }
            function _createTelCtx() {
                var theCtx = (0, $21bc92e23804c647$export$ca98f11e981bcfd6)(_getPluginChain(), _configHandler.cfg, _self);
                theCtx[0, $45806013ed348c93$export$8693bdba21bfca93 /* @min:%2eonComplete */ ](_startLogPoller);
                return theCtx;
            }
            // Initialize or Re-initialize the plugins
            function _initPluginChain(updateState) {
                // Extension validation
                var theExtensions = $125d8f3d04332ece$var$_validateExtensions(_self[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ], (0, $585383ffe353022e$export$a1373ad9f192f374), _configExtensions);
                _pluginChain = null;
                _pluginVersionString = null;
                _pluginVersionStringArr = null;
                // Get the primary channel queue and include as part of the normal extensions
                _channels = (_channelConfig || [])[0] || [];
                // Add any channels provided in the extensions and sort them
                _channels = (0, $e144361666ed071d$export$478771939b7b39a2)((0, $5831ddb3a0caf7c7$export$69c7b96f216fdf7b)(_channels, theExtensions[0, $aa96917b132802ee$export$829012af4b2055a2 /* @min:%2echannels */ ]));
                // Create an array of all extensions, including the _channels
                var allExtensions = (0, $5831ddb3a0caf7c7$export$69c7b96f216fdf7b)((0, $e144361666ed071d$export$478771939b7b39a2)(theExtensions[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ]), _channels);
                // Required to allow plugins to call core.getPlugin() during their own initialization
                _extensions = (0, $5831ddb3a0caf7c7$export$5da24d7703175bc5)(allExtensions);
                // This has a side effect of adding the extensions passed during initialization
                // into the config.extensions, so you can see all of the extensions loaded.
                // This will also get updated by the addPlugin() and remove plugin code.
                var cfgExtensions = _self.config[0, $aa96917b132802ee$export$a077ce616a1ab4ee /* @min:%2eextensions */ ] || [];
                cfgExtensions.splice(0, cfgExtensions[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]);
                (0, $5831ddb3a0caf7c7$export$69c7b96f216fdf7b)(cfgExtensions, _extensions);
                var rootCtx = _createTelCtx();
                // Initializing the channels first
                if (_channels && _channels[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) (0, $e144361666ed071d$export$be211df7b1eeb33e)(rootCtx[0, $45806013ed348c93$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ](_channels), allExtensions);
                // Now initialize the normal extensions (explicitly not including the _channels as this can cause duplicate initialization)
                (0, $e144361666ed071d$export$be211df7b1eeb33e)(rootCtx, allExtensions);
                if (updateState) _doUpdate(updateState);
            }
            function _getPlugin(pluginIdentifier) {
                var theExt = null;
                var thePlugin = null;
                var channelHosts = [];
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_extensions, function(ext) {
                    if (ext[0, $45806013ed348c93$export$f001befbf8417151 /* @min:%2eidentifier */ ] === pluginIdentifier && ext !== _telemetryInitializerPlugin) {
                        thePlugin = ext;
                        return -1;
                    }
                    if (ext.getChannel) channelHosts[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](ext);
                });
                if (!thePlugin && channelHosts[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(channelHosts, function(host) {
                    thePlugin = host.getChannel(pluginIdentifier);
                    if (!thePlugin) return -1;
                });
                if (thePlugin) theExt = {
                    plugin: thePlugin,
                    setEnabled: function(enabled) {
                        (0, $e144361666ed071d$export$37cfaecb9b4b1b3b)(thePlugin)[0, $aa96917b132802ee$export$49e9417944569ae8] = !enabled;
                    },
                    isEnabled: function() {
                        var pluginState = (0, $e144361666ed071d$export$37cfaecb9b4b1b3b)(thePlugin);
                        return !pluginState[0, $45806013ed348c93$export$7176fb2a7d11927e /* @min:%2eteardown */ ] && !pluginState[0, $aa96917b132802ee$export$49e9417944569ae8];
                    },
                    remove: function(isAsync, removeCb) {
                        var _a;
                        if (isAsync === void 0) isAsync = true;
                        var pluginsToRemove = [
                            thePlugin
                        ];
                        var unloadState = (_a = {
                            reason: 1 /* TelemetryUnloadReason.PluginUnload */ 
                        }, _a[0, $45806013ed348c93$export$d8114c9e990204cb /* @min:isAsync */ ] = isAsync, _a);
                        _removePlugins(pluginsToRemove, unloadState, function(removed) {
                            if (removed) // Re-Initialize the plugin chain
                            _initPluginChain({
                                reason: 32 /* TelemetryUpdateReason.PluginRemoved */ ,
                                removed: pluginsToRemove
                            });
                            removeCb && removeCb(removed);
                        });
                    }
                };
                return theExt;
            }
            function _getPluginChain() {
                if (!_pluginChain) {
                    // copy the collection of extensions
                    var extensions = (_extensions || []).slice();
                    // During add / remove this may get called again, so don't read if already present
                    if ((0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(extensions, _telemetryInitializerPlugin) === -1) extensions[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](_telemetryInitializerPlugin);
                    _pluginChain = (0, $21bc92e23804c647$export$107e639207cdf742)((0, $e144361666ed071d$export$478771939b7b39a2)(extensions), _configHandler.cfg, _self);
                }
                return _pluginChain;
            }
            function _removePlugins(thePlugins, unloadState, removeComplete) {
                if (thePlugins && thePlugins[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    var unloadChain = (0, $21bc92e23804c647$export$107e639207cdf742)(thePlugins, _configHandler.cfg, _self);
                    var unloadCtx = (0, $21bc92e23804c647$export$91bbbd4999751948)(unloadChain, _self);
                    unloadCtx[0, $45806013ed348c93$export$8693bdba21bfca93 /* @min:%2eonComplete */ ](function() {
                        var removed = false;
                        // Remove the listed config extensions
                        var newConfigExtensions = [];
                        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_configExtensions, function(plugin, idx) {
                            if (!$125d8f3d04332ece$var$_isPluginPresent(plugin, thePlugins)) newConfigExtensions[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](plugin);
                            else removed = true;
                        });
                        _configExtensions = newConfigExtensions;
                        _pluginVersionString = null;
                        _pluginVersionStringArr = null;
                        // Re-Create the channel config
                        var newChannelConfig = [];
                        if (_channelConfig) {
                            (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_channelConfig, function(queue, idx) {
                                var newQueue = [];
                                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(queue, function(channel) {
                                    if (!$125d8f3d04332ece$var$_isPluginPresent(channel, thePlugins)) newQueue[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](channel);
                                    else removed = true;
                                });
                                newChannelConfig[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](newQueue);
                            });
                            _channelConfig = newChannelConfig;
                        }
                        removeComplete && removeComplete(removed);
                        _startLogPoller();
                    });
                    unloadCtx[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](unloadState);
                } else removeComplete(false);
            }
            function _flushInternalLogs() {
                if (_logger && _logger.queue) {
                    var queue = _logger.queue.slice(0);
                    _logger.queue[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] = 0;
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(queue, function(logMessage) {
                        var _a;
                        var item = (_a = {}, _a[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:name */ ] = _internalLogsEventName ? _internalLogsEventName : "InternalMessageId: " + logMessage[0, $45806013ed348c93$export$2cc5b49df2eed261 /* @min:%2emessageId */ ], _a[0, $45806013ed348c93$export$3ea6750b8a852044 /* @min:iKey */ ] = _instrumentationKey, _a[0, $45806013ed348c93$export$7b5ba5854159c1f0 /* @min:time */ ] = (0, $ede407819d2d28c9$export$dfaaa8705752128f)(new Date()), _a.baseType = (0, $bacca83328a730a7$export$70ef838ed08aad47).dataType, _a.baseData = {
                            message: logMessage[0, $45806013ed348c93$export$923606b70907833e /* @min:%2emessage */ ]
                        }, _a);
                        _self.track(item);
                    });
                }
            }
            function _flushChannels(isAsync, callBack, sendReason, cbTimeout) {
                // Setting waiting to one so that we don't call the callBack until we finish iterating
                var waiting = 1;
                var doneIterating = false;
                var cbTimer = null;
                cbTimeout = cbTimeout || 5000;
                function doCallback() {
                    waiting--;
                    if (doneIterating && waiting === 0) {
                        cbTimer && cbTimer[0, $45806013ed348c93$export$bd01c5e3f12db01c /* @min:%2ecancel */ ]();
                        cbTimer = null;
                        callBack && callBack(doneIterating);
                        callBack = null;
                    }
                }
                if (_channels && _channels[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    var flushCtx = _createTelCtx()[0, $45806013ed348c93$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ](_channels);
                    flushCtx.iterate(function(plugin) {
                        if (plugin.flush) {
                            waiting++;
                            var handled_1 = false;
                            // Not all channels will call this callback for every scenario
                            if (!plugin.flush(isAsync, function() {
                                handled_1 = true;
                                doCallback();
                            }, sendReason)) {
                                if (!handled_1) {
                                    // If any channel doesn't return true and it didn't call the callback, then we should assume that the callback
                                    // will never be called, so use a timeout to allow the channel(s) some time to "finish" before triggering any
                                    // followup function (such as unloading)
                                    if (isAsync && cbTimer == null) cbTimer = (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
                                        cbTimer = null;
                                        doCallback();
                                    }, cbTimeout);
                                    else doCallback();
                                }
                            }
                        }
                    });
                }
                doneIterating = true;
                doCallback();
                return true;
            }
            function _initPerfManager() {
                // Save the previous config based performance manager creator to avoid creating new perf manager instances if unchanged
                var prevCfgPerfMgr;
                // Will get recalled if any referenced config values are changed
                _addUnloadHook(_configHandler[0, $45806013ed348c93$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](function(details) {
                    var enablePerfMgr = details.cfg.enablePerfMgr;
                    if (enablePerfMgr) {
                        var createPerfMgr = details.cfg[0, $aa96917b132802ee$export$1cf3476332da55b3 /* @min:%2ecreatePerfMgr */ ];
                        if (prevCfgPerfMgr !== createPerfMgr) {
                            if (!createPerfMgr) createPerfMgr = $125d8f3d04332ece$var$_createPerfManager;
                            // Set the performance manager creation function if not defined
                            (0, $ede407819d2d28c9$export$51417ccc212471e)(details.cfg, (0, $aa96917b132802ee$export$1cf3476332da55b3), createPerfMgr);
                            prevCfgPerfMgr = createPerfMgr;
                            // Remove any existing config based performance manager
                            _cfgPerfManager = null;
                        }
                        // Only create the performance manager if it's not already created or manually set
                        if (!_perfManager && !_cfgPerfManager && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(createPerfMgr)) // Create a new config based performance manager
                        _cfgPerfManager = createPerfMgr(_self, _self[0, $45806013ed348c93$export$3a09068de032bb32 /* @min:%2egetNotifyMgr */ ]());
                    } else {
                        // Remove any existing config based performance manager
                        _cfgPerfManager = null;
                        // Clear the previous cached value so it can be GC'd
                        prevCfgPerfMgr = null;
                    }
                }));
            }
            function _doUpdate(updateState) {
                var updateCtx = (0, $21bc92e23804c647$export$e4c32b40c4fbf98a)(_getPluginChain(), _self);
                updateCtx[0, $45806013ed348c93$export$8693bdba21bfca93 /* @min:%2eonComplete */ ](_startLogPoller);
                if (!_self._updateHook || _self._updateHook(updateCtx, updateState) !== true) updateCtx[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](updateState);
            }
            function _logOrThrowError(message) {
                var logger = _self[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ];
                if (logger) {
                    // there should always be a logger
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 73 /* _eInternalMessageId.PluginException */ , message);
                    _startLogPoller();
                } else (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)(message);
            }
            function _notifyInvalidEvent(telemetryItem) {
                var manager = _self[0, $45806013ed348c93$export$3a09068de032bb32 /* @min:%2egetNotifyMgr */ ]();
                if (manager) manager[0, $aa96917b132802ee$export$bacb5b2f4c1081b9 /* @min:%2eeventsDiscarded */ ]([
                    telemetryItem
                ], 2 /* eEventsDiscardedReason.InvalidEvent */ );
            }
            function _addUnloadHook(hooks) {
                _hookContainer.add(hooks);
            }
        });
    }
    // Removed Stub for AppInsightsCore.prototype.initialize.
    // Removed Stub for AppInsightsCore.prototype.getChannels.
    // Removed Stub for AppInsightsCore.prototype.track.
    // Removed Stub for AppInsightsCore.prototype.getProcessTelContext.
    // Removed Stub for AppInsightsCore.prototype.getNotifyMgr.
    // Removed Stub for AppInsightsCore.prototype.addNotificationListener.
    // Removed Stub for AppInsightsCore.prototype.removeNotificationListener.
    // Removed Stub for AppInsightsCore.prototype.getCookieMgr.
    // Removed Stub for AppInsightsCore.prototype.setCookieMgr.
    // Removed Stub for AppInsightsCore.prototype.getPerfMgr.
    // Removed Stub for AppInsightsCore.prototype.setPerfMgr.
    // Removed Stub for AppInsightsCore.prototype.eventCnt.
    // Removed Stub for AppInsightsCore.prototype.pollInternalLogs.
    // Removed Stub for AppInsightsCore.prototype.stopPollingInternalLogs.
    // Removed Stub for AppInsightsCore.prototype.addTelemetryInitializer.
    // Removed Stub for AppInsightsCore.prototype.unload.
    // Removed Stub for AppInsightsCore.prototype.getPlugin.
    // Removed Stub for AppInsightsCore.prototype.addPlugin.
    // Removed Stub for AppInsightsCore.prototype.updateCfg.
    // Removed Stub for AppInsightsCore.prototype.evtNamespace.
    // Removed Stub for AppInsightsCore.prototype.addUnloadCb.
    // Removed Stub for AppInsightsCore.prototype.flush.
    // Removed Stub for AppInsightsCore.prototype.getTraceCtx.
    // Removed Stub for AppInsightsCore.prototype.setTraceCtx.
    // Removed Stub for AppInsightsCore.prototype.addUnloadHook.
    // Removed Stub for AppInsightsCore.prototype.onCfgChange.
    // Removed Stub for AppInsightsCore.prototype.activeStatus.
    // Removed Stub for AppInsightsCore.prototype._setPendingStatus.
    // Removed Stub for AppInsightsCore.prototype.releaseQueue.
    // Removed Stub for AppInsightsCore.prototype._updateHook.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    AppInsightsCore.__ieDyn = 1;
    return AppInsightsCore;
}();


/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var $8291b597e9a6dfe3$export$be41298b7716c698 = "duration";
var $8291b597e9a6dfe3$export$400e70f2a2ecb5aa = "properties";


/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $83680ca0bbc253cc$export$8ff033ecd75b66c3 = "requestUrl"; // Count: 11
var $83680ca0bbc253cc$export$25a34734290022f3 = "inst"; // Count: 5
var $83680ca0bbc253cc$export$6eae51590aaea43 = "length"; // Count: 8
var $83680ca0bbc253cc$export$a5eb52c53bba8560 = "traceID"; // Count: 9
var $83680ca0bbc253cc$export$c105b94efa183847 = "spanID"; // Count: 8
var $83680ca0bbc253cc$export$4e92e4b92b41ba2d = "traceFlags"; // Count: 13
var $83680ca0bbc253cc$export$fdcd48959e13aba7 = "context"; // Count: 7
var $83680ca0bbc253cc$export$fcf18cee9ee41961 = "aborted"; // Count: 7
var $83680ca0bbc253cc$export$f8d9e07631527156 = "traceId"; // Count: 5
var $83680ca0bbc253cc$export$e39be82dc519c4ae = "spanId"; // Count: 5
var $83680ca0bbc253cc$export$3b3afe26ca0e015c = "_addHook"; // Count: 4
var $83680ca0bbc253cc$export$f9ae8d0acf86503e = "core"; // Count: 8
var $83680ca0bbc253cc$export$ec2c4b7da1ef8dd0 = "includeCorrelationHeaders"; // Count: 4
var $83680ca0bbc253cc$export$de5be3709039b9b0 = "getAbsoluteUrl"; // Count: 3
var $83680ca0bbc253cc$export$829ed22a43b4aada = "headers"; // Count: 6
var $83680ca0bbc253cc$export$b58618e731cdb301 = "requestHeaders"; // Count: 13
var $83680ca0bbc253cc$export$84ecd29f369f5b1d = "setRequestHeader"; // Count: 3
var $83680ca0bbc253cc$export$2aa2820bfe761f5b = "trackDependencyDataInternal"; // Count: 2
var $83680ca0bbc253cc$export$69cac26425c8ea23 = "startTime"; // Count: 6
var $83680ca0bbc253cc$export$e4eaee9e01d9baaa = "toLowerCase"; // Count: 6
var $83680ca0bbc253cc$export$abc5bbd8bd54996a = "enableRequestHeaderTracking"; // Count: 3
var $83680ca0bbc253cc$export$928b837287a09b1f = "enableAjaxErrorStatusText"; // Count: 2
var $83680ca0bbc253cc$export$a2e6a87e51acdf74 = "enableAjaxPerfTracking"; // Count: 2
var $83680ca0bbc253cc$export$8e8c994d518b7819 = "maxAjaxCallsPerView"; // Count: 2
var $83680ca0bbc253cc$export$e4bbd5d3fe5db54b = "excludeRequestFromAutoTrackingPatterns"; // Count: 2
var $83680ca0bbc253cc$export$e9d1b90025f35753 = "addRequestContext"; // Count: 2
var $83680ca0bbc253cc$export$1b35c99ae5c93631 = "disableAjaxTracking"; // Count: 3
var $83680ca0bbc253cc$export$990dec05286abf9b = "ajaxPerfLookupDelay"; // Count: 2
var $83680ca0bbc253cc$export$391aca270631e029 = "disableFetchTracking"; // Count: 2
var $83680ca0bbc253cc$export$21cd44ec55cfc0f9 = "enableResponseHeaderTracking"; // Count: 2
var $83680ca0bbc253cc$export$f8d169088a01f6f2 = "status"; // Count: 11
var $83680ca0bbc253cc$export$e44f43b238a0c7f0 = "statusText"; // Count: 9
var $83680ca0bbc253cc$export$422ea83a60e3414b = "headerMap"; // Count: 8
var $83680ca0bbc253cc$export$9984940f44bb6769 = "openDone"; // Count: 3
var $83680ca0bbc253cc$export$ebd7b63f645a373e = "sendDone"; // Count: 3
var $83680ca0bbc253cc$export$b3507d39ae3f3e22 = "requestSentTime"; // Count: 9
var $83680ca0bbc253cc$export$dda6370f5a5c9f36 = "abortDone"; // Count: 3
var $83680ca0bbc253cc$export$90dab0fe9b2b7158 = "getTraceId"; // Count: 3
var $83680ca0bbc253cc$export$1fd22cf8d803736f = "getTraceFlags"; // Count: 3
var $83680ca0bbc253cc$export$47d30bd816d62bdc = "method"; // Count: 8
var $83680ca0bbc253cc$export$cce28811c9041832 = "errorStatusText"; // Count: 3
var $83680ca0bbc253cc$export$99588eb1c78d46e0 = "stateChangeAttached"; // Count: 2
var $83680ca0bbc253cc$export$d9f76b3afffa4e88 = "responseText"; // Count: 6
var $83680ca0bbc253cc$export$e52fa892d403cac3 = "responseFinishedTime"; // Count: 7
var $83680ca0bbc253cc$export$e31aceb60e1b3a1a = "CreateTrackItem"; // Count: 3
var $83680ca0bbc253cc$export$71a9f4a2e496846d = "response"; // Count: 4
var $83680ca0bbc253cc$export$121ad73699ff0814 = "getAllResponseHeaders"; // Count: 2
var $83680ca0bbc253cc$export$e2e640c31408a88f = "getPartAProps"; // Count: 3
var $83680ca0bbc253cc$export$9e85e7b326182790 = "perfMark"; // Count: 4
var $83680ca0bbc253cc$export$9734b0a24bf02e93 = "name"; // Count: 6
var $83680ca0bbc253cc$export$6bec4987b5d3526c = "perfTiming"; // Count: 3
var $83680ca0bbc253cc$export$4852fd87b68a6e1f = "exception"; // Count: 5
var $83680ca0bbc253cc$export$c9bea9d79dd8e37a = "ajaxDiagnosticsMessage"; // Count: 3
var $83680ca0bbc253cc$export$c4a9b5c39c7409f7 = "correlationContext"; // Count: 3
var $83680ca0bbc253cc$export$7820e90f0eaab413 = "ajaxTotalDuration"; // Count: 3
var $83680ca0bbc253cc$export$c050ff25390a2bce = "eventTraceCtx"; // Count: 3


/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




/** @ignore */ function $48c7b9d8e3de1826$var$_calcPerfDuration(resourceEntry, start, end) {
    var result = 0;
    var from = resourceEntry[start];
    var to = resourceEntry[end];
    if (from && to) result = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(from, to);
    return result;
}
/** @ignore */ function $48c7b9d8e3de1826$var$_setPerfDuration(props, name, resourceEntry, start, end) {
    var result = 0;
    var value = $48c7b9d8e3de1826$var$_calcPerfDuration(resourceEntry, start, end);
    if (value) result = $48c7b9d8e3de1826$var$_setPerfValue(props, name, (0, $7c0ecef5df4b34f7$export$4460ed97e7c4a927)(value));
    return result;
}
/** @ignore */ function $48c7b9d8e3de1826$var$_setPerfValue(props, name, value) {
    var strPerf = "ajaxPerf";
    var result = 0;
    if (props && name && value) {
        var perfData = props[strPerf] = props[strPerf] || {};
        perfData[name] = value;
        result = 1;
    }
    return result;
}
/** @ignore */ function $48c7b9d8e3de1826$var$_populatePerfData(ajaxData, dependency) {
    /*
    * https://developer.mozilla.org/en-US/docs/Web/API/Resource_Timing_API/Using_the_Resource_Timing_API
    *  | -startTime
    *  | -redirectStart
    *  |            | -redirectEnd
    *  |            | | -fetchStart
    *  |            | |   | -domainLookupStart
    *  |            | |   |                |- domainLookupEnd
    *  |            | |   |                | | -connectStart
    *  |            | |   |                | |  | -secureConnectionStart
    *  |            | |   |                | |  |        | -connectEnd
    *  |            | |   |                | |  |        | | -requestStart
    *  |            | |   |                | |  |        | |           | | -responseStart
    *  |            | |   |                | |  |        | |           | |            | | -responseEnd
    *  +------------+-+---+----------------+-+--+--------+-+-----------+-+------------+-+
    *  |--redirect--| |---|--domainLookup--| |--connect--| |--request--| |--response--| |
    *  |-------------------networkConnect----------------|
    *  |                                                   |---------sentRequest--------|
    *  |------------------------------------perfTotal-----------------------------------|
    */ var resourceEntry = ajaxData[0, $83680ca0bbc253cc$export$6bec4987b5d3526c /* @min:%2eperfTiming */ ];
    var props = dependency[0, $8291b597e9a6dfe3$export$400e70f2a2ecb5aa /* @min:%2eproperties */ ] || {};
    var propsSet = 0;
    var strName = "name";
    var strStart = "Start";
    var strEnd = "End";
    var strDomainLookup = "domainLookup";
    var strConnect = "connect";
    var strRedirect = "redirect";
    var strRequest = "request";
    var strResponse = "response";
    var strStartTime = "startTime";
    var strDomainLookupStart = strDomainLookup + strStart;
    var strDomainLookupEnd = strDomainLookup + strEnd;
    var strConnectStart = strConnect + strStart;
    var strConnectEnd = strConnect + strEnd;
    var strRequestStart = strRequest + strStart;
    var strRequestEnd = strRequest + strEnd;
    var strResponseStart = strResponse + strStart;
    var strResponseEnd = strResponse + strEnd;
    var strRedirectStart = strRedirect + strStart;
    var strRedirectEnd = strRedirect = strEnd;
    var strTransferSize = "transferSize";
    var strEncodedBodySize = "encodedBodySize";
    var strDecodedBodySize = "decodedBodySize";
    var strServerTiming = "serverTiming";
    if (resourceEntry) {
        // redirect
        propsSet |= $48c7b9d8e3de1826$var$_setPerfDuration(props, strRedirect, resourceEntry, strRedirectStart, strRedirectEnd);
        // domainLookup
        propsSet |= $48c7b9d8e3de1826$var$_setPerfDuration(props, strDomainLookup, resourceEntry, strDomainLookupStart, strDomainLookupEnd);
        // connect
        propsSet |= $48c7b9d8e3de1826$var$_setPerfDuration(props, strConnect, resourceEntry, strConnectStart, strConnectEnd);
        // request
        propsSet |= $48c7b9d8e3de1826$var$_setPerfDuration(props, strRequest, resourceEntry, strRequestStart, strRequestEnd);
        // response
        propsSet |= $48c7b9d8e3de1826$var$_setPerfDuration(props, strResponse, resourceEntry, strResponseStart, strResponseEnd);
        // Network connection time
        propsSet |= $48c7b9d8e3de1826$var$_setPerfDuration(props, "networkConnect", resourceEntry, strStartTime, strConnectEnd);
        // Sent Request
        propsSet |= $48c7b9d8e3de1826$var$_setPerfDuration(props, "sentRequest", resourceEntry, strRequestStart, strResponseEnd);
        // PerfTotal / Duration
        var duration = resourceEntry[0, $8291b597e9a6dfe3$export$be41298b7716c698 /* @min:%2eduration */ ];
        if (!duration) duration = $48c7b9d8e3de1826$var$_calcPerfDuration(resourceEntry, strStartTime, strResponseEnd) || 0;
        propsSet |= $48c7b9d8e3de1826$var$_setPerfValue(props, (0, $8291b597e9a6dfe3$export$be41298b7716c698), duration);
        propsSet |= $48c7b9d8e3de1826$var$_setPerfValue(props, "perfTotal", duration);
        var serverTiming = resourceEntry[strServerTiming];
        if (serverTiming) {
            var server_1 = {};
            (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(serverTiming, function(value, idx) {
                var name = (0, $ede407819d2d28c9$export$f60443f194e40bc2)(value[strName] || "" + idx);
                var newValue = server_1[name] || {};
                (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(value, function(key, val) {
                    if (key !== strName && (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(val) || (0, $5831ddb3a0caf7c7$export$7e4aa119212bc614)(val)) {
                        if (newValue[key]) val = newValue[key] + ";" + val;
                        if (val || !(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(val)) // Only set the value if it has a value and it's not an empty string
                        newValue[key] = val;
                    }
                });
                server_1[name] = newValue;
            });
            propsSet |= $48c7b9d8e3de1826$var$_setPerfValue(props, strServerTiming, server_1);
        }
        propsSet |= $48c7b9d8e3de1826$var$_setPerfValue(props, strTransferSize, resourceEntry[strTransferSize]);
        propsSet |= $48c7b9d8e3de1826$var$_setPerfValue(props, strEncodedBodySize, resourceEntry[strEncodedBodySize]);
        propsSet |= $48c7b9d8e3de1826$var$_setPerfValue(props, strDecodedBodySize, resourceEntry[strDecodedBodySize]);
    } else if (ajaxData[0, $83680ca0bbc253cc$export$9e85e7b326182790 /* @min:%2eperfMark */ ]) propsSet |= $48c7b9d8e3de1826$var$_setPerfValue(props, "missing", ajaxData.perfAttempts);
    if (propsSet) dependency[0, $8291b597e9a6dfe3$export$400e70f2a2ecb5aa /* @min:%2eproperties */ ] = props;
}
var $48c7b9d8e3de1826$export$79f098456caec6e7 = /** @class */ function() {
    function XHRMonitoringState() {
        var self = this;
        self[0, $83680ca0bbc253cc$export$9984940f44bb6769 /* @min:%2eopenDone */ ] = false;
        self.setRequestHeaderDone = false;
        self[0, $83680ca0bbc253cc$export$ebd7b63f645a373e /* @min:%2esendDone */ ] = false;
        self[0, $83680ca0bbc253cc$export$dda6370f5a5c9f36 /* @min:%2eabortDone */ ] = false;
        // <summary>True, if onreadyStateChangeCallback function attached to xhr, otherwise false</summary>
        self[0, $83680ca0bbc253cc$export$99588eb1c78d46e0 /* @min:%2estateChangeAttached */ ] = false;
    }
    return XHRMonitoringState;
}();
var $48c7b9d8e3de1826$export$3391d178758cbbb1 = /** @class */ function() {
    function ajaxRecord(traceId, spanId, logger, traceCtx) {
        var _a;
        var self = this;
        var _logger = logger;
        var strResponseText = "responseText";
        // Assigning the initial/default values within the constructor to avoid typescript from creating a bunch of
        // this.XXXX = null
        self[0, $83680ca0bbc253cc$export$9e85e7b326182790 /* @min:%2eperfMark */ ] = null;
        self.completed = false;
        self.requestHeadersSize = null;
        self[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ] = null;
        self.responseReceivingDuration = null;
        self.callbackDuration = null;
        self[0, $83680ca0bbc253cc$export$7820e90f0eaab413 /* @min:%2eajaxTotalDuration */ ] = null;
        self[0, $83680ca0bbc253cc$export$fcf18cee9ee41961 /* @min:%2eaborted */ ] = 0;
        self.pageUrl = null;
        self[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] = null;
        self.requestSize = 0;
        self[0, $83680ca0bbc253cc$export$47d30bd816d62bdc /* @min:%2emethod */ ] = null;
        self[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ] = null;
        self[0, $83680ca0bbc253cc$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ] = null;
        self.responseStartedTime = null;
        self[0, $83680ca0bbc253cc$export$e52fa892d403cac3 /* @min:%2eresponseFinishedTime */ ] = null;
        self.callbackFinishedTime = null;
        self.endTime = null;
        self.xhrMonitoringState = new $48c7b9d8e3de1826$export$79f098456caec6e7();
        self.clientFailure = 0;
        self[0, $83680ca0bbc253cc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ] = traceId;
        self[0, $83680ca0bbc253cc$export$c105b94efa183847 /* @min:%2espanID */ ] = spanId;
        self[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] = traceCtx === null || traceCtx === void 0 ? void 0 : traceCtx.getTraceFlags();
        if (traceCtx) self[0, $83680ca0bbc253cc$export$c050ff25390a2bce /* @min:%2eeventTraceCtx */ ] = (_a = {}, _a[0, $83680ca0bbc253cc$export$f8d9e07631527156 /* @min:traceId */ ] = traceCtx[0, $83680ca0bbc253cc$export$90dab0fe9b2b7158 /* @min:%2egetTraceId */ ](), _a[0, $83680ca0bbc253cc$export$e39be82dc519c4ae /* @min:spanId */ ] = traceCtx.getSpanId(), _a[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:traceFlags */ ] = traceCtx[0, $83680ca0bbc253cc$export$1fd22cf8d803736f /* @min:%2egetTraceFlags */ ](), _a);
        else self[0, $83680ca0bbc253cc$export$c050ff25390a2bce /* @min:%2eeventTraceCtx */ ] = null;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(ajaxRecord, self, function(self) {
            self.getAbsoluteUrl = function() {
                return self[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] ? (0, $b5e9e2ed66fb6b5a$export$a98678973ebe2123)(self[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ]) : null;
            };
            self.getPathName = function() {
                return self[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] ? (0, $3ad7e6398fcf0cbb$export$356146502a9f860c)(_logger, (0, $b5e9e2ed66fb6b5a$export$b959f3bc0a239498)(self[0, $83680ca0bbc253cc$export$47d30bd816d62bdc /* @min:%2emethod */ ], self[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ])) : null;
            };
            self[0, $83680ca0bbc253cc$export$e31aceb60e1b3a1a /* @min:%2eCreateTrackItem */ ] = function(ajaxType, enableRequestHeaderTracking, getResponse) {
                var _a;
                // round to 3 decimal points
                self.ajaxTotalDuration = Math.round((0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(self.requestSentTime, self.responseFinishedTime) * 1000) / 1000;
                if (self[0, $83680ca0bbc253cc$export$7820e90f0eaab413 /* @min:%2eajaxTotalDuration */ ] < 0) return null;
                var dependency = (_a = {
                    id: "|" + self[0, $83680ca0bbc253cc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ] + "." + self[0, $83680ca0bbc253cc$export$c105b94efa183847 /* @min:%2espanID */ ],
                    target: self[0, $83680ca0bbc253cc$export$de5be3709039b9b0 /* @min:%2egetAbsoluteUrl */ ]()
                }, _a[0, $83680ca0bbc253cc$export$9734b0a24bf02e93 /* @min:name */ ] = self.getPathName(), _a.type = ajaxType, _a[0, $83680ca0bbc253cc$export$69cac26425c8ea23 /* @min:startTime */ ] = null, _a.duration = self[0, $83680ca0bbc253cc$export$7820e90f0eaab413 /* @min:%2eajaxTotalDuration */ ], _a.success = +self[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ] >= 200 && +self[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ] < 400, _a.responseCode = +self[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ], _a[0, $8291b597e9a6dfe3$export$400e70f2a2ecb5aa] = {
                    HttpMethod: self[0, $83680ca0bbc253cc$export$47d30bd816d62bdc /* @min:%2emethod */ ]
                }, _a);
                var props = dependency[0, $8291b597e9a6dfe3$export$400e70f2a2ecb5aa];
                if (self[0, $83680ca0bbc253cc$export$fcf18cee9ee41961 /* @min:%2eaborted */ ]) props[0, $83680ca0bbc253cc$export$fcf18cee9ee41961 /* @min:%2eaborted */ ] = true;
                if (self[0, $83680ca0bbc253cc$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ]) {
                    // Set the correct dependency start time
                    dependency[0, $83680ca0bbc253cc$export$69cac26425c8ea23 /* @min:%2estartTime */ ] = new Date();
                    dependency[0, $83680ca0bbc253cc$export$69cac26425c8ea23 /* @min:%2estartTime */ ].setTime(self[0, $83680ca0bbc253cc$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ]);
                }
                // Add Ajax perf details if available
                $48c7b9d8e3de1826$var$_populatePerfData(self, dependency);
                if (enableRequestHeaderTracking) {
                    if ((0, $5831ddb3a0caf7c7$export$f7628dc18f4211e5)(self.requestHeaders)[0, $83680ca0bbc253cc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) props[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ] = self[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ];
                }
                if (getResponse) {
                    var response = getResponse();
                    if (response) {
                        // enrich dependency target with correlation context from the server
                        var correlationContext = response[0, $83680ca0bbc253cc$export$c4a9b5c39c7409f7 /* @min:%2ecorrelationContext */ ];
                        if (correlationContext) dependency.correlationContext = /* dependency.target + " | " + */ correlationContext;
                        if (response[0, $83680ca0bbc253cc$export$422ea83a60e3414b /* @min:%2eheaderMap */ ]) {
                            if ((0, $5831ddb3a0caf7c7$export$f7628dc18f4211e5)(response.headerMap)[0, $83680ca0bbc253cc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) props.responseHeaders = response[0, $83680ca0bbc253cc$export$422ea83a60e3414b /* @min:%2eheaderMap */ ];
                        }
                        if (self[0, $83680ca0bbc253cc$export$cce28811c9041832 /* @min:%2eerrorStatusText */ ]) {
                            if (self[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ] >= 400) {
                                var responseType = response.type;
                                if (responseType === "" || responseType === "text") props.responseText = response.responseText ? response[0, $83680ca0bbc253cc$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ] + " - " + response[strResponseText] : response[0, $83680ca0bbc253cc$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ];
                                if (responseType === "json") props.responseText = response.response ? response[0, $83680ca0bbc253cc$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ] + " - " + JSON.stringify(response[0, $83680ca0bbc253cc$export$71a9f4a2e496846d /* @min:%2eresponse */ ]) : response[0, $83680ca0bbc253cc$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ];
                            } else if (self[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ] === 0) props.responseText = response[0, $83680ca0bbc253cc$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ] || "";
                        }
                    }
                }
                return dependency;
            };
            self[0, $83680ca0bbc253cc$export$e2e640c31408a88f /* @min:%2egetPartAProps */ ] = function() {
                var _a;
                var partA = null;
                var traceCtx = self[0, $83680ca0bbc253cc$export$c050ff25390a2bce /* @min:%2eeventTraceCtx */ ];
                if (traceCtx && (traceCtx[0, $83680ca0bbc253cc$export$f8d9e07631527156 /* @min:%2etraceId */ ] || traceCtx[0, $83680ca0bbc253cc$export$e39be82dc519c4ae /* @min:%2espanId */ ])) {
                    partA = {};
                    var traceExt = partA[(0, $6e37c6a219f9960f$export$152f4bb29f8263d0).TraceExt] = (_a = {}, _a[0, $83680ca0bbc253cc$export$a5eb52c53bba8560 /* @min:traceID */ ] = traceCtx[0, $83680ca0bbc253cc$export$f8d9e07631527156 /* @min:%2etraceId */ ], _a.parentID = traceCtx[0, $83680ca0bbc253cc$export$e39be82dc519c4ae /* @min:%2espanId */ ], _a);
                    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(traceCtx[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ])) traceExt[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] = traceCtx[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ];
                }
                return partA;
            };
        });
    }
    // Removed Stub for ajaxRecord.prototype.getAbsoluteUrl.
    // Removed Stub for ajaxRecord.prototype.getPathName.
    // Removed Stub for ajaxRecord.prototype.CreateTrackItem.
    // Removed Stub for ajaxRecord.prototype.getPartAProps.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    ajaxRecord.__ieDyn = 1;
    return ajaxRecord;
}();


var $fa5a8e720c6a6dfc$var$_a;
var $fa5a8e720c6a6dfc$var$AJAX_MONITOR_PREFIX = "ai.ajxmn.";
var $fa5a8e720c6a6dfc$var$strDiagLog = "diagLog";
var $fa5a8e720c6a6dfc$var$AJAX_DATA_CONTAINER = "_ajaxData";
var $fa5a8e720c6a6dfc$var$STR_FETCH = "fetch";
var $fa5a8e720c6a6dfc$var$ERROR_HEADER = "Failed to monitor XMLHttpRequest";
var $fa5a8e720c6a6dfc$var$ERROR_PREFIX = ", monitoring data for this ajax call ";
var $fa5a8e720c6a6dfc$var$ERROR_POSTFIX = $fa5a8e720c6a6dfc$var$ERROR_PREFIX + "may be incorrect.";
var $fa5a8e720c6a6dfc$var$ERROR_NOT_SENT = $fa5a8e720c6a6dfc$var$ERROR_PREFIX + "won't be sent.";
var $fa5a8e720c6a6dfc$var$CORRELATION_HEADER_ERROR = "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.";
var $fa5a8e720c6a6dfc$var$CUSTOM_REQUEST_CONTEXT_ERROR = "Failed to add custom defined request context as configured call back may missing a null check.";
var $fa5a8e720c6a6dfc$var$FAILED_TO_CALCULATE_DURATION_ERROR = "Failed to calculate the duration of the ";
// Using a global value so that to handle same iKey with multiple app insights instances (mostly for testing)
var $fa5a8e720c6a6dfc$var$_markCount = 0;
/** @Ignore */ function $fa5a8e720c6a6dfc$var$_supportsFetch() {
    var _global = (0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)();
    if (!_global || (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_global.Request) || (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_global.Request[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049]) || (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_global[$fa5a8e720c6a6dfc$var$STR_FETCH])) return null;
    return _global[$fa5a8e720c6a6dfc$var$STR_FETCH];
}
/**
 * Determines whether ajax monitoring can be enabled on this document
 * @returns True if Ajax monitoring is supported on this page, otherwise false
 * @ignore
 */ function $fa5a8e720c6a6dfc$var$_supportsAjaxMonitoring(ajaxMonitorInstance, ajaxDataId) {
    var _a, _b;
    var result = false;
    if ((0, $0d2c2fb24388dcf8$export$cfeac9aa070f0108)()) {
        var proto = XMLHttpRequest[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049];
        result = !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(proto) && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(proto.open) && // eslint-disable-line security/detect-non-literal-fs-filename -- false positive
        !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(proto.send) && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(proto.abort);
    }
    var ieVer = (0, $0d2c2fb24388dcf8$export$eb7ff627fa81c42e)();
    if (ieVer && ieVer < 9) result = false;
    if (result) // Disable if the XmlHttpRequest can't be extended or hooked
    try {
        var xhr = new XMLHttpRequest();
        var xhrData = {
            xh: [],
            i: (_a = {}, _a[ajaxDataId] = {}, _a)
        };
        xhr[$fa5a8e720c6a6dfc$var$AJAX_DATA_CONTAINER] = xhrData;
        // Check that we can update the prototype
        var theOpen = XMLHttpRequest[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049].open;
        XMLHttpRequest[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049].open = theOpen;
    } catch (e) {
        // We can't decorate the xhr object so disable monitoring
        result = false;
        $fa5a8e720c6a6dfc$var$_throwInternalCritical(ajaxMonitorInstance, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , "Failed to enable XMLHttpRequest monitoring, extension is not supported", (_b = {}, _b[0, $83680ca0bbc253cc$export$4852fd87b68a6e1f /* @min:exception */ ] = (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e), _b));
    }
    return result;
}
/**
 * Internal helper to fetch the SDK instance tracking data for this XHR request
 * @param xhr
 * @param ajaxDataId
 * @returns
 */ var $fa5a8e720c6a6dfc$var$_getAjaxData = function(xhr, ajaxDataId) {
    if (xhr && ajaxDataId && xhr[$fa5a8e720c6a6dfc$var$AJAX_DATA_CONTAINER]) return (xhr[$fa5a8e720c6a6dfc$var$AJAX_DATA_CONTAINER].i || {})[ajaxDataId];
    return null;
};
/**
 * @ignore
 * Internal helper to track the singleton shared tracking headers, so we can attempt to not create headers
 * that might cause an issue if multiple values are populated.
 * @param xhr - The instrumented XHR instance
 */ var $fa5a8e720c6a6dfc$var$_addSharedXhrHeaders = function(xhr, name, value) {
    if (xhr) {
        var headers = (xhr[$fa5a8e720c6a6dfc$var$AJAX_DATA_CONTAINER] || {}).xh;
        if (headers) headers.push({
            n: name,
            v: value
        });
    }
};
var $fa5a8e720c6a6dfc$var$_isHeaderSet = function(xhr, name) {
    var isPresent = false;
    if (xhr) {
        var headers = (xhr[$fa5a8e720c6a6dfc$var$AJAX_DATA_CONTAINER] || {}).xh;
        if (headers) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(headers, function(header) {
            if (header.n === name) {
                isPresent = true;
                return -1;
            }
        });
    }
    return isPresent;
};
/** @Ignore */ function $fa5a8e720c6a6dfc$var$_getFailedAjaxDiagnosticsMessage(xhr, ajaxDataId) {
    var result = "";
    try {
        var ajaxData = $fa5a8e720c6a6dfc$var$_getAjaxData(xhr, ajaxDataId);
        if (ajaxData && ajaxData[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ]) result += "(url: '" + ajaxData[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] + "')";
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
    return result;
}
/** @ignore */ function $fa5a8e720c6a6dfc$var$_throwInternalCritical(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(ajaxMonitorInstance[$fa5a8e720c6a6dfc$var$strDiagLog](), 1 /* eLoggingSeverity.CRITICAL */ , msgId, message, properties, isUserAct);
}
/** @ignore */ function $fa5a8e720c6a6dfc$var$_throwInternalWarning(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(ajaxMonitorInstance[$fa5a8e720c6a6dfc$var$strDiagLog](), 2 /* eLoggingSeverity.WARNING */ , msgId, message, properties, isUserAct);
}
/** @Ignore */ function $fa5a8e720c6a6dfc$var$_createErrorCallbackFunc(ajaxMonitorInstance, internalMessage, message) {
    // tslint:disable-next-line
    return function(callDetails) {
        var _a;
        $fa5a8e720c6a6dfc$var$_throwInternalCritical(ajaxMonitorInstance, internalMessage, message, (_a = {
            ajaxDiagnosticsMessage: $fa5a8e720c6a6dfc$var$_getFailedAjaxDiagnosticsMessage(callDetails[0, $83680ca0bbc253cc$export$25a34734290022f3 /* @min:%2einst */ ], ajaxMonitorInstance._ajaxDataId)
        }, _a[0, $83680ca0bbc253cc$export$4852fd87b68a6e1f /* @min:exception */ ] = (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(callDetails.err), _a));
    };
}
function $fa5a8e720c6a6dfc$var$_indexOf(value, match) {
    if (value && match) return (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(value, match);
    return -1;
}
function $fa5a8e720c6a6dfc$var$_addHandler(container, id, theFunc) {
    var theHandler = {
        id: id,
        fn: theFunc
    };
    container.push(theHandler);
    return {
        remove: function() {
            (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(container, function(initializer, idx) {
                if (initializer.id === theHandler.id) {
                    container.splice(idx, 1);
                    return -1;
                }
            });
        }
    };
}
function $fa5a8e720c6a6dfc$var$_processDependencyContainer(core, container, details, message) {
    var result = true;
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(container, function(theFunc, idx) {
        try {
            if (theFunc.fn.call(null, details) === false) result = false;
        } catch (e) {
            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(core && core.logger, 1 /* eLoggingSeverity.CRITICAL */ , 64 /* _eInternalMessageId.TelemetryInitializerFailed */ , "Dependency " + message + " [#" + idx + "] failed: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
            }, true);
        }
    });
    return result;
}
function $fa5a8e720c6a6dfc$var$_processDependencyListeners(listeners, core, ajaxData, xhr, input, init) {
    var _a;
    var initializersCount = listeners[0, $83680ca0bbc253cc$export$6eae51590aaea43 /* @min:%2elength */ ];
    if (initializersCount > 0) {
        var details = (_a = {}, _a[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:core */ ] = core, _a.xhr = xhr, _a.input = input, _a.init = init, _a.traceId = ajaxData[0, $83680ca0bbc253cc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ], _a.spanId = ajaxData[0, $83680ca0bbc253cc$export$c105b94efa183847 /* @min:%2espanID */ ], _a.traceFlags = ajaxData[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ], _a.context = ajaxData[0, $83680ca0bbc253cc$export$fdcd48959e13aba7 /* @min:%2econtext */ ] || {}, _a.aborted = !!ajaxData[0, $83680ca0bbc253cc$export$fcf18cee9ee41961 /* @min:%2eaborted */ ], _a);
        $fa5a8e720c6a6dfc$var$_processDependencyContainer(core, listeners, details, "listener");
        ajaxData[0, $83680ca0bbc253cc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ] = details[0, $83680ca0bbc253cc$export$f8d9e07631527156 /* @min:%2etraceId */ ];
        ajaxData[0, $83680ca0bbc253cc$export$c105b94efa183847 /* @min:%2espanID */ ] = details[0, $83680ca0bbc253cc$export$e39be82dc519c4ae /* @min:%2espanId */ ];
        ajaxData[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] = details[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ];
        ajaxData[0, $83680ca0bbc253cc$export$fdcd48959e13aba7 /* @min:%2econtext */ ] = details[0, $83680ca0bbc253cc$export$fdcd48959e13aba7 /* @min:%2econtext */ ];
    }
}
var $fa5a8e720c6a6dfc$var$BLOB_CORE = "*.blob.core.";
var $fa5a8e720c6a6dfc$export$ae1f7dcb3278b8bb = (0, $5831ddb3a0caf7c7$export$5da24d7703175bc5)([
    $fa5a8e720c6a6dfc$var$BLOB_CORE + "windows.net",
    $fa5a8e720c6a6dfc$var$BLOB_CORE + "chinacloudapi.cn",
    $fa5a8e720c6a6dfc$var$BLOB_CORE + "cloudapi.de",
    $fa5a8e720c6a6dfc$var$BLOB_CORE + "usgovcloudapi.net"
]);
var $fa5a8e720c6a6dfc$var$_internalExcludeEndpoints = [
    /https:\/\/[^\/]*(\.pipe\.aria|aria\.pipe|events\.data|collector\.azure)\.[^\/]+\/(OneCollector\/1|Collector\/3)\.0/i
];
var $fa5a8e720c6a6dfc$var$_defaultConfig = (0, $5831ddb3a0caf7c7$export$5da24d7703175bc5)(($fa5a8e720c6a6dfc$var$_a = {}, $fa5a8e720c6a6dfc$var$_a[0, $83680ca0bbc253cc$export$8e8c994d518b7819 /* @min:maxAjaxCallsPerView */ ] = 500, $fa5a8e720c6a6dfc$var$_a[0, $83680ca0bbc253cc$export$1b35c99ae5c93631 /* @min:disableAjaxTracking */ ] = false, $fa5a8e720c6a6dfc$var$_a[0, $83680ca0bbc253cc$export$391aca270631e029 /* @min:disableFetchTracking */ ] = false, $fa5a8e720c6a6dfc$var$_a[0, $83680ca0bbc253cc$export$e4bbd5d3fe5db54b /* @min:excludeRequestFromAutoTrackingPatterns */ ] = undefined, $fa5a8e720c6a6dfc$var$_a.disableCorrelationHeaders = false, $fa5a8e720c6a6dfc$var$_a.distributedTracingMode = 1 /* eDistributedTracingModes.AI_AND_W3C */ , $fa5a8e720c6a6dfc$var$_a.correlationHeaderExcludedDomains = $fa5a8e720c6a6dfc$export$ae1f7dcb3278b8bb, $fa5a8e720c6a6dfc$var$_a.correlationHeaderDomains = undefined, $fa5a8e720c6a6dfc$var$_a.correlationHeaderExcludePatterns = undefined, $fa5a8e720c6a6dfc$var$_a.appId = undefined, $fa5a8e720c6a6dfc$var$_a.enableCorsCorrelation = false, $fa5a8e720c6a6dfc$var$_a[0, $83680ca0bbc253cc$export$abc5bbd8bd54996a /* @min:enableRequestHeaderTracking */ ] = false, $fa5a8e720c6a6dfc$var$_a[0, $83680ca0bbc253cc$export$21cd44ec55cfc0f9 /* @min:enableResponseHeaderTracking */ ] = false, $fa5a8e720c6a6dfc$var$_a[0, $83680ca0bbc253cc$export$928b837287a09b1f /* @min:enableAjaxErrorStatusText */ ] = false, $fa5a8e720c6a6dfc$var$_a[0, $83680ca0bbc253cc$export$a2e6a87e51acdf74 /* @min:enableAjaxPerfTracking */ ] = false, $fa5a8e720c6a6dfc$var$_a.maxAjaxPerfLookupAttempts = 3, $fa5a8e720c6a6dfc$var$_a[0, $83680ca0bbc253cc$export$990dec05286abf9b /* @min:ajaxPerfLookupDelay */ ] = 25, $fa5a8e720c6a6dfc$var$_a.ignoreHeaders = [
    "Authorization",
    "X-API-Key",
    "WWW-Authenticate"
], $fa5a8e720c6a6dfc$var$_a[0, $83680ca0bbc253cc$export$e9d1b90025f35753 /* @min:addRequestContext */ ] = undefined, $fa5a8e720c6a6dfc$var$_a.addIntEndpoints = true, $fa5a8e720c6a6dfc$var$_a));
var $fa5a8e720c6a6dfc$export$d9a50c4d1eb2475f = /** @class */ function(_super) {
    (0, $dc463ff9724142dd$export$1f9c32e3fbfb8e62)(AjaxMonitor, _super);
    function AjaxMonitor() {
        var _this = _super.call(this) || this;
        _this.identifier = AjaxMonitor.identifier;
        _this.priority = 120;
        var _fetchInitialized; // fetch monitoring initialized
        var _xhrInitialized; // XHR monitoring initialized
        var _currentWindowHost;
        var _extensionConfig;
        var _enableRequestHeaderTracking;
        var _enableAjaxErrorStatusText;
        var _trackAjaxAttempts;
        var _context;
        var _isUsingW3CHeaders;
        var _isUsingAIHeaders;
        var _markPrefix;
        var _enableAjaxPerfTracking;
        var _maxAjaxCallsPerView;
        var _enableResponseHeaderTracking;
        var _disabledUrls;
        var _disableAjaxTracking;
        var _disableFetchTracking;
        var _excludeRequestFromAutoTrackingPatterns;
        var _addRequestContext;
        var _evtNamespace;
        var _ajaxDataId;
        var _dependencyHandlerId;
        var _dependencyListeners;
        var _dependencyInitializers;
        var _ignoreHeaders;
        var _maxAjaxPerfLookupAttempts;
        var _ajaxPerfLookupDelay;
        var _distributedTracingMode;
        var _appId;
        var _polyfillInitialized;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(AjaxMonitor, _this, function(_self, _base) {
            var _addHook = _base[0, $83680ca0bbc253cc$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ];
            _initDefaults();
            _self.initialize = function(config, core, extensions, pluginChain) {
                if (!_self.isInitialized()) {
                    _base.initialize(config, core, extensions, pluginChain);
                    _evtNamespace = (0, $02f0ede5277c99cd$export$3f37a50e0edde3be)((0, $0e058b881c0798ff$export$eb4a6badb18ead04)("ajax"), core && core.evtNamespace && core.evtNamespace());
                    _populateDefaults(config);
                    _instrumentXhr();
                    _instrumentFetch();
                    _populateContext();
                }
            };
            _self._doTeardown = function() {
                _initDefaults();
            };
            _self.trackDependencyData = function(dependency, properties) {
                _reportDependencyInternal(_dependencyInitializers, _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ], null, dependency, properties);
            };
            _self[0, $83680ca0bbc253cc$export$ec2c4b7da1ef8dd0 /* @min:%2eincludeCorrelationHeaders */ ] = function(ajaxData, input, init, xhr) {
                // Test Hook to allow the overriding of the location host
                var currentWindowHost = _self["_currentWindowHost"] || _currentWindowHost;
                $fa5a8e720c6a6dfc$var$_processDependencyListeners(_dependencyListeners, _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ], ajaxData, xhr, input, init);
                if (input || input === "") {
                    if ((0, $d98f9809e5d6a7c7$export$a62d10d7f896c08c)(_extensionConfig, ajaxData[0, $83680ca0bbc253cc$export$de5be3709039b9b0 /* @min:%2egetAbsoluteUrl */ ](), currentWindowHost)) {
                        if (!init) init = {};
                        // init headers override original request headers
                        // so, if they exist use only them, otherwise use request's because they should have been applied in the first place
                        // not using original request headers will result in them being lost
                        var headers = new Headers(init[0, $83680ca0bbc253cc$export$829ed22a43b4aada /* @min:%2eheaders */ ] || (input instanceof Request ? input[0, $83680ca0bbc253cc$export$829ed22a43b4aada /* @min:%2eheaders */ ] || {} : {}));
                        if (_isUsingAIHeaders) {
                            var id = "|" + ajaxData[0, $83680ca0bbc253cc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ] + "." + ajaxData[0, $83680ca0bbc253cc$export$c105b94efa183847 /* @min:%2espanID */ ];
                            headers.set((0, $921552b7fb658c3b$export$e499e02a1fe05177)[3 /* eRequestHeaders.requestIdHeader */ ], id);
                            if (_enableRequestHeaderTracking) ajaxData[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][(0, $921552b7fb658c3b$export$e499e02a1fe05177)[3 /* eRequestHeaders.requestIdHeader */ ]] = id;
                        }
                        var appId = _appId || _context && _context.appId();
                        if (appId) {
                            headers.set((0, $921552b7fb658c3b$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ], (0, $921552b7fb658c3b$export$e499e02a1fe05177)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId);
                            if (_enableRequestHeaderTracking) ajaxData[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][(0, $921552b7fb658c3b$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ]] = (0, $921552b7fb658c3b$export$e499e02a1fe05177)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId;
                        }
                        if (_isUsingW3CHeaders) {
                            var traceFlags = ajaxData[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ];
                            if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(traceFlags)) traceFlags = 0x01;
                            var traceParent = (0, $4726195e2d737947$export$55f8c39d2c902d0d)((0, $4726195e2d737947$export$2f21fe23413fe96b)(ajaxData[0, $83680ca0bbc253cc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ], ajaxData[0, $83680ca0bbc253cc$export$c105b94efa183847 /* @min:%2espanID */ ], traceFlags));
                            headers.set((0, $921552b7fb658c3b$export$e499e02a1fe05177)[4 /* eRequestHeaders.traceParentHeader */ ], traceParent);
                            if (_enableRequestHeaderTracking) ajaxData[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][(0, $921552b7fb658c3b$export$e499e02a1fe05177)[4 /* eRequestHeaders.traceParentHeader */ ]] = traceParent;
                        }
                        init[0, $83680ca0bbc253cc$export$829ed22a43b4aada /* @min:%2eheaders */ ] = headers;
                    }
                    return init;
                } else if (xhr) {
                    if ((0, $d98f9809e5d6a7c7$export$a62d10d7f896c08c)(_extensionConfig, ajaxData[0, $83680ca0bbc253cc$export$de5be3709039b9b0 /* @min:%2egetAbsoluteUrl */ ](), currentWindowHost)) {
                        if (_isUsingAIHeaders) {
                            if (!$fa5a8e720c6a6dfc$var$_isHeaderSet(xhr, (0, $921552b7fb658c3b$export$e499e02a1fe05177)[3 /* eRequestHeaders.requestIdHeader */ ])) {
                                var id = "|" + ajaxData[0, $83680ca0bbc253cc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ] + "." + ajaxData[0, $83680ca0bbc253cc$export$c105b94efa183847 /* @min:%2espanID */ ];
                                xhr[0, $83680ca0bbc253cc$export$84ecd29f369f5b1d /* @min:%2esetRequestHeader */ ]((0, $921552b7fb658c3b$export$e499e02a1fe05177)[3 /* eRequestHeaders.requestIdHeader */ ], id);
                                if (_enableRequestHeaderTracking) ajaxData[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][(0, $921552b7fb658c3b$export$e499e02a1fe05177)[3 /* eRequestHeaders.requestIdHeader */ ]] = id;
                            } else $fa5a8e720c6a6dfc$var$_throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */ , "Unable to set [" + (0, $921552b7fb658c3b$export$e499e02a1fe05177)[3 /* eRequestHeaders.requestIdHeader */ ] + "] as it has already been set by another instance");
                        }
                        var appId = _appId || _context && _context.appId();
                        if (appId) {
                            if (!$fa5a8e720c6a6dfc$var$_isHeaderSet(xhr, (0, $921552b7fb658c3b$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ])) {
                                xhr[0, $83680ca0bbc253cc$export$84ecd29f369f5b1d /* @min:%2esetRequestHeader */ ]((0, $921552b7fb658c3b$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ], (0, $921552b7fb658c3b$export$e499e02a1fe05177)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId);
                                if (_enableRequestHeaderTracking) ajaxData[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][(0, $921552b7fb658c3b$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ]] = (0, $921552b7fb658c3b$export$e499e02a1fe05177)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId;
                            } else $fa5a8e720c6a6dfc$var$_throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */ , "Unable to set [" + (0, $921552b7fb658c3b$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ] + "] as it has already been set by another instance");
                        }
                        if (_isUsingW3CHeaders) {
                            var traceFlags = ajaxData[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ];
                            if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(traceFlags)) traceFlags = 0x01;
                            if (!$fa5a8e720c6a6dfc$var$_isHeaderSet(xhr, (0, $921552b7fb658c3b$export$e499e02a1fe05177)[4 /* eRequestHeaders.traceParentHeader */ ])) {
                                var traceParent = (0, $4726195e2d737947$export$55f8c39d2c902d0d)((0, $4726195e2d737947$export$2f21fe23413fe96b)(ajaxData[0, $83680ca0bbc253cc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ], ajaxData[0, $83680ca0bbc253cc$export$c105b94efa183847 /* @min:%2espanID */ ], traceFlags));
                                xhr[0, $83680ca0bbc253cc$export$84ecd29f369f5b1d /* @min:%2esetRequestHeader */ ]((0, $921552b7fb658c3b$export$e499e02a1fe05177)[4 /* eRequestHeaders.traceParentHeader */ ], traceParent);
                                if (_enableRequestHeaderTracking) ajaxData[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][(0, $921552b7fb658c3b$export$e499e02a1fe05177)[4 /* eRequestHeaders.traceParentHeader */ ]] = traceParent;
                            } else $fa5a8e720c6a6dfc$var$_throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */ , "Unable to set [" + (0, $921552b7fb658c3b$export$e499e02a1fe05177)[4 /* eRequestHeaders.traceParentHeader */ ] + "] as it has already been set by another instance");
                        }
                    }
                    return xhr;
                }
                return undefined;
            };
            _self[0, $83680ca0bbc253cc$export$2aa2820bfe761f5b /* @min:%2etrackDependencyDataInternal */ ] = function(dependency, properties, systemProperties) {
                if (_maxAjaxCallsPerView === -1 || _trackAjaxAttempts < _maxAjaxCallsPerView) {
                    // Hack since expected format in w3c mode is |abc.def.
                    // Non-w3c format is |abc.def
                    // @todo Remove if better solution is available, e.g. handle in portal
                    if ((_distributedTracingMode === 2 /* eDistributedTracingModes.W3C */  || _distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */ ) && typeof dependency.id === "string" && dependency.id[dependency.id[0, $83680ca0bbc253cc$export$6eae51590aaea43 /* @min:%2elength */ ] - 1] !== ".") dependency.id += ".";
                    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(dependency[0, $83680ca0bbc253cc$export$69cac26425c8ea23 /* @min:%2estartTime */ ])) dependency[0, $83680ca0bbc253cc$export$69cac26425c8ea23 /* @min:%2estartTime */ ] = new Date();
                    var item = (0, $f5d319867b0979c9$export$2dc41327de8d98f1)(dependency, (0, $97ca5e424f1910ef$export$a7b48490930dbffa).dataType, (0, $97ca5e424f1910ef$export$a7b48490930dbffa).envelopeType, _self[$fa5a8e720c6a6dfc$var$strDiagLog](), properties, systemProperties);
                    _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ].track(item);
                } else if (_trackAjaxAttempts === _maxAjaxCallsPerView) $fa5a8e720c6a6dfc$var$_throwInternalCritical(_self, 55 /* _eInternalMessageId.MaxAjaxPerPVExceeded */ , "Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.", true);
                ++_trackAjaxAttempts;
            };
            _self.addDependencyListener = function(dependencyListener) {
                return $fa5a8e720c6a6dfc$var$_addHandler(_dependencyListeners, _dependencyHandlerId++, dependencyListener);
            };
            _self.addDependencyInitializer = function(dependencyInitializer) {
                return $fa5a8e720c6a6dfc$var$_addHandler(_dependencyInitializers, _dependencyHandlerId++, dependencyInitializer);
            };
            function _initDefaults() {
                var location = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)();
                _fetchInitialized = false; // fetch monitoring initialized
                _xhrInitialized = false; // XHR monitoring initialized
                _polyfillInitialized = false; // polyfill monitoring initialized
                _currentWindowHost = location && location.host && location.host[0, $83680ca0bbc253cc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
                _extensionConfig = null;
                _enableRequestHeaderTracking = false;
                _enableAjaxErrorStatusText = false;
                _trackAjaxAttempts = 0;
                _context = null;
                _isUsingW3CHeaders = false;
                _isUsingAIHeaders = false;
                _markPrefix = null;
                _enableAjaxPerfTracking = false;
                _maxAjaxCallsPerView = 0;
                _enableResponseHeaderTracking = false;
                _disabledUrls = {};
                _disableAjaxTracking = false;
                _disableFetchTracking = false;
                _excludeRequestFromAutoTrackingPatterns = null;
                _addRequestContext = null;
                _evtNamespace = null;
                _dependencyHandlerId = 0;
                _dependencyListeners = [];
                _dependencyInitializers = [];
                _ajaxDataId = (0, $0e058b881c0798ff$export$eb4a6badb18ead04)("ajaxData");
                _self._ajaxDataId = _ajaxDataId;
                _ignoreHeaders = null;
                _maxAjaxPerfLookupAttempts = 1;
                _ajaxPerfLookupDelay = 1;
                _distributedTracingMode = 1 /* eDistributedTracingModes.AI_AND_W3C */ ;
                _appId = null;
            }
            function _populateDefaults(config) {
                _self[0, $83680ca0bbc253cc$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $6387583e0b25820c$export$454a433e4deb244f)(config, function(details) {
                    var config = details.cfg;
                    var ctx = (0, $21bc92e23804c647$export$ca98f11e981bcfd6)(null, config, _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ]);
                    _extensionConfig = ctx.getExtCfg(AjaxMonitor.identifier, $fa5a8e720c6a6dfc$var$_defaultConfig);
                    _distributedTracingMode = _extensionConfig.distributedTracingMode;
                    _enableRequestHeaderTracking = _extensionConfig[0, $83680ca0bbc253cc$export$abc5bbd8bd54996a /* @min:%2eenableRequestHeaderTracking */ ];
                    _enableAjaxErrorStatusText = _extensionConfig[0, $83680ca0bbc253cc$export$928b837287a09b1f /* @min:%2eenableAjaxErrorStatusText */ ];
                    _enableAjaxPerfTracking = _extensionConfig[0, $83680ca0bbc253cc$export$a2e6a87e51acdf74 /* @min:%2eenableAjaxPerfTracking */ ];
                    _maxAjaxCallsPerView = _extensionConfig[0, $83680ca0bbc253cc$export$8e8c994d518b7819 /* @min:%2emaxAjaxCallsPerView */ ];
                    _excludeRequestFromAutoTrackingPatterns = [].concat(_extensionConfig[0, $83680ca0bbc253cc$export$e4bbd5d3fe5db54b /* @min:%2eexcludeRequestFromAutoTrackingPatterns */ ] || [], _extensionConfig.addIntEndpoints !== false ? $fa5a8e720c6a6dfc$var$_internalExcludeEndpoints : []);
                    _addRequestContext = _extensionConfig[0, $83680ca0bbc253cc$export$e9d1b90025f35753 /* @min:%2eaddRequestContext */ ];
                    _isUsingAIHeaders = _distributedTracingMode === 0 /* eDistributedTracingModes.AI */  || _distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */ ;
                    _isUsingW3CHeaders = _distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */  || _distributedTracingMode === 2 /* eDistributedTracingModes.W3C */ ;
                    if (_enableAjaxPerfTracking) _markPrefix = _ajaxDataId;
                    _disableAjaxTracking = !!_extensionConfig[0, $83680ca0bbc253cc$export$1b35c99ae5c93631 /* @min:%2edisableAjaxTracking */ ];
                    _maxAjaxPerfLookupAttempts = _extensionConfig.maxAjaxPerfLookupAttempts;
                    _ajaxPerfLookupDelay = _extensionConfig[0, $83680ca0bbc253cc$export$990dec05286abf9b /* @min:%2eajaxPerfLookupDelay */ ];
                    _ignoreHeaders = _extensionConfig.ignoreHeaders;
                    _appId = _extensionConfig.appId;
                }));
            }
            function _populateContext() {
                var propExt = _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ].getPlugin((0, $5343a490b8ca01c7$export$2268e69a6d93b7cc));
                if (propExt) _context = propExt.plugin[0, $83680ca0bbc253cc$export$fdcd48959e13aba7 /* @min:%2econtext */ ]; // we could move IPropertiesPlugin to common as well
            }
            // discard the header if it's defined as ignoreHeaders in ICorrelationConfig
            function _canIncludeHeaders(header) {
                var rlt = true;
                if (header || _ignoreHeaders) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_ignoreHeaders, function(key) {
                    if (key[0, $83680ca0bbc253cc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]() === header[0, $83680ca0bbc253cc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]()) {
                        rlt = false;
                        return -1;
                    }
                });
                return rlt;
            }
            // Fetch Stuff
            function _instrumentFetch() {
                var fetch = $fa5a8e720c6a6dfc$var$_supportsFetch();
                if (!fetch) return;
                var global = (0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)();
                var isPolyfill = fetch.polyfill;
                _self[0, $83680ca0bbc253cc$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $6387583e0b25820c$export$454a433e4deb244f)(_extensionConfig, function() {
                    _disableFetchTracking = !!_extensionConfig[0, $83680ca0bbc253cc$export$391aca270631e029 /* @min:%2edisableFetchTracking */ ];
                    _enableResponseHeaderTracking = _extensionConfig[0, $83680ca0bbc253cc$export$21cd44ec55cfc0f9 /* @min:%2eenableResponseHeaderTracking */ ];
                    if (!_disableFetchTracking && !_fetchInitialized) {
                        _addHook((0, $b3babfece552aa67$export$152e6c4c396a57a)(global, $fa5a8e720c6a6dfc$var$STR_FETCH, {
                            ns: _evtNamespace,
                            // Add request hook
                            req: function(callDetails, input, init) {
                                var fetchData;
                                if (!_disableFetchTracking && _fetchInitialized && !_isDisabledRequest(null, input, init) && // If we have a polyfil and XHR instrumented then let XHR report otherwise we get duplicates
                                !(isPolyfill && _xhrInitialized)) {
                                    var ctx = callDetails.ctx();
                                    fetchData = _createFetchRecord(input, init);
                                    var newInit = _self[0, $83680ca0bbc253cc$export$ec2c4b7da1ef8dd0 /* @min:%2eincludeCorrelationHeaders */ ](fetchData, input, init);
                                    if (newInit !== init) callDetails.set(1, newInit);
                                    ctx.data = fetchData;
                                }
                            },
                            rsp: function(callDetails, input) {
                                if (!_disableFetchTracking) {
                                    var fetchData_1 = callDetails.ctx().data;
                                    if (fetchData_1) // Replace the result with the new promise from this code
                                    callDetails.rslt = callDetails.rslt.then(function(response) {
                                        _reportFetchMetrics(callDetails, (response || {})[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ], input, response, fetchData_1, function() {
                                            var _a;
                                            var ajaxResponse = (_a = {
                                                statusText: (response || {})[0, $83680ca0bbc253cc$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ]
                                            }, _a[0, $83680ca0bbc253cc$export$422ea83a60e3414b /* @min:headerMap */ ] = null, _a[0, $83680ca0bbc253cc$export$c4a9b5c39c7409f7 /* @min:correlationContext */ ] = _getFetchCorrelationContext(response), _a);
                                            if (_enableResponseHeaderTracking && response) {
                                                var responseHeaderMap_1 = {};
                                                response.headers.forEach(function(value, name) {
                                                    if (_canIncludeHeaders(name)) responseHeaderMap_1[name] = value;
                                                });
                                                ajaxResponse[0, $83680ca0bbc253cc$export$422ea83a60e3414b /* @min:%2eheaderMap */ ] = responseHeaderMap_1;
                                            }
                                            return ajaxResponse;
                                        });
                                        return response;
                                    }).catch(function(reason) {
                                        _reportFetchMetrics(callDetails, 0, input, null, fetchData_1, null, {
                                            error: reason.message || (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(reason)
                                        });
                                        throw reason;
                                    });
                                }
                            },
                            // Create an error callback to report any hook errors
                            hkErr: $fa5a8e720c6a6dfc$var$_createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , "Failed to monitor Window.fetch" + $fa5a8e720c6a6dfc$var$ERROR_POSTFIX)
                        }, true, (0, $5831ddb3a0caf7c7$export$97b87b8868ff7a3c)()));
                        _fetchInitialized = true;
                    } else if (isPolyfill && !_polyfillInitialized) {
                        // If fetch is a polyfill we need to capture the request to ensure that we correctly track
                        // disabled request URLS (i.e. internal urls) to ensure we don't end up in a constant loop
                        // of reporting ourselves, for example React Native uses a polyfill for fetch
                        // Note: Polyfill implementations that don't support the "polyfill" tag are not supported
                        // the workaround is to add a polyfill property to your fetch implementation before initializing
                        // App Insights
                        _addHook((0, $b3babfece552aa67$export$152e6c4c396a57a)(global, $fa5a8e720c6a6dfc$var$STR_FETCH, {
                            ns: _evtNamespace,
                            req: function(callDetails, input, init) {
                                // Just call so that we record any disabled URL
                                _isDisabledRequest(null, input, init);
                            }
                        }));
                        _polyfillInitialized = true;
                    }
                }));
                if (isPolyfill) // retag the instrumented fetch with the same polyfill settings this is mostly for testing
                // But also supports multiple App Insights usages
                global[$fa5a8e720c6a6dfc$var$STR_FETCH].polyfill = isPolyfill;
            }
            function _hookProto(target, funcName, callbacks) {
                _addHook((0, $b3babfece552aa67$export$6b32104a5f4313f6)(target, funcName, callbacks));
            }
            function _instrumentXhr() {
                if (!$fa5a8e720c6a6dfc$var$_supportsAjaxMonitoring(_self, _ajaxDataId)) return;
                _self[0, $83680ca0bbc253cc$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $6387583e0b25820c$export$454a433e4deb244f)(_extensionConfig, function() {
                    _disableAjaxTracking = !!_extensionConfig[0, $83680ca0bbc253cc$export$1b35c99ae5c93631 /* @min:%2edisableAjaxTracking */ ];
                    _enableRequestHeaderTracking = _extensionConfig[0, $83680ca0bbc253cc$export$abc5bbd8bd54996a /* @min:%2eenableRequestHeaderTracking */ ];
                    if (!_disableAjaxTracking && !_xhrInitialized) {
                        // Instrument open
                        _hookProto(XMLHttpRequest, "open", {
                            ns: _evtNamespace,
                            req: function(callDetails, method, url, async) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails[0, $83680ca0bbc253cc$export$25a34734290022f3 /* @min:%2einst */ ];
                                    var ajaxData = $fa5a8e720c6a6dfc$var$_getAjaxData(xhr, _ajaxDataId);
                                    if (!_isDisabledRequest(xhr, url) && _isMonitoredXhrInstance(xhr, ajaxData, true)) {
                                        if (!ajaxData || !ajaxData.xhrMonitoringState[0, $83680ca0bbc253cc$export$9984940f44bb6769 /* @min:%2eopenDone */ ]) // Only create a single ajaxData (even when multiple AI instances are running)
                                        ajaxData = _openHandler(xhr, method, url, async);
                                        // always attach to the on ready state change (required for handling multiple instances)
                                        _attachToOnReadyStateChange(xhr, ajaxData);
                                    }
                                }
                            },
                            hkErr: $fa5a8e720c6a6dfc$var$_createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , $fa5a8e720c6a6dfc$var$ERROR_HEADER + ".open" + $fa5a8e720c6a6dfc$var$ERROR_POSTFIX)
                        });
                        // Instrument send
                        _hookProto(XMLHttpRequest, "send", {
                            ns: _evtNamespace,
                            req: function(callDetails, context) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails[0, $83680ca0bbc253cc$export$25a34734290022f3 /* @min:%2einst */ ];
                                    var ajaxData = $fa5a8e720c6a6dfc$var$_getAjaxData(xhr, _ajaxDataId);
                                    if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState[0, $83680ca0bbc253cc$export$ebd7b63f645a373e /* @min:%2esendDone */ ]) {
                                        _createMarkId("xhr", ajaxData);
                                        ajaxData[0, $83680ca0bbc253cc$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ] = (0, $d98f9809e5d6a7c7$export$30a447e32c58a836)();
                                        _self[0, $83680ca0bbc253cc$export$ec2c4b7da1ef8dd0 /* @min:%2eincludeCorrelationHeaders */ ](ajaxData, undefined, undefined, xhr);
                                        ajaxData.xhrMonitoringState[0, $83680ca0bbc253cc$export$ebd7b63f645a373e /* @min:%2esendDone */ ] = true;
                                    }
                                }
                            },
                            hkErr: $fa5a8e720c6a6dfc$var$_createErrorCallbackFunc(_self, 17 /* _eInternalMessageId.FailedMonitorAjaxSend */ , $fa5a8e720c6a6dfc$var$ERROR_HEADER + $fa5a8e720c6a6dfc$var$ERROR_POSTFIX)
                        });
                        // Instrument abort
                        _hookProto(XMLHttpRequest, "abort", {
                            ns: _evtNamespace,
                            req: function(callDetails) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails[0, $83680ca0bbc253cc$export$25a34734290022f3 /* @min:%2einst */ ];
                                    var ajaxData = $fa5a8e720c6a6dfc$var$_getAjaxData(xhr, _ajaxDataId);
                                    if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState[0, $83680ca0bbc253cc$export$dda6370f5a5c9f36 /* @min:%2eabortDone */ ]) {
                                        ajaxData[0, $83680ca0bbc253cc$export$fcf18cee9ee41961 /* @min:%2eaborted */ ] = 1;
                                        ajaxData.xhrMonitoringState[0, $83680ca0bbc253cc$export$dda6370f5a5c9f36 /* @min:%2eabortDone */ ] = true;
                                    }
                                }
                            },
                            hkErr: $fa5a8e720c6a6dfc$var$_createErrorCallbackFunc(_self, 13 /* _eInternalMessageId.FailedMonitorAjaxAbort */ , $fa5a8e720c6a6dfc$var$ERROR_HEADER + ".abort" + $fa5a8e720c6a6dfc$var$ERROR_POSTFIX)
                        });
                        // Instrument setRequestHeader
                        _hookProto(XMLHttpRequest, "setRequestHeader", {
                            ns: _evtNamespace,
                            req: function(callDetails, header, value) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails[0, $83680ca0bbc253cc$export$25a34734290022f3 /* @min:%2einst */ ];
                                    var ajaxData = $fa5a8e720c6a6dfc$var$_getAjaxData(xhr, _ajaxDataId);
                                    if (ajaxData && _isMonitoredXhrInstance(xhr, ajaxData)) {
                                        $fa5a8e720c6a6dfc$var$_addSharedXhrHeaders(xhr, header, value);
                                        if (_enableRequestHeaderTracking && _canIncludeHeaders(header)) {
                                            if (ajaxData) ajaxData[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][header] = value;
                                        }
                                    }
                                }
                            },
                            hkErr: $fa5a8e720c6a6dfc$var$_createErrorCallbackFunc(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */ , $fa5a8e720c6a6dfc$var$ERROR_HEADER + ".setRequestHeader" + $fa5a8e720c6a6dfc$var$ERROR_POSTFIX)
                        });
                        _xhrInitialized = true;
                    }
                }));
            }
            function _isDisabledRequest(xhr, request, init) {
                var isDisabled = false;
                var theUrl = ((!(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(request) ? (request || {}).url || "" : request) || "")[0, $83680ca0bbc253cc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
                // check excludeRequestFromAutoTrackingPatterns before stripping off any query string
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_excludeRequestFromAutoTrackingPatterns, function(regex) {
                    var theRegex = regex;
                    if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(regex)) theRegex = new RegExp(regex);
                    if (!isDisabled) isDisabled = theRegex.test(theUrl);
                });
                // if request url matches with exclude regex pattern, return true and no need to check for headers
                if (isDisabled) return isDisabled;
                var idx = $fa5a8e720c6a6dfc$var$_indexOf(theUrl, "?");
                var idx2 = $fa5a8e720c6a6dfc$var$_indexOf(theUrl, "#");
                if (idx === -1 || idx2 !== -1 && idx2 < idx) idx = idx2;
                if (idx !== -1) // Strip off any Query string
                theUrl = theUrl.substring(0, idx);
                // check that this instance is not not used by ajax call performed inside client side monitoring to send data to collector
                if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(xhr)) // Look on the XMLHttpRequest of the URL string value
                isDisabled = xhr[0, $8ac3b4fe9182f568$export$7c6abff2f2bdd9c0] === true || theUrl[0, $8ac3b4fe9182f568$export$7c6abff2f2bdd9c0] === true;
                else if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(request)) // Look for DisabledPropertyName in either Request or RequestInit
                isDisabled = (typeof request === "object" ? request[0, $8ac3b4fe9182f568$export$7c6abff2f2bdd9c0] === true : false) || (init ? init[0, $8ac3b4fe9182f568$export$7c6abff2f2bdd9c0] === true : false);
                // Also add extra check just in case the XHR or fetch objects where not decorated with the DisableProperty due to sealing or freezing
                if (!isDisabled && theUrl && (0, $d98f9809e5d6a7c7$export$edade5317663baa4)(theUrl)) isDisabled = true;
                if (isDisabled) // Add the disabled url if not present
                {
                    if (!_disabledUrls[theUrl]) _disabledUrls[theUrl] = 1;
                } else // Check to see if the url is listed as disabled
                if (_disabledUrls[theUrl]) isDisabled = true;
                return isDisabled;
            }
            /// <summary>Verifies that particular instance of XMLHttpRequest needs to be monitored</summary>
            /// <param name="excludeAjaxDataValidation">Optional parameter. True if ajaxData must be excluded from verification</param>
            /// <returns type="bool">True if instance needs to be monitored, otherwise false</returns>
            function _isMonitoredXhrInstance(xhr, ajaxData, excludeAjaxDataValidation) {
                var ajaxValidation = true;
                var initialized = _xhrInitialized;
                if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(xhr)) ajaxValidation = excludeAjaxDataValidation === true || !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(ajaxData);
                // checking to see that all interested functions on xhr were instrumented
                return initialized && ajaxValidation;
            }
            function _getDistributedTraceCtx() {
                var distributedTraceCtx = null;
                if (_self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ] && _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ].getTraceCtx) distributedTraceCtx = _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ].getTraceCtx(false);
                // Fall back
                if (!distributedTraceCtx && _context && _context.telemetryTrace) distributedTraceCtx = (0, $d98f9809e5d6a7c7$export$847d5dabba5fabb9)(_context.telemetryTrace);
                return distributedTraceCtx;
            }
            function _openHandler(xhr, method, url, async) {
                var _a;
                var distributedTraceCtx = _getDistributedTraceCtx();
                var traceID = distributedTraceCtx && distributedTraceCtx[0, $83680ca0bbc253cc$export$90dab0fe9b2b7158 /* @min:%2egetTraceId */ ]() || (0, $61bcf5b470259c00$export$58d1fad45f39d957)();
                var spanID = (0, $5831ddb3a0caf7c7$export$25b2a9bb66b0078d)((0, $61bcf5b470259c00$export$58d1fad45f39d957)(), 0, 16);
                var xhrRequestData = xhr[$fa5a8e720c6a6dfc$var$AJAX_DATA_CONTAINER] = xhr[$fa5a8e720c6a6dfc$var$AJAX_DATA_CONTAINER] || {
                    xh: [],
                    i: {}
                };
                var ajaxDataCntr = xhrRequestData.i = xhrRequestData.i || {};
                var ajaxData = ajaxDataCntr[_ajaxDataId] = ajaxDataCntr[_ajaxDataId] || new (0, $48c7b9d8e3de1826$export$3391d178758cbbb1)(traceID, spanID, _self[$fa5a8e720c6a6dfc$var$strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx());
                ajaxData[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] = distributedTraceCtx && distributedTraceCtx[0, $83680ca0bbc253cc$export$1fd22cf8d803736f /* @min:%2egetTraceFlags */ ]();
                ajaxData[0, $83680ca0bbc253cc$export$47d30bd816d62bdc /* @min:%2emethod */ ] = method;
                ajaxData[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] = url;
                ajaxData.xhrMonitoringState[0, $83680ca0bbc253cc$export$9984940f44bb6769 /* @min:%2eopenDone */ ] = true;
                ajaxData[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ] = {};
                ajaxData.async = async;
                ajaxData[0, $83680ca0bbc253cc$export$cce28811c9041832 /* @min:%2eerrorStatusText */ ] = _enableAjaxErrorStatusText;
                return ajaxData;
            }
            function _attachToOnReadyStateChange(xhr, ajaxData) {
                ajaxData.xhrMonitoringState[0, $83680ca0bbc253cc$export$99588eb1c78d46e0 /* @min:%2estateChangeAttached */ ] = (0, $02f0ede5277c99cd$export$324ab159353a60a9)(xhr, "readystatechange", function() {
                    var _a;
                    try {
                        if (xhr && xhr.readyState === 4 && _isMonitoredXhrInstance(xhr, ajaxData)) _onAjaxComplete(xhr);
                    } catch (e) {
                        var exceptionText = (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e);
                        // ignore messages with c00c023f, as this a known IE9 XHR abort issue
                        if (!exceptionText || $fa5a8e720c6a6dfc$var$_indexOf(exceptionText[0, $83680ca0bbc253cc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ](), "c00c023f") === -1) $fa5a8e720c6a6dfc$var$_throwInternalCritical(_self, 16 /* _eInternalMessageId.FailedMonitorAjaxRSC */ , $fa5a8e720c6a6dfc$var$ERROR_HEADER + " 'readystatechange' event handler" + $fa5a8e720c6a6dfc$var$ERROR_POSTFIX, (_a = {}, _a[0, $83680ca0bbc253cc$export$c9bea9d79dd8e37a /* @min:ajaxDiagnosticsMessage */ ] = $fa5a8e720c6a6dfc$var$_getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId), _a[0, $83680ca0bbc253cc$export$4852fd87b68a6e1f /* @min:exception */ ] = exceptionText, _a));
                    }
                }, _evtNamespace);
            }
            function _getResponseText(xhr) {
                try {
                    var responseType = xhr.responseType;
                    if (responseType === "" || responseType === "text") // As per the specification responseText is only valid if the type is an empty string or "text"
                    return xhr[0, $83680ca0bbc253cc$export$d9f76b3afffa4e88 /* @min:%2eresponseText */ ];
                } catch (e) {
                // This shouldn't happen because of the above check -- but just in case, so just ignore
                }
                return null;
            }
            function _onAjaxComplete(xhr) {
                var ajaxData = $fa5a8e720c6a6dfc$var$_getAjaxData(xhr, _ajaxDataId);
                ajaxData[0, $83680ca0bbc253cc$export$e52fa892d403cac3 /* @min:%2eresponseFinishedTime */ ] = (0, $d98f9809e5d6a7c7$export$30a447e32c58a836)();
                ajaxData[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ] = xhr[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ];
                function _reportXhrError(e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["ajaxDiagnosticsMessage"] = $fa5a8e720c6a6dfc$var$_getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId);
                    if (e) errorProps["exception"] = (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e);
                    $fa5a8e720c6a6dfc$var$_throwInternalWarning(_self, 14 /* _eInternalMessageId.FailedMonitorAjaxDur */ , $fa5a8e720c6a6dfc$var$FAILED_TO_CALCULATE_DURATION_ERROR + "ajax call" + $fa5a8e720c6a6dfc$var$ERROR_NOT_SENT, errorProps);
                }
                _findPerfResourceEntry("xmlhttprequest", ajaxData, function() {
                    try {
                        var dependency = ajaxData[0, $83680ca0bbc253cc$export$e31aceb60e1b3a1a /* @min:%2eCreateTrackItem */ ]("Ajax", _enableRequestHeaderTracking, function() {
                            var _a;
                            var ajaxResponse = (_a = {
                                statusText: xhr[0, $83680ca0bbc253cc$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ]
                            }, _a[0, $83680ca0bbc253cc$export$422ea83a60e3414b /* @min:headerMap */ ] = null, _a[0, $83680ca0bbc253cc$export$c4a9b5c39c7409f7 /* @min:correlationContext */ ] = _getAjaxCorrelationContext(xhr), _a.type = xhr.responseType, _a[0, $83680ca0bbc253cc$export$d9f76b3afffa4e88 /* @min:responseText */ ] = _getResponseText(xhr), _a.response = xhr[0, $83680ca0bbc253cc$export$71a9f4a2e496846d /* @min:%2eresponse */ ], _a);
                            if (_enableResponseHeaderTracking) {
                                var headers = xhr[0, $83680ca0bbc253cc$export$121ad73699ff0814 /* @min:%2egetAllResponseHeaders */ ]();
                                if (headers) {
                                    // xhr.getAllResponseHeaders() method returns all the response headers, separated by CRLF, as a string or null
                                    // the regex converts the header string into an array of individual headers
                                    var arr = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(headers).split(/[\r\n]+/);
                                    var responseHeaderMap_2 = {};
                                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(arr, function(line) {
                                        var parts = line.split(": ");
                                        var header = parts.shift();
                                        var value = parts.join(": ");
                                        if (_canIncludeHeaders(header)) responseHeaderMap_2[header] = value;
                                    });
                                    ajaxResponse[0, $83680ca0bbc253cc$export$422ea83a60e3414b /* @min:%2eheaderMap */ ] = responseHeaderMap_2;
                                }
                            }
                            return ajaxResponse;
                        });
                        var properties = void 0;
                        try {
                            if (!!_addRequestContext) properties = _addRequestContext({
                                status: xhr[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ],
                                xhr: xhr
                            });
                        } catch (e) {
                            $fa5a8e720c6a6dfc$var$_throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */ , $fa5a8e720c6a6dfc$var$CUSTOM_REQUEST_CONTEXT_ERROR);
                        }
                        if (dependency) {
                            if (properties !== undefined) dependency[0, $8291b597e9a6dfe3$export$400e70f2a2ecb5aa /* @min:%2eproperties */ ] = (0, $dc463ff9724142dd$export$b3cf7a802e578501)((0, $dc463ff9724142dd$export$b3cf7a802e578501)({}, dependency.properties), properties);
                            var sysProperties = ajaxData[0, $83680ca0bbc253cc$export$e2e640c31408a88f /* @min:%2egetPartAProps */ ]();
                            _reportDependencyInternal(_dependencyInitializers, _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ], ajaxData, dependency, null, sysProperties);
                        } else _reportXhrError(null, {
                            requestSentTime: ajaxData[0, $83680ca0bbc253cc$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ],
                            responseFinishedTime: ajaxData[0, $83680ca0bbc253cc$export$e52fa892d403cac3 /* @min:%2eresponseFinishedTime */ ]
                        });
                    } finally{
                        // cleanup telemetry data
                        try {
                            var xhrRequestData = xhr[$fa5a8e720c6a6dfc$var$AJAX_DATA_CONTAINER] || {
                                i: {}
                            };
                            var ajaxDataCntr = xhrRequestData.i || {};
                            if (ajaxDataCntr[_ajaxDataId]) ajaxDataCntr[_ajaxDataId] = null;
                        } catch (e) {
                        // May throw in environments that prevent extension or freeze xhr
                        }
                    }
                }, function(e) {
                    _reportXhrError(e, null);
                });
            }
            function _getAjaxCorrelationContext(xhr) {
                var _a;
                try {
                    var responseHeadersString = xhr[0, $83680ca0bbc253cc$export$121ad73699ff0814 /* @min:%2egetAllResponseHeaders */ ]();
                    if (responseHeadersString !== null) {
                        var index = $fa5a8e720c6a6dfc$var$_indexOf(responseHeadersString[0, $83680ca0bbc253cc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ](), (0, $921552b7fb658c3b$export$e499e02a1fe05177)[8 /* eRequestHeaders.requestContextHeaderLowerCase */ ]);
                        if (index !== -1) {
                            var responseHeader = xhr.getResponseHeader((0, $921552b7fb658c3b$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ]);
                            return (0, $d98f9809e5d6a7c7$export$dbaf37203f788583)(responseHeader);
                        }
                    }
                } catch (e) {
                    $fa5a8e720c6a6dfc$var$_throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */ , $fa5a8e720c6a6dfc$var$CORRELATION_HEADER_ERROR, (_a = {}, _a[0, $83680ca0bbc253cc$export$c9bea9d79dd8e37a /* @min:ajaxDiagnosticsMessage */ ] = $fa5a8e720c6a6dfc$var$_getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId), _a[0, $83680ca0bbc253cc$export$4852fd87b68a6e1f /* @min:exception */ ] = (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e), _a));
                }
            }
            function _createMarkId(type, ajaxData) {
                if (ajaxData[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] && _markPrefix && _enableAjaxPerfTracking) {
                    var performance_1 = (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)();
                    if (performance_1 && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(performance_1.mark)) {
                        $fa5a8e720c6a6dfc$var$_markCount++;
                        var markId = _markPrefix + type + "#" + $fa5a8e720c6a6dfc$var$_markCount;
                        performance_1.mark(markId);
                        var entries = performance_1.getEntriesByName(markId);
                        if (entries && entries[0, $83680ca0bbc253cc$export$6eae51590aaea43 /* @min:%2elength */ ] === 1) ajaxData[0, $83680ca0bbc253cc$export$9e85e7b326182790 /* @min:%2eperfMark */ ] = entries[0];
                    }
                }
            }
            function _findPerfResourceEntry(initiatorType, ajaxData, trackCallback, reportError) {
                var perfMark = ajaxData[0, $83680ca0bbc253cc$export$9e85e7b326182790 /* @min:%2eperfMark */ ];
                var performance = (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)();
                var maxAttempts = _maxAjaxPerfLookupAttempts;
                var retryDelay = _ajaxPerfLookupDelay;
                var requestUrl = ajaxData[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ];
                var attempt = 0;
                (function locateResourceTiming() {
                    try {
                        if (performance && perfMark) {
                            attempt++;
                            var perfTiming = null;
                            var entries = performance.getEntries();
                            for(var lp = entries[0, $83680ca0bbc253cc$export$6eae51590aaea43 /* @min:%2elength */ ] - 1; lp >= 0; lp--){
                                var entry = entries[lp];
                                if (entry) {
                                    if (entry.entryType === "resource") {
                                        if (entry.initiatorType === initiatorType && ($fa5a8e720c6a6dfc$var$_indexOf(entry[0, $83680ca0bbc253cc$export$9734b0a24bf02e93 /* @min:%2ename */ ], requestUrl) !== -1 || $fa5a8e720c6a6dfc$var$_indexOf(requestUrl, entry[0, $83680ca0bbc253cc$export$9734b0a24bf02e93 /* @min:%2ename */ ]) !== -1)) perfTiming = entry;
                                    } else if (entry.entryType === "mark" && entry[0, $83680ca0bbc253cc$export$9734b0a24bf02e93 /* @min:%2ename */ ] === perfMark[0, $83680ca0bbc253cc$export$9734b0a24bf02e93 /* @min:%2ename */ ]) {
                                        // We hit the start event
                                        ajaxData[0, $83680ca0bbc253cc$export$6bec4987b5d3526c /* @min:%2eperfTiming */ ] = perfTiming;
                                        break;
                                    }
                                    if (entry[0, $83680ca0bbc253cc$export$69cac26425c8ea23 /* @min:%2estartTime */ ] < perfMark[0, $83680ca0bbc253cc$export$69cac26425c8ea23 /* @min:%2estartTime */ ] - 1000) break;
                                }
                            }
                        }
                        if (!perfMark || // - we don't have a perfMark or
                        ajaxData[0, $83680ca0bbc253cc$export$6bec4987b5d3526c /* @min:%2eperfTiming */ ] || // - we have not found the perf entry or
                        attempt >= maxAttempts || // - we have tried too many attempts or
                        ajaxData.async === false) {
                            if (perfMark && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(performance.clearMarks)) // Remove the mark so we don't fill up the performance resources too much
                            performance.clearMarks(perfMark[0, $83680ca0bbc253cc$export$9734b0a24bf02e93 /* @min:%2ename */ ]);
                            ajaxData.perfAttempts = attempt;
                            // just continue and report the track event
                            trackCallback();
                        } else // We need to wait for the browser to populate the window.performance entry
                        // This needs to be at least 1ms as waiting <= 1 (on firefox) is not enough time for fetch or xhr,
                        // this is a scheduling issue for the browser implementation
                        (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(locateResourceTiming, retryDelay);
                    } catch (e) {
                        reportError(e);
                    }
                })();
            }
            function _createFetchRecord(input, init) {
                var _a;
                var distributedTraceCtx = _getDistributedTraceCtx();
                var traceID = distributedTraceCtx && distributedTraceCtx[0, $83680ca0bbc253cc$export$90dab0fe9b2b7158 /* @min:%2egetTraceId */ ]() || (0, $61bcf5b470259c00$export$58d1fad45f39d957)();
                var spanID = (0, $5831ddb3a0caf7c7$export$25b2a9bb66b0078d)((0, $61bcf5b470259c00$export$58d1fad45f39d957)(), 0, 16);
                var ajaxData = new (0, $48c7b9d8e3de1826$export$3391d178758cbbb1)(traceID, spanID, _self[$fa5a8e720c6a6dfc$var$strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx());
                ajaxData[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] = distributedTraceCtx && distributedTraceCtx[0, $83680ca0bbc253cc$export$1fd22cf8d803736f /* @min:%2egetTraceFlags */ ]();
                ajaxData[0, $83680ca0bbc253cc$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ] = (0, $d98f9809e5d6a7c7$export$30a447e32c58a836)();
                ajaxData[0, $83680ca0bbc253cc$export$cce28811c9041832 /* @min:%2eerrorStatusText */ ] = _enableAjaxErrorStatusText;
                var requestUrl;
                if (input instanceof Request) requestUrl = (input || {}).url || "";
                else requestUrl = input;
                if (requestUrl === "") {
                    var location_1 = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)();
                    if (location_1 && location_1.href) requestUrl = (0, $5831ddb3a0caf7c7$export$c07560e259c81ec6)(location_1.href, "#")[0];
                }
                ajaxData[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] = requestUrl;
                var method = "GET";
                if (init && init[0, $83680ca0bbc253cc$export$47d30bd816d62bdc /* @min:%2emethod */ ]) method = init[0, $83680ca0bbc253cc$export$47d30bd816d62bdc /* @min:%2emethod */ ];
                else if (input && input instanceof Request) method = input[0, $83680ca0bbc253cc$export$47d30bd816d62bdc /* @min:%2emethod */ ];
                ajaxData[0, $83680ca0bbc253cc$export$47d30bd816d62bdc /* @min:%2emethod */ ] = method;
                var requestHeaders = {};
                if (_enableRequestHeaderTracking) {
                    var headers = new Headers((init ? init[0, $83680ca0bbc253cc$export$829ed22a43b4aada /* @min:%2eheaders */ ] : 0) || (input instanceof Request ? input[0, $83680ca0bbc253cc$export$829ed22a43b4aada /* @min:%2eheaders */ ] || {} : {}));
                    headers.forEach(function(value, key) {
                        if (_canIncludeHeaders(key)) requestHeaders[key] = value;
                    });
                }
                ajaxData[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ] = requestHeaders;
                _createMarkId($fa5a8e720c6a6dfc$var$STR_FETCH, ajaxData);
                return ajaxData;
            }
            function _getFailedFetchDiagnosticsMessage(input) {
                var result = "";
                try {
                    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(input)) {
                        if (typeof input === "string") result += "(url: '".concat(input, "')");
                        else result += "(url: '".concat(input.url, "')");
                    }
                } catch (e) {
                    $fa5a8e720c6a6dfc$var$_throwInternalCritical(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , "Failed to grab failed fetch diagnostics message", {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
                return result;
            }
            function _reportFetchMetrics(callDetails, status, input, response, ajaxData, getResponse, properties) {
                if (!ajaxData) return;
                function _reportFetchError(msgId, e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["fetchDiagnosticsMessage"] = _getFailedFetchDiagnosticsMessage(input);
                    if (e) errorProps["exception"] = (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e);
                    $fa5a8e720c6a6dfc$var$_throwInternalWarning(_self, msgId, $fa5a8e720c6a6dfc$var$FAILED_TO_CALCULATE_DURATION_ERROR + "fetch call" + $fa5a8e720c6a6dfc$var$ERROR_NOT_SENT, errorProps);
                }
                ajaxData[0, $83680ca0bbc253cc$export$e52fa892d403cac3 /* @min:%2eresponseFinishedTime */ ] = (0, $d98f9809e5d6a7c7$export$30a447e32c58a836)();
                ajaxData[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ] = status;
                _findPerfResourceEntry($fa5a8e720c6a6dfc$var$STR_FETCH, ajaxData, function() {
                    var dependency = ajaxData[0, $83680ca0bbc253cc$export$e31aceb60e1b3a1a /* @min:%2eCreateTrackItem */ ]("Fetch", _enableRequestHeaderTracking, getResponse);
                    var properties;
                    try {
                        if (!!_addRequestContext) properties = _addRequestContext({
                            status: status,
                            request: input,
                            response: response
                        });
                    } catch (e) {
                        $fa5a8e720c6a6dfc$var$_throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */ , $fa5a8e720c6a6dfc$var$CUSTOM_REQUEST_CONTEXT_ERROR);
                    }
                    if (dependency) {
                        if (properties !== undefined) dependency[0, $8291b597e9a6dfe3$export$400e70f2a2ecb5aa /* @min:%2eproperties */ ] = (0, $dc463ff9724142dd$export$b3cf7a802e578501)((0, $dc463ff9724142dd$export$b3cf7a802e578501)({}, dependency.properties), properties);
                        var sysProperties = ajaxData[0, $83680ca0bbc253cc$export$e2e640c31408a88f /* @min:%2egetPartAProps */ ]();
                        _reportDependencyInternal(_dependencyInitializers, _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ], ajaxData, dependency, null, sysProperties);
                    } else _reportFetchError(14 /* _eInternalMessageId.FailedMonitorAjaxDur */ , null, {
                        requestSentTime: ajaxData[0, $83680ca0bbc253cc$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ],
                        responseFinishedTime: ajaxData[0, $83680ca0bbc253cc$export$e52fa892d403cac3 /* @min:%2eresponseFinishedTime */ ]
                    });
                }, function(e) {
                    _reportFetchError(18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */ , e, null);
                });
            }
            function _getFetchCorrelationContext(response) {
                var _a;
                if (response && response[0, $83680ca0bbc253cc$export$829ed22a43b4aada /* @min:%2eheaders */ ]) try {
                    var responseHeader = response[0, $83680ca0bbc253cc$export$829ed22a43b4aada /* @min:%2eheaders */ ].get((0, $921552b7fb658c3b$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ]);
                    return (0, $d98f9809e5d6a7c7$export$dbaf37203f788583)(responseHeader);
                } catch (e) {
                    $fa5a8e720c6a6dfc$var$_throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */ , $fa5a8e720c6a6dfc$var$CORRELATION_HEADER_ERROR, (_a = {
                        fetchDiagnosticsMessage: _getFailedFetchDiagnosticsMessage(response)
                    }, _a[0, $83680ca0bbc253cc$export$4852fd87b68a6e1f /* @min:exception */ ] = (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e), _a));
                }
            }
            function _reportDependencyInternal(initializers, core, ajaxData, dependency, properties, systemProperties) {
                var _a;
                var result = true;
                var initializersCount = initializers[0, $83680ca0bbc253cc$export$6eae51590aaea43 /* @min:%2elength */ ];
                if (initializersCount > 0) {
                    var details = (_a = {
                        item: dependency
                    }, _a[0, $8291b597e9a6dfe3$export$400e70f2a2ecb5aa /* @min:properties */ ] = properties, _a.sysProperties = systemProperties, _a.context = ajaxData ? ajaxData[0, $83680ca0bbc253cc$export$fdcd48959e13aba7 /* @min:%2econtext */ ] : null, _a.aborted = ajaxData ? !!ajaxData[0, $83680ca0bbc253cc$export$fcf18cee9ee41961 /* @min:%2eaborted */ ] : false, _a);
                    result = $fa5a8e720c6a6dfc$var$_processDependencyContainer(core, initializers, details, "initializer");
                }
                if (result) _self[0, $83680ca0bbc253cc$export$2aa2820bfe761f5b /* @min:%2etrackDependencyDataInternal */ ](dependency, properties, systemProperties);
            }
        });
        return _this;
    }
    // Removed Stub for AjaxMonitor.prototype.initialize.
    AjaxMonitor.prototype.processTelemetry = function(item, itemCtx) {
        this.processNext(item, itemCtx);
    };
    // Removed Stub for AjaxMonitor.prototype.trackDependencyData.
    // Removed Stub for AjaxMonitor.prototype.includeCorrelationHeaders.
    // Removed Stub for AjaxMonitor.prototype.addDependencyListener.
    /**
     * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
     * It is called after the dependency call has completed and any available performance details are available. A dependency
     * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
     * request so that it doesn't count against the `maxAjaxCallsPerView`.
     * @param dependencyInitializer - The Dependency Telemetry Initializer function
     * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
     */ AjaxMonitor.prototype.addDependencyInitializer = function(dependencyInitializer) {
        return null;
    };
    // Removed Stub for AjaxMonitor.prototype.trackDependencyDataInternal.
    AjaxMonitor.identifier = "AjaxDependencyPlugin";
    return AjaxMonitor;
}((0, $dc0100a6f2a9749a$export$64a11c2f90e6766c));


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
* PropertiesPlugin.ts
* @copyright Microsoft 2018
*/ 




/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
* TelemetryContext.ts
* @copyright Microsoft 2018
*/ 


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $1b92b75e30847feb$export$16975c34e60e1e61 = /** @class */ function() {
    function Application() {}
    return Application;
}();


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $885938404d9e4878$export$8215d14a63d9fb10 = /** @class */ function() {
    /**
     * Constructs a new instance of the Device class
     */ function Device() {
        // don't attempt to fingerprint browsers
        this.id = "browser";
        // Device type is a dimension in our data platform
        // Setting it to 'Browser' allows to separate client and server dependencies/exceptions
        this.deviceClass = "Browser";
    }
    return Device;
}();


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $5ff137899dd4083e$var$Version = "3.3.3";
var $5ff137899dd4083e$export$81742925a72ee8f2 = /** @class */ function() {
    /**
     * Constructs a new instance of the internal telemetry data class.
     */ function Internal(config, unloadHookContainer) {
        var _this = this;
        var unloadHook = (0, $6387583e0b25820c$export$454a433e4deb244f)(config, function() {
            var prefix = config.sdkExtension;
            _this.sdkVersion = (prefix ? prefix + "_" : "") + "javascript:" + $5ff137899dd4083e$var$Version;
        });
        unloadHookContainer && unloadHookContainer.add(unloadHook);
    }
    return Internal;
}();


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $1f89f396e0e70995$export$18a2be9195644f38 = /** @class */ function() {
    function Location() {}
    return Location;
}();


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $55134f1c835b6d44$export$1c39d669bde62767 = "sessionManager"; // Count: 3
var $55134f1c835b6d44$export$c9f4bebf02f459de = "update"; // Count: 4
var $55134f1c835b6d44$export$52b1fe3e70f4c699 = "isUserCookieSet"; // Count: 4
var $55134f1c835b6d44$export$e8019acdc6dfe227 = "isNewUser"; // Count: 4
var $55134f1c835b6d44$export$2d15b9b0e9d1daaa = "getTraceCtx"; // Count: 3
var $55134f1c835b6d44$export$805965d0d38cc4a5 = "telemetryTrace"; // Count: 3
var $55134f1c835b6d44$export$585a4eb45f8043ec = "applySessionContext"; // Count: 2
var $55134f1c835b6d44$export$5c833c29ed72a760 = "applyApplicationContext"; // Count: 2
var $55134f1c835b6d44$export$f3448cce94ee4935 = "applyDeviceContext"; // Count: 2
var $55134f1c835b6d44$export$a6c599a5c1ab6761 = "applyOperationContext"; // Count: 2
var $55134f1c835b6d44$export$5090ada1085f4557 = "applyUserContext"; // Count: 2
var $55134f1c835b6d44$export$dddc87038d37bcef = "applyOperatingSystemContxt"; // Count: 2
var $55134f1c835b6d44$export$4768decfd4f15bcf = "applyLocationContext"; // Count: 2
var $55134f1c835b6d44$export$348ac062a116e27c = "applyInternalContext"; // Count: 2
var $55134f1c835b6d44$export$f251a1587d4aac90 = "accountId"; // Count: 7
var $55134f1c835b6d44$export$3af04f76fec134a = "getSessionId"; // Count: 4
var $55134f1c835b6d44$export$6d013a7bc2da53c1 = "namePrefix"; // Count: 3
var $55134f1c835b6d44$export$d2109757a25c372a = "sessionCookiePostfix"; // Count: 2
var $55134f1c835b6d44$export$f3af58106bbab288 = "userCookiePostfix"; // Count: 2
var $55134f1c835b6d44$export$5c90c36f2382a0ff = "idLength"; // Count: 4
var $55134f1c835b6d44$export$d4e11a6879dac67b = "getNewId"; // Count: 3
var $55134f1c835b6d44$export$6eae51590aaea43 = "length"; // Count: 4
var $55134f1c835b6d44$export$4d608086992f55c7 = "automaticSession"; // Count: 5
var $55134f1c835b6d44$export$574ff42e0e7ce0c = "authenticatedId"; // Count: 6
var $55134f1c835b6d44$export$8c9471ee03377604 = "acquisitionDate"; // Count: 5
var $55134f1c835b6d44$export$7254663b30b11264 = "renewalDate"; // Count: 4
var $55134f1c835b6d44$export$9876e756459769d6 = "join"; // Count: 5
var $55134f1c835b6d44$export$57599fb6aa598bd4 = "cookieSeparator"; // Count: 5
var $55134f1c835b6d44$export$7bdc84f949b24ffd = "authUserCookieName"; // Count: 3


var $f111a398d037d42b$var$SESSION_COOKIE_NAME = "ai_session";
var $f111a398d037d42b$var$ACQUISITION_SPAN = 86400000; // 24 hours in ms
var $f111a398d037d42b$var$RENEWAL_SPAN = 1800000; // 30 minutes in ms
var $f111a398d037d42b$var$COOKIE_UPDATE_INTERVAL = 60000; // 1 minute in ms
var $f111a398d037d42b$export$1fb4852a55678982 = /** @class */ function() {
    function Session() {}
    return Session;
}();
var $f111a398d037d42b$export$9a3efd42578d1f11 = /** @class */ function() {
    function _SessionManager(config, core, unloadHookContainer) {
        var self = this;
        var _storageNamePrefix;
        var _cookieUpdatedTimestamp;
        var _logger = (0, $bacca83328a730a7$export$5102d32ea1d740a)(core);
        var _cookieManager = (0, $aaa64f3935d14265$export$76c0b273586c25c7)(core);
        var _sessionExpirationMs;
        var _sessionRenewalMs;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(_SessionManager, self, function(_self) {
            if (!config) config = {};
            var unloadHook = (0, $6387583e0b25820c$export$454a433e4deb244f)(config, function(details) {
                _sessionExpirationMs = config.sessionExpirationMs || $f111a398d037d42b$var$ACQUISITION_SPAN;
                _sessionRenewalMs = config.sessionRenewalMs || $f111a398d037d42b$var$RENEWAL_SPAN;
                // sessionCookiePostfix takes the preference if it is configured, otherwise takes namePrefix if configured.
                var sessionCookiePostfix = config.sessionCookiePostfix || config[0, $55134f1c835b6d44$export$6d013a7bc2da53c1 /* @min:%2enamePrefix */ ] || "";
                _storageNamePrefix = $f111a398d037d42b$var$SESSION_COOKIE_NAME + sessionCookiePostfix;
            });
            unloadHookContainer && unloadHookContainer.add(unloadHook);
            _self[0, $55134f1c835b6d44$export$4d608086992f55c7 /* @min:%2eautomaticSession */ ] = new $f111a398d037d42b$export$1fb4852a55678982();
            _self[0, $55134f1c835b6d44$export$c9f4bebf02f459de /* @min:%2eupdate */ ] = function() {
                // Always using Date getTime() as there is a bug in older IE instances that causes the performance timings to have the hi-bit set eg 0x800000000 causing
                // the number to be incorrect.
                var nowMs = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)();
                var isExpired = false;
                var session = _self[0, $55134f1c835b6d44$export$4d608086992f55c7 /* @min:%2eautomaticSession */ ];
                if (!session.id) isExpired = !_initializeAutomaticSession(session, nowMs);
                if (!isExpired && _sessionExpirationMs > 0) {
                    var timeSinceAcqMs = nowMs - session[0, $55134f1c835b6d44$export$8c9471ee03377604 /* @min:%2eacquisitionDate */ ];
                    var timeSinceRenewalMs = nowMs - session[0, $55134f1c835b6d44$export$7254663b30b11264 /* @min:%2erenewalDate */ ];
                    isExpired = timeSinceAcqMs < 0 || timeSinceRenewalMs < 0; // expired if the acquisition or last renewal are in the future
                    isExpired = isExpired || timeSinceAcqMs > _sessionExpirationMs; // expired if the time since acquisition is more than session Expiration
                    isExpired = isExpired || timeSinceRenewalMs > _sessionRenewalMs; // expired if the time since last renewal is more than renewal period
                }
                // renew if acquisitionSpan or renewalSpan has elapsed
                if (isExpired) // update automaticSession so session state has correct id
                _renew(nowMs);
                else // do not update the cookie more often than cookieUpdateInterval
                if (!_cookieUpdatedTimestamp || nowMs - _cookieUpdatedTimestamp > $f111a398d037d42b$var$COOKIE_UPDATE_INTERVAL) _setCookie(session, nowMs);
            };
            /**
             *  Record the current state of the automatic session and store it in our cookie string format
             *  into the browser's local storage. This is used to restore the session data when the cookie
             *  expires.
             */ _self.backup = function() {
                var session = _self[0, $55134f1c835b6d44$export$4d608086992f55c7 /* @min:%2eautomaticSession */ ];
                _setStorage(session.id, session[0, $55134f1c835b6d44$export$8c9471ee03377604 /* @min:%2eacquisitionDate */ ], session[0, $55134f1c835b6d44$export$7254663b30b11264 /* @min:%2erenewalDate */ ]);
            };
            /**
             * Use config.namePrefix + ai_session cookie data or local storage data (when the cookie is unavailable) to
             * initialize the automatic session.
             * @returns true if values set otherwise false
             */ function _initializeAutomaticSession(session, now) {
                var isValid = false;
                var cookieValue = _cookieManager.get(_storageNamePrefix);
                if (cookieValue && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(cookieValue.split)) isValid = _initializeAutomaticSessionWithData(session, cookieValue);
                else {
                    // There's no cookie, but we might have session data in local storage
                    // This can happen if the session expired or the user actively deleted the cookie
                    // We only want to recover data if the cookie is missing from expiry. We should respect the user's wishes if the cookie was deleted actively.
                    // The User class handles this for us and deletes our local storage object if the persistent user cookie was removed.
                    var storageValue = (0, $3fab9bbcce274f86$export$c3876355f131c85c)(_logger, _storageNamePrefix);
                    if (storageValue) isValid = _initializeAutomaticSessionWithData(session, storageValue);
                }
                return isValid || !!session.id;
            }
            /**
             * Extract id, acquisitionDate, and renewalDate from an ai_session payload string and
             * use this data to initialize automaticSession.
             *
             * @param sessionData - The string stored in an ai_session cookie or local storage backup
             * @returns true if values set otherwise false
             */ function _initializeAutomaticSessionWithData(session, sessionData) {
                var isValid = false;
                var sessionReset = ", session will be reset";
                var tokens = sessionData.split("|");
                if (tokens[0, $55134f1c835b6d44$export$6eae51590aaea43 /* @min:%2elength */ ] >= 2) try {
                    var acqMs = +tokens[1] || 0;
                    var renewalMs = +tokens[2] || 0;
                    if (isNaN(acqMs) || acqMs <= 0) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 27 /* _eInternalMessageId.SessionRenewalDateIsZero */ , "AI session acquisition date is 0" + sessionReset);
                    else if (isNaN(renewalMs) || renewalMs <= 0) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 27 /* _eInternalMessageId.SessionRenewalDateIsZero */ , "AI session renewal date is 0" + sessionReset);
                    else if (tokens[0]) {
                        // Everything looks valid so set the values
                        session.id = tokens[0];
                        session[0, $55134f1c835b6d44$export$8c9471ee03377604 /* @min:%2eacquisitionDate */ ] = acqMs;
                        session[0, $55134f1c835b6d44$export$7254663b30b11264 /* @min:%2erenewalDate */ ] = renewalMs;
                        isValid = true;
                    }
                } catch (e) {
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 1 /* eLoggingSeverity.CRITICAL */ , 9 /* _eInternalMessageId.ErrorParsingAISessionCookie */ , "Error parsing ai_session value [" + (sessionData || "") + "]" + sessionReset + " - " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
                return isValid;
            }
            function _renew(nowMs) {
                var getNewId = config[0, $55134f1c835b6d44$export$d4e11a6879dac67b /* @min:%2egetNewId */ ] || (0, $dfdef4661b59546e$export$9ffd10a3fbdc175b);
                _self.automaticSession.id = getNewId(config[0, $55134f1c835b6d44$export$5c90c36f2382a0ff /* @min:%2eidLength */ ] || 22);
                _self[0, $55134f1c835b6d44$export$4d608086992f55c7 /* @min:%2eautomaticSession */ ][0, $55134f1c835b6d44$export$8c9471ee03377604 /* @min:%2eacquisitionDate */ ] = nowMs;
                _setCookie(_self[0, $55134f1c835b6d44$export$4d608086992f55c7 /* @min:%2eautomaticSession */ ], nowMs);
                // If this browser does not support local storage, fire an internal log to keep track of it at this point
                if (!(0, $3fab9bbcce274f86$export$f28746933126d63f)()) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 0 /* _eInternalMessageId.BrowserDoesNotSupportLocalStorage */ , "Browser does not support local storage. Session durations will be inaccurate.");
            }
            function _setCookie(session, nowMs) {
                var acq = session[0, $55134f1c835b6d44$export$8c9471ee03377604 /* @min:%2eacquisitionDate */ ];
                session[0, $55134f1c835b6d44$export$7254663b30b11264 /* @min:%2erenewalDate */ ] = nowMs;
                var renewalPeriodMs = _sessionRenewalMs;
                // Set cookie to expire after the session expiry time passes or the session renewal deadline, whichever is sooner
                // Expiring the cookie will cause the session to expire even if the user isn't on the page
                var acqTimeLeftMs = acq + _sessionExpirationMs - nowMs;
                var cookie = [
                    session.id,
                    acq,
                    nowMs
                ];
                var maxAgeSec = 0;
                if (acqTimeLeftMs < renewalPeriodMs) maxAgeSec = acqTimeLeftMs / 1000;
                else maxAgeSec = renewalPeriodMs / 1000;
                var cookieDomain = config.cookieDomain || null;
                // if sessionExpirationMs is set to 0, it means the expiry is set to 0 for this session cookie
                // A cookie with 0 expiry in the session cookie will never expire for that browser session.  If the browser is closed the cookie expires.
                // Depending on the browser, another instance does not inherit this cookie, however, another tab will
                _cookieManager.set(_storageNamePrefix, cookie[0, $55134f1c835b6d44$export$9876e756459769d6 /* @min:%2ejoin */ ]("|"), _sessionExpirationMs > 0 ? maxAgeSec : null, cookieDomain);
                _cookieUpdatedTimestamp = nowMs;
            }
            function _setStorage(guid, acq, renewal) {
                // Keep data in local storage to retain the last session id, allowing us to cleanly end the session when it expires
                // Browsers that don't support local storage won't be able to end sessions cleanly from the client
                // The server will notice this and end the sessions itself, with loss of accurate session duration
                (0, $3fab9bbcce274f86$export$631bce20500dc098)(_logger, _storageNamePrefix, [
                    guid,
                    acq,
                    renewal
                ][0, $55134f1c835b6d44$export$9876e756459769d6 /* @min:%2ejoin */ ]("|"));
            }
        });
    }
    // Removed Stub for _SessionManager.prototype.update.
    // Removed Stub for _SessionManager.prototype.backup.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    _SessionManager.__ieDyn = 1;
    return _SessionManager;
}();


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

var $9696d76715c00784$export$d65492b1f626b9ec = /** @class */ function() {
    function TelemetryTrace(id, parentId, name, logger) {
        var _self = this;
        _self.traceID = id || (0, $61bcf5b470259c00$export$58d1fad45f39d957)();
        _self.parentID = parentId;
        var location = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)();
        if (!name && location && location.pathname) name = location.pathname;
        _self.name = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, name);
    }
    return TelemetryTrace;
}();


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




function $78e506bf511dec78$var$_validateUserInput(id) {
    // Validate:
    // 1. Id is a non-empty string.
    // 2. It does not contain special characters for cookies.
    if (typeof id !== "string" || !id || id.match(/,|;|=| |\|/)) return false;
    return true;
}
var $78e506bf511dec78$export$1f44aaf2ec115b54 = /** @class */ function() {
    function User(config, core, unloadHookContainer) {
        /**
         * A flag indicating whether this represents a new user
         */ this.isNewUser = false;
        /**
         * A flag indicating whether the user cookie has been set
         */ this.isUserCookieSet = false;
        var _logger = (0, $bacca83328a730a7$export$5102d32ea1d740a)(core);
        var _cookieManager = (0, $aaa64f3935d14265$export$76c0b273586c25c7)(core);
        var _storageNamePrefix;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(User, this, function(_self) {
            // Define _self.config
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "config", {
                g: function() {
                    return config;
                }
            });
            var unloadHook = (0, $6387583e0b25820c$export$454a433e4deb244f)(config, function() {
                var userCookiePostfix = config[0, $55134f1c835b6d44$export$f3af58106bbab288 /* @min:%2euserCookiePostfix */ ] || "";
                _storageNamePrefix = User.userCookieName + userCookiePostfix;
                // get userId or create new one if none exists
                var cookie = _cookieManager.get(_storageNamePrefix);
                if (cookie) {
                    _self[0, $55134f1c835b6d44$export$e8019acdc6dfe227 /* @min:%2eisNewUser */ ] = false;
                    var params = cookie.split(User[0, $55134f1c835b6d44$export$57599fb6aa598bd4 /* @min:%2ecookieSeparator */ ]);
                    if (params[0, $55134f1c835b6d44$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                        _self.id = params[0];
                        // we already have a cookie
                        _self[0, $55134f1c835b6d44$export$52b1fe3e70f4c699 /* @min:%2eisUserCookieSet */ ] = !!_self.id;
                    }
                }
                if (!_self.id) {
                    _self.id = _generateNewId();
                    var newCookie = _generateNewCookie(_self.id);
                    _setUserCookie(newCookie[0, $55134f1c835b6d44$export$9876e756459769d6 /* @min:%2ejoin */ ](User[0, $55134f1c835b6d44$export$57599fb6aa598bd4 /* @min:%2ecookieSeparator */ ]));
                    // If we have an config.namePrefix() + ai_session in local storage this means the user actively removed our cookies.
                    // We should respect their wishes and clear ourselves from local storage
                    var name_1 = (config[0, $55134f1c835b6d44$export$6d013a7bc2da53c1 /* @min:%2enamePrefix */ ] || "") + "ai_session";
                    (0, $3fab9bbcce274f86$export$63137c65c2cc6743)(_logger, name_1);
                }
                // We still take the account id from the ctor param for backward compatibility.
                // But if the the customer set the accountId through the newer setAuthenticatedUserContext API, we will override it.
                _self[0, $55134f1c835b6d44$export$f251a1587d4aac90 /* @min:%2eaccountId */ ] = config[0, $55134f1c835b6d44$export$f251a1587d4aac90 /* @min:%2eaccountId */ ] || undefined;
                // Get the auth user id and account id from the cookie if exists
                // Cookie is in the pattern: <authenticatedId>|<accountId>
                var authCookie = _cookieManager.get(User[0, $55134f1c835b6d44$export$7bdc84f949b24ffd /* @min:%2eauthUserCookieName */ ]);
                if (authCookie) {
                    authCookie = decodeURI(authCookie);
                    var authCookieString = authCookie.split(User[0, $55134f1c835b6d44$export$57599fb6aa598bd4 /* @min:%2ecookieSeparator */ ]);
                    if (authCookieString[0]) _self[0, $55134f1c835b6d44$export$574ff42e0e7ce0c /* @min:%2eauthenticatedId */ ] = authCookieString[0];
                    if (authCookieString[0, $55134f1c835b6d44$export$6eae51590aaea43 /* @min:%2elength */ ] > 1 && authCookieString[1]) _self[0, $55134f1c835b6d44$export$f251a1587d4aac90 /* @min:%2eaccountId */ ] = authCookieString[1];
                }
            });
            unloadHookContainer && unloadHookContainer.add(unloadHook);
            function _generateNewId() {
                var theConfig = config || {};
                var getNewId = theConfig[0, $55134f1c835b6d44$export$d4e11a6879dac67b /* @min:%2egetNewId */ ] || (0, $dfdef4661b59546e$export$9ffd10a3fbdc175b);
                var id = getNewId(theConfig[0, $55134f1c835b6d44$export$5c90c36f2382a0ff /* @min:%2eidLength */ ] ? config[0, $55134f1c835b6d44$export$5c90c36f2382a0ff /* @min:%2eidLength */ ] : 22);
                return id;
            }
            function _generateNewCookie(userId) {
                var acqStr = (0, $ede407819d2d28c9$export$dfaaa8705752128f)(new Date());
                _self.accountAcquisitionDate = acqStr;
                _self[0, $55134f1c835b6d44$export$e8019acdc6dfe227 /* @min:%2eisNewUser */ ] = true;
                var newCookie = [
                    userId,
                    acqStr
                ];
                return newCookie;
            }
            function _setUserCookie(cookie) {
                // without expiration, cookies expire at the end of the session
                // set it to 365 days from now
                // 365 * 24 * 60 * 60 = 31536000
                var oneYear = 31536000;
                _self[0, $55134f1c835b6d44$export$52b1fe3e70f4c699 /* @min:%2eisUserCookieSet */ ] = _cookieManager.set(_storageNamePrefix, cookie, oneYear);
            }
            _self.setAuthenticatedUserContext = function(authenticatedUserId, accountId, storeInCookie) {
                if (storeInCookie === void 0) storeInCookie = false;
                // Validate inputs to ensure no cookie control characters.
                var isInvalidInput = !$78e506bf511dec78$var$_validateUserInput(authenticatedUserId) || accountId && !$78e506bf511dec78$var$_validateUserInput(accountId);
                if (isInvalidInput) {
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 60 /* _eInternalMessageId.SetAuthContextFailedAccountName */ , "Setting auth user context failed. User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.", true);
                    return;
                }
                // Create cookie string.
                _self[0, $55134f1c835b6d44$export$574ff42e0e7ce0c /* @min:%2eauthenticatedId */ ] = authenticatedUserId;
                var authCookie = _self[0, $55134f1c835b6d44$export$574ff42e0e7ce0c /* @min:%2eauthenticatedId */ ];
                if (accountId) {
                    _self[0, $55134f1c835b6d44$export$f251a1587d4aac90 /* @min:%2eaccountId */ ] = accountId;
                    authCookie = [
                        _self[0, $55134f1c835b6d44$export$574ff42e0e7ce0c /* @min:%2eauthenticatedId */ ],
                        _self.accountId
                    ][0, $55134f1c835b6d44$export$9876e756459769d6 /* @min:%2ejoin */ ](User[0, $55134f1c835b6d44$export$57599fb6aa598bd4 /* @min:%2ecookieSeparator */ ]);
                }
                if (storeInCookie) // Set the cookie. No expiration date because this is a session cookie (expires when browser closed).
                // Encoding the cookie to handle unexpected unicode characters.
                _cookieManager.set(User[0, $55134f1c835b6d44$export$7bdc84f949b24ffd /* @min:%2eauthUserCookieName */ ], encodeURI(authCookie));
            };
            /**
             * Clears the authenticated user id and the account id from the user context.
             * @returns {}
             */ _self.clearAuthenticatedUserContext = function() {
                _self[0, $55134f1c835b6d44$export$574ff42e0e7ce0c /* @min:%2eauthenticatedId */ ] = null;
                _self[0, $55134f1c835b6d44$export$f251a1587d4aac90 /* @min:%2eaccountId */ ] = null;
                _cookieManager.del(User[0, $55134f1c835b6d44$export$7bdc84f949b24ffd /* @min:%2eauthUserCookieName */ ]);
            };
            _self[0, $55134f1c835b6d44$export$c9f4bebf02f459de /* @min:%2eupdate */ ] = function(userId) {
                // Optimizations to avoid setting and processing the cookie when not needed
                if (_self.id !== userId || !_self[0, $55134f1c835b6d44$export$52b1fe3e70f4c699 /* @min:%2eisUserCookieSet */ ]) {
                    var user_id = userId ? userId : _generateNewId();
                    var user_cookie = _generateNewCookie(user_id);
                    _setUserCookie(user_cookie[0, $55134f1c835b6d44$export$9876e756459769d6 /* @min:%2ejoin */ ](User[0, $55134f1c835b6d44$export$57599fb6aa598bd4 /* @min:%2ecookieSeparator */ ]));
                }
            };
        });
    }
    // Removed Stub for User.prototype.setAuthenticatedUserContext.
    // Removed Stub for User.prototype.clearAuthenticatedUserContext.
    // Removed Stub for User.prototype.update.
    User.cookieSeparator = "|";
    User.userCookieName = "ai_user";
    User.authUserCookieName = "ai_authUser";
    return User;
}();



var $979b887352d12f37$var$strExt = "ext";
var $979b887352d12f37$var$strTags = "tags";
function $979b887352d12f37$var$_removeEmpty(target, name) {
    if (target && target[name] && (0, $5831ddb3a0caf7c7$export$f7628dc18f4211e5)(target[name])[0, $55134f1c835b6d44$export$6eae51590aaea43 /* @min:%2elength */ ] === 0) delete target[name];
}
function $979b887352d12f37$var$_nullResult() {
    return null;
}
var $979b887352d12f37$export$7b6b7bc4acb29126 = /** @class */ function() {
    function TelemetryContext(core, defaultConfig, previousTraceCtx, unloadHookContainer) {
        var _this = this;
        var logger = core.logger;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(TelemetryContext, this, function(_self) {
            _self.appId = $979b887352d12f37$var$_nullResult;
            _self[0, $55134f1c835b6d44$export$3af04f76fec134a /* @min:%2egetSessionId */ ] = $979b887352d12f37$var$_nullResult;
            _self.application = new (0, $1b92b75e30847feb$export$16975c34e60e1e61)();
            _self.internal = new (0, $5ff137899dd4083e$export$81742925a72ee8f2)(defaultConfig, unloadHookContainer);
            if ((0, $5831ddb3a0caf7c7$export$fef62134eea24008)()) {
                _self[0, $55134f1c835b6d44$export$1c39d669bde62767 /* @min:%2esessionManager */ ] = new (0, $f111a398d037d42b$export$9a3efd42578d1f11)(defaultConfig, core, unloadHookContainer);
                _self.device = new (0, $885938404d9e4878$export$8215d14a63d9fb10)();
                _self.location = new (0, $1f89f396e0e70995$export$18a2be9195644f38)();
                _self.user = new (0, $78e506bf511dec78$export$1f44aaf2ec115b54)(defaultConfig, core, unloadHookContainer);
                var traceId = void 0;
                var parentId = void 0;
                var name_1;
                if (previousTraceCtx) {
                    traceId = previousTraceCtx.getTraceId();
                    parentId = previousTraceCtx.getSpanId();
                    name_1 = previousTraceCtx.getName();
                }
                _self[0, $55134f1c835b6d44$export$805965d0d38cc4a5 /* @min:%2etelemetryTrace */ ] = new (0, $9696d76715c00784$export$d65492b1f626b9ec)(traceId, parentId, name_1, logger);
                _self.session = new (0, $f111a398d037d42b$export$1fb4852a55678982)();
            }
            _self[0, $55134f1c835b6d44$export$3af04f76fec134a /* @min:%2egetSessionId */ ] = function() {
                var session = _self.session;
                var sesId = null;
                // If customer set session info, apply their context; otherwise apply context automatically generated
                if (session && (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(session.id)) sesId = session.id;
                else {
                    // Gets the automatic session if it exists or an empty object
                    var autoSession = (_self[0, $55134f1c835b6d44$export$1c39d669bde62767 /* @min:%2esessionManager */ ] || {})[0, $55134f1c835b6d44$export$4d608086992f55c7 /* @min:%2eautomaticSession */ ];
                    sesId = autoSession && (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(autoSession.id) ? autoSession.id : null;
                }
                return sesId;
            };
            _self[0, $55134f1c835b6d44$export$585a4eb45f8043ec /* @min:%2eapplySessionContext */ ] = function(evt, itemCtx) {
                (0, $ede407819d2d28c9$export$80746c6bc6142fc8)((0, $ede407819d2d28c9$export$51417ccc212471e)(evt.ext, (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).AppExt), "sesId", _self[0, $55134f1c835b6d44$export$3af04f76fec134a /* @min:%2egetSessionId */ ](), (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
            };
            _self[0, $55134f1c835b6d44$export$dddc87038d37bcef /* @min:%2eapplyOperatingSystemContxt */ ] = function(evt, itemCtx) {
                (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(evt.ext, (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).OSExt, _self.os);
            };
            _self[0, $55134f1c835b6d44$export$5c833c29ed72a760 /* @min:%2eapplyApplicationContext */ ] = function(evt, itemCtx) {
                var application = _self.application;
                if (application) {
                    // evt.ext.app
                    var tags = (0, $ede407819d2d28c9$export$51417ccc212471e)(evt, $979b887352d12f37$var$strTags);
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(tags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).applicationVersion, application.ver, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(tags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).applicationBuild, application.build, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                }
            };
            _self[0, $55134f1c835b6d44$export$f3448cce94ee4935 /* @min:%2eapplyDeviceContext */ ] = function(evt, itemCtx) {
                var device = _self.device;
                if (device) {
                    // evt.ext.device
                    var extDevice = (0, $ede407819d2d28c9$export$51417ccc212471e)((0, $ede407819d2d28c9$export$51417ccc212471e)(evt, $979b887352d12f37$var$strExt), (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).DeviceExt);
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(extDevice, "localId", device.id, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(extDevice, "ip", device.ip, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(extDevice, "model", device.model, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(extDevice, "deviceClass", device.deviceClass, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                }
            };
            _self[0, $55134f1c835b6d44$export$348ac062a116e27c /* @min:%2eapplyInternalContext */ ] = function(evt, itemCtx) {
                var internal = _self.internal;
                if (internal) {
                    var tags = (0, $ede407819d2d28c9$export$51417ccc212471e)(evt, $979b887352d12f37$var$strTags);
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(tags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).internalAgentVersion, internal.agentVersion, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)); // not mapped in CS 4.0
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(tags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).internalSdkVersion, (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, internal.sdkVersion, 64), (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                    if (evt.baseType === (0, $bacca83328a730a7$export$70ef838ed08aad47).dataType || evt.baseType === (0, $3e77672805d15946$export$12c0fdede1c6bc6c).dataType) {
                        (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(tags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).internalSnippet, internal.snippetVer, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                        (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(tags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).internalSdkSrc, internal.sdkSrc, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                    }
                }
            };
            _self[0, $55134f1c835b6d44$export$4768decfd4f15bcf /* @min:%2eapplyLocationContext */ ] = function(evt, itemCtx) {
                var location = _this.location;
                if (location) (0, $ede407819d2d28c9$export$80746c6bc6142fc8)((0, $ede407819d2d28c9$export$51417ccc212471e)(evt, $979b887352d12f37$var$strTags, []), (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).locationIp, location.ip, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
            };
            _self[0, $55134f1c835b6d44$export$a6c599a5c1ab6761 /* @min:%2eapplyOperationContext */ ] = function(evt, itemCtx) {
                var telemetryTrace = _self[0, $55134f1c835b6d44$export$805965d0d38cc4a5 /* @min:%2etelemetryTrace */ ];
                if (telemetryTrace) {
                    var extTrace = (0, $ede407819d2d28c9$export$51417ccc212471e)((0, $ede407819d2d28c9$export$51417ccc212471e)(evt, $979b887352d12f37$var$strExt), (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).TraceExt, {
                        traceID: undefined,
                        parentID: undefined
                    });
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(extTrace, "traceID", telemetryTrace.traceID, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54), (0, $5831ddb3a0caf7c7$export$bedb7023a7733221));
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(extTrace, "name", telemetryTrace.name, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54), (0, $5831ddb3a0caf7c7$export$bedb7023a7733221));
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(extTrace, "parentID", telemetryTrace.parentID, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54), (0, $5831ddb3a0caf7c7$export$bedb7023a7733221));
                }
            };
            _self.applyWebContext = function(evt, itemCtx) {
                var web = _this.web;
                if (web) (0, $ede407819d2d28c9$export$80746c6bc6142fc8)((0, $ede407819d2d28c9$export$51417ccc212471e)(evt, $979b887352d12f37$var$strExt), (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).WebExt, web);
            };
            _self[0, $55134f1c835b6d44$export$5090ada1085f4557 /* @min:%2eapplyUserContext */ ] = function(evt, itemCtx) {
                var user = _self.user;
                if (user) {
                    var tags = (0, $ede407819d2d28c9$export$51417ccc212471e)(evt, $979b887352d12f37$var$strTags, []);
                    // stays in tags
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(tags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).userAccountId, user[0, $55134f1c835b6d44$export$f251a1587d4aac90 /* @min:%2eaccountId */ ], (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                    // CS 4.0
                    var extUser = (0, $ede407819d2d28c9$export$51417ccc212471e)((0, $ede407819d2d28c9$export$51417ccc212471e)(evt, $979b887352d12f37$var$strExt), (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).UserExt);
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(extUser, "id", user.id, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(extUser, "authId", user[0, $55134f1c835b6d44$export$574ff42e0e7ce0c /* @min:%2eauthenticatedId */ ], (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                }
            };
            _self.cleanUp = function(evt, itemCtx) {
                var ext = evt.ext;
                if (ext) {
                    $979b887352d12f37$var$_removeEmpty(ext, (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).DeviceExt);
                    $979b887352d12f37$var$_removeEmpty(ext, (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).UserExt);
                    $979b887352d12f37$var$_removeEmpty(ext, (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).WebExt);
                    $979b887352d12f37$var$_removeEmpty(ext, (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).OSExt);
                    $979b887352d12f37$var$_removeEmpty(ext, (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).AppExt);
                    $979b887352d12f37$var$_removeEmpty(ext, (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).TraceExt);
                }
            };
        });
    }
    // Removed Stub for TelemetryContext.prototype.applySessionContext.
    // Removed Stub for TelemetryContext.prototype.applyOperatingSystemContxt.
    // Removed Stub for TelemetryContext.prototype.applyApplicationContext.
    // Removed Stub for TelemetryContext.prototype.applyDeviceContext.
    // Removed Stub for TelemetryContext.prototype.applyInternalContext.
    // Removed Stub for TelemetryContext.prototype.applyLocationContext.
    // Removed Stub for TelemetryContext.prototype.applyOperationContext.
    // Removed Stub for TelemetryContext.prototype.applyWebContext.
    // Removed Stub for TelemetryContext.prototype.applyUserContext.
    // Removed Stub for TelemetryContext.prototype.cleanUp.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    TelemetryContext.__ieDyn = 1;
    return TelemetryContext;
}();



var $23e243b798ea743c$var$_a;
var $23e243b798ea743c$var$undefString;
var $23e243b798ea743c$var$nullValue = null;
var $23e243b798ea743c$var$_defaultConfig = (0, $5831ddb3a0caf7c7$export$a15782d21797da4c)(($23e243b798ea743c$var$_a = {}, $23e243b798ea743c$var$_a[0, $55134f1c835b6d44$export$f251a1587d4aac90 /* @min:accountId */ ] = $23e243b798ea743c$var$nullValue, $23e243b798ea743c$var$_a.sessionRenewalMs = 1800000, $23e243b798ea743c$var$_a.samplingPercentage = 100, $23e243b798ea743c$var$_a.sessionExpirationMs = 86400000, $23e243b798ea743c$var$_a.cookieDomain = $23e243b798ea743c$var$nullValue, $23e243b798ea743c$var$_a.sdkExtension = $23e243b798ea743c$var$nullValue, $23e243b798ea743c$var$_a.isBrowserLinkTrackingEnabled = false, $23e243b798ea743c$var$_a.appId = $23e243b798ea743c$var$nullValue, $23e243b798ea743c$var$_a[0, $55134f1c835b6d44$export$3af04f76fec134a /* @min:getSessionId */ ] = $23e243b798ea743c$var$nullValue, $23e243b798ea743c$var$_a[0, $55134f1c835b6d44$export$6d013a7bc2da53c1 /* @min:namePrefix */ ] = $23e243b798ea743c$var$undefString, $23e243b798ea743c$var$_a[0, $55134f1c835b6d44$export$d2109757a25c372a /* @min:sessionCookiePostfix */ ] = $23e243b798ea743c$var$undefString, $23e243b798ea743c$var$_a[0, $55134f1c835b6d44$export$f3af58106bbab288 /* @min:userCookiePostfix */ ] = $23e243b798ea743c$var$undefString, $23e243b798ea743c$var$_a[0, $55134f1c835b6d44$export$5c90c36f2382a0ff /* @min:idLength */ ] = 22, $23e243b798ea743c$var$_a[0, $55134f1c835b6d44$export$d4e11a6879dac67b /* @min:getNewId */ ] = $23e243b798ea743c$var$nullValue, $23e243b798ea743c$var$_a));
var $23e243b798ea743c$var$PropertiesPlugin = /** @class */ function(_super) {
    (0, $dc463ff9724142dd$export$1f9c32e3fbfb8e62)(PropertiesPlugin, _super);
    function PropertiesPlugin() {
        var _this = _super.call(this) || this;
        _this.priority = 110;
        _this.identifier = (0, $5343a490b8ca01c7$export$2268e69a6d93b7cc);
        var _extensionConfig;
        var _distributedTraceCtx;
        var _previousTraceCtx;
        var _context;
        var _disableUserInitMessage;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(PropertiesPlugin, _this, function(_self, _base) {
            _initDefaults();
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "context", {
                g: function() {
                    return _context;
                }
            });
            _self.initialize = function(config, core, extensions, pluginChain) {
                _base.initialize(config, core, extensions, pluginChain);
                _populateDefaults(config);
            };
            /**
             * Add Part A fields to the event
             * @param event - The event that needs to be processed
             */ _self.processTelemetry = function(event, itemCtx) {
                if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(event)) {
                    itemCtx = _self._getTelCtx(itemCtx);
                    // If the envelope is PageView, reset the internal message count so that we can send internal telemetry for the new page.
                    if (event.name === (0, $3e77672805d15946$export$12c0fdede1c6bc6c).envelopeType) itemCtx.diagLog().resetInternalMessageCount();
                    var theContext = _context || {};
                    if (theContext.session) // If customer did not provide custom session id update the session manager
                    {
                        if (typeof _context.session.id !== "string" && theContext[0, $55134f1c835b6d44$export$1c39d669bde62767 /* @min:%2esessionManager */ ]) theContext[0, $55134f1c835b6d44$export$1c39d669bde62767 /* @min:%2esessionManager */ ][0, $55134f1c835b6d44$export$c9f4bebf02f459de /* @min:%2eupdate */ ]();
                    }
                    var userCtx = theContext.user;
                    if (userCtx && !userCtx[0, $55134f1c835b6d44$export$52b1fe3e70f4c699 /* @min:%2eisUserCookieSet */ ]) userCtx[0, $55134f1c835b6d44$export$c9f4bebf02f459de /* @min:%2eupdate */ ](theContext.user.id);
                    _processTelemetryInternal(event, itemCtx);
                    if (userCtx && userCtx[0, $55134f1c835b6d44$export$e8019acdc6dfe227 /* @min:%2eisNewUser */ ]) {
                        userCtx[0, $55134f1c835b6d44$export$e8019acdc6dfe227 /* @min:%2eisNewUser */ ] = false;
                        if (!_disableUserInitMessage) {
                            var message = new (0, $bacca83328a730a7$export$70ef838ed08aad47)(72 /* _eInternalMessageId.SendBrowserInfoOnUserInit */ , ((0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)() || {}).userAgent || "");
                            (0, $bacca83328a730a7$export$e15fbe42d9bc9d3d)(itemCtx.diagLog(), 1 /* eLoggingSeverity.CRITICAL */ , message);
                        }
                    }
                    _self.processNext(event, itemCtx);
                }
            };
            _self._doTeardown = function(unloadCtx, unloadState) {
                var core = (unloadCtx || {}).core();
                if (core && core[0, $55134f1c835b6d44$export$2d15b9b0e9d1daaa /* @min:%2egetTraceCtx */ ]) {
                    var traceCtx = core[0, $55134f1c835b6d44$export$2d15b9b0e9d1daaa /* @min:%2egetTraceCtx */ ](false);
                    if (traceCtx === _distributedTraceCtx) core.setTraceCtx(_previousTraceCtx);
                }
                _initDefaults();
            };
            function _initDefaults() {
                _extensionConfig = null;
                _distributedTraceCtx = null;
                _previousTraceCtx = null;
                _context = null;
                _disableUserInitMessage = true;
            }
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self.core;
                // This function will be re-called whenever any referenced configuration is changed
                _self._addHook((0, $6387583e0b25820c$export$454a433e4deb244f)(config, function() {
                    var ctx = (0, $21bc92e23804c647$export$ca98f11e981bcfd6)(null, config, core);
                    if (config.storagePrefix) (0, $3fab9bbcce274f86$export$a08dccf4adbf6df9)(config.storagePrefix);
                    _disableUserInitMessage = config.disableUserInitMessage === false ? false : true;
                    _extensionConfig = ctx.getExtCfg(identifier, $23e243b798ea743c$var$_defaultConfig);
                    // Test hook to allow accessing the internal values -- explicitly not defined as an available property on the class
                    _self["_extConfig"] = _extensionConfig;
                }));
                // This is outside of the onConfigChange as we don't want to update (replace) these values whenever a referenced config item changes
                _previousTraceCtx = core[0, $55134f1c835b6d44$export$2d15b9b0e9d1daaa /* @min:%2egetTraceCtx */ ](false);
                _context = new (0, $979b887352d12f37$export$7b6b7bc4acb29126)(core, _extensionConfig, _previousTraceCtx, _self._unloadHooks);
                _distributedTraceCtx = (0, $d98f9809e5d6a7c7$export$847d5dabba5fabb9)(_self.context[0, $55134f1c835b6d44$export$805965d0d38cc4a5 /* @min:%2etelemetryTrace */ ], _previousTraceCtx);
                core.setTraceCtx(_distributedTraceCtx);
                _self.context.appId = function() {
                    var breezeChannel = core.getPlugin((0, $5343a490b8ca01c7$export$a714a094d3058c99));
                    return breezeChannel ? breezeChannel.plugin["_appId"] : null;
                };
            }
            function _processTelemetryInternal(evt, itemCtx) {
                // Set Part A fields
                (0, $ede407819d2d28c9$export$51417ccc212471e)(evt, "tags", []);
                (0, $ede407819d2d28c9$export$51417ccc212471e)(evt, "ext", {});
                var ctx = _self.context;
                ctx[0, $55134f1c835b6d44$export$585a4eb45f8043ec /* @min:%2eapplySessionContext */ ](evt, itemCtx);
                ctx[0, $55134f1c835b6d44$export$5c833c29ed72a760 /* @min:%2eapplyApplicationContext */ ](evt, itemCtx);
                ctx[0, $55134f1c835b6d44$export$f3448cce94ee4935 /* @min:%2eapplyDeviceContext */ ](evt, itemCtx);
                ctx[0, $55134f1c835b6d44$export$a6c599a5c1ab6761 /* @min:%2eapplyOperationContext */ ](evt, itemCtx);
                ctx[0, $55134f1c835b6d44$export$5090ada1085f4557 /* @min:%2eapplyUserContext */ ](evt, itemCtx);
                ctx[0, $55134f1c835b6d44$export$dddc87038d37bcef /* @min:%2eapplyOperatingSystemContxt */ ](evt, itemCtx);
                ctx.applyWebContext(evt, itemCtx);
                ctx[0, $55134f1c835b6d44$export$4768decfd4f15bcf /* @min:%2eapplyLocationContext */ ](evt, itemCtx); // legacy tags
                ctx[0, $55134f1c835b6d44$export$348ac062a116e27c /* @min:%2eapplyInternalContext */ ](evt, itemCtx); // legacy tags
                ctx.cleanUp(evt, itemCtx);
            }
        });
        return _this;
    }
    // Removed Stub for PropertiesPlugin.prototype.initialize.
    // Removed Stub for PropertiesPlugin.prototype.processTelemetry.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PropertiesPlugin.__ieDyn = 1;
    return PropertiesPlugin;
}((0, $dc0100a6f2a9749a$export$64a11c2f90e6766c));
var $23e243b798ea743c$export$2e2bcd8739ae039 = $23e243b798ea743c$var$PropertiesPlugin;




/*
 * Application Insights JavaScript SDK - Web, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var $b3f475366d0d8052$var$_AUTHENTICATED_USER_CONTEXT = "AuthenticatedUserContext";
var $b3f475366d0d8052$var$_TRACK = "track";
var $b3f475366d0d8052$export$5e8607ab26634759 = "";
var $b3f475366d0d8052$export$c40a95bd1f19a04a = "snippet";
var $b3f475366d0d8052$export$da4182b670dc48ff = "getCookieMgr";
var $b3f475366d0d8052$export$4dff843ac2d49cae = "startTrackPage";
var $b3f475366d0d8052$export$83ac403ed0121674 = "stopTrackPage";
var $b3f475366d0d8052$export$36b97ab40aae74fe = "flush";
var $b3f475366d0d8052$export$5ac4d387b85102 = "startTrackEvent";
var $b3f475366d0d8052$export$7895813056375cb = "stopTrackEvent";
var $b3f475366d0d8052$export$40f0bd7f5212655f = "addTelemetryInitializer";
var $b3f475366d0d8052$export$98706f009830c697 = $b3f475366d0d8052$export$40f0bd7f5212655f + "s";
var $b3f475366d0d8052$export$6030ed320bde556b = "pollInternalLogs";
var $b3f475366d0d8052$export$59cf80c2878d98fc = "getPlugin";
var $b3f475366d0d8052$export$657de6e6c53d3d4b = "evtNamespace";
var $b3f475366d0d8052$export$2a937c908483aaba = $b3f475366d0d8052$var$_TRACK + "Event";
var $b3f475366d0d8052$export$6a76308d410f3214 = $b3f475366d0d8052$var$_TRACK + "Trace";
var $b3f475366d0d8052$export$f73efacb9b6b9a35 = $b3f475366d0d8052$var$_TRACK + "Metric";
var $b3f475366d0d8052$export$96dcb75b34c1a4 = $b3f475366d0d8052$var$_TRACK + "PageView";
var $b3f475366d0d8052$export$5a8b50b634878942 = $b3f475366d0d8052$var$_TRACK + "Exception";
var $b3f475366d0d8052$export$ab9c6dcf6c4e2bbc = $b3f475366d0d8052$var$_TRACK + "DependencyData";
var $b3f475366d0d8052$export$94666ce386bd4f64 = "set" + $b3f475366d0d8052$var$_AUTHENTICATED_USER_CONTEXT;
var $b3f475366d0d8052$export$f920535c288b298f = "clear" + $b3f475366d0d8052$var$_AUTHENTICATED_USER_CONTEXT;
var $b3f475366d0d8052$export$3d96e9cd6640c426 = "https://js.monitor.azure.com/scripts/b/ai.config.1.cfg.json";


/*
 * Application Insights JavaScript SDK - Web, 3.3.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $15293b9a79d9f5bb$export$568c4302d11f2b22 = "version"; // Count: 6
var $15293b9a79d9f5bb$export$a1c208448cc1b3be = "queue"; // Count: 6
var $15293b9a79d9f5bb$export$1160203e21ea532 = "connectionString"; // Count: 4
var $15293b9a79d9f5bb$export$81cfd43387c8dbcc = "instrumentationKey"; // Count: 5
var $15293b9a79d9f5bb$export$328dc4bf95326f45 = "instrumentationkey"; // Count: 2
var $15293b9a79d9f5bb$export$96c2ecc9f92e8e2c = "userOverrideEndpointUrl"; // Count: 6
var $15293b9a79d9f5bb$export$bfa1c9e5dcf1e78 = "endpointUrl"; // Count: 6
var $15293b9a79d9f5bb$export$3960f2eafedb8f1 = "ingestionendpoint"; // Count: 2
var $15293b9a79d9f5bb$export$f30bfb116278d530 = "onunloadFlush"; // Count: 6
var $15293b9a79d9f5bb$export$fdcd48959e13aba7 = "context"; // Count: 5
var $15293b9a79d9f5bb$export$c2ced5c1a6503d1e = "addHousekeepingBeforeUnload"; // Count: 2
var $15293b9a79d9f5bb$export$b6508117e9f77f7f = "sendMessage"; // Count: 3
var $15293b9a79d9f5bb$export$2df53973544a18a4 = "updateSnippetDefinitions"; // Count: 2


"use strict";
var $c39992e8a81e1e47$var$_a, $c39992e8a81e1e47$var$_b, $c39992e8a81e1e47$var$_c, $c39992e8a81e1e47$var$_d;
var $c39992e8a81e1e47$var$_internalSdkSrc;
// This is an exclude list of properties that should not be updated during initialization
// They include a combination of private and internal property names
var $c39992e8a81e1e47$var$_ignoreUpdateSnippetProperties = [
    (0, $b3f475366d0d8052$export$c40a95bd1f19a04a),
    "dependencies",
    "properties",
    "_snippetVersion",
    "appInsightsNew",
    "getSKUDefaults"
];
var $c39992e8a81e1e47$var$IKEY_USAGE = "iKeyUsage";
var $c39992e8a81e1e47$var$CDN_USAGE = "CdnUsage";
var $c39992e8a81e1e47$var$SDK_LOADER_VER = "SdkLoaderVer";
var $c39992e8a81e1e47$var$UNDEFINED_VALUE = undefined;
var $c39992e8a81e1e47$var$default_limit = {
    samplingRate: 100,
    maxSendNumber: 1
};
var $c39992e8a81e1e47$var$default_interval = {
    monthInterval: 3,
    daysOfMonth: [
        28
    ]
};
var $c39992e8a81e1e47$var$default_throttle_config = {
    disabled: true,
    limit: (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)($c39992e8a81e1e47$var$default_limit),
    interval: (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)($c39992e8a81e1e47$var$default_interval)
};
// We need to include all properties that we only reference that we want to be dynamically updatable here
// So they are converted even when not specified in the passed configuration
var $c39992e8a81e1e47$var$defaultConfigValues = ($c39992e8a81e1e47$var$_a = {}, $c39992e8a81e1e47$var$_a[0, $15293b9a79d9f5bb$export$1160203e21ea532 /* @min:connectionString */ ] = $c39992e8a81e1e47$var$UNDEFINED_VALUE, $c39992e8a81e1e47$var$_a[0, $15293b9a79d9f5bb$export$bfa1c9e5dcf1e78 /* @min:endpointUrl */ ] = $c39992e8a81e1e47$var$UNDEFINED_VALUE, $c39992e8a81e1e47$var$_a[0, $15293b9a79d9f5bb$export$81cfd43387c8dbcc /* @min:instrumentationKey */ ] = $c39992e8a81e1e47$var$UNDEFINED_VALUE, $c39992e8a81e1e47$var$_a[0, $15293b9a79d9f5bb$export$96c2ecc9f92e8e2c /* @min:userOverrideEndpointUrl */ ] = $c39992e8a81e1e47$var$UNDEFINED_VALUE, $c39992e8a81e1e47$var$_a.diagnosticLogInterval = (0, $3b63eef6ee7529a9$export$d0884590a6a82e6c)($c39992e8a81e1e47$var$_chkDiagLevel, 10000), $c39992e8a81e1e47$var$_a.featureOptIn = ($c39992e8a81e1e47$var$_b = {}, $c39992e8a81e1e47$var$_b[$c39992e8a81e1e47$var$IKEY_USAGE] = {
    mode: 3 /* FeatureOptInMode.enable */ 
}, $c39992e8a81e1e47$var$_b[$c39992e8a81e1e47$var$CDN_USAGE] = {
    mode: 2 /* FeatureOptInMode.disable */ 
}, $c39992e8a81e1e47$var$_b[$c39992e8a81e1e47$var$SDK_LOADER_VER] = {
    mode: 2 /* FeatureOptInMode.disable */ 
}, $c39992e8a81e1e47$var$_b), $c39992e8a81e1e47$var$_a.throttleMgrCfg = (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)(($c39992e8a81e1e47$var$_c = {}, $c39992e8a81e1e47$var$_c[109 /* _eInternalMessageId.DefaultThrottleMsgKey */ ] = (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)($c39992e8a81e1e47$var$default_throttle_config), $c39992e8a81e1e47$var$_c[106 /* _eInternalMessageId.InstrumentationKeyDeprecation */ ] = (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)($c39992e8a81e1e47$var$default_throttle_config), $c39992e8a81e1e47$var$_c[111 /* _eInternalMessageId.SdkLdrUpdate */ ] = (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)($c39992e8a81e1e47$var$default_throttle_config), $c39992e8a81e1e47$var$_c[110 /* _eInternalMessageId.CdnDeprecation */ ] = (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)($c39992e8a81e1e47$var$default_throttle_config), $c39992e8a81e1e47$var$_c)), $c39992e8a81e1e47$var$_a.extensionConfig = (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)(($c39992e8a81e1e47$var$_d = {}, $c39992e8a81e1e47$var$_d["AppInsightsCfgSyncPlugin"] = (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)({
    cfgUrl: (0, $b3f475366d0d8052$export$3d96e9cd6640c426),
    syncMode: 2 /* ICfgSyncMode.Receive */ 
}), $c39992e8a81e1e47$var$_d)), $c39992e8a81e1e47$var$_a);
function $c39992e8a81e1e47$var$_chkDiagLevel(value) {
    // Make sure we have a value > 0
    return value && value > 0;
}
/**
 * Application Insights API
 * @group Entrypoint
 * @group Classes
 * @class Initialization
 * @implements {IApplicationInsights}
 */ var $c39992e8a81e1e47$export$e8021799dbedb971 = /** @class */ function() {
    function AppInsightsSku(snippet) {
        var _this = this;
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var dependencies;
        var properties;
        var _sender;
        var _snippetVersion;
        var _evtNamespace;
        var _houseKeepingNamespace;
        var _core;
        var _config;
        var _analyticsPlugin;
        var _cfgSyncPlugin;
        var _throttleMgr;
        var _iKeySentMessage;
        var _cdnSentMessage;
        var _sdkVerSentMessage;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(AppInsightsSku, this, function(_self) {
            _initDefaults();
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "config", {
                g: function() {
                    return _config;
                }
            });
            (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)([
                "pluginVersionStringArr",
                "pluginVersionString"
            ], function(key) {
                (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, key, {
                    g: function() {
                        if (_core) return _core[key];
                        return null;
                    }
                });
            });
            // initialize the queue and config in case they are undefined
            _snippetVersion = "" + (snippet.sv || snippet[0, $15293b9a79d9f5bb$export$568c4302d11f2b22 /* @min:%2eversion */ ] || "");
            snippet[0, $15293b9a79d9f5bb$export$a1c208448cc1b3be /* @min:%2equeue */ ] = snippet[0, $15293b9a79d9f5bb$export$a1c208448cc1b3be /* @min:%2equeue */ ] || [];
            snippet[0, $15293b9a79d9f5bb$export$568c4302d11f2b22 /* @min:%2eversion */ ] = snippet[0, $15293b9a79d9f5bb$export$568c4302d11f2b22 /* @min:%2eversion */ ] || 2.0; // Default to new version
            var cfgHandler = (0, $6387583e0b25820c$export$3a9e9180c14487fd)(snippet.config || {}, $c39992e8a81e1e47$var$defaultConfigValues);
            _config = cfgHandler.cfg;
            _analyticsPlugin = new (0, $f8c459c2dab16ec4$export$ca681bfeb2cf0fca)();
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "appInsights", {
                g: function() {
                    return _analyticsPlugin;
                }
            });
            properties = new (0, $23e243b798ea743c$export$2e2bcd8739ae039)();
            dependencies = new (0, $fa5a8e720c6a6dfc$export$d9a50c4d1eb2475f)();
            _sender = new (0, $7f068950e30577d3$export$c5a96f3e01fb6582)();
            _core = new (0, $125d8f3d04332ece$export$e7ac25a6828d23bf)();
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "core", {
                g: function() {
                    return _core;
                }
            });
            // Will get recalled if any referenced values are changed
            _addUnloadHook((0, $6387583e0b25820c$export$454a433e4deb244f)(cfgHandler, function() {
                var configCs = _config[0, $15293b9a79d9f5bb$export$1160203e21ea532 /* @min:%2econnectionString */ ];
                function _parseCs() {
                    return (0, $4121df0a705d038e$export$87a90c443c3ca3ef)(function(resolve, reject) {
                        (0, $4121df0a705d038e$export$856fe465480fa77a)(configCs, function(res) {
                            var curCs = res && res.value;
                            var parsedCs = null;
                            if (!res.rejected && curCs) {
                                // replace cs with resolved values in case of circular promises
                                _config[0, $15293b9a79d9f5bb$export$1160203e21ea532 /* @min:%2econnectionString */ ] = curCs;
                                parsedCs = (0, $ca7f93f92bf1443c$export$6369f286b474466d)(curCs);
                            }
                            // if can't resolve cs promise, null will be returned
                            resolve(parsedCs);
                        });
                    });
                }
                if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(configCs)) {
                    var ikeyPromise = (0, $4121df0a705d038e$export$87a90c443c3ca3ef)(function(resolve, reject) {
                        _parseCs().then(function(cs) {
                            var ikey = _config[0, $15293b9a79d9f5bb$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ];
                            ikey = cs && cs[0, $15293b9a79d9f5bb$export$328dc4bf95326f45 /* @min:%2einstrumentationkey */ ] || ikey;
                            resolve(ikey);
                        }).catch(function(e) {
                            // parseCs will always resolve(unless timeout)
                            // return null in case any error happens
                            resolve(null);
                        });
                    });
                    var url = _config[0, $15293b9a79d9f5bb$export$96c2ecc9f92e8e2c /* @min:%2euserOverrideEndpointUrl */ ];
                    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(url)) url = (0, $4121df0a705d038e$export$87a90c443c3ca3ef)(function(resolve, reject) {
                        _parseCs().then(function(cs) {
                            var url = _config[0, $15293b9a79d9f5bb$export$bfa1c9e5dcf1e78 /* @min:%2eendpointUrl */ ];
                            var ingest = cs && cs[0, $15293b9a79d9f5bb$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ];
                            url = ingest ? ingest + (0, $8ac3b4fe9182f568$export$e6c0f3431c6cd728) : url;
                            resolve(url);
                        }).catch(function(e) {
                            // parseCs will always resolve(unless timeout)
                            // return null in case any error happens
                            resolve(null);
                        });
                    });
                    _config[0, $15293b9a79d9f5bb$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ] = ikeyPromise;
                    _config[0, $15293b9a79d9f5bb$export$bfa1c9e5dcf1e78 /* @min:%2eendpointUrl */ ] = url;
                }
                if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(configCs) && configCs) {
                    // confirm if promiselike function present
                    // handle cs promise here
                    // add cases to oneNote
                    var cs = (0, $ca7f93f92bf1443c$export$6369f286b474466d)(configCs);
                    var ingest = cs[0, $15293b9a79d9f5bb$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ];
                    _config.endpointUrl = _config[0, $15293b9a79d9f5bb$export$96c2ecc9f92e8e2c /* @min:%2euserOverrideEndpointUrl */ ] ? _config[0, $15293b9a79d9f5bb$export$96c2ecc9f92e8e2c /* @min:%2euserOverrideEndpointUrl */ ] : ingest + (0, $8ac3b4fe9182f568$export$e6c0f3431c6cd728); // add /v2/track
                    _config[0, $15293b9a79d9f5bb$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ] = cs[0, $15293b9a79d9f5bb$export$328dc4bf95326f45 /* @min:%2einstrumentationkey */ ] || _config[0, $15293b9a79d9f5bb$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ];
                }
                // userOverrideEndpointUrl have the highest priority
                _config.endpointUrl = _config[0, $15293b9a79d9f5bb$export$96c2ecc9f92e8e2c /* @min:%2euserOverrideEndpointUrl */ ] ? _config[0, $15293b9a79d9f5bb$export$96c2ecc9f92e8e2c /* @min:%2euserOverrideEndpointUrl */ ] : _config[0, $15293b9a79d9f5bb$export$bfa1c9e5dcf1e78 /* @min:%2eendpointUrl */ ];
            }));
            _self[0, $b3f475366d0d8052$export$c40a95bd1f19a04a /* @min:%2esnippet */ ] = snippet;
            _self[0, $b3f475366d0d8052$export$36b97ab40aae74fe /* @min:%2eflush */ ] = function(async, callBack) {
                if (async === void 0) async = true;
                var result;
                (0, $67947f06182dbd51$export$c6fbeb260600c482)(_core, function() {
                    return "AISKU.flush";
                }, function() {
                    if (async && !callBack) result = (0, $4121df0a705d038e$export$5a1eb20c68656e88)(function(resolve) {
                        callBack = resolve;
                    });
                    var waiting = 1;
                    var flushDone = function() {
                        waiting--;
                        if (waiting === 0) callBack();
                    };
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_core.getChannels(), function(channel) {
                        if (channel) {
                            waiting++;
                            channel[0, $b3f475366d0d8052$export$36b97ab40aae74fe /* @min:%2eflush */ ](async, flushDone);
                        }
                    });
                    // decrement the initial "waiting"
                    flushDone();
                }, null, async);
                return result;
            };
            _self[0, $15293b9a79d9f5bb$export$f30bfb116278d530 /* @min:%2eonunloadFlush */ ] = function(async) {
                if (async === void 0) async = true;
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_core.getChannels(), function(channel) {
                    if (channel[0, $15293b9a79d9f5bb$export$f30bfb116278d530 /* @min:%2eonunloadFlush */ ]) channel[0, $15293b9a79d9f5bb$export$f30bfb116278d530 /* @min:%2eonunloadFlush */ ]();
                    else channel[0, $b3f475366d0d8052$export$36b97ab40aae74fe /* @min:%2eflush */ ](async);
                });
            };
            _self.loadAppInsights = function(legacyMode, logger, notificationManager) {
                if (legacyMode === void 0) legacyMode = false;
                if (legacyMode) (0, $5831ddb3a0caf7c7$export$6523a1bd3b6e3128)("Legacy Mode is no longer supported");
                function _updateSnippetProperties(snippet) {
                    if (snippet) {
                        var snippetVer = "";
                        if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_snippetVersion)) snippetVer += _snippetVersion;
                        if (_self[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ] && _self[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ].internal) _self[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ].internal.snippetVer = snippetVer || "-";
                        // apply updated properties to the global instance (snippet)
                        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(_self, function(field, value) {
                            if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(field) && !(0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(value) && field && field[0] !== "_" && // Don't copy "internal" values
                            (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)($c39992e8a81e1e47$var$_ignoreUpdateSnippetProperties, field) === -1) {
                                if (snippet[field] !== value) snippet[field] = value;
                            }
                        });
                    }
                }
                (0, $67947f06182dbd51$export$c6fbeb260600c482)(_self.core, function() {
                    return "AISKU.loadAppInsights";
                }, function() {
                    // initialize core
                    _core.initialize(_config, [
                        _sender,
                        properties,
                        dependencies,
                        _analyticsPlugin,
                        _cfgSyncPlugin
                    ], logger, notificationManager);
                    (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "context", {
                        g: function() {
                            return properties[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ];
                        }
                    });
                    if (!_throttleMgr) _throttleMgr = new (0, $855be7931ba802b6$export$a6e7e472befd3464)(_core);
                    var sdkSrc = $c39992e8a81e1e47$export$62f75e89e888afb6();
                    if (sdkSrc && _self[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ]) _self[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ].internal.sdkSrc = sdkSrc;
                    _updateSnippetProperties(_self[0, $b3f475366d0d8052$export$c40a95bd1f19a04a /* @min:%2esnippet */ ]);
                    // Empty queue of all api calls logged prior to sdk download
                    _self.emptyQueue();
                    _self[0, $b3f475366d0d8052$export$6030ed320bde556b /* @min:%2epollInternalLogs */ ]();
                    _self[0, $15293b9a79d9f5bb$export$c2ced5c1a6503d1e /* @min:%2eaddHousekeepingBeforeUnload */ ](_self);
                    _addUnloadHook((0, $6387583e0b25820c$export$454a433e4deb244f)(cfgHandler, function() {
                        var defaultEnable = false;
                        if (_config.throttleMgrCfg[109 /* _eInternalMessageId.DefaultThrottleMsgKey */ ]) defaultEnable = !_config.throttleMgrCfg[109 /* _eInternalMessageId.DefaultThrottleMsgKey */ ].disabled;
                        if (!_throttleMgr.isReady() && _config.extensionConfig && _config.extensionConfig[_cfgSyncPlugin.identifier] && defaultEnable) // set ready state to true will automatically trigger flush()
                        _throttleMgr.onReadyState(true);
                        var result;
                        if (!_iKeySentMessage && !_config[0, $15293b9a79d9f5bb$export$1160203e21ea532 /* @min:%2econnectionString */ ] && (0, $ede407819d2d28c9$export$87e0f7dd6dec932f)($c39992e8a81e1e47$var$IKEY_USAGE, _config)) {
                            result = _throttleMgr[0, $15293b9a79d9f5bb$export$b6508117e9f77f7f /* @min:%2esendMessage */ ](106 /* _eInternalMessageId.InstrumentationKeyDeprecation */ , "See Instrumentation key support at aka.ms/IkeyMigrate");
                            _iKeySentMessage = true;
                        }
                        if (!_cdnSentMessage && _self[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ].internal.sdkSrc && _self[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ].internal.sdkSrc.indexOf("az416426") != -1 && (0, $ede407819d2d28c9$export$87e0f7dd6dec932f)($c39992e8a81e1e47$var$CDN_USAGE, _config)) {
                            result = _throttleMgr[0, $15293b9a79d9f5bb$export$b6508117e9f77f7f /* @min:%2esendMessage */ ](110 /* _eInternalMessageId.CdnDeprecation */ , "See Cdn support notice at aka.ms/JsActiveCdn");
                            _cdnSentMessage = true;
                        }
                        if (!_sdkVerSentMessage && parseInt(_snippetVersion) < 6 && (0, $ede407819d2d28c9$export$87e0f7dd6dec932f)($c39992e8a81e1e47$var$SDK_LOADER_VER, _config)) {
                            result = _throttleMgr[0, $15293b9a79d9f5bb$export$b6508117e9f77f7f /* @min:%2esendMessage */ ](111 /* _eInternalMessageId.SdkLdrUpdate */ , "An updated Sdk Loader is available, see aka.ms/SnippetVer");
                            _sdkVerSentMessage = true;
                        }
                    }));
                });
                return _self;
            };
            _self[0, $15293b9a79d9f5bb$export$2df53973544a18a4 /* @min:%2eupdateSnippetDefinitions */ ] = function(snippet) {
                // apply full appInsights to the global instance
                // Note: This must be called before loadAppInsights is called
                (0, $ede407819d2d28c9$export$21c1f632458708da)(snippet, _self, function(name) {
                    // Not excluding names prefixed with "_" as we need to proxy some functions like _onError
                    return name && (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)($c39992e8a81e1e47$var$_ignoreUpdateSnippetProperties, name) === -1;
                });
            };
            _self.emptyQueue = function() {
                // call functions that were queued before the main script was loaded
                try {
                    if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(_self.snippet[0, $15293b9a79d9f5bb$export$a1c208448cc1b3be /* @min:%2equeue */ ])) {
                        // note: do not check length in the for-loop conditional in case something goes wrong and the stub methods are not overridden.
                        var length_1 = _self.snippet[0, $15293b9a79d9f5bb$export$a1c208448cc1b3be /* @min:%2equeue */ ].length;
                        for(var i = 0; i < length_1; i++){
                            var call = _self.snippet[0, $15293b9a79d9f5bb$export$a1c208448cc1b3be /* @min:%2equeue */ ][i];
                            call();
                        }
                        _self.snippet[0, $15293b9a79d9f5bb$export$a1c208448cc1b3be /* @min:%2equeue */ ] = undefined;
                        delete _self.snippet[0, $15293b9a79d9f5bb$export$a1c208448cc1b3be /* @min:%2equeue */ ];
                    }
                } catch (exception) {
                    var properties_1 = {};
                    if (exception && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(exception.toString)) properties_1.exception = exception.toString();
                // need from core
                // Microsoft.ApplicationInsights._InternalLogging.throwInternal(
                //     eLoggingSeverity.WARNING,
                //     _eInternalMessageId.FailedToSendQueuedTelemetry,
                //     "Failed to send queued telemetry",
                //     properties);
                }
            };
            _self[0, $15293b9a79d9f5bb$export$c2ced5c1a6503d1e /* @min:%2eaddHousekeepingBeforeUnload */ ] = function(appInsightsInstance) {
                // Add callback to push events when the user navigates away
                if ((0, $5831ddb3a0caf7c7$export$fef62134eea24008)() || (0, $5831ddb3a0caf7c7$export$c4372eca9c56fe99)()) {
                    var performHousekeeping_1 = function() {
                        // Adds the ability to flush all data before the page unloads.
                        // Note: This approach tries to push a sync request with all the pending events onbeforeunload.
                        // Firefox does not respect this.Other browsers DO push out the call with < 100% hit rate.
                        // Telemetry here will help us analyze how effective this approach is.
                        // Another approach would be to make this call sync with a acceptable timeout to reduce the
                        // impact on user experience.
                        // appInsightsInstance.context._sender.triggerSend();
                        appInsightsInstance[0, $15293b9a79d9f5bb$export$f30bfb116278d530 /* @min:%2eonunloadFlush */ ](false);
                        // Back up the current session to local storage
                        // This lets us close expired sessions after the cookies themselves expire
                        if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(_self.core[0, $b3f475366d0d8052$export$59cf80c2878d98fc /* @min:%2egetPlugin */ ])) {
                            var loadedPlugin = _this.core[0, $b3f475366d0d8052$export$59cf80c2878d98fc /* @min:%2egetPlugin */ ]((0, $5343a490b8ca01c7$export$2268e69a6d93b7cc));
                            if (loadedPlugin) {
                                var propertiesPlugin = loadedPlugin.plugin;
                                if (propertiesPlugin && propertiesPlugin[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ] && propertiesPlugin[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ]._sessionManager) propertiesPlugin[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ]._sessionManager.backup();
                            }
                        }
                    };
                    var added_1 = false;
                    if (!_houseKeepingNamespace) _houseKeepingNamespace = (0, $02f0ede5277c99cd$export$3f37a50e0edde3be)(_evtNamespace, _core[0, $b3f475366d0d8052$export$657de6e6c53d3d4b /* @min:%2eevtNamespace */ ] && _core[0, $b3f475366d0d8052$export$657de6e6c53d3d4b /* @min:%2eevtNamespace */ ]());
                    // Will be recalled if any referenced config properties change
                    _addUnloadHook((0, $6387583e0b25820c$export$454a433e4deb244f)(_config, function(details) {
                        var coreConfig = details.cfg;
                        var analyticsPlugin = appInsightsInstance.appInsights;
                        var ctx = (0, $21bc92e23804c647$export$ca98f11e981bcfd6)(null, coreConfig, analyticsPlugin.core);
                        var extConfig = ctx.getExtCfg(analyticsPlugin.identifier || (0, $5343a490b8ca01c7$export$862d858b0002f352));
                        // As we could get recalled, remove any previously registered event handlers first
                        _removePageEventHandlers();
                        var excludePageUnloadEvents = coreConfig.disablePageUnloadEvents;
                        if (!extConfig.disableFlushOnBeforeUnload) {
                            // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
                            // As just hooking the window does not always fire (on chrome) for page navigation's.
                            if ((0, $02f0ede5277c99cd$export$f16ce149aca77fdd)(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace)) added_1 = true;
                            // We also need to hook the pagehide and visibilitychange events as not all versions of Safari support load/unload events.
                            if ((0, $02f0ede5277c99cd$export$46744aee53e5e558)(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace)) added_1 = true;
                            // A reactNative app may not have a window and therefore the beforeunload/pagehide events -- so don't
                            // log the failure in this case
                            if (!added_1 && !(0, $0d2c2fb24388dcf8$export$f7a1e23e542d38e3)()) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_core.logger, 1 /* eLoggingSeverity.CRITICAL */ , 19 /* _eInternalMessageId.FailedToAddHandlerForOnBeforeUnload */ , "Could not add handler for beforeunload and pagehide");
                        }
                        if (!added_1 && !extConfig.disableFlushOnUnload) // If we didn't add the normal set then attempt to add the pagehide and visibilitychange only
                        (0, $02f0ede5277c99cd$export$46744aee53e5e558)(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace);
                    }));
                }
            };
            _self.getSender = function() {
                return _sender;
            };
            _self.unload = function(isAsync, unloadComplete, cbTimeout) {
                var unloadDone = false;
                var result;
                if (isAsync && !unloadComplete) result = (0, $4121df0a705d038e$export$5a1eb20c68656e88)(function(resolve) {
                    // Set the callback to the promise resolve callback
                    unloadComplete = resolve;
                });
                function _unloadCallback(unloadState) {
                    if (!unloadDone) {
                        unloadDone = true;
                        _initDefaults();
                        unloadComplete && unloadComplete(unloadState);
                    }
                }
                _self[0, $15293b9a79d9f5bb$export$f30bfb116278d530 /* @min:%2eonunloadFlush */ ](isAsync);
                _removePageEventHandlers();
                _core.unload && _core.unload(isAsync, _unloadCallback, cbTimeout);
                return result;
            };
            (0, $ede407819d2d28c9$export$94f4c7fb7e7d8dc7)(_self, _analyticsPlugin, [
                (0, $b3f475366d0d8052$export$da4182b670dc48ff),
                (0, $b3f475366d0d8052$export$2a937c908483aaba),
                (0, $b3f475366d0d8052$export$96dcb75b34c1a4),
                "trackPageViewPerformance",
                (0, $b3f475366d0d8052$export$5a8b50b634878942),
                "_onerror",
                (0, $b3f475366d0d8052$export$6a76308d410f3214),
                (0, $b3f475366d0d8052$export$f73efacb9b6b9a35),
                (0, $b3f475366d0d8052$export$4dff843ac2d49cae),
                (0, $b3f475366d0d8052$export$83ac403ed0121674),
                (0, $b3f475366d0d8052$export$5ac4d387b85102),
                (0, $b3f475366d0d8052$export$7895813056375cb)
            ]);
            (0, $ede407819d2d28c9$export$94f4c7fb7e7d8dc7)(_self, _getCurrentDependencies, [
                (0, $b3f475366d0d8052$export$ab9c6dcf6c4e2bbc),
                "addDependencyListener",
                "addDependencyInitializer"
            ]);
            (0, $ede407819d2d28c9$export$94f4c7fb7e7d8dc7)(_self, _core, [
                (0, $b3f475366d0d8052$export$40f0bd7f5212655f),
                (0, $b3f475366d0d8052$export$6030ed320bde556b),
                "stopPollingInternalLogs",
                (0, $b3f475366d0d8052$export$59cf80c2878d98fc),
                "addPlugin",
                (0, $b3f475366d0d8052$export$657de6e6c53d3d4b),
                "addUnloadCb",
                "getTraceCtx",
                "updateCfg",
                "onCfgChange"
            ]);
            (0, $ede407819d2d28c9$export$94f4c7fb7e7d8dc7)(_self, function() {
                var context = properties[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ];
                return context ? context.user : null;
            }, [
                (0, $b3f475366d0d8052$export$94666ce386bd4f64),
                (0, $b3f475366d0d8052$export$f920535c288b298f)
            ]);
            // Using a function to support the dynamic adding / removal of plugins, so this will always return the current value
            function _getCurrentDependencies() {
                return dependencies;
            }
            function _initDefaults() {
                _evtNamespace = (0, $0e058b881c0798ff$export$eb4a6badb18ead04)("AISKU");
                _houseKeepingNamespace = null;
                dependencies = null;
                properties = null;
                _sender = null;
                _snippetVersion = null;
                _throttleMgr = null;
                _iKeySentMessage = false;
                _cdnSentMessage = false;
                _sdkVerSentMessage = false;
                _cfgSyncPlugin = new (0, $c0d1696c8c7ba142$export$30ebafc03af98b74)();
            }
            function _removePageEventHandlers() {
                // Remove any registered event handlers
                if (_houseKeepingNamespace) {
                    (0, $02f0ede5277c99cd$export$272dc813b0b2654c)(null, _houseKeepingNamespace);
                    (0, $02f0ede5277c99cd$export$6aca6ee3a147169f)(null, _houseKeepingNamespace);
                }
            }
            function _addUnloadHook(hooks) {
                _core.addUnloadHook(hooks);
            }
        });
    }
    // Analytics Plugin
    // Removed Stub for AppInsightsSku.prototype.getCookieMgr.
    // Removed Stub for AppInsightsSku.prototype.trackEvent.
    // Removed Stub for AppInsightsSku.prototype.trackPageView.
    // Removed Stub for AppInsightsSku.prototype.trackPageViewPerformance.
    // Removed Stub for AppInsightsSku.prototype.trackException.
    // Removed Stub for AppInsightsSku.prototype._onerror.
    // Removed Stub for AppInsightsSku.prototype.trackTrace.
    // Removed Stub for AppInsightsSku.prototype.trackMetric.
    // Removed Stub for AppInsightsSku.prototype.startTrackPage.
    // Removed Stub for AppInsightsSku.prototype.stopTrackPage.
    // Removed Stub for AppInsightsSku.prototype.startTrackEvent.
    // Removed Stub for AppInsightsSku.prototype.stopTrackEvent.
    // Removed Stub for AppInsightsSku.prototype.addTelemetryInitializer.
    // Properties Plugin
    // Removed Stub for AppInsightsSku.prototype.setAuthenticatedUserContext.
    // Removed Stub for AppInsightsSku.prototype.clearAuthenticatedUserContext.
    // Dependencies Plugin
    // Removed Stub for AppInsightsSku.prototype.trackDependencyData.
    // Misc
    // Removed Stub for AppInsightsSku.prototype.flush.
    // Removed Stub for AppInsightsSku.prototype.onunloadFlush.
    // Removed Stub for AppInsightsSku.prototype.loadAppInsights.
    // Removed Stub for AppInsightsSku.prototype.updateSnippetDefinitions.
    // Removed Stub for AppInsightsSku.prototype.emptyQueue.
    // Removed Stub for AppInsightsSku.prototype.pollInternalLogs.
    // Removed Stub for AppInsightsSku.prototype.stopPollingInternalLogs.
    // Removed Stub for AppInsightsSku.prototype.addHousekeepingBeforeUnload.
    // Removed Stub for AppInsightsSku.prototype.getSender.
    // Removed Stub for AppInsightsSku.prototype.unload.
    // Removed Stub for AppInsightsSku.prototype.getPlugin.
    // Removed Stub for AppInsightsSku.prototype.addPlugin.
    // Removed Stub for AppInsightsSku.prototype.updateCfg.
    // Removed Stub for AppInsightsSku.prototype.evtNamespace.
    // Removed Stub for AppInsightsSku.prototype.addUnloadCb.
    // Removed Stub for AppInsightsSku.prototype.addDependencyListener.
    /**
     * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
     * It is called after the dependency call has completed and any available performance details are available. A dependency
     * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
     * request so that it doesn't count against the `maxAjaxCallsPerView`.
     * @param dependencyInitializer - The Dependency Telemetry Initializer function
     * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
     */ AppInsightsSku.prototype.addDependencyInitializer = function(dependencyInitializer) {
        return null;
    };
    // Removed Stub for AppInsightsSku.prototype.getTraceCtx.
    // Removed Stub for AppInsightsSku.prototype.onCfgChange.
    return AppInsightsSku;
}();
function $c39992e8a81e1e47$export$62f75e89e888afb6() {
    if ($c39992e8a81e1e47$var$_internalSdkSrc) // Use the cached value
    return $c39992e8a81e1e47$var$_internalSdkSrc;
    var sdkSrc = null;
    var isModule = false;
    var cdns = [
        "://js.monitor.azure.com/",
        "://az416426.vo.msecnd.net/"
    ];
    try {
        // Try and determine whether the sdk is being loaded from the CDN
        // currentScript is only valid during initial processing
        var scrpt = (document || {}).currentScript;
        if (scrpt) sdkSrc = scrpt.src;
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
    if (sdkSrc) {
        try {
            var url_1 = sdkSrc.toLowerCase();
            if (url_1) {
                var src_1 = "";
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(cdns, function(value, idx) {
                    if ((0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(url_1, value) !== -1) {
                        src_1 = "cdn" + (idx + 1);
                        if ((0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(url_1, "/scripts/") === -1) {
                            if ((0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(url_1, "/next/") !== -1) src_1 += "-next";
                            else if ((0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(url_1, "/beta/") !== -1) src_1 += "-beta";
                        }
                        $c39992e8a81e1e47$var$_internalSdkSrc = src_1 + (isModule ? ".mod" : "");
                        return -1;
                    }
                });
            }
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        // Cache the found value so we don't have to look it up again
        $c39992e8a81e1e47$var$_internalSdkSrc = sdkSrc;
    }
    return $c39992e8a81e1e47$var$_internalSdkSrc;
}


class $968f28756c67bd23$export$b9721ef022f71a68 extends Error {
}
$968f28756c67bd23$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $968f28756c67bd23$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $968f28756c67bd23$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $968f28756c67bd23$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $968f28756c67bd23$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $968f28756c67bd23$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $968f28756c67bd23$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $968f28756c67bd23$var$base64UrlDecode(part);
    } catch (e) {
        throw new $968f28756c67bd23$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $968f28756c67bd23$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}


function $f34e39b94a174052$export$2e2bcd8739ae039(jwtToken) {
    let applicationInsights = null;
    const connectionString = window.APPLICATIONINSIGHTS_CONNECTION_STRING === "__APPLICATIONINSIGHTS_CONNECTION_STRING__" ? "" : window.APPLICATIONINSIGHTS_CONNECTION_STRING;
    if (connectionString) {
        applicationInsights = new (0, $c39992e8a81e1e47$export$e8021799dbedb971)({
            config: {
                connectionString: connectionString
            }
        });
        applicationInsights.loadAppInsights();
        const decodedJwt = (0, $968f28756c67bd23$export$fa1e2fb699b7861e)(jwtToken);
        applicationInsights.addTelemetryInitializer((envelope)=>{
            envelope.data.arterTid = decodedJwt.arter_tid;
            envelope.data.authIssuer = decodedJwt.iss;
            if (envelope.baseType === "PageviewData" || envelope.baseType === "PageviewPerformanceData") envelope.baseData.name = window.location.pathname.replaceAll(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/g, "{id}").slice(1);
        });
    }
    return applicationInsights;
}


const $8a23c0557a977d39$var$ConfigurationContext = (0, $13c40c34b78c8ee2$export$fd42f52fd3ae1109)({});
function $8a23c0557a977d39$export$3d84f372296c3d76({ uuid: uuid, source: source, lang: lang, ...props }) {
    const [readyToListen, setReadyToListen] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(false);
    const [parentSystemConfiguration, setParentSystemConfiguration] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(null);
    const [applicationInsights, setApplicationInsights] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(null);
    const drawingId = uuid || source;
    const xml = (0, $b678971e312560c2$export$2e2bcd8739ae039)(drawingId, parentSystemConfiguration);
    const receive = (evt)=>{
        if (evt.data.message && evt.data.message === (0, $5ffe098e6e560069$export$6b60ce27feb4311e)) {
            setParentSystemConfiguration(evt.data.configuration);
            setApplicationInsights((0, $f34e39b94a174052$export$2e2bcd8739ae039)(evt.data.configuration.authentication.jwt));
        }
        if (evt.data.message && evt.data.message === (0, $5ffe098e6e560069$export$c8806dc6e5449e79)) setParentSystemConfiguration((prevConfiguration)=>({
                ...prevConfiguration,
                authentication: {
                    jwt: evt.data.jwt
                }
            }));
    };
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        if (readyToListen) (0, $5ffe098e6e560069$export$d037512f99596d45)();
    }, [
        readyToListen
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        window.addEventListener("message", receive);
        setReadyToListen(true);
        return ()=>{
            window.removeEventListener("message", receive);
        };
    }, []);
    const configuration = (0, $204a33a7557cbbd0$export$1538c33de8887b59)(()=>({
            parentSystemConfiguration: parentSystemConfiguration,
            uuid: uuid,
            lang: lang,
            xml: xml,
            applicationInsights: applicationInsights
        }), [
        applicationInsights,
        lang,
        parentSystemConfiguration,
        uuid,
        xml
    ]);
    return parentSystemConfiguration && xml != null ? /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($8a23c0557a977d39$var$ConfigurationContext.Provider, {
        value: configuration,
        children: props.children
    }) : null;
}
function $8a23c0557a977d39$export$730006aaa55ed657() {
    const context = (0, $204a33a7557cbbd0$export$fae74005e78b1a27)($8a23c0557a977d39$var$ConfigurationContext);
    if (!context) throw new Error(`useConfiguration must be used within a ConfigurationProvider`);
    return context;
}


const $cf92d1b7e7859fe9$export$56a2318c6197b5fa = "/editor/?spin=1&embed=1&proto=json&pv=0&configure=1";
const $cf92d1b7e7859fe9$export$785bf7d1ab2d87f8 = "/editor/?spin=1&embed=1&proto=json&chrome=0&toolbar=0&configure=1&grid=1";



function $77a7d6c066212564$export$68848ddac0f5dabe(data, { jwt: jwt }) {
    return (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post("/api/v1/drawings", data.xml, {
        headers: {
            Authorization: `Bearer ${jwt}`,
            "Content-Type": "application/xml"
        }
    });
}
function $77a7d6c066212564$export$2c009e4c830c57d8(id, data, { jwt: jwt }) {
    return (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).put(`/api/v1/drawings/${id}`, data.xml, {
        headers: {
            Authorization: `Bearer ${jwt}`,
            "Content-Type": "application/xml"
        }
    });
}




function $00974229370781c2$var$useParentSystemEvents({ onGetImage: onGetImage, onRenderLinkIcons: onRenderLinkIcons, onRemoveLinkIcons: onRemoveLinkIcons, onActivateLinkIcons: onActivateLinkIcons, onDeactivateLinkIcons: onDeactivateLinkIcons, onHighlight: onHighlight, onSavingSuccess: onSavingSuccess, onSavingFailed: onSavingFailed }) {
    const [readyToListen, setReadyToListen] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(false);
    const receiveParentSystemMessages = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((evt)=>{
        if (evt.data.message) switch(evt.data.message){
            case $5ffe098e6e560069$export$de263d49a916f147:
                onGetImage?.();
                break;
            case $5ffe098e6e560069$export$f26c57e51ac4ea52:
                onRenderLinkIcons?.(evt.data.links);
                break;
            case $5ffe098e6e560069$export$5e897e3fa998e5c1:
                onRemoveLinkIcons?.(evt.data.objectIds);
                break;
            case $5ffe098e6e560069$export$204c77719608f548:
                onActivateLinkIcons?.(evt.data.objectIds);
                break;
            case $5ffe098e6e560069$export$39a7e91b3892a011:
                onDeactivateLinkIcons?.(evt.data.objectIds);
                break;
            case $5ffe098e6e560069$export$73f7aa85b0021907:
                onHighlight?.(evt.data.opacity, evt.data.objects);
                break;
            case $5ffe098e6e560069$export$ef1febaf297f2cfc:
                onSavingSuccess?.();
                break;
            case $5ffe098e6e560069$export$7eb593425f027669:
                onSavingFailed?.();
                break;
            default:
                break;
        }
    }, [
        onGetImage,
        onHighlight,
        onRemoveLinkIcons,
        onRenderLinkIcons,
        onActivateLinkIcons,
        onDeactivateLinkIcons,
        onSavingFailed,
        onSavingSuccess
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        window.addEventListener("message", receiveParentSystemMessages);
        setReadyToListen(true);
        return ()=>{
            window.removeEventListener("message", receiveParentSystemMessages);
        };
    }, [
        receiveParentSystemMessages
    ]);
    return readyToListen;
}
var $00974229370781c2$export$2e2bcd8739ae039 = $00974229370781c2$var$useParentSystemEvents;



const $7ede9c8cdddf5721$export$6b60ce27feb4311e = "configure";
const $7ede9c8cdddf5721$export$e1a19a3c81ada28 = "initMenus";
const $7ede9c8cdddf5721$export$d1bd897305076d02 = "stateSaving";
const $7ede9c8cdddf5721$export$954e59a06103d859 = "stateSavingSuccess";
const $7ede9c8cdddf5721$export$e1e598406ea44162 = "stateSavingFailed";
const $7ede9c8cdddf5721$export$2d95f7c8f440a11e = "getLayers";
const $7ede9c8cdddf5721$export$80ca26e36ce5fc7a = "getScale";
const $7ede9c8cdddf5721$export$f26c57e51ac4ea52 = "renderLinkIcons";
const $7ede9c8cdddf5721$export$5e897e3fa998e5c1 = "removeLinkIcons";
const $7ede9c8cdddf5721$export$204c77719608f548 = "activateLinkIcons";
const $7ede9c8cdddf5721$export$39a7e91b3892a011 = "deactivateLinkIcons";
const $7ede9c8cdddf5721$export$505d4fd2b98cd2fc = "toggleLayer";
const $7ede9c8cdddf5721$export$fae5d17304677194 = "scale";
const $7ede9c8cdddf5721$export$db681cc2ef83e91f = "zoomIn";
const $7ede9c8cdddf5721$export$63ea321ad91823a7 = "zoomOut";
const $7ede9c8cdddf5721$export$6e395b72b1ec2d70 = "exportWithObjectData";
const $7ede9c8cdddf5721$export$73f7aa85b0021907 = "highlight";
const $7ede9c8cdddf5721$export$de263d49a916f147 = "getImage";
const $7ede9c8cdddf5721$export$2abd996c98e8a5b1 = "exportWithObjectData";
const $7ede9c8cdddf5721$export$2f1db86e2f145bf5 = "hover";
const $7ede9c8cdddf5721$export$feca3229d3cbc1f4 = "hoverOut";
const $7ede9c8cdddf5721$export$5adb665701eda1ce = "click";
const $7ede9c8cdddf5721$export$618b8e958ed20ed = "clickLinkIcon";
const $7ede9c8cdddf5721$export$e4e23f82cbfc946 = "drawIoLoaded";
function $7ede9c8cdddf5721$var$sendDrawIoMessage(iframe, message) {
    iframe.contentWindow.postMessage(message, "*");
}
function $7ede9c8cdddf5721$export$557b848d06fcf2d3(iframe, objectIds, message) {
    $7ede9c8cdddf5721$var$sendDrawIoMessage(iframe, {
        deleteConfirmationAction: $7ede9c8cdddf5721$export$6b60ce27feb4311e,
        objectIds: objectIds,
        message: message
    });
}
function $7ede9c8cdddf5721$export$df37a732ce70a06d(iframe, config) {
    $7ede9c8cdddf5721$var$sendDrawIoMessage(iframe, {
        editorAction: $7ede9c8cdddf5721$export$e1a19a3c81ada28,
        config: config
    });
}
function $7ede9c8cdddf5721$export$7b2d94cd0594760(iframe) {
    $7ede9c8cdddf5721$var$sendDrawIoMessage(iframe, {
        toolbarAction: $7ede9c8cdddf5721$export$2d95f7c8f440a11e
    });
}
function $7ede9c8cdddf5721$export$7aa5499a3441d1ff(iframe) {
    $7ede9c8cdddf5721$var$sendDrawIoMessage(iframe, {
        toolbarAction: $7ede9c8cdddf5721$export$80ca26e36ce5fc7a
    });
}
function $7ede9c8cdddf5721$export$ccfab31e18fc4e8b(iframe, links) {
    $7ede9c8cdddf5721$var$sendDrawIoMessage(iframe, {
        iconAction: $7ede9c8cdddf5721$export$f26c57e51ac4ea52,
        links: links
    });
}
function $7ede9c8cdddf5721$export$4ac0c38650672a08(iframe, objectIds) {
    $7ede9c8cdddf5721$var$sendDrawIoMessage(iframe, {
        iconAction: $7ede9c8cdddf5721$export$5e897e3fa998e5c1,
        objectIds: objectIds
    });
}
function $7ede9c8cdddf5721$export$46936ac77bc37d1f(iframe, objectIds) {
    $7ede9c8cdddf5721$var$sendDrawIoMessage(iframe, {
        iconAction: $7ede9c8cdddf5721$export$204c77719608f548,
        objectIds: objectIds
    });
}
function $7ede9c8cdddf5721$export$90a9932c28ebf0d7(iframe, objectIds) {
    $7ede9c8cdddf5721$var$sendDrawIoMessage(iframe, {
        iconAction: $7ede9c8cdddf5721$export$39a7e91b3892a011,
        objectIds: objectIds
    });
}
function $7ede9c8cdddf5721$export$71dcb6a93da2d97(iframe, layerId) {
    $7ede9c8cdddf5721$var$sendDrawIoMessage(iframe, {
        toolbarAction: $7ede9c8cdddf5721$export$505d4fd2b98cd2fc,
        layerId: layerId
    });
}
function $7ede9c8cdddf5721$export$bd25ec43a55ac801(iframe, scale) {
    $7ede9c8cdddf5721$var$sendDrawIoMessage(iframe, {
        toolbarAction: $7ede9c8cdddf5721$export$fae5d17304677194,
        scale: scale
    });
}
function $7ede9c8cdddf5721$export$ef96e4a50aa67003(iframe) {
    $7ede9c8cdddf5721$var$sendDrawIoMessage(iframe, {
        toolbarAction: $7ede9c8cdddf5721$export$db681cc2ef83e91f
    });
}
function $7ede9c8cdddf5721$export$e9cd81b7241a6111(iframe) {
    $7ede9c8cdddf5721$var$sendDrawIoMessage(iframe, {
        toolbarAction: $7ede9c8cdddf5721$export$63ea321ad91823a7
    });
}
function $7ede9c8cdddf5721$export$e865a5602f99826b(iframe, originalExportMessage) {
    $7ede9c8cdddf5721$var$sendDrawIoMessage(iframe, {
        message: $7ede9c8cdddf5721$export$6e395b72b1ec2d70,
        originalExportMessage: originalExportMessage
    });
}
function $7ede9c8cdddf5721$export$85ca66bf981551c3(iframe) {
    $7ede9c8cdddf5721$var$sendDrawIoMessage(iframe, {
        editorState: $7ede9c8cdddf5721$export$954e59a06103d859
    });
}
function $7ede9c8cdddf5721$export$39ed7906cc419ab0(iframe) {
    $7ede9c8cdddf5721$var$sendDrawIoMessage(iframe, {
        editorState: $7ede9c8cdddf5721$export$e1e598406ea44162
    });
}
function $7ede9c8cdddf5721$export$fa2694cb3058bf66(iframe, opacity, objects) {
    $7ede9c8cdddf5721$var$sendDrawIoMessage(iframe, {
        styleAction: $7ede9c8cdddf5721$export$73f7aa85b0021907,
        opacity: opacity,
        objects: objects
    });
}
function $7ede9c8cdddf5721$export$37fc649e9981c658(iframe) {
    $7ede9c8cdddf5721$var$sendDrawIoMessage(iframe, {
        message: $7ede9c8cdddf5721$export$e4e23f82cbfc946
    });
}


function $6a131471210cea5c$var$useDrawIoPluginsApi(drawIoRef) {
    const renderLinkIcons = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((links)=>$7ede9c8cdddf5721$export$ccfab31e18fc4e8b(drawIoRef.current, links), [
        drawIoRef
    ]);
    const removeLinkIcons = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((objectIds)=>$7ede9c8cdddf5721$export$4ac0c38650672a08(drawIoRef.current, objectIds), [
        drawIoRef
    ]);
    const activateLinkIcons = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((objectIds)=>$7ede9c8cdddf5721$export$46936ac77bc37d1f(drawIoRef.current, objectIds), [
        drawIoRef
    ]);
    const deactivateLinkIcons = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((objectIds)=>$7ede9c8cdddf5721$export$90a9932c28ebf0d7(drawIoRef.current, objectIds), [
        drawIoRef
    ]);
    const highlight = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((opacity, objectIds)=>$7ede9c8cdddf5721$export$fa2694cb3058bf66(drawIoRef.current, opacity, objectIds), [
        drawIoRef
    ]);
    const setSavingStateSuccess = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>$7ede9c8cdddf5721$export$85ca66bf981551c3(drawIoRef.current), [
        drawIoRef
    ]);
    const setSavingStateFailed = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>$7ede9c8cdddf5721$export$39ed7906cc419ab0(drawIoRef.current), [
        drawIoRef
    ]);
    const configureDeleteConfirmation = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((objectIds, message)=>$7ede9c8cdddf5721$export$557b848d06fcf2d3(drawIoRef.current, objectIds, message), [
        drawIoRef
    ]);
    const initMenus = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((configuration)=>$7ede9c8cdddf5721$export$df37a732ce70a06d(drawIoRef.current, configuration), [
        drawIoRef
    ]);
    const exportWithObjectData = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((originalExportMessage)=>$7ede9c8cdddf5721$export$e865a5602f99826b(drawIoRef.current, originalExportMessage), [
        drawIoRef
    ]);
    const informDrawIoIsLoaded = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>$7ede9c8cdddf5721$export$37fc649e9981c658(drawIoRef.current), [
        drawIoRef
    ]);
    return {
        renderLinkIcons: renderLinkIcons,
        removeLinkIcons: removeLinkIcons,
        activateLinkIcons: activateLinkIcons,
        deactivateLinkIcons: deactivateLinkIcons,
        highlight: highlight,
        setSavingStateFailed: setSavingStateFailed,
        setSavingStateSuccess: setSavingStateSuccess,
        configureDeleteConfirmation: configureDeleteConfirmation,
        initMenus: initMenus,
        exportWithObjectData: exportWithObjectData,
        informDrawIoIsLoaded: informDrawIoIsLoaded
    };
}
var $6a131471210cea5c$export$2e2bcd8739ae039 = $6a131471210cea5c$var$useDrawIoPluginsApi;



const $79b4b7ce969dfc1f$export$c2f1dc8c266df5c6 = "load";
const $79b4b7ce969dfc1f$export$913b189fef2e8b23 = "export";
const $79b4b7ce969dfc1f$export$d6c864855ddd310f = "configure";
const $79b4b7ce969dfc1f$export$1ecb7f7c79c250da = "png";
const $79b4b7ce969dfc1f$export$7c24b7da9e68e32f = "init";
const $79b4b7ce969dfc1f$export$41b2264feb1fd8fb = "load";
const $79b4b7ce969dfc1f$export$4b2dffa8820ba30c = "save";
const $79b4b7ce969dfc1f$export$fd381237ce43fc80 = "configure";
const $79b4b7ce969dfc1f$export$8cdc228205c5f9f3 = "export";
const $79b4b7ce969dfc1f$export$3ca6aa523ed0b4f9 = "exit";
function $79b4b7ce969dfc1f$var$sendDrawIoMessage(iframe, msg) {
    iframe.contentWindow.postMessage(JSON.stringify(msg), "*");
}
function $79b4b7ce969dfc1f$export$3fd7ca7993daa918(iframe, xml) {
    $79b4b7ce969dfc1f$var$sendDrawIoMessage(iframe, {
        action: $79b4b7ce969dfc1f$export$c2f1dc8c266df5c6,
        autosave: 0,
        xml: xml
    });
}
function $79b4b7ce969dfc1f$export$d1100b21ea20bd46(iframe) {
    $79b4b7ce969dfc1f$var$sendDrawIoMessage(iframe, {
        action: $79b4b7ce969dfc1f$export$913b189fef2e8b23,
        format: $79b4b7ce969dfc1f$export$1ecb7f7c79c250da
    });
}
function $79b4b7ce969dfc1f$export$d037512f99596d45(iframe, config) {
    $79b4b7ce969dfc1f$var$sendDrawIoMessage(iframe, {
        action: $79b4b7ce969dfc1f$export$d6c864855ddd310f,
        config: config
    });
}


function $bcccd94ae87225f9$var$useDrawIoEvents({ onConfigure: onConfigure, onInit: onInit, onLoad: onLoad, onSave: onSave, onExport: onExport, onExit: onExit }) {
    const [readyToListen, setReadyToListen] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(false);
    const receiveDrawIoMessages = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((evt)=>{
        if (evt.data.length > 0) {
            const msg = JSON.parse(evt.data);
            switch(msg.event){
                case $79b4b7ce969dfc1f$export$fd381237ce43fc80:
                    onConfigure?.(msg);
                    break;
                case $79b4b7ce969dfc1f$export$7c24b7da9e68e32f:
                    onInit?.(msg);
                    break;
                case $79b4b7ce969dfc1f$export$41b2264feb1fd8fb:
                    onLoad?.(msg);
                    break;
                case $79b4b7ce969dfc1f$export$4b2dffa8820ba30c:
                    onSave?.(msg);
                    break;
                case $79b4b7ce969dfc1f$export$8cdc228205c5f9f3:
                    onExport?.(msg);
                    break;
                case $79b4b7ce969dfc1f$export$3ca6aa523ed0b4f9:
                    onExit?.(msg);
                    break;
                default:
                    break;
            }
        }
    }, [
        onConfigure,
        onExit,
        onExport,
        onInit,
        onLoad,
        onSave
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        window.addEventListener("message", receiveDrawIoMessages);
        setReadyToListen(true);
        return ()=>{
            window.removeEventListener("message", receiveDrawIoMessages);
        };
    }, [
        receiveDrawIoMessages
    ]);
    return readyToListen;
}
var $bcccd94ae87225f9$export$2e2bcd8739ae039 = $bcccd94ae87225f9$var$useDrawIoEvents;




function $b7c7131e4fc050fe$var$useDrawIoApi(drawIoRef) {
    const configure = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((configuration)=>$79b4b7ce969dfc1f$export$d037512f99596d45(drawIoRef.current, configuration), [
        drawIoRef
    ]);
    const load = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((xml)=>$79b4b7ce969dfc1f$export$3fd7ca7993daa918(drawIoRef.current, xml), [
        drawIoRef
    ]);
    const exportPng = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>$79b4b7ce969dfc1f$export$d1100b21ea20bd46(drawIoRef.current), [
        drawIoRef
    ]);
    return {
        configure: configure,
        load: load,
        exportPng: exportPng
    };
}
var $b7c7131e4fc050fe$export$2e2bcd8739ae039 = $b7c7131e4fc050fe$var$useDrawIoApi;




function $b41b4234c52865cd$var$useParentSystemApi() {
    const triggerLoad = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((height)=>$5ffe098e6e560069$export$3fd7ca7993daa918(height), []);
    const triggerViewerEvent = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((evt)=>$5ffe098e6e560069$export$c0bd7ff637c35648(evt), []);
    const sendImage = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((img)=>$5ffe098e6e560069$export$60072eb1fc683daf(img), []);
    const triggerExit = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>$5ffe098e6e560069$export$bf844755cacf5eeb(), []);
    const triggerJwtUpdate = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>$5ffe098e6e560069$export$5a4edfb6cfce8da2(), []);
    const triggerSave = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((uuid, image, objectData)=>$5ffe098e6e560069$export$167a6e0c4c2a8c73(uuid, image, objectData), []);
    const triggerUpdate = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((uuid, image, objectData)=>$5ffe098e6e560069$export$634e8c9c16324be9(uuid, image, objectData), []);
    return {
        triggerLoad: triggerLoad,
        triggerViewerEvent: triggerViewerEvent,
        sendImage: sendImage,
        triggerExit: triggerExit,
        triggerJwtUpdate: triggerJwtUpdate,
        triggerSave: triggerSave,
        triggerUpdate: triggerUpdate
    };
}
var $b41b4234c52865cd$export$2e2bcd8739ae039 = $b41b4234c52865cd$var$useParentSystemApi;



function $89a0aee218b31b1b$var$useDrawIoPluginEvents({ onViewerEvent: onViewerEvent, onExportEvent: onExportEvent }) {
    const [readyToListen, setReadyToListen] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(false);
    const receiveDrawIoPluginMessages = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((evt)=>{
        if (evt.data.viewerEvent) onViewerEvent?.(evt);
        if (evt.data.exportEvent) onExportEvent?.(evt);
    }, [
        onViewerEvent,
        onExportEvent
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        window.addEventListener("message", receiveDrawIoPluginMessages);
        setReadyToListen(true);
        return ()=>{
            window.removeEventListener("message", receiveDrawIoPluginMessages);
        };
    }, [
        receiveDrawIoPluginMessages
    ]);
    return readyToListen;
}
var $89a0aee218b31b1b$export$2e2bcd8739ae039 = $89a0aee218b31b1b$var$useDrawIoPluginEvents;




var $9eb2a280729c9dcf$exports = {};
"use strict";

var $9eb2a280729c9dcf$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $9eb2a280729c9dcf$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $9eb2a280729c9dcf$var$LoadingIcon = function LoadingIcon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === undefined ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === undefined ? 24 : _ref$size, children = _ref.children, props = $9eb2a280729c9dcf$var$objectWithoutProperties(_ref, [
        "color",
        "size",
        "children"
    ]);
    var className = "mdi-icon " + (props.class || props.className || "");
    return $13c40c34b78c8ee2$export$c8a8987d4410bf2d("svg", $9eb2a280729c9dcf$var$_extends({}, props, {
        "class": className,
        width: size,
        height: size,
        fill: color,
        viewBox: "0 0 24 24"
    }), $13c40c34b78c8ee2$export$c8a8987d4410bf2d("path", {
        d: "M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"
    }));
};
$9eb2a280729c9dcf$exports = $9eb2a280729c9dcf$var$LoadingIcon;


const $ca26d6bd0b19d011$export$910b680d1eea6990 = "en";
var $ca26d6bd0b19d011$export$2e2bcd8739ae039 = {
    EXPORT: {
        en: "Export",
        fi: "Vie"
    },
    FULL_SCREEN: {
        en: "Full screen",
        fi: "Koko n\xe4ytt\xf6"
    },
    EXIT_FULL_SCREEN: {
        en: "Exit full screen",
        fi: "Poistu koko n\xe4yt\xf6n tilasta"
    },
    LAYERS: {
        en: "Layers",
        fi: "Tasot"
    },
    LOADING: {
        en: "Loading",
        fi: "Ladataan"
    },
    ZOOM: {
        en: "Zoom",
        fi: "Zoomaa"
    },
    ZOOM_IN: {
        en: "Zoom in",
        fi: "L\xe4henn\xe4"
    },
    ZOOM_OUT: {
        en: "Zoom out",
        fi: "Loitonna"
    }
};


function $d59e6dd9d7beef66$var$LoadingScreen({ spinnerColor: spinnerColor = "#4d4d4d", language: language }) {
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        className: "loading-screen",
        "data-testid": "loading-screen",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($9eb2a280729c9dcf$exports))), {
                "data-testid": "spinner",
                style: {
                    color: spinnerColor
                }
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                className: "loading-text",
                "data-testid": "loading-text",
                children: `${(0, $ca26d6bd0b19d011$export$2e2bcd8739ae039).LOADING[language] || (0, $ca26d6bd0b19d011$export$2e2bcd8739ae039).LOADING[0, $ca26d6bd0b19d011$export$910b680d1eea6990]}...`
            })
        ]
    });
}
var $d59e6dd9d7beef66$export$2e2bcd8739ae039 = $d59e6dd9d7beef66$var$LoadingScreen;



// currently drawio doesn't allow untrusted plugins to be configured in embedded mode
// so we have to use this workaround to inject our custom plugins to drawio configuration
// also if no plugins is passed we also want to clear existing plugins
// to avoid unexpected behaviour caused by stale configurations
function $86ceef0d553066ce$var$setDrawIoPluginsToLocalStorageConfig(plugins) {
    const drawIoConfig = JSON.parse(localStorage.getItem(".drawio-config"));
    localStorage.setItem(".drawio-config", JSON.stringify({
        ...drawIoConfig,
        plugins: plugins
    }));
}
function $86ceef0d553066ce$var$useDrawIoPlugins(plugins) {
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        $86ceef0d553066ce$var$setDrawIoPluginsToLocalStorageConfig(plugins || []);
    }, [
        plugins
    ]);
}
var $86ceef0d553066ce$export$2e2bcd8739ae039 = $86ceef0d553066ce$var$useDrawIoPlugins;


const $67ec855308ffbdb8$export$880e502895606525 = {
    compressXml: true
};
const $67ec855308ffbdb8$export$85f9a49433c01dc = {
    disable: {
        menus: [
            "embed"
        ],
        actions: [
            "plugins",
            "exportUrl"
        ]
    }
};


function $5e4c5940bc0b4610$var$Wrapper(props) {
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $8a23c0557a977d39$export$3d84f372296c3d76), {
        ...props,
        children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($5e4c5940bc0b4610$var$Editor, {})
    });
}
function $5e4c5940bc0b4610$var$Editor() {
    const { parentSystemConfiguration: parentSystemConfiguration, applicationInsights: applicationInsights, xml: xml, uuid: uuid, lang: lang } = (0, $8a23c0557a977d39$export$730006aaa55ed657)();
    const drawIoRef = (0, $204a33a7557cbbd0$export$b8f5890fc79d6aca)(null);
    const [drawIoLoaded, setDrawIoLoaded] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(false);
    const [id, setId] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(uuid);
    const [, setSaving] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(false);
    const [failedSaveRequest, setFailedSaveRequest] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(null);
    (0, $86ceef0d553066ce$export$2e2bcd8739ae039)([
        "/src/plugins/uniqueid.js",
        "/src/plugins/export.js",
        "/src/plugins/editor-menu.js",
        ...parentSystemConfiguration?.deleteConfirmation ? [
            "/src/plugins/delete-confirmation.js"
        ] : []
    ]);
    const { configure: configureDrawIo, load: loadDrawIo, exportPng: exportPng } = (0, $b7c7131e4fc050fe$export$2e2bcd8739ae039)(drawIoRef);
    const { setSavingStateSuccess: setSavingStateSuccess, setSavingStateFailed: setDrawIoSavingStateFailed, configureDeleteConfirmation: configureDeleteConfirmation, initMenus: initMenus, exportWithObjectData: exportWithObjectData } = (0, $6a131471210cea5c$export$2e2bcd8739ae039)(drawIoRef);
    const { triggerExit: triggerExit, triggerJwtUpdate: triggerJwtUpdate, triggerSave: triggerParentSystemSave, triggerUpdate: triggerParentSystemUpdate } = (0, $b41b4234c52865cd$export$2e2bcd8739ae039)();
    const handleConfigure = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>configureDrawIo({
            ...(0, $67ec855308ffbdb8$export$880e502895606525),
            ...parentSystemConfiguration?.drawioConfiguration
        }), [
        configureDrawIo,
        parentSystemConfiguration?.drawioConfiguration
    ]);
    const handleDrawIoInit = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>{
        loadDrawIo(xml);
    }, [
        loadDrawIo,
        xml
    ]);
    const handleLoad = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>{
        if (parentSystemConfiguration?.deleteConfirmation) {
            const { objectIds: objectIds, message: message } = parentSystemConfiguration.deleteConfirmation;
            configureDeleteConfirmation(objectIds, message);
        }
        initMenus((0, $67ec855308ffbdb8$export$85f9a49433c01dc));
        setDrawIoLoaded(true);
    }, [
        parentSystemConfiguration,
        configureDeleteConfirmation,
        initMenus
    ]);
    const handleExit = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>{
        triggerExit();
    }, [
        triggerExit
    ]);
    const handleExport = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((msg)=>{
        exportWithObjectData(msg);
    }, [
        exportWithObjectData
    ]);
    const saveNewDrawing = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((data, authentication)=>{
        (0, $77a7d6c066212564$export$68848ddac0f5dabe)(data, authentication).then((response)=>{
            setId(response.data.uuid);
            triggerParentSystemSave(response.data.uuid, data.image, data.objectData);
        }).catch((error)=>{
            if (error.response && error.response.status === 401) {
                triggerJwtUpdate();
                setFailedSaveRequest({
                    data: data,
                    authentication: authentication
                });
            } else setDrawIoSavingStateFailed();
            console.error(error.message);
        }).finally(()=>{
            setSaving(false);
        });
    }, [
        setDrawIoSavingStateFailed,
        triggerJwtUpdate,
        triggerParentSystemSave
    ]);
    const updateDrawing = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((data, authentication)=>{
        (0, $77a7d6c066212564$export$2c009e4c830c57d8)(id, data, authentication).then(()=>{
            triggerParentSystemUpdate(id, data.image, data.objectData);
        }).catch((error)=>{
            if (error.response && error.response.status === 401) {
                triggerJwtUpdate();
                setFailedSaveRequest({
                    data: data,
                    authentication: authentication
                });
            } else setDrawIoSavingStateFailed();
            console.error(error.message);
        }).finally(()=>{
            setSaving(false);
        });
    }, [
        id,
        setDrawIoSavingStateFailed,
        triggerJwtUpdate,
        triggerParentSystemUpdate
    ]);
    const saveDrawing = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((data, authentication)=>{
        if (id) updateDrawing(data, authentication);
        else saveNewDrawing(data, authentication);
    }, [
        id,
        updateDrawing,
        saveNewDrawing
    ]);
    const handleSave = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((data)=>setSaving((prevState)=>{
            const noPendingSaveRequests = !prevState;
            if (noPendingSaveRequests) saveDrawing(data, parentSystemConfiguration.authentication);
            return true;
        }), [
        saveDrawing,
        parentSystemConfiguration
    ]);
    const handleExportWithObjectData = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((evt)=>handleSave(evt.data.data), [
        handleSave
    ]);
    const readyToListenParentSystemEvents = (0, $00974229370781c2$export$2e2bcd8739ae039)({
        onSavingSuccess: setSavingStateSuccess,
        onSavingFailed: setDrawIoSavingStateFailed
    });
    const readyToListenDrawIoEvents = (0, $bcccd94ae87225f9$export$2e2bcd8739ae039)({
        onConfigure: handleConfigure,
        onInit: handleDrawIoInit,
        onSave: exportPng,
        onExport: handleExport,
        onLoad: handleLoad,
        onExit: handleExit
    });
    const readyToListenDrawIoPluginEvents = (0, $89a0aee218b31b1b$export$2e2bcd8739ae039)({
        onExportEvent: handleExportWithObjectData
    });
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        if (failedSaveRequest && failedSaveRequest.authentication.jwt !== parentSystemConfiguration.authentication.jwt) {
            saveDrawing(failedSaveRequest.data, parentSystemConfiguration.authentication);
            setFailedSaveRequest(null);
        }
    }, [
        failedSaveRequest,
        parentSystemConfiguration,
        saveDrawing
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        if (applicationInsights) applicationInsights.trackPageView();
    }, [
        applicationInsights
    ]);
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        className: "drawio",
        children: [
            readyToListenParentSystemEvents && readyToListenDrawIoEvents && readyToListenDrawIoPluginEvents ? /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("iframe", {
                ref: drawIoRef,
                src: `${(0, $cf92d1b7e7859fe9$export$56a2318c6197b5fa)}&lang=${lang}`,
                title: "drawio",
                "data-testid": "drawio"
            }) : null,
            drawIoLoaded ? null : /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $d59e6dd9d7beef66$export$2e2bcd8739ae039), {
                language: lang,
                spinnerColor: parentSystemConfiguration.colors?.spinner
            })
        ]
    });
}
var $5e4c5940bc0b4610$export$2e2bcd8739ae039 = $5e4c5940bc0b4610$var$Wrapper;















function $30f23c2abbe74fa9$var$ToolbarButton({ children: children, tooltipText: tooltipText, onClick: onClick, disabled: disabled, selected: selected, testid: testid }) {
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
        className: `toolbar-btn ${selected ? "selected" : ""}`,
        onClick: onClick,
        disabled: disabled,
        "data-testid": testid,
        children: [
            children,
            selected ? null : /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                className: "tooltip",
                "data-testid": `${testid}-tooltip`,
                children: tooltipText
            })
        ]
    });
}
var $30f23c2abbe74fa9$export$2e2bcd8739ae039 = $30f23c2abbe74fa9$var$ToolbarButton;




function $73dfc3d1e46150f3$var$Dropdown({ children: children, testid: testid }) {
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        className: "dropdown-container",
        "data-testid": testid,
        children: children
    });
}
var $73dfc3d1e46150f3$export$2e2bcd8739ae039 = $73dfc3d1e46150f3$var$Dropdown;






function $8013f63ab4def1fc$var$DropdownListItemText({ text: text }) {
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        className: "list-item-text",
        children: text
    });
}
var $8013f63ab4def1fc$export$2e2bcd8739ae039 = $8013f63ab4def1fc$var$DropdownListItemText;


function $abfdfc93d692bded$var$DropdownValueItem({ onValueClick: onValueClick, value: value, text: text }) {
    function handleOnClick() {
        onValueClick(value);
    }
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        className: "dropdown-list-item",
        onClick: handleOnClick,
        children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $8013f63ab4def1fc$export$2e2bcd8739ae039), {
            text: text
        })
    });
}
var $abfdfc93d692bded$export$2e2bcd8739ae039 = $abfdfc93d692bded$var$DropdownValueItem;




function $2184b887078c765b$var$ToolbarButtonWithDropdown({ button: button, showDropdown: showDropdown, dropdown: dropdown }) {
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        className: "toolbar-btn-with-dropdown-container",
        children: [
            button,
            showDropdown ? dropdown : null
        ]
    });
}
var $2184b887078c765b$export$2e2bcd8739ae039 = $2184b887078c765b$var$ToolbarButtonWithDropdown;




function $6b4bcb490beea368$var$Zoom({ toggleDropdown: toggleDropdown, showDropdown: showDropdown, drawIoRef: drawIoRef, language: language }) {
    const [zoom, setZoom] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(100);
    const onZoomClick = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((value)=>{
        (0, $7ede9c8cdddf5721$export$bd25ec43a55ac801)(drawIoRef.current, value);
        toggleDropdown();
    }, [
        drawIoRef,
        toggleDropdown
    ]);
    const receive = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((evt)=>{
        if (evt.data.scale) setZoom(Math.trunc(evt.data.scale * 100));
    }, []);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        window.addEventListener("message", receive);
        (0, $7ede9c8cdddf5721$export$7aa5499a3441d1ff)(drawIoRef.current);
        return ()=>{
            window.removeEventListener("message", receive);
        };
    }, [
        receive,
        drawIoRef
    ]);
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $2184b887078c765b$export$2e2bcd8739ae039), {
        button: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $30f23c2abbe74fa9$export$2e2bcd8739ae039), {
            onClick: toggleDropdown,
            tooltipText: (0, $ca26d6bd0b19d011$export$2e2bcd8739ae039).ZOOM[language],
            selected: showDropdown,
            testid: "zoom-btn",
            children: `${zoom}%`
        }),
        dropdown: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $73dfc3d1e46150f3$export$2e2bcd8739ae039), {
            testid: "zoom-dropdown-container",
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $abfdfc93d692bded$export$2e2bcd8739ae039), {
                    onValueClick: onZoomClick,
                    text: "50%",
                    value: 0.5
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $abfdfc93d692bded$export$2e2bcd8739ae039), {
                    onValueClick: onZoomClick,
                    text: "100%",
                    value: 1
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $abfdfc93d692bded$export$2e2bcd8739ae039), {
                    onValueClick: onZoomClick,
                    text: "200%",
                    value: 2
                })
            ]
        }),
        showDropdown: showDropdown
    });
}
var $6b4bcb490beea368$export$2e2bcd8739ae039 = $6b4bcb490beea368$var$Zoom;





var $ea81af0d91f9da51$exports = {};
"use strict";

var $ea81af0d91f9da51$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $ea81af0d91f9da51$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $ea81af0d91f9da51$var$PlusIcon = function PlusIcon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === undefined ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === undefined ? 24 : _ref$size, children = _ref.children, props = $ea81af0d91f9da51$var$objectWithoutProperties(_ref, [
        "color",
        "size",
        "children"
    ]);
    var className = "mdi-icon " + (props.class || props.className || "");
    return $13c40c34b78c8ee2$export$c8a8987d4410bf2d("svg", $ea81af0d91f9da51$var$_extends({}, props, {
        "class": className,
        width: size,
        height: size,
        fill: color,
        viewBox: "0 0 24 24"
    }), $13c40c34b78c8ee2$export$c8a8987d4410bf2d("path", {
        d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
    }));
};
$ea81af0d91f9da51$exports = $ea81af0d91f9da51$var$PlusIcon;





function $69df16dd683a3135$var$ZoomIn({ drawIoRef: drawIoRef, language: language }) {
    const zoomIn = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>{
        (0, $7ede9c8cdddf5721$export$ef96e4a50aa67003)(drawIoRef.current);
    }, [
        drawIoRef
    ]);
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $30f23c2abbe74fa9$export$2e2bcd8739ae039), {
        onClick: zoomIn,
        tooltipText: (0, $ca26d6bd0b19d011$export$2e2bcd8739ae039).ZOOM_IN[language],
        testid: "zoom-in-btn",
        children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ea81af0d91f9da51$exports))), {})
    });
}
var $69df16dd683a3135$export$2e2bcd8739ae039 = $69df16dd683a3135$var$ZoomIn;





var $0f8fd6cc5602d51b$exports = {};
"use strict";

var $0f8fd6cc5602d51b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $0f8fd6cc5602d51b$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $0f8fd6cc5602d51b$var$MinusIcon = function MinusIcon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === undefined ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === undefined ? 24 : _ref$size, children = _ref.children, props = $0f8fd6cc5602d51b$var$objectWithoutProperties(_ref, [
        "color",
        "size",
        "children"
    ]);
    var className = "mdi-icon " + (props.class || props.className || "");
    return $13c40c34b78c8ee2$export$c8a8987d4410bf2d("svg", $0f8fd6cc5602d51b$var$_extends({}, props, {
        "class": className,
        width: size,
        height: size,
        fill: color,
        viewBox: "0 0 24 24"
    }), $13c40c34b78c8ee2$export$c8a8987d4410bf2d("path", {
        d: "M19,13H5V11H19V13Z"
    }));
};
$0f8fd6cc5602d51b$exports = $0f8fd6cc5602d51b$var$MinusIcon;





function $25d339993bcbc2fc$var$ZoomOut({ drawIoRef: drawIoRef, language: language }) {
    const zoomOut = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>{
        (0, $7ede9c8cdddf5721$export$e9cd81b7241a6111)(drawIoRef.current);
    }, [
        drawIoRef
    ]);
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $30f23c2abbe74fa9$export$2e2bcd8739ae039), {
        onClick: zoomOut,
        tooltipText: (0, $ca26d6bd0b19d011$export$2e2bcd8739ae039).ZOOM_OUT[language],
        testid: "zoom-out-btn",
        children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($0f8fd6cc5602d51b$exports))), {})
    });
}
var $25d339993bcbc2fc$export$2e2bcd8739ae039 = $25d339993bcbc2fc$var$ZoomOut;





var $ca7613def1ab856a$exports = {};
"use strict";

var $ca7613def1ab856a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $ca7613def1ab856a$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $ca7613def1ab856a$var$LayersOutlineIcon = function LayersOutlineIcon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === undefined ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === undefined ? 24 : _ref$size, children = _ref.children, props = $ca7613def1ab856a$var$objectWithoutProperties(_ref, [
        "color",
        "size",
        "children"
    ]);
    var className = "mdi-icon " + (props.class || props.className || "");
    return $13c40c34b78c8ee2$export$c8a8987d4410bf2d("svg", $ca7613def1ab856a$var$_extends({}, props, {
        "class": className,
        width: size,
        height: size,
        fill: color,
        viewBox: "0 0 24 24"
    }), $13c40c34b78c8ee2$export$c8a8987d4410bf2d("path", {
        d: "M12,18.54L19.37,12.8L21,14.07L12,21.07L3,14.07L4.62,12.81L12,18.54M12,16L3,9L12,2L21,9L12,16M12,4.53L6.26,9L12,13.47L17.74,9L12,4.53Z"
    }));
};
$ca7613def1ab856a$exports = $ca7613def1ab856a$var$LayersOutlineIcon;









var $c6787ef409d66408$exports = {};
"use strict";

var $c6787ef409d66408$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $c6787ef409d66408$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $c6787ef409d66408$var$CheckIcon = function CheckIcon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === undefined ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === undefined ? 24 : _ref$size, children = _ref.children, props = $c6787ef409d66408$var$objectWithoutProperties(_ref, [
        "color",
        "size",
        "children"
    ]);
    var className = "mdi-icon " + (props.class || props.className || "");
    return $13c40c34b78c8ee2$export$c8a8987d4410bf2d("svg", $c6787ef409d66408$var$_extends({}, props, {
        "class": className,
        width: size,
        height: size,
        fill: color,
        viewBox: "0 0 24 24"
    }), $13c40c34b78c8ee2$export$c8a8987d4410bf2d("path", {
        d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
    }));
};
$c6787ef409d66408$exports = $c6787ef409d66408$var$CheckIcon;



function $3a53f86a73755461$var$DropdownCheckboxItem({ htmlFor: htmlFor, checked: checked, onChange: onChange, item: item, text: text }) {
    function handleOnChange() {
        onChange(item);
    }
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("label", {
        className: "checkbox-container dropdown-list-item",
        htmlFor: htmlFor,
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("input", {
                id: htmlFor,
                checked: checked,
                className: "checkbox-input",
                type: "checkbox",
                "data-testid": htmlFor,
                onChange: handleOnChange
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                className: "check-icon",
                children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($c6787ef409d66408$exports))), {})
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $8013f63ab4def1fc$export$2e2bcd8739ae039), {
                text: text
            })
        ]
    });
}
var $3a53f86a73755461$export$2e2bcd8739ae039 = $3a53f86a73755461$var$DropdownCheckboxItem;


function $fa509516b7147b7b$var$LayerDropdown({ layers: layers, onItemChange: onItemChange }) {
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $73dfc3d1e46150f3$export$2e2bcd8739ae039), {
        testid: "layer-dropdown",
        children: layers.map((layer)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $3a53f86a73755461$export$2e2bcd8739ae039), {
                checked: layer.visible,
                item: layer,
                onChange: onItemChange,
                htmlFor: `layer-checkbox-${layer.id}`,
                text: layer.name
            }))
    });
}
var $fa509516b7147b7b$export$2e2bcd8739ae039 = $fa509516b7147b7b$var$LayerDropdown;




function $1e8f343bb6ba9f22$var$Layers({ toggleDropdown: toggleDropdown, showDropdown: showDropdown, drawIoRef: drawIoRef, language: language }) {
    const [layers, setLayers] = (0, $204a33a7557cbbd0$export$60241385465d0a34)([]);
    const toggleLayer = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(({ id: id })=>{
        (0, $7ede9c8cdddf5721$export$71dcb6a93da2d97)(drawIoRef.current, id);
    }, [
        drawIoRef
    ]);
    const receive = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((evt)=>{
        if (evt.data.layers) setLayers(evt.data.layers);
    }, []);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        window.addEventListener("message", receive);
        (0, $7ede9c8cdddf5721$export$7b2d94cd0594760)(drawIoRef.current);
        return ()=>{
            window.removeEventListener("message", receive);
        };
    }, [
        receive,
        drawIoRef
    ]);
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $2184b887078c765b$export$2e2bcd8739ae039), {
        button: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $30f23c2abbe74fa9$export$2e2bcd8739ae039), {
            onClick: toggleDropdown,
            tooltipText: (0, $ca26d6bd0b19d011$export$2e2bcd8739ae039).LAYERS[language],
            disabled: layers.length < 2,
            selected: showDropdown,
            testid: "layers-btn",
            children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ca7613def1ab856a$exports))), {})
        }),
        dropdown: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $fa509516b7147b7b$export$2e2bcd8739ae039), {
            layers: layers,
            onItemChange: toggleLayer
        }),
        showDropdown: showDropdown
    });
}
var $1e8f343bb6ba9f22$export$2e2bcd8739ae039 = $1e8f343bb6ba9f22$var$Layers;





var $d31185463f33a344$exports = {};
"use strict";

var $d31185463f33a344$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $d31185463f33a344$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $d31185463f33a344$var$DownloadOutlineIcon = function DownloadOutlineIcon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === undefined ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === undefined ? 24 : _ref$size, children = _ref.children, props = $d31185463f33a344$var$objectWithoutProperties(_ref, [
        "color",
        "size",
        "children"
    ]);
    var className = "mdi-icon " + (props.class || props.className || "");
    return $13c40c34b78c8ee2$export$c8a8987d4410bf2d("svg", $d31185463f33a344$var$_extends({}, props, {
        "class": className,
        width: size,
        height: size,
        fill: color,
        viewBox: "0 0 24 24"
    }), $13c40c34b78c8ee2$export$c8a8987d4410bf2d("path", {
        d: "M13,5V11H14.17L12,13.17L9.83,11H11V5H13M15,3H9V9H5L12,16L19,9H15V3M19,18H5V20H19V18Z"
    }));
};
$d31185463f33a344$exports = $d31185463f33a344$var$DownloadOutlineIcon;







function $37ca85d7e49da201$var$DropdownListItem({ onClick: onClick, text: text }) {
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        className: "dropdown-list-item",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $8013f63ab4def1fc$export$2e2bcd8739ae039), {
            text: text
        })
    });
}
var $37ca85d7e49da201$export$2e2bcd8739ae039 = $37ca85d7e49da201$var$DropdownListItem;




function $4901755b44fe4428$export$2e2bcd8739ae039(dataURI, filename) {
    const link = document.createElement("a");
    link.href = dataURI;
    link.download = filename;
    link.click();
}


function $4de3413d6541ee3d$var$Exports({ toggleDropdown: toggleDropdown, showDropdown: showDropdown, uuid: uuid, xml: xml, language: language, onExportPng: onExportPng }) {
    const exportXml = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>{
        const file = new Blob([
            xml
        ], {
            type: "text/xml"
        });
        const filename = `${uuid}.xml`;
        if (window.navigator && window.navigator.msSaveBlob) window.navigator.msSaveBlob(file, filename);
        else (0, $4901755b44fe4428$export$2e2bcd8739ae039)(URL.createObjectURL(file), filename);
    }, [
        uuid,
        xml
    ]);
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $2184b887078c765b$export$2e2bcd8739ae039), {
        button: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $30f23c2abbe74fa9$export$2e2bcd8739ae039), {
            onClick: toggleDropdown,
            tooltipText: (0, $ca26d6bd0b19d011$export$2e2bcd8739ae039).EXPORT[language],
            selected: showDropdown,
            testid: "export-btn",
            children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d31185463f33a344$exports))), {})
        }),
        dropdown: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $73dfc3d1e46150f3$export$2e2bcd8739ae039), {
            testid: "export-dropdown-container",
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $37ca85d7e49da201$export$2e2bcd8739ae039), {
                    onClick: onExportPng,
                    text: "PNG"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $37ca85d7e49da201$export$2e2bcd8739ae039), {
                    onClick: exportXml,
                    text: "XML"
                })
            ]
        }),
        showDropdown: showDropdown
    });
}
var $4de3413d6541ee3d$export$2e2bcd8739ae039 = $4de3413d6541ee3d$var$Exports;



function $c3cb55beadcde167$var$useComponentVisible(current) {
    const [visible, setVisible] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(current);
    const ref = (0, $204a33a7557cbbd0$export$b8f5890fc79d6aca)(null);
    const handleClickOutside = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((event)=>{
        if (ref.current.base && !ref.current.base.contains(event.target)) setVisible(false);
    }, [
        ref
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        document.addEventListener("click", handleClickOutside, true);
        return ()=>{
            document.removeEventListener("click", handleClickOutside, true);
        };
    }, [
        handleClickOutside
    ]);
    return {
        ref: ref,
        visible: visible,
        setVisible: setVisible
    };
}
var $c3cb55beadcde167$export$2e2bcd8739ae039 = $c3cb55beadcde167$var$useComponentVisible;






var $a2c96a06e79eea26$exports = {};
"use strict";

var $a2c96a06e79eea26$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $a2c96a06e79eea26$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $a2c96a06e79eea26$var$FullscreenIcon = function FullscreenIcon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === undefined ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === undefined ? 24 : _ref$size, children = _ref.children, props = $a2c96a06e79eea26$var$objectWithoutProperties(_ref, [
        "color",
        "size",
        "children"
    ]);
    var className = "mdi-icon " + (props.class || props.className || "");
    return $13c40c34b78c8ee2$export$c8a8987d4410bf2d("svg", $a2c96a06e79eea26$var$_extends({}, props, {
        "class": className,
        width: size,
        height: size,
        fill: color,
        viewBox: "0 0 24 24"
    }), $13c40c34b78c8ee2$export$c8a8987d4410bf2d("path", {
        d: "M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z"
    }));
};
$a2c96a06e79eea26$exports = $a2c96a06e79eea26$var$FullscreenIcon;


var $7d75bfc46d478d61$exports = {};
"use strict";

var $7d75bfc46d478d61$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $7d75bfc46d478d61$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $7d75bfc46d478d61$var$FullscreenExitIcon = function FullscreenExitIcon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === undefined ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === undefined ? 24 : _ref$size, children = _ref.children, props = $7d75bfc46d478d61$var$objectWithoutProperties(_ref, [
        "color",
        "size",
        "children"
    ]);
    var className = "mdi-icon " + (props.class || props.className || "");
    return $13c40c34b78c8ee2$export$c8a8987d4410bf2d("svg", $7d75bfc46d478d61$var$_extends({}, props, {
        "class": className,
        width: size,
        height: size,
        fill: color,
        viewBox: "0 0 24 24"
    }), $13c40c34b78c8ee2$export$c8a8987d4410bf2d("path", {
        d: "M14,14H19V16H16V19H14V14M5,14H10V19H8V16H5V14M8,5H10V10H5V8H8V5M19,8V10H14V5H16V8H19Z"
    }));
};
$7d75bfc46d478d61$exports = $7d75bfc46d478d61$var$FullscreenExitIcon;






function $0cf07db757caaaec$var$FullScreen({ language: language }) {
    const [fullScreen, setFullScreen] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(false);
    const enterFullScreen = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>{
        (0, $5ffe098e6e560069$export$3707f9d7fabf4fd)();
        setFullScreen(true);
    }, []);
    const exitFullScreen = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>{
        (0, $5ffe098e6e560069$export$586ad21cd043140f)();
        setFullScreen(false);
    }, []);
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {
        children: fullScreen ? /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $30f23c2abbe74fa9$export$2e2bcd8739ae039), {
            onClick: exitFullScreen,
            tooltipText: (0, $ca26d6bd0b19d011$export$2e2bcd8739ae039).EXIT_FULL_SCREEN[language],
            testid: "exit-full-screen-btn",
            children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($7d75bfc46d478d61$exports))), {})
        }) : /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $30f23c2abbe74fa9$export$2e2bcd8739ae039), {
            onClick: enterFullScreen,
            tooltipText: (0, $ca26d6bd0b19d011$export$2e2bcd8739ae039).FULL_SCREEN[language],
            testid: "full-screen-btn",
            children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($a2c96a06e79eea26$exports))), {})
        })
    });
}
var $0cf07db757caaaec$export$2e2bcd8739ae039 = $0cf07db757caaaec$var$FullScreen;


function $5651352f45544fd8$var$Toolbar({ language: language = (0, $ca26d6bd0b19d011$export$910b680d1eea6990), drawIoRef: drawIoRef, uuid: uuid, xml: xml, onExportPng: onExportPng, fullScreenEnabled: fullScreenEnabled }) {
    const { ref: zoom, visible: zoomDropdownVisible, setVisible: setZoomDropdownVisible } = (0, $c3cb55beadcde167$export$2e2bcd8739ae039)(false);
    const { ref: exports, visible: exportsDropdownVisible, setVisible: setExportsDropdownVisible } = (0, $c3cb55beadcde167$export$2e2bcd8739ae039)(false);
    const { ref: layers, visible: layersDropdownVisible, setVisible: setLayersDropdownVisible } = (0, $c3cb55beadcde167$export$2e2bcd8739ae039)(false);
    const toggleZoomDropdown = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>{
        setZoomDropdownVisible(!zoomDropdownVisible);
    }, [
        setZoomDropdownVisible,
        zoomDropdownVisible
    ]);
    const toggleLayerDropdown = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>{
        setLayersDropdownVisible(!layersDropdownVisible);
    }, [
        setLayersDropdownVisible,
        layersDropdownVisible
    ]);
    const toggleExportDropdown = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>{
        setExportsDropdownVisible(!exportsDropdownVisible);
    }, [
        setExportsDropdownVisible,
        exportsDropdownVisible
    ]);
    const handleClickToIframe = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>{
        setZoomDropdownVisible(false);
        setExportsDropdownVisible(false);
        setLayersDropdownVisible(false);
    }, [
        setExportsDropdownVisible,
        setLayersDropdownVisible,
        setZoomDropdownVisible
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        if (drawIoRef.current) drawIoRef.current.contentWindow.addEventListener("click", handleClickToIframe);
    }, [
        drawIoRef,
        handleClickToIframe
    ]);
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        className: "toolbar",
        "data-testid": "toolbar",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                className: "size-tools-wrapper",
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $6b4bcb490beea368$export$2e2bcd8739ae039), {
                        ref: zoom,
                        toggleDropdown: toggleZoomDropdown,
                        showDropdown: zoomDropdownVisible,
                        drawIoRef: drawIoRef,
                        language: language
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $69df16dd683a3135$export$2e2bcd8739ae039), {
                        drawIoRef: drawIoRef,
                        language: language
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $25d339993bcbc2fc$export$2e2bcd8739ae039), {
                        drawIoRef: drawIoRef,
                        language: language
                    }),
                    fullScreenEnabled ? /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $0cf07db757caaaec$export$2e2bcd8739ae039), {
                        language: language
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $1e8f343bb6ba9f22$export$2e2bcd8739ae039), {
                ref: layers,
                toggleDropdown: toggleLayerDropdown,
                showDropdown: layersDropdownVisible,
                drawIoRef: drawIoRef,
                language: language
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $4de3413d6541ee3d$export$2e2bcd8739ae039), {
                ref: exports,
                toggleDropdown: toggleExportDropdown,
                showDropdown: exportsDropdownVisible,
                uuid: uuid,
                xml: xml,
                language: language,
                onExportPng: onExportPng
            })
        ]
    });
}
var $5651352f45544fd8$export$2e2bcd8739ae039 = $5651352f45544fd8$var$Toolbar;





function $7d2da8fe47990fa7$export$2e2bcd8739ae039(dataURI) {
    const byteString = atob(dataURI.split(",")[1]);
    const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const dataView = new DataView(arrayBuffer);
    for(let i = 0; i < byteString.length; i++)dataView.setUint8(i, byteString.charCodeAt(i));
    return new Blob([
        arrayBuffer
    ], {
        type: mimeString
    });
}



const $911038f7c2707207$export$f7197f5350badaf = 300;
function $911038f7c2707207$export$f94bfad638068b6c(msg) {
    const heightOfDrawingOrPage = msg.pageVisible ? msg.page.height : msg.bounds.height;
    return Math.max($911038f7c2707207$export$f7197f5350badaf, heightOfDrawingOrPage);
}
function $911038f7c2707207$export$ea18af249ae1fbd0(filename, dataURI) {
    if (window.navigator?.msSaveBlob) window.navigator.msSaveBlob((0, $7d2da8fe47990fa7$export$2e2bcd8739ae039)(dataURI), filename);
    else (0, $4901755b44fe4428$export$2e2bcd8739ae039)(dataURI, filename);
}
const $911038f7c2707207$export$e5b6f98afa6e17d4 = ".geDiagramBackdrop { background-color: #ffffff !important; } .geBackgroundPage { box-shadow: none !important; background-image: none !important; } .geDiagramContainer svg { background-image: none !important; } .mxPopupMenu { display: none !important; }";










const $b585a0c1244fe8ab$export$f706fb4d309717c = {
    PARENT_SYSTEM_IMAGE_REQUEST: "parentSystemImageRequest",
    USER_DOWNLOAD_PNG_REQUEST: "userDownloadPngRequest"
};
const $b585a0c1244fe8ab$export$d9657bb2a56d8fe7 = {
    ADD_REQUEST: "addRequest",
    PROCESS_REQUEST: "processRequest"
};
const $b585a0c1244fe8ab$var$exportRequestQueueReducer = (state, action)=>{
    switch(action.type){
        case $b585a0c1244fe8ab$export$d9657bb2a56d8fe7.ADD_REQUEST:
            return [
                ...state,
                action.payload
            ];
        case $b585a0c1244fe8ab$export$d9657bb2a56d8fe7.PROCESS_REQUEST:
            {
                const [nextRequest, ...remainingRequests] = state;
                if (nextRequest === $b585a0c1244fe8ab$export$f706fb4d309717c.PARENT_SYSTEM_IMAGE_REQUEST) $5ffe098e6e560069$export$60072eb1fc683daf(action.payload.data);
                if (nextRequest === $b585a0c1244fe8ab$export$f706fb4d309717c.USER_DOWNLOAD_PNG_REQUEST) (0, $911038f7c2707207$export$ea18af249ae1fbd0)(`${action.payload.uuid}.png`, action.payload.data);
                return remainingRequests;
            }
        default:
            return state;
    }
};
var $b585a0c1244fe8ab$export$2e2bcd8739ae039 = $b585a0c1244fe8ab$var$exportRequestQueueReducer;


function $f6215c4122ce74a3$var$Wrapper(props) {
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $8a23c0557a977d39$export$3d84f372296c3d76), {
        ...props,
        children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($f6215c4122ce74a3$var$Viewer, {})
    });
}
function $f6215c4122ce74a3$var$Viewer() {
    const { parentSystemConfiguration: parentSystemConfiguration, applicationInsights: applicationInsights, xml: xml, uuid: uuid, lang: lang } = (0, $8a23c0557a977d39$export$730006aaa55ed657)();
    const drawIoRef = (0, $204a33a7557cbbd0$export$b8f5890fc79d6aca)(null);
    const [drawIoLoaded, setDrawIoLoaded] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(false);
    const [, dispatch] = (0, $204a33a7557cbbd0$export$13e3392192263954)((0, $b585a0c1244fe8ab$export$2e2bcd8739ae039), []);
    (0, $86ceef0d553066ce$export$2e2bcd8739ae039)([
        "/src/plugins/viewer.js",
        "/src/plugins/icons.js",
        "/src/plugins/highlight.js"
    ]);
    const { configure: configureDrawIo, load: loadDrawIo, exportPng: exportPng } = (0, $b7c7131e4fc050fe$export$2e2bcd8739ae039)(drawIoRef);
    const { renderLinkIcons: renderLinkIcons, removeLinkIcons: removeLinkIcons, activateLinkIcons: activateLinkIcons, deactivateLinkIcons: deactivateLinkIcons, highlight: highlight, informDrawIoIsLoaded: informDrawIoIsLoaded } = (0, $6a131471210cea5c$export$2e2bcd8739ae039)(drawIoRef);
    const { triggerLoad: triggerParentSystemLoad, triggerViewerEvent: triggerViewerEvent } = (0, $b41b4234c52865cd$export$2e2bcd8739ae039)();
    const handleDrawIoConfigureEvent = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>configureDrawIo({
            ...parentSystemConfiguration?.drawioConfiguration,
            css: `${(0, $911038f7c2707207$export$e5b6f98afa6e17d4)} ${parentSystemConfiguration?.drawioConfiguration?.css || ""}`
        }), [
        configureDrawIo,
        parentSystemConfiguration?.drawioConfiguration
    ]);
    const handleDrawIoInitEvent = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>{
        loadDrawIo(xml);
    }, [
        loadDrawIo,
        xml
    ]);
    const handleDrawIoLoadEvent = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((msg)=>{
        setDrawIoLoaded(true);
        triggerParentSystemLoad((0, $911038f7c2707207$export$f94bfad638068b6c)(msg));
        informDrawIoIsLoaded();
    }, [
        triggerParentSystemLoad,
        informDrawIoIsLoaded
    ]);
    const enqueueExportPng = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((exportType)=>{
        dispatch({
            type: (0, $b585a0c1244fe8ab$export$d9657bb2a56d8fe7).ADD_REQUEST,
            payload: exportType
        });
        exportPng();
    }, [
        exportPng
    ]);
    const handleGetImage = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>enqueueExportPng((0, $b585a0c1244fe8ab$export$f706fb4d309717c).PARENT_SYSTEM_IMAGE_REQUEST), [
        enqueueExportPng
    ]);
    const handleDownloadPng = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)(()=>enqueueExportPng((0, $b585a0c1244fe8ab$export$f706fb4d309717c).USER_DOWNLOAD_PNG_REQUEST), [
        enqueueExportPng
    ]);
    const handleDrawIoExportEvent = (0, $204a33a7557cbbd0$export$35808ee640e87ca7)((msg)=>{
        dispatch({
            type: (0, $b585a0c1244fe8ab$export$d9657bb2a56d8fe7).PROCESS_REQUEST,
            payload: {
                uuid: uuid,
                data: msg.data
            }
        });
    }, [
        uuid
    ]);
    const readyToListenParentSystemEvents = (0, $00974229370781c2$export$2e2bcd8739ae039)({
        onGetImage: handleGetImage,
        onRenderLinkIcons: renderLinkIcons,
        onRemoveLinkIcons: removeLinkIcons,
        onActivateLinkIcons: activateLinkIcons,
        onDeactivateLinkIcons: deactivateLinkIcons,
        onHighlight: highlight
    });
    const readyToListenDrawIoEvents = (0, $bcccd94ae87225f9$export$2e2bcd8739ae039)({
        onConfigure: handleDrawIoConfigureEvent,
        onInit: handleDrawIoInitEvent,
        onLoad: handleDrawIoLoadEvent,
        onExport: handleDrawIoExportEvent
    });
    const readyToListenDrawIoPluginEvents = (0, $89a0aee218b31b1b$export$2e2bcd8739ae039)({
        onViewerEvent: triggerViewerEvent
    });
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        if (applicationInsights) applicationInsights.trackPageView();
    }, [
        applicationInsights
    ]);
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        className: "disable-select",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                className: "drawio",
                children: readyToListenParentSystemEvents && readyToListenDrawIoEvents && readyToListenDrawIoPluginEvents ? /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("iframe", {
                    ref: drawIoRef,
                    src: `${(0, $cf92d1b7e7859fe9$export$785bf7d1ab2d87f8)}&lang=${lang}`,
                    title: "drawio",
                    "data-testid": "drawio"
                }) : null
            }),
            drawIoLoaded ? /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $5651352f45544fd8$export$2e2bcd8739ae039), {
                language: lang,
                drawIoRef: drawIoRef,
                uuid: uuid,
                xml: xml,
                onExportPng: handleDownloadPng,
                fullScreenEnabled: parentSystemConfiguration.fullScreenEnabled
            }) : /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $d59e6dd9d7beef66$export$2e2bcd8739ae039), {
                language: lang,
                spinnerColor: parentSystemConfiguration.colors?.spinner
            })
        ]
    });
}
var $f6215c4122ce74a3$export$2e2bcd8739ae039 = $f6215c4122ce74a3$var$Wrapper;



const $b66147a275019090$var$App = ()=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $044786338e0e8fe2$export$55185c17a0fcbe46), {
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $5e4c5940bc0b4610$export$2e2bcd8739ae039), {
                path: "/new"
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $5e4c5940bc0b4610$export$2e2bcd8739ae039), {
                path: "/edit/:uuid"
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $f6215c4122ce74a3$export$2e2bcd8739ae039), {
                path: "/show"
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $f6215c4122ce74a3$export$2e2bcd8739ae039), {
                path: "/show/:uuid"
            })
        ]
    });
var $b66147a275019090$export$2e2bcd8739ae039 = $b66147a275019090$var$App;


(0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $b66147a275019090$export$2e2bcd8739ae039), {}), document.getElementById("root"));


//# sourceMappingURL=index.9734806b.js.map
